/* tslint:disable */
/* eslint-disable */
/**
 * HIMMA APP API
 * API for the food delivery application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AbandonedCartMailStatus
 */
export interface AbandonedCartMailStatus {
    /**
     * Enable/disable abandoned cart emails
     * @type {boolean}
     * @memberof AbandonedCartMailStatus
     */
    'status': boolean;
    /**
     * Hours after which to send abandoned cart email
     * @type {number}
     * @memberof AbandonedCartMailStatus
     */
    'sendAbandonedCartMailAfterHours'?: number;
}
/**
 * 
 * @export
 * @interface AddDeliveryManagerRequestSchema
 */
export interface AddDeliveryManagerRequestSchema {
    /**
     * name of the delivery manager
     * @type {string}
     * @memberof AddDeliveryManagerRequestSchema
     */
    'name': string;
    /**
     * email of the delivery manager
     * @type {string}
     * @memberof AddDeliveryManagerRequestSchema
     */
    'email': string;
    /**
     * mobile number of the delivery manager
     * @type {string}
     * @memberof AddDeliveryManagerRequestSchema
     */
    'mobileNumber': string;
    /**
     * password of the delivery manager
     * @type {string}
     * @memberof AddDeliveryManagerRequestSchema
     */
    'password': string;
    /**
     * profile photo of the delivery manager
     * @type {string}
     * @memberof AddDeliveryManagerRequestSchema
     */
    'profilePhoto'?: string;
}
/**
 * 
 * @export
 * @interface AddMealRequest
 */
export interface AddMealRequest {
    /**
     * Meal name in English
     * @type {string}
     * @memberof AddMealRequest
     */
    'mealNameEnglish': string;
    /**
     * Meal name in Arabic
     * @type {string}
     * @memberof AddMealRequest
     */
    'mealNameArabic': string;
    /**
     * ID of the store
     * @type {string}
     * @memberof AddMealRequest
     */
    'storeId': string;
    /**
     * ID of the item for the meal
     * @type {string}
     * @memberof AddMealRequest
     */
    'items': string;
    /**
     * Array of choice group IDs for the meal
     * @type {Array<string>}
     * @memberof AddMealRequest
     */
    'choiceGroups': Array<string>;
    /**
     * Price of the meal (whole number)
     * @type {number}
     * @memberof AddMealRequest
     */
    'price': number;
    /**
     * Currency code (e.g., USD, SAR, AED)
     * @type {string}
     * @memberof AddMealRequest
     */
    'currency': string;
    /**
     * ID of the merchant
     * @type {string}
     * @memberof AddMealRequest
     */
    'merchantId'?: string;
}
/**
 * 
 * @export
 * @interface AddOfferRequestSchema
 */
export interface AddOfferRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof AddOfferRequestSchema
     */
    'couponCode': string;
    /**
     * 
     * @type {string}
     * @memberof AddOfferRequestSchema
     */
    'couponName': string;
    /**
     * 
     * @type {string}
     * @memberof AddOfferRequestSchema
     */
    'couponType': AddOfferRequestSchemaCouponTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AddOfferRequestSchema
     */
    'maxCouponAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AddOfferRequestSchema
     */
    'couponValue': number;
    /**
     * 
     * @type {string}
     * @memberof AddOfferRequestSchema
     */
    'couponStartDate': string;
    /**
     * 
     * @type {number}
     * @memberof AddOfferRequestSchema
     */
    'validityDays': number;
    /**
     * 
     * @type {string}
     * @memberof AddOfferRequestSchema
     */
    'termsAndConditions': string;
    /**
     * 
     * @type {number}
     * @memberof AddOfferRequestSchema
     */
    'couponPerUserLimit': number;
    /**
     * 
     * @type {number}
     * @memberof AddOfferRequestSchema
     */
    'totalCouponCount': number;
}

export const AddOfferRequestSchemaCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type AddOfferRequestSchemaCouponTypeEnum = typeof AddOfferRequestSchemaCouponTypeEnum[keyof typeof AddOfferRequestSchemaCouponTypeEnum];

/**
 * 
 * @export
 * @interface AddOrEditChoiceRequestSchema
 */
export interface AddOrEditChoiceRequestSchema {
    /**
     * Type of store to which the choice belongs
     * @type {string}
     * @memberof AddOrEditChoiceRequestSchema
     */
    'storeType': AddOrEditChoiceRequestSchemaStoreTypeEnum;
    /**
     * ID of the store to which the choice belongs
     * @type {string}
     * @memberof AddOrEditChoiceRequestSchema
     */
    'storeId': string;
    /**
     * name of the choice in English
     * @type {string}
     * @memberof AddOrEditChoiceRequestSchema
     */
    'choiceNameEnglish': string;
    /**
     * name of the choice in Arabic
     * @type {string}
     * @memberof AddOrEditChoiceRequestSchema
     */
    'choiceNameArabic': string;
    /**
     * price of the choice
     * @type {number}
     * @memberof AddOrEditChoiceRequestSchema
     */
    'price': number;
    /**
     * Type of user who added the choice
     * @type {string}
     * @memberof AddOrEditChoiceRequestSchema
     */
    'addedBy': AddOrEditChoiceRequestSchemaAddedByEnum;
}

export const AddOrEditChoiceRequestSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type AddOrEditChoiceRequestSchemaStoreTypeEnum = typeof AddOrEditChoiceRequestSchemaStoreTypeEnum[keyof typeof AddOrEditChoiceRequestSchemaStoreTypeEnum];
export const AddOrEditChoiceRequestSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type AddOrEditChoiceRequestSchemaAddedByEnum = typeof AddOrEditChoiceRequestSchemaAddedByEnum[keyof typeof AddOrEditChoiceRequestSchemaAddedByEnum];

/**
 * 
 * @export
 * @interface AddOrEditCmsPageRequestSchema
 */
export interface AddOrEditCmsPageRequestSchema {
    /**
     * The title of the page.
     * @type {string}
     * @memberof AddOrEditCmsPageRequestSchema
     */
    'pageTitle': string;
    /**
     * The title of the page in Arabic.
     * @type {string}
     * @memberof AddOrEditCmsPageRequestSchema
     */
    'pageTitleInArabic': string;
    /**
     * The description of the page.
     * @type {string}
     * @memberof AddOrEditCmsPageRequestSchema
     */
    'pageDescription': string;
    /**
     * The description of the page in Arabic.
     * @type {string}
     * @memberof AddOrEditCmsPageRequestSchema
     */
    'pageDescriptionInArabic': string;
}
/**
 * 
 * @export
 * @interface AddOrEditCouponRequestSchema
 */
export interface AddOrEditCouponRequestSchema {
    /**
     * The coupon code that will be used to redeem the coupon.
     * @type {string}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponCode': string;
    /**
     * The name of the coupon.
     * @type {string}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponName': string;
    /**
     * The type of coupon (e.g., percentage, fixed amount).
     * @type {string}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponType': AddOrEditCouponRequestSchemaCouponTypeEnum;
    /**
     * The maximum amount of the coupon when coupon type is percentage.
     * @type {number}
     * @memberof AddOrEditCouponRequestSchema
     */
    'maxCouponAmount'?: number;
    /**
     * The value of the coupon.
     * @type {number}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponValue': number;
    /**
     * The start date of the coupon in ISO 8601 format (YYYY-MM-DD).
     * @type {string}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponStartDate': string;
    /**
     * The end date of the coupon in ISO 8601 format (YYYY-MM-DD).
     * @type {string}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponEndDate': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOrEditCouponRequestSchema
     */
    'stores': Array<string>;
    /**
     * The maximum number of times a user can use the coupon.
     * @type {number}
     * @memberof AddOrEditCouponRequestSchema
     */
    'couponPerUserLimit': number;
    /**
     * The total number of coupons available.
     * @type {number}
     * @memberof AddOrEditCouponRequestSchema
     */
    'totalCouponCount': number;
    /**
     * The minimum order value required to apply the coupon.
     * @type {number}
     * @memberof AddOrEditCouponRequestSchema
     */
    'minimumOrderValue': number;
    /**
     * Indicates whether to send the coupon to all users via email.
     * @type {boolean}
     * @memberof AddOrEditCouponRequestSchema
     */
    'sendEmailToAllUsers': boolean;
}

export const AddOrEditCouponRequestSchemaCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type AddOrEditCouponRequestSchemaCouponTypeEnum = typeof AddOrEditCouponRequestSchemaCouponTypeEnum[keyof typeof AddOrEditCouponRequestSchemaCouponTypeEnum];

/**
 * 
 * @export
 * @interface AddOrEditDeliveryBoyRequestSchema
 */
export interface AddOrEditDeliveryBoyRequestSchema {
    /**
     * The first name of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'firstName'?: string;
    /**
     * The last name of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'lastName'?: string;
    /**
     * The email address of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'email'?: string;
    /**
     * The password of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'alternativeMobileNumber'?: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'currencyCode'?: CurrencyCode;
    /**
     * The delivery vehicle type of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'deliveryVehicleType'?: AddOrEditDeliveryBoyRequestSchemaDeliveryVehicleTypeEnum;
    /**
     * The name of the vehicle
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'vehicleName'?: string;
    /**
     * The vehicle number of the the delivery boy
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'vehicleNumber'?: string;
    /**
     * The vehicle type of the the delivery boy
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'vehilceType'?: string;
    /**
     * The maximum order limit of the delivery boy.
     * @type {number}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'maximumOrderLimit'?: number;
    /**
     * The location of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'location'?: string;
    /**
     * The country of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'country'?: string;
    /**
     * The state of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'state'?: string;
    /**
     * The city of the delivery boy.
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'city'?: string;
    /**
     * The status of the delivery
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'status'?: AddOrEditDeliveryBoyRequestSchemaStatusEnum;
    /**
     * Indicates if the merchant is available for orders
     * @type {boolean}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'isAvailable'?: boolean;
    /**
     * Preferred language of the delivery partner
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'preferredLanguage'?: AddOrEditDeliveryBoyRequestSchemaPreferredLanguageEnum;
    /**
     * Driving licence number of the delivery boy
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'drivingLicenceNumber'?: string;
    /**
     * AWS S3 URL for driving licence proof document
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'driverLicenceProof'?: string;
    /**
     * Expiry date of the driving licence
     * @type {string}
     * @memberof AddOrEditDeliveryBoyRequestSchema
     */
    'drivingLicenceExpiryDate'?: string;
}

export const AddOrEditDeliveryBoyRequestSchemaDeliveryVehicleTypeEnum = {
    Truck: 'Truck',
    TwoWheeler: 'Two-wheeler',
    Both: 'Both'
} as const;

export type AddOrEditDeliveryBoyRequestSchemaDeliveryVehicleTypeEnum = typeof AddOrEditDeliveryBoyRequestSchemaDeliveryVehicleTypeEnum[keyof typeof AddOrEditDeliveryBoyRequestSchemaDeliveryVehicleTypeEnum];
export const AddOrEditDeliveryBoyRequestSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type AddOrEditDeliveryBoyRequestSchemaStatusEnum = typeof AddOrEditDeliveryBoyRequestSchemaStatusEnum[keyof typeof AddOrEditDeliveryBoyRequestSchemaStatusEnum];
export const AddOrEditDeliveryBoyRequestSchemaPreferredLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;

export type AddOrEditDeliveryBoyRequestSchemaPreferredLanguageEnum = typeof AddOrEditDeliveryBoyRequestSchemaPreferredLanguageEnum[keyof typeof AddOrEditDeliveryBoyRequestSchemaPreferredLanguageEnum];

/**
 * 
 * @export
 * @interface AddOrEditFaqRequestSchema
 */
export interface AddOrEditFaqRequestSchema {
    /**
     * The question for the FAQ page
     * @type {string}
     * @memberof AddOrEditFaqRequestSchema
     */
    'question': string;
    /**
     * The question in Arabic for the FAQ page
     * @type {string}
     * @memberof AddOrEditFaqRequestSchema
     */
    'questionInArabic': string;
    /**
     * The answer for the FAQ page
     * @type {string}
     * @memberof AddOrEditFaqRequestSchema
     */
    'answer': string;
    /**
     * The answer in Arabic for the FAQ page
     * @type {string}
     * @memberof AddOrEditFaqRequestSchema
     */
    'answerInArabic': string;
}
/**
 * 
 * @export
 * @interface AddOrEditItemRequestSchema
 */
export interface AddOrEditItemRequestSchema {
    /**
     * The unique identifier for the item
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemId'?: string;
    /**
     * The unique identifier for the store
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'storeId': string;
    /**
     * The name of the restaurant (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'storeName'?: string;
    /**
     * The category ID of the item (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemCategoryId': string;
    /**
     * The category ID of the item (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemSubCategoryId': string;
    /**
     * The unique code for the item (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemCode': string;
    /**
     * The name of the item (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemName': string;
    /**
     * The Arabic name of the item (optional)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemNameArabic': string;
    /**
     * Description of the item in English (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemContent': string;
    /**
     * Description of the item in Arabic (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemContentArabic': string;
    /**
     * The quantity of the item (mandatory)
     * @type {number}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemQuantity': number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof AddOrEditItemRequestSchema
     */
    'currencyCode': CurrencyCode;
    /**
     * The original price of the item (mandatory)
     * @type {number}
     * @memberof AddOrEditItemRequestSchema
     */
    'originalPrice': number;
    /**
     * Indicates if a discount is available (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'discount': boolean;
    /**
     * The discounted price of the item (required if discount is true)
     * @type {number}
     * @memberof AddOrEditItemRequestSchema
     */
    'discountedPrice'?: number;
    /**
     * Availability of the discount (required if discount is true)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'discountAvailableTime'?: AddOrEditItemRequestSchemaDiscountAvailableTimeEnum;
    /**
     * 
     * @type {AddOrEditItemRequestSchemaDiscountAvailableDuration}
     * @memberof AddOrEditItemRequestSchema
     */
    'discountAvailableDuration'?: AddOrEditItemRequestSchemaDiscountAvailableDuration;
    /**
     * Type of item (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'vegOrNonVeg'?: AddOrEditItemRequestSchemaVegOrNonVegEnum;
    /**
     * Indicates if tax is applicable (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'tax': boolean;
    /**
     * Name of the tax (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'taxName'?: string;
    /**
     * Name of the tax in Arabic (optional)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'taxNameArabic'?: string;
    /**
     * Percentage of the tax (mandatory)
     * @type {number}
     * @memberof AddOrEditItemRequestSchema
     */
    'taxPercentage'?: number;
    /**
     * Indicates if the item is part of a combo pack (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'comboPack': boolean;
    /**
     * Whether the item is halal (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'isHalal'?: boolean;
    /**
     * Indicates if the item is in stock (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'isStockAvailable': boolean;
    /**
     * Times of the day when the item is available. User can select multiple options.
     * @type {Array<string>}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemAvailableTime'?: Array<AddOrEditItemRequestSchemaItemAvailableTimeEnum>;
    /**
     * Description of the item in English (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'description': string;
    /**
     * Description of the item in Arabic (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'descriptionArabic'?: string;
    /**
     * Meta keywords for the item separated by comma (optional)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'metaKeywords'?: string;
    /**
     * Meta keywords for the item separated by comma in Arabic (optional)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'metaKeyWordsArabic'?: string;
    /**
     * Meta description for the item (optional)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'metaDescription'?: string;
    /**
     * Meta description in Arabic (optional)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'metaDescriptionArabic'?: string;
    /**
     * Indicates if the item has choices (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'hasChoice': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemChoices'?: Array<string>;
    /**
     * Indicates if the item has specifications (mandatory)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'hasSpecification': boolean;
    /**
     * 
     * @type {Array<AddOrEditItemRequestSchemaItemSpecificationInner>}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemSpecification'?: Array<AddOrEditItemRequestSchemaItemSpecificationInner>;
    /**
     * URLs of the item images (mandatory)
     * @type {Array<string>}
     * @memberof AddOrEditItemRequestSchema
     */
    'itemImage': Array<string>;
    /**
     * Who added the category.
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'addedBy': AddOrEditItemRequestSchemaAddedByEnum;
    /**
     * Status of the item (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'status'?: AddOrEditItemRequestSchemaStatusEnum;
    /**
     * Whether the item requires a prescription (for pharmacy items)
     * @type {boolean}
     * @memberof AddOrEditItemRequestSchema
     */
    'requiresPrescription'?: boolean;
    /**
     * Type of prescription required (standard, controlled substance, or over-the-counter)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'prescriptionType'?: AddOrEditItemRequestSchemaPrescriptionTypeEnum;
    /**
     * Additional notes about prescription requirements (English)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'prescriptionNotes'?: string;
    /**
     * Additional notes about prescription requirements (Arabic)
     * @type {string}
     * @memberof AddOrEditItemRequestSchema
     */
    'prescriptionNotesArabic'?: string;
    /**
     * Choice groups associated with the item
     * @type {Array<AddOrEditItemRequestSchemaChoiceGroupsInner>}
     * @memberof AddOrEditItemRequestSchema
     */
    'choiceGroups'?: Array<AddOrEditItemRequestSchemaChoiceGroupsInner>;
}

export const AddOrEditItemRequestSchemaDiscountAvailableTimeEnum = {
    Always: 'always',
    Sometimes: 'sometimes'
} as const;

export type AddOrEditItemRequestSchemaDiscountAvailableTimeEnum = typeof AddOrEditItemRequestSchemaDiscountAvailableTimeEnum[keyof typeof AddOrEditItemRequestSchemaDiscountAvailableTimeEnum];
export const AddOrEditItemRequestSchemaVegOrNonVegEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type AddOrEditItemRequestSchemaVegOrNonVegEnum = typeof AddOrEditItemRequestSchemaVegOrNonVegEnum[keyof typeof AddOrEditItemRequestSchemaVegOrNonVegEnum];
export const AddOrEditItemRequestSchemaItemAvailableTimeEnum = {
    Breakfast: 'breakfast',
    Brunch: 'brunch',
    Lunch: 'lunch',
    Supper: 'supper',
    Dinner: 'dinner'
} as const;

export type AddOrEditItemRequestSchemaItemAvailableTimeEnum = typeof AddOrEditItemRequestSchemaItemAvailableTimeEnum[keyof typeof AddOrEditItemRequestSchemaItemAvailableTimeEnum];
export const AddOrEditItemRequestSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type AddOrEditItemRequestSchemaAddedByEnum = typeof AddOrEditItemRequestSchemaAddedByEnum[keyof typeof AddOrEditItemRequestSchemaAddedByEnum];
export const AddOrEditItemRequestSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type AddOrEditItemRequestSchemaStatusEnum = typeof AddOrEditItemRequestSchemaStatusEnum[keyof typeof AddOrEditItemRequestSchemaStatusEnum];
export const AddOrEditItemRequestSchemaPrescriptionTypeEnum = {
    Standard: 'standard',
    Controlled: 'controlled',
    Otc: 'otc'
} as const;

export type AddOrEditItemRequestSchemaPrescriptionTypeEnum = typeof AddOrEditItemRequestSchemaPrescriptionTypeEnum[keyof typeof AddOrEditItemRequestSchemaPrescriptionTypeEnum];

/**
 * 
 * @export
 * @interface AddOrEditItemRequestSchemaChoiceGroupsInner
 */
export interface AddOrEditItemRequestSchemaChoiceGroupsInner {
    /**
     * ID of the choice group (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchemaChoiceGroupsInner
     */
    'choiceGroupId'?: string;
    /**
     * Name of the choice group (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchemaChoiceGroupsInner
     */
    'choiceGroupName'?: string;
}
/**
 * Duration for which the discount is available (required if discountAvailableTime is \"sometimes\")
 * @export
 * @interface AddOrEditItemRequestSchemaDiscountAvailableDuration
 */
export interface AddOrEditItemRequestSchemaDiscountAvailableDuration {
    /**
     * Start date and time for the discount (required if discountAvailableTime is \"sometimes\")
     * @type {string}
     * @memberof AddOrEditItemRequestSchemaDiscountAvailableDuration
     */
    'from': string;
    /**
     * End date and time for the discount (required if discountAvailableTime is \"sometimes\")
     * @type {string}
     * @memberof AddOrEditItemRequestSchemaDiscountAvailableDuration
     */
    'to': string;
}
/**
 * 
 * @export
 * @interface AddOrEditItemRequestSchemaItemSpecificationInner
 */
export interface AddOrEditItemRequestSchemaItemSpecificationInner {
    /**
     * Name of the specification (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchemaItemSpecificationInner
     */
    'specificationTitle'?: string;
    /**
     * Description of the specification (mandatory)
     * @type {string}
     * @memberof AddOrEditItemRequestSchemaItemSpecificationInner
     */
    'specificationDescription'?: string;
}
/**
 * 
 * @export
 * @interface AddOrEditSubAdminRequest
 */
export interface AddOrEditSubAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrEditSubAdminRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrEditSubAdminRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrEditSubAdminRequest
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddOrEditSubAdminRequest
     */
    'password'?: string;
    /**
     * If true, the sub-admin has full system access
     * @type {boolean}
     * @memberof AddOrEditSubAdminRequest
     */
    'privilege'?: boolean;
    /**
     * 
     * @type {Permissions}
     * @memberof AddOrEditSubAdminRequest
     */
    'permissions'?: Permissions;
}
/**
 * 
 * @export
 * @interface AddOrUpdateCartItem
 */
export interface AddOrUpdateCartItem {
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateCartItem
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateCartItem
     */
    'storeType': AddOrUpdateCartItemStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateCartItem
     */
    'itemId': string;
    /**
     * Optional variant of the item (e.g., size, flavor)
     * @type {string}
     * @memberof AddOrUpdateCartItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddOrUpdateCartItem
     */
    'choices'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AddOrUpdateCartItem
     */
    'quantity': number;
    /**
     * Special instructions for this item
     * @type {string}
     * @memberof AddOrUpdateCartItem
     */
    'specialInstructions'?: string;
}

export const AddOrUpdateCartItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type AddOrUpdateCartItemStoreTypeEnum = typeof AddOrUpdateCartItemStoreTypeEnum[keyof typeof AddOrUpdateCartItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface AddOrUpdateCartRequestSchema
 */
export interface AddOrUpdateCartRequestSchema {
    /**
     * 
     * @type {Array<AddOrUpdateCartItem>}
     * @memberof AddOrUpdateCartRequestSchema
     */
    'cartItems'?: Array<AddOrUpdateCartItem>;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof AddOrUpdateCartRequestSchema
     */
    'orderMode'?: AddOrUpdateCartRequestSchemaOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (required when orderMode is preOrder)
     * @type {string}
     * @memberof AddOrUpdateCartRequestSchema
     */
    'preOrderDateTime'?: string;
}

export const AddOrUpdateCartRequestSchemaOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type AddOrUpdateCartRequestSchemaOrderModeEnum = typeof AddOrUpdateCartRequestSchemaOrderModeEnum[keyof typeof AddOrUpdateCartRequestSchemaOrderModeEnum];

/**
 * 
 * @export
 * @interface AddOrUpdateCartResponseSchema
 */
export interface AddOrUpdateCartResponseSchema {
    /**
     * 
     * @type {CartAmountsSchema}
     * @memberof AddOrUpdateCartResponseSchema
     */
    'cartPrice': CartAmountsSchema;
    /**
     * A message indicating the result of the cart update operation.
     * @type {string}
     * @memberof AddOrUpdateCartResponseSchema
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AddOrUpdateChoiceGroupRequestSchema
 */
export interface AddOrUpdateChoiceGroupRequestSchema {
    /**
     * The name of the choice group in English.
     * @type {string}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'choiceGroupNameEnglish': string;
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'storeType': AddOrUpdateChoiceGroupRequestSchemaStoreTypeEnum;
    /**
     * The ID of the store to which the choice group belongs.
     * @type {string}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'storeId': string;
    /**
     * The name of the choice group in Arabic.
     * @type {string}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'choiceGroupNameArabic': string;
    /**
     * The minimum limit for the choice group.
     * @type {number}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'minimumLimit': number;
    /**
     * The maximum limit for the choice group.
     * @type {number}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'maximumLimit': number;
    /**
     * Indicates whether the choice group is optional or required.
     * @type {boolean}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'choiceGroupOption': boolean;
    /**
     * The details of the choices associated with the choice group.
     * @type {Array<string>}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'choiceDetails': Array<string>;
    /**
     * Type of user who added the choice
     * @type {string}
     * @memberof AddOrUpdateChoiceGroupRequestSchema
     */
    'addedBy': AddOrUpdateChoiceGroupRequestSchemaAddedByEnum;
}

export const AddOrUpdateChoiceGroupRequestSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type AddOrUpdateChoiceGroupRequestSchemaStoreTypeEnum = typeof AddOrUpdateChoiceGroupRequestSchemaStoreTypeEnum[keyof typeof AddOrUpdateChoiceGroupRequestSchemaStoreTypeEnum];
export const AddOrUpdateChoiceGroupRequestSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type AddOrUpdateChoiceGroupRequestSchemaAddedByEnum = typeof AddOrUpdateChoiceGroupRequestSchemaAddedByEnum[keyof typeof AddOrUpdateChoiceGroupRequestSchemaAddedByEnum];

/**
 * 
 * @export
 * @interface AddOrUpdateDeviceIdRequest
 */
export interface AddOrUpdateDeviceIdRequest {
    /**
     * The unique identifier for the user.
     * @type {string}
     * @memberof AddOrUpdateDeviceIdRequest
     */
    'userId': string;
    /**
     * The type of user, either \'User\' or \'DeliveryBoy\'.
     * @type {string}
     * @memberof AddOrUpdateDeviceIdRequest
     */
    'userType': AddOrUpdateDeviceIdRequestUserTypeEnum;
    /**
     * The unique identifier for the user\'s device (FCM token for push notifications).
     * @type {string}
     * @memberof AddOrUpdateDeviceIdRequest
     */
    'deviceId': string;
    /**
     * Indicates whether the user is currently logged in.
     * @type {boolean}
     * @memberof AddOrUpdateDeviceIdRequest
     */
    'isLoggedIn': boolean;
}

export const AddOrUpdateDeviceIdRequestUserTypeEnum = {
    User: 'User',
    DeliveryBoy: 'DeliveryBoy'
} as const;

export type AddOrUpdateDeviceIdRequestUserTypeEnum = typeof AddOrUpdateDeviceIdRequestUserTypeEnum[keyof typeof AddOrUpdateDeviceIdRequestUserTypeEnum];

/**
 * 
 * @export
 * @interface AddOrUpdateWishListRequestSchema
 */
export interface AddOrUpdateWishListRequestSchema {
    /**
     * Unique identifier of the user
     * @type {string}
     * @memberof AddOrUpdateWishListRequestSchema
     */
    'userId': string;
    /**
     * Unique identifier of the store
     * @type {string}
     * @memberof AddOrUpdateWishListRequestSchema
     */
    'storeId': string;
    /**
     * Type of the store
     * @type {string}
     * @memberof AddOrUpdateWishListRequestSchema
     */
    'storeType': AddOrUpdateWishListRequestSchemaStoreTypeEnum;
    /**
     * Unique identifier of the item (required only if `wishlistType` is \"item\")
     * @type {string}
     * @memberof AddOrUpdateWishListRequestSchema
     */
    'itemId'?: string | null;
    /**
     * Defines whether the wishlist is for an item or a store
     * @type {string}
     * @memberof AddOrUpdateWishListRequestSchema
     */
    'wishlistType': AddOrUpdateWishListRequestSchemaWishlistTypeEnum;
    /**
     * Operation to perform on the wishlist
     * @type {string}
     * @memberof AddOrUpdateWishListRequestSchema
     */
    'action': AddOrUpdateWishListRequestSchemaActionEnum;
}

export const AddOrUpdateWishListRequestSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type AddOrUpdateWishListRequestSchemaStoreTypeEnum = typeof AddOrUpdateWishListRequestSchemaStoreTypeEnum[keyof typeof AddOrUpdateWishListRequestSchemaStoreTypeEnum];
export const AddOrUpdateWishListRequestSchemaWishlistTypeEnum = {
    Item: 'item',
    Store: 'store'
} as const;

export type AddOrUpdateWishListRequestSchemaWishlistTypeEnum = typeof AddOrUpdateWishListRequestSchemaWishlistTypeEnum[keyof typeof AddOrUpdateWishListRequestSchemaWishlistTypeEnum];
export const AddOrUpdateWishListRequestSchemaActionEnum = {
    Add: 'Add',
    Remove: 'Remove'
} as const;

export type AddOrUpdateWishListRequestSchemaActionEnum = typeof AddOrUpdateWishListRequestSchemaActionEnum[keyof typeof AddOrUpdateWishListRequestSchemaActionEnum];

/**
 * 
 * @export
 * @interface AddReviewRequest
 */
export interface AddReviewRequest {
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof AddReviewRequest
     */
    'orderId': string;
    /**
     * Unique identifier for the user submitting the review
     * @type {string}
     * @memberof AddReviewRequest
     */
    'userId': string;
    /**
     * 
     * @type {DeliveryRating}
     * @memberof AddReviewRequest
     */
    'deliveryRating'?: DeliveryRating;
    /**
     * Ratings per item in the order
     * @type {Array<ItemRating>}
     * @memberof AddReviewRequest
     */
    'itemRatings'?: Array<ItemRating>;
    /**
     * Reviews per store in the order (for multi-store orders)
     * @type {Array<StoreRating>}
     * @memberof AddReviewRequest
     */
    'storeRatings'?: Array<StoreRating>;
}
/**
 * 
 * @export
 * @interface AddStore201Response
 */
export interface AddStore201Response {
    /**
     * 
     * @type {string}
     * @memberof AddStore201Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface AddUserNotificationRequest
 */
export interface AddUserNotificationRequest {
    /**
     * Unique identifier of the user
     * @type {string}
     * @memberof AddUserNotificationRequest
     */
    'userId': string;
    /**
     * Type of user (e.g., customer, merchant)
     * @type {string}
     * @memberof AddUserNotificationRequest
     */
    'userType': string;
    /**
     * Type of notification
     * @type {string}
     * @memberof AddUserNotificationRequest
     */
    'notificationType': string;
    /**
     * Title of the notification
     * @type {string}
     * @memberof AddUserNotificationRequest
     */
    'notificationTitle': string;
    /**
     * Body content of the notification
     * @type {string}
     * @memberof AddUserNotificationRequest
     */
    'notificationBody': string;
    /**
     * Additional data associated with the notification
     * @type {string}
     * @memberof AddUserNotificationRequest
     */
    'notificationData': string;
}
/**
 * 
 * @export
 * @interface AddUserSchema
 */
export interface AddUserSchema {
    /**
     * 
     * @type {string}
     * @memberof AddUserSchema
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AddUserSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AddUserSchema
     */
    'mobileNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AddUserSchema
     */
    'alternativeMobileNumber': string;
    /**
     * URL of the restaurant logo (mandatory)
     * @type {string}
     * @memberof AddUserSchema
     */
    'profileImage': string;
    /**
     * Password for the user account (mandatory)
     * @type {string}
     * @memberof AddUserSchema
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface AdminAssignDriverRequestSchema
 */
export interface AdminAssignDriverRequestSchema {
    /**
     * The MongoDB ID of the order to assign driver to
     * @type {string}
     * @memberof AdminAssignDriverRequestSchema
     */
    'orderId': string;
    /**
     * Assignment mode - manual requires driverId, automatic finds nearest available driver
     * @type {string}
     * @memberof AdminAssignDriverRequestSchema
     */
    'mode': AdminAssignDriverRequestSchemaModeEnum;
    /**
     * Required for manual mode - The MongoDB ID of the driver to assign
     * @type {string}
     * @memberof AdminAssignDriverRequestSchema
     */
    'driverId'?: string;
    /**
     * Optional reason for driver assignment or change
     * @type {string}
     * @memberof AdminAssignDriverRequestSchema
     */
    'reason'?: string;
    /**
     * Optional bonus amount for driver. If provided, driver will receive this bonus and order will be marked as urgent. If not provided, no bonus is applied (standard assignment).
     * @type {number}
     * @memberof AdminAssignDriverRequestSchema
     */
    'bonusAmount'?: number;
}

export const AdminAssignDriverRequestSchemaModeEnum = {
    Manual: 'manual',
    Automatic: 'automatic'
} as const;

export type AdminAssignDriverRequestSchemaModeEnum = typeof AdminAssignDriverRequestSchemaModeEnum[keyof typeof AdminAssignDriverRequestSchemaModeEnum];

/**
 * 
 * @export
 * @interface AdminAssignDriverResponseSchema
 */
export interface AdminAssignDriverResponseSchema {
    /**
     * Success message indicating assignment status
     * @type {string}
     * @memberof AdminAssignDriverResponseSchema
     */
    'message': string;
    /**
     * 
     * @type {AdminAssignDriverResponseSchemaAssignedDriver}
     * @memberof AdminAssignDriverResponseSchema
     */
    'assignedDriver'?: AdminAssignDriverResponseSchemaAssignedDriver;
}
/**
 * Details of the assigned driver
 * @export
 * @interface AdminAssignDriverResponseSchemaAssignedDriver
 */
export interface AdminAssignDriverResponseSchemaAssignedDriver {
    /**
     * The MongoDB ID of the assigned driver
     * @type {string}
     * @memberof AdminAssignDriverResponseSchemaAssignedDriver
     */
    'driverId'?: string;
    /**
     * Full name of the assigned driver
     * @type {string}
     * @memberof AdminAssignDriverResponseSchemaAssignedDriver
     */
    'driverName'?: string;
    /**
     * Phone number of the assigned driver
     * @type {string}
     * @memberof AdminAssignDriverResponseSchemaAssignedDriver
     */
    'driverPhone'?: string;
}
/**
 * 
 * @export
 * @interface AdminCommissionReportRequest
 */
export interface AdminCommissionReportRequest {
    /**
     * Array of store IDs to filter by (optional - omit to include all stores). Maximum 50 stores per request. 
     * @type {Array<string>}
     * @memberof AdminCommissionReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant/store owner ID to filter by (optional - omit to include all merchants). Filter by stores owned by a specific merchant. 
     * @type {string}
     * @memberof AdminCommissionReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types (optional - omit to include all types)
     * @type {Array<string>}
     * @memberof AdminCommissionReportRequest
     */
    'storeType'?: Array<AdminCommissionReportRequestStoreTypeEnum>;
    /**
     * Order statuses to include in commission calculation (defaults to ORDER_DELIVERED only). - ORDER_DELIVERED: Successfully delivered orders (commission collected) - MERCHANT_CANCELLED: Merchant cancelled orders (may affect commission) - DELIVERY_FAILED: Failed delivery attempts (may affect commission) 
     * @type {Array<string>}
     * @memberof AdminCommissionReportRequest
     */
    'orderStatuses'?: Array<AdminCommissionReportRequestOrderStatusesEnum>;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to order completion date (when commission was earned). - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof AdminCommissionReportRequest
     */
    'dateRange': AdminCommissionReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof AdminCommissionReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof AdminCommissionReportRequest
     */
    'dateTo'?: string;
}

export const AdminCommissionReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type AdminCommissionReportRequestStoreTypeEnum = typeof AdminCommissionReportRequestStoreTypeEnum[keyof typeof AdminCommissionReportRequestStoreTypeEnum];
export const AdminCommissionReportRequestOrderStatusesEnum = {
    OrderDelivered: 'ORDER_DELIVERED',
    MerchantCancelled: 'MERCHANT_CANCELLED',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type AdminCommissionReportRequestOrderStatusesEnum = typeof AdminCommissionReportRequestOrderStatusesEnum[keyof typeof AdminCommissionReportRequestOrderStatusesEnum];
export const AdminCommissionReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type AdminCommissionReportRequestDateRangeEnum = typeof AdminCommissionReportRequestDateRangeEnum[keyof typeof AdminCommissionReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface AdminDashboardResponse
 */
export interface AdminDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminDashboardResponse
     */
    'dashboardType': AdminDashboardResponseDashboardTypeEnum;
    /**
     * 
     * @type {MetricsCardItem}
     * @memberof AdminDashboardResponse
     */
    'metricsCards': MetricsCardItem;
    /**
     * Line chart data showing monthly order trends for visualization.
     * @type {Array<OrderTrendsLineChartItem>}
     * @memberof AdminDashboardResponse
     */
    'orderTrendsLineChart': Array<OrderTrendsLineChartItem>;
    /**
     * Pie chart data showing customer distribution by registration type.
     * @type {Array<CustomerRegistrationTypePieChartItem>}
     * @memberof AdminDashboardResponse
     */
    'customerRegistrationTypePieChart': Array<CustomerRegistrationTypePieChartItem>;
    /**
     * Pie chart data for merchant operational statuses.
     * @type {Array<MerchantStatusPieChartItem>}
     * @memberof AdminDashboardResponse
     */
    'merchantStatusPieChart': Array<MerchantStatusPieChartItem>;
    /**
     * Pie chart data for store open/closed status.
     * @type {Array<StoreStatusPieChartItem>}
     * @memberof AdminDashboardResponse
     */
    'storeStatusPieChart': Array<StoreStatusPieChartItem>;
    /**
     * Pie chart data for delivery personnel activity statuses.
     * @type {Array<DeliveryBoyStatusPieChartItem>}
     * @memberof AdminDashboardResponse
     */
    'deliveryBoyStatusPieChart': Array<DeliveryBoyStatusPieChartItem>;
    /**
     * Pie chart data for current order processing statuses.
     * @type {Array<OrderStatusPieChartItem>}
     * @memberof AdminDashboardResponse
     */
    'orderStatusPieChart': Array<OrderStatusPieChartItem>;
    /**
     * Revenue pie chart breakdown by store type.
     * @type {Array<RevenueByStoreTypePieChartItem>}
     * @memberof AdminDashboardResponse
     */
    'revenueByStoreTypePieChart': Array<RevenueByStoreTypePieChartItem>;
    /**
     * List of recent customer signups with summary fields.
     * @type {Array<RecentCustomer>}
     * @memberof AdminDashboardResponse
     */
    'recentCustomersList': Array<RecentCustomer>;
    /**
     * List of recent merchant additions with summary fields.
     * @type {Array<RecentMerchant>}
     * @memberof AdminDashboardResponse
     */
    'recentMerchantsList': Array<RecentMerchant>;
}

export const AdminDashboardResponseDashboardTypeEnum = {
    Admin: 'admin'
} as const;

export type AdminDashboardResponseDashboardTypeEnum = typeof AdminDashboardResponseDashboardTypeEnum[keyof typeof AdminDashboardResponseDashboardTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderDetail
 */
export interface AdminOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'deliveryType': AdminOrderDetailDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'currentStatus': AdminOrderDetailCurrentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderDetail
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'paymentStatus': AdminOrderDetailPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'paymentMethod'?: AdminOrderDetailPaymentMethodEnum;
    /**
     * 
     * @type {ShippingAddressNew}
     * @memberof AdminOrderDetail
     */
    'shippingAddress'?: ShippingAddressNew;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level)
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'prescriptionUrl'?: string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'orderMode'?: AdminOrderDetailOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (calculated as scheduledDeliveryTime minus configured preparation time)
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'processStartTime'?: string;
    /**
     * Indicates whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof AdminOrderDetail
     */
    'canCancel'?: boolean;
    /**
     * Indicates if the customer has tipped for this order
     * @type {boolean}
     * @memberof AdminOrderDetail
     */
    'isTipped'?: boolean;
    /**
     * 
     * @type {InvoiceDetailsNew}
     * @memberof AdminOrderDetail
     */
    'invoiceDetails'?: InvoiceDetailsNew;
    /**
     * 
     * @type {Array<TrackingHistoryItem>}
     * @memberof AdminOrderDetail
     */
    'trackingHistory'?: Array<TrackingHistoryItem>;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetail
     */
    'userType'?: AdminOrderDetailUserTypeEnum;
    /**
     * 
     * @type {Array<AdminOrderItem>}
     * @memberof AdminOrderDetail
     */
    'orderItems'?: Array<AdminOrderItem>;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof AdminOrderDetail
     */
    'customerInfo'?: CustomerInfo;
    /**
     * 
     * @type {OrderDeliveryDetails}
     * @memberof AdminOrderDetail
     */
    'orderDeliveryDetails'?: OrderDeliveryDetails;
    /**
     * 
     * @type {Array<StorePickupStatusNew>}
     * @memberof AdminOrderDetail
     */
    'storePickupStatuses'?: Array<StorePickupStatusNew>;
    /**
     * 
     * @type {MultiStoreInfo}
     * @memberof AdminOrderDetail
     */
    'multiStoreInfo'?: MultiStoreInfo;
    /**
     * 
     * @type {DriverAssignmentInfo}
     * @memberof AdminOrderDetail
     */
    'driverAssignmentInfo'?: DriverAssignmentInfo;
}

export const AdminOrderDetailDeliveryTypeEnum = {
    Delivery: 'delivery',
    SelfPickup: 'selfPickup'
} as const;

export type AdminOrderDetailDeliveryTypeEnum = typeof AdminOrderDetailDeliveryTypeEnum[keyof typeof AdminOrderDetailDeliveryTypeEnum];
export const AdminOrderDetailCurrentStatusEnum = {
    PaymentPending: 'Payment Pending',
    OrderPlaced: 'Order Placed',
    PreOrderPendingAcceptance: 'Pre-Order Pending Acceptance',
    PreOrderAccepted: 'Pre-Order Accepted',
    PreOrderDriverAssignment: 'Pre-Order Driver Assignment',
    DeliveryPartnerAssigned: 'Delivery Partner Assigned',
    DeliveryPartnerAccepted: 'Delivery Partner Accepted',
    MerchantAccepted: 'Merchant Accepted',
    MerchantRejected: 'Merchant Rejected',
    OrderPreparing: 'Order Preparing',
    ReadyForPickup: 'Ready for Pickup',
    OrderDispatched: 'Order Dispatched',
    OrderArrived: 'Order Arrived',
    OrderDelivered: 'Order Delivered',
    OrderCancelled: 'Order Cancelled',
    DeliveryFailed: 'Delivery Failed'
} as const;

export type AdminOrderDetailCurrentStatusEnum = typeof AdminOrderDetailCurrentStatusEnum[keyof typeof AdminOrderDetailCurrentStatusEnum];
export const AdminOrderDetailPaymentStatusEnum = {
    Paid: 'paid',
    Unpaid: 'unpaid',
    Partial: 'partial',
    Failed: 'failed'
} as const;

export type AdminOrderDetailPaymentStatusEnum = typeof AdminOrderDetailPaymentStatusEnum[keyof typeof AdminOrderDetailPaymentStatusEnum];
export const AdminOrderDetailPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type AdminOrderDetailPaymentMethodEnum = typeof AdminOrderDetailPaymentMethodEnum[keyof typeof AdminOrderDetailPaymentMethodEnum];
export const AdminOrderDetailOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type AdminOrderDetailOrderModeEnum = typeof AdminOrderDetailOrderModeEnum[keyof typeof AdminOrderDetailOrderModeEnum];
export const AdminOrderDetailUserTypeEnum = {
    Admin: 'Admin'
} as const;

export type AdminOrderDetailUserTypeEnum = typeof AdminOrderDetailUserTypeEnum[keyof typeof AdminOrderDetailUserTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderItem
 */
export interface AdminOrderItem {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'storeType': AdminOrderItemStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminOrderItem
     */
    'imageUrl'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItem
     */
    'originalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItem
     */
    'discountedPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'specialInstructions'?: string;
    /**
     * 
     * @type {Array<ItemChoiceNew>}
     * @memberof AdminOrderItem
     */
    'choices'?: Array<ItemChoiceNew>;
    /**
     * ID of the meal added with this item
     * @type {string}
     * @memberof AdminOrderItem
     */
    'mealId'?: string;
    /**
     * Name of the meal (English)
     * @type {string}
     * @memberof AdminOrderItem
     */
    'mealName'?: string;
    /**
     * Name of the meal (Arabic)
     * @type {string}
     * @memberof AdminOrderItem
     */
    'mealNameArabic'?: string;
    /**
     * Price of the meal
     * @type {number}
     * @memberof AdminOrderItem
     */
    'mealPrice'?: number;
    /**
     * Choice groups selected for the meal
     * @type {Array<OrderItemMealChoiceGroupsInner>}
     * @memberof AdminOrderItem
     */
    'mealChoiceGroups'?: Array<OrderItemMealChoiceGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderItem
     */
    'merchantAccepted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItem
     */
    'merchantAcceptedTime'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderItem
     */
    'isPickedUp'?: boolean;
    /**
     * 
     * @type {AdminOrderItemAllOfCostBreakdown}
     * @memberof AdminOrderItem
     */
    'costBreakdown'?: AdminOrderItemAllOfCostBreakdown;
}

export const AdminOrderItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type AdminOrderItemStoreTypeEnum = typeof AdminOrderItemStoreTypeEnum[keyof typeof AdminOrderItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderItemAllOfCostBreakdown
 */
export interface AdminOrderItemAllOfCostBreakdown {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemAllOfCostBreakdown
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemAllOfCostBreakdown
     */
    'tax'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemAllOfCostBreakdown
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ApplyCouponRequest
 */
export interface ApplyCouponRequest {
    /**
     * The ID of the user applying the coupon
     * @type {string}
     * @memberof ApplyCouponRequest
     */
    'userId': string;
    /**
     * The ID of the store where the coupon is applied
     * @type {string}
     * @memberof ApplyCouponRequest
     */
    'storeId': string;
    /**
     * The action to apply the coupon
     * @type {string}
     * @memberof ApplyCouponRequest
     */
    'action': ApplyCouponRequestActionEnum;
    /**
     * The ID of the coupon to apply
     * @type {string}
     * @memberof ApplyCouponRequest
     */
    'couponId': string;
    /**
     * The coupon code to apply
     * @type {string}
     * @memberof ApplyCouponRequest
     */
    'couponCode': string;
}

export const ApplyCouponRequestActionEnum = {
    Apply: 'apply'
} as const;

export type ApplyCouponRequestActionEnum = typeof ApplyCouponRequestActionEnum[keyof typeof ApplyCouponRequestActionEnum];

/**
 * 
 * @export
 * @interface AssignOfferRequestSchema
 */
export interface AssignOfferRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof AssignOfferRequestSchema
     */
    'userId': string;
    /**
     * 
     * @type {Array<AssignOfferRequestSchemaOffersInner>}
     * @memberof AssignOfferRequestSchema
     */
    'offers': Array<AssignOfferRequestSchemaOffersInner>;
}
/**
 * 
 * @export
 * @interface AssignOfferRequestSchemaOffersInner
 */
export interface AssignOfferRequestSchemaOffersInner {
    /**
     * 
     * @type {string}
     * @memberof AssignOfferRequestSchemaOffersInner
     */
    'offerId': string;
    /**
     * 
     * @type {number}
     * @memberof AssignOfferRequestSchemaOffersInner
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface AvailableCoupon
 */
export interface AvailableCoupon {
    /**
     * Unique identifier for the coupon
     * @type {string}
     * @memberof AvailableCoupon
     */
    'couponId': string;
    /**
     * Unique code for the coupon
     * @type {string}
     * @memberof AvailableCoupon
     */
    'couponCode': string;
    /**
     * Name or title of the coupon
     * @type {string}
     * @memberof AvailableCoupon
     */
    'couponName': string;
    /**
     * Type of the coupon discount
     * @type {string}
     * @memberof AvailableCoupon
     */
    'couponType': AvailableCouponCouponTypeEnum;
    /**
     * Maximum amount of the discount (percentage)
     * @type {number}
     * @memberof AvailableCoupon
     */
    'maxCouponAmount'?: number;
    /**
     * Discount amount or percentage
     * @type {number}
     * @memberof AvailableCoupon
     */
    'couponValue': number;
    /**
     * Start date of the coupon validity
     * @type {string}
     * @memberof AvailableCoupon
     */
    'couponStartDate': string;
    /**
     * End date of the coupon validity
     * @type {string}
     * @memberof AvailableCoupon
     */
    'couponEndDate': string;
    /**
     * Minimum order value to apply the coupon
     * @type {number}
     * @memberof AvailableCoupon
     */
    'minimumOrderValue': number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof AvailableCoupon
     */
    'currencyCode': CurrencyCode;
    /**
     * ID of the store where the coupon is applicable
     * @type {string}
     * @memberof AvailableCoupon
     */
    'storeId': string;
    /**
     * Name of the store where the coupon is applicable
     * @type {string}
     * @memberof AvailableCoupon
     */
    'storeName': string;
    /**
     * Indicates if the coupon is applied to the current order
     * @type {boolean}
     * @memberof AvailableCoupon
     */
    'isApplied': boolean;
}

export const AvailableCouponCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type AvailableCouponCouponTypeEnum = typeof AvailableCouponCouponTypeEnum[keyof typeof AvailableCouponCouponTypeEnum];

/**
 * 
 * @export
 * @interface AvailableOfferCoupon
 */
export interface AvailableOfferCoupon {
    /**
     * Unique identifier for the coupon
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'couponId': string;
    /**
     * Unique code for the coupon
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'couponCode': string;
    /**
     * Name or title of the coupon
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'couponName': string;
    /**
     * Type of the coupon discount
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'couponType': AvailableOfferCouponCouponTypeEnum;
    /**
     * Maximum amount of the discount (percentage)
     * @type {number}
     * @memberof AvailableOfferCoupon
     */
    'maxCouponAmount'?: number;
    /**
     * Discount amount or percentage
     * @type {number}
     * @memberof AvailableOfferCoupon
     */
    'couponValue': number;
    /**
     * Start date of the coupon validity
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'couponStartDate': string;
    /**
     * End date of the coupon validity
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'couponEndDate': string;
    /**
     * Minimum order value to apply the coupon
     * @type {number}
     * @memberof AvailableOfferCoupon
     */
    'minimumOrderValue'?: number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof AvailableOfferCoupon
     */
    'currencyCode': CurrencyCode;
    /**
     * Terms and conditions of the coupon
     * @type {string}
     * @memberof AvailableOfferCoupon
     */
    'termsAndConditions': string;
    /**
     * Indicates if the coupon is applied to the current order
     * @type {boolean}
     * @memberof AvailableOfferCoupon
     */
    'isApplied': boolean;
}

export const AvailableOfferCouponCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type AvailableOfferCouponCouponTypeEnum = typeof AvailableOfferCouponCouponTypeEnum[keyof typeof AvailableOfferCouponCouponTypeEnum];

/**
 * 
 * @export
 * @interface AwsPresignedURL
 */
export interface AwsPresignedURL {
    /**
     * The type of storage (e.g., \"aws\").
     * @type {string}
     * @memberof AwsPresignedURL
     */
    'type': string;
    /**
     * The presigned URL.
     * @type {string}
     * @memberof AwsPresignedURL
     */
    'signedUrl': string;
    /**
     * The expiration time of the presigned URL in minutes.
     * @type {number}
     * @memberof AwsPresignedURL
     */
    'expiresInMinutes': number;
    /**
     * The S3 bucket name.
     * @type {string}
     * @memberof AwsPresignedURL
     */
    'bucket': string;
    /**
     * The name of the file.
     * @type {string}
     * @memberof AwsPresignedURL
     */
    'fileName': string;
    /**
     * The AWS region.
     * @type {string}
     * @memberof AwsPresignedURL
     */
    'region': string;
}
/**
 * 
 * @export
 * @interface BaseOrderDetail
 */
export interface BaseOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'deliveryType': BaseOrderDetailDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'currentStatus': BaseOrderDetailCurrentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BaseOrderDetail
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'paymentStatus': BaseOrderDetailPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'paymentMethod'?: BaseOrderDetailPaymentMethodEnum;
    /**
     * 
     * @type {ShippingAddressNew}
     * @memberof BaseOrderDetail
     */
    'shippingAddress'?: ShippingAddressNew;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level)
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'prescriptionUrl'?: string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'orderMode'?: BaseOrderDetailOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (calculated as scheduledDeliveryTime minus configured preparation time)
     * @type {string}
     * @memberof BaseOrderDetail
     */
    'processStartTime'?: string;
    /**
     * Indicates whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof BaseOrderDetail
     */
    'canCancel'?: boolean;
    /**
     * Indicates if the customer has tipped for this order
     * @type {boolean}
     * @memberof BaseOrderDetail
     */
    'isTipped'?: boolean;
    /**
     * 
     * @type {InvoiceDetailsNew}
     * @memberof BaseOrderDetail
     */
    'invoiceDetails'?: InvoiceDetailsNew;
    /**
     * 
     * @type {Array<TrackingHistoryItem>}
     * @memberof BaseOrderDetail
     */
    'trackingHistory'?: Array<TrackingHistoryItem>;
}

export const BaseOrderDetailDeliveryTypeEnum = {
    Delivery: 'delivery',
    SelfPickup: 'selfPickup'
} as const;

export type BaseOrderDetailDeliveryTypeEnum = typeof BaseOrderDetailDeliveryTypeEnum[keyof typeof BaseOrderDetailDeliveryTypeEnum];
export const BaseOrderDetailCurrentStatusEnum = {
    PaymentPending: 'Payment Pending',
    OrderPlaced: 'Order Placed',
    PreOrderPendingAcceptance: 'Pre-Order Pending Acceptance',
    PreOrderAccepted: 'Pre-Order Accepted',
    PreOrderDriverAssignment: 'Pre-Order Driver Assignment',
    DeliveryPartnerAssigned: 'Delivery Partner Assigned',
    DeliveryPartnerAccepted: 'Delivery Partner Accepted',
    MerchantAccepted: 'Merchant Accepted',
    MerchantRejected: 'Merchant Rejected',
    OrderPreparing: 'Order Preparing',
    ReadyForPickup: 'Ready for Pickup',
    OrderDispatched: 'Order Dispatched',
    OrderArrived: 'Order Arrived',
    OrderDelivered: 'Order Delivered',
    OrderCancelled: 'Order Cancelled',
    DeliveryFailed: 'Delivery Failed'
} as const;

export type BaseOrderDetailCurrentStatusEnum = typeof BaseOrderDetailCurrentStatusEnum[keyof typeof BaseOrderDetailCurrentStatusEnum];
export const BaseOrderDetailPaymentStatusEnum = {
    Paid: 'paid',
    Unpaid: 'unpaid',
    Partial: 'partial',
    Failed: 'failed'
} as const;

export type BaseOrderDetailPaymentStatusEnum = typeof BaseOrderDetailPaymentStatusEnum[keyof typeof BaseOrderDetailPaymentStatusEnum];
export const BaseOrderDetailPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type BaseOrderDetailPaymentMethodEnum = typeof BaseOrderDetailPaymentMethodEnum[keyof typeof BaseOrderDetailPaymentMethodEnum];
export const BaseOrderDetailOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type BaseOrderDetailOrderModeEnum = typeof BaseOrderDetailOrderModeEnum[keyof typeof BaseOrderDetailOrderModeEnum];

/**
 * 
 * @export
 * @interface BaseOrderItem
 */
export interface BaseOrderItem {
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'storeType': BaseOrderItemStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseOrderItem
     */
    'imageUrl'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BaseOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof BaseOrderItem
     */
    'originalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof BaseOrderItem
     */
    'discountedPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseOrderItem
     */
    'specialInstructions'?: string;
    /**
     * 
     * @type {Array<ItemChoiceNew>}
     * @memberof BaseOrderItem
     */
    'choices'?: Array<ItemChoiceNew>;
    /**
     * ID of the meal added with this item
     * @type {string}
     * @memberof BaseOrderItem
     */
    'mealId'?: string;
    /**
     * Name of the meal (English)
     * @type {string}
     * @memberof BaseOrderItem
     */
    'mealName'?: string;
    /**
     * Name of the meal (Arabic)
     * @type {string}
     * @memberof BaseOrderItem
     */
    'mealNameArabic'?: string;
    /**
     * Price of the meal
     * @type {number}
     * @memberof BaseOrderItem
     */
    'mealPrice'?: number;
    /**
     * Choice groups selected for the meal
     * @type {Array<OrderItemMealChoiceGroupsInner>}
     * @memberof BaseOrderItem
     */
    'mealChoiceGroups'?: Array<OrderItemMealChoiceGroupsInner>;
}

export const BaseOrderItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type BaseOrderItemStoreTypeEnum = typeof BaseOrderItemStoreTypeEnum[keyof typeof BaseOrderItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface BaseReviewSchema
 */
export interface BaseReviewSchema {
    /**
     * 
     * @type {string}
     * @memberof BaseReviewSchema
     */
    'reviewId': string;
    /**
     * 
     * @type {string}
     * @memberof BaseReviewSchema
     */
    'type'?: BaseReviewSchemaTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof BaseReviewSchema
     */
    'rating': number;
    /**
     * 
     * @type {string}
     * @memberof BaseReviewSchema
     */
    'comment': string;
    /**
     * 
     * @type {string}
     * @memberof BaseReviewSchema
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof BaseReviewSchema
     */
    'createdAt': string;
}

export const BaseReviewSchemaTypeEnum = {
    ItemStore: 'itemStore',
    DeliveryBoy: 'deliveryBoy'
} as const;

export type BaseReviewSchemaTypeEnum = typeof BaseReviewSchemaTypeEnum[keyof typeof BaseReviewSchemaTypeEnum];

/**
 * 
 * @export
 * @interface BaseStoreFields
 */
export interface BaseStoreFields {
    /**
     * The ID of the store
     * @type {string}
     * @memberof BaseStoreFields
     */
    'id'?: string;
    /**
     * The merchant ID (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'merchantId': string;
    /**
     * The category IDs of the store
     * @type {Array<string>}
     * @memberof BaseStoreFields
     */
    'categoryId'?: Array<string>;
    /**
     * The name of the store (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'storeName': string;
    /**
     * The Arabic name of the store
     * @type {string}
     * @memberof BaseStoreFields
     */
    'storeNameArabic'?: string;
    /**
     * 
     * @type {MinOrderAmountSchema}
     * @memberof BaseStoreFields
     */
    'minOrderAmount': MinOrderAmountSchema;
    /**
     * Whether the store allows pre-ordering (mandatory)
     * @type {boolean}
     * @memberof BaseStoreFields
     */
    'canPreOrder': boolean;
    /**
     * Whether the store offers self-pickup (optional, default is false)
     * @type {boolean}
     * @memberof BaseStoreFields
     */
    'hasSelfPickup': boolean;
    /**
     * Whether delivery is available (optional, default is true)
     * @type {boolean}
     * @memberof BaseStoreFields
     */
    'deliveryAvailable': boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaDeliveryFee}
     * @memberof BaseStoreFields
     */
    'deliveryFee': WritableRestaurantDataSchemaDeliveryFee;
    /**
     * 
     * @type {TimeDataSchema}
     * @memberof BaseStoreFields
     */
    'deliveryTime': TimeDataSchema;
    /**
     * Description of the store in English (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'aboutStore': string;
    /**
     * Description of the store in Arabic (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'aboutStoreArabic'?: string;
    /**
     * Delivery radius in kilometers (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'deliveryRadiusKM': string;
    /**
     * Store phone number (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'storePhoneNumber': string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof BaseStoreFields
     */
    'storeAddress': RestaurantAddressSchema;
    /**
     * URL of the store logo (mandatory)
     * @type {string}
     * @memberof BaseStoreFields
     */
    'storeLogo': string;
    /**
     * URLs of the store banners (mandatory)
     * @type {Array<string>}
     * @memberof BaseStoreFields
     */
    'storeBanner': Array<string>;
    /**
     * 
     * @type {WorkingHoursSchema}
     * @memberof BaseStoreFields
     */
    'workingHours': WorkingHoursSchema;
    /**
     * Whether cancellation is allowed (optional, default is true)
     * @type {boolean}
     * @memberof BaseStoreFields
     */
    'isCancellationAllowed'?: boolean;
    /**
     * Cancellation policy of the store (optional, default is \"No cancellation\")
     * @type {string}
     * @memberof BaseStoreFields
     */
    'cancellationPolicy'?: string;
    /**
     * Cancellation fee (optional, default is \"0\")
     * @type {string}
     * @memberof BaseStoreFields
     */
    'cancellationFee'?: string;
    /**
     * Whether the store is wishlisted (optional, default is false)
     * @type {boolean}
     * @memberof BaseStoreFields
     */
    'isWishListed'?: boolean;
    /**
     * Rating of the store (optional, default is 0)
     * @type {number}
     * @memberof BaseStoreFields
     */
    'rating'?: number;
}
/**
 * 
 * @export
 * @interface BasicSiteInfo
 */
export interface BasicSiteInfo {
    /**
     * Site name in default language
     * @type {string}
     * @memberof BasicSiteInfo
     */
    'siteName'?: string;
    /**
     * Site name in Arabic
     * @type {string}
     * @memberof BasicSiteInfo
     */
    'siteNameArabic'?: string;
    /**
     * Primary contact email address
     * @type {string}
     * @memberof BasicSiteInfo
     */
    'contactEmail'?: string;
    /**
     * Primary contact phone number
     * @type {string}
     * @memberof BasicSiteInfo
     */
    'contactPhone'?: string;
    /**
     * Site description in default language
     * @type {string}
     * @memberof BasicSiteInfo
     */
    'siteDescription'?: string;
    /**
     * Site description in Arabic
     * @type {string}
     * @memberof BasicSiteInfo
     */
    'siteDescriptionArabic'?: string;
}
/**
 * 
 * @export
 * @interface BillSummary
 */
export interface BillSummary {
    /**
     * Subtotal amount for items
     * @type {number}
     * @memberof BillSummary
     */
    'subTotal': number;
    /**
     * Tax amount
     * @type {number}
     * @memberof BillSummary
     */
    'tax': number;
    /**
     * Delivery fee
     * @type {number}
     * @memberof BillSummary
     */
    'deliveryFee': number;
    /**
     * Coupon discount applied
     * @type {number}
     * @memberof BillSummary
     */
    'couponDiscount': number;
    /**
     * Amount paid using wallet
     * @type {number}
     * @memberof BillSummary
     */
    'walletUsed': number;
    /**
     * Total refund amount
     * @type {number}
     * @memberof BillSummary
     */
    'totalRefund': number;
    /**
     * Final total amount
     * @type {number}
     * @memberof BillSummary
     */
    'total': number;
    /**
     * Remaining amount to pay after wallet usage (for walletAndCashOnDelivery)
     * @type {number}
     * @memberof BillSummary
     */
    'remainingAmountToPay'?: number;
    /**
     * 
     * @type {PaymentBreakdown}
     * @memberof BillSummary
     */
    'paymentBreakdown'?: PaymentBreakdown;
    /**
     * Bill breakdown by store
     * @type {Array<StoreBillBreakdown>}
     * @memberof BillSummary
     */
    'storeBreakdown': Array<StoreBillBreakdown>;
}
/**
 * 
 * @export
 * @interface BlockOrUnblockRestaurantCategoryRequest
 */
export interface BlockOrUnblockRestaurantCategoryRequest {
    /**
     * 
     * @type {boolean}
     * @memberof BlockOrUnblockRestaurantCategoryRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface BulkUploadItem400Response
 */
export interface BulkUploadItem400Response {
    /**
     * 
     * @type {string}
     * @memberof BulkUploadItem400Response
     */
    'error'?: string;
    /**
     * 
     * @type {Array<BulkUploadValidationErrorSchema>}
     * @memberof BulkUploadItem400Response
     */
    'errors'?: Array<BulkUploadValidationErrorSchema>;
}
/**
 * 
 * @export
 * @interface BulkUploadResponseSchema
 */
export interface BulkUploadResponseSchema {
    /**
     * Indicates successful upload
     * @type {boolean}
     * @memberof BulkUploadResponseSchema
     */
    'success'?: boolean;
    /**
     * Number of items successfully created
     * @type {number}
     * @memberof BulkUploadResponseSchema
     */
    'itemsCreated'?: number;
    /**
     * Success message
     * @type {string}
     * @memberof BulkUploadResponseSchema
     */
    'message': string;
    /**
     * Unique identifier for the background job
     * @type {string}
     * @memberof BulkUploadResponseSchema
     */
    'jobId'?: string;
    /**
     * Estimated number of rows to process
     * @type {number}
     * @memberof BulkUploadResponseSchema
     */
    'estimatedRows'?: number;
    /**
     * Current job status
     * @type {string}
     * @memberof BulkUploadResponseSchema
     */
    'status'?: BulkUploadResponseSchemaStatusEnum;
}

export const BulkUploadResponseSchemaStatusEnum = {
    Queued: 'queued'
} as const;

export type BulkUploadResponseSchemaStatusEnum = typeof BulkUploadResponseSchemaStatusEnum[keyof typeof BulkUploadResponseSchemaStatusEnum];

/**
 * 
 * @export
 * @interface BulkUploadStatusResponseSchema
 */
export interface BulkUploadStatusResponseSchema {
    /**
     * Unique identifier for the job
     * @type {string}
     * @memberof BulkUploadStatusResponseSchema
     */
    'jobId': string;
    /**
     * Current status of the bulk upload job
     * @type {string}
     * @memberof BulkUploadStatusResponseSchema
     */
    'status': BulkUploadStatusResponseSchemaStatusEnum;
    /**
     * Processing progress as percentage (0-100)
     * @type {number}
     * @memberof BulkUploadStatusResponseSchema
     */
    'progress'?: number;
    /**
     * Total number of rows in the file
     * @type {number}
     * @memberof BulkUploadStatusResponseSchema
     */
    'totalRows'?: number;
    /**
     * Number of rows processed so far
     * @type {number}
     * @memberof BulkUploadStatusResponseSchema
     */
    'processedRows'?: number;
    /**
     * Number of rows successfully processed
     * @type {number}
     * @memberof BulkUploadStatusResponseSchema
     */
    'successfulRows'?: number;
    /**
     * Number of rows that failed
     * @type {number}
     * @memberof BulkUploadStatusResponseSchema
     */
    'failedRows'?: number;
    /**
     * Array of validation errors (if any)
     * @type {Array<BulkUploadValidationErrorSchema>}
     * @memberof BulkUploadStatusResponseSchema
     */
    'errors'?: Array<BulkUploadValidationErrorSchema>;
    /**
     * 
     * @type {BulkUploadStatusResponseSchemaResult}
     * @memberof BulkUploadStatusResponseSchema
     */
    'result'?: BulkUploadStatusResponseSchemaResult;
}

export const BulkUploadStatusResponseSchemaStatusEnum = {
    Queued: 'queued',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type BulkUploadStatusResponseSchemaStatusEnum = typeof BulkUploadStatusResponseSchemaStatusEnum[keyof typeof BulkUploadStatusResponseSchemaStatusEnum];

/**
 * Final result (only present when status is completed)
 * @export
 * @interface BulkUploadStatusResponseSchemaResult
 */
export interface BulkUploadStatusResponseSchemaResult {
    /**
     * Total items successfully created
     * @type {number}
     * @memberof BulkUploadStatusResponseSchemaResult
     */
    'itemsCreated'?: number;
    /**
     * Success message
     * @type {string}
     * @memberof BulkUploadStatusResponseSchemaResult
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface BulkUploadValidationErrorSchema
 */
export interface BulkUploadValidationErrorSchema {
    /**
     * The row number where the error occurred
     * @type {number}
     * @memberof BulkUploadValidationErrorSchema
     */
    'row': number;
    /**
     * The field that caused the error (optional)
     * @type {string}
     * @memberof BulkUploadValidationErrorSchema
     */
    'field'?: string;
    /**
     * Error message describing what went wrong
     * @type {string}
     * @memberof BulkUploadValidationErrorSchema
     */
    'message': string;
    /**
     * The invalid value (optional)
     * @type {any}
     * @memberof BulkUploadValidationErrorSchema
     */
    'value'?: any;
}
/**
 * Request to calculate featured store pricing
 * @export
 * @interface CalculateFeaturedPriceRequest
 */
export interface CalculateFeaturedPriceRequest {
    /**
     * Start date for featured store subscription
     * @type {string}
     * @memberof CalculateFeaturedPriceRequest
     */
    'fromDate': string;
    /**
     * End date for featured store subscription
     * @type {string}
     * @memberof CalculateFeaturedPriceRequest
     */
    'toDate': string;
}
/**
 * Response with calculated pricing for featured store
 * @export
 * @interface CalculateFeaturedPriceResponse
 */
export interface CalculateFeaturedPriceResponse {
    /**
     * Price per day configured in settings
     * @type {number}
     * @memberof CalculateFeaturedPriceResponse
     */
    'pricePerDay': number;
    /**
     * Number of days calculated from date range
     * @type {number}
     * @memberof CalculateFeaturedPriceResponse
     */
    'numberOfDays': number;
    /**
     * Total price for the period
     * @type {number}
     * @memberof CalculateFeaturedPriceResponse
     */
    'totalPrice': number;
    /**
     * Currency code
     * @type {string}
     * @memberof CalculateFeaturedPriceResponse
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface CancelledOrdersReportRequest
 */
export interface CancelledOrdersReportRequest {
    /**
     * Array of store IDs to filter by (optional - omit to include all stores). Maximum 50 stores per request. 
     * @type {Array<string>}
     * @memberof CancelledOrdersReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant ID to filter by (optional - omit to include all merchants). Merchants can only access their own stores. 
     * @type {string}
     * @memberof CancelledOrdersReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types (optional - omit to include all types)
     * @type {Array<string>}
     * @memberof CancelledOrdersReportRequest
     */
    'storeType'?: Array<CancelledOrdersReportRequestStoreTypeEnum>;
    /**
     * Filter by who cancelled the order (optional - omit to include all). Maps to the \'canceledBy\' field in order allAudits array. 
     * @type {Array<string>}
     * @memberof CancelledOrdersReportRequest
     */
    'cancelledBy'?: Array<CancelledOrdersReportRequestCancelledByEnum>;
    /**
     * Filter by cancellation reason (partial text search, case-insensitive). Will match orders where cancellationReason contains this text. Optional - omit to include all cancellation reasons. 
     * @type {string}
     * @memberof CancelledOrdersReportRequest
     */
    'cancellationReason'?: string;
    /**
     * Order states to include in the report (defaults to ORDER_CANCELLED, MERCHANT_CANCELLED, and DELIVERY_FAILED). Note: MERCHANT_DENIED is when merchant rejects order before acceptance, not typically counted as cancellation but can be included if specified. 
     * @type {Array<string>}
     * @memberof CancelledOrdersReportRequest
     */
    'orderStates'?: Array<CancelledOrdersReportRequestOrderStatesEnum>;
    /**
     * Filter by refund status (optional - omit to include all refund statuses). - refunded: Customer has been refunded - initiated: Refund process started but not completed - notEligible: Order not eligible for refund 
     * @type {Array<string>}
     * @memberof CancelledOrdersReportRequest
     */
    'refundStatus'?: Array<CancelledOrdersReportRequestRefundStatusEnum>;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to CANCEL DATE (when order was cancelled), not order creation date. - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof CancelledOrdersReportRequest
     */
    'dateRange': CancelledOrdersReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof CancelledOrdersReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof CancelledOrdersReportRequest
     */
    'dateTo'?: string;
}

export const CancelledOrdersReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type CancelledOrdersReportRequestStoreTypeEnum = typeof CancelledOrdersReportRequestStoreTypeEnum[keyof typeof CancelledOrdersReportRequestStoreTypeEnum];
export const CancelledOrdersReportRequestCancelledByEnum = {
    Customer: 'customer',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner',
    Admin: 'admin',
    System: 'system'
} as const;

export type CancelledOrdersReportRequestCancelledByEnum = typeof CancelledOrdersReportRequestCancelledByEnum[keyof typeof CancelledOrdersReportRequestCancelledByEnum];
export const CancelledOrdersReportRequestOrderStatesEnum = {
    OrderCancelled: 'ORDER_CANCELLED',
    MerchantCancelled: 'MERCHANT_CANCELLED',
    DeliveryFailed: 'DELIVERY_FAILED',
    MerchantDenied: 'MERCHANT_DENIED'
} as const;

export type CancelledOrdersReportRequestOrderStatesEnum = typeof CancelledOrdersReportRequestOrderStatesEnum[keyof typeof CancelledOrdersReportRequestOrderStatesEnum];
export const CancelledOrdersReportRequestRefundStatusEnum = {
    Refunded: 'refunded',
    NotEligible: 'notEligible',
    Initiated: 'initiated'
} as const;

export type CancelledOrdersReportRequestRefundStatusEnum = typeof CancelledOrdersReportRequestRefundStatusEnum[keyof typeof CancelledOrdersReportRequestRefundStatusEnum];
export const CancelledOrdersReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type CancelledOrdersReportRequestDateRangeEnum = typeof CancelledOrdersReportRequestDateRangeEnum[keyof typeof CancelledOrdersReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface CartAmountsSchema
 */
export interface CartAmountsSchema {
    /**
     * The subtotal amount of the cart before tax and fees.
     * @type {number}
     * @memberof CartAmountsSchema
     */
    'subtotal': number;
    /**
     * The tax amount applied to the cart.
     * @type {number}
     * @memberof CartAmountsSchema
     */
    'tax': number;
    /**
     * The delivery fee for the cart.
     * @type {number}
     * @memberof CartAmountsSchema
     */
    'deliveryFee': number;
    /**
     * The total amount of the cart including subtotal, tax, and delivery fee.
     * @type {number}
     * @memberof CartAmountsSchema
     */
    'total': number;
    /**
     * The coupon discount amount applied to the cart.
     * @type {number}
     * @memberof CartAmountsSchema
     */
    'couponDiscount'?: number;
}
/**
 * 
 * @export
 * @interface CartItem
 */
export interface CartItem {
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'itemNameArabic'?: string;
    /**
     * 
     * @type {string}
     * @memberof CartItem
     */
    'itemImageUrl'?: string;
    /**
     * Optional variant of the item (e.g., size, flavor)
     * @type {string}
     * @memberof CartItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof CartItem
     */
    'currencyCode'?: CurrencyCode;
    /**
     * 
     * @type {number}
     * @memberof CartItem
     */
    'originalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof CartItem
     */
    'discountPrice': number;
    /**
     * 
     * @type {number}
     * @memberof CartItem
     */
    'quantity': number;
    /**
     * Special instructions for this item (e.g., no onions, extra spicy)
     * @type {string}
     * @memberof CartItem
     */
    'specialInstructions'?: string;
    /**
     * Indicates if this pharmacy item requires a prescription (only applicable for PharmacyStore items)
     * @type {boolean}
     * @memberof CartItem
     */
    'requiresPrescription'?: boolean;
    /**
     * Indicates if the item is currently out of stock (itemQuantity <= 0)
     * @type {boolean}
     * @memberof CartItem
     */
    'isOutOfStock'?: boolean;
    /**
     * Current available quantity in stock (undefined means unlimited stock)
     * @type {number}
     * @memberof CartItem
     */
    'availableQuantity'?: number;
    /**
     * List of choices selected for this item
     * @type {Array<StoreItemChoice>}
     * @memberof CartItem
     */
    'choices'?: Array<StoreItemChoice>;
}


/**
 * 
 * @export
 * @interface CartPrice
 */
export interface CartPrice {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof CartPrice
     */
    'currencyCode'?: CurrencyCode;
    /**
     * 
     * @type {number}
     * @memberof CartPrice
     */
    'subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof CartPrice
     */
    'tax': number;
    /**
     * 
     * @type {number}
     * @memberof CartPrice
     */
    'deliveryFee': number;
    /**
     * 
     * @type {number}
     * @memberof CartPrice
     */
    'total': number;
    /**
     * Total discount applied from coupons
     * @type {number}
     * @memberof CartPrice
     */
    'couponDiscount'?: number;
}


/**
 * 
 * @export
 * @interface ChangePasswordRequestSchema
 */
export interface ChangePasswordRequestSchema {
    /**
     * Current password
     * @type {string}
     * @memberof ChangePasswordRequestSchema
     */
    'currentPassword': string;
    /**
     * New password
     * @type {string}
     * @memberof ChangePasswordRequestSchema
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface CheckUserExistsRequest
 */
export interface CheckUserExistsRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckUserExistsRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CheckUserExistsRequest
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface CheckUserExistsResponse
 */
export interface CheckUserExistsResponse {
    /**
     * Indicates whether the user exists in the database
     * @type {boolean}
     * @memberof CheckUserExistsResponse
     */
    'isExists': boolean;
    /**
     * Human-readable message
     * @type {string}
     * @memberof CheckUserExistsResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CheckoutPaymentDetails
 */
export interface CheckoutPaymentDetails {
    /**
     * Total order amount
     * @type {number}
     * @memberof CheckoutPaymentDetails
     */
    'totalAmount'?: number;
    /**
     * Amount deducted from wallet
     * @type {number}
     * @memberof CheckoutPaymentDetails
     */
    'walletAmountUsed'?: number;
    /**
     * Remaining amount to be paid via other methods
     * @type {number}
     * @memberof CheckoutPaymentDetails
     */
    'remainingAmount'?: number;
    /**
     * Primary payment method used
     * @type {string}
     * @memberof CheckoutPaymentDetails
     */
    'paymentMethod'?: string;
}
/**
 * 
 * @export
 * @interface CheckoutRequestSchema
 */
export interface CheckoutRequestSchema {
    /**
     * Platform type - determines payment response format (web: checkoutUrl, mobile: clientSecret for SDK)
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'platform'?: CheckoutRequestSchemaPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'deliveryType': CheckoutRequestSchemaDeliveryTypeEnum;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof CheckoutRequestSchema
     */
    'shippingAddress': ShippingAddress;
    /**
     * Method of payment for the order
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'paymentMethod': CheckoutRequestSchemaPaymentMethodEnum;
    /**
     * Explicit payment gateway selection for online payments (required when paymentMethod is onlinePayment or walletAndOnlinePayment)
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'paymentGateway'?: CheckoutRequestSchemaPaymentGatewayEnum;
    /**
     * Whether to use wallet balance for payment
     * @type {boolean}
     * @memberof CheckoutRequestSchema
     */
    'useWalletBalance'?: boolean;
    /**
     * Amount to deduct from wallet (optional, will use available balance if not specified)
     * @type {number}
     * @memberof CheckoutRequestSchema
     */
    'walletAmount'?: number;
    /**
     * Optional note to the delivery person
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level, required if any item needs prescription)
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'prescriptionUrl'?: string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'orderMode'?: CheckoutRequestSchemaOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (required when orderMode is preOrder, must be at least 1 hour in the future)
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Type of cart items
     * @type {string}
     * @memberof CheckoutRequestSchema
     */
    'cartItemsType': CheckoutRequestSchemaCartItemsTypeEnum;
}

export const CheckoutRequestSchemaPlatformEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;

export type CheckoutRequestSchemaPlatformEnum = typeof CheckoutRequestSchemaPlatformEnum[keyof typeof CheckoutRequestSchemaPlatformEnum];
export const CheckoutRequestSchemaDeliveryTypeEnum = {
    Delivery: 'delivery',
    SelfPickup: 'selfPickup'
} as const;

export type CheckoutRequestSchemaDeliveryTypeEnum = typeof CheckoutRequestSchemaDeliveryTypeEnum[keyof typeof CheckoutRequestSchemaDeliveryTypeEnum];
export const CheckoutRequestSchemaPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type CheckoutRequestSchemaPaymentMethodEnum = typeof CheckoutRequestSchemaPaymentMethodEnum[keyof typeof CheckoutRequestSchemaPaymentMethodEnum];
export const CheckoutRequestSchemaPaymentGatewayEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type CheckoutRequestSchemaPaymentGatewayEnum = typeof CheckoutRequestSchemaPaymentGatewayEnum[keyof typeof CheckoutRequestSchemaPaymentGatewayEnum];
export const CheckoutRequestSchemaOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type CheckoutRequestSchemaOrderModeEnum = typeof CheckoutRequestSchemaOrderModeEnum[keyof typeof CheckoutRequestSchemaOrderModeEnum];
export const CheckoutRequestSchemaCartItemsTypeEnum = {
    All: 'All',
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type CheckoutRequestSchemaCartItemsTypeEnum = typeof CheckoutRequestSchemaCartItemsTypeEnum[keyof typeof CheckoutRequestSchemaCartItemsTypeEnum];

/**
 * 
 * @export
 * @interface CheckoutResponseSchema
 */
export interface CheckoutResponseSchema {
    /**
     * 
     * @type {boolean}
     * @memberof CheckoutResponseSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {CheckoutPaymentDetails}
     * @memberof CheckoutResponseSchema
     */
    'paymentDetails'?: CheckoutPaymentDetails;
    /**
     * Gateway checkout session ID (for online payments)
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'checkoutId'?: string;
    /**
     * URL to redirect user for payment (web platform only)
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'checkoutUrl'?: string;
    /**
     * Client secret for mobile SDK payment (mobile platform only, Stripe only)
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'clientSecret'?: string;
    /**
     * Payment gateway type (for online payments)
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'gatewayType'?: CheckoutResponseSchemaGatewayTypeEnum;
    /**
     * Payment session expiry time
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'expiresAt'?: string;
    /**
     * Order mode - normal or preOrder
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'orderMode'?: CheckoutResponseSchemaOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (calculated as scheduledDeliveryTime minus configured preparation time, only present for preOrder mode)
     * @type {string}
     * @memberof CheckoutResponseSchema
     */
    'processStartTime'?: string;
    /**
     * Whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof CheckoutResponseSchema
     */
    'canCancel'?: boolean;
}

export const CheckoutResponseSchemaGatewayTypeEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type CheckoutResponseSchemaGatewayTypeEnum = typeof CheckoutResponseSchemaGatewayTypeEnum[keyof typeof CheckoutResponseSchemaGatewayTypeEnum];
export const CheckoutResponseSchemaOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type CheckoutResponseSchemaOrderModeEnum = typeof CheckoutResponseSchemaOrderModeEnum[keyof typeof CheckoutResponseSchemaOrderModeEnum];

/**
 * 
 * @export
 * @interface ChoiceGroupList
 */
export interface ChoiceGroupList {
    /**
     * Unique identifier for the choice group
     * @type {string}
     * @memberof ChoiceGroupList
     */
    'choiceGroupId': string;
    /**
     * Name of the choice group in English
     * @type {string}
     * @memberof ChoiceGroupList
     */
    'choiceGroupName': string;
}
/**
 * 
 * @export
 * @interface ChoiceList
 */
export interface ChoiceList {
    /**
     * Unique identifier for the choice
     * @type {string}
     * @memberof ChoiceList
     */
    'choiceId': string;
    /**
     * Name of the choice
     * @type {string}
     * @memberof ChoiceList
     */
    'choiceName': string;
}
/**
 * 
 * @export
 * @interface ChoiceSchema
 */
export interface ChoiceSchema {
    /**
     * ID of the choice
     * @type {string}
     * @memberof ChoiceSchema
     */
    'choiceId': string;
    /**
     * Type of store to which the choice belongs
     * @type {string}
     * @memberof ChoiceSchema
     */
    'storeType': ChoiceSchemaStoreTypeEnum;
    /**
     * ID of the store to which the choice belongs
     * @type {string}
     * @memberof ChoiceSchema
     */
    'storeId': string;
    /**
     * Name of the store to which the choice belongs
     * @type {string}
     * @memberof ChoiceSchema
     */
    'storeName': string;
    /**
     * name of the choice in English
     * @type {string}
     * @memberof ChoiceSchema
     */
    'choiceNameEnglish': string;
    /**
     * name of the choice in Arabic
     * @type {string}
     * @memberof ChoiceSchema
     */
    'choiceNameArabic': string;
    /**
     * price of the choice
     * @type {number}
     * @memberof ChoiceSchema
     */
    'price': number;
    /**
     * status of the choice
     * @type {string}
     * @memberof ChoiceSchema
     */
    'status': ChoiceSchemaStatusEnum;
    /**
     * who added the choice
     * @type {string}
     * @memberof ChoiceSchema
     */
    'addedBy': ChoiceSchemaAddedByEnum;
    /**
     * name of the merchant
     * @type {string}
     * @memberof ChoiceSchema
     */
    'merchantName'?: string;
    /**
     * email of the merchant
     * @type {string}
     * @memberof ChoiceSchema
     */
    'merchantEmail'?: string;
}

export const ChoiceSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type ChoiceSchemaStoreTypeEnum = typeof ChoiceSchemaStoreTypeEnum[keyof typeof ChoiceSchemaStoreTypeEnum];
export const ChoiceSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type ChoiceSchemaStatusEnum = typeof ChoiceSchemaStatusEnum[keyof typeof ChoiceSchemaStatusEnum];
export const ChoiceSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type ChoiceSchemaAddedByEnum = typeof ChoiceSchemaAddedByEnum[keyof typeof ChoiceSchemaAddedByEnum];

/**
 * 
 * @export
 * @interface CmsPageResponseSchema
 */
export interface CmsPageResponseSchema {
    /**
     * ID of the CMS page
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'pageId': string;
    /**
     * The title of the page.
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'pageTitle': string;
    /**
     * The title of the page in Arabic.
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'pageTitleInArabic': string;
    /**
     * The description of the page.
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'pageDescription': string;
    /**
     * The description of the page in Arabic.
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'pageDescriptionInArabic': string;
    /**
     * URL-friendly slug generated from the page title
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'slug': string;
    /**
     * The status of the coupon.
     * @type {string}
     * @memberof CmsPageResponseSchema
     */
    'status': CmsPageResponseSchemaStatusEnum;
}

export const CmsPageResponseSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type CmsPageResponseSchemaStatusEnum = typeof CmsPageResponseSchemaStatusEnum[keyof typeof CmsPageResponseSchemaStatusEnum];

/**
 * 
 * @export
 * @interface CommissionRecord
 */
export interface CommissionRecord {
    /**
     * Unique commission tracking ID
     * @type {string}
     * @memberof CommissionRecord
     */
    'id'?: string;
    /**
     * Type of commission record
     * @type {string}
     * @memberof CommissionRecord
     */
    'recordType'?: CommissionRecordRecordTypeEnum;
    /**
     * Name of the restaurant (common in merchant & admin_merchant)
     * @type {string}
     * @memberof CommissionRecord
     */
    'storeName'?: string;
    /**
     * Total order amount in JOD (common in merchant & admin_merchant)
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalOrderAmount'?: number;
    /**
     * Total admin commission amount in JOD (common in merchant & admin_merchant)
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalAdminCommissionAmount'?: number;
    /**
     * Total amount for merchant rejected items in JOD (common in merchant & admin_merchant)
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalMerchantRejectedItemAmount'?: number;
    /**
     * Total amount for user cancelled items in JOD (common in merchant & admin_merchant)
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalUserCancelledItemAmount'?: number;
    /**
     * Balance amount to receive in JOD (common in merchant & delivery_partner)
     * @type {number}
     * @memberof CommissionRecord
     */
    'balanceAmountToReceive'?: number;
    /**
     * Amount received from admin in JOD (merchant only)
     * @type {number}
     * @memberof CommissionRecord
     */
    'receivedAmountFromAdmin'?: number;
    /**
     * Merchant email address
     * @type {string}
     * @memberof CommissionRecord
     */
    'merchantEmail'?: string;
    /**
     * Merchant name
     * @type {string}
     * @memberof CommissionRecord
     */
    'merchantName'?: string;
    /**
     * Delivery fee in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'deliveryFee'?: number;
    /**
     * Total wallet, coupon & offer amount in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalWalletCouponOfferAmount'?: number;
    /**
     * Total item amount in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalItemAmount'?: number;
    /**
     * Admin paid amount to merchant in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'adminPaidAmountToMerchant'?: number;
    /**
     * Balance amount to pay in JOD (can be negative)
     * @type {number}
     * @memberof CommissionRecord
     */
    'balanceAmountToPay'?: number;
    /**
     * Current payment status
     * @type {string}
     * @memberof CommissionRecord
     */
    'paymentStatus'?: string;
    /**
     * Delivery partner ID
     * @type {string}
     * @memberof CommissionRecord
     */
    'deliveryPartnerId'?: string;
    /**
     * Delivery partner name
     * @type {string}
     * @memberof CommissionRecord
     */
    'deliveryPartnerName'?: string;
    /**
     * Delivery partner email
     * @type {string}
     * @memberof CommissionRecord
     */
    'deliveryPartnerEmail'?: string;
    /**
     * Delivery partner phone number
     * @type {string}
     * @memberof CommissionRecord
     */
    'deliveryPartnerPhone'?: string;
    /**
     * Total number of orders delivered
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalOrders'?: number;
    /**
     * Total order amount in JOD (delivery_partner only)
     * @type {number}
     * @memberof CommissionRecord
     */
    'orderAmount'?: number;
    /**
     * Amount received by delivery partner in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'receivedAmount'?: number;
    /**
     * Total commission amount in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'totalCommissionAmount'?: number;
    /**
     * Amount paid to delivery partner in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'paidAmount'?: number;
    /**
     * Balance amount to pay to delivery person in JOD
     * @type {number}
     * @memberof CommissionRecord
     */
    'balanceAmountToPayToDeliveryPerson'?: number;
    /**
     * Record creation timestamp
     * @type {string}
     * @memberof CommissionRecord
     */
    'createdAt'?: string;
    /**
     * Record last update timestamp
     * @type {string}
     * @memberof CommissionRecord
     */
    'updatedAt'?: string;
    /**
     * List of transactions associated with this record
     * @type {Array<CommissionTransaction>}
     * @memberof CommissionRecord
     */
    'transactions'?: Array<CommissionTransaction>;
}

export const CommissionRecordRecordTypeEnum = {
    Merchant: 'merchant',
    AdminMerchant: 'admin_merchant',
    DeliveryPartner: 'delivery_partner'
} as const;

export type CommissionRecordRecordTypeEnum = typeof CommissionRecordRecordTypeEnum[keyof typeof CommissionRecordRecordTypeEnum];

/**
 * 
 * @export
 * @interface CommissionTrackingResponse
 */
export interface CommissionTrackingResponse {
    /**
     * 
     * @type {Array<CommissionRecord>}
     * @memberof CommissionTrackingResponse
     */
    'records'?: Array<CommissionRecord>;
    /**
     * 
     * @type {Pagination}
     * @memberof CommissionTrackingResponse
     */
    'pagination'?: Pagination;
}
/**
 * 
 * @export
 * @interface CommissionTrackingSummary
 */
export interface CommissionTrackingSummary {
    /**
     * Total number of records across all types
     * @type {number}
     * @memberof CommissionTrackingSummary
     */
    'totalRecords'?: number;
    /**
     * 
     * @type {CommissionTrackingSummaryRecordsByType}
     * @memberof CommissionTrackingSummary
     */
    'recordsByType'?: CommissionTrackingSummaryRecordsByType;
    /**
     * 
     * @type {CommissionTrackingSummaryTotalAmounts}
     * @memberof CommissionTrackingSummary
     */
    'totalAmounts'?: CommissionTrackingSummaryTotalAmounts;
    /**
     * 
     * @type {CommissionTrackingSummaryTransactionsSummary}
     * @memberof CommissionTrackingSummary
     */
    'transactionsSummary'?: CommissionTrackingSummaryTransactionsSummary;
}
/**
 * 
 * @export
 * @interface CommissionTrackingSummaryRecordsByType
 */
export interface CommissionTrackingSummaryRecordsByType {
    /**
     * Number of merchant commission records
     * @type {number}
     * @memberof CommissionTrackingSummaryRecordsByType
     */
    'merchant'?: number;
    /**
     * Number of admin merchant commission records
     * @type {number}
     * @memberof CommissionTrackingSummaryRecordsByType
     */
    'admin_merchant'?: number;
    /**
     * Number of delivery partner commission records
     * @type {number}
     * @memberof CommissionTrackingSummaryRecordsByType
     */
    'delivery_partner'?: number;
}
/**
 * 
 * @export
 * @interface CommissionTrackingSummaryTotalAmounts
 */
export interface CommissionTrackingSummaryTotalAmounts {
    /**
     * Sum of all order amounts
     * @type {number}
     * @memberof CommissionTrackingSummaryTotalAmounts
     */
    'totalOrderAmount'?: number;
    /**
     * Sum of all commission amounts
     * @type {number}
     * @memberof CommissionTrackingSummaryTotalAmounts
     */
    'totalCommissionAmount'?: number;
    /**
     * Sum of all balance amounts
     * @type {number}
     * @memberof CommissionTrackingSummaryTotalAmounts
     */
    'totalBalanceAmount'?: number;
    /**
     * Sum of all paid amounts
     * @type {number}
     * @memberof CommissionTrackingSummaryTotalAmounts
     */
    'totalPaidAmount'?: number;
}
/**
 * 
 * @export
 * @interface CommissionTrackingSummaryTransactionsSummary
 */
export interface CommissionTrackingSummaryTransactionsSummary {
    /**
     * Total number of transactions
     * @type {number}
     * @memberof CommissionTrackingSummaryTransactionsSummary
     */
    'totalTransactions'?: number;
    /**
     * Sum of all transaction amounts
     * @type {number}
     * @memberof CommissionTrackingSummaryTransactionsSummary
     */
    'totalTransactionAmount'?: number;
}
/**
 * 
 * @export
 * @interface CommissionTransaction
 */
export interface CommissionTransaction {
    /**
     * Unique transaction ID
     * @type {string}
     * @memberof CommissionTransaction
     */
    'id'?: string;
    /**
     * Transaction reference ID
     * @type {string}
     * @memberof CommissionTransaction
     */
    'transactionId'?: string;
    /**
     * Merchant email (for merchant/admin merchant transactions)
     * @type {string}
     * @memberof CommissionTransaction
     */
    'merchantEmail'?: string | null;
    /**
     * Merchant name (for merchant/admin merchant transactions)
     * @type {string}
     * @memberof CommissionTransaction
     */
    'merchantName'?: string | null;
    /**
     * Delivery partner name (for delivery partner transactions)
     * @type {string}
     * @memberof CommissionTransaction
     */
    'deliveryPartnerName'?: string | null;
    /**
     * Amount paid by admin to merchant/delivery partner
     * @type {number}
     * @memberof CommissionTransaction
     */
    'adminPaidAmountToMerchant'?: number;
    /**
     * Paid amount in JOD
     * @type {number}
     * @memberof CommissionTransaction
     */
    'paidAmount'?: number;
    /**
     * Received order amount in JOD
     * @type {number}
     * @memberof CommissionTransaction
     */
    'receivedOrderAmount'?: number | null;
    /**
     * Payment date and time
     * @type {string}
     * @memberof CommissionTransaction
     */
    'paidDate'?: string;
    /**
     * Payment method used
     * @type {string}
     * @memberof CommissionTransaction
     */
    'payType'?: CommissionTransactionPayTypeEnum;
    /**
     * Transaction status
     * @type {string}
     * @memberof CommissionTransaction
     */
    'transactionStatus'?: CommissionTransactionTransactionStatusEnum;
    /**
     * Additional remarks or notes
     * @type {string}
     * @memberof CommissionTransaction
     */
    'remarks'?: string | null;
    /**
     * Transaction creation timestamp
     * @type {string}
     * @memberof CommissionTransaction
     */
    'createdAt'?: string;
    /**
     * Transaction last update timestamp
     * @type {string}
     * @memberof CommissionTransaction
     */
    'updatedAt'?: string;
}

export const CommissionTransactionPayTypeEnum = {
    NetBanking: 'net_banking',
    CreditCard: 'credit_card',
    DebitCard: 'debit_card',
    Wallet: 'wallet',
    Cash: 'cash',
    BankTransfer: 'bank_transfer',
    Upi: 'upi'
} as const;

export type CommissionTransactionPayTypeEnum = typeof CommissionTransactionPayTypeEnum[keyof typeof CommissionTransactionPayTypeEnum];
export const CommissionTransactionTransactionStatusEnum = {
    Completed: 'completed',
    Pending: 'pending',
    Failed: 'failed',
    Cancelled: 'cancelled'
} as const;

export type CommissionTransactionTransactionStatusEnum = typeof CommissionTransactionTransactionStatusEnum[keyof typeof CommissionTransactionTransactionStatusEnum];

/**
 * 
 * @export
 * @interface CommonDeliveryFeeSchema
 */
export interface CommonDeliveryFeeSchema {
    /**
     * Common delivery fee status
     * @type {string}
     * @memberof CommonDeliveryFeeSchema
     */
    'type': CommonDeliveryFeeSchemaTypeEnum;
    /**
     * The value of the common delivery fee
     * @type {number}
     * @memberof CommonDeliveryFeeSchema
     */
    'commonDeliveryFeeValue'?: number;
}

export const CommonDeliveryFeeSchemaTypeEnum = {
    Disable: 'disable',
    Enable: 'enable'
} as const;

export type CommonDeliveryFeeSchemaTypeEnum = typeof CommonDeliveryFeeSchemaTypeEnum[keyof typeof CommonDeliveryFeeSchemaTypeEnum];

/**
 * 
 * @export
 * @interface CommonDeliveryRadius
 */
export interface CommonDeliveryRadius {
    /**
     * Use common delivery radius for all restaurants
     * @type {boolean}
     * @memberof CommonDeliveryRadius
     */
    'status': boolean;
    /**
     * Common delivery radius
     * @type {number}
     * @memberof CommonDeliveryRadius
     */
    'deliveryRadius'?: number;
    /**
     * Delivery radius type (kilometers or miles)
     * @type {string}
     * @memberof CommonDeliveryRadius
     */
    'deliveryRadiusType'?: CommonDeliveryRadiusDeliveryRadiusTypeEnum;
}

export const CommonDeliveryRadiusDeliveryRadiusTypeEnum = {
    Kilometers: 'kilometers',
    Miles: 'miles'
} as const;

export type CommonDeliveryRadiusDeliveryRadiusTypeEnum = typeof CommonDeliveryRadiusDeliveryRadiusTypeEnum[keyof typeof CommonDeliveryRadiusDeliveryRadiusTypeEnum];

/**
 * 
 * @export
 * @interface ConfigurationSettings
 */
export interface ConfigurationSettings {
    /**
     * 
     * @type {OnboardingSlides}
     * @memberof ConfigurationSettings
     */
    'onboardingSlidesData'?: OnboardingSlides;
    /**
     * 
     * @type {DesignSettings}
     * @memberof ConfigurationSettings
     */
    'appDesignData'?: DesignSettings;
    /**
     * 
     * @type {SocialLoginOptions}
     * @memberof ConfigurationSettings
     */
    'socialLoginData'?: SocialLoginOptions;
    /**
     * 
     * @type {GoogleMapsSettings}
     * @memberof ConfigurationSettings
     */
    'googleMapsData'?: GoogleMapsSettings;
    /**
     * 
     * @type {Array<DynamicHomePageContentSettings>}
     * @memberof ConfigurationSettings
     */
    'dynamicHomePageContentData'?: Array<DynamicHomePageContentSettings>;
    /**
     * 
     * @type {GeneralSettingsRequest}
     * @memberof ConfigurationSettings
     */
    'generalSettingsData'?: GeneralSettingsRequest;
}
/**
 * 
 * @export
 * @interface CouponResponseSchema
 */
export interface CouponResponseSchema {
    /**
     * ID of the coupon
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'couponId': string;
    /**
     * The coupon code that will be used to redeem the coupon.
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'couponCode': string;
    /**
     * The name of the coupon.
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'couponName': string;
    /**
     * The type of coupon (e.g., percentage, fixed amount).
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'couponType': CouponResponseSchemaCouponTypeEnum;
    /**
     * The maximum amount of the coupon when coupon type is percentage.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'maxCouponAmount'?: number;
    /**
     * The value of the coupon.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'couponValue': number;
    /**
     * The start date of the coupon in ISO 8601 format (YYYY-MM-DD).
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'couponStartDate': string;
    /**
     * The end date of the coupon in ISO 8601 format (YYYY-MM-DD).
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'couponEndDate': string;
    /**
     * The number of days the coupon is valid for.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'validityDays'?: number;
    /**
     * 
     * @type {Array<CouponResponseSchemaStoresInner>}
     * @memberof CouponResponseSchema
     */
    'stores': Array<CouponResponseSchemaStoresInner>;
    /**
     * The maximum number of times a user can use the coupon.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'couponPerUserLimit': number;
    /**
     * The total number of coupons available.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'totalCouponCount': number;
    /**
     * The number of coupons that have been used.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'usedCouponCount'?: number;
    /**
     * The percentage of coupons that have been used.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'unusedCouponCount'?: number;
    /**
     * The minimum order value required to apply the coupon.
     * @type {number}
     * @memberof CouponResponseSchema
     */
    'minimumOrderValue': number;
    /**
     * Indicates whether to send the coupon to all users via email.
     * @type {boolean}
     * @memberof CouponResponseSchema
     */
    'sendEmailToAllUsers': boolean;
    /**
     * The status of the coupon.
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'status'?: CouponResponseSchemaStatusEnum;
    /**
     * The entity that added the coupon.
     * @type {string}
     * @memberof CouponResponseSchema
     */
    'addedBy'?: CouponResponseSchemaAddedByEnum;
}

export const CouponResponseSchemaCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type CouponResponseSchemaCouponTypeEnum = typeof CouponResponseSchemaCouponTypeEnum[keyof typeof CouponResponseSchemaCouponTypeEnum];
export const CouponResponseSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type CouponResponseSchemaStatusEnum = typeof CouponResponseSchemaStatusEnum[keyof typeof CouponResponseSchemaStatusEnum];
export const CouponResponseSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type CouponResponseSchemaAddedByEnum = typeof CouponResponseSchemaAddedByEnum[keyof typeof CouponResponseSchemaAddedByEnum];

/**
 * 
 * @export
 * @interface CouponResponseSchemaStoresInner
 */
export interface CouponResponseSchemaStoresInner {
    /**
     * The unique identifier of the store.
     * @type {string}
     * @memberof CouponResponseSchemaStoresInner
     */
    'storeId'?: string;
    /**
     * The name of the store.
     * @type {string}
     * @memberof CouponResponseSchemaStoresInner
     */
    'storeName'?: string;
}
/**
 * 
 * @export
 * @interface CreateItemCategoryRequest
 */
export interface CreateItemCategoryRequest {
    /**
     * The ID of the store to which the item category belongs.
     * @type {string}
     * @memberof CreateItemCategoryRequest
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemCategoryRequest
     */
    'storeType': CreateItemCategoryRequestStoreTypeEnum;
    /**
     * The name of the restaurant category in English.
     * @type {string}
     * @memberof CreateItemCategoryRequest
     */
    'nameEnglish': string;
    /**
     * The name of the restaurant category in Arabic.
     * @type {string}
     * @memberof CreateItemCategoryRequest
     */
    'nameArabic': string;
    /**
     * Who added the category.
     * @type {string}
     * @memberof CreateItemCategoryRequest
     */
    'addedBy': CreateItemCategoryRequestAddedByEnum;
}

export const CreateItemCategoryRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type CreateItemCategoryRequestStoreTypeEnum = typeof CreateItemCategoryRequestStoreTypeEnum[keyof typeof CreateItemCategoryRequestStoreTypeEnum];
export const CreateItemCategoryRequestAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type CreateItemCategoryRequestAddedByEnum = typeof CreateItemCategoryRequestAddedByEnum[keyof typeof CreateItemCategoryRequestAddedByEnum];

/**
 * 
 * @export
 * @interface CreateItemSubCategoryRequest
 */
export interface CreateItemSubCategoryRequest {
    /**
     * The ID of the store to which the item subcategory belongs.
     * @type {string}
     * @memberof CreateItemSubCategoryRequest
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateItemSubCategoryRequest
     */
    'storeType': CreateItemSubCategoryRequestStoreTypeEnum;
    /**
     * The name of the subcategory in English.
     * @type {string}
     * @memberof CreateItemSubCategoryRequest
     */
    'nameEnglish': string;
    /**
     * The name of the subcategory in Arabic.
     * @type {string}
     * @memberof CreateItemSubCategoryRequest
     */
    'nameArabic': string;
    /**
     * The ID of the parent category to which the subcategory will be mapped.
     * @type {string}
     * @memberof CreateItemSubCategoryRequest
     */
    'parentCategoryId': string;
    /**
     * Who added the subcategory.
     * @type {string}
     * @memberof CreateItemSubCategoryRequest
     */
    'addedBy': CreateItemSubCategoryRequestAddedByEnum;
}

export const CreateItemSubCategoryRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type CreateItemSubCategoryRequestStoreTypeEnum = typeof CreateItemSubCategoryRequestStoreTypeEnum[keyof typeof CreateItemSubCategoryRequestStoreTypeEnum];
export const CreateItemSubCategoryRequestAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type CreateItemSubCategoryRequestAddedByEnum = typeof CreateItemSubCategoryRequestAddedByEnum[keyof typeof CreateItemSubCategoryRequestAddedByEnum];

/**
 * 
 * @export
 * @interface CreateRestaurantCategoryRequest
 */
export interface CreateRestaurantCategoryRequest {
    /**
     * The type of user who is creating the category.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'createdUserType': CreateRestaurantCategoryRequestCreatedUserTypeEnum;
    /**
     * The ID of the user who is creating the category.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'createdUserId': string;
    /**
     * The type of category being created.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'storeCategoryType'?: CreateRestaurantCategoryRequestStoreCategoryTypeEnum;
    /**
     * The category name in English.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'nameEnglish': string;
    /**
     * The category name in Arabic.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'nameArabic': string;
    /**
     * The URL of the category image.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'categoryImage': string;
    /**
     * The URL of the category icon.
     * @type {string}
     * @memberof CreateRestaurantCategoryRequest
     */
    'categoryIcon': string;
}

export const CreateRestaurantCategoryRequestCreatedUserTypeEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type CreateRestaurantCategoryRequestCreatedUserTypeEnum = typeof CreateRestaurantCategoryRequestCreatedUserTypeEnum[keyof typeof CreateRestaurantCategoryRequestCreatedUserTypeEnum];
export const CreateRestaurantCategoryRequestStoreCategoryTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type CreateRestaurantCategoryRequestStoreCategoryTypeEnum = typeof CreateRestaurantCategoryRequestStoreCategoryTypeEnum[keyof typeof CreateRestaurantCategoryRequestStoreCategoryTypeEnum];

/**
 * 
 * @export
 * @interface CurrencyAndTimeSettings
 */
export interface CurrencyAndTimeSettings {
    /**
     * Default system currency code (ISO 4217, 3 uppercase letters)
     * @type {string}
     * @memberof CurrencyAndTimeSettings
     */
    'defaultCurrency'?: string;
    /**
     * Currency symbol for display
     * @type {string}
     * @memberof CurrencyAndTimeSettings
     */
    'currencySymbol'?: string;
    /**
     * Currency converter API key
     * @type {string}
     * @memberof CurrencyAndTimeSettings
     */
    'currencyConverterApiKey'?: string;
    /**
     * Timezone identifier (e.g., America/New_York)
     * @type {string}
     * @memberof CurrencyAndTimeSettings
     */
    'timeZone'?: string;
    /**
     * Date time format string
     * @type {string}
     * @memberof CurrencyAndTimeSettings
     */
    'dateTimeFormat'?: string;
    /**
     * Enable/disable email notifications
     * @type {boolean}
     * @memberof CurrencyAndTimeSettings
     */
    'emailStatus'?: boolean;
    /**
     * Enable/disable SMS notifications
     * @type {boolean}
     * @memberof CurrencyAndTimeSettings
     */
    'smsStatus'?: boolean;
}
/**
 * Supported currency codes
 * @export
 * @enum {string}
 */

export const CurrencyCode = {
    Usd: 'USD',
    Jod: 'JOD'
} as const;

export type CurrencyCode = typeof CurrencyCode[keyof typeof CurrencyCode];


/**
 * 
 * @export
 * @interface CustomerCheckoutDetails
 */
export interface CustomerCheckoutDetails {
    /**
     * 
     * @type {string}
     * @memberof CustomerCheckoutDetails
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerCheckoutDetails
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerCheckoutDetails
     */
    'userEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerCheckoutDetails
     */
    'userPhoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerCheckoutDetails
     */
    'userAlternativePhoneNumber'?: string;
    /**
     * 
     * @type {Array<UserAddressSchema>}
     * @memberof CustomerCheckoutDetails
     */
    'deliveryAddress': Array<UserAddressSchema>;
}
/**
 * 
 * @export
 * @interface CustomerCmsPageSchema
 */
export interface CustomerCmsPageSchema {
    /**
     * ID of the CMS page
     * @type {string}
     * @memberof CustomerCmsPageSchema
     */
    'id': string;
    /**
     * The title of the page in the requested language
     * @type {string}
     * @memberof CustomerCmsPageSchema
     */
    'pageTitle': string;
    /**
     * The description of the page in the requested language
     * @type {string}
     * @memberof CustomerCmsPageSchema
     */
    'pageDescription': string;
    /**
     * URL-friendly slug generated from the page title
     * @type {string}
     * @memberof CustomerCmsPageSchema
     */
    'slug': string;
}
/**
 * 
 * @export
 * @interface CustomerCmsPagesResponseSchema
 */
export interface CustomerCmsPagesResponseSchema {
    /**
     * List of CMS pages for customer display
     * @type {Array<CustomerCmsPageSchema>}
     * @memberof CustomerCmsPagesResponseSchema
     */
    'data': Array<CustomerCmsPageSchema>;
}
/**
 * 
 * @export
 * @interface CustomerDetailsSchema
 */
export interface CustomerDetailsSchema {
    /**
     * Unique identifier for the customer
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'id': string;
    /**
     * Full name of the customer
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userName': string;
    /**
     * Email address of the customer
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userEmail': string;
    /**
     * Phone number of the customer (Must be a valid international number)
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userPhoneNumber'?: string;
    /**
     * Alternative phone number of the customer (Must be a valid international number)
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userAlternativePhoneNumber'?: string;
    /**
     * 
     * @type {Array<UserAddressSchema>}
     * @memberof CustomerDetailsSchema
     */
    'userAddresses'?: Array<UserAddressSchema>;
    /**
     * URL of the customer\'s profile image
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userProfileImage'?: string | null;
    /**
     * Preferred theme color of the customer, used for UI customization
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userPreferredThemeColor'?: string;
    /**
     * Preferred language of the customer (e.g., en, ar)
     * @type {string}
     * @memberof CustomerDetailsSchema
     */
    'userPreferredLanguage'?: string;
    /**
     * Number of unread notifications for the customer
     * @type {number}
     * @memberof CustomerDetailsSchema
     */
    'notificationsCount': number;
}
/**
 * 
 * @export
 * @interface CustomerFaqSchema
 */
export interface CustomerFaqSchema {
    /**
     * ID of the FAQ
     * @type {string}
     * @memberof CustomerFaqSchema
     */
    'id': string;
    /**
     * The question for the FAQ in the requested language
     * @type {string}
     * @memberof CustomerFaqSchema
     */
    'question': string;
    /**
     * The answer for the FAQ in the requested language
     * @type {string}
     * @memberof CustomerFaqSchema
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface CustomerFaqsResponseSchema
 */
export interface CustomerFaqsResponseSchema {
    /**
     * List of FAQs for customer display
     * @type {Array<CustomerFaqSchema>}
     * @memberof CustomerFaqsResponseSchema
     */
    'data': Array<CustomerFaqSchema>;
}
/**
 * 
 * @export
 * @interface CustomerFullDetailsSchema
 */
export interface CustomerFullDetailsSchema {
    /**
     * 
     * @type {string}
     * @memberof CustomerFullDetailsSchema
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerFullDetailsSchema
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerFullDetailsSchema
     */
    'userEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerFullDetailsSchema
     */
    'userPhoneNumber': string;
    /**
     * 
     * @type {number}
     * @memberof CustomerFullDetailsSchema
     */
    'totalOrders': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerFullDetailsSchema
     */
    'totalOrderAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerFullDetailsSchema
     */
    'walletBalance': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerFullDetailsSchema
     */
    'loyaltyPoints': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerFullDetailsSchema
     */
    'assignedOffersCount': number;
}
/**
 * 
 * @export
 * @interface CustomerInfo
 */
export interface CustomerInfo {
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerInfo
     */
    'phoneNumber': string;
}
/**
 * 
 * @export
 * @interface CustomerListItem
 */
export interface CustomerListItem {
    /**
     * Unique identifier for the customer
     * @type {string}
     * @memberof CustomerListItem
     */
    'customerId': string;
    /**
     * Full name of the customer
     * @type {string}
     * @memberof CustomerListItem
     */
    'name': string;
    /**
     * Email of the customer
     * @type {string}
     * @memberof CustomerListItem
     */
    'email': string;
    /**
     * Phone number of the customer
     * @type {string}
     * @memberof CustomerListItem
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface CustomerLoyaltyHistory
 */
export interface CustomerLoyaltyHistory {
    /**
     * 
     * @type {string}
     * @memberof CustomerLoyaltyHistory
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerLoyaltyHistory
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerLoyaltyHistory
     */
    'userEmail': string;
    /**
     * 
     * @type {number}
     * @memberof CustomerLoyaltyHistory
     */
    'totalPointsEarned': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLoyaltyHistory
     */
    'totalPointsRedeemed': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLoyaltyHistory
     */
    'availablePoints': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLoyaltyHistory
     */
    'totalRedeemedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerLoyaltyHistory
     */
    'minimumTargetPoints': number;
    /**
     * 
     * @type {Array<LoyaltyTransactionSchema>}
     * @memberof CustomerLoyaltyHistory
     */
    'transactions': Array<LoyaltyTransactionSchema>;
}
/**
 * 
 * @export
 * @interface CustomerOrderDetail
 */
export interface CustomerOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'deliveryType': CustomerOrderDetailDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'currentStatus': CustomerOrderDetailCurrentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderDetail
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'paymentStatus': CustomerOrderDetailPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'paymentMethod'?: CustomerOrderDetailPaymentMethodEnum;
    /**
     * 
     * @type {ShippingAddressNew}
     * @memberof CustomerOrderDetail
     */
    'shippingAddress'?: ShippingAddressNew;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level)
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'prescriptionUrl'?: string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'orderMode'?: CustomerOrderDetailOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (calculated as scheduledDeliveryTime minus configured preparation time)
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'processStartTime'?: string;
    /**
     * Indicates whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof CustomerOrderDetail
     */
    'canCancel'?: boolean;
    /**
     * Indicates if the customer has tipped for this order
     * @type {boolean}
     * @memberof CustomerOrderDetail
     */
    'isTipped'?: boolean;
    /**
     * 
     * @type {InvoiceDetailsNew}
     * @memberof CustomerOrderDetail
     */
    'invoiceDetails'?: InvoiceDetailsNew;
    /**
     * 
     * @type {Array<TrackingHistoryItem>}
     * @memberof CustomerOrderDetail
     */
    'trackingHistory'?: Array<TrackingHistoryItem>;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderDetail
     */
    'userType'?: CustomerOrderDetailUserTypeEnum;
    /**
     * 
     * @type {Array<CustomerOrderItem>}
     * @memberof CustomerOrderDetail
     */
    'orderItems'?: Array<CustomerOrderItem>;
    /**
     * 
     * @type {DeliveryInfo}
     * @memberof CustomerOrderDetail
     */
    'deliveryInfo'?: DeliveryInfo;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerOrderDetail
     */
    'isReviewed'?: boolean;
}

export const CustomerOrderDetailDeliveryTypeEnum = {
    Delivery: 'delivery',
    SelfPickup: 'selfPickup'
} as const;

export type CustomerOrderDetailDeliveryTypeEnum = typeof CustomerOrderDetailDeliveryTypeEnum[keyof typeof CustomerOrderDetailDeliveryTypeEnum];
export const CustomerOrderDetailCurrentStatusEnum = {
    PaymentPending: 'Payment Pending',
    OrderPlaced: 'Order Placed',
    PreOrderPendingAcceptance: 'Pre-Order Pending Acceptance',
    PreOrderAccepted: 'Pre-Order Accepted',
    PreOrderDriverAssignment: 'Pre-Order Driver Assignment',
    DeliveryPartnerAssigned: 'Delivery Partner Assigned',
    DeliveryPartnerAccepted: 'Delivery Partner Accepted',
    MerchantAccepted: 'Merchant Accepted',
    MerchantRejected: 'Merchant Rejected',
    OrderPreparing: 'Order Preparing',
    ReadyForPickup: 'Ready for Pickup',
    OrderDispatched: 'Order Dispatched',
    OrderArrived: 'Order Arrived',
    OrderDelivered: 'Order Delivered',
    OrderCancelled: 'Order Cancelled',
    DeliveryFailed: 'Delivery Failed'
} as const;

export type CustomerOrderDetailCurrentStatusEnum = typeof CustomerOrderDetailCurrentStatusEnum[keyof typeof CustomerOrderDetailCurrentStatusEnum];
export const CustomerOrderDetailPaymentStatusEnum = {
    Paid: 'paid',
    Unpaid: 'unpaid',
    Partial: 'partial',
    Failed: 'failed'
} as const;

export type CustomerOrderDetailPaymentStatusEnum = typeof CustomerOrderDetailPaymentStatusEnum[keyof typeof CustomerOrderDetailPaymentStatusEnum];
export const CustomerOrderDetailPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type CustomerOrderDetailPaymentMethodEnum = typeof CustomerOrderDetailPaymentMethodEnum[keyof typeof CustomerOrderDetailPaymentMethodEnum];
export const CustomerOrderDetailOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type CustomerOrderDetailOrderModeEnum = typeof CustomerOrderDetailOrderModeEnum[keyof typeof CustomerOrderDetailOrderModeEnum];
export const CustomerOrderDetailUserTypeEnum = {
    Customer: 'Customer'
} as const;

export type CustomerOrderDetailUserTypeEnum = typeof CustomerOrderDetailUserTypeEnum[keyof typeof CustomerOrderDetailUserTypeEnum];

/**
 * 
 * @export
 * @interface CustomerOrderItem
 */
export interface CustomerOrderItem {
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'storeType': CustomerOrderItemStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerOrderItem
     */
    'imageUrl'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItem
     */
    'originalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof CustomerOrderItem
     */
    'discountedPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'specialInstructions'?: string;
    /**
     * 
     * @type {Array<ItemChoiceNew>}
     * @memberof CustomerOrderItem
     */
    'choices'?: Array<ItemChoiceNew>;
    /**
     * ID of the meal added with this item
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'mealId'?: string;
    /**
     * Name of the meal (English)
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'mealName'?: string;
    /**
     * Name of the meal (Arabic)
     * @type {string}
     * @memberof CustomerOrderItem
     */
    'mealNameArabic'?: string;
    /**
     * Price of the meal
     * @type {number}
     * @memberof CustomerOrderItem
     */
    'mealPrice'?: number;
    /**
     * Choice groups selected for the meal
     * @type {Array<OrderItemMealChoiceGroupsInner>}
     * @memberof CustomerOrderItem
     */
    'mealChoiceGroups'?: Array<OrderItemMealChoiceGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerOrderItem
     */
    'merchantAccepted': boolean;
}

export const CustomerOrderItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type CustomerOrderItemStoreTypeEnum = typeof CustomerOrderItemStoreTypeEnum[keyof typeof CustomerOrderItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface CustomerRegistrationTypePieChartItem
 */
export interface CustomerRegistrationTypePieChartItem {
    /**
     * Registration method label (Normal/Admin/Google/etc.).
     * @type {string}
     * @memberof CustomerRegistrationTypePieChartItem
     */
    'type': string;
    /**
     * Number of customers registered via each method.
     * @type {number}
     * @memberof CustomerRegistrationTypePieChartItem
     */
    'count': number;
    /**
     * Percentage of customers registered via each method.
     * @type {number}
     * @memberof CustomerRegistrationTypePieChartItem
     */
    'percentage': number;
}
/**
 * Customer wallet information for admin panel with transaction history
 * @export
 * @interface CustomerWalletDetails
 */
export interface CustomerWalletDetails {
    /**
     * Unique customer identifier
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'customerId': string;
    /**
     * Customer full name
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'customerName': string;
    /**
     * Customer email address
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'customerEmail': string;
    /**
     * Customer phone number
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'customerPhone': string;
    /**
     * Current wallet balance
     * @type {number}
     * @memberof CustomerWalletDetails
     */
    'availableWalletBalance': number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof CustomerWalletDetails
     */
    'currencyCode': CurrencyCode;
    /**
     * Wallet identifier
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'walletId'?: string;
    /**
     * Date of last wallet transaction
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'lastTransactionDate'?: string;
    /**
     * Total number of transactions
     * @type {number}
     * @memberof CustomerWalletDetails
     */
    'totalTransactions'?: number;
    /**
     * Customer account status
     * @type {string}
     * @memberof CustomerWalletDetails
     */
    'customerStatus'?: CustomerWalletDetailsCustomerStatusEnum;
    /**
     * Recent wallet transactions (limited to last 10 by default)
     * @type {Array<CustomerWalletTransaction>}
     * @memberof CustomerWalletDetails
     */
    'recentTransactions': Array<CustomerWalletTransaction>;
    /**
     * Total amount credited to wallet
     * @type {number}
     * @memberof CustomerWalletDetails
     */
    'totalCredited'?: number;
    /**
     * Total amount debited from wallet
     * @type {number}
     * @memberof CustomerWalletDetails
     */
    'totalDebited'?: number;
}

export const CustomerWalletDetailsCustomerStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type CustomerWalletDetailsCustomerStatusEnum = typeof CustomerWalletDetailsCustomerStatusEnum[keyof typeof CustomerWalletDetailsCustomerStatusEnum];

/**
 * Response for admin customer wallet listing
 * @export
 * @interface CustomerWalletListResponse
 */
export interface CustomerWalletListResponse {
    /**
     * List of customers with wallet details
     * @type {Array<CustomerWalletDetails>}
     * @memberof CustomerWalletListResponse
     */
    'data': Array<CustomerWalletDetails>;
    /**
     * 
     * @type {Pagination}
     * @memberof CustomerWalletListResponse
     */
    'pagination': Pagination;
}
/**
 * Wallet transaction details for admin view
 * @export
 * @interface CustomerWalletTransaction
 */
export interface CustomerWalletTransaction {
    /**
     * Unique transaction identifier
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'transactionId': string;
    /**
     * Transaction amount
     * @type {number}
     * @memberof CustomerWalletTransaction
     */
    'amount': number;
    /**
     * Transaction type
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'type': CustomerWalletTransactionTypeEnum;
    /**
     * Transaction description in English
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'description': string;
    /**
     * Transaction description in Arabic
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'descriptionArabic'?: string;
    /**
     * Transaction status
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'status': CustomerWalletTransactionStatusEnum;
    /**
     * Transaction creation date
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'createdAt': string;
    /**
     * Who initiated the transaction
     * @type {string}
     * @memberof CustomerWalletTransaction
     */
    'initiatedBy'?: CustomerWalletTransactionInitiatedByEnum;
    /**
     * Wallet balance after this transaction
     * @type {number}
     * @memberof CustomerWalletTransaction
     */
    'balanceAfterTransaction'?: number;
}

export const CustomerWalletTransactionTypeEnum = {
    Credit: 'credit',
    Debit: 'debit'
} as const;

export type CustomerWalletTransactionTypeEnum = typeof CustomerWalletTransactionTypeEnum[keyof typeof CustomerWalletTransactionTypeEnum];
export const CustomerWalletTransactionStatusEnum = {
    Success: 'success',
    Failed: 'failed',
    Pending: 'pending'
} as const;

export type CustomerWalletTransactionStatusEnum = typeof CustomerWalletTransactionStatusEnum[keyof typeof CustomerWalletTransactionStatusEnum];
export const CustomerWalletTransactionInitiatedByEnum = {
    User: 'user',
    Admin: 'admin',
    System: 'system'
} as const;

export type CustomerWalletTransactionInitiatedByEnum = typeof CustomerWalletTransactionInitiatedByEnum[keyof typeof CustomerWalletTransactionInitiatedByEnum];

/**
 * @type DashboardResponse
 * @export
 */
export type DashboardResponse = { dashboardType: 'admin' } & AdminDashboardResponse | { dashboardType: 'merchant' } & MerchantDashboardResponse;

/**
 * 
 * @export
 * @interface DayPeakHours
 */
export interface DayPeakHours {
    /**
     * Enable peak hours for this day
     * @type {boolean}
     * @memberof DayPeakHours
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<TimeRange>}
     * @memberof DayPeakHours
     */
    'timeRanges'?: Array<TimeRange>;
}
/**
 * 
 * @export
 * @interface DeleteChoicesRequest
 */
export interface DeleteChoicesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteChoicesRequest
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteItemsRequest
 */
export interface DeleteItemsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteItemsRequest
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteMealsRequest
 */
export interface DeleteMealsRequest {
    /**
     * Array of meal IDs to delete
     * @type {Array<string>}
     * @memberof DeleteMealsRequest
     */
    'mealIds': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteNewsletterSubscribersRequest
 */
export interface DeleteNewsletterSubscribersRequest {
    /**
     * List of subscriber IDs to delete
     * @type {Array<string>}
     * @memberof DeleteNewsletterSubscribersRequest
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteOffersRequestSchema
 */
export interface DeleteOffersRequestSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteOffersRequestSchema
     */
    'offerIds': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteReviewsRequest
 */
export interface DeleteReviewsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteReviewsRequest
     */
    'reviewIds': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteSubAdminsRequest
 */
export interface DeleteSubAdminsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteSubAdminsRequest
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteSubscriptionPlansRequest
 */
export interface DeleteSubscriptionPlansRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteSubscriptionPlansRequest
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeleteUsersRequest
 */
export interface DeleteUsersRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteUsersRequest
     */
    'usersIds': Array<string>;
}
/**
 * 
 * @export
 * @interface DeliveryAddress
 */
export interface DeliveryAddress {
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddress
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddress
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddress
     */
    'latitude': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddress
     */
    'longitude': string;
}
/**
 * 
 * @export
 * @interface DeliveryAddressSchema
 */
export interface DeliveryAddressSchema {
    /**
     * Latitude coordinate for delivery location
     * @type {string}
     * @memberof DeliveryAddressSchema
     */
    'latitude': string;
    /**
     * Longitude coordinate for delivery location
     * @type {string}
     * @memberof DeliveryAddressSchema
     */
    'longitude': string;
}
/**
 * 
 * @export
 * @interface DeliveryBoyReview
 */
export interface DeliveryBoyReview {
    /**
     * Type of review, must be \'DeliveryPerson\'
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'type'?: DeliveryBoyReviewTypeEnum;
    /**
     * Unique identifier for the store review
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'reviewId'?: string;
    /**
     * Unique identifier for the delivery person being reviewed
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'deliveryPersonId'?: string;
    /**
     * Name of the delivery person being reviewed
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'deliveryPersonName'?: string;
    /**
     * Name of the customer providing the review
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'customerName'?: string;
    /**
     * Unique identifier for the customer providing the review
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'customerId'?: string;
    /**
     * Indicates whether the review is approved or not
     * @type {boolean}
     * @memberof DeliveryBoyReview
     */
    'reviewApprovalStatus'?: boolean;
    /**
     * Review text for the store
     * @type {string}
     * @memberof DeliveryBoyReview
     */
    'comment'?: string;
    /**
     * Overall rating (1-5) for the store
     * @type {number}
     * @memberof DeliveryBoyReview
     */
    'rating'?: number;
}

export const DeliveryBoyReviewTypeEnum = {
    DeliveryPerson: 'DeliveryPerson'
} as const;

export type DeliveryBoyReviewTypeEnum = typeof DeliveryBoyReviewTypeEnum[keyof typeof DeliveryBoyReviewTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryBoySchema
 */
export interface DeliveryBoySchema {
    /**
     * The unique identifier of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'deliverBoyId'?: string;
    /**
     * The first name of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'firstName': string;
    /**
     * The last name of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'lastName'?: string;
    /**
     * The email address of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'mobileNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'alternativeMobileNumber'?: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof DeliveryBoySchema
     */
    'currencyCode': CurrencyCode;
    /**
     * The delivery vehicle type of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'deliveryVehicleType': DeliveryBoySchemaDeliveryVehicleTypeEnum;
    /**
     * The name of the vehicle
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'vehicleName': string;
    /**
     * The vehicle number of the the delivery boy
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'vehicleNumber': string;
    /**
     * The vehicle type of the the delivery boy
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'vehilceType'?: string;
    /**
     * The maximum order limit of the delivery boy.
     * @type {number}
     * @memberof DeliveryBoySchema
     */
    'maximumOrderLimit': number;
    /**
     * The location of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'location'?: string;
    /**
     * The country of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'country'?: string;
    /**
     * The state of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'state'?: string;
    /**
     * The city of the delivery boy.
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'city'?: string;
    /**
     * The status of the delivery
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'status'?: DeliveryBoySchemaStatusEnum;
    /**
     * Driving licence number of the delivery boy
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'drivingLicenceNumber'?: string;
    /**
     * AWS S3 URL for driving licence proof document
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'driverLicenceProof'?: string;
    /**
     * Expiry date of the driving licence
     * @type {string}
     * @memberof DeliveryBoySchema
     */
    'drivingLicenceExpiryDate'?: string;
}

export const DeliveryBoySchemaDeliveryVehicleTypeEnum = {
    Truck: 'Truck',
    TwoWheeler: 'Two-wheeler',
    Both: 'Both'
} as const;

export type DeliveryBoySchemaDeliveryVehicleTypeEnum = typeof DeliveryBoySchemaDeliveryVehicleTypeEnum[keyof typeof DeliveryBoySchemaDeliveryVehicleTypeEnum];
export const DeliveryBoySchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type DeliveryBoySchemaStatusEnum = typeof DeliveryBoySchemaStatusEnum[keyof typeof DeliveryBoySchemaStatusEnum];

/**
 * 
 * @export
 * @interface DeliveryBoyShort
 */
export interface DeliveryBoyShort {
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyShort
     */
    'deliveryBoyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyShort
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyShort
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryBoyStatusPieChartItem
 */
export interface DeliveryBoyStatusPieChartItem {
    /**
     * Delivery member status value (Available, Busy, Offline).
     * @type {string}
     * @memberof DeliveryBoyStatusPieChartItem
     */
    'status': string;
    /**
     * Number of delivery boys for each status.
     * @type {number}
     * @memberof DeliveryBoyStatusPieChartItem
     */
    'count': number;
    /**
     * Percentage of delivery boys for each status.
     * @type {number}
     * @memberof DeliveryBoyStatusPieChartItem
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface DeliveryBoyWithLocation
 */
export interface DeliveryBoyWithLocation {
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'deliveryBoyId': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'mobileNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'vehicleName': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'vehicleNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'deliveryVehicleType': DeliveryBoyWithLocationDeliveryVehicleTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof DeliveryBoyWithLocation
     */
    'maximumOrderLimit': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryBoyWithLocation
     */
    'rating': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryBoyWithLocation
     */
    'responseTime': number;
    /**
     * 
     * @type {DeliveryBoyWithLocationCoordinates}
     * @memberof DeliveryBoyWithLocation
     */
    'coordinates': DeliveryBoyWithLocationCoordinates;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocation
     */
    'timestamp': string;
    /**
     * 
     * @type {DeliveryBoyWithLocationOrderDetails}
     * @memberof DeliveryBoyWithLocation
     */
    'orderDetails'?: DeliveryBoyWithLocationOrderDetails | null;
}

export const DeliveryBoyWithLocationDeliveryVehicleTypeEnum = {
    Truck: 'Truck',
    TwoWheeler: 'Two-wheeler',
    Both: 'Both'
} as const;

export type DeliveryBoyWithLocationDeliveryVehicleTypeEnum = typeof DeliveryBoyWithLocationDeliveryVehicleTypeEnum[keyof typeof DeliveryBoyWithLocationDeliveryVehicleTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryBoyWithLocationCoordinates
 */
export interface DeliveryBoyWithLocationCoordinates {
    /**
     * 
     * @type {number}
     * @memberof DeliveryBoyWithLocationCoordinates
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryBoyWithLocationCoordinates
     */
    'longitude'?: number;
}
/**
 * Order details if driver is currently engaged in an order (matches DeliveryPartnerOrderDetail structure)
 * @export
 * @interface DeliveryBoyWithLocationOrderDetails
 */
export interface DeliveryBoyWithLocationOrderDetails {
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocationOrderDetails
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocationOrderDetails
     */
    'currentOrderState'?: string;
    /**
     * 
     * @type {DeliveryBoyWithLocationOrderDetailsCustomerInfo}
     * @memberof DeliveryBoyWithLocationOrderDetails
     */
    'customerInfo'?: DeliveryBoyWithLocationOrderDetailsCustomerInfo;
    /**
     * 
     * @type {Array<DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner>}
     * @memberof DeliveryBoyWithLocationOrderDetails
     */
    'storePickupStatuses'?: Array<DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner>;
}
/**
 * 
 * @export
 * @interface DeliveryBoyWithLocationOrderDetailsCustomerInfo
 */
export interface DeliveryBoyWithLocationOrderDetailsCustomerInfo {
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocationOrderDetailsCustomerInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocationOrderDetailsCustomerInfo
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner
 */
export interface DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner {
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner
     */
    'storeName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryBoyWithLocationOrderDetailsStorePickupStatusesInner
     */
    'isPickedUp'?: boolean;
}
/**
 * 
 * @export
 * @interface DeliveryChargeSettingSchema
 */
export interface DeliveryChargeSettingSchema {
    /**
     * Type of delivery fee setting
     * @type {string}
     * @memberof DeliveryChargeSettingSchema
     */
    'type': DeliveryChargeSettingSchemaTypeEnum;
    /**
     * 
     * @type {DeliveryFeeStatusSchema}
     * @memberof DeliveryChargeSettingSchema
     */
    'deliveryFeeStatus'?: DeliveryFeeStatusSchema;
    /**
     * 
     * @type {PeakHourDeliveryFeeStatusSchema}
     * @memberof DeliveryChargeSettingSchema
     */
    'peakHourDeliveryFeeStatus'?: PeakHourDeliveryFeeStatusSchema;
}

export const DeliveryChargeSettingSchemaTypeEnum = {
    Default: 'default',
    Custom: 'custom'
} as const;

export type DeliveryChargeSettingSchemaTypeEnum = typeof DeliveryChargeSettingSchemaTypeEnum[keyof typeof DeliveryChargeSettingSchemaTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryCheckout
 */
export interface DeliveryCheckout {
    /**
     * 
     * @type {string}
     * @memberof DeliveryCheckout
     */
    'deliveryType': DeliveryCheckoutDeliveryTypeEnum;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof DeliveryCheckout
     */
    'shippingAddress': ShippingAddress;
    /**
     * Method of payment for the order
     * @type {string}
     * @memberof DeliveryCheckout
     */
    'paymentMethod': DeliveryCheckoutPaymentMethodEnum;
    /**
     * Optional note to the delivery person
     * @type {string}
     * @memberof DeliveryCheckout
     */
    'noteToDriver'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryCheckout
     */
    'couponCode'?: string;
    /**
     * Type of cart items
     * @type {string}
     * @memberof DeliveryCheckout
     */
    'cartItemsType': DeliveryCheckoutCartItemsTypeEnum;
}

export const DeliveryCheckoutDeliveryTypeEnum = {
    Delivery: 'delivery'
} as const;

export type DeliveryCheckoutDeliveryTypeEnum = typeof DeliveryCheckoutDeliveryTypeEnum[keyof typeof DeliveryCheckoutDeliveryTypeEnum];
export const DeliveryCheckoutPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment'
} as const;

export type DeliveryCheckoutPaymentMethodEnum = typeof DeliveryCheckoutPaymentMethodEnum[keyof typeof DeliveryCheckoutPaymentMethodEnum];
export const DeliveryCheckoutCartItemsTypeEnum = {
    All: 'All',
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type DeliveryCheckoutCartItemsTypeEnum = typeof DeliveryCheckoutCartItemsTypeEnum[keyof typeof DeliveryCheckoutCartItemsTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryFeeCommissionSettings
 */
export interface DeliveryFeeCommissionSettings {
    /**
     * Enable/disable delivery fee
     * @type {boolean}
     * @memberof DeliveryFeeCommissionSettings
     */
    'deliveryFeeStatus'?: boolean;
    /**
     * Type of delivery fee calculation
     * @type {string}
     * @memberof DeliveryFeeCommissionSettings
     */
    'deliveryFeeType'?: DeliveryFeeCommissionSettingsDeliveryFeeTypeEnum;
    /**
     * Common delivery fee amount
     * @type {number}
     * @memberof DeliveryFeeCommissionSettings
     */
    'commonDeliveryFee'?: number;
    /**
     * Delivery fee per kilometer
     * @type {number}
     * @memberof DeliveryFeeCommissionSettings
     */
    'feePerKM'?: number;
    /**
     * Delivery boy kilometer range
     * @type {number}
     * @memberof DeliveryFeeCommissionSettings
     */
    'deliveryBoyKilometerRange'?: number;
}

export const DeliveryFeeCommissionSettingsDeliveryFeeTypeEnum = {
    Common: 'common',
    PerKilometer: 'perKilometer'
} as const;

export type DeliveryFeeCommissionSettingsDeliveryFeeTypeEnum = typeof DeliveryFeeCommissionSettingsDeliveryFeeTypeEnum[keyof typeof DeliveryFeeCommissionSettingsDeliveryFeeTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryFeeSchema
 */
export interface DeliveryFeeSchema {
    /**
     * Indicates if there is a delivery fee.
     * @type {boolean}
     * @memberof DeliveryFeeSchema
     */
    'hasDeliveryFee'?: boolean;
    /**
     * 
     * @type {DeliveryFeeSchemaDeliveryFee}
     * @memberof DeliveryFeeSchema
     */
    'deliveryFee'?: DeliveryFeeSchemaDeliveryFee;
}
/**
 * Delivery fee settings (optional).
 * @export
 * @interface DeliveryFeeSchemaDeliveryFee
 */
export interface DeliveryFeeSchemaDeliveryFee {
    /**
     * Whether the restaurant applies a common delivery fee.
     * @type {boolean}
     * @memberof DeliveryFeeSchemaDeliveryFee
     */
    'hasCommonDeliveryFee'?: boolean;
    /**
     * The common delivery fee (optional).
     * @type {number}
     * @memberof DeliveryFeeSchemaDeliveryFee
     */
    'commonDeliveryFee'?: number;
    /**
     * Whether the restaurant applies a fee per kilometer.
     * @type {boolean}
     * @memberof DeliveryFeeSchemaDeliveryFee
     */
    'hasFeePerKilometer'?: boolean;
    /**
     * The fee per kilometer (optional).
     * @type {number}
     * @memberof DeliveryFeeSchemaDeliveryFee
     */
    'feePerKilometer'?: number;
}
/**
 * 
 * @export
 * @interface DeliveryFeeStatusSchema
 */
export interface DeliveryFeeStatusSchema {
    /**
     * Delivery fee status
     * @type {string}
     * @memberof DeliveryFeeStatusSchema
     */
    'type': DeliveryFeeStatusSchemaTypeEnum;
    /**
     * 
     * @type {CommonDeliveryFeeSchema}
     * @memberof DeliveryFeeStatusSchema
     */
    'commonDeliveryFee'?: CommonDeliveryFeeSchema;
    /**
     * 
     * @type {FeePerKMSchema}
     * @memberof DeliveryFeeStatusSchema
     */
    'feePerKM'?: FeePerKMSchema;
}

export const DeliveryFeeStatusSchemaTypeEnum = {
    Disable: 'disable',
    Enable: 'enable'
} as const;

export type DeliveryFeeStatusSchemaTypeEnum = typeof DeliveryFeeStatusSchemaTypeEnum[keyof typeof DeliveryFeeStatusSchemaTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryInfo
 */
export interface DeliveryInfo {
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    'deliveryPartnerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    'deliveryPartnerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryInfo
     */
    'deliveryPartnerPhone'?: string;
    /**
     * Timestamp when the driver was assigned to the order
     * @type {string}
     * @memberof DeliveryInfo
     */
    'assignedAt'?: string;
    /**
     * Timestamp when the driver accepted the order
     * @type {string}
     * @memberof DeliveryInfo
     */
    'acceptedAt'?: string;
    /**
     * Timestamp when the driver denied the order
     * @type {string}
     * @memberof DeliveryInfo
     */
    'deniedAt'?: string;
    /**
     * Whether the denial was manual (by driver) or automatic (timeout)
     * @type {string}
     * @memberof DeliveryInfo
     */
    'denialType'?: DeliveryInfoDenialTypeEnum;
    /**
     * Reason for denial if available
     * @type {string}
     * @memberof DeliveryInfo
     */
    'denialReason'?: string;
}

export const DeliveryInfoDenialTypeEnum = {
    Manual: 'manual',
    Auto: 'auto'
} as const;

export type DeliveryInfoDenialTypeEnum = typeof DeliveryInfoDenialTypeEnum[keyof typeof DeliveryInfoDenialTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryOrderItem
 */
export interface DeliveryOrderItem {
    /**
     * Item identifier
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'itemId': string;
    /**
     * Item name in multiple languages
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'itemName': string;
    /**
     * Item variant
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'itemVariant'?: string;
    /**
     * Item images
     * @type {Array<string>}
     * @memberof DeliveryOrderItem
     */
    'imageUrl'?: Array<string>;
    /**
     * Item quantity
     * @type {number}
     * @memberof DeliveryOrderItem
     */
    'quantity': number;
    /**
     * Original item price
     * @type {number}
     * @memberof DeliveryOrderItem
     */
    'originalPrice'?: number;
    /**
     * Discounted price
     * @type {number}
     * @memberof DeliveryOrderItem
     */
    'discountPrice'?: number;
    /**
     * Special preparation instructions
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'specialInstructions'?: string;
    /**
     * 
     * @type {Array<ItemChoice>}
     * @memberof DeliveryOrderItem
     */
    'choices'?: Array<ItemChoice>;
    /**
     * Store identifier
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'storeId': string;
    /**
     * Store name in multiple languages
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'storeName': string;
    /**
     * Type of store
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'storeType': string;
    /**
     * Whether merchant accepted this item
     * @type {boolean}
     * @memberof DeliveryOrderItem
     */
    'merchantAccepted': boolean;
    /**
     * Whether merchant denied this item
     * @type {boolean}
     * @memberof DeliveryOrderItem
     */
    'merchantDenied'?: boolean;
    /**
     * Time when merchant accepted
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'merchantAcceptedTime'?: string;
    /**
     * Time when merchant denied
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'merchantDeniedTime'?: string;
    /**
     * Whether item is ready for pickup
     * @type {boolean}
     * @memberof DeliveryOrderItem
     */
    'isReadyForPickup'?: boolean;
    /**
     * Time when item became ready for pickup
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'readyForPickupTime'?: string;
    /**
     * Whether item has been picked up
     * @type {boolean}
     * @memberof DeliveryOrderItem
     */
    'isPickedUp'?: boolean;
    /**
     * Time when item was picked up
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'pickupTime'?: string;
    /**
     * Whether item is cancelled
     * @type {boolean}
     * @memberof DeliveryOrderItem
     */
    'isCancelled'?: boolean;
    /**
     * Reason for cancellation
     * @type {string}
     * @memberof DeliveryOrderItem
     */
    'cancellationReason'?: string;
    /**
     * Item subtotal
     * @type {number}
     * @memberof DeliveryOrderItem
     */
    'subTotal'?: number;
    /**
     * Item tax
     * @type {number}
     * @memberof DeliveryOrderItem
     */
    'tax'?: number;
    /**
     * Item total
     * @type {number}
     * @memberof DeliveryOrderItem
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DeliveryPartnerCustomerInfo
 */
export interface DeliveryPartnerCustomerInfo {
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerCustomerInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerCustomerInfo
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerCustomerInfo
     */
    'deliveryInstructions'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryPartnerDetailsSchema
 */
export interface DeliveryPartnerDetailsSchema {
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'isAvailable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'isAssigned': boolean;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'mobileNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'alternativeMobileNumber'?: string | null;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'currencyCode': CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'deliveryVehicleType': DeliveryPartnerDetailsSchemaDeliveryVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'vehicleName': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'vehicleNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'vehilceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'maximumOrderLimit': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'status': DeliveryPartnerDetailsSchemaStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'rating'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'unreadNotificationsCount'?: number;
    /**
     * Preferred language of the delivery partner
     * @type {string}
     * @memberof DeliveryPartnerDetailsSchema
     */
    'preferredLanguage'?: DeliveryPartnerDetailsSchemaPreferredLanguageEnum;
}

export const DeliveryPartnerDetailsSchemaDeliveryVehicleTypeEnum = {
    Truck: 'Truck',
    TwoWheeler: 'Two-wheeler',
    Both: 'Both'
} as const;

export type DeliveryPartnerDetailsSchemaDeliveryVehicleTypeEnum = typeof DeliveryPartnerDetailsSchemaDeliveryVehicleTypeEnum[keyof typeof DeliveryPartnerDetailsSchemaDeliveryVehicleTypeEnum];
export const DeliveryPartnerDetailsSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type DeliveryPartnerDetailsSchemaStatusEnum = typeof DeliveryPartnerDetailsSchemaStatusEnum[keyof typeof DeliveryPartnerDetailsSchemaStatusEnum];
export const DeliveryPartnerDetailsSchemaPreferredLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;

export type DeliveryPartnerDetailsSchemaPreferredLanguageEnum = typeof DeliveryPartnerDetailsSchemaPreferredLanguageEnum[keyof typeof DeliveryPartnerDetailsSchemaPreferredLanguageEnum];

/**
 * 
 * @export
 * @interface DeliveryPartnerLocation
 */
export interface DeliveryPartnerLocation {
    /**
     * Latitude in decimal degrees
     * @type {number}
     * @memberof DeliveryPartnerLocation
     */
    'lat': number;
    /**
     * Longitude in decimal degrees
     * @type {number}
     * @memberof DeliveryPartnerLocation
     */
    'lng': number;
    /**
     * Human-readable address
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'address'?: string;
    /**
     * When this location was last updated
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'lastUpdated'?: string;
    /**
     * Delivery partner name
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'name': string;
    /**
     * Contact phone number
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'phone': string;
    /**
     * Vehicle details
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'vehicle': string;
    /**
     * Delivery partner rating
     * @type {number}
     * @memberof DeliveryPartnerLocation
     */
    'rating': number;
    /**
     * Profile picture URL
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'avatar'?: string;
    /**
     * Estimated time of arrival
     * @type {string}
     * @memberof DeliveryPartnerLocation
     */
    'eta'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryPartnerOrder
 */
export interface DeliveryPartnerOrder {
    /**
     * Unique order identifier
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'orderId': string;
    /**
     * Human readable order number
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'orderNumber': string;
    /**
     * Customer ID who placed the order
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'customerId': string;
    /**
     * Date when order was placed
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'orderDate': string;
    /**
     * Current order status
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'currentStatus': string;
    /**
     * Time when driver accepted the order
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'driverAcceptedTime'?: string;
    /**
     * Time when pickup started
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'pickupStartTime'?: string;
    /**
     * Time when all pickups completed
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'pickupCompletionTime'?: string;
    /**
     * Time when order was delivered
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'deliveredTime'?: string;
    /**
     * 
     * @type {DeliveryShippingAddress}
     * @memberof DeliveryPartnerOrder
     */
    'shippingAddress': DeliveryShippingAddress;
    /**
     * 
     * @type {Array<DeliveryOrderItem>}
     * @memberof DeliveryPartnerOrder
     */
    'orderItems': Array<DeliveryOrderItem>;
    /**
     * 
     * @type {Array<StorePickupStatus>}
     * @memberof DeliveryPartnerOrder
     */
    'storePickupStatuses'?: Array<StorePickupStatus>;
    /**
     * Total number of stores to pickup from
     * @type {number}
     * @memberof DeliveryPartnerOrder
     */
    'totalStoresCount'?: number;
    /**
     * Number of stores already picked up from
     * @type {number}
     * @memberof DeliveryPartnerOrder
     */
    'completedStoresCount'?: number;
    /**
     * Whether all stores have been picked up from
     * @type {boolean}
     * @memberof DeliveryPartnerOrder
     */
    'allStoresPickedUp'?: boolean;
    /**
     * Subtotal amount
     * @type {number}
     * @memberof DeliveryPartnerOrder
     */
    'subTotal'?: number;
    /**
     * Tax amount
     * @type {number}
     * @memberof DeliveryPartnerOrder
     */
    'tax'?: number;
    /**
     * Delivery fee
     * @type {number}
     * @memberof DeliveryPartnerOrder
     */
    'deliveryFee'?: number;
    /**
     * Total order amount
     * @type {number}
     * @memberof DeliveryPartnerOrder
     */
    'totalAmount': number;
    /**
     * Whether the order is still active
     * @type {boolean}
     * @memberof DeliveryPartnerOrder
     */
    'isActive': boolean;
    /**
     * Time elapsed since driver accepted the order
     * @type {string}
     * @memberof DeliveryPartnerOrder
     */
    'timeFromAcceptance'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryPartnerOrderDetail
 */
export interface DeliveryPartnerOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'deliveryType': DeliveryPartnerOrderDetailDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'currentStatus': DeliveryPartnerOrderDetailCurrentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerOrderDetail
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'paymentStatus': DeliveryPartnerOrderDetailPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'paymentMethod'?: DeliveryPartnerOrderDetailPaymentMethodEnum;
    /**
     * 
     * @type {ShippingAddressNew}
     * @memberof DeliveryPartnerOrderDetail
     */
    'shippingAddress'?: ShippingAddressNew;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'prescriptionUrl'?: string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'orderMode'?: DeliveryPartnerOrderDetailOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (calculated as scheduledDeliveryTime minus configured preparation time)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'processStartTime'?: string;
    /**
     * Indicates whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetail
     */
    'canCancel'?: boolean;
    /**
     * Indicates if the customer has tipped for this order
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetail
     */
    'isTipped'?: boolean;
    /**
     * 
     * @type {InvoiceDetailsNew}
     * @memberof DeliveryPartnerOrderDetail
     */
    'invoiceDetails'?: InvoiceDetailsNew;
    /**
     * 
     * @type {Array<TrackingHistoryItem>}
     * @memberof DeliveryPartnerOrderDetail
     */
    'trackingHistory'?: Array<TrackingHistoryItem>;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'userType'?: DeliveryPartnerOrderDetailUserTypeEnum;
    /**
     * Formatted date-time when driver accepted (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'driverAcceptedTime'?: string;
    /**
     * Formatted date-time when pickup started (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'pickupStartTime'?: string;
    /**
     * Formatted date-time when pickup completed (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'pickupCompletionTime'?: string;
    /**
     * Formatted date-time when order delivered (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'deliveredTime'?: string;
    /**
     * 
     * @type {Array<DeliveryPartnerOrderItem>}
     * @memberof DeliveryPartnerOrderDetail
     */
    'orderItems'?: Array<DeliveryPartnerOrderItem>;
    /**
     * 
     * @type {DeliveryPartnerCustomerInfo}
     * @memberof DeliveryPartnerOrderDetail
     */
    'customerInfo'?: DeliveryPartnerCustomerInfo;
    /**
     * 
     * @type {Array<StorePickupStatusNew>}
     * @memberof DeliveryPartnerOrderDetail
     */
    'storePickupStatuses'?: Array<StorePickupStatusNew>;
    /**
     * Total number of stores with accepted items
     * @type {number}
     * @memberof DeliveryPartnerOrderDetail
     */
    'totalStoresCount'?: number;
    /**
     * Number of stores that have been picked up
     * @type {number}
     * @memberof DeliveryPartnerOrderDetail
     */
    'completedStoresCount'?: number;
    /**
     * Whether all stores have been picked up
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetail
     */
    'allStoresPickedUp'?: boolean;
    /**
     * 
     * @type {DeliveryPartnerOrderDetailAllOfDeliveryControls}
     * @memberof DeliveryPartnerOrderDetail
     */
    'deliveryControls'?: DeliveryPartnerOrderDetailAllOfDeliveryControls;
    /**
     * Time elapsed since driver accepted the order
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'timeFromAcceptance'?: string;
    /**
     * Whether the order is currently active
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetail
     */
    'isActive'?: boolean;
    /**
     * Instructions for delivery partner
     * @type {string}
     * @memberof DeliveryPartnerOrderDetail
     */
    'deliveryInstructions'?: string;
    /**
     * 
     * @type {EarningsBreakdown}
     * @memberof DeliveryPartnerOrderDetail
     */
    'earningsBreakdown'?: EarningsBreakdown;
    /**
     * Whether this is an urgent order with bonus
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetail
     */
    'isUrgentOrder'?: boolean;
    /**
     * 
     * @type {DeliveryPartnerOrderDetailAllOfUrgentOrderInfo}
     * @memberof DeliveryPartnerOrderDetail
     */
    'urgentOrderInfo'?: DeliveryPartnerOrderDetailAllOfUrgentOrderInfo;
}

export const DeliveryPartnerOrderDetailDeliveryTypeEnum = {
    Delivery: 'delivery',
    SelfPickup: 'selfPickup'
} as const;

export type DeliveryPartnerOrderDetailDeliveryTypeEnum = typeof DeliveryPartnerOrderDetailDeliveryTypeEnum[keyof typeof DeliveryPartnerOrderDetailDeliveryTypeEnum];
export const DeliveryPartnerOrderDetailCurrentStatusEnum = {
    PaymentPending: 'Payment Pending',
    OrderPlaced: 'Order Placed',
    PreOrderPendingAcceptance: 'Pre-Order Pending Acceptance',
    PreOrderAccepted: 'Pre-Order Accepted',
    PreOrderDriverAssignment: 'Pre-Order Driver Assignment',
    DeliveryPartnerAssigned: 'Delivery Partner Assigned',
    DeliveryPartnerAccepted: 'Delivery Partner Accepted',
    MerchantAccepted: 'Merchant Accepted',
    MerchantRejected: 'Merchant Rejected',
    OrderPreparing: 'Order Preparing',
    ReadyForPickup: 'Ready for Pickup',
    OrderDispatched: 'Order Dispatched',
    OrderArrived: 'Order Arrived',
    OrderDelivered: 'Order Delivered',
    OrderCancelled: 'Order Cancelled',
    DeliveryFailed: 'Delivery Failed'
} as const;

export type DeliveryPartnerOrderDetailCurrentStatusEnum = typeof DeliveryPartnerOrderDetailCurrentStatusEnum[keyof typeof DeliveryPartnerOrderDetailCurrentStatusEnum];
export const DeliveryPartnerOrderDetailPaymentStatusEnum = {
    Paid: 'paid',
    Unpaid: 'unpaid',
    Partial: 'partial',
    Failed: 'failed'
} as const;

export type DeliveryPartnerOrderDetailPaymentStatusEnum = typeof DeliveryPartnerOrderDetailPaymentStatusEnum[keyof typeof DeliveryPartnerOrderDetailPaymentStatusEnum];
export const DeliveryPartnerOrderDetailPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type DeliveryPartnerOrderDetailPaymentMethodEnum = typeof DeliveryPartnerOrderDetailPaymentMethodEnum[keyof typeof DeliveryPartnerOrderDetailPaymentMethodEnum];
export const DeliveryPartnerOrderDetailOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type DeliveryPartnerOrderDetailOrderModeEnum = typeof DeliveryPartnerOrderDetailOrderModeEnum[keyof typeof DeliveryPartnerOrderDetailOrderModeEnum];
export const DeliveryPartnerOrderDetailUserTypeEnum = {
    DeliveryPartner: 'DeliveryPartner'
} as const;

export type DeliveryPartnerOrderDetailUserTypeEnum = typeof DeliveryPartnerOrderDetailUserTypeEnum[keyof typeof DeliveryPartnerOrderDetailUserTypeEnum];

/**
 * Delivery partner specific controls
 * @export
 * @interface DeliveryPartnerOrderDetailAllOfDeliveryControls
 */
export interface DeliveryPartnerOrderDetailAllOfDeliveryControls {
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetailAllOfDeliveryControls
     */
    'canAccept'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetailAllOfDeliveryControls
     */
    'canMarkPickedUp'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryPartnerOrderDetailAllOfDeliveryControls
     */
    'canMarkDelivered'?: boolean;
}
/**
 * Urgent order details (present only if isUrgentOrder is true)
 * @export
 * @interface DeliveryPartnerOrderDetailAllOfUrgentOrderInfo
 */
export interface DeliveryPartnerOrderDetailAllOfUrgentOrderInfo {
    /**
     * Reason why order is marked as urgent
     * @type {string}
     * @memberof DeliveryPartnerOrderDetailAllOfUrgentOrderInfo
     */
    'reason'?: string;
    /**
     * When timeout was extended
     * @type {string}
     * @memberof DeliveryPartnerOrderDetailAllOfUrgentOrderInfo
     */
    'timeoutExtendedAt'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryPartnerOrderItem
 */
export interface DeliveryPartnerOrderItem {
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'storeType': DeliveryPartnerOrderItemStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeliveryPartnerOrderItem
     */
    'imageUrl'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'originalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'discountedPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'specialInstructions'?: string;
    /**
     * 
     * @type {Array<ItemChoiceNew>}
     * @memberof DeliveryPartnerOrderItem
     */
    'choices'?: Array<ItemChoiceNew>;
    /**
     * ID of the meal added with this item
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'mealId'?: string;
    /**
     * Name of the meal (English)
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'mealName'?: string;
    /**
     * Name of the meal (Arabic)
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'mealNameArabic'?: string;
    /**
     * Price of the meal
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'mealPrice'?: number;
    /**
     * Choice groups selected for the meal
     * @type {Array<OrderItemMealChoiceGroupsInner>}
     * @memberof DeliveryPartnerOrderItem
     */
    'mealChoiceGroups'?: Array<OrderItemMealChoiceGroupsInner>;
    /**
     * Whether merchant accepted this item
     * @type {boolean}
     * @memberof DeliveryPartnerOrderItem
     */
    'merchantAccepted'?: boolean;
    /**
     * Formatted date-time when merchant accepted (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'merchantAcceptedTime'?: string;
    /**
     * Formatted date-time when merchant denied (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'merchantDeniedTime'?: string | null;
    /**
     * Whether item is ready for pickup
     * @type {boolean}
     * @memberof DeliveryPartnerOrderItem
     */
    'isReadyForPickup'?: boolean;
    /**
     * Formatted date-time when item became ready for pickup (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'readyForPickupTime'?: string | null;
    /**
     * Whether item has been picked up
     * @type {boolean}
     * @memberof DeliveryPartnerOrderItem
     */
    'isPickedUp'?: boolean;
    /**
     * Formatted date-time when item was picked up (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'pickupTime'?: string | null;
    /**
     * Whether item is cancelled
     * @type {boolean}
     * @memberof DeliveryPartnerOrderItem
     */
    'isCancelled'?: boolean;
    /**
     * Reason for cancellation
     * @type {string}
     * @memberof DeliveryPartnerOrderItem
     */
    'cancellationReason'?: string | null;
    /**
     * Item subtotal
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'subTotal'?: number;
    /**
     * Tax amount for this item
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'tax'?: number;
    /**
     * Total amount for this item
     * @type {number}
     * @memberof DeliveryPartnerOrderItem
     */
    'total'?: number;
}

export const DeliveryPartnerOrderItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type DeliveryPartnerOrderItemStoreTypeEnum = typeof DeliveryPartnerOrderItemStoreTypeEnum[keyof typeof DeliveryPartnerOrderItemStoreTypeEnum];

/**
 * 
 * @export
 * @interface DeliveryPerformanceReportRequest
 */
export interface DeliveryPerformanceReportRequest {
    /**
     * Array of delivery partner IDs to filter by (optional - omit to include all delivery partners). Maximum 50 delivery partners per request. 
     * @type {Array<string>}
     * @memberof DeliveryPerformanceReportRequest
     */
    'deliveryPartnerIds'?: Array<string>;
    /**
     * Filter by driver account status (optional - omit to include all statuses). - blocked: Driver account is blocked/deactivated - unblocked: Driver account is active 
     * @type {Array<string>}
     * @memberof DeliveryPerformanceReportRequest
     */
    'driverStatus'?: Array<DeliveryPerformanceReportRequestDriverStatusEnum>;
    /**
     * Order statuses to include in performance metrics (defaults to all delivery-related statuses). - ORDER_DELIVERED: Successfully delivered orders (positive performance metric) - ORDER_CANCELLED: Customer/merchant cancelled orders (affects driver performance) - DELIVERY_FAILED: Failed delivery attempts (negative performance metric) 
     * @type {Array<string>}
     * @memberof DeliveryPerformanceReportRequest
     */
    'orderStatuses'?: Array<DeliveryPerformanceReportRequestOrderStatusesEnum>;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to DELIVERY COMPLETION DATE (deliveredTime timestamp), not order acceptance date. - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof DeliveryPerformanceReportRequest
     */
    'dateRange': DeliveryPerformanceReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof DeliveryPerformanceReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof DeliveryPerformanceReportRequest
     */
    'dateTo'?: string;
}

export const DeliveryPerformanceReportRequestDriverStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type DeliveryPerformanceReportRequestDriverStatusEnum = typeof DeliveryPerformanceReportRequestDriverStatusEnum[keyof typeof DeliveryPerformanceReportRequestDriverStatusEnum];
export const DeliveryPerformanceReportRequestOrderStatusesEnum = {
    OrderDelivered: 'ORDER_DELIVERED',
    OrderCancelled: 'ORDER_CANCELLED',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type DeliveryPerformanceReportRequestOrderStatusesEnum = typeof DeliveryPerformanceReportRequestOrderStatusesEnum[keyof typeof DeliveryPerformanceReportRequestOrderStatusesEnum];
export const DeliveryPerformanceReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type DeliveryPerformanceReportRequestDateRangeEnum = typeof DeliveryPerformanceReportRequestDateRangeEnum[keyof typeof DeliveryPerformanceReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface DeliveryRating
 */
export interface DeliveryRating {
    /**
     * Unique identifier for the delivery partner
     * @type {string}
     * @memberof DeliveryRating
     */
    'deliveryPartnerId': string;
    /**
     * Rating for the delivery partner (1-5)
     * @type {number}
     * @memberof DeliveryRating
     */
    'rating': number;
    /**
     * Textual review about delivery partner
     * @type {string}
     * @memberof DeliveryRating
     */
    'review': string;
}
/**
 * 
 * @export
 * @interface DeliveryShippingAddress
 */
export interface DeliveryShippingAddress {
    /**
     * Customer first name
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'firstName': string;
    /**
     * Customer last name
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'lastName'?: string;
    /**
     * Customer phone number
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'phoneNumber': string;
    /**
     * Alternative phone number
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'alternativePhoneNumber'?: string;
    /**
     * Customer email
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'email'?: string;
    /**
     * Full address
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'addressLine'?: string;
    /**
     * Address latitude
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'latitude'?: string;
    /**
     * Address longitude
     * @type {string}
     * @memberof DeliveryShippingAddress
     */
    'longitude'?: string;
}
/**
 * 
 * @export
 * @interface DesignSettings
 */
export interface DesignSettings {
    /**
     * 
     * @type {string}
     * @memberof DesignSettings
     */
    'logoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DesignSettings
     */
    'faviconUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DesignSettings
     */
    'splashScreenUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DesignSettings
     */
    'heroImageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DesignSettings
     */
    'appColor': string;
}
/**
 * Driver assignment and urgency information for admin
 * @export
 * @interface DriverAssignmentInfo
 */
export interface DriverAssignmentInfo {
    /**
     * Whether admin can manually assign/reassign a driver to this order
     * @type {boolean}
     * @memberof DriverAssignmentInfo
     */
    'canManuallyAssignDriver'?: boolean;
    /**
     * Number of times driver assignment was attempted
     * @type {number}
     * @memberof DriverAssignmentInfo
     */
    'driverAssignmentAttempts'?: number;
    /**
     * Number of nearby drivers who rejected this order
     * @type {number}
     * @memberof DriverAssignmentInfo
     */
    'nearbyDriversRejected'?: number;
    /**
     * Whether order is marked as urgent (has bonus)
     * @type {boolean}
     * @memberof DriverAssignmentInfo
     */
    'isUrgent'?: boolean;
    /**
     * Bonus amount offered to driver
     * @type {number}
     * @memberof DriverAssignmentInfo
     */
    'driverBonus'?: number;
    /**
     * When timeout was extended (if extended)
     * @type {string}
     * @memberof DriverAssignmentInfo
     */
    'timeoutExtendedAt'?: string;
    /**
     * Reason for timeout extension
     * @type {string}
     * @memberof DriverAssignmentInfo
     */
    'timeoutExtensionReason'?: string;
}
/**
 * 
 * @export
 * @interface DriverPayoutReportRequest
 */
export interface DriverPayoutReportRequest {
    /**
     * Array of delivery partner IDs to filter by (optional - omit to include all delivery partners). Maximum 50 delivery partners per request. 
     * @type {Array<string>}
     * @memberof DriverPayoutReportRequest
     */
    'deliveryPartnerIds'?: Array<string>;
    /**
     * Filter by driver account status (optional - omit to include all statuses). - blocked: Driver account is blocked/deactivated - unblocked: Driver account is active 
     * @type {Array<string>}
     * @memberof DriverPayoutReportRequest
     */
    'driverStatus'?: Array<DriverPayoutReportRequestDriverStatusEnum>;
    /**
     * Filter by settlement/payout status (optional - omit to include all statuses). - PENDING: Earnings calculated but payout not initiated - INPROGRESS: Payout processing in progress - COMPLETED: Payout successfully completed - FAILED: Payout failed - CANCELLED: Payout cancelled 
     * @type {Array<string>}
     * @memberof DriverPayoutReportRequest
     */
    'settlementStatus'?: Array<DriverPayoutReportRequestSettlementStatusEnum>;
    /**
     * Filter by order payment methods (optional - omit to include all methods). Useful for tracking COD (Cash on Delivery) collection by drivers. 
     * @type {Array<string>}
     * @memberof DriverPayoutReportRequest
     */
    'paymentMethods'?: Array<DriverPayoutReportRequestPaymentMethodsEnum>;
    /**
     * Order statuses to include (defaults to ORDER_DELIVERED only). - ORDER_DELIVERED: Successfully delivered orders (driver earns full payment) - DELIVERY_FAILED: Failed delivery attempts (may affect driver earnings) 
     * @type {Array<string>}
     * @memberof DriverPayoutReportRequest
     */
    'orderStatuses'?: Array<DriverPayoutReportRequestOrderStatusesEnum>;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to ORDER DELIVERY DATE (when order was delivered/completed), not payout date. - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof DriverPayoutReportRequest
     */
    'dateRange': DriverPayoutReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof DriverPayoutReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof DriverPayoutReportRequest
     */
    'dateTo'?: string;
}

export const DriverPayoutReportRequestDriverStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type DriverPayoutReportRequestDriverStatusEnum = typeof DriverPayoutReportRequestDriverStatusEnum[keyof typeof DriverPayoutReportRequestDriverStatusEnum];
export const DriverPayoutReportRequestSettlementStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type DriverPayoutReportRequestSettlementStatusEnum = typeof DriverPayoutReportRequestSettlementStatusEnum[keyof typeof DriverPayoutReportRequestSettlementStatusEnum];
export const DriverPayoutReportRequestPaymentMethodsEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type DriverPayoutReportRequestPaymentMethodsEnum = typeof DriverPayoutReportRequestPaymentMethodsEnum[keyof typeof DriverPayoutReportRequestPaymentMethodsEnum];
export const DriverPayoutReportRequestOrderStatusesEnum = {
    OrderDelivered: 'ORDER_DELIVERED',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type DriverPayoutReportRequestOrderStatusesEnum = typeof DriverPayoutReportRequestOrderStatusesEnum[keyof typeof DriverPayoutReportRequestOrderStatusesEnum];
export const DriverPayoutReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type DriverPayoutReportRequestDateRangeEnum = typeof DriverPayoutReportRequestDateRangeEnum[keyof typeof DriverPayoutReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface DriverSettings
 */
export interface DriverSettings {
    /**
     * Fixed bonus amount for emergency driver assignments
     * @type {number}
     * @memberof DriverSettings
     */
    'emergencyDriverBonusAmount'?: number;
    /**
     * Percentage-based bonus for emergency driver assignments (0 means use fixed amount)
     * @type {number}
     * @memberof DriverSettings
     */
    'emergencyDriverBonusPercentage'?: number;
    /**
     * Seconds to extend timeout when no drivers available (default 180 = 3 minutes)
     * @type {number}
     * @memberof DriverSettings
     */
    'driverUnavailableTimeoutExtension'?: number;
    /**
     * Enable/disable automatic timeout extension when drivers unavailable
     * @type {boolean}
     * @memberof DriverSettings
     */
    'enableAutomaticTimeoutExtension'?: boolean;
}
/**
 * 
 * @export
 * @interface DynamicHomeContentSchema
 */
export interface DynamicHomeContentSchema {
    /**
     * The ID of the dynamic content.
     * @type {string}
     * @memberof DynamicHomeContentSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DynamicHomeContentSchema
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DynamicHomeContentSchema
     */
    'imgUrl': string;
    /**
     * 
     * @type {string}
     * @memberof DynamicHomeContentSchema
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface DynamicHomePageContentSettings
 */
export interface DynamicHomePageContentSettings {
    /**
     * Unique identifier for the dynamic home page content
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'storeType': DynamicHomePageContentSettingsStoreTypeEnum;
    /**
     * URL of the image to be displayed on the dynamic home page
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'imageUrl': string;
    /**
     * Text to be displayed on the image
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'imageTextEnglish'?: string;
    /**
     * Text to be displayed on the image in Arabic
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'imageTextArabic'?: string;
    /**
     * URL to redirect when the banner is clicked
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'redirectUrl'?: string;
    /**
     * Text for the button on the banner
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'buttonTextEnglish'?: string;
    /**
     * Text for the button on the banner in Arabic
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'buttonTextInArabic'?: string;
    /**
     * Start time for the banner display
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'bannerStartTime': string;
    /**
     * End time for the banner display
     * @type {string}
     * @memberof DynamicHomePageContentSettings
     */
    'bannerEndTime': string;
}

export const DynamicHomePageContentSettingsStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type DynamicHomePageContentSettingsStoreTypeEnum = typeof DynamicHomePageContentSettingsStoreTypeEnum[keyof typeof DynamicHomePageContentSettingsStoreTypeEnum];

/**
 * Breakdown of delivery earnings showing tentative and confirmed amounts
 * @export
 * @interface EarningsBreakdown
 */
export interface EarningsBreakdown {
    /**
     * Total tentative earnings from all stores (before merchant acceptance/denial)
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'tentativeTotal'?: number;
    /**
     * Confirmed earnings from accepted stores only
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'confirmedEarnings'?: number;
    /**
     * Lost earnings from denied stores
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'deniedEarnings'?: number;
    /**
     * Earnings from stores still pending merchant response
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'pendingEarnings'?: number;
    /**
     * Base delivery fee for this order
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'deliveryFee'?: number;
    /**
     * Emergency/urgent delivery bonus (if any)
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'driverBonus'?: number;
    /**
     * Total earnings including bonus (deliveryFee + driverBonus)
     * @type {number}
     * @memberof EarningsBreakdown
     */
    'totalEarnings'?: number;
}
/**
 * 
 * @export
 * @interface EditAdminRequest
 */
export interface EditAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof EditAdminRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAdminRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditAdminRequest
     */
    'mobileNumber'?: string;
}
/**
 * 
 * @export
 * @interface EditDeliveryManagerRequestSchema
 */
export interface EditDeliveryManagerRequestSchema {
    /**
     * name of the delivery manager
     * @type {string}
     * @memberof EditDeliveryManagerRequestSchema
     */
    'name': string;
    /**
     * email of the delivery manager
     * @type {string}
     * @memberof EditDeliveryManagerRequestSchema
     */
    'email': string;
    /**
     * mobile number of the delivery manager
     * @type {string}
     * @memberof EditDeliveryManagerRequestSchema
     */
    'mobileNumber': string;
    /**
     * profile photo of the delivery manager
     * @type {string}
     * @memberof EditDeliveryManagerRequestSchema
     */
    'profilePhoto'?: string;
}
/**
 * 
 * @export
 * @interface EditItemCategoryRequest
 */
export interface EditItemCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof EditItemCategoryRequest
     */
    'storeType'?: EditItemCategoryRequestStoreTypeEnum;
    /**
     * Updated name in English
     * @type {string}
     * @memberof EditItemCategoryRequest
     */
    'nameEnglish': string;
    /**
     * Updated name in Arabic
     * @type {string}
     * @memberof EditItemCategoryRequest
     */
    'nameArabic': string;
    /**
     * Who modified the category
     * @type {string}
     * @memberof EditItemCategoryRequest
     */
    'addedBy': EditItemCategoryRequestAddedByEnum;
}

export const EditItemCategoryRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type EditItemCategoryRequestStoreTypeEnum = typeof EditItemCategoryRequestStoreTypeEnum[keyof typeof EditItemCategoryRequestStoreTypeEnum];
export const EditItemCategoryRequestAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type EditItemCategoryRequestAddedByEnum = typeof EditItemCategoryRequestAddedByEnum[keyof typeof EditItemCategoryRequestAddedByEnum];

/**
 * 
 * @export
 * @interface EditItemSubCategoryRequest
 */
export interface EditItemSubCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof EditItemSubCategoryRequest
     */
    'storeType'?: EditItemSubCategoryRequestStoreTypeEnum;
    /**
     * The updated name of the sub-item category in English.
     * @type {string}
     * @memberof EditItemSubCategoryRequest
     */
    'nameEnglish': string;
    /**
     * The updated name of the sub-item category in Arabic.
     * @type {string}
     * @memberof EditItemSubCategoryRequest
     */
    'nameArabic': string;
    /**
     * The ID of the parent category to which the sub-item category belongs.
     * @type {string}
     * @memberof EditItemSubCategoryRequest
     */
    'parentCategoryId': string;
    /**
     * The updated status of the sub-item category.
     * @type {string}
     * @memberof EditItemSubCategoryRequest
     */
    'status'?: EditItemSubCategoryRequestStatusEnum;
    /**
     * Who updated the sub-item category.
     * @type {string}
     * @memberof EditItemSubCategoryRequest
     */
    'addedBy'?: EditItemSubCategoryRequestAddedByEnum;
}

export const EditItemSubCategoryRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type EditItemSubCategoryRequestStoreTypeEnum = typeof EditItemSubCategoryRequestStoreTypeEnum[keyof typeof EditItemSubCategoryRequestStoreTypeEnum];
export const EditItemSubCategoryRequestStatusEnum = {
    Published: 'Published',
    Unpublished: 'Unpublished'
} as const;

export type EditItemSubCategoryRequestStatusEnum = typeof EditItemSubCategoryRequestStatusEnum[keyof typeof EditItemSubCategoryRequestStatusEnum];
export const EditItemSubCategoryRequestAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type EditItemSubCategoryRequestAddedByEnum = typeof EditItemSubCategoryRequestAddedByEnum[keyof typeof EditItemSubCategoryRequestAddedByEnum];

/**
 * 
 * @export
 * @interface EditMealRequest
 */
export interface EditMealRequest {
    /**
     * Meal name in English
     * @type {string}
     * @memberof EditMealRequest
     */
    'mealNameEnglish': string;
    /**
     * Meal name in Arabic
     * @type {string}
     * @memberof EditMealRequest
     */
    'mealNameArabic': string;
    /**
     * ID of the item for the meal
     * @type {string}
     * @memberof EditMealRequest
     */
    'items': string;
    /**
     * Array of choice group IDs for the meal
     * @type {Array<string>}
     * @memberof EditMealRequest
     */
    'choiceGroups': Array<string>;
    /**
     * Price of the meal (whole number)
     * @type {number}
     * @memberof EditMealRequest
     */
    'price': number;
    /**
     * Currency code (e.g., USD, SAR, AED)
     * @type {string}
     * @memberof EditMealRequest
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface EditOfferRequestSchema
 */
export interface EditOfferRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof EditOfferRequestSchema
     */
    'couponName'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditOfferRequestSchema
     */
    'couponType'?: EditOfferRequestSchemaCouponTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof EditOfferRequestSchema
     */
    'maxCouponAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditOfferRequestSchema
     */
    'couponValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditOfferRequestSchema
     */
    'couponStartDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditOfferRequestSchema
     */
    'validityDays'?: number;
    /**
     * 
     * @type {string}
     * @memberof EditOfferRequestSchema
     */
    'termsAndConditions'?: string;
    /**
     * 
     * @type {number}
     * @memberof EditOfferRequestSchema
     */
    'couponPerUserLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof EditOfferRequestSchema
     */
    'totalCouponCount'?: number;
}

export const EditOfferRequestSchemaCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type EditOfferRequestSchemaCouponTypeEnum = typeof EditOfferRequestSchemaCouponTypeEnum[keyof typeof EditOfferRequestSchemaCouponTypeEnum];

/**
 * 
 * @export
 * @interface EditUserRequestSchema
 */
export interface EditUserRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'alternativeMobileNumber'?: string;
    /**
     * URL of the restaurant logo (mandatory)
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'profileImage'?: string;
    /**
     * The primary color theme for the user profile
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'themeColor'?: string;
    /**
     * Preferred language of the user (e.g., en, ar)
     * @type {string}
     * @memberof EditUserRequestSchema
     */
    'language'?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponseSchema
 */
export interface ErrorResponseSchema {
    /**
     * Status code of the response
     * @type {number}
     * @memberof ErrorResponseSchema
     */
    'statusCode': number;
    /**
     * Type of the http error
     * @type {string}
     * @memberof ErrorResponseSchema
     */
    'error': string;
    /**
     * Detailed description of the error
     * @type {string}
     * @memberof ErrorResponseSchema
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface FaqListResponseSchema
 */
export interface FaqListResponseSchema {
    /**
     * ID of the CMS page
     * @type {string}
     * @memberof FaqListResponseSchema
     */
    'faqId': string;
    /**
     * The question for the FAQ page
     * @type {string}
     * @memberof FaqListResponseSchema
     */
    'question': string;
    /**
     * The question in Arabic for the FAQ page
     * @type {string}
     * @memberof FaqListResponseSchema
     */
    'questionInArabic': string;
    /**
     * The answer for the FAQ page
     * @type {string}
     * @memberof FaqListResponseSchema
     */
    'answer': string;
    /**
     * The answer in Arabic for the FAQ page
     * @type {string}
     * @memberof FaqListResponseSchema
     */
    'answerInArabic': string;
    /**
     * The status of the coupon.
     * @type {string}
     * @memberof FaqListResponseSchema
     */
    'status': FaqListResponseSchemaStatusEnum;
}

export const FaqListResponseSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type FaqListResponseSchemaStatusEnum = typeof FaqListResponseSchemaStatusEnum[keyof typeof FaqListResponseSchemaStatusEnum];

/**
 * 
 * @export
 * @interface FeaturedRestaurant
 */
export interface FeaturedRestaurant {
    /**
     * Enable/disable featured restaurant (max 4)
     * @type {boolean}
     * @memberof FeaturedRestaurant
     */
    'status': boolean;
    /**
     * Featured restaurant price per day
     * @type {number}
     * @memberof FeaturedRestaurant
     */
    'featuredPricePerDay'?: number;
}
/**
 * Detailed information about a featured store subscription
 * @export
 * @interface FeaturedStoreSubscriptionDetails
 */
export interface FeaturedStoreSubscriptionDetails {
    /**
     * Subscription ID
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'subscriptionId'?: string;
    /**
     * Store ID
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'storeId'?: string;
    /**
     * Store name in multiple languages
     * @type {{ [key: string]: string; }}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'storeName'?: { [key: string]: string; };
    /**
     * Store logo URL
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'storeLogo'?: string;
    /**
     * Type of store
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'storeType'?: string;
    /**
     * Subscription start date
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'startDate'?: string;
    /**
     * Subscription end date
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'endDate'?: string;
    /**
     * Total price paid
     * @type {number}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'totalPrice'?: number;
    /**
     * Price per day
     * @type {number}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'pricePerDay'?: number;
    /**
     * Number of days
     * @type {number}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'numberOfDays'?: number;
    /**
     * Payment status
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'paymentStatus'?: FeaturedStoreSubscriptionDetailsPaymentStatusEnum;
    /**
     * Payment method used
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'paymentMethod'?: FeaturedStoreSubscriptionDetailsPaymentMethodEnum;
    /**
     * Subscription status
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'status'?: FeaturedStoreSubscriptionDetailsStatusEnum;
    /**
     * Subscription creation date
     * @type {string}
     * @memberof FeaturedStoreSubscriptionDetails
     */
    'createdAt'?: string;
}

export const FeaturedStoreSubscriptionDetailsPaymentStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type FeaturedStoreSubscriptionDetailsPaymentStatusEnum = typeof FeaturedStoreSubscriptionDetailsPaymentStatusEnum[keyof typeof FeaturedStoreSubscriptionDetailsPaymentStatusEnum];
export const FeaturedStoreSubscriptionDetailsPaymentMethodEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type FeaturedStoreSubscriptionDetailsPaymentMethodEnum = typeof FeaturedStoreSubscriptionDetailsPaymentMethodEnum[keyof typeof FeaturedStoreSubscriptionDetailsPaymentMethodEnum];
export const FeaturedStoreSubscriptionDetailsStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    Pending: 'pending',
    Failed: 'failed'
} as const;

export type FeaturedStoreSubscriptionDetailsStatusEnum = typeof FeaturedStoreSubscriptionDetailsStatusEnum[keyof typeof FeaturedStoreSubscriptionDetailsStatusEnum];

/**
 * 
 * @export
 * @interface FeePerKMSchema
 */
export interface FeePerKMSchema {
    /**
     * Fee per kilometer status
     * @type {string}
     * @memberof FeePerKMSchema
     */
    'type': FeePerKMSchemaTypeEnum;
    /**
     * The value of the fee per kilometer
     * @type {number}
     * @memberof FeePerKMSchema
     */
    'feePerKMValue'?: number;
}

export const FeePerKMSchemaTypeEnum = {
    Disable: 'disable',
    Enable: 'enable'
} as const;

export type FeePerKMSchemaTypeEnum = typeof FeePerKMSchemaTypeEnum[keyof typeof FeePerKMSchemaTypeEnum];

/**
 * 
 * @export
 * @interface FoodCategorySchema
 */
export interface FoodCategorySchema {
    /**
     * 
     * @type {string}
     * @memberof FoodCategorySchema
     */
    'category'?: string;
    /**
     * 
     * @type {Array<FoodItemSchema>}
     * @memberof FoodCategorySchema
     */
    'foodItems'?: Array<FoodItemSchema>;
}
/**
 * 
 * @export
 * @interface FoodItemSchema
 */
export interface FoodItemSchema {
    /**
     * 
     * @type {string}
     * @memberof FoodItemSchema
     */
    'name': string;
    /**
     * 
     * @type {FoodItemSchemaFinalPrice}
     * @memberof FoodItemSchema
     */
    'finalPrice': FoodItemSchemaFinalPrice;
    /**
     * 
     * @type {FoodItemSchemaMrp}
     * @memberof FoodItemSchema
     */
    'mrp'?: FoodItemSchemaMrp | null;
    /**
     * 
     * @type {boolean}
     * @memberof FoodItemSchema
     */
    'isFavorite': boolean;
}
/**
 * 
 * @export
 * @interface FoodItemSchemaFinalPrice
 */
export interface FoodItemSchemaFinalPrice {
    /**
     * 
     * @type {number}
     * @memberof FoodItemSchemaFinalPrice
     */
    'value'?: number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FoodItemSchemaFinalPrice
     */
    'currency'?: CurrencyCode;
}


/**
 * 
 * @export
 * @interface FoodItemSchemaMrp
 */
export interface FoodItemSchemaMrp {
    /**
     * 
     * @type {number}
     * @memberof FoodItemSchemaMrp
     */
    'value'?: number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof FoodItemSchemaMrp
     */
    'currency'?: CurrencyCode;
}


/**
 * 
 * @export
 * @interface FooterSettings
 */
export interface FooterSettings {
    /**
     * Footer text in default language
     * @type {string}
     * @memberof FooterSettings
     */
    'footerText'?: string;
    /**
     * Footer text in Arabic
     * @type {string}
     * @memberof FooterSettings
     */
    'footerTextArabic'?: string;
    /**
     * Footer description in default language
     * @type {string}
     * @memberof FooterSettings
     */
    'footerDescription'?: string;
    /**
     * Footer description in Arabic
     * @type {string}
     * @memberof FooterSettings
     */
    'footerDescriptionArabic'?: string;
}
/**
 * 
 * @export
 * @interface ForgotPasswordByEmail
 */
export interface ForgotPasswordByEmail {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordByEmail
     */
    'channel': ForgotPasswordByEmailChannelEnum;
    /**
     * User\'s email address
     * @type {string}
     * @memberof ForgotPasswordByEmail
     */
    'email': string;
    /**
     * The platform type for which the password reset is requested
     * @type {string}
     * @memberof ForgotPasswordByEmail
     */
    'platformType': ForgotPasswordByEmailPlatformTypeEnum;
}

export const ForgotPasswordByEmailChannelEnum = {
    Email: 'email'
} as const;

export type ForgotPasswordByEmailChannelEnum = typeof ForgotPasswordByEmailChannelEnum[keyof typeof ForgotPasswordByEmailChannelEnum];
export const ForgotPasswordByEmailPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ForgotPasswordByEmailPlatformTypeEnum = typeof ForgotPasswordByEmailPlatformTypeEnum[keyof typeof ForgotPasswordByEmailPlatformTypeEnum];

/**
 * 
 * @export
 * @interface ForgotPasswordByPhone
 */
export interface ForgotPasswordByPhone {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordByPhone
     */
    'channel': ForgotPasswordByPhoneChannelEnum;
    /**
     * Phone number of the user (Must be a valid international number)
     * @type {string}
     * @memberof ForgotPasswordByPhone
     */
    'phoneNumber': string;
    /**
     * The platform type for which the password reset is requested
     * @type {string}
     * @memberof ForgotPasswordByPhone
     */
    'platformType': ForgotPasswordByPhonePlatformTypeEnum;
}

export const ForgotPasswordByPhoneChannelEnum = {
    Phone: 'phone'
} as const;

export type ForgotPasswordByPhoneChannelEnum = typeof ForgotPasswordByPhoneChannelEnum[keyof typeof ForgotPasswordByPhoneChannelEnum];
export const ForgotPasswordByPhonePlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ForgotPasswordByPhonePlatformTypeEnum = typeof ForgotPasswordByPhonePlatformTypeEnum[keyof typeof ForgotPasswordByPhonePlatformTypeEnum];

/**
 * 
 * @export
 * @interface ForgotPasswordRequestSchema
 */
export interface ForgotPasswordRequestSchema {
    /**
     * Contact method type
     * @type {string}
     * @memberof ForgotPasswordRequestSchema
     */
    'channel': ForgotPasswordRequestSchemaChannelEnum;
    /**
     * User\'s email address (required when channel is email)
     * @type {string}
     * @memberof ForgotPasswordRequestSchema
     */
    'email'?: string;
    /**
     * Phone number (required when channel is phone)
     * @type {string}
     * @memberof ForgotPasswordRequestSchema
     */
    'phoneNumber'?: string;
    /**
     * The platform type
     * @type {string}
     * @memberof ForgotPasswordRequestSchema
     */
    'platformType': ForgotPasswordRequestSchemaPlatformTypeEnum;
}

export const ForgotPasswordRequestSchemaChannelEnum = {
    Email: 'email',
    Phone: 'phone'
} as const;

export type ForgotPasswordRequestSchemaChannelEnum = typeof ForgotPasswordRequestSchemaChannelEnum[keyof typeof ForgotPasswordRequestSchemaChannelEnum];
export const ForgotPasswordRequestSchemaPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ForgotPasswordRequestSchemaPlatformTypeEnum = typeof ForgotPasswordRequestSchemaPlatformTypeEnum[keyof typeof ForgotPasswordRequestSchemaPlatformTypeEnum];

/**
 * 
 * @export
 * @interface FullOrder
 */
export interface FullOrder {
    /**
     * 
     * @type {string}
     * @memberof FullOrder
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof FullOrder
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof FullOrder
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof FullOrder
     */
    'orderDate': string;
    /**
     * 
     * @type {number}
     * @memberof FullOrder
     */
    'orderAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FullOrder
     */
    'invoiceAmount': number;
    /**
     * 
     * @type {string}
     * @memberof FullOrder
     */
    'status': FullOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof FullOrder
     */
    'paymentStatus': string;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof FullOrder
     */
    'items': Array<OrderItem>;
    /**
     * 
     * @type {InvoiceDetails}
     * @memberof FullOrder
     */
    'invoice': InvoiceDetails;
    /**
     * 
     * @type {TrackingDetails}
     * @memberof FullOrder
     */
    'tracking': TrackingDetails;
}

export const FullOrderStatusEnum = {
    OrderPlaced: 'Order Placed',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    PreparingForDeliver: 'Preparing for deliver',
    Dispatched: 'Dispatched',
    Started: 'Started',
    Arrived: 'Arrived',
    Delivered: 'Delivered',
    Cancelled: 'Cancelled'
} as const;

export type FullOrderStatusEnum = typeof FullOrderStatusEnum[keyof typeof FullOrderStatusEnum];

/**
 * 
 * @export
 * @interface GeneralSettingsRequest
 */
export interface GeneralSettingsRequest {
    /**
     * Site name in default language
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'siteName'?: string;
    /**
     * Site name in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'siteNameArabic'?: string;
    /**
     * Primary contact email address
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'contactEmail'?: string;
    /**
     * Primary contact phone number
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'contactPhone'?: string;
    /**
     * Site description in default language
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'siteDescription'?: string;
    /**
     * Site description in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'siteDescriptionArabic'?: string;
    /**
     * Meta title for SEO
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'metaTitle'?: string;
    /**
     * Meta title in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'metaTitleArabic'?: string;
    /**
     * Meta keywords for SEO
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'metaKeywords'?: string;
    /**
     * Meta keywords in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'metaKeywordsArabic'?: string;
    /**
     * Meta description for SEO
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'metaDescription'?: string;
    /**
     * Meta description in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'metaDescriptionArabic'?: string;
    /**
     * Footer text in default language
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'footerText'?: string;
    /**
     * Footer text in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'footerTextArabic'?: string;
    /**
     * Footer description in default language
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'footerDescription'?: string;
    /**
     * Footer description in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'footerDescriptionArabic'?: string;
    /**
     * Pre-footer title in default language
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'preFooterTitle'?: string;
    /**
     * Pre-footer title in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'preFooterTitleArabic'?: string;
    /**
     * Pre-footer description in default language
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'preFooterDescription'?: string;
    /**
     * Pre-footer description in Arabic
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'preFooterDescriptionArabic'?: string;
    /**
     * Pre-footer image URL (380x640 to 400x670 pixels)
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'preFooterImage'?: string;
    /**
     * Login page image URL (465x335 to 475x345 pixels)
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'loginImage'?: string;
    /**
     * Featured restaurant image URL (must be 660x380 pixels)
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'featuredRestaurantImage'?: string;
    /**
     * iTunes App Store URL
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'itunesUrl'?: string;
    /**
     * Google Play Store URL
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'playStoreUrl'?: string;
    /**
     * Enable/disable coupon functionality
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'couponStatus'?: boolean;
    /**
     * 
     * @type {OtpVerificationStatus}
     * @memberof GeneralSettingsRequest
     */
    'otpVerificationStatus'?: OtpVerificationStatus;
    /**
     * Enable/disable email verification
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'mailVerificationStatus'?: boolean;
    /**
     * Enable/disable no-contact delivery
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'noContactDeliveryStatus'?: boolean;
    /**
     * Enable/disable self pickup option
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'selfPickupStatus'?: boolean;
    /**
     * Show or hide out of stock products
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'showOutOfStockProducts'?: boolean;
    /**
     * Show or hide stock information
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'showStock'?: boolean;
    /**
     * Enable/disable delivery fee
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'deliveryFeeStatus'?: boolean;
    /**
     * Type of delivery fee calculation
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'deliveryFeeType'?: GeneralSettingsRequestDeliveryFeeTypeEnum;
    /**
     * Common delivery fee amount
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'commonDeliveryFee'?: number;
    /**
     * Delivery fee per kilometer
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'feePerKM'?: number;
    /**
     * Delivery boy kilometer range
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'deliveryBoyKilometerRange'?: number;
    /**
     * 
     * @type {PeakHoursDeliveryFeeStatus}
     * @memberof GeneralSettingsRequest
     */
    'peakHoursDeliveryFeeStatus'?: PeakHoursDeliveryFeeStatus;
    /**
     * 
     * @type {OrderHistoryExpire}
     * @memberof GeneralSettingsRequest
     */
    'orderHistoryExpire'?: OrderHistoryExpire;
    /**
     * 
     * @type {AbandonedCartMailStatus}
     * @memberof GeneralSettingsRequest
     */
    'abandonedCartMailStatus'?: AbandonedCartMailStatus;
    /**
     * 
     * @type {ReferFriends}
     * @memberof GeneralSettingsRequest
     */
    'referFriends'?: ReferFriends;
    /**
     * Enable/disable password protection
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'passwordProtection'?: boolean;
    /**
     * Show or hide captcha
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'showCaptcha'?: boolean;
    /**
     * Suspend customer after invalid login attempts
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'invalidLoginSuspendCustomer'?: boolean;
    /**
     * 
     * @type {FeaturedRestaurant}
     * @memberof GeneralSettingsRequest
     */
    'featuredRestaurant'?: FeaturedRestaurant;
    /**
     * Common commission percentage
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'commonCommissionPercentage'?: number;
    /**
     * 
     * @type {CommonDeliveryRadius}
     * @memberof GeneralSettingsRequest
     */
    'commonDeliveryRadius'?: CommonDeliveryRadius;
    /**
     * Default system currency code (ISO 4217, 3 uppercase letters)
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'defaultCurrency'?: string;
    /**
     * Currency symbol for display
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'currencySymbol'?: string;
    /**
     * Currency converter API key
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'currencyConverterApiKey'?: string;
    /**
     * Timezone identifier (e.g., America/New_York)
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'timeZone'?: string;
    /**
     * Date time format string
     * @type {string}
     * @memberof GeneralSettingsRequest
     */
    'dateTimeFormat'?: string;
    /**
     * Enable/disable email notifications
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'emailStatus'?: boolean;
    /**
     * Enable/disable SMS notifications
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'smsStatus'?: boolean;
    /**
     * 
     * @type {PreOrderStatus}
     * @memberof GeneralSettingsRequest
     */
    'preOrderStatus'?: PreOrderStatus;
    /**
     * Fixed bonus amount for emergency driver assignments
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'emergencyDriverBonusAmount'?: number;
    /**
     * Percentage-based bonus for emergency driver assignments (0 means use fixed amount)
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'emergencyDriverBonusPercentage'?: number;
    /**
     * Seconds to extend timeout when no drivers available (default 180 = 3 minutes)
     * @type {number}
     * @memberof GeneralSettingsRequest
     */
    'driverUnavailableTimeoutExtension'?: number;
    /**
     * Enable/disable automatic timeout extension when drivers unavailable
     * @type {boolean}
     * @memberof GeneralSettingsRequest
     */
    'enableAutomaticTimeoutExtension'?: boolean;
    /**
     * 
     * @type {LoyaltyRewardsStatus}
     * @memberof GeneralSettingsRequest
     */
    'loyaltyRewardsStatus'?: LoyaltyRewardsStatus;
}

export const GeneralSettingsRequestDeliveryFeeTypeEnum = {
    Common: 'common',
    PerKilometer: 'perKilometer'
} as const;

export type GeneralSettingsRequestDeliveryFeeTypeEnum = typeof GeneralSettingsRequestDeliveryFeeTypeEnum[keyof typeof GeneralSettingsRequestDeliveryFeeTypeEnum];

/**
 * 
 * @export
 * @interface GeneralSettingsResponse
 */
export interface GeneralSettingsResponse {
    /**
     * Site name in default language
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'siteName'?: string;
    /**
     * Site name in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'siteNameArabic'?: string;
    /**
     * Primary contact email address
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'contactEmail'?: string;
    /**
     * Primary contact phone number
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'contactPhone'?: string;
    /**
     * Site description in default language
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'siteDescription'?: string;
    /**
     * Site description in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'siteDescriptionArabic'?: string;
    /**
     * Meta title for SEO
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'metaTitle'?: string;
    /**
     * Meta title in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'metaTitleArabic'?: string;
    /**
     * Meta keywords for SEO
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'metaKeywords'?: string;
    /**
     * Meta keywords in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'metaKeywordsArabic'?: string;
    /**
     * Meta description for SEO
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'metaDescription'?: string;
    /**
     * Meta description in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'metaDescriptionArabic'?: string;
    /**
     * Footer text in default language
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'footerText'?: string;
    /**
     * Footer text in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'footerTextArabic'?: string;
    /**
     * Footer description in default language
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'footerDescription'?: string;
    /**
     * Footer description in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'footerDescriptionArabic'?: string;
    /**
     * Pre-footer title in default language
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'preFooterTitle'?: string;
    /**
     * Pre-footer title in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'preFooterTitleArabic'?: string;
    /**
     * Pre-footer description in default language
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'preFooterDescription'?: string;
    /**
     * Pre-footer description in Arabic
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'preFooterDescriptionArabic'?: string;
    /**
     * Pre-footer image URL (380x640 to 400x670 pixels)
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'preFooterImage'?: string;
    /**
     * Login page image URL (465x335 to 475x345 pixels)
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'loginImage'?: string;
    /**
     * Featured restaurant image URL (must be 660x380 pixels)
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'featuredRestaurantImage'?: string;
    /**
     * iTunes App Store URL
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'itunesUrl'?: string;
    /**
     * Google Play Store URL
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'playStoreUrl'?: string;
    /**
     * Enable/disable coupon functionality
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'couponStatus'?: boolean;
    /**
     * 
     * @type {OtpVerificationStatus}
     * @memberof GeneralSettingsResponse
     */
    'otpVerificationStatus'?: OtpVerificationStatus;
    /**
     * Enable/disable email verification
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'mailVerificationStatus'?: boolean;
    /**
     * Enable/disable no-contact delivery
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'noContactDeliveryStatus'?: boolean;
    /**
     * Enable/disable self pickup option
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'selfPickupStatus'?: boolean;
    /**
     * Show or hide out of stock products
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'showOutOfStockProducts'?: boolean;
    /**
     * Show or hide stock information
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'showStock'?: boolean;
    /**
     * Enable/disable delivery fee
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'deliveryFeeStatus'?: boolean;
    /**
     * Type of delivery fee calculation
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'deliveryFeeType'?: GeneralSettingsResponseDeliveryFeeTypeEnum;
    /**
     * Common delivery fee amount
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'commonDeliveryFee'?: number;
    /**
     * Delivery fee per kilometer
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'feePerKM'?: number;
    /**
     * Delivery boy kilometer range
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'deliveryBoyKilometerRange'?: number;
    /**
     * 
     * @type {PeakHoursDeliveryFeeStatus}
     * @memberof GeneralSettingsResponse
     */
    'peakHoursDeliveryFeeStatus'?: PeakHoursDeliveryFeeStatus;
    /**
     * 
     * @type {OrderHistoryExpire}
     * @memberof GeneralSettingsResponse
     */
    'orderHistoryExpire'?: OrderHistoryExpire;
    /**
     * 
     * @type {AbandonedCartMailStatus}
     * @memberof GeneralSettingsResponse
     */
    'abandonedCartMailStatus'?: AbandonedCartMailStatus;
    /**
     * 
     * @type {ReferFriends}
     * @memberof GeneralSettingsResponse
     */
    'referFriends'?: ReferFriends;
    /**
     * Enable/disable password protection
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'passwordProtection'?: boolean;
    /**
     * Show or hide captcha
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'showCaptcha'?: boolean;
    /**
     * Suspend customer after invalid login attempts
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'invalidLoginSuspendCustomer'?: boolean;
    /**
     * 
     * @type {FeaturedRestaurant}
     * @memberof GeneralSettingsResponse
     */
    'featuredRestaurant'?: FeaturedRestaurant;
    /**
     * Common commission percentage
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'commonCommissionPercentage'?: number;
    /**
     * 
     * @type {CommonDeliveryRadius}
     * @memberof GeneralSettingsResponse
     */
    'commonDeliveryRadius'?: CommonDeliveryRadius;
    /**
     * Default system currency code (ISO 4217, 3 uppercase letters)
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'defaultCurrency'?: string;
    /**
     * Currency symbol for display
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'currencySymbol'?: string;
    /**
     * Currency converter API key
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'currencyConverterApiKey'?: string;
    /**
     * Timezone identifier (e.g., America/New_York)
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'timeZone'?: string;
    /**
     * Date time format string
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'dateTimeFormat'?: string;
    /**
     * Enable/disable email notifications
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'emailStatus'?: boolean;
    /**
     * Enable/disable SMS notifications
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'smsStatus'?: boolean;
    /**
     * 
     * @type {PreOrderStatus}
     * @memberof GeneralSettingsResponse
     */
    'preOrderStatus'?: PreOrderStatus;
    /**
     * Fixed bonus amount for emergency driver assignments
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'emergencyDriverBonusAmount'?: number;
    /**
     * Percentage-based bonus for emergency driver assignments (0 means use fixed amount)
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'emergencyDriverBonusPercentage'?: number;
    /**
     * Seconds to extend timeout when no drivers available (default 180 = 3 minutes)
     * @type {number}
     * @memberof GeneralSettingsResponse
     */
    'driverUnavailableTimeoutExtension'?: number;
    /**
     * Enable/disable automatic timeout extension when drivers unavailable
     * @type {boolean}
     * @memberof GeneralSettingsResponse
     */
    'enableAutomaticTimeoutExtension'?: boolean;
    /**
     * 
     * @type {LoyaltyRewardsStatus}
     * @memberof GeneralSettingsResponse
     */
    'loyaltyRewardsStatus'?: LoyaltyRewardsStatus;
    /**
     * Settings configuration ID
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'id'?: string;
    /**
     * Settings creation timestamp
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'createdAt'?: string;
    /**
     * Settings last update timestamp
     * @type {string}
     * @memberof GeneralSettingsResponse
     */
    'updatedAt'?: string;
}

export const GeneralSettingsResponseDeliveryFeeTypeEnum = {
    Common: 'common',
    PerKilometer: 'perKilometer'
} as const;

export type GeneralSettingsResponseDeliveryFeeTypeEnum = typeof GeneralSettingsResponseDeliveryFeeTypeEnum[keyof typeof GeneralSettingsResponseDeliveryFeeTypeEnum];

/**
 * 
 * @export
 * @interface GenerateCouponCodeResponseSchema
 */
export interface GenerateCouponCodeResponseSchema {
    /**
     * The coupon code that will be used to redeem the coupon.
     * @type {string}
     * @memberof GenerateCouponCodeResponseSchema
     */
    'couponCode': string;
}
/**
 * 
 * @export
 * @interface GeneratePresignedUrlRequest
 */
export interface GeneratePresignedUrlRequest {
    /**
     * The action to perform (upload, download, or delete).
     * @type {string}
     * @memberof GeneratePresignedUrlRequest
     */
    'action': GeneratePresignedUrlRequestActionEnum;
    /**
     * The name of the file.
     * @type {string}
     * @memberof GeneratePresignedUrlRequest
     */
    'fileName': string;
}

export const GeneratePresignedUrlRequestActionEnum = {
    Upload: 'upload',
    Download: 'download',
    Delete: 'delete'
} as const;

export type GeneratePresignedUrlRequestActionEnum = typeof GeneratePresignedUrlRequestActionEnum[keyof typeof GeneratePresignedUrlRequestActionEnum];

/**
 * 
 * @export
 * @interface GenerateReferralCodeResponse
 */
export interface GenerateReferralCodeResponse {
    /**
     * Indicates if the referral code generation was successful
     * @type {boolean}
     * @memberof GenerateReferralCodeResponse
     */
    'success': boolean;
    /**
     * The generated unique referral code for the user
     * @type {string}
     * @memberof GenerateReferralCodeResponse
     */
    'referralCode': string;
    /**
     * Success message
     * @type {string}
     * @memberof GenerateReferralCodeResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface GetAllBannerImagesResponse
 */
export interface GetAllBannerImagesResponse {
    /**
     * 
     * @type {Array<DynamicHomePageContentSettings>}
     * @memberof GetAllBannerImagesResponse
     */
    'data'?: Array<DynamicHomePageContentSettings>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllBannerImagesResponse
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllChoiceGroupResponseSchema
 */
export interface GetAllChoiceGroupResponseSchema {
    /**
     * 
     * @type {Array<GetAllChoiceGroupsSchema>}
     * @memberof GetAllChoiceGroupResponseSchema
     */
    'data': Array<GetAllChoiceGroupsSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllChoiceGroupResponseSchema
     */
    'pagination': GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllChoiceGroupsSchema
 */
export interface GetAllChoiceGroupsSchema {
    /**
     * The id of the choice group
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'choiceGroupId': string;
    /**
     * The type of store to which the choice group belongs.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'storeType': GetAllChoiceGroupsSchemaStoreTypeEnum;
    /**
     * The ID of the store to which the choice group belongs.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'storeId': string;
    /**
     * The name of the store to which the choice group belongs.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'storeName': string;
    /**
     * The name of the choice group in English.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'choiceGroupNameEnglish': string;
    /**
     * The name of the choice group in Arabic.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'choiceGroupNameArabic': string;
    /**
     * The minimum limit for the choice group.
     * @type {number}
     * @memberof GetAllChoiceGroupsSchema
     */
    'minimumLimit': number;
    /**
     * The maximum limit for the choice group.
     * @type {number}
     * @memberof GetAllChoiceGroupsSchema
     */
    'maximumLimit': number;
    /**
     * Indicates whether the choice group is required or not.
     * @type {boolean}
     * @memberof GetAllChoiceGroupsSchema
     */
    'choiceGroupOption': boolean;
    /**
     * The details of the choices associated with the choice group.
     * @type {Array<GetAllChoiceGroupsSchemaChoiceDetailsInner>}
     * @memberof GetAllChoiceGroupsSchema
     */
    'choiceDetails': Array<GetAllChoiceGroupsSchemaChoiceDetailsInner>;
    /**
     * status of the choice group
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'status': GetAllChoiceGroupsSchemaStatusEnum;
    /**
     * who added the choice group
     * @type {string}
     * @memberof GetAllChoiceGroupsSchema
     */
    'addedBy'?: GetAllChoiceGroupsSchemaAddedByEnum;
}

export const GetAllChoiceGroupsSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type GetAllChoiceGroupsSchemaStoreTypeEnum = typeof GetAllChoiceGroupsSchemaStoreTypeEnum[keyof typeof GetAllChoiceGroupsSchemaStoreTypeEnum];
export const GetAllChoiceGroupsSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type GetAllChoiceGroupsSchemaStatusEnum = typeof GetAllChoiceGroupsSchemaStatusEnum[keyof typeof GetAllChoiceGroupsSchemaStatusEnum];
export const GetAllChoiceGroupsSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type GetAllChoiceGroupsSchemaAddedByEnum = typeof GetAllChoiceGroupsSchemaAddedByEnum[keyof typeof GetAllChoiceGroupsSchemaAddedByEnum];

/**
 * 
 * @export
 * @interface GetAllChoiceGroupsSchemaChoiceDetailsInner
 */
export interface GetAllChoiceGroupsSchemaChoiceDetailsInner {
    /**
     * The ID of the choice.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchemaChoiceDetailsInner
     */
    'choiceId'?: string;
    /**
     * The name of the choice.
     * @type {string}
     * @memberof GetAllChoiceGroupsSchemaChoiceDetailsInner
     */
    'choiceName'?: string;
    /**
     * The price of the choice.
     * @type {number}
     * @memberof GetAllChoiceGroupsSchemaChoiceDetailsInner
     */
    'choicePrice'?: number;
}
/**
 * 
 * @export
 * @interface GetAllChoicesResponseSchema
 */
export interface GetAllChoicesResponseSchema {
    /**
     * 
     * @type {Array<ChoiceSchema>}
     * @memberof GetAllChoicesResponseSchema
     */
    'data': Array<ChoiceSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllChoicesResponseSchema
     */
    'pagination': GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllCmsPagesResponseSchema
 */
export interface GetAllCmsPagesResponseSchema {
    /**
     * 
     * @type {Array<CmsPageResponseSchema>}
     * @memberof GetAllCmsPagesResponseSchema
     */
    'data'?: Array<CmsPageResponseSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllCmsPagesResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllCouponsResponseSchema
 */
export interface GetAllCouponsResponseSchema {
    /**
     * 
     * @type {Array<CouponResponseSchema>}
     * @memberof GetAllCouponsResponseSchema
     */
    'data'?: Array<CouponResponseSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllCouponsResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllDeliveryBoysResponseSchema
 */
export interface GetAllDeliveryBoysResponseSchema {
    /**
     * 
     * @type {Array<DeliveryBoySchema>}
     * @memberof GetAllDeliveryBoysResponseSchema
     */
    'data'?: Array<DeliveryBoySchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllDeliveryBoysResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllDeliveryManagersResponseSchema
 */
export interface GetAllDeliveryManagersResponseSchema {
    /**
     * 
     * @type {Array<GetAllDeliveryManagersResponseSchemaDataInner>}
     * @memberof GetAllDeliveryManagersResponseSchema
     */
    'data'?: Array<GetAllDeliveryManagersResponseSchemaDataInner>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllDeliveryManagersResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllDeliveryManagersResponseSchemaDataInner
 */
export interface GetAllDeliveryManagersResponseSchemaDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetAllDeliveryManagersResponseSchemaDataInner
     */
    'deliveryManagerId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllDeliveryManagersResponseSchemaDataInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllDeliveryManagersResponseSchemaDataInner
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllDeliveryManagersResponseSchemaDataInner
     */
    'mobileNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetAllDeliveryManagersResponseSchemaDataInner
     */
    'profilePhoto'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllDeliveryManagersResponseSchemaDataInner
     */
    'status': GetAllDeliveryManagersResponseSchemaDataInnerStatusEnum;
}

export const GetAllDeliveryManagersResponseSchemaDataInnerStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type GetAllDeliveryManagersResponseSchemaDataInnerStatusEnum = typeof GetAllDeliveryManagersResponseSchemaDataInnerStatusEnum[keyof typeof GetAllDeliveryManagersResponseSchemaDataInnerStatusEnum];

/**
 * 
 * @export
 * @interface GetAllFaqsResponseSchema
 */
export interface GetAllFaqsResponseSchema {
    /**
     * 
     * @type {Array<FaqListResponseSchema>}
     * @memberof GetAllFaqsResponseSchema
     */
    'data'?: Array<FaqListResponseSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllFaqsResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllItemsInStockResponseSchema
 */
export interface GetAllItemsInStockResponseSchema {
    /**
     * 
     * @type {Array<ItemStockSchema>}
     * @memberof GetAllItemsInStockResponseSchema
     */
    'data'?: Array<ItemStockSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllItemsInStockResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllItemsResponseSchema
 */
export interface GetAllItemsResponseSchema {
    /**
     * 
     * @type {Array<AddOrEditItemRequestSchema>}
     * @memberof GetAllItemsResponseSchema
     */
    'data'?: Array<AddOrEditItemRequestSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllItemsResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllMeals200Response
 */
export interface GetAllMeals200Response {
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200Response
     */
    'message'?: string;
    /**
     * 
     * @type {Array<GetAllMeals200ResponseDataInner>}
     * @memberof GetAllMeals200Response
     */
    'data'?: Array<GetAllMeals200ResponseDataInner>;
    /**
     * 
     * @type {GetAllMeals200ResponsePagination}
     * @memberof GetAllMeals200Response
     */
    'pagination'?: GetAllMeals200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllMeals200ResponseDataInner
 */
export interface GetAllMeals200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'mealId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'mealNameEnglish'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'mealNameArabic'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'storeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'storeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'itemName'?: string;
    /**
     * 
     * @type {Array<GetAllMeals200ResponseDataInnerChoiceGroupDetailsInner>}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'choiceGroupDetails'?: Array<GetAllMeals200ResponseDataInnerChoiceGroupDetailsInner>;
    /**
     * 
     * @type {number}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'addedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInner
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface GetAllMeals200ResponseDataInnerChoiceGroupDetailsInner
 */
export interface GetAllMeals200ResponseDataInnerChoiceGroupDetailsInner {
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInnerChoiceGroupDetailsInner
     */
    'choiceGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllMeals200ResponseDataInnerChoiceGroupDetailsInner
     */
    'choiceGroupName'?: string;
}
/**
 * 
 * @export
 * @interface GetAllMeals200ResponsePagination
 */
export interface GetAllMeals200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetAllMeals200ResponsePagination
     */
    'totalItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllMeals200ResponsePagination
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllMeals200ResponsePagination
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAllMeals200ResponsePagination
     */
    'totalPages'?: number;
}
/**
 * 
 * @export
 * @interface GetAllNewsletterSubscribersResponse
 */
export interface GetAllNewsletterSubscribersResponse {
    /**
     * List of newsletter subscribers
     * @type {Array<NewsletterSubscriber>}
     * @memberof GetAllNewsletterSubscribersResponse
     */
    'subscribers': Array<NewsletterSubscriber>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetAllNewsletterSubscribersResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface GetAllNotificationsResponse
 */
export interface GetAllNotificationsResponse {
    /**
     * Current page number
     * @type {number}
     * @memberof GetAllNotificationsResponse
     */
    'page': number;
    /**
     * Number of records per page
     * @type {number}
     * @memberof GetAllNotificationsResponse
     */
    'limit': number;
    /**
     * Total number of records
     * @type {number}
     * @memberof GetAllNotificationsResponse
     */
    'totalRecords': number;
    /**
     * 
     * @type {Array<Notification>}
     * @memberof GetAllNotificationsResponse
     */
    'notifications': Array<Notification>;
}
/**
 * 
 * @export
 * @interface GetAllOffersResponseSchema
 */
export interface GetAllOffersResponseSchema {
    /**
     * 
     * @type {Array<OfferResponseSchema>}
     * @memberof GetAllOffersResponseSchema
     */
    'data': Array<OfferResponseSchema>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetAllOffersResponseSchema
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface GetAllReviewsResponseSchema
 */
export interface GetAllReviewsResponseSchema {
    /**
     * 
     * @type {Array<Review>}
     * @memberof GetAllReviewsResponseSchema
     */
    'data'?: Array<Review>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllReviewsResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllSubAdminsResponse
 */
export interface GetAllSubAdminsResponse {
    /**
     * 
     * @type {Array<SubAdminWithPermissions>}
     * @memberof GetAllSubAdminsResponse
     */
    'data'?: Array<SubAdminWithPermissions>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllSubAdminsResponse
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAllUsersResponseSchema
 */
export interface GetAllUsersResponseSchema {
    /**
     * 
     * @type {Array<UserSchema>}
     * @memberof GetAllUsersResponseSchema
     */
    'data'?: Array<UserSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetAllUsersResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetAvailableCouponsRequest
 */
export interface GetAvailableCouponsRequest {
    /**
     * List of store IDs to fetch available coupons for
     * @type {Array<string>}
     * @memberof GetAvailableCouponsRequest
     */
    'storeIds': Array<string>;
    /**
     * User ID to filter coupons based on user-specific usage limits
     * @type {string}
     * @memberof GetAvailableCouponsRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface GetAvailableCouponsResponse
 */
export interface GetAvailableCouponsResponse {
    /**
     * 
     * @type {GetAvailableCouponsResponseData}
     * @memberof GetAvailableCouponsResponse
     */
    'data': GetAvailableCouponsResponseData;
}
/**
 * 
 * @export
 * @interface GetAvailableCouponsResponseData
 */
export interface GetAvailableCouponsResponseData {
    /**
     * Store coupons grouped by store name
     * @type {{ [key: string]: Array<AvailableCoupon>; }}
     * @memberof GetAvailableCouponsResponseData
     */
    'storeCoupons': { [key: string]: Array<AvailableCoupon>; };
    /**
     * User-specific offer coupons
     * @type {Array<AvailableOfferCoupon>}
     * @memberof GetAvailableCouponsResponseData
     */
    'offerCoupons': Array<AvailableOfferCoupon>;
}
/**
 * 
 * @export
 * @interface GetAvailableOffersForAssignment
 */
export interface GetAvailableOffersForAssignment {
    /**
     * 
     * @type {Array<OfferResponseSchema>}
     * @memberof GetAvailableOffersForAssignment
     */
    'data': Array<OfferResponseSchema>;
}
/**
 * 
 * @export
 * @interface GetCustomerLoyaltyHistory
 */
export interface GetCustomerLoyaltyHistory {
    /**
     * 
     * @type {Array<CustomerLoyaltyHistory>}
     * @memberof GetCustomerLoyaltyHistory
     */
    'data': Array<CustomerLoyaltyHistory>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetCustomerLoyaltyHistory
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface GetCustomersDetailsForOffers
 */
export interface GetCustomersDetailsForOffers {
    /**
     * 
     * @type {Array<CustomerFullDetailsSchema>}
     * @memberof GetCustomersDetailsForOffers
     */
    'data': Array<CustomerFullDetailsSchema>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetCustomersDetailsForOffers
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface GetDeliveryPartnerOrderHistoryResponse
 */
export interface GetDeliveryPartnerOrderHistoryResponse {
    /**
     * Current page number
     * @type {number}
     * @memberof GetDeliveryPartnerOrderHistoryResponse
     */
    'page': number;
    /**
     * Number of records per page
     * @type {number}
     * @memberof GetDeliveryPartnerOrderHistoryResponse
     */
    'limit': number;
    /**
     * Total number of records
     * @type {number}
     * @memberof GetDeliveryPartnerOrderHistoryResponse
     */
    'totalRecords': number;
    /**
     * 
     * @type {Array<DeliveryPartnerOrder>}
     * @memberof GetDeliveryPartnerOrderHistoryResponse
     */
    'orders': Array<DeliveryPartnerOrder>;
}
/**
 * Response containing featured store subscriptions
 * @export
 * @interface GetFeaturedStoreSubscriptionsResponse
 */
export interface GetFeaturedStoreSubscriptionsResponse {
    /**
     * List of subscriptions
     * @type {Array<FeaturedStoreSubscriptionDetails>}
     * @memberof GetFeaturedStoreSubscriptionsResponse
     */
    'subscriptions'?: Array<FeaturedStoreSubscriptionDetails>;
    /**
     * 
     * @type {Pagination}
     * @memberof GetFeaturedStoreSubscriptionsResponse
     */
    'pagination'?: Pagination;
}
/**
 * 
 * @export
 * @interface GetItemCategories200Response
 */
export interface GetItemCategories200Response {
    /**
     * 
     * @type {Array<GetItemCategoriesResponse>}
     * @memberof GetItemCategories200Response
     */
    'data'?: Array<GetItemCategoriesResponse>;
    /**
     * 
     * @type {number}
     * @memberof GetItemCategories200Response
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetItemCategories200Response
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetItemCategories200Response
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface GetItemCategoriesResponse
 */
export interface GetItemCategoriesResponse {
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'storeType': GetItemCategoriesResponseStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'nameEnglish': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'nameArabic': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'addedBy': GetItemCategoriesResponseAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof GetItemCategoriesResponse
     */
    'status': GetItemCategoriesResponseStatusEnum;
    /**
     * 
     * @type {Array<GetItemCategoriesResponse>}
     * @memberof GetItemCategoriesResponse
     */
    'subCategories'?: Array<GetItemCategoriesResponse>;
}

export const GetItemCategoriesResponseStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type GetItemCategoriesResponseStoreTypeEnum = typeof GetItemCategoriesResponseStoreTypeEnum[keyof typeof GetItemCategoriesResponseStoreTypeEnum];
export const GetItemCategoriesResponseAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type GetItemCategoriesResponseAddedByEnum = typeof GetItemCategoriesResponseAddedByEnum[keyof typeof GetItemCategoriesResponseAddedByEnum];
export const GetItemCategoriesResponseStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type GetItemCategoriesResponseStatusEnum = typeof GetItemCategoriesResponseStatusEnum[keyof typeof GetItemCategoriesResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetItemSubCategoriesResponse
 */
export interface GetItemSubCategoriesResponse {
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'storeType': GetItemSubCategoriesResponseStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'nameEnglish': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'nameArabic': string;
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'addedBy': GetItemSubCategoriesResponseAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'status': GetItemSubCategoriesResponseStatusEnum;
    /**
     * ID of the parent category
     * @type {string}
     * @memberof GetItemSubCategoriesResponse
     */
    'parentCategoryId': string;
}

export const GetItemSubCategoriesResponseStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type GetItemSubCategoriesResponseStoreTypeEnum = typeof GetItemSubCategoriesResponseStoreTypeEnum[keyof typeof GetItemSubCategoriesResponseStoreTypeEnum];
export const GetItemSubCategoriesResponseAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type GetItemSubCategoriesResponseAddedByEnum = typeof GetItemSubCategoriesResponseAddedByEnum[keyof typeof GetItemSubCategoriesResponseAddedByEnum];
export const GetItemSubCategoriesResponseStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type GetItemSubCategoriesResponseStatusEnum = typeof GetItemSubCategoriesResponseStatusEnum[keyof typeof GetItemSubCategoriesResponseStatusEnum];

/**
 * 
 * @export
 * @interface GetLoyaltyPointsResponse
 */
export interface GetLoyaltyPointsResponse {
    /**
     * Total points earned historically
     * @type {number}
     * @memberof GetLoyaltyPointsResponse
     */
    'totalPointsEarned': number;
    /**
     * Points available for redemption
     * @type {number}
     * @memberof GetLoyaltyPointsResponse
     */
    'availablePoints': number;
    /**
     * Total points redeemed
     * @type {number}
     * @memberof GetLoyaltyPointsResponse
     */
    'redeemedPoints': number;
    /**
     * Amount user will receive if they redeem all available points
     * @type {number}
     * @memberof GetLoyaltyPointsResponse
     */
    'potentialWalletCredit': number;
    /**
     * Minimum points required to redeem
     * @type {number}
     * @memberof GetLoyaltyPointsResponse
     */
    'minimumTargetPoints': number;
    /**
     * Whether user has enough points to redeem
     * @type {boolean}
     * @memberof GetLoyaltyPointsResponse
     */
    'canRedeem': boolean;
    /**
     * Value of each point when converted to wallet credit
     * @type {number}
     * @memberof GetLoyaltyPointsResponse
     */
    'redeemPointValue': number;
    /**
     * History of earned points
     * @type {Array<LoyaltyTransactionSchema>}
     * @memberof GetLoyaltyPointsResponse
     */
    'earnedHistory': Array<LoyaltyTransactionSchema>;
    /**
     * History of redeemed points
     * @type {Array<LoyaltyTransactionSchema>}
     * @memberof GetLoyaltyPointsResponse
     */
    'redeemedHistory': Array<LoyaltyTransactionSchema>;
}
/**
 * A unified order details schema that adapts its fields based on userType. Each userType will use only the relevant fields. 
 * @export
 * @interface GetOrderDetailsResponse
 */
export interface GetOrderDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'userType': GetOrderDetailsResponseUserTypeEnum;
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'orderedOn'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'currentStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDetailsResponse
     */
    'totalAmount'?: number;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof GetOrderDetailsResponse
     */
    'orderItems'?: Array<OrderItem>;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof GetOrderDetailsResponse
     */
    'shippingAddress'?: ShippingAddress;
    /**
     * 
     * @type {InvoiceDetails}
     * @memberof GetOrderDetailsResponse
     */
    'invoiceDetails'?: InvoiceDetails;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof GetOrderDetailsResponse
     */
    'trackingHistory'?: Array<TrackingEvent>;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderDetailsResponse
     */
    'isReviewed'?: boolean;
    /**
     * 
     * @type {UserShort}
     * @memberof GetOrderDetailsResponse
     */
    'customerInfo'?: UserShort;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'specialInstructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'prepStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDetailsResponse
     */
    'orderAcceptedAt'?: string;
    /**
     * 
     * @type {DeliveryBoyShort}
     * @memberof GetOrderDetailsResponse
     */
    'deliveryDetails'?: DeliveryBoyShort | null;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof GetOrderDetailsResponse
     */
    'deliveryAddress'?: ShippingAddress;
    /**
     * 
     * @type {UserShort}
     * @memberof GetOrderDetailsResponse
     */
    'customerContact'?: UserShort;
    /**
     * 
     * @type {Array<StoreInfo>}
     * @memberof GetOrderDetailsResponse
     */
    'pickupLocation'?: Array<StoreInfo>;
    /**
     * 
     * @type {UserShort}
     * @memberof GetOrderDetailsResponse
     */
    'user'?: UserShort;
    /**
     * 
     * @type {DeliveryBoyShort}
     * @memberof GetOrderDetailsResponse
     */
    'deliveryBoy'?: DeliveryBoyShort | null;
    /**
     * 
     * @type {Review}
     * @memberof GetOrderDetailsResponse
     */
    'reviewSummary'?: Review;
    /**
     * 
     * @type {Array<OrderDetailsAdminAuditLogsInner>}
     * @memberof GetOrderDetailsResponse
     */
    'auditLogs'?: Array<OrderDetailsAdminAuditLogsInner>;
}

export const GetOrderDetailsResponseUserTypeEnum = {
    Customer: 'Customer',
    Merchant: 'Merchant',
    DeliveryPartner: 'DeliveryPartner',
    Admin: 'Admin'
} as const;

export type GetOrderDetailsResponseUserTypeEnum = typeof GetOrderDetailsResponseUserTypeEnum[keyof typeof GetOrderDetailsResponseUserTypeEnum];

/**
 * 
 * @export
 * @interface GetRestaurantDetailsSchema
 */
export interface GetRestaurantDetailsSchema {
    /**
     * The unique identifier of the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'id'?: string;
    /**
     * The name of the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'name'?: string;
    /**
     * The name of the restaurant in Arabic.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'nameArabic'?: string;
    /**
     * A brief description of the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantDescription'?: string;
    /**
     * A brief description of the restaurant in Arabic.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantDescriptionArabic'?: string;
    /**
     * The URL of the restaurant\'s logo.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantLogo'?: string;
    /**
     * URLs for restaurant banners.
     * @type {Array<string>}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantBanner'?: Array<string>;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantCurrency'?: CurrencyCode;
    /**
     * Indicates if pre-ordering is available.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchema
     */
    'preOrderOption'?: boolean;
    /**
     * The average rating of the restaurant.
     * @type {number}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantRating'?: number;
    /**
     * The cancellation policy of the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'cancellationPolicy'?: string;
    /**
     * The cancellation policy of the restaurant in Arabic.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'cancellationPolicyArabic'?: string;
    /**
     * Indicates if refunds are enabled for the restaurant.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchema
     */
    'refundStatus'?: boolean;
    /**
     * Indicates if cancellations are enabled for the restaurant.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchema
     */
    'cancellationStatus'?: boolean;
    /**
     * The cancellation fee for the restaurant.
     * @type {number}
     * @memberof GetRestaurantDetailsSchema
     */
    'cancellationFee'?: number;
    /**
     * The address of the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantLocation'?: string;
    /**
     * Estimated delivery time for the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'deliveryTime'?: string;
    /**
     * The URL of the restaurant\'s promotional video.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'videoUrl'?: string;
    /**
     * Indicates if the restaurant is an express delivery partner.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchema
     */
    'expressStatus'?: boolean;
    /**
     * The booking type for the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'bookingType'?: GetRestaurantDetailsSchemaBookingTypeEnum;
    /**
     * The ID of the booking type.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'bookingTypeId'?: string;
    /**
     * Indicates if time slots are enabled for the restaurant.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchema
     */
    'timeSlotStatus'?: boolean;
    /**
     * The minimum number of calendar days for booking.
     * @type {number}
     * @memberof GetRestaurantDetailsSchema
     */
    'minimumCalenderDays'?: number;
    /**
     * The ID of the workflow for the restaurant.
     * @type {string}
     * @memberof GetRestaurantDetailsSchema
     */
    'workFlowId'?: string;
    /**
     * Availability status of the restaurant.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchema
     */
    'isAvailable'?: boolean;
    /**
     * Minimum order amount required for delivery.
     * @type {number}
     * @memberof GetRestaurantDetailsSchema
     */
    'minOrderAmount'?: number;
    /**
     * Weekly working hours of the restaurant
     * @type {Array<WorkingHoursSchema>}
     * @memberof GetRestaurantDetailsSchema
     */
    'workingHours'?: Array<WorkingHoursSchema>;
    /**
     * List of reviews for the restaurant.
     * @type {Array<RestaurantReviewSchema>}
     * @memberof GetRestaurantDetailsSchema
     */
    'restaurantReview'?: Array<RestaurantReviewSchema>;
    /**
     * 
     * @type {Array<GetRestaurantDetailsSchemaItemCategoriesInner>}
     * @memberof GetRestaurantDetailsSchema
     */
    'itemCategories'?: Array<GetRestaurantDetailsSchemaItemCategoriesInner>;
    /**
     * 
     * @type {Array<GetRestaurantDetailsSchemaFoodItemsInner>}
     * @memberof GetRestaurantDetailsSchema
     */
    'foodItems'?: Array<GetRestaurantDetailsSchemaFoodItemsInner>;
}

export const GetRestaurantDetailsSchemaBookingTypeEnum = {
    DineIn: 'dine-in',
    TakeAway: 'take-away',
    Delivery: 'delivery'
} as const;

export type GetRestaurantDetailsSchemaBookingTypeEnum = typeof GetRestaurantDetailsSchemaBookingTypeEnum[keyof typeof GetRestaurantDetailsSchemaBookingTypeEnum];

/**
 * 
 * @export
 * @interface GetRestaurantDetailsSchemaFoodItemsInner
 */
export interface GetRestaurantDetailsSchemaFoodItemsInner {
    /**
     * The unique identifier of the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'id'?: string;
    /**
     * The name of the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'name'?: string;
    /**
     * The slug of the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemSlug'?: string;
    /**
     * The average rating of the food item.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemRating'?: number;
    /**
     * The URL of the food item\'s image.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemImage'?: string;
    /**
     * The content of the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemContent'?: string;
    /**
     * A brief description of the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemDescription'?: string;
    /**
     * A brief description of the food item in Arabic.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemDescriptionArabic'?: string;
    /**
     * Indicates if the food item has types.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemHasType'?: boolean;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemCurrency'?: CurrencyCode;
    /**
     * Indicates whether the food item is vegetarian or non-vegetarian.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'vegOrNonVeg'?: GetRestaurantDetailsSchemaFoodItemsInnerVegOrNonVegEnum;
    /**
     * Indicates whether the food item is halal.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'isHalal'?: boolean;
    /**
     * Indicates whether the food item is marked as a favorite by the user.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'isFavorite'?: boolean;
    /**
     * The maximum retail price of the food item.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'mrp'?: number;
    /**
     * Indicates if the food item has a discount.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemHasDiscount'?: boolean;
    /**
     * The final price of the food item after discounts.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'finalPrice'?: number;
    /**
     * Indicates if the food item has choices.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemHasChoice'?: boolean;
    /**
     * The quantity of the food item.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemQuantity'?: number;
    /**
     * Indicates if the food item is available.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemAvailability'?: boolean;
    /**
     * The number of times the food item has been added to the wishlist.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'wishListCount'?: number;
    /**
     * Indicates if the food item has a coupon.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemHasCoupon'?: boolean;
    /**
     * The quantity of the food item in the cart.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'cartQuantity'?: number;
    /**
     * The ID of the cart item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'cartId'?: string;
    /**
     * Indicates if the food item exists in the cart.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'existsInCart'?: boolean;
    /**
     * Indicates if the food item has variants.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemHasVariant'?: boolean;
    /**
     * The number of variants available for the food item.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'itemVariantCount'?: number;
    /**
     * The brand name of the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'brandName'?: string;
    /**
     * Indicates if the food item is a combo.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'comboStatus'?: boolean;
    /**
     * The service time for the food item.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'serviceTime'?: string;
    /**
     * 
     * @type {Array<GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner>}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'choiceList'?: Array<GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner>;
    /**
     * Indicates if the food item is slot-based.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'isSlotBased'?: boolean;
    /**
     * The count of the food item in the cart.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'cartCount'?: number;
    /**
     * The total amount for the food item in the cart.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'cartAmount'?: number;
    /**
     * Indicates if the food item is in the cart.
     * @type {boolean}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'cartStatus'?: boolean;
    /**
     * The ID of the category the food item belongs to.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'categoryId'?: string;
    /**
     * The ID of the sub-category the food item belongs to.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInner
     */
    'subCategoryId'?: string;
}

export const GetRestaurantDetailsSchemaFoodItemsInnerVegOrNonVegEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type GetRestaurantDetailsSchemaFoodItemsInnerVegOrNonVegEnum = typeof GetRestaurantDetailsSchemaFoodItemsInnerVegOrNonVegEnum[keyof typeof GetRestaurantDetailsSchemaFoodItemsInnerVegOrNonVegEnum];

/**
 * 
 * @export
 * @interface GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner
 */
export interface GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner {
    /**
     * The unique identifier of the choice.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner
     */
    'id'?: string;
    /**
     * The name of the choice.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner
     */
    'name'?: string;
    /**
     * The price of the choice.
     * @type {number}
     * @memberof GetRestaurantDetailsSchemaFoodItemsInnerChoiceListInner
     */
    'price'?: number;
}
/**
 * 
 * @export
 * @interface GetRestaurantDetailsSchemaItemCategoriesInner
 */
export interface GetRestaurantDetailsSchemaItemCategoriesInner {
    /**
     * The unique identifier of the category.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaItemCategoriesInner
     */
    'id'?: string;
    /**
     * The name of the category.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaItemCategoriesInner
     */
    'name'?: string;
    /**
     * 
     * @type {GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory}
     * @memberof GetRestaurantDetailsSchemaItemCategoriesInner
     */
    'subCategory'?: GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory;
}
/**
 * 
 * @export
 * @interface GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory
 */
export interface GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory {
    /**
     * The unique identifier of the sub-category.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory
     */
    'id'?: string;
    /**
     * The name of the sub-category.
     * @type {string}
     * @memberof GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory
     */
    'name'?: string;
}
/**
 * @type GetSpecialUserDetails200Response
 * @export
 */
export type GetSpecialUserDetails200Response = DeliveryPartnerDetailsSchema | MerchantDetailsSchema | SubAdminDetailsSchema | SuperAdminDetailsSchema;

/**
 * 
 * @export
 * @interface GetStoreListForAdminSchema
 */
export interface GetStoreListForAdminSchema {
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'nameEnglish'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'nameArabic'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'merchantName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'merchantEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'restaurantCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'addedBy'?: GetStoreListForAdminSchemaAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListForAdminSchema
     */
    'status'?: GetStoreListForAdminSchemaStatusEnum;
    /**
     * 
     * @type {WritableStoreDataSchema}
     * @memberof GetStoreListForAdminSchema
     */
    'restaurantDetails'?: WritableStoreDataSchema;
}

export const GetStoreListForAdminSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type GetStoreListForAdminSchemaAddedByEnum = typeof GetStoreListForAdminSchemaAddedByEnum[keyof typeof GetStoreListForAdminSchemaAddedByEnum];
export const GetStoreListForAdminSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type GetStoreListForAdminSchemaStatusEnum = typeof GetStoreListForAdminSchemaStatusEnum[keyof typeof GetStoreListForAdminSchemaStatusEnum];

/**
 * 
 * @export
 * @interface GetStoreListResponseSchema
 */
export interface GetStoreListResponseSchema {
    /**
     * 
     * @type {Array<GetStoreListSchema>}
     * @memberof GetStoreListResponseSchema
     */
    'data'?: Array<GetStoreListSchema>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetStoreListResponseSchema
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetStoreListSchema
 */
export interface GetStoreListSchema {
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'nameEnglish': string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'nameArabic': string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'merchantEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'restaurantCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'addedBy': GetStoreListSchemaAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof GetStoreListSchema
     */
    'status': GetStoreListSchemaStatusEnum;
    /**
     * 
     * @type {WritableStoreDataSchema}
     * @memberof GetStoreListSchema
     */
    'restaurantDetails': WritableStoreDataSchema;
}

export const GetStoreListSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type GetStoreListSchemaAddedByEnum = typeof GetStoreListSchemaAddedByEnum[keyof typeof GetStoreListSchemaAddedByEnum];
export const GetStoreListSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type GetStoreListSchemaStatusEnum = typeof GetStoreListSchemaStatusEnum[keyof typeof GetStoreListSchemaStatusEnum];

/**
 * 
 * @export
 * @interface GetSubItemCategories200Response
 */
export interface GetSubItemCategories200Response {
    /**
     * 
     * @type {Array<GetItemSubCategoriesResponse>}
     * @memberof GetSubItemCategories200Response
     */
    'data'?: Array<GetItemSubCategoriesResponse>;
    /**
     * 
     * @type {GetSubItemCategories200ResponsePagination}
     * @memberof GetSubItemCategories200Response
     */
    'pagination'?: GetSubItemCategories200ResponsePagination;
}
/**
 * 
 * @export
 * @interface GetSubItemCategories200ResponsePagination
 */
export interface GetSubItemCategories200ResponsePagination {
    /**
     * 
     * @type {number}
     * @memberof GetSubItemCategories200ResponsePagination
     */
    'totalItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubItemCategories200ResponsePagination
     */
    'totalPages'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubItemCategories200ResponsePagination
     */
    'currentPage'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubItemCategories200ResponsePagination
     */
    'limit'?: number;
}
/**
 * 
 * @export
 * @interface GetUserCart200Response
 */
export interface GetUserCart200Response {
    /**
     * 
     * @type {Array<GetUserCartResponseSchema>}
     * @memberof GetUserCart200Response
     */
    'cart'?: Array<GetUserCartResponseSchema>;
}
/**
 * 
 * @export
 * @interface GetUserCartResponseSchema
 */
export interface GetUserCartResponseSchema {
    /**
     * Expected delivery or pickup time
     * @type {string}
     * @memberof GetUserCartResponseSchema
     */
    'preorderDateTime'?: string | null;
    /**
     * Order mode - normal or pre-order
     * @type {string}
     * @memberof GetUserCartResponseSchema
     */
    'orderMode'?: GetUserCartResponseSchemaOrderModeEnum;
    /**
     * 
     * @type {CartPrice}
     * @memberof GetUserCartResponseSchema
     */
    'cartPrice': CartPrice;
    /**
     * ID of the applied coupon, if any
     * @type {string}
     * @memberof GetUserCartResponseSchema
     */
    'couponId'?: string | null;
    /**
     * Code of the applied coupon, if any
     * @type {string}
     * @memberof GetUserCartResponseSchema
     */
    'couponCode'?: string | null;
    /**
     * Discount amount from the applied coupon, if any
     * @type {number}
     * @memberof GetUserCartResponseSchema
     */
    'couponDiscount'?: number | null;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof GetUserCartResponseSchema
     */
    'noteToDriver'?: string | null;
    /**
     * Prescription URL for pharmacy items (cart-level, applies to entire order)
     * @type {string}
     * @memberof GetUserCartResponseSchema
     */
    'prescriptionUrl'?: string | null;
    /**
     * List of stores with their respective cart items
     * @type {Array<GroupedStoreCart>}
     * @memberof GetUserCartResponseSchema
     */
    'stores': Array<GroupedStoreCart>;
}

export const GetUserCartResponseSchemaOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type GetUserCartResponseSchemaOrderModeEnum = typeof GetUserCartResponseSchemaOrderModeEnum[keyof typeof GetUserCartResponseSchemaOrderModeEnum];

/**
 * 
 * @export
 * @interface GetUserWishListResponseSchema
 */
export interface GetUserWishListResponseSchema {
    /**
     * Type of store used for filtering
     * @type {string}
     * @memberof GetUserWishListResponseSchema
     */
    'storeType': GetUserWishListResponseSchemaStoreTypeEnum;
    /**
     * List of wishlisted stores
     * @type {Array<GetUserWishListResponseSchemaStoreWishListInner>}
     * @memberof GetUserWishListResponseSchema
     */
    'storeWishList': Array<GetUserWishListResponseSchemaStoreWishListInner>;
    /**
     * List of wishlisted items
     * @type {Array<GetUserWishListResponseSchemaItemWishListInner>}
     * @memberof GetUserWishListResponseSchema
     */
    'itemWishList': Array<GetUserWishListResponseSchemaItemWishListInner>;
}

export const GetUserWishListResponseSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore',
    All: 'All'
} as const;

export type GetUserWishListResponseSchemaStoreTypeEnum = typeof GetUserWishListResponseSchemaStoreTypeEnum[keyof typeof GetUserWishListResponseSchemaStoreTypeEnum];

/**
 * 
 * @export
 * @interface GetUserWishListResponseSchemaItemWishListInner
 */
export interface GetUserWishListResponseSchemaItemWishListInner {
    /**
     * ID of the store this item belongs to
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'storeId': string;
    /**
     * Name of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'storeName': string;
    /**
     * Type of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'storeType': GetUserWishListResponseSchemaItemWishListInnerStoreTypeEnum;
    /**
     * Unique identifier of the item
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'itemId': string;
    /**
     * Name of the item
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'itemName': string;
    /**
     * Description of the item
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'itemDescription': string;
    /**
     * Whether the item is currently available
     * @type {boolean}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'isItemAvailableNow': boolean;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'currencyCode': CurrencyCode;
    /**
     * Original price of the item
     * @type {number}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'originalPrice': number;
    /**
     * Discounted price of the item
     * @type {number}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'discountPrice': number;
    /**
     * URL of the item\'s image
     * @type {string}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'itemImageUrl': string;
    /**
     * Choice groups associated with the item
     * @type {Array<StoreItemChoiceGroup>}
     * @memberof GetUserWishListResponseSchemaItemWishListInner
     */
    'choiceGroups': Array<StoreItemChoiceGroup>;
}

export const GetUserWishListResponseSchemaItemWishListInnerStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type GetUserWishListResponseSchemaItemWishListInnerStoreTypeEnum = typeof GetUserWishListResponseSchemaItemWishListInnerStoreTypeEnum[keyof typeof GetUserWishListResponseSchemaItemWishListInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface GetUserWishListResponseSchemaStoreWishListInner
 */
export interface GetUserWishListResponseSchemaStoreWishListInner {
    /**
     * Unique identifier of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storeId': string;
    /**
     * Name of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storeName': string;
    /**
     * Type of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storeType': GetUserWishListResponseSchemaStoreWishListInnerStoreTypeEnum;
    /**
     * Description of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'aboutStore': string;
    /**
     * Address of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storeAddress': string;
    /**
     * Phone number of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storePhoneNumber': string;
    /**
     * Image URL of the store
     * @type {string}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storeLogo': string;
    /**
     * List of image URLs of the store\'s banner
     * @type {Array<string>}
     * @memberof GetUserWishListResponseSchemaStoreWishListInner
     */
    'storeBanner': Array<string>;
}

export const GetUserWishListResponseSchemaStoreWishListInnerStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type GetUserWishListResponseSchemaStoreWishListInnerStoreTypeEnum = typeof GetUserWishListResponseSchemaStoreWishListInnerStoreTypeEnum[keyof typeof GetUserWishListResponseSchemaStoreWishListInnerStoreTypeEnum];

/**
 * Returns user\'s current wallet balance and recent transactions
 * @export
 * @interface GetWalletDetailsResponse
 */
export interface GetWalletDetailsResponse {
    /**
     * The unique identifier for the wallet
     * @type {string}
     * @memberof GetWalletDetailsResponse
     */
    'walletId': string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GetWalletDetailsResponse
     */
    'currencyCode': CurrencyCode;
    /**
     * The current balance in the user\'s wallet
     * @type {number}
     * @memberof GetWalletDetailsResponse
     */
    'walletBalance': number;
    /**
     * A list of recent transactions associated with the wallet
     * @type {Array<WalletTransaction>}
     * @memberof GetWalletDetailsResponse
     */
    'walletTransactions': Array<WalletTransaction>;
}


/**
 * 
 * @export
 * @interface GoogleMapsSettings
 */
export interface GoogleMapsSettings {
    /**
     * Whether map should be shown on the order tracking page
     * @type {boolean}
     * @memberof GoogleMapsSettings
     */
    'isEnabled': boolean;
    /**
     * Google Maps API key with HTTP restriction
     * @type {string}
     * @memberof GoogleMapsSettings
     */
    'apiKeyHttpRestricted'?: string;
    /**
     * Google Maps API key with IP restriction
     * @type {string}
     * @memberof GoogleMapsSettings
     */
    'apiKeyIpRestricted'?: string;
    /**
     * Google Maps API key with no IP or HTTP restriction
     * @type {string}
     * @memberof GoogleMapsSettings
     */
    'apiKeyUnrestricted'?: string;
}
/**
 * 
 * @export
 * @interface GroceryStore
 */
export interface GroceryStore {
    /**
     * The ID of the store
     * @type {string}
     * @memberof GroceryStore
     */
    'id'?: string;
    /**
     * The merchant ID (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'merchantId': string;
    /**
     * The category IDs of the store
     * @type {Array<string>}
     * @memberof GroceryStore
     */
    'categoryId'?: Array<string>;
    /**
     * The name of the store (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'storeName': string;
    /**
     * The Arabic name of the store
     * @type {string}
     * @memberof GroceryStore
     */
    'storeNameArabic'?: string;
    /**
     * 
     * @type {MinOrderAmountSchema}
     * @memberof GroceryStore
     */
    'minOrderAmount': MinOrderAmountSchema;
    /**
     * Whether the store allows pre-ordering (mandatory)
     * @type {boolean}
     * @memberof GroceryStore
     */
    'canPreOrder': boolean;
    /**
     * Whether the store offers self-pickup (optional, default is false)
     * @type {boolean}
     * @memberof GroceryStore
     */
    'hasSelfPickup': boolean;
    /**
     * Whether delivery is available (optional, default is true)
     * @type {boolean}
     * @memberof GroceryStore
     */
    'deliveryAvailable': boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaDeliveryFee}
     * @memberof GroceryStore
     */
    'deliveryFee': WritableRestaurantDataSchemaDeliveryFee;
    /**
     * 
     * @type {TimeDataSchema}
     * @memberof GroceryStore
     */
    'deliveryTime': TimeDataSchema;
    /**
     * Description of the store in English (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'aboutStore': string;
    /**
     * Description of the store in Arabic (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'aboutStoreArabic'?: string;
    /**
     * Delivery radius in kilometers (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'deliveryRadiusKM': string;
    /**
     * Store phone number (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'storePhoneNumber': string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof GroceryStore
     */
    'storeAddress': RestaurantAddressSchema;
    /**
     * URL of the store logo (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'storeLogo': string;
    /**
     * URLs of the store banners (mandatory)
     * @type {Array<string>}
     * @memberof GroceryStore
     */
    'storeBanner': Array<string>;
    /**
     * 
     * @type {WorkingHoursSchema}
     * @memberof GroceryStore
     */
    'workingHours': WorkingHoursSchema;
    /**
     * Whether cancellation is allowed (optional, default is true)
     * @type {boolean}
     * @memberof GroceryStore
     */
    'isCancellationAllowed'?: boolean;
    /**
     * Cancellation policy of the store (optional, default is \"No cancellation\")
     * @type {string}
     * @memberof GroceryStore
     */
    'cancellationPolicy'?: string;
    /**
     * Cancellation fee (optional, default is \"0\")
     * @type {string}
     * @memberof GroceryStore
     */
    'cancellationFee'?: string;
    /**
     * Whether the store is wishlisted (optional, default is false)
     * @type {boolean}
     * @memberof GroceryStore
     */
    'isWishListed'?: boolean;
    /**
     * Rating of the store (optional, default is 0)
     * @type {number}
     * @memberof GroceryStore
     */
    'rating'?: number;
    /**
     * Type of store (mandatory)
     * @type {string}
     * @memberof GroceryStore
     */
    'storeType': GroceryStoreStoreTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GroceryStore
     */
    'additionalPackagingRequest': boolean;
}

export const GroceryStoreStoreTypeEnum = {
    GroceryStore: 'GroceryStore'
} as const;

export type GroceryStoreStoreTypeEnum = typeof GroceryStoreStoreTypeEnum[keyof typeof GroceryStoreStoreTypeEnum];

/**
 * 
 * @export
 * @interface GroupedStoreCart
 */
export interface GroupedStoreCart {
    /**
     * 
     * @type {string}
     * @memberof GroupedStoreCart
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof GroupedStoreCart
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof GroupedStoreCart
     */
    'storeType'?: GroupedStoreCartStoreTypeEnum;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof GroupedStoreCart
     */
    'currencyCode'?: CurrencyCode;
    /**
     * Whether the store supports self-pickup mode
     * @type {boolean}
     * @memberof GroupedStoreCart
     */
    'isSelfPickup'?: boolean;
    /**
     * Whether the store supports delivery mode
     * @type {boolean}
     * @memberof GroupedStoreCart
     */
    'isDelivery'?: boolean;
    /**
     * Whether the store supports pre-order mode
     * @type {boolean}
     * @memberof GroupedStoreCart
     */
    'isPreOrder'?: boolean;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof GroupedStoreCart
     */
    'cartItems': Array<CartItem>;
}

export const GroupedStoreCartStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type GroupedStoreCartStoreTypeEnum = typeof GroupedStoreCartStoreTypeEnum[keyof typeof GroupedStoreCartStoreTypeEnum];

/**
 * 
 * @export
 * @interface HomePageContentResponse
 */
export interface HomePageContentResponse {
    /**
     * List of restaurants available on the home page
     * @type {Array<RestaurantSchema>}
     * @memberof HomePageContentResponse
     */
    'restaurants': Array<RestaurantSchema>;
    /**
     * Dynamic content for the home page
     * @type {Array<DynamicHomeContentSchema>}
     * @memberof HomePageContentResponse
     */
    'dynamicContent': Array<DynamicHomeContentSchema>;
    /**
     * List of featured restaurants
     * @type {Array<RestaurantSchema>}
     * @memberof HomePageContentResponse
     */
    'featuredRestaurants': Array<RestaurantSchema>;
}
/**
 * 
 * @export
 * @interface HomePageResponseSchema
 */
export interface HomePageResponseSchema {
    /**
     * 
     * @type {CustomerDetailsSchema}
     * @memberof HomePageResponseSchema
     */
    'userDetails'?: CustomerDetailsSchema;
    /**
     * List of available store types with their icons
     * @type {Array<HomePageResponseSchemaAvailableStoreTypesInner>}
     * @memberof HomePageResponseSchema
     */
    'availableStoreTypes'?: Array<HomePageResponseSchemaAvailableStoreTypesInner>;
    /**
     * Type of store (mandatory)
     * @type {string}
     * @memberof HomePageResponseSchema
     */
    'storeType'?: HomePageResponseSchemaStoreTypeEnum;
    /**
     * 
     * @type {Array<HomePageResponseSchemaBannersInner>}
     * @memberof HomePageResponseSchema
     */
    'banners'?: Array<HomePageResponseSchemaBannersInner>;
    /**
     * 
     * @type {HomePageResponseSchemaFilters}
     * @memberof HomePageResponseSchema
     */
    'filters'?: HomePageResponseSchemaFilters;
    /**
     * List of store categories nearer to a user
     * @type {Array<RestaurantCategory>}
     * @memberof HomePageResponseSchema
     */
    'storeCategories'?: Array<RestaurantCategory>;
    /**
     * 
     * @type {Array<WritableStoreDataSchema>}
     * @memberof HomePageResponseSchema
     */
    'nearestStores'?: Array<WritableStoreDataSchema>;
    /**
     * 
     * @type {Array<WritableStoreDataSchema>}
     * @memberof HomePageResponseSchema
     */
    'exploreStores'?: Array<WritableStoreDataSchema>;
    /**
     * 
     * @type {Array<WritableStoreDataSchema>}
     * @memberof HomePageResponseSchema
     */
    'featuredStores'?: Array<WritableStoreDataSchema>;
    /**
     * List of items or stores based on the search term or filters applied
     * @type {Array<HomePageResponseSchemaSearchResultsInner>}
     * @memberof HomePageResponseSchema
     */
    'searchResults'?: Array<HomePageResponseSchemaSearchResultsInner>;
}

export const HomePageResponseSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type HomePageResponseSchemaStoreTypeEnum = typeof HomePageResponseSchemaStoreTypeEnum[keyof typeof HomePageResponseSchemaStoreTypeEnum];

/**
 * 
 * @export
 * @interface HomePageResponseSchemaAvailableStoreTypesInner
 */
export interface HomePageResponseSchemaAvailableStoreTypesInner {
    /**
     * Store type
     * @type {string}
     * @memberof HomePageResponseSchemaAvailableStoreTypesInner
     */
    'type'?: HomePageResponseSchemaAvailableStoreTypesInnerTypeEnum;
    /**
     * URL of the icon representing the store type
     * @type {string}
     * @memberof HomePageResponseSchemaAvailableStoreTypesInner
     */
    'iconUrl'?: string;
}

export const HomePageResponseSchemaAvailableStoreTypesInnerTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type HomePageResponseSchemaAvailableStoreTypesInnerTypeEnum = typeof HomePageResponseSchemaAvailableStoreTypesInnerTypeEnum[keyof typeof HomePageResponseSchemaAvailableStoreTypesInnerTypeEnum];

/**
 * 
 * @export
 * @interface HomePageResponseSchemaBannersInner
 */
export interface HomePageResponseSchemaBannersInner {
    /**
     * URL of the banner image
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'imageUrl'?: string;
    /**
     * Text displayed on the banner image
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'imageText'?: string;
    /**
     * Text displayed on the banner image
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'imageTextArabic'?: string;
    /**
     * URL to redirect when the banner is clicked
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'redirectUrl'?: string;
    /**
     * Text for the button on the banner
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'buttonText'?: string;
    /**
     * Start time for the banner display
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'bannerStartTime'?: string;
    /**
     * End time for the banner display
     * @type {string}
     * @memberof HomePageResponseSchemaBannersInner
     */
    'bannerEndTime'?: string;
}
/**
 * 
 * @export
 * @interface HomePageResponseSchemaFilters
 */
export interface HomePageResponseSchemaFilters {
    /**
     * Type of sort options
     * @type {Array<string>}
     * @memberof HomePageResponseSchemaFilters
     */
    'sortByOptions'?: Array<HomePageResponseSchemaFiltersSortByOptionsEnum>;
    /**
     * List of available filter options
     * @type {Array<string>}
     * @memberof HomePageResponseSchemaFilters
     */
    'offers'?: Array<HomePageResponseSchemaFiltersOffersEnum>;
    /**
     * List of store categories nearer to a user
     * @type {Array<RestaurantCategory>}
     * @memberof HomePageResponseSchemaFilters
     */
    'cuisines'?: Array<RestaurantCategory>;
}

export const HomePageResponseSchemaFiltersSortByOptionsEnum = {
    FastDelivery: 'FastDelivery',
    Distance: 'Distance',
    RatingHighToLow: 'RatingHighToLow'
} as const;

export type HomePageResponseSchemaFiltersSortByOptionsEnum = typeof HomePageResponseSchemaFiltersSortByOptionsEnum[keyof typeof HomePageResponseSchemaFiltersSortByOptionsEnum];
export const HomePageResponseSchemaFiltersOffersEnum = {
    FreeDelivery: 'FreeDelivery',
    Deal: 'Deal',
    Vouchers: 'Vouchers'
} as const;

export type HomePageResponseSchemaFiltersOffersEnum = typeof HomePageResponseSchemaFiltersOffersEnum[keyof typeof HomePageResponseSchemaFiltersOffersEnum];

/**
 * 
 * @export
 * @interface HomePageResponseSchemaSearchResultsInner
 */
export interface HomePageResponseSchemaSearchResultsInner {
    /**
     * Unique identifier for the item or store
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'itemId'?: string;
    /**
     * Name of the item found in the search
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'itemName'?: string;
    /**
     * Type of item found in the search
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'type'?: HomePageResponseSchemaSearchResultsInnerTypeEnum;
    /**
     * Unique identifier for the store where the item is found
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'storeId'?: string;
    /**
     * Name of the store where the item is found
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'storeName'?: string;
    /**
     * Type of store where the item is found
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'storeType'?: HomePageResponseSchemaSearchResultsInnerStoreTypeEnum;
    /**
     * URL of the icon representing the item or store
     * @type {string}
     * @memberof HomePageResponseSchemaSearchResultsInner
     */
    'iconUrl'?: string;
}

export const HomePageResponseSchemaSearchResultsInnerTypeEnum = {
    Store: 'Store',
    Item: 'Item'
} as const;

export type HomePageResponseSchemaSearchResultsInnerTypeEnum = typeof HomePageResponseSchemaSearchResultsInnerTypeEnum[keyof typeof HomePageResponseSchemaSearchResultsInnerTypeEnum];
export const HomePageResponseSchemaSearchResultsInnerStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type HomePageResponseSchemaSearchResultsInnerStoreTypeEnum = typeof HomePageResponseSchemaSearchResultsInnerStoreTypeEnum[keyof typeof HomePageResponseSchemaSearchResultsInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface ImageSettings
 */
export interface ImageSettings {
    /**
     * Login page image URL (465x335 to 475x345 pixels)
     * @type {string}
     * @memberof ImageSettings
     */
    'loginImage'?: string;
    /**
     * Featured restaurant image URL (must be 660x380 pixels)
     * @type {string}
     * @memberof ImageSettings
     */
    'featuredRestaurantImage'?: string;
}
/**
 * 
 * @export
 * @interface InitiateSettlementPaymentRequest
 */
export interface InitiateSettlementPaymentRequest {
    /**
     * ID of the user making the payment (fromUserId)
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'userId': string;
    /**
     * Array of settlement IDs to pay
     * @type {Array<string>}
     * @memberof InitiateSettlementPaymentRequest
     */
    'settlementIds': Array<string>;
    /**
     * Payment mode - ONLINE (gateway), MANUAL (external payment), or WALLET (customer refunds only)
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'paymentMode': InitiateSettlementPaymentRequestPaymentModeEnum;
    /**
     * Optional - Override the calculated total amount. If not provided, total will be calculated from settlements. Useful when paying partial amounts.
     * @type {number}
     * @memberof InitiateSettlementPaymentRequest
     */
    'amount'?: number;
    /**
     * Optional - Payment notes or comments for reference
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'remarks'?: string;
    /**
     * Platform type for ONLINE mode (web returns checkout URL, mobile returns clientSecret)
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'platform'?: InitiateSettlementPaymentRequestPlatformEnum;
    /**
     * For ONLINE mode - explicitly select payment gateway (auto-selected based on currency if not provided)
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'paymentGateway'?: InitiateSettlementPaymentRequestPaymentGatewayEnum;
    /**
     * Required for MANUAL mode - external transaction reference ID
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'transactionId'?: string;
    /**
     * Optional for MANUAL mode - URL to uploaded payment proof (invoice/screenshot)
     * @type {string}
     * @memberof InitiateSettlementPaymentRequest
     */
    'paymentProof'?: string;
}

export const InitiateSettlementPaymentRequestPaymentModeEnum = {
    Online: 'ONLINE',
    Manual: 'MANUAL',
    Wallet: 'WALLET'
} as const;

export type InitiateSettlementPaymentRequestPaymentModeEnum = typeof InitiateSettlementPaymentRequestPaymentModeEnum[keyof typeof InitiateSettlementPaymentRequestPaymentModeEnum];
export const InitiateSettlementPaymentRequestPlatformEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;

export type InitiateSettlementPaymentRequestPlatformEnum = typeof InitiateSettlementPaymentRequestPlatformEnum[keyof typeof InitiateSettlementPaymentRequestPlatformEnum];
export const InitiateSettlementPaymentRequestPaymentGatewayEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type InitiateSettlementPaymentRequestPaymentGatewayEnum = typeof InitiateSettlementPaymentRequestPaymentGatewayEnum[keyof typeof InitiateSettlementPaymentRequestPaymentGatewayEnum];

/**
 * @type InitiateSettlementPaymentResponse
 * @export
 */
export type InitiateSettlementPaymentResponse = { paymentMode: 'MANUAL' } & ManualSettlementPaymentResponse | { paymentMode: 'ONLINE' } & OnlineSettlementPaymentResponse | { paymentMode: 'WALLET' } & WalletSettlementPaymentResponse;

/**
 * Permission settings for inventory/stock management
 * @export
 * @interface InventoryPermission
 */
export interface InventoryPermission {
    /**
     * Can view inventory
     * @type {boolean}
     * @memberof InventoryPermission
     */
    'view'?: boolean;
    /**
     * Can add stock quantity
     * @type {boolean}
     * @memberof InventoryPermission
     */
    'add'?: boolean;
    /**
     * Can export inventory data
     * @type {boolean}
     * @memberof InventoryPermission
     */
    'export'?: boolean;
}
/**
 * 
 * @export
 * @interface InvoiceDetails
 */
export interface InvoiceDetails {
    /**
     * 
     * @type {InvoiceDetailsBillingTo}
     * @memberof InvoiceDetails
     */
    'billingTo'?: InvoiceDetailsBillingTo;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'tax'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'deliveryFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'walletUsed'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'offerDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'cancelledTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetails
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetails
     */
    'paymentMethod'?: string;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof InvoiceDetails
     */
    'items'?: Array<OrderItem>;
}
/**
 * 
 * @export
 * @interface InvoiceDetailsBillingTo
 */
export interface InvoiceDetailsBillingTo {
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetailsBillingTo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetailsBillingTo
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetailsBillingTo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetailsBillingTo
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceDetailsNew
 */
export interface InvoiceDetailsNew {
    /**
     * 
     * @type {ShippingAddressNew}
     * @memberof InvoiceDetailsNew
     */
    'shippingAddress'?: ShippingAddressNew;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'subTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'tax'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'deliveryFee'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'walletUsed'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'couponDiscount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'total'?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDetailsNew
     */
    'paymentMethod'?: InvoiceDetailsNewPaymentMethodEnum;
    /**
     * Remaining amount to pay on delivery (for walletAndCashOnDelivery)
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'remainingAmountToPay'?: number;
    /**
     * Amount to collect from customer (for delivery partners)
     * @type {number}
     * @memberof InvoiceDetailsNew
     */
    'amountToCollect'?: number;
}

export const InvoiceDetailsNewPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type InvoiceDetailsNewPaymentMethodEnum = typeof InvoiceDetailsNewPaymentMethodEnum[keyof typeof InvoiceDetailsNewPaymentMethodEnum];

/**
 * 
 * @export
 * @interface ItemChoice
 */
export interface ItemChoice {
    /**
     * Choice identifier
     * @type {string}
     * @memberof ItemChoice
     */
    'choiceId': string;
    /**
     * Choice name in multiple languages
     * @type {string}
     * @memberof ItemChoice
     */
    'choiceName': string;
    /**
     * Additional price for this choice
     * @type {number}
     * @memberof ItemChoice
     */
    'choicePrice': number;
}
/**
 * 
 * @export
 * @interface ItemChoiceNew
 */
export interface ItemChoiceNew {
    /**
     * 
     * @type {string}
     * @memberof ItemChoiceNew
     */
    'choiceId': string;
    /**
     * 
     * @type {string}
     * @memberof ItemChoiceNew
     */
    'choiceName': string;
    /**
     * 
     * @type {number}
     * @memberof ItemChoiceNew
     */
    'choicePrice': number;
}
/**
 * 
 * @export
 * @interface ItemRating
 */
export interface ItemRating {
    /**
     * Unique identifier for the food item
     * @type {string}
     * @memberof ItemRating
     */
    'itemId': string;
    /**
     * Rating given to this item (1-5, no text comments)
     * @type {number}
     * @memberof ItemRating
     */
    'rating': number;
}
/**
 * 
 * @export
 * @interface ItemReview
 */
export interface ItemReview {
    /**
     * Type of review, must be \'Item\'
     * @type {string}
     * @memberof ItemReview
     */
    'type'?: ItemReviewTypeEnum;
    /**
     * Unique identifier for the store review
     * @type {string}
     * @memberof ItemReview
     */
    'reviewId'?: string;
    /**
     * Unique identifier for the item being reviewed
     * @type {string}
     * @memberof ItemReview
     */
    'itemId'?: string;
    /**
     * Name of the item being reviewed
     * @type {string}
     * @memberof ItemReview
     */
    'itemName'?: string;
    /**
     * Unique code for the item being reviewed
     * @type {string}
     * @memberof ItemReview
     */
    'itemCode'?: string;
    /**
     * Unique identifier for the store where the item is available
     * @type {string}
     * @memberof ItemReview
     */
    'storeId'?: string;
    /**
     * Name of the store where the item is available
     * @type {string}
     * @memberof ItemReview
     */
    'storeName'?: string;
    /**
     * Name of the customer providing the review
     * @type {string}
     * @memberof ItemReview
     */
    'customerName'?: string;
    /**
     * Unique identifier for the customer providing the review
     * @type {string}
     * @memberof ItemReview
     */
    'customerId'?: string;
    /**
     * Email address of the customer providing the review
     * @type {string}
     * @memberof ItemReview
     */
    'customerEmail'?: string;
    /**
     * Indicates whether the review is approved or not
     * @type {boolean}
     * @memberof ItemReview
     */
    'reviewApprovalStatus'?: boolean;
    /**
     * Review text for the store
     * @type {string}
     * @memberof ItemReview
     */
    'comment'?: string;
    /**
     * Overall rating (1-5) for the store
     * @type {number}
     * @memberof ItemReview
     */
    'rating'?: number;
}

export const ItemReviewTypeEnum = {
    Item: 'Item'
} as const;

export type ItemReviewTypeEnum = typeof ItemReviewTypeEnum[keyof typeof ItemReviewTypeEnum];

/**
 * Complete review data for an item
 * @export
 * @interface ItemReviewDataSchema
 */
export interface ItemReviewDataSchema {
    /**
     * 
     * @type {ReviewSummarySchema}
     * @memberof ItemReviewDataSchema
     */
    'reviewSummary'?: ReviewSummarySchema;
    /**
     * List of recent approved reviews (max 10)
     * @type {Array<UserReviewSchema>}
     * @memberof ItemReviewDataSchema
     */
    'recentReviews'?: Array<UserReviewSchema>;
}
/**
 * 
 * @export
 * @interface ItemStatusPieChartItem
 */
export interface ItemStatusPieChartItem {
    /**
     * Store operating status value (Open, Closed).
     * @type {string}
     * @memberof ItemStatusPieChartItem
     */
    'status': string;
    /**
     * Number of stores for each status.
     * @type {number}
     * @memberof ItemStatusPieChartItem
     */
    'count': number;
    /**
     * Percentage of stores for each status.
     * @type {number}
     * @memberof ItemStatusPieChartItem
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface ItemStockSchema
 */
export interface ItemStockSchema {
    /**
     * The unique identifier for the item (optional)
     * @type {string}
     * @memberof ItemStockSchema
     */
    'itemId': string;
    /**
     * The name of the item (optional)
     * @type {string}
     * @memberof ItemStockSchema
     */
    'itemName'?: string;
    /**
     * The unique code for the item (optional)
     * @type {string}
     * @memberof ItemStockSchema
     */
    'productCode': string;
    /**
     * The name of the restaurant (optional)
     * @type {string}
     * @memberof ItemStockSchema
     */
    'restaurantName': string;
    /**
     * The name of the merchant (optional)
     * @type {string}
     * @memberof ItemStockSchema
     */
    'merchantName': string;
    /**
     * The quantity of the item in stock
     * @type {number}
     * @memberof ItemStockSchema
     */
    'quantity': number;
    /**
     * The quantity of the item sold
     * @type {number}
     * @memberof ItemStockSchema
     */
    'soldQuantity': number;
}
/**
 * 
 * @export
 * @interface LocationPoint
 */
export interface LocationPoint {
    /**
     * Latitude in decimal degrees
     * @type {number}
     * @memberof LocationPoint
     */
    'lat': number;
    /**
     * Longitude in decimal degrees
     * @type {number}
     * @memberof LocationPoint
     */
    'lng': number;
    /**
     * Human-readable address
     * @type {string}
     * @memberof LocationPoint
     */
    'address'?: string;
    /**
     * When this location was last updated
     * @type {string}
     * @memberof LocationPoint
     */
    'lastUpdated'?: string;
}
/**
 * @type LoginRequestWrapper
 * @export
 */
export type LoginRequestWrapper = { loginType: 'social' } & SocialLoginRequestSchema | { loginType: 'traditionalEmail' } & ManualLoginWithEmail | { loginType: 'traditionalPhone' } & ManualLoginWithPhone;

/**
 * 
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
    /**
     * The auth token for the user
     * @type {string}
     * @memberof LoginResponse
     */
    'token': string;
    /**
     * The unique identifier for the user
     * @type {string}
     * @memberof LoginResponse
     */
    'userId': string;
    /**
     * The type of user (e.g., SuperAdmin, SubAdmin, Merchant)
     * @type {string}
     * @memberof LoginResponse
     */
    'userType': LoginResponseUserTypeEnum;
}

export const LoginResponseUserTypeEnum = {
    SuperAdmin: 'superAdmin',
    SubAdmin: 'subAdmin',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner',
    Customer: 'customer'
} as const;

export type LoginResponseUserTypeEnum = typeof LoginResponseUserTypeEnum[keyof typeof LoginResponseUserTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const LoginTypeEnum = {
    Traditional: 'traditional'
} as const;

export type LoginTypeEnum = typeof LoginTypeEnum[keyof typeof LoginTypeEnum];


/**
 * @type LoginUserRequest
 * @export
 */
export type LoginUserRequest = ManualLoginWithEmail | ManualLoginWithPhone | SocialLoginRequestSchema;

/**
 * 
 * @export
 * @interface LoyaltyProgramSettings
 */
export interface LoyaltyProgramSettings {
    /**
     * 
     * @type {LoyaltyRewardsStatus}
     * @memberof LoyaltyProgramSettings
     */
    'loyaltyRewardsStatus'?: LoyaltyRewardsStatus;
}
/**
 * 
 * @export
 * @interface LoyaltyRewardsStatus
 */
export interface LoyaltyRewardsStatus {
    /**
     * Enable/disable loyalty rewards system
     * @type {boolean}
     * @memberof LoyaltyRewardsStatus
     */
    'status'?: boolean;
    /**
     * Minimum target points for loyalty program
     * @type {number}
     * @memberof LoyaltyRewardsStatus
     */
    'minimumTargetPoints'?: number;
    /**
     * Currency to points conversion ratio - points earned per unit of currency spent (e.g., 0.5 means 0.5 points per 1 JOD)
     * @type {number}
     * @memberof LoyaltyRewardsStatus
     */
    'currencyToPointsRatio'?: number;
    /**
     * Value of each point when redeemed (e.g., 0.01)
     * @type {number}
     * @memberof LoyaltyRewardsStatus
     */
    'redeemPointValue'?: number;
}
/**
 * 
 * @export
 * @interface LoyaltyTransactionSchema
 */
export interface LoyaltyTransactionSchema {
    /**
     * MongoDB ObjectId of the loyalty transaction subdocument
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'transactionId': string;
    /**
     * Points earned or redeemed
     * @type {number}
     * @memberof LoyaltyTransactionSchema
     */
    'points': number;
    /**
     * Type of transaction
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'type': LoyaltyTransactionSchemaTypeEnum;
    /**
     * Description of transaction in requested language
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'description': string;
    /**
     * MongoDB ObjectId reference to Order (only for earned transactions)
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'orderId'?: string;
    /**
     * Human-readable order number (only for earned transactions)
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'orderNumber'?: string;
    /**
     * Order amount for reference (only for earned transactions)
     * @type {number}
     * @memberof LoyaltyTransactionSchema
     */
    'orderAmount'?: number;
    /**
     * Wallet transaction ID (only for redeemed transactions)
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'walletTransactionId'?: string;
    /**
     * Wallet credit amount (only for redeemed transactions)
     * @type {number}
     * @memberof LoyaltyTransactionSchema
     */
    'walletCreditAmount'?: number;
    /**
     * Transaction timestamp
     * @type {string}
     * @memberof LoyaltyTransactionSchema
     */
    'createdAt': string;
}

export const LoyaltyTransactionSchemaTypeEnum = {
    Earned: 'earned',
    Redeemed: 'redeemed'
} as const;

export type LoyaltyTransactionSchemaTypeEnum = typeof LoyaltyTransactionSchemaTypeEnum[keyof typeof LoyaltyTransactionSchemaTypeEnum];

/**
 * @type ManageCouponRequest
 * @export
 */
export type ManageCouponRequest = ApplyCouponRequest | RemoveCouponRequest;

/**
 * 
 * @export
 * @interface ManageCouponResponse
 */
export interface ManageCouponResponse {
    /**
     * Whether the coupon was successfully redeemed
     * @type {boolean}
     * @memberof ManageCouponResponse
     */
    'success': boolean;
    /**
     * Human-readable message confirming redemption
     * @type {string}
     * @memberof ManageCouponResponse
     */
    'message': string;
    /**
     * The total discount applied to the order from this coupon
     * @type {number}
     * @memberof ManageCouponResponse
     */
    'discountApplied'?: number;
    /**
     * 
     * @type {CartPrice}
     * @memberof ManageCouponResponse
     */
    'cartPriceAfterDiscount'?: CartPrice;
}
/**
 * 
 * @export
 * @interface ManualLoginWithEmail
 */
export interface ManualLoginWithEmail {
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithEmail
     */
    'loginType': ManualLoginWithEmailLoginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithEmail
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithEmail
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithEmail
     */
    'platformType': ManualLoginWithEmailPlatformTypeEnum;
}

export const ManualLoginWithEmailLoginTypeEnum = {
    TraditionalEmail: 'traditionalEmail'
} as const;

export type ManualLoginWithEmailLoginTypeEnum = typeof ManualLoginWithEmailLoginTypeEnum[keyof typeof ManualLoginWithEmailLoginTypeEnum];
export const ManualLoginWithEmailPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ManualLoginWithEmailPlatformTypeEnum = typeof ManualLoginWithEmailPlatformTypeEnum[keyof typeof ManualLoginWithEmailPlatformTypeEnum];

/**
 * 
 * @export
 * @interface ManualLoginWithPhone
 */
export interface ManualLoginWithPhone {
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithPhone
     */
    'loginType': ManualLoginWithPhoneLoginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithPhone
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithPhone
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ManualLoginWithPhone
     */
    'platformType': ManualLoginWithPhonePlatformTypeEnum;
}

export const ManualLoginWithPhoneLoginTypeEnum = {
    TraditionalPhone: 'traditionalPhone'
} as const;

export type ManualLoginWithPhoneLoginTypeEnum = typeof ManualLoginWithPhoneLoginTypeEnum[keyof typeof ManualLoginWithPhoneLoginTypeEnum];
export const ManualLoginWithPhonePlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ManualLoginWithPhonePlatformTypeEnum = typeof ManualLoginWithPhonePlatformTypeEnum[keyof typeof ManualLoginWithPhonePlatformTypeEnum];

/**
 * 
 * @export
 * @interface ManualSettlementPaymentResponse
 */
export interface ManualSettlementPaymentResponse {
    /**
     * Payment mode discriminator
     * @type {string}
     * @memberof ManualSettlementPaymentResponse
     */
    'paymentMode': ManualSettlementPaymentResponsePaymentModeEnum;
    /**
     * Whether payment was successful
     * @type {boolean}
     * @memberof ManualSettlementPaymentResponse
     */
    'success'?: boolean;
    /**
     * Success message
     * @type {string}
     * @memberof ManualSettlementPaymentResponse
     */
    'message'?: string;
    /**
     * ID of the settlement payment record
     * @type {string}
     * @memberof ManualSettlementPaymentResponse
     */
    'settlementPaymentId'?: string;
    /**
     * Array of settlement IDs in this payment
     * @type {Array<string>}
     * @memberof ManualSettlementPaymentResponse
     */
    'settlementIds'?: Array<string>;
    /**
     * Total amount paid
     * @type {number}
     * @memberof ManualSettlementPaymentResponse
     */
    'totalAmount'?: number;
}

export const ManualSettlementPaymentResponsePaymentModeEnum = {
    Manual: 'MANUAL'
} as const;

export type ManualSettlementPaymentResponsePaymentModeEnum = typeof ManualSettlementPaymentResponsePaymentModeEnum[keyof typeof ManualSettlementPaymentResponsePaymentModeEnum];

/**
 * 
 * @export
 * @interface ManualSignUpRequestSchema
 */
export interface ManualSignUpRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'signupType': ManualSignUpRequestSchemaSignupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'mobile': string;
    /**
     * 
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'userName': string;
    /**
     * The platform type for which the signup is requested
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'platformType': ManualSignUpRequestSchemaPlatformTypeEnum;
    /**
     * Optional referral code for signup
     * @type {string}
     * @memberof ManualSignUpRequestSchema
     */
    'referralCode'?: string;
}

export const ManualSignUpRequestSchemaSignupTypeEnum = {
    Traditional: 'traditional'
} as const;

export type ManualSignUpRequestSchemaSignupTypeEnum = typeof ManualSignUpRequestSchemaSignupTypeEnum[keyof typeof ManualSignUpRequestSchemaSignupTypeEnum];
export const ManualSignUpRequestSchemaPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ManualSignUpRequestSchemaPlatformTypeEnum = typeof ManualSignUpRequestSchemaPlatformTypeEnum[keyof typeof ManualSignUpRequestSchemaPlatformTypeEnum];

/**
 * 
 * @export
 * @interface MarkNotificationAsReadRequest
 */
export interface MarkNotificationAsReadRequest {
    /**
     * The unique ID of the user to mark as read.
     * @type {string}
     * @memberof MarkNotificationAsReadRequest
     */
    'userId': string;
    /**
     * The type of user making the request (e.g., customer, admin, merchant, deliveryPartner).
     * @type {string}
     * @memberof MarkNotificationAsReadRequest
     */
    'userType': MarkNotificationAsReadRequestUserTypeEnum;
    /**
     * Whether the notification is read or not.
     * @type {boolean}
     * @memberof MarkNotificationAsReadRequest
     */
    'isRead': boolean;
}

export const MarkNotificationAsReadRequestUserTypeEnum = {
    Customer: 'customer',
    Admin: 'admin',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type MarkNotificationAsReadRequestUserTypeEnum = typeof MarkNotificationAsReadRequestUserTypeEnum[keyof typeof MarkNotificationAsReadRequestUserTypeEnum];

/**
 * The merchant\'s address (optional).
 * @export
 * @interface MerchantAddressSchema
 */
export interface MerchantAddressSchema {
    /**
     * The location of the merchant.
     * @type {string}
     * @memberof MerchantAddressSchema
     */
    'location'?: string;
    /**
     * The country where the merchant is located.
     * @type {string}
     * @memberof MerchantAddressSchema
     */
    'country'?: string;
    /**
     * The state where the merchant is located.
     * @type {string}
     * @memberof MerchantAddressSchema
     */
    'state'?: string;
    /**
     * The city where the merchant is located.
     * @type {string}
     * @memberof MerchantAddressSchema
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface MerchantDashboardResponse
 */
export interface MerchantDashboardResponse {
    /**
     * 
     * @type {string}
     * @memberof MerchantDashboardResponse
     */
    'dashboardType': MerchantDashboardResponseDashboardTypeEnum;
    /**
     * 
     * @type {MetricsCardItem}
     * @memberof MerchantDashboardResponse
     */
    'metricsCards': MetricsCardItem;
    /**
     * Line chart data showing monthly order trends for visualization.
     * @type {Array<OrderTrendsLineChartItem>}
     * @memberof MerchantDashboardResponse
     */
    'orderTrendsLineChart': Array<OrderTrendsLineChartItem>;
    /**
     * Pie chart data for item availability statuses.
     * @type {Array<ItemStatusPieChartItem>}
     * @memberof MerchantDashboardResponse
     */
    'itemStatusPieChart': Array<ItemStatusPieChartItem>;
    /**
     * List of recent orders with summary fields.
     * @type {Array<RecentOrder>}
     * @memberof MerchantDashboardResponse
     */
    'recentOrdersList': Array<RecentOrder>;
}

export const MerchantDashboardResponseDashboardTypeEnum = {
    Merchant: 'merchant'
} as const;

export type MerchantDashboardResponseDashboardTypeEnum = typeof MerchantDashboardResponseDashboardTypeEnum[keyof typeof MerchantDashboardResponseDashboardTypeEnum];

/**
 * 
 * @export
 * @interface MerchantDetailsSchema
 */
export interface MerchantDetailsSchema {
    /**
     * Unique identifier for the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'id': string;
    /**
     * List of store IDs associated with the merchant
     * @type {Array<string>}
     * @memberof MerchantDetailsSchema
     */
    'storeIds': Array<string> | null;
    /**
     * Role of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'role': MerchantDetailsSchemaRoleEnum;
    /**
     * Email address of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'email': string;
    /**
     * Phone number of the merchant (Must be a valid international number)
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'mobileNo': string;
    /**
     * First name of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'firstName': string;
    /**
     * Last name of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'lastName': string;
    /**
     * Type of business the merchant is engaged in
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'businessType': string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof MerchantDetailsSchema
     */
    'currencyCode': CurrencyCode;
    /**
     * 
     * @type {MerchantDetailsSchemaAddress}
     * @memberof MerchantDetailsSchema
     */
    'address': MerchantDetailsSchemaAddress | null;
    /**
     * Commission percentage charged by the platform
     * @type {number}
     * @memberof MerchantDetailsSchema
     */
    'commissionPercentage'?: number;
    /**
     * Indicates if the merchant can cancel orders
     * @type {boolean}
     * @memberof MerchantDetailsSchema
     */
    'cancelStatus'?: boolean;
    /**
     * Cancellation policy of the merchant in English
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'cancellationPolicyEnglish'?: string;
    /**
     * Cancellation policy of the merchant in Arabic
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'cancellationPolicyArabic'?: string;
    /**
     * ID proof of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'idProof'?: string;
    /**
     * Restaurant license of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'restaurantLicense'?: string;
    /**
     * 
     * @type {MerchantSchemaPaymentDetails}
     * @memberof MerchantDetailsSchema
     */
    'paymentDetails'?: MerchantSchemaPaymentDetails;
    /**
     * Indicates if the merchant account is active
     * @type {boolean}
     * @memberof MerchantDetailsSchema
     */
    'isActive': boolean;
    /**
     * Number of unread notifications for the merchant
     * @type {number}
     * @memberof MerchantDetailsSchema
     */
    'notificationsCount': number;
    /**
     * Preferred language of the merchant
     * @type {string}
     * @memberof MerchantDetailsSchema
     */
    'preferredLanguage'?: MerchantDetailsSchemaPreferredLanguageEnum;
}

export const MerchantDetailsSchemaRoleEnum = {
    Merchant: 'merchant'
} as const;

export type MerchantDetailsSchemaRoleEnum = typeof MerchantDetailsSchemaRoleEnum[keyof typeof MerchantDetailsSchemaRoleEnum];
export const MerchantDetailsSchemaPreferredLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;

export type MerchantDetailsSchemaPreferredLanguageEnum = typeof MerchantDetailsSchemaPreferredLanguageEnum[keyof typeof MerchantDetailsSchemaPreferredLanguageEnum];

/**
 * Address details of the merchant
 * @export
 * @interface MerchantDetailsSchemaAddress
 */
export interface MerchantDetailsSchemaAddress {
    /**
     * 
     * @type {string}
     * @memberof MerchantDetailsSchemaAddress
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantDetailsSchemaAddress
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantDetailsSchemaAddress
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof MerchantDetailsSchemaAddress
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface MerchantListSchema
 */
export interface MerchantListSchema {
    /**
     * 
     * @type {Array<MerchantSchema>}
     * @memberof MerchantListSchema
     */
    'data': Array<MerchantSchema>;
    /**
     * 
     * @type {Pagination}
     * @memberof MerchantListSchema
     */
    'pagination': Pagination;
}
/**
 * The merchant\'s net banking details (optional).
 * @export
 * @interface MerchantNetBankingSchema
 */
export interface MerchantNetBankingSchema {
    /**
     * The publish status of the net banking account.
     * @type {string}
     * @memberof MerchantNetBankingSchema
     */
    'publishStatus'?: MerchantNetBankingSchemaPublishStatusEnum;
    /**
     * The name of the bank.
     * @type {string}
     * @memberof MerchantNetBankingSchema
     */
    'bankName'?: string;
    /**
     * The branch name of the bank.
     * @type {string}
     * @memberof MerchantNetBankingSchema
     */
    'branch'?: string;
    /**
     * The bank account number.
     * @type {string}
     * @memberof MerchantNetBankingSchema
     */
    'accountNumber'?: string;
    /**
     * The IFSC code of the bank branch.
     * @type {string}
     * @memberof MerchantNetBankingSchema
     */
    'ifscode'?: string;
}

export const MerchantNetBankingSchemaPublishStatusEnum = {
    Publish: 'publish',
    Unpublish: 'unpublish'
} as const;

export type MerchantNetBankingSchemaPublishStatusEnum = typeof MerchantNetBankingSchemaPublishStatusEnum[keyof typeof MerchantNetBankingSchemaPublishStatusEnum];

/**
 * 
 * @export
 * @interface MerchantOrderDetail
 */
export interface MerchantOrderDetail {
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'deliveryType': MerchantOrderDetailDeliveryTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'currentStatus': MerchantOrderDetailCurrentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof MerchantOrderDetail
     */
    'orderAmount': number;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'paymentStatus': MerchantOrderDetailPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'paymentMethod'?: MerchantOrderDetailPaymentMethodEnum;
    /**
     * 
     * @type {ShippingAddressNew}
     * @memberof MerchantOrderDetail
     */
    'shippingAddress'?: ShippingAddressNew;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level)
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'prescriptionUrl'?: string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'orderMode'?: MerchantOrderDetailOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (calculated as scheduledDeliveryTime minus configured preparation time)
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'processStartTime'?: string;
    /**
     * Indicates whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof MerchantOrderDetail
     */
    'canCancel'?: boolean;
    /**
     * Indicates if the customer has tipped for this order
     * @type {boolean}
     * @memberof MerchantOrderDetail
     */
    'isTipped'?: boolean;
    /**
     * 
     * @type {InvoiceDetailsNew}
     * @memberof MerchantOrderDetail
     */
    'invoiceDetails'?: InvoiceDetailsNew;
    /**
     * 
     * @type {Array<TrackingHistoryItem>}
     * @memberof MerchantOrderDetail
     */
    'trackingHistory'?: Array<TrackingHistoryItem>;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderDetail
     */
    'userType': MerchantOrderDetailUserTypeEnum;
    /**
     * 
     * @type {Array<MerchantOrderItem>}
     * @memberof MerchantOrderDetail
     */
    'orderItems': Array<MerchantOrderItem>;
    /**
     * 
     * @type {CustomerInfo}
     * @memberof MerchantOrderDetail
     */
    'customerInfo': CustomerInfo;
    /**
     * 
     * @type {DeliveryInfo}
     * @memberof MerchantOrderDetail
     */
    'deliveryInfo'?: DeliveryInfo;
    /**
     * 
     * @type {MerchantOrderDetailAllOfMerchantControls}
     * @memberof MerchantOrderDetail
     */
    'merchantControls': MerchantOrderDetailAllOfMerchantControls;
}

export const MerchantOrderDetailDeliveryTypeEnum = {
    Delivery: 'delivery',
    SelfPickup: 'selfPickup'
} as const;

export type MerchantOrderDetailDeliveryTypeEnum = typeof MerchantOrderDetailDeliveryTypeEnum[keyof typeof MerchantOrderDetailDeliveryTypeEnum];
export const MerchantOrderDetailCurrentStatusEnum = {
    PaymentPending: 'Payment Pending',
    OrderPlaced: 'Order Placed',
    PreOrderPendingAcceptance: 'Pre-Order Pending Acceptance',
    PreOrderAccepted: 'Pre-Order Accepted',
    PreOrderDriverAssignment: 'Pre-Order Driver Assignment',
    DeliveryPartnerAssigned: 'Delivery Partner Assigned',
    DeliveryPartnerAccepted: 'Delivery Partner Accepted',
    MerchantAccepted: 'Merchant Accepted',
    MerchantRejected: 'Merchant Rejected',
    OrderPreparing: 'Order Preparing',
    ReadyForPickup: 'Ready for Pickup',
    OrderDispatched: 'Order Dispatched',
    OrderArrived: 'Order Arrived',
    OrderDelivered: 'Order Delivered',
    OrderCancelled: 'Order Cancelled',
    DeliveryFailed: 'Delivery Failed'
} as const;

export type MerchantOrderDetailCurrentStatusEnum = typeof MerchantOrderDetailCurrentStatusEnum[keyof typeof MerchantOrderDetailCurrentStatusEnum];
export const MerchantOrderDetailPaymentStatusEnum = {
    Paid: 'paid',
    Unpaid: 'unpaid',
    Partial: 'partial',
    Failed: 'failed'
} as const;

export type MerchantOrderDetailPaymentStatusEnum = typeof MerchantOrderDetailPaymentStatusEnum[keyof typeof MerchantOrderDetailPaymentStatusEnum];
export const MerchantOrderDetailPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type MerchantOrderDetailPaymentMethodEnum = typeof MerchantOrderDetailPaymentMethodEnum[keyof typeof MerchantOrderDetailPaymentMethodEnum];
export const MerchantOrderDetailOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type MerchantOrderDetailOrderModeEnum = typeof MerchantOrderDetailOrderModeEnum[keyof typeof MerchantOrderDetailOrderModeEnum];
export const MerchantOrderDetailUserTypeEnum = {
    Merchant: 'Merchant'
} as const;

export type MerchantOrderDetailUserTypeEnum = typeof MerchantOrderDetailUserTypeEnum[keyof typeof MerchantOrderDetailUserTypeEnum];

/**
 * Merchant-specific control actions
 * @export
 * @interface MerchantOrderDetailAllOfMerchantControls
 */
export interface MerchantOrderDetailAllOfMerchantControls {
    /**
     * 
     * @type {boolean}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'canAcceptOrder'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'canRejectOrder'?: boolean;
    /**
     * Enable when driver accepted and order not yet in preparing state
     * @type {boolean}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'canPrepareOrder'?: boolean;
    /**
     * Enable after order is in preparing state
     * @type {boolean}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'canMarkReadyForPickup'?: boolean;
    /**
     * Enable for self-pickup orders after items marked ready
     * @type {boolean}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'canMarkDelivered'?: boolean;
    /**
     * Enable for self-pickup orders when customer doesn\'t collect
     * @type {boolean}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'canCancelOrder'?: boolean;
    /**
     * Current preparation status to show in UI dropdown
     * @type {string}
     * @memberof MerchantOrderDetailAllOfMerchantControls
     */
    'currentPreparationStatus'?: MerchantOrderDetailAllOfMerchantControlsCurrentPreparationStatusEnum;
}

export const MerchantOrderDetailAllOfMerchantControlsCurrentPreparationStatusEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Rejected: 'REJECTED',
    OrderPreparing: 'ORDER_PREPARING',
    ReadyForPickup: 'READY_FOR_PICKUP',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED'
} as const;

export type MerchantOrderDetailAllOfMerchantControlsCurrentPreparationStatusEnum = typeof MerchantOrderDetailAllOfMerchantControlsCurrentPreparationStatusEnum[keyof typeof MerchantOrderDetailAllOfMerchantControlsCurrentPreparationStatusEnum];

/**
 * 
 * @export
 * @interface MerchantOrderItem
 */
export interface MerchantOrderItem {
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'itemId': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'storeType': MerchantOrderItemStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'itemVariant'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MerchantOrderItem
     */
    'imageUrl'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof MerchantOrderItem
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof MerchantOrderItem
     */
    'originalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof MerchantOrderItem
     */
    'discountedPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'specialInstructions'?: string;
    /**
     * 
     * @type {Array<ItemChoiceNew>}
     * @memberof MerchantOrderItem
     */
    'choices'?: Array<ItemChoiceNew>;
    /**
     * ID of the meal added with this item
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'mealId'?: string;
    /**
     * Name of the meal (English)
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'mealName'?: string;
    /**
     * Name of the meal (Arabic)
     * @type {string}
     * @memberof MerchantOrderItem
     */
    'mealNameArabic'?: string;
    /**
     * Price of the meal
     * @type {number}
     * @memberof MerchantOrderItem
     */
    'mealPrice'?: number;
    /**
     * Choice groups selected for the meal
     * @type {Array<OrderItemMealChoiceGroupsInner>}
     * @memberof MerchantOrderItem
     */
    'mealChoiceGroups'?: Array<OrderItemMealChoiceGroupsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantOrderItem
     */
    'merchantAccepted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantOrderItem
     */
    'merchantDenied'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MerchantOrderItem
     */
    'isReadyForPickup'?: boolean;
}

export const MerchantOrderItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type MerchantOrderItemStoreTypeEnum = typeof MerchantOrderItemStoreTypeEnum[keyof typeof MerchantOrderItemStoreTypeEnum];

/**
 * The merchant\'s PayPal account details (optional).
 * @export
 * @interface MerchantPayPalSchema
 */
export interface MerchantPayPalSchema {
    /**
     * The publish status of the PayPal account.
     * @type {string}
     * @memberof MerchantPayPalSchema
     */
    'publishStatus'?: MerchantPayPalSchemaPublishStatusEnum;
    /**
     * The PayPal client ID.
     * @type {string}
     * @memberof MerchantPayPalSchema
     */
    'clientId'?: string;
    /**
     * The PayPal secret ID.
     * @type {string}
     * @memberof MerchantPayPalSchema
     */
    'secretId'?: string;
}

export const MerchantPayPalSchemaPublishStatusEnum = {
    Publish: 'publish',
    Unpublish: 'unpublish'
} as const;

export type MerchantPayPalSchemaPublishStatusEnum = typeof MerchantPayPalSchemaPublishStatusEnum[keyof typeof MerchantPayPalSchemaPublishStatusEnum];

/**
 * 
 * @export
 * @interface MerchantPayoutReportRequest
 */
export interface MerchantPayoutReportRequest {
    /**
     * Array of store IDs to filter by (optional - omit to include all accessible stores). Maximum 50 stores per request. Merchants can only access their own stores. 
     * @type {Array<string>}
     * @memberof MerchantPayoutReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant/store owner ID to filter by (optional - omit to include all accessible merchants). Merchants can only access their own ID. Admins can access any merchant. 
     * @type {string}
     * @memberof MerchantPayoutReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types (optional - omit to include all types)
     * @type {Array<string>}
     * @memberof MerchantPayoutReportRequest
     */
    'storeType'?: Array<MerchantPayoutReportRequestStoreTypeEnum>;
    /**
     * Date range for the report (filters by order delivery dates). - today: Today\'s settlements (midnight to now, UTC) - thisWeek: This week\'s settlements (Monday to now, UTC) - thisMonth: This month\'s settlements (1st to now, UTC) - last30Days: Last 30 days of settlements - thisYear: This year\'s settlements (Jan 1 to now, UTC) - custom: Use dateFrom and dateTo parameters for custom date range 
     * @type {string}
     * @memberof MerchantPayoutReportRequest
     */
    'dateRange': MerchantPayoutReportRequestDateRangeEnum;
    /**
     * Filter by settlement/payout status (optional - omit to include all statuses). - PENDING: Payout calculated but not initiated - INPROGRESS: Payment processing in progress - COMPLETED: Payment successfully completed - FAILED: Payment failed - CANCELLED: Payout cancelled 
     * @type {Array<string>}
     * @memberof MerchantPayoutReportRequest
     */
    'settlementStatus'?: Array<MerchantPayoutReportRequestSettlementStatusEnum>;
    /**
     * Order statuses to include in the report (defaults to ORDER_DELIVERED only). - ORDER_DELIVERED: Successfully delivered orders (eligible for payout) - MERCHANT_CANCELLED: Merchant cancelled orders (may affect payout) - DELIVERY_FAILED: Failed delivery attempts (may affect payout) 
     * @type {Array<string>}
     * @memberof MerchantPayoutReportRequest
     */
    'orderStatuses'?: Array<MerchantPayoutReportRequestOrderStatusesEnum>;
    /**
     * Filter by order payment methods (optional - omit to include all methods). Useful for tracking COD collection and reconciliation. 
     * @type {Array<string>}
     * @memberof MerchantPayoutReportRequest
     */
    'paymentMethods'?: Array<MerchantPayoutReportRequestPaymentMethodsEnum>;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if settlementPeriod is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof MerchantPayoutReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if settlementPeriod is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof MerchantPayoutReportRequest
     */
    'dateTo'?: string;
}

export const MerchantPayoutReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type MerchantPayoutReportRequestStoreTypeEnum = typeof MerchantPayoutReportRequestStoreTypeEnum[keyof typeof MerchantPayoutReportRequestStoreTypeEnum];
export const MerchantPayoutReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type MerchantPayoutReportRequestDateRangeEnum = typeof MerchantPayoutReportRequestDateRangeEnum[keyof typeof MerchantPayoutReportRequestDateRangeEnum];
export const MerchantPayoutReportRequestSettlementStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type MerchantPayoutReportRequestSettlementStatusEnum = typeof MerchantPayoutReportRequestSettlementStatusEnum[keyof typeof MerchantPayoutReportRequestSettlementStatusEnum];
export const MerchantPayoutReportRequestOrderStatusesEnum = {
    OrderDelivered: 'ORDER_DELIVERED',
    MerchantCancelled: 'MERCHANT_CANCELLED',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type MerchantPayoutReportRequestOrderStatusesEnum = typeof MerchantPayoutReportRequestOrderStatusesEnum[keyof typeof MerchantPayoutReportRequestOrderStatusesEnum];
export const MerchantPayoutReportRequestPaymentMethodsEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type MerchantPayoutReportRequestPaymentMethodsEnum = typeof MerchantPayoutReportRequestPaymentMethodsEnum[keyof typeof MerchantPayoutReportRequestPaymentMethodsEnum];

/**
 * 
 * @export
 * @interface MerchantSchema
 */
export interface MerchantSchema {
    /**
     * ID of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'id'?: string;
    /**
     * ID of the admin user who created this merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'createdUserId'?: string;
    /**
     * First name of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'firstName'?: string;
    /**
     * Last name of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'lastName'?: string;
    /**
     * Email address of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'email'?: string;
    /**
     * Mobile number of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'mobileNo'?: string;
    /**
     * Password of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'password'?: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof MerchantSchema
     */
    'currencyCode'?: CurrencyCode;
    /**
     * Business type of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'businessType'?: string;
    /**
     * Commission type of the merchant - \'common\' uses platform-wide commission, \'custom\' uses merchant-specific commission
     * @type {string}
     * @memberof MerchantSchema
     */
    'commissionType'?: MerchantSchemaCommissionTypeEnum;
    /**
     * Commission percentage of the merchant (only used when commissionType is \'custom\')
     * @type {number}
     * @memberof MerchantSchema
     */
    'commissionPercentage'?: number;
    /**
     * Cancel status of the merchant
     * @type {boolean}
     * @memberof MerchantSchema
     */
    'cancelStatus'?: boolean;
    /**
     * Cancellation policy of the merchant in English
     * @type {string}
     * @memberof MerchantSchema
     */
    'cancellationPolicyEnglish'?: string;
    /**
     * Cancellation policy of the merchant in Arabic
     * @type {string}
     * @memberof MerchantSchema
     */
    'cancellationPolicyArabic'?: string;
    /**
     * ID proof of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'idProof'?: string;
    /**
     * Restaurant license of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'restaurantLicense'?: string;
    /**
     * 
     * @type {MerchantAddressSchema}
     * @memberof MerchantSchema
     */
    'address'?: MerchantAddressSchema;
    /**
     * 
     * @type {MerchantSchemaPaymentDetails}
     * @memberof MerchantSchema
     */
    'paymentDetails'?: MerchantSchemaPaymentDetails;
    /**
     * Status of the merchant
     * @type {boolean}
     * @memberof MerchantSchema
     */
    'isActive'?: boolean;
    /**
     * Preferred language of the merchant
     * @type {string}
     * @memberof MerchantSchema
     */
    'preferredLanguage'?: MerchantSchemaPreferredLanguageEnum;
}

export const MerchantSchemaCommissionTypeEnum = {
    Common: 'common',
    Custom: 'custom'
} as const;

export type MerchantSchemaCommissionTypeEnum = typeof MerchantSchemaCommissionTypeEnum[keyof typeof MerchantSchemaCommissionTypeEnum];
export const MerchantSchemaPreferredLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;

export type MerchantSchemaPreferredLanguageEnum = typeof MerchantSchemaPreferredLanguageEnum[keyof typeof MerchantSchemaPreferredLanguageEnum];

/**
 * Payment details of the merchant
 * @export
 * @interface MerchantSchemaPaymentDetails
 */
export interface MerchantSchemaPaymentDetails {
    /**
     * 
     * @type {MerchantStripeDetailsSchema}
     * @memberof MerchantSchemaPaymentDetails
     */
    'stripe'?: MerchantStripeDetailsSchema;
    /**
     * 
     * @type {MerchantPayPalSchema}
     * @memberof MerchantSchemaPaymentDetails
     */
    'paypal'?: MerchantPayPalSchema;
    /**
     * 
     * @type {MerchantNetBankingSchema}
     * @memberof MerchantSchemaPaymentDetails
     */
    'netBanking'?: MerchantNetBankingSchema;
}
/**
 * 
 * @export
 * @interface MerchantStatusPieChartItem
 */
export interface MerchantStatusPieChartItem {
    /**
     * Merchant status value (Active, Inactive).
     * @type {string}
     * @memberof MerchantStatusPieChartItem
     */
    'status': string;
    /**
     * Number of merchants in each status.
     * @type {number}
     * @memberof MerchantStatusPieChartItem
     */
    'count': number;
    /**
     * Percentage of merchants in each status.
     * @type {number}
     * @memberof MerchantStatusPieChartItem
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface MerchantStore
 */
export interface MerchantStore {
    /**
     * The unique identifier of the store.
     * @type {string}
     * @memberof MerchantStore
     */
    'id': string;
    /**
     * The name of the store.
     * @type {string}
     * @memberof MerchantStore
     */
    'name': string;
    /**
     * The type of store (e.g., Restaurant, GroceryStore, PharmacyStore).
     * @type {string}
     * @memberof MerchantStore
     */
    'storeType'?: MerchantStoreStoreTypeEnum;
}

export const MerchantStoreStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type MerchantStoreStoreTypeEnum = typeof MerchantStoreStoreTypeEnum[keyof typeof MerchantStoreStoreTypeEnum];

/**
 * The merchant\'s Stripe account details (optional).
 * @export
 * @interface MerchantStripeDetailsSchema
 */
export interface MerchantStripeDetailsSchema {
    /**
     * The publish status of the Stripe account.
     * @type {string}
     * @memberof MerchantStripeDetailsSchema
     */
    'publishStatus'?: MerchantStripeDetailsSchemaPublishStatusEnum;
    /**
     * The Stripe client ID.
     * @type {string}
     * @memberof MerchantStripeDetailsSchema
     */
    'clientId'?: string;
    /**
     * The Stripe secret ID.
     * @type {string}
     * @memberof MerchantStripeDetailsSchema
     */
    'secretId'?: string;
}

export const MerchantStripeDetailsSchemaPublishStatusEnum = {
    Publish: 'publish',
    Unpublish: 'unpublish'
} as const;

export type MerchantStripeDetailsSchemaPublishStatusEnum = typeof MerchantStripeDetailsSchemaPublishStatusEnum[keyof typeof MerchantStripeDetailsSchemaPublishStatusEnum];

/**
 * 
 * @export
 * @interface MetricsCardItem
 */
export interface MetricsCardItem {
    /**
     * Total number of registered customers within the specified date range.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'customersCount'?: number;
    /**
     * Total number of merchants onboarded during the selected period.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'merchantsCount'?: number;
    /**
     * Total count of store entities managed by all merchants.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'storesCount': number;
    /**
     * Total number of items available across all stores.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'storesItemsCount': number;
    /**
     * Total number of active delivery personnel registered in the system.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'deliveryMembersCount'?: number;
    /**
     * Aggregate count of all orders placed in the platform within the date range.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'ordersCount': number;
    /**
     * Number of orders marked as delivered in the given period.
     * @type {number}
     * @memberof MetricsCardItem
     */
    'deliveredOrdersCount': number;
}
/**
 * 
 * @export
 * @interface MinOrderAmountSchema
 */
export interface MinOrderAmountSchema {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof MinOrderAmountSchema
     */
    'currency'?: CurrencyCode;
    /**
     * Minimum order amount value
     * @type {number}
     * @memberof MinOrderAmountSchema
     */
    'value'?: number;
}


/**
 * 
 * @export
 * @interface MobileUrlSettings
 */
export interface MobileUrlSettings {
    /**
     * iTunes App Store URL
     * @type {string}
     * @memberof MobileUrlSettings
     */
    'itunesUrl'?: string;
    /**
     * Google Play Store URL
     * @type {string}
     * @memberof MobileUrlSettings
     */
    'playStoreUrl'?: string;
}
/**
 * 
 * @export
 * @interface MultiStoreInfo
 */
export interface MultiStoreInfo {
    /**
     * 
     * @type {number}
     * @memberof MultiStoreInfo
     */
    'totalStoresCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof MultiStoreInfo
     */
    'completedStoresCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MultiStoreInfo
     */
    'allStoresPickedUp'?: boolean;
}
/**
 * User\'s delivery person review with order details
 * @export
 * @interface MyDeliveryPersonReview
 */
export interface MyDeliveryPersonReview {
    /**
     * Review type discriminator
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'type': MyDeliveryPersonReviewTypeEnum;
    /**
     * Unique review identifier
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'reviewId': string;
    /**
     * Delivery person rating (1-5)
     * @type {number}
     * @memberof MyDeliveryPersonReview
     */
    'rating': number;
    /**
     * Review text about delivery service
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'comment'?: string;
    /**
     * Whether the review has been approved
     * @type {boolean}
     * @memberof MyDeliveryPersonReview
     */
    'reviewApprovalStatus'?: boolean;
    /**
     * When the review was created
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'createdAt': string;
    /**
     * Associated order ID
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'orderId': string;
    /**
     * Human-readable order number
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'orderNumber'?: string;
    /**
     * When the order was placed
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'orderDate'?: string;
    /**
     * Current order status
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'orderStatus'?: string;
    /**
     * Delivery partner ID
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'deliveryPersonId': string;
    /**
     * Name of the delivery partner
     * @type {string}
     * @memberof MyDeliveryPersonReview
     */
    'deliveryPersonName': string;
}

export const MyDeliveryPersonReviewTypeEnum = {
    DeliveryPerson: 'DeliveryPerson'
} as const;

export type MyDeliveryPersonReviewTypeEnum = typeof MyDeliveryPersonReviewTypeEnum[keyof typeof MyDeliveryPersonReviewTypeEnum];

/**
 * User\'s item review with order and store details
 * @export
 * @interface MyItemReview
 */
export interface MyItemReview {
    /**
     * Review type discriminator
     * @type {string}
     * @memberof MyItemReview
     */
    'type': MyItemReviewTypeEnum;
    /**
     * Unique review identifier
     * @type {string}
     * @memberof MyItemReview
     */
    'reviewId': string;
    /**
     * Item rating (1-5)
     * @type {number}
     * @memberof MyItemReview
     */
    'rating': number;
    /**
     * Review text (optional for item reviews)
     * @type {string}
     * @memberof MyItemReview
     */
    'comment'?: string;
    /**
     * Whether the review has been approved
     * @type {boolean}
     * @memberof MyItemReview
     */
    'reviewApprovalStatus'?: boolean;
    /**
     * When the review was created
     * @type {string}
     * @memberof MyItemReview
     */
    'createdAt': string;
    /**
     * Associated order ID
     * @type {string}
     * @memberof MyItemReview
     */
    'orderId': string;
    /**
     * Human-readable order number
     * @type {string}
     * @memberof MyItemReview
     */
    'orderNumber'?: string;
    /**
     * When the order was placed
     * @type {string}
     * @memberof MyItemReview
     */
    'orderDate'?: string;
    /**
     * Current order status
     * @type {string}
     * @memberof MyItemReview
     */
    'orderStatus'?: string;
    /**
     * Food item ID
     * @type {string}
     * @memberof MyItemReview
     */
    'itemId': string;
    /**
     * Name of the food item
     * @type {string}
     * @memberof MyItemReview
     */
    'itemName': string;
    /**
     * Store/restaurant ID
     * @type {string}
     * @memberof MyItemReview
     */
    'storeId': string;
    /**
     * Name of the store/restaurant
     * @type {string}
     * @memberof MyItemReview
     */
    'storeName': string;
}

export const MyItemReviewTypeEnum = {
    Item: 'Item'
} as const;

export type MyItemReviewTypeEnum = typeof MyItemReviewTypeEnum[keyof typeof MyItemReviewTypeEnum];

/**
 * Response containing user\'s review history with pagination
 * @export
 * @interface MyReviewsResponse
 */
export interface MyReviewsResponse {
    /**
     * 
     * @type {Array<MyReviewsResponseDataInner>}
     * @memberof MyReviewsResponse
     */
    'data': Array<MyReviewsResponseDataInner>;
    /**
     * 
     * @type {Pagination}
     * @memberof MyReviewsResponse
     */
    'pagination': Pagination;
}
/**
 * @type MyReviewsResponseDataInner
 * @export
 */
export type MyReviewsResponseDataInner = { type: 'DeliveryPerson' } & MyDeliveryPersonReview | { type: 'Item' } & MyItemReview | { type: 'Store' } & MyStoreReview;

/**
 * User\'s store review with order details
 * @export
 * @interface MyStoreReview
 */
export interface MyStoreReview {
    /**
     * Review type discriminator
     * @type {string}
     * @memberof MyStoreReview
     */
    'type': MyStoreReviewTypeEnum;
    /**
     * Unique review identifier
     * @type {string}
     * @memberof MyStoreReview
     */
    'reviewId': string;
    /**
     * Store review text
     * @type {string}
     * @memberof MyStoreReview
     */
    'comment': string;
    /**
     * Whether the review has been approved
     * @type {boolean}
     * @memberof MyStoreReview
     */
    'reviewApprovalStatus'?: boolean;
    /**
     * When the review was created
     * @type {string}
     * @memberof MyStoreReview
     */
    'createdAt': string;
    /**
     * Associated order ID
     * @type {string}
     * @memberof MyStoreReview
     */
    'orderId': string;
    /**
     * Human-readable order number
     * @type {string}
     * @memberof MyStoreReview
     */
    'orderNumber'?: string;
    /**
     * When the order was placed
     * @type {string}
     * @memberof MyStoreReview
     */
    'orderDate'?: string;
    /**
     * Current order status
     * @type {string}
     * @memberof MyStoreReview
     */
    'orderStatus'?: string;
    /**
     * Store/restaurant ID
     * @type {string}
     * @memberof MyStoreReview
     */
    'storeId': string;
    /**
     * Name of the store/restaurant
     * @type {string}
     * @memberof MyStoreReview
     */
    'storeName': string;
}

export const MyStoreReviewTypeEnum = {
    Store: 'Store'
} as const;

export type MyStoreReviewTypeEnum = typeof MyStoreReviewTypeEnum[keyof typeof MyStoreReviewTypeEnum];

/**
 * Permission settings for newsletter management
 * @export
 * @interface NewsLetterPermission
 */
export interface NewsLetterPermission {
    /**
     * Can view newsletter subscribers
     * @type {boolean}
     * @memberof NewsLetterPermission
     */
    'view'?: boolean;
    /**
     * Can delete subscribers
     * @type {boolean}
     * @memberof NewsLetterPermission
     */
    'delete'?: boolean;
    /**
     * Can block subscribers
     * @type {boolean}
     * @memberof NewsLetterPermission
     */
    'block'?: boolean;
    /**
     * Can unblock subscribers
     * @type {boolean}
     * @memberof NewsLetterPermission
     */
    'unBlock'?: boolean;
}
/**
 * 
 * @export
 * @interface NewsletterSubscriber
 */
export interface NewsletterSubscriber {
    /**
     * 
     * @type {string}
     * @memberof NewsletterSubscriber
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSubscriber
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterSubscriber
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * Unique identifier for the notification
     * @type {string}
     * @memberof Notification
     */
    'id': string;
    /**
     * ID of the user who received the notification
     * @type {string}
     * @memberof Notification
     */
    'userId'?: string;
    /**
     * Title of the notification
     * @type {string}
     * @memberof Notification
     */
    'title': string;
    /**
     * Body of the notification, containing information about the notification
     * @type {string}
     * @memberof Notification
     */
    'body': string;
    /**
     * Type of notification (e.g., order update, delivery status, promotional message)
     * @type {string}
     * @memberof Notification
     */
    'notificationType': string;
    /**
     * URL of the notification image
     * @type {string}
     * @memberof Notification
     */
    'notificationImage'?: string;
    /**
     * Additional data associated with the notification
     * @type {string}
     * @memberof Notification
     */
    'notificationData'?: string;
    /**
     * Date and time when the notification was created
     * @type {string}
     * @memberof Notification
     */
    'createdAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    'isRead': boolean;
}
/**
 * 
 * @export
 * @interface OfferResponseSchema
 */
export interface OfferResponseSchema {
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'offerId': string;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'couponCode': string;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'couponName': string;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'couponType': OfferResponseSchemaCouponTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof OfferResponseSchema
     */
    'maxCouponAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferResponseSchema
     */
    'couponValue': number;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'couponStartDate': string;
    /**
     * 
     * @type {number}
     * @memberof OfferResponseSchema
     */
    'validityDays': number;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'termsAndConditions': string;
    /**
     * 
     * @type {number}
     * @memberof OfferResponseSchema
     */
    'couponPerUserLimit': number;
    /**
     * 
     * @type {number}
     * @memberof OfferResponseSchema
     */
    'totalCouponCount': number;
    /**
     * 
     * @type {number}
     * @memberof OfferResponseSchema
     */
    'usedCouponCount': number;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'status': OfferResponseSchemaStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'addedBy'?: OfferResponseSchemaAddedByEnum;
    /**
     * 
     * @type {string}
     * @memberof OfferResponseSchema
     */
    'createdAt': string;
}

export const OfferResponseSchemaCouponTypeEnum = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type OfferResponseSchemaCouponTypeEnum = typeof OfferResponseSchemaCouponTypeEnum[keyof typeof OfferResponseSchemaCouponTypeEnum];
export const OfferResponseSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type OfferResponseSchemaStatusEnum = typeof OfferResponseSchemaStatusEnum[keyof typeof OfferResponseSchemaStatusEnum];
export const OfferResponseSchemaAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;

export type OfferResponseSchemaAddedByEnum = typeof OfferResponseSchemaAddedByEnum[keyof typeof OfferResponseSchemaAddedByEnum];

/**
 * 
 * @export
 * @interface OnboardingScreen
 */
export interface OnboardingScreen {
    /**
     * Title of the onboarding screen
     * @type {string}
     * @memberof OnboardingScreen
     */
    'title'?: string;
    /**
     * Title of the onboarding screen in Arabic
     * @type {string}
     * @memberof OnboardingScreen
     */
    'titleArabic'?: string;
    /**
     * Description of the onboarding screen
     * @type {string}
     * @memberof OnboardingScreen
     */
    'description'?: string;
    /**
     * Description of the onboarding screen in Arabic
     * @type {string}
     * @memberof OnboardingScreen
     */
    'descriptionArabic'?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingScreen
     */
    'imageUrl': string;
}
/**
 * 
 * @export
 * @interface OnboardingSlides
 */
export interface OnboardingSlides {
    /**
     * 
     * @type {Array<OnboardingScreen>}
     * @memberof OnboardingSlides
     */
    'screens': Array<OnboardingScreen>;
}
/**
 * 
 * @export
 * @interface OnlineSettlementPaymentResponse
 */
export interface OnlineSettlementPaymentResponse {
    /**
     * Payment mode discriminator
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'paymentMode': OnlineSettlementPaymentResponsePaymentModeEnum;
    /**
     * ID of the settlement payment record
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'settlementPaymentId'?: string;
    /**
     * Gateway checkout session ID
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'checkoutId'?: string;
    /**
     * URL for web payment widget (web platform only)
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'checkoutUrl'?: string;
    /**
     * Client secret for mobile SDK (mobile platform only)
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'clientSecret'?: string;
    /**
     * Ephemeral key for mobile SDK (Stripe mobile only)
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'ephemeralKey'?: string;
    /**
     * Stripe customer ID (Stripe mobile only)
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'customerId'?: string;
    /**
     * Gateway publishable key (mobile platform only)
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'publishableKey'?: string;
    /**
     * Total amount to be paid
     * @type {number}
     * @memberof OnlineSettlementPaymentResponse
     */
    'totalAmount'?: number;
    /**
     * Checkout session expiration time
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'expiresAt'?: string;
    /**
     * Payment gateway being used
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'gatewayType'?: OnlineSettlementPaymentResponseGatewayTypeEnum;
    /**
     * Result URL for Hyperpay (Hyperpay web only)
     * @type {string}
     * @memberof OnlineSettlementPaymentResponse
     */
    'shopperResultUrl'?: string;
}

export const OnlineSettlementPaymentResponsePaymentModeEnum = {
    Online: 'ONLINE'
} as const;

export type OnlineSettlementPaymentResponsePaymentModeEnum = typeof OnlineSettlementPaymentResponsePaymentModeEnum[keyof typeof OnlineSettlementPaymentResponsePaymentModeEnum];
export const OnlineSettlementPaymentResponseGatewayTypeEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type OnlineSettlementPaymentResponseGatewayTypeEnum = typeof OnlineSettlementPaymentResponseGatewayTypeEnum[keyof typeof OnlineSettlementPaymentResponseGatewayTypeEnum];

/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderDate': string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'orderAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'invoiceAmount': number;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'status': OrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'paymentStatus': string;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof Order
     */
    'items': Array<OrderItem>;
}

export const OrderStatusEnum = {
    OrderPlaced: 'Order Placed',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    PreparingForDeliver: 'Preparing for deliver',
    Dispatched: 'Dispatched',
    Started: 'Started',
    Arrived: 'Arrived',
    Delivered: 'Delivered',
    Cancelled: 'Cancelled'
} as const;

export type OrderStatusEnum = typeof OrderStatusEnum[keyof typeof OrderStatusEnum];

/**
 * 
 * @export
 * @interface OrderAndCartSettings
 */
export interface OrderAndCartSettings {
    /**
     * 
     * @type {OrderHistoryExpire}
     * @memberof OrderAndCartSettings
     */
    'orderHistoryExpire'?: OrderHistoryExpire;
    /**
     * 
     * @type {AbandonedCartMailStatus}
     * @memberof OrderAndCartSettings
     */
    'abandonedCartMailStatus'?: AbandonedCartMailStatus;
}
/**
 * 
 * @export
 * @interface OrderDeliveryDetails
 */
export interface OrderDeliveryDetails {
    /**
     * 
     * @type {Array<DeliveryInfo>}
     * @memberof OrderDeliveryDetails
     */
    'assignedDeliveryPartners'?: Array<DeliveryInfo>;
    /**
     * 
     * @type {Array<DeliveryInfo>}
     * @memberof OrderDeliveryDetails
     */
    'acceptedDeliveryPartners'?: Array<DeliveryInfo>;
    /**
     * 
     * @type {Array<DeliveryInfo>}
     * @memberof OrderDeliveryDetails
     */
    'deniedDeliveryPartners'?: Array<DeliveryInfo>;
}
/**
 * 
 * @export
 * @interface OrderDetails
 */
export interface OrderDetails {
    /**
     * When order was placed
     * @type {string}
     * @memberof OrderDetails
     */
    'orderPlaced': string;
    /**
     * Short order code for reference
     * @type {string}
     * @memberof OrderDetails
     */
    'orderCode': string;
    /**
     * Delivery timing type
     * @type {string}
     * @memberof OrderDetails
     */
    'scheduledDelivery': OrderDetailsScheduledDeliveryEnum;
    /**
     * Scheduled delivery time (if applicable)
     * @type {string}
     * @memberof OrderDetails
     */
    'scheduledTime'?: string;
    /**
     * Customer instructions
     * @type {string}
     * @memberof OrderDetails
     */
    'specialInstructions'?: string;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof OrderDetails
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level)
     * @type {string}
     * @memberof OrderDetails
     */
    'prescriptionUrl'?: string;
    /**
     * Payment method used
     * @type {string}
     * @memberof OrderDetails
     */
    'paymentMethod'?: string;
}

export const OrderDetailsScheduledDeliveryEnum = {
    Now: 'now',
    Scheduled: 'scheduled'
} as const;

export type OrderDetailsScheduledDeliveryEnum = typeof OrderDetailsScheduledDeliveryEnum[keyof typeof OrderDetailsScheduledDeliveryEnum];

/**
 * 
 * @export
 * @interface OrderDetailsAdmin
 */
export interface OrderDetailsAdmin {
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsAdmin
     */
    'userType': OrderDetailsAdminUserTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsAdmin
     */
    'orderId': string;
    /**
     * 
     * @type {UserShort}
     * @memberof OrderDetailsAdmin
     */
    'user': UserShort;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof OrderDetailsAdmin
     */
    'shippingAddress': ShippingAddress;
    /**
     * 
     * @type {DeliveryBoyShort}
     * @memberof OrderDetailsAdmin
     */
    'deliveryBoy': DeliveryBoyShort | null;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof OrderDetailsAdmin
     */
    'orderItems': Array<OrderItem>;
    /**
     * 
     * @type {InvoiceDetails}
     * @memberof OrderDetailsAdmin
     */
    'invoiceDetails': InvoiceDetails;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof OrderDetailsAdmin
     */
    'trackingHistory': Array<TrackingEvent>;
    /**
     * 
     * @type {Array<OrderDetailsAdminAuditLogsInner>}
     * @memberof OrderDetailsAdmin
     */
    'auditLogs': Array<OrderDetailsAdminAuditLogsInner>;
}

export const OrderDetailsAdminUserTypeEnum = {
    Admin: 'Admin'
} as const;

export type OrderDetailsAdminUserTypeEnum = typeof OrderDetailsAdminUserTypeEnum[keyof typeof OrderDetailsAdminUserTypeEnum];

/**
 * 
 * @export
 * @interface OrderDetailsAdminAuditLogsInner
 */
export interface OrderDetailsAdminAuditLogsInner {
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsAdminAuditLogsInner
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsAdminAuditLogsInner
     */
    'userType'?: string;
    /**
     * 
     * @type {object}
     * @memberof OrderDetailsAdminAuditLogsInner
     */
    'changes'?: object;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsAdminAuditLogsInner
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface OrderDetailsCustomer
 */
export interface OrderDetailsCustomer {
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsCustomer
     */
    'userType': OrderDetailsCustomerUserTypeEnum;
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof OrderDetailsCustomer
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsCustomer
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsCustomer
     */
    'orderedOn': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsCustomer
     */
    'currentStatus': string;
    /**
     * 
     * @type {number}
     * @memberof OrderDetailsCustomer
     */
    'totalAmount': number;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof OrderDetailsCustomer
     */
    'orderItems': Array<OrderItem>;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof OrderDetailsCustomer
     */
    'shippingAddress'?: ShippingAddress;
    /**
     * 
     * @type {InvoiceDetails}
     * @memberof OrderDetailsCustomer
     */
    'invoiceDetails': InvoiceDetails;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof OrderDetailsCustomer
     */
    'trackingHistory': Array<TrackingEvent>;
    /**
     * 
     * @type {boolean}
     * @memberof OrderDetailsCustomer
     */
    'isReviewed': boolean;
}

export const OrderDetailsCustomerUserTypeEnum = {
    Customer: 'Customer'
} as const;

export type OrderDetailsCustomerUserTypeEnum = typeof OrderDetailsCustomerUserTypeEnum[keyof typeof OrderDetailsCustomerUserTypeEnum];

/**
 * 
 * @export
 * @interface OrderDetailsDeliveryBoy
 */
export interface OrderDetailsDeliveryBoy {
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsDeliveryBoy
     */
    'userType': OrderDetailsDeliveryBoyUserTypeEnum;
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof OrderDetailsDeliveryBoy
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsDeliveryBoy
     */
    'orderNumber': string;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof OrderDetailsDeliveryBoy
     */
    'deliveryAddress': ShippingAddress;
    /**
     * 
     * @type {UserShort}
     * @memberof OrderDetailsDeliveryBoy
     */
    'customerContact': UserShort;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof OrderDetailsDeliveryBoy
     */
    'orderItems': Array<OrderItem>;
    /**
     * 
     * @type {StoreInfo}
     * @memberof OrderDetailsDeliveryBoy
     */
    'pickupLocation': StoreInfo;
}

export const OrderDetailsDeliveryBoyUserTypeEnum = {
    DeliveryPartner: 'DeliveryPartner'
} as const;

export type OrderDetailsDeliveryBoyUserTypeEnum = typeof OrderDetailsDeliveryBoyUserTypeEnum[keyof typeof OrderDetailsDeliveryBoyUserTypeEnum];

/**
 * 
 * @export
 * @interface OrderDetailsMerchant
 */
export interface OrderDetailsMerchant {
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsMerchant
     */
    'userType': OrderDetailsMerchantUserTypeEnum;
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof OrderDetailsMerchant
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsMerchant
     */
    'orderNumber': string;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof OrderDetailsMerchant
     */
    'orderItems': Array<OrderItem>;
    /**
     * 
     * @type {UserShort}
     * @memberof OrderDetailsMerchant
     */
    'customerInfo': UserShort;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsMerchant
     */
    'specialInstructions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsMerchant
     */
    'prepStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsMerchant
     */
    'orderAcceptedAt'?: string;
    /**
     * 
     * @type {DeliveryBoyShort}
     * @memberof OrderDetailsMerchant
     */
    'deliveryDetails'?: DeliveryBoyShort | null;
}

export const OrderDetailsMerchantUserTypeEnum = {
    Merchant: 'Merchant'
} as const;

export type OrderDetailsMerchantUserTypeEnum = typeof OrderDetailsMerchantUserTypeEnum[keyof typeof OrderDetailsMerchantUserTypeEnum];

/**
 * @type OrderDetailsNew
 * @export
 */
export type OrderDetailsNew = { userType: 'Admin' } & AdminOrderDetail | { userType: 'Customer' } & CustomerOrderDetail | { userType: 'DeliveryPartner' } & DeliveryPartnerOrderDetail | { userType: 'Merchant' } & MerchantOrderDetail;

/**
 * 
 * @export
 * @interface OrderHistoryExpire
 */
export interface OrderHistoryExpire {
    /**
     * Enable/disable order history expiration
     * @type {boolean}
     * @memberof OrderHistoryExpire
     */
    'status'?: boolean;
    /**
     * Order history expiration duration
     * @type {number}
     * @memberof OrderHistoryExpire
     */
    'orderHistoryExpireDuration'?: number;
}
/**
 * 
 * @export
 * @interface OrderHistoryItem
 */
export interface OrderHistoryItem {
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof OrderHistoryItem
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryItem
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryItem
     */
    'orderedOn': string;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryItem
     */
    'status': OrderHistoryItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof OrderHistoryItem
     */
    'totalAmount': number;
    /**
     * 
     * @type {Array<OrderItem>}
     * @memberof OrderHistoryItem
     */
    'orderItems': Array<OrderItem>;
    /**
     * 
     * @type {InvoiceDetails}
     * @memberof OrderHistoryItem
     */
    'invoiceDetails': InvoiceDetails;
    /**
     * 
     * @type {string}
     * @memberof OrderHistoryItem
     */
    'repeatOrderUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderHistoryItem
     */
    'isReviewed': boolean;
}

export const OrderHistoryItemStatusEnum = {
    OrderPlaced: 'Order Placed',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    PreparingForDeliver: 'Preparing for deliver',
    Dispatched: 'Dispatched',
    Started: 'Started',
    Arrived: 'Arrived',
    Delivered: 'Delivered',
    Cancelled: 'Cancelled'
} as const;

export type OrderHistoryItemStatusEnum = typeof OrderHistoryItemStatusEnum[keyof typeof OrderHistoryItemStatusEnum];

/**
 * 
 * @export
 * @interface OrderHistoryResponse
 */
export interface OrderHistoryResponse {
    /**
     * 
     * @type {Array<OrderHistoryItem>}
     * @memberof OrderHistoryResponse
     */
    'orders': Array<OrderHistoryItem>;
}
/**
 * 
 * @export
 * @interface OrderInfo
 */
export interface OrderInfo {
    /**
     * 
     * @type {string}
     * @memberof OrderInfo
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfo
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfo
     */
    'storeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderInfo
     */
    'customerName'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderInfo
     */
    'orderAmount'?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderInfo
     */
    'orderDate'?: string;
}
/**
 * 
 * @export
 * @interface OrderItem
 */
export interface OrderItem {
    /**
     * Unique identifier for the item in the order
     * @type {string}
     * @memberof OrderItem
     */
    'itemId': string;
    /**
     * Unique identifier for the store where the item was purchased
     * @type {string}
     * @memberof OrderItem
     */
    'storeId': string;
    /**
     * Name of the store where the item was purchased
     * @type {string}
     * @memberof OrderItem
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderItem
     */
    'itemVariant'?: string;
    /**
     * Number of units of the item ordered
     * @type {number}
     * @memberof OrderItem
     */
    'quantity': number;
    /**
     * Price per unit of the item before any discounts
     * @type {number}
     * @memberof OrderItem
     */
    'unitPrice': number;
    /**
     * Price after any applicable discounts
     * @type {number}
     * @memberof OrderItem
     */
    'discountedPrice'?: number;
    /**
     * URL of the item\'s image
     * @type {string}
     * @memberof OrderItem
     */
    'imageUrl': string;
    /**
     * Indicates if the item was accepted by the store
     * @type {boolean}
     * @memberof OrderItem
     */
    'isAccepted'?: boolean;
    /**
     * Indicates if the item was rejected by the store
     * @type {boolean}
     * @memberof OrderItem
     */
    'isRejected'?: boolean;
    /**
     * Indicates if the item was cancelled by the customer
     * @type {boolean}
     * @memberof OrderItem
     */
    'isCancelled'?: boolean;
    /**
     * List of choices available under this group
     * @type {Array<StoreItemChoice>}
     * @memberof OrderItem
     */
    'choices'?: Array<StoreItemChoice>;
    /**
     * ID of the meal added with this item
     * @type {string}
     * @memberof OrderItem
     */
    'mealId'?: string;
    /**
     * Name of the meal (English)
     * @type {string}
     * @memberof OrderItem
     */
    'mealName'?: string;
    /**
     * Name of the meal (Arabic)
     * @type {string}
     * @memberof OrderItem
     */
    'mealNameArabic'?: string;
    /**
     * Price of the meal
     * @type {number}
     * @memberof OrderItem
     */
    'mealPrice'?: number;
    /**
     * Choice groups selected for the meal
     * @type {Array<OrderItemMealChoiceGroupsInner>}
     * @memberof OrderItem
     */
    'mealChoiceGroups'?: Array<OrderItemMealChoiceGroupsInner>;
}
/**
 * 
 * @export
 * @interface OrderItemMealChoiceGroupsInner
 */
export interface OrderItemMealChoiceGroupsInner {
    /**
     * 
     * @type {string}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'choiceGroupId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'choiceGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'choiceGroupNameArabic'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'minimumLimit'?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'maximumLimit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'choiceGroupOption'?: boolean;
    /**
     * 
     * @type {Array<OrderItemMealChoiceGroupsInnerChoicesInner>}
     * @memberof OrderItemMealChoiceGroupsInner
     */
    'choices'?: Array<OrderItemMealChoiceGroupsInnerChoicesInner>;
}
/**
 * 
 * @export
 * @interface OrderItemMealChoiceGroupsInnerChoicesInner
 */
export interface OrderItemMealChoiceGroupsInnerChoicesInner {
    /**
     * 
     * @type {string}
     * @memberof OrderItemMealChoiceGroupsInnerChoicesInner
     */
    'choiceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemMealChoiceGroupsInnerChoicesInner
     */
    'choiceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemMealChoiceGroupsInnerChoicesInner
     */
    'choiceNameArabic'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemMealChoiceGroupsInnerChoicesInner
     */
    'choicePrice'?: number;
}
/**
 * 
 * @export
 * @interface OrderItems
 */
export interface OrderItems {
    /**
     * Unique identifier for the order item
     * @type {string}
     * @memberof OrderItems
     */
    'id': string;
    /**
     * Name of the ordered item
     * @type {string}
     * @memberof OrderItems
     */
    'name': string;
    /**
     * Quantity of the item ordered
     * @type {number}
     * @memberof OrderItems
     */
    'quantity': number;
    /**
     * Price of the item in smallest currency unit
     * @type {number}
     * @memberof OrderItems
     */
    'price': number;
    /**
     * Status of this particular item
     * @type {string}
     * @memberof OrderItems
     */
    'status': OrderItemsStatusEnum;
    /**
     * Reason for denial (only present when status is \'denied\')
     * @type {string}
     * @memberof OrderItems
     */
    'reason'?: string;
}

export const OrderItemsStatusEnum = {
    Accepted: 'accepted',
    Denied: 'denied',
    Pending: 'pending'
} as const;

export type OrderItemsStatusEnum = typeof OrderItemsStatusEnum[keyof typeof OrderItemsStatusEnum];

/**
 * 
 * @export
 * @interface OrderListResponse
 */
export interface OrderListResponse {
    /**
     * 
     * @type {Array<FullOrder>}
     * @memberof OrderListResponse
     */
    'orders': Array<FullOrder>;
    /**
     * 
     * @type {Pagination}
     * @memberof OrderListResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface OrderResponse
 */
export interface OrderResponse {
    /**
     * 
     * @type {Array<OrderDetailsNew>}
     * @memberof OrderResponse
     */
    'orders': Array<OrderDetailsNew>;
    /**
     * 
     * @type {Pagination}
     * @memberof OrderResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface OrderStatus
 */
export interface OrderStatus {
    /**
     * Current overall order status
     * @type {string}
     * @memberof OrderStatus
     */
    'current': OrderStatusCurrentEnum;
    /**
     * Order progress percentage
     * @type {number}
     * @memberof OrderStatus
     */
    'progress': number;
    /**
     * Status message for customer
     * @type {string}
     * @memberof OrderStatus
     */
    'message'?: string;
}

export const OrderStatusCurrentEnum = {
    PaymentPending: 'Payment Pending',
    OrderPlaced: 'Order Placed',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    Preparing: 'Preparing',
    ReadyForPickup: 'Ready for Pickup',
    ReadyForCollection: 'Ready for Collection',
    Dispatched: 'Dispatched',
    Arrived: 'Arrived',
    Delivered: 'Delivered',
    Cancelled: 'Cancelled',
    DeliveryFailed: 'Delivery Failed'
} as const;

export type OrderStatusCurrentEnum = typeof OrderStatusCurrentEnum[keyof typeof OrderStatusCurrentEnum];

/**
 * 
 * @export
 * @interface OrderStatusPieChartItem
 */
export interface OrderStatusPieChartItem {
    /**
     * Order status value (Delivered, In Transit, Pending, Cancelled).
     * @type {string}
     * @memberof OrderStatusPieChartItem
     */
    'status': string;
    /**
     * Number of orders for each status category.
     * @type {number}
     * @memberof OrderStatusPieChartItem
     */
    'count': number;
    /**
     * Percentage of orders for each status category.
     * @type {number}
     * @memberof OrderStatusPieChartItem
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface OrderSummaryReportRequest
 */
export interface OrderSummaryReportRequest {
    /**
     * Array of store IDs (optional - omit to include all stores)
     * @type {Array<string>}
     * @memberof OrderSummaryReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant ID (optional - omit to include all merchants)
     * @type {string}
     * @memberof OrderSummaryReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types
     * @type {Array<string>}
     * @memberof OrderSummaryReportRequest
     */
    'storeType'?: Array<OrderSummaryReportRequestStoreTypeEnum>;
    /**
     * Order statuses to include (defaults to all statuses if omitted)
     * @type {Array<string>}
     * @memberof OrderSummaryReportRequest
     */
    'orderStatuses'?: Array<OrderSummaryReportRequestOrderStatusesEnum>;
    /**
     * Filter by payment methods
     * @type {Array<string>}
     * @memberof OrderSummaryReportRequest
     */
    'paymentMethods'?: Array<OrderSummaryReportRequestPaymentMethodsEnum>;
    /**
     * Predefined date range periods or custom
     * @type {string}
     * @memberof OrderSummaryReportRequest
     */
    'dateRange': OrderSummaryReportRequestDateRangeEnum;
    /**
     * Start date (required if dateRange is \'custom\')
     * @type {string}
     * @memberof OrderSummaryReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date (required if dateRange is \'custom\')
     * @type {string}
     * @memberof OrderSummaryReportRequest
     */
    'dateTo'?: string;
}

export const OrderSummaryReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type OrderSummaryReportRequestStoreTypeEnum = typeof OrderSummaryReportRequestStoreTypeEnum[keyof typeof OrderSummaryReportRequestStoreTypeEnum];
export const OrderSummaryReportRequestOrderStatusesEnum = {
    OrderDelivered: 'ORDER_DELIVERED',
    OrderCancelled: 'ORDER_CANCELLED',
    MerchantCancelled: 'MERCHANT_CANCELLED',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type OrderSummaryReportRequestOrderStatusesEnum = typeof OrderSummaryReportRequestOrderStatusesEnum[keyof typeof OrderSummaryReportRequestOrderStatusesEnum];
export const OrderSummaryReportRequestPaymentMethodsEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type OrderSummaryReportRequestPaymentMethodsEnum = typeof OrderSummaryReportRequestPaymentMethodsEnum[keyof typeof OrderSummaryReportRequestPaymentMethodsEnum];
export const OrderSummaryReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type OrderSummaryReportRequestDateRangeEnum = typeof OrderSummaryReportRequestDateRangeEnum[keyof typeof OrderSummaryReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface OrderSummarySchema
 */
export interface OrderSummarySchema {
    /**
     * List of stores with pricing and validation status
     * @type {Array<StoreOrderSummarySchema>}
     * @memberof OrderSummarySchema
     */
    'stores': Array<StoreOrderSummarySchema>;
    /**
     * 
     * @type {TotalPricingSchema}
     * @memberof OrderSummarySchema
     */
    'totalPricing': TotalPricingSchema;
    /**
     * Selected delivery mode (if provided in request)
     * @type {string}
     * @memberof OrderSummarySchema
     */
    'deliveryMode'?: OrderSummarySchemaDeliveryModeEnum;
    /**
     * Selected order mode (if provided in request)
     * @type {string}
     * @memberof OrderSummarySchema
     */
    'orderMode'?: OrderSummarySchemaOrderModeEnum;
    /**
     * Overall estimated delivery/pickup time (calculated only if deliveryMode provided)
     * @type {string}
     * @memberof OrderSummarySchema
     */
    'estimatedDeliveryTime'?: string;
}

export const OrderSummarySchemaDeliveryModeEnum = {
    SelfPickup: 'selfPickup',
    Delivery: 'delivery'
} as const;

export type OrderSummarySchemaDeliveryModeEnum = typeof OrderSummarySchemaDeliveryModeEnum[keyof typeof OrderSummarySchemaDeliveryModeEnum];
export const OrderSummarySchemaOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type OrderSummarySchemaOrderModeEnum = typeof OrderSummarySchemaOrderModeEnum[keyof typeof OrderSummarySchemaOrderModeEnum];

/**
 * 
 * @export
 * @interface OrderTimeline
 */
export interface OrderTimeline {
    /**
     * Order progress timeline steps
     * @type {Array<TimelineStep>}
     * @memberof OrderTimeline
     */
    'steps': Array<TimelineStep>;
    /**
     * Current active step number
     * @type {number}
     * @memberof OrderTimeline
     */
    'currentStep': number;
}
/**
 * 
 * @export
 * @interface OrderTrackingResponse
 */
export interface OrderTrackingResponse {
    /**
     * Unique order identifier
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'orderId': string;
    /**
     * Human-readable order number
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof OrderTrackingResponse
     */
    'orderStatus': OrderStatus;
    /**
     * Order delivery type
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'deliveryType': OrderTrackingResponseDeliveryTypeEnum;
    /**
     * Estimated delivery/pickup time in ISO 8601 format
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'estimatedDelivery': string;
    /**
     * Order mode - normal for immediate orders, preOrder for scheduled orders
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'orderMode'?: OrderTrackingResponseOrderModeEnum;
    /**
     * Scheduled delivery time for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'scheduledDeliveryTime'?: string;
    /**
     * Time when order processing starts for pre-orders (only present for preOrder mode)
     * @type {string}
     * @memberof OrderTrackingResponse
     */
    'processStartTime'?: string;
    /**
     * Indicates whether the order can be cancelled at this time (for pre-orders, only before processStartTime)
     * @type {boolean}
     * @memberof OrderTrackingResponse
     */
    'canCancel'?: boolean;
    /**
     * 
     * @type {TrackingMapData}
     * @memberof OrderTrackingResponse
     */
    'trackingMap': TrackingMapData;
    /**
     * 
     * @type {OrderTimeline}
     * @memberof OrderTrackingResponse
     */
    'orderTimeline': OrderTimeline;
    /**
     * 
     * @type {OrderDetails}
     * @memberof OrderTrackingResponse
     */
    'orderDetails': OrderDetails;
    /**
     * Items and status grouped by store
     * @type {Array<StoreGroup>}
     * @memberof OrderTrackingResponse
     */
    'storeGroups': Array<StoreGroup>;
    /**
     * 
     * @type {RefundInformation}
     * @memberof OrderTrackingResponse
     */
    'refundInformation'?: RefundInformation;
    /**
     * 
     * @type {BillSummary}
     * @memberof OrderTrackingResponse
     */
    'billSummary': BillSummary;
    /**
     * Indicates whether the order has been tipped
     * @type {boolean}
     * @memberof OrderTrackingResponse
     */
    'isTipped'?: boolean;
}

export const OrderTrackingResponseDeliveryTypeEnum = {
    Delivery: 'delivery',
    Pickup: 'pickup'
} as const;

export type OrderTrackingResponseDeliveryTypeEnum = typeof OrderTrackingResponseDeliveryTypeEnum[keyof typeof OrderTrackingResponseDeliveryTypeEnum];
export const OrderTrackingResponseOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type OrderTrackingResponseOrderModeEnum = typeof OrderTrackingResponseOrderModeEnum[keyof typeof OrderTrackingResponseOrderModeEnum];

/**
 * 
 * @export
 * @interface OrderTrendsLineChartItem
 */
export interface OrderTrendsLineChartItem {
    /**
     * List of month labels (e.g., \'Jan\', \'Feb\') representing each data point on the X-axis.
     * @type {string}
     * @memberof OrderTrendsLineChartItem
     */
    'month': string;
    /**
     * The year corresponding to the order data points.
     * @type {number}
     * @memberof OrderTrendsLineChartItem
     */
    'year': number;
    /**
     * Array of integer values representing total order counts per month for the line chart Y-axis.
     * @type {number}
     * @memberof OrderTrendsLineChartItem
     */
    'totalOrders': number;
}
/**
 * 
 * @export
 * @interface OtpRequest
 */
export interface OtpRequest {
    /**
     * Medium to resend OTP
     * @type {string}
     * @memberof OtpRequest
     */
    'channel': OtpRequestChannelEnum;
    /**
     * User\'s email address (required when channel is email)
     * @type {string}
     * @memberof OtpRequest
     */
    'email'?: string;
    /**
     * Valid phone number (required when channel is phone)
     * @type {string}
     * @memberof OtpRequest
     */
    'phoneNumber'?: string;
}

export const OtpRequestChannelEnum = {
    Email: 'email',
    Phone: 'phone'
} as const;

export type OtpRequestChannelEnum = typeof OtpRequestChannelEnum[keyof typeof OtpRequestChannelEnum];

/**
 * 
 * @export
 * @interface OtpVerificationStatus
 */
export interface OtpVerificationStatus {
    /**
     * OTP verification status
     * @type {boolean}
     * @memberof OtpVerificationStatus
     */
    'status': boolean;
    /**
     * Twilio Account SID
     * @type {string}
     * @memberof OtpVerificationStatus
     */
    'twilioSid'?: string;
    /**
     * Twilio Auth Token
     * @type {string}
     * @memberof OtpVerificationStatus
     */
    'twilioToken'?: string;
    /**
     * Twilio phone number
     * @type {string}
     * @memberof OtpVerificationStatus
     */
    'twilioFrom'?: string;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'totalItems': number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'pageSize': number;
    /**
     * 
     * @type {number}
     * @memberof Pagination
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @interface PaymentBreakdown
 */
export interface PaymentBreakdown {
    /**
     * Amount originally paid
     * @type {number}
     * @memberof PaymentBreakdown
     */
    'paidAmount': number;
    /**
     * Amount refunded
     * @type {number}
     * @memberof PaymentBreakdown
     */
    'refundAmount': number;
    /**
     * Net amount charged
     * @type {number}
     * @memberof PaymentBreakdown
     */
    'netAmount': number;
    /**
     * Payment method used
     * @type {string}
     * @memberof PaymentBreakdown
     */
    'paymentMethod'?: string;
}
/**
 * 
 * @export
 * @interface PaymentGateway
 */
export interface PaymentGateway {
    /**
     * 
     * @type {string}
     * @memberof PaymentGateway
     */
    'gatewayType': PaymentGatewayGatewayTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentGateway
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentGateway
     */
    'isPrimary'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaymentGateway
     */
    'supportedCurrencies': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentGateway
     */
    'testMode'?: boolean;
}

export const PaymentGatewayGatewayTypeEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type PaymentGatewayGatewayTypeEnum = typeof PaymentGatewayGatewayTypeEnum[keyof typeof PaymentGatewayGatewayTypeEnum];

/**
 * 
 * @export
 * @interface PaymentGatewaysResponse
 */
export interface PaymentGatewaysResponse {
    /**
     * 
     * @type {Array<PaymentGateway>}
     * @memberof PaymentGatewaysResponse
     */
    'gateways': Array<PaymentGateway>;
}
/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'method': PaymentMethodMethodEnum;
}

export const PaymentMethodMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment'
} as const;

export type PaymentMethodMethodEnum = typeof PaymentMethodMethodEnum[keyof typeof PaymentMethodMethodEnum];

/**
 * 
 * @export
 * @interface PeakHourDataSchema
 */
export interface PeakHourDataSchema {
    /**
     * 
     * @type {string}
     * @memberof PeakHourDataSchema
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PeakHourDataSchema
     */
    'endTime'?: string;
    /**
     * The amount for the peak hour period
     * @type {number}
     * @memberof PeakHourDataSchema
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface PeakHourDeliveryFeeStatusSchema
 */
export interface PeakHourDeliveryFeeStatusSchema {
    /**
     * Peak hour delivery fee status
     * @type {string}
     * @memberof PeakHourDeliveryFeeStatusSchema
     */
    'type': PeakHourDeliveryFeeStatusSchemaTypeEnum;
    /**
     * 
     * @type {PeakHourDeliveryFeeStatusSchemaData}
     * @memberof PeakHourDeliveryFeeStatusSchema
     */
    'data'?: PeakHourDeliveryFeeStatusSchemaData;
}

export const PeakHourDeliveryFeeStatusSchemaTypeEnum = {
    Disable: 'disable',
    Enable: 'enable'
} as const;

export type PeakHourDeliveryFeeStatusSchemaTypeEnum = typeof PeakHourDeliveryFeeStatusSchemaTypeEnum[keyof typeof PeakHourDeliveryFeeStatusSchemaTypeEnum];

/**
 * 
 * @export
 * @interface PeakHourDeliveryFeeStatusSchemaData
 */
export interface PeakHourDeliveryFeeStatusSchemaData {
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'sunday'?: Array<PeakHourDataSchema>;
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'monday'?: Array<PeakHourDataSchema>;
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'tuesday'?: Array<PeakHourDataSchema>;
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'wednesday'?: Array<PeakHourDataSchema>;
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'thursday'?: Array<PeakHourDataSchema>;
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'friday'?: Array<PeakHourDataSchema>;
    /**
     * 
     * @type {Array<PeakHourDataSchema>}
     * @memberof PeakHourDeliveryFeeStatusSchemaData
     */
    'saturday'?: Array<PeakHourDataSchema>;
}
/**
 * 
 * @export
 * @interface PeakHoursConfiguration
 */
export interface PeakHoursConfiguration {
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'sunday'?: DayPeakHours;
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'monday'?: DayPeakHours;
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'tuesday'?: DayPeakHours;
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'wednesday'?: DayPeakHours;
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'thursday'?: DayPeakHours;
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'friday'?: DayPeakHours;
    /**
     * 
     * @type {DayPeakHours}
     * @memberof PeakHoursConfiguration
     */
    'saturday'?: DayPeakHours;
}
/**
 * 
 * @export
 * @interface PeakHoursDeliveryFeeStatus
 */
export interface PeakHoursDeliveryFeeStatus {
    /**
     * Enable/disable peak hours delivery fee
     * @type {boolean}
     * @memberof PeakHoursDeliveryFeeStatus
     */
    'status': boolean;
    /**
     * 
     * @type {PeakHoursConfiguration}
     * @memberof PeakHoursDeliveryFeeStatus
     */
    'peakHoursConfiguration'?: PeakHoursConfiguration;
}
/**
 * 
 * @export
 * @interface PeakHoursSettings
 */
export interface PeakHoursSettings {
    /**
     * 
     * @type {PeakHoursDeliveryFeeStatus}
     * @memberof PeakHoursSettings
     */
    'peakHoursDeliveryFeeStatus'?: PeakHoursDeliveryFeeStatus;
}
/**
 * 
 * @export
 * @interface PendingOrdersReportRequest
 */
export interface PendingOrdersReportRequest {
    /**
     * Array of store IDs to filter by (optional - omit to include all stores). Maximum 50 stores per request. 
     * @type {Array<string>}
     * @memberof PendingOrdersReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant/store owner ID to filter by (optional - omit to include all merchants). Admin users can access pending orders for any merchant. 
     * @type {string}
     * @memberof PendingOrdersReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types (optional - omit to include all types)
     * @type {Array<string>}
     * @memberof PendingOrdersReportRequest
     */
    'storeType'?: Array<PendingOrdersReportRequestStoreTypeEnum>;
    /**
     * Filter by current order status (optional - omit to include all pending statuses). These are statuses representing orders that are still in progress: - ORDER_PLACED: Order has been placed by customer - ORDER_ACCEPTED: Store has accepted the order - ORDER_READY_FOR_PICKUP: Store has prepared the order - DRIVER_ACCEPTED: Driver has accepted the delivery - DRIVER_ARRIVED: Driver has arrived at pickup location - DRIVER_PICKED_UP: Driver has picked up the order - DRIVER_ON_THE_WAY: Driver is on the way to customer 
     * @type {Array<string>}
     * @memberof PendingOrdersReportRequest
     */
    'currentStatus'?: Array<PendingOrdersReportRequestCurrentStatusEnum>;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to ORDER PLACED DATE (when order was created), not delivery completion date. - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof PendingOrdersReportRequest
     */
    'dateRange': PendingOrdersReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof PendingOrdersReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof PendingOrdersReportRequest
     */
    'dateTo'?: string;
}

export const PendingOrdersReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type PendingOrdersReportRequestStoreTypeEnum = typeof PendingOrdersReportRequestStoreTypeEnum[keyof typeof PendingOrdersReportRequestStoreTypeEnum];
export const PendingOrdersReportRequestCurrentStatusEnum = {
    OrderPlaced: 'ORDER_PLACED',
    OrderAccepted: 'ORDER_ACCEPTED',
    OrderReadyForPickup: 'ORDER_READY_FOR_PICKUP',
    DriverAccepted: 'DRIVER_ACCEPTED',
    DriverArrived: 'DRIVER_ARRIVED',
    DriverPickedUp: 'DRIVER_PICKED_UP',
    DriverOnTheWay: 'DRIVER_ON_THE_WAY'
} as const;

export type PendingOrdersReportRequestCurrentStatusEnum = typeof PendingOrdersReportRequestCurrentStatusEnum[keyof typeof PendingOrdersReportRequestCurrentStatusEnum];
export const PendingOrdersReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type PendingOrdersReportRequestDateRangeEnum = typeof PendingOrdersReportRequestDateRangeEnum[keyof typeof PendingOrdersReportRequestDateRangeEnum];

/**
 * Permission settings for different modules
 * @export
 * @interface Permissions
 */
export interface Permissions {
    /**
     * 
     * @type {ViewOnlyPermission}
     * @memberof Permissions
     */
    'dashboard'?: ViewOnlyPermission;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'storeCategory'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'itemCategory'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'itemSubCategory'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'choiceGroup'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'choices'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'storeOwner'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'store'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'customer'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'item'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'deliveryBoy'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'coupon'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'cms'?: SubAdminPermissions;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'faq'?: SubAdminPermissions;
    /**
     * 
     * @type {ReviewPermission}
     * @memberof Permissions
     */
    'storeReview'?: ReviewPermission;
    /**
     * 
     * @type {ReviewPermission}
     * @memberof Permissions
     */
    'deliveryReview'?: ReviewPermission;
    /**
     * 
     * @type {ViewOnlyPermission}
     * @memberof Permissions
     */
    'order'?: ViewOnlyPermission;
    /**
     * 
     * @type {InventoryPermission}
     * @memberof Permissions
     */
    'inventory'?: InventoryPermission;
    /**
     * 
     * @type {SettingsPermission}
     * @memberof Permissions
     */
    'settings'?: SettingsPermission;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'referFriend'?: SubAdminPermissions;
    /**
     * 
     * @type {NewsLetterPermission}
     * @memberof Permissions
     */
    'newsLetter'?: NewsLetterPermission;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'deliveryBoyMap'?: SubAdminPermissions;
    /**
     * 
     * @type {ReportsPermission}
     * @memberof Permissions
     */
    'reports'?: ReportsPermission;
    /**
     * 
     * @type {SubAdminPermissions}
     * @memberof Permissions
     */
    'promotionalAndOffers'?: SubAdminPermissions;
    /**
     * 
     * @type {WalletPermission}
     * @memberof Permissions
     */
    'wallet'?: WalletPermission;
    /**
     * 
     * @type {SettlementPermission}
     * @memberof Permissions
     */
    'settlement'?: SettlementPermission;
    /**
     * 
     * @type {PushNotificationPermission}
     * @memberof Permissions
     */
    'pushNotification'?: PushNotificationPermission;
}
/**
 * 
 * @export
 * @interface PharmacyStore
 */
export interface PharmacyStore {
    /**
     * The ID of the store
     * @type {string}
     * @memberof PharmacyStore
     */
    'id'?: string;
    /**
     * The merchant ID (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'merchantId': string;
    /**
     * The category IDs of the store
     * @type {Array<string>}
     * @memberof PharmacyStore
     */
    'categoryId'?: Array<string>;
    /**
     * The name of the store (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'storeName': string;
    /**
     * The Arabic name of the store
     * @type {string}
     * @memberof PharmacyStore
     */
    'storeNameArabic'?: string;
    /**
     * 
     * @type {MinOrderAmountSchema}
     * @memberof PharmacyStore
     */
    'minOrderAmount': MinOrderAmountSchema;
    /**
     * Whether the store allows pre-ordering (mandatory)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'canPreOrder': boolean;
    /**
     * Whether the store offers self-pickup (optional, default is false)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'hasSelfPickup': boolean;
    /**
     * Whether delivery is available (optional, default is true)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'deliveryAvailable': boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaDeliveryFee}
     * @memberof PharmacyStore
     */
    'deliveryFee': WritableRestaurantDataSchemaDeliveryFee;
    /**
     * 
     * @type {TimeDataSchema}
     * @memberof PharmacyStore
     */
    'deliveryTime': TimeDataSchema;
    /**
     * Description of the store in English (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'aboutStore': string;
    /**
     * Description of the store in Arabic (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'aboutStoreArabic'?: string;
    /**
     * Delivery radius in kilometers (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'deliveryRadiusKM': string;
    /**
     * Store phone number (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'storePhoneNumber': string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof PharmacyStore
     */
    'storeAddress': RestaurantAddressSchema;
    /**
     * URL of the store logo (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'storeLogo': string;
    /**
     * URLs of the store banners (mandatory)
     * @type {Array<string>}
     * @memberof PharmacyStore
     */
    'storeBanner': Array<string>;
    /**
     * 
     * @type {WorkingHoursSchema}
     * @memberof PharmacyStore
     */
    'workingHours': WorkingHoursSchema;
    /**
     * Whether cancellation is allowed (optional, default is true)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'isCancellationAllowed'?: boolean;
    /**
     * Cancellation policy of the store (optional, default is \"No cancellation\")
     * @type {string}
     * @memberof PharmacyStore
     */
    'cancellationPolicy'?: string;
    /**
     * Cancellation fee (optional, default is \"0\")
     * @type {string}
     * @memberof PharmacyStore
     */
    'cancellationFee'?: string;
    /**
     * Whether the store is wishlisted (optional, default is false)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'isWishListed'?: boolean;
    /**
     * Rating of the store (optional, default is 0)
     * @type {number}
     * @memberof PharmacyStore
     */
    'rating'?: number;
    /**
     * Type of store (mandatory)
     * @type {string}
     * @memberof PharmacyStore
     */
    'storeType': PharmacyStoreStoreTypeEnum;
    /**
     * Whether the pharmacy accepts additional packaging requests (mandatory)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'additionalPackagingRequest': boolean;
    /**
     * Whether a prescription is needed for the pharmacy (mandatory)
     * @type {boolean}
     * @memberof PharmacyStore
     */
    'prescriptionNeeded'?: boolean;
}

export const PharmacyStoreStoreTypeEnum = {
    PharmacyStore: 'PharmacyStore'
} as const;

export type PharmacyStoreStoreTypeEnum = typeof PharmacyStoreStoreTypeEnum[keyof typeof PharmacyStoreStoreTypeEnum];

/**
 * 
 * @export
 * @interface PickupStatus
 */
export interface PickupStatus {
    /**
     * Whether items were picked up
     * @type {boolean}
     * @memberof PickupStatus
     */
    'isPickedUp': boolean;
    /**
     * Whether store has confirmed items
     * @type {boolean}
     * @memberof PickupStatus
     */
    'hasConfirmedItems': boolean;
    /**
     * Pickup completion time
     * @type {string}
     * @memberof PickupStatus
     */
    'pickupTime'?: string;
    /**
     * Items pending pickup
     * @type {number}
     * @memberof PickupStatus
     */
    'pendingItemsCount'?: number;
    /**
     * Estimated pickup time
     * @type {string}
     * @memberof PickupStatus
     */
    'estimatedPickupTime'?: string;
}
/**
 * 
 * @export
 * @interface PreFooterSettings
 */
export interface PreFooterSettings {
    /**
     * Pre-footer title in default language
     * @type {string}
     * @memberof PreFooterSettings
     */
    'preFooterTitle'?: string;
    /**
     * Pre-footer title in Arabic
     * @type {string}
     * @memberof PreFooterSettings
     */
    'preFooterTitleArabic'?: string;
    /**
     * Pre-footer description in default language
     * @type {string}
     * @memberof PreFooterSettings
     */
    'preFooterDescription'?: string;
    /**
     * Pre-footer description in Arabic
     * @type {string}
     * @memberof PreFooterSettings
     */
    'preFooterDescriptionArabic'?: string;
    /**
     * Pre-footer image URL (380x640 to 400x670 pixels)
     * @type {string}
     * @memberof PreFooterSettings
     */
    'preFooterImage'?: string;
}
/**
 * 
 * @export
 * @interface PreOrderSettings
 */
export interface PreOrderSettings {
    /**
     * 
     * @type {PreOrderStatus}
     * @memberof PreOrderSettings
     */
    'preOrderStatus'?: PreOrderStatus;
}
/**
 * 
 * @export
 * @interface PreOrderStatus
 */
export interface PreOrderStatus {
    /**
     * Enable/disable pre-order functionality
     * @type {boolean}
     * @memberof PreOrderStatus
     */
    'status'?: boolean;
    /**
     * Time in seconds for merchant to accept pre-order (default 600 = 10 minutes)
     * @type {number}
     * @memberof PreOrderStatus
     */
    'merchantAcceptanceTimeInSeconds'?: number;
    /**
     * Minutes before scheduled time to start processing pre-order (default 60 minutes)
     * @type {number}
     * @memberof PreOrderStatus
     */
    'processStartBeforeMinutes'?: number;
    /**
     * Minimum advance time in minutes to place pre-order (default 360 = 6 hours)
     * @type {number}
     * @memberof PreOrderStatus
     */
    'minimumAdvanceMinutes'?: number;
    /**
     * Maximum advance time in days to place pre-order (default 7 days)
     * @type {number}
     * @memberof PreOrderStatus
     */
    'maximumAdvanceDays'?: number;
}
/**
 * 
 * @export
 * @interface PrepareOrderErrorResponseSchema
 */
export interface PrepareOrderErrorResponseSchema {
    /**
     * Always false for error responses
     * @type {boolean}
     * @memberof PrepareOrderErrorResponseSchema
     */
    'success': boolean;
    /**
     * HTTP status code
     * @type {number}
     * @memberof PrepareOrderErrorResponseSchema
     */
    'statusCode': number;
    /**
     * Detailed validation errors with types and messages
     * @type {Array<ValidationErrorSchema>}
     * @memberof PrepareOrderErrorResponseSchema
     */
    'validationErrors': Array<ValidationErrorSchema>;
}
/**
 * 
 * @export
 * @interface PrepareOrderRequestSchema
 */
export interface PrepareOrderRequestSchema {
    /**
     * Type of order - immediate or scheduled for later. At least one of orderMode or deliveryMode must be provided
     * @type {string}
     * @memberof PrepareOrderRequestSchema
     */
    'orderMode'?: PrepareOrderRequestSchemaOrderModeEnum;
    /**
     * How the order will be fulfilled. At least one of orderMode or deliveryMode must be provided
     * @type {string}
     * @memberof PrepareOrderRequestSchema
     */
    'deliveryMode'?: PrepareOrderRequestSchemaDeliveryModeEnum;
    /**
     * Required when orderMode is \'preOrder\'. ISO 8601 datetime string
     * @type {string}
     * @memberof PrepareOrderRequestSchema
     */
    'preOrderDateTime'?: string;
    /**
     * 
     * @type {DeliveryAddressSchema}
     * @memberof PrepareOrderRequestSchema
     */
    'deliveryAddress'?: DeliveryAddressSchema;
    /**
     * Special delivery instructions for the driver
     * @type {string}
     * @memberof PrepareOrderRequestSchema
     */
    'noteToDriver'?: string;
    /**
     * Prescription URL for pharmacy items (order-level, required if any item needs prescription)
     * @type {string}
     * @memberof PrepareOrderRequestSchema
     */
    'prescriptionUrl'?: string;
}

export const PrepareOrderRequestSchemaOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;

export type PrepareOrderRequestSchemaOrderModeEnum = typeof PrepareOrderRequestSchemaOrderModeEnum[keyof typeof PrepareOrderRequestSchemaOrderModeEnum];
export const PrepareOrderRequestSchemaDeliveryModeEnum = {
    SelfPickup: 'selfPickup',
    Delivery: 'delivery'
} as const;

export type PrepareOrderRequestSchemaDeliveryModeEnum = typeof PrepareOrderRequestSchemaDeliveryModeEnum[keyof typeof PrepareOrderRequestSchemaDeliveryModeEnum];

/**
 * 
 * @export
 * @interface PrepareOrderResponseSchema
 */
export interface PrepareOrderResponseSchema {
    /**
     * Whether order preparation was successful
     * @type {boolean}
     * @memberof PrepareOrderResponseSchema
     */
    'success': boolean;
    /**
     * 
     * @type {OrderSummarySchema}
     * @memberof PrepareOrderResponseSchema
     */
    'orderSummary': OrderSummarySchema;
}
/**
 * Public-facing settings response with no sensitive credentials
 * @export
 * @interface PublicSettingsResponse
 */
export interface PublicSettingsResponse {
    /**
     * 
     * @type {PublicSettingsResponseOnboardingSlides}
     * @memberof PublicSettingsResponse
     */
    'onboardingSlides'?: PublicSettingsResponseOnboardingSlides;
    /**
     * 
     * @type {PublicSettingsResponseDesign}
     * @memberof PublicSettingsResponse
     */
    'design'?: PublicSettingsResponseDesign;
    /**
     * 
     * @type {PublicSettingsResponseSocialLogin}
     * @memberof PublicSettingsResponse
     */
    'socialLogin'?: PublicSettingsResponseSocialLogin;
    /**
     * 
     * @type {PublicSettingsResponseGoogleMaps}
     * @memberof PublicSettingsResponse
     */
    'googleMaps'?: PublicSettingsResponseGoogleMaps;
    /**
     * 
     * @type {PublicSettingsResponseGeneral}
     * @memberof PublicSettingsResponse
     */
    'general'?: PublicSettingsResponseGeneral;
    /**
     * 
     * @type {Array<PublicSettingsResponseBannersInner>}
     * @memberof PublicSettingsResponse
     */
    'banners'?: Array<PublicSettingsResponseBannersInner>;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseBannersInner
 */
export interface PublicSettingsResponseBannersInner {
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'storeType'?: PublicSettingsResponseBannersInnerStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'imageText'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'redirectUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'buttonText'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'bannerStartTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'bannerEndTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseBannersInner
     */
    'status'?: string;
}

export const PublicSettingsResponseBannersInnerStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type PublicSettingsResponseBannersInnerStoreTypeEnum = typeof PublicSettingsResponseBannersInnerStoreTypeEnum[keyof typeof PublicSettingsResponseBannersInnerStoreTypeEnum];

/**
 * 
 * @export
 * @interface PublicSettingsResponseDesign
 */
export interface PublicSettingsResponseDesign {
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseDesign
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseDesign
     */
    'faviconUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseDesign
     */
    'splashScreenUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseDesign
     */
    'heroImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseDesign
     */
    'appColor'?: string;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseGeneral
 */
export interface PublicSettingsResponseGeneral {
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'siteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'siteDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'metaTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'metaKeywords'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'metaDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'footerText'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'footerDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'preFooterTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'preFooterDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'preFooterImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'loginImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'featuredRestaurantImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'contactEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'contactPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'itunesUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'playStoreUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'timeZone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneral
     */
    'dateTimeFormat'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'couponStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'mailVerificationStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'otpVerificationEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'noContactDeliveryStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'selfPickupStatus'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'showOutOfStockProducts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'showStock'?: boolean;
    /**
     * Enable/disable My Rewards feature (mapped from loyaltyRewardsStatus.status)
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'myRewardsToggle'?: boolean;
    /**
     * Enable/disable My Offers feature (mapped from couponStatus)
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'myOffersToggle'?: boolean;
    /**
     * Enable/disable Refer a Friend feature (mapped from referFriends.status)
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'referFriendToggle'?: boolean;
    /**
     * Enable/disable Pre-Order functionality (mapped from preOrderStatus.status)
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'preOrderToggle'?: boolean;
    /**
     * 
     * @type {PublicSettingsResponseGeneralDeliveryRadius}
     * @memberof PublicSettingsResponseGeneral
     */
    'deliveryRadius'?: PublicSettingsResponseGeneralDeliveryRadius;
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneral
     */
    'featuredRestaurantEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseGeneralDeliveryRadius
 */
export interface PublicSettingsResponseGeneralDeliveryRadius {
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGeneralDeliveryRadius
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublicSettingsResponseGeneralDeliveryRadius
     */
    'radius'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseGeneralDeliveryRadius
     */
    'unit'?: PublicSettingsResponseGeneralDeliveryRadiusUnitEnum;
}

export const PublicSettingsResponseGeneralDeliveryRadiusUnitEnum = {
    Kilometers: 'kilometers',
    Miles: 'miles'
} as const;

export type PublicSettingsResponseGeneralDeliveryRadiusUnitEnum = typeof PublicSettingsResponseGeneralDeliveryRadiusUnitEnum[keyof typeof PublicSettingsResponseGeneralDeliveryRadiusUnitEnum];

/**
 * 
 * @export
 * @interface PublicSettingsResponseGoogleMaps
 */
export interface PublicSettingsResponseGoogleMaps {
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseGoogleMaps
     */
    'isEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseOnboardingSlides
 */
export interface PublicSettingsResponseOnboardingSlides {
    /**
     * 
     * @type {Array<PublicSettingsResponseOnboardingSlidesScreensInner>}
     * @memberof PublicSettingsResponseOnboardingSlides
     */
    'screens'?: Array<PublicSettingsResponseOnboardingSlidesScreensInner>;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseOnboardingSlidesScreensInner
 */
export interface PublicSettingsResponseOnboardingSlidesScreensInner {
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseOnboardingSlidesScreensInner
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseOnboardingSlidesScreensInner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseOnboardingSlidesScreensInner
     */
    'imageUrl'?: string;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseSocialLogin
 */
export interface PublicSettingsResponseSocialLogin {
    /**
     * 
     * @type {PublicSettingsResponseSocialLoginGoogle}
     * @memberof PublicSettingsResponseSocialLogin
     */
    'google'?: PublicSettingsResponseSocialLoginGoogle;
    /**
     * 
     * @type {PublicSettingsResponseSocialLoginGoogle}
     * @memberof PublicSettingsResponseSocialLogin
     */
    'facebook'?: PublicSettingsResponseSocialLoginGoogle;
    /**
     * 
     * @type {PublicSettingsResponseSocialLoginGoogle}
     * @memberof PublicSettingsResponseSocialLogin
     */
    'apple'?: PublicSettingsResponseSocialLoginGoogle;
}
/**
 * 
 * @export
 * @interface PublicSettingsResponseSocialLoginGoogle
 */
export interface PublicSettingsResponseSocialLoginGoogle {
    /**
     * 
     * @type {boolean}
     * @memberof PublicSettingsResponseSocialLoginGoogle
     */
    'isEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingsResponseSocialLoginGoogle
     */
    'buttonText'?: string;
}
/**
 * Request to purchase featured store subscription
 * @export
 * @interface PurchaseFeaturedStoreRequest
 */
export interface PurchaseFeaturedStoreRequest {
    /**
     * ID of the store to feature
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'storeId': string;
    /**
     * ID of the merchant who owns the store
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'merchantId': string;
    /**
     * Start date for featured store subscription
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'fromDate': string;
    /**
     * End date for featured store subscription
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'toDate': string;
    /**
     * Currency code for the transaction
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'currencyCode'?: string;
    /**
     * Payment gateway to use
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'paymentMethod': PurchaseFeaturedStoreRequestPaymentMethodEnum;
    /**
     * Platform type (determines response format)
     * @type {string}
     * @memberof PurchaseFeaturedStoreRequest
     */
    'platform'?: PurchaseFeaturedStoreRequestPlatformEnum;
}

export const PurchaseFeaturedStoreRequestPaymentMethodEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type PurchaseFeaturedStoreRequestPaymentMethodEnum = typeof PurchaseFeaturedStoreRequestPaymentMethodEnum[keyof typeof PurchaseFeaturedStoreRequestPaymentMethodEnum];
export const PurchaseFeaturedStoreRequestPlatformEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;

export type PurchaseFeaturedStoreRequestPlatformEnum = typeof PurchaseFeaturedStoreRequestPlatformEnum[keyof typeof PurchaseFeaturedStoreRequestPlatformEnum];

/**
 * Response after initiating featured store purchase
 * @export
 * @interface PurchaseFeaturedStoreResponse
 */
export interface PurchaseFeaturedStoreResponse {
    /**
     * Featured store subscription ID
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'subscriptionId': string;
    /**
     * Payment gateway checkout/session I
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'checkoutId': string;
    /**
     * Payment gateway checkout URL (for web)
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'checkoutUrl'?: string;
    /**
     * Payment intent client secret (for mobile Stripe)
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'clientSecret'?: string;
    /**
     * Ephemeral key for Stripe mobile SDK
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'ephemeralKey'?: string;
    /**
     * Stripe customer ID (for mobile)
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'customerId'?: string;
    /**
     * Stripe publishable key (for mobile)
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'publishableKey'?: string;
    /**
     * Payment gateway type being used
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'gatewayType': PurchaseFeaturedStoreResponseGatewayTypeEnum;
    /**
     * Total price to pay
     * @type {number}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'totalPrice'?: number;
    /**
     * Price per day
     * @type {number}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'pricePerDay'?: number;
    /**
     * Number of days
     * @type {number}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'numberOfDays'?: number;
    /**
     * Currency code
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'currency'?: string;
    /**
     * Checkout session expiry time
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'expiresAt': string;
    /**
     * User-friendly message
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'message': string;
    /**
     * Shopper result URL for HyperPay
     * @type {string}
     * @memberof PurchaseFeaturedStoreResponse
     */
    'shopperResultUrl'?: string;
}

export const PurchaseFeaturedStoreResponseGatewayTypeEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type PurchaseFeaturedStoreResponseGatewayTypeEnum = typeof PurchaseFeaturedStoreResponseGatewayTypeEnum[keyof typeof PurchaseFeaturedStoreResponseGatewayTypeEnum];

/**
 * Permission settings for push notification module
 * @export
 * @interface PushNotificationPermission
 */
export interface PushNotificationPermission {
    /**
     * Can send push notifications
     * @type {boolean}
     * @memberof PushNotificationPermission
     */
    'add'?: boolean;
}
/**
 * Breakdown of reviews by star rating
 * @export
 * @interface RatingBreakdownSchema
 */
export interface RatingBreakdownSchema {
    /**
     * Number of 1-star reviews
     * @type {number}
     * @memberof RatingBreakdownSchema
     */
    '1'?: number;
    /**
     * Number of 2-star reviews
     * @type {number}
     * @memberof RatingBreakdownSchema
     */
    '2'?: number;
    /**
     * Number of 3-star reviews
     * @type {number}
     * @memberof RatingBreakdownSchema
     */
    '3'?: number;
    /**
     * Number of 4-star reviews
     * @type {number}
     * @memberof RatingBreakdownSchema
     */
    '4'?: number;
    /**
     * Number of 5-star reviews
     * @type {number}
     * @memberof RatingBreakdownSchema
     */
    '5'?: number;
}
/**
 * 
 * @export
 * @interface RecentCustomer
 */
export interface RecentCustomer {
    /**
     * Full name of the recently added customer.
     * @type {string}
     * @memberof RecentCustomer
     */
    'customerName': string;
    /**
     * Email address of the customer.
     * @type {string}
     * @memberof RecentCustomer
     */
    'email': string;
    /**
     * Phone number of the customer.
     * @type {string}
     * @memberof RecentCustomer
     */
    'customerPhone': string;
    /**
     * Current status of the customer account (e.g. Active, Pending).
     * @type {string}
     * @memberof RecentCustomer
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface RecentMerchant
 */
export interface RecentMerchant {
    /**
     * Full name of the merchant.
     * @type {string}
     * @memberof RecentMerchant
     */
    'merchantName': string;
    /**
     * Email address of the merchant.
     * @type {string}
     * @memberof RecentMerchant
     */
    'email': string;
    /**
     * Contact phone number of the merchant.
     * @type {string}
     * @memberof RecentMerchant
     */
    'phone': string;
    /**
     * Current operational status of the merchant (e.g. Active, Inactive).
     * @type {string}
     * @memberof RecentMerchant
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface RecentOrder
 */
export interface RecentOrder {
    /**
     * Full name of the recently added customer.
     * @type {string}
     * @memberof RecentOrder
     */
    'customerName': string;
    /**
     * Quantity of items in the order.
     * @type {number}
     * @memberof RecentOrder
     */
    'itemQuantity': number;
    /**
     * Total amount for the order.
     * @type {number}
     * @memberof RecentOrder
     */
    'Amount': number;
}
/**
 * 
 * @export
 * @interface RedeemPointsRequest
 */
export interface RedeemPointsRequest {
    /**
     * The ID of the user
     * @type {string}
     * @memberof RedeemPointsRequest
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface RedeemPointsResponse
 */
export interface RedeemPointsResponse {
    /**
     * Number of points redeemed
     * @type {number}
     * @memberof RedeemPointsResponse
     */
    'pointsRedeemed': number;
    /**
     * Amount credited to wallet
     * @type {number}
     * @memberof RedeemPointsResponse
     */
    'walletCreditAmount': number;
    /**
     * Points remaining after redemption
     * @type {number}
     * @memberof RedeemPointsResponse
     */
    'remainingPoints': number;
    /**
     * Wallet transaction ID for the credit
     * @type {string}
     * @memberof RedeemPointsResponse
     */
    'walletTransactionId': string;
}
/**
 * 
 * @export
 * @interface ReferFriends
 */
export interface ReferFriends {
    /**
     * Enable/disable refer friends feature
     * @type {boolean}
     * @memberof ReferFriends
     */
    'status': boolean;
    /**
     * Referral offer percentage
     * @type {number}
     * @memberof ReferFriends
     */
    'offerPercentage'?: number;
    /**
     * Maximum referral amount
     * @type {number}
     * @memberof ReferFriends
     */
    'maxReferralAmount'?: number;
}
/**
 * 
 * @export
 * @interface ReferalAndSecurity
 */
export interface ReferalAndSecurity {
    /**
     * 
     * @type {ReferFriends}
     * @memberof ReferalAndSecurity
     */
    'referFriends'?: ReferFriends;
    /**
     * Enable/disable password protection
     * @type {boolean}
     * @memberof ReferalAndSecurity
     */
    'passwordProtection'?: boolean;
    /**
     * Show or hide captcha
     * @type {boolean}
     * @memberof ReferalAndSecurity
     */
    'showCaptcha'?: boolean;
    /**
     * Suspend customer after invalid login attempts
     * @type {boolean}
     * @memberof ReferalAndSecurity
     */
    'invalidLoginSuspendCustomer'?: boolean;
}
/**
 * 
 * @export
 * @interface ReferralCodeSchema
 */
export interface ReferralCodeSchema {
    /**
     * Unique referral code generated for the user
     * @type {string}
     * @memberof ReferralCodeSchema
     */
    'referralCode': string;
    /**
     * ID of the user who generated this referral code
     * @type {string}
     * @memberof ReferralCodeSchema
     */
    'referrerUserId': string;
    /**
     * Timestamp when the referral code was created
     * @type {string}
     * @memberof ReferralCodeSchema
     */
    'createdAt': string;
    /**
     * Whether this referral code has been used (one-time use only)
     * @type {boolean}
     * @memberof ReferralCodeSchema
     */
    'isUsed': boolean;
    /**
     * Timestamp when the referral code was used (null if unused)
     * @type {string}
     * @memberof ReferralCodeSchema
     */
    'usedAt'?: string | null;
    /**
     * ID of the user who used this referral code (null if unused)
     * @type {string}
     * @memberof ReferralCodeSchema
     */
    'usedByUserId'?: string | null;
}
/**
 * 
 * @export
 * @interface ReferralReportItem
 */
export interface ReferralReportItem {
    /**
     * Unique identifier for the referral
     * @type {string}
     * @memberof ReferralReportItem
     */
    'referralId': string;
    /**
     * Name of the user who created the referral code
     * @type {string}
     * @memberof ReferralReportItem
     */
    'referrerUserName': string;
    /**
     * The referral code
     * @type {string}
     * @memberof ReferralReportItem
     */
    'referralCode': string;
    /**
     * Name of the user who used the referral code (null if not used)
     * @type {string}
     * @memberof ReferralReportItem
     */
    'usedUserName': string | null;
    /**
     * Percentage offered as referral reward
     * @type {number}
     * @memberof ReferralReportItem
     */
    'offerPercentage': number;
    /**
     * Amount credited to wallet as referral reward
     * @type {number}
     * @memberof ReferralReportItem
     */
    'walletAmount': number;
    /**
     * Current status of the referral
     * @type {string}
     * @memberof ReferralReportItem
     */
    'status': ReferralReportItemStatusEnum;
    /**
     * When the referral code was created
     * @type {string}
     * @memberof ReferralReportItem
     */
    'createdAt': string;
    /**
     * When the referral code was used (null if not used)
     * @type {string}
     * @memberof ReferralReportItem
     */
    'usedAt': string | null;
}

export const ReferralReportItemStatusEnum = {
    Initiated: 'Initiated',
    SignedUp: 'SignedUp',
    WalletPaid: 'WalletPaid'
} as const;

export type ReferralReportItemStatusEnum = typeof ReferralReportItemStatusEnum[keyof typeof ReferralReportItemStatusEnum];

/**
 * 
 * @export
 * @interface ReferralReportResponse
 */
export interface ReferralReportResponse {
    /**
     * Array of referral report items
     * @type {Array<ReferralReportItem>}
     * @memberof ReferralReportResponse
     */
    'data': Array<ReferralReportItem>;
    /**
     * 
     * @type {Pagination}
     * @memberof ReferralReportResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface RefreshTokenRequestSchema
 */
export interface RefreshTokenRequestSchema {
    /**
     * Refresh token
     * @type {string}
     * @memberof RefreshTokenRequestSchema
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface RefundInformation
 */
export interface RefundInformation {
    /**
     * Total refund amount across all stores
     * @type {number}
     * @memberof RefundInformation
     */
    'totalRefundAmount': number;
    /**
     * Overall refund status
     * @type {string}
     * @memberof RefundInformation
     */
    'refundStatus': RefundInformationRefundStatusEnum;
    /**
     * Refund reason summary
     * @type {string}
     * @memberof RefundInformation
     */
    'refundReason'?: string;
    /**
     * Refund processing time
     * @type {string}
     * @memberof RefundInformation
     */
    'processedAt'?: string;
    /**
     * Estimated time for refund to reflect
     * @type {string}
     * @memberof RefundInformation
     */
    'estimatedRefundTime'?: string;
    /**
     * Refund breakdown by store
     * @type {Array<StoreRefund>}
     * @memberof RefundInformation
     */
    'storeRefunds': Array<StoreRefund>;
}

export const RefundInformationRefundStatusEnum = {
    Processed: 'processed',
    Pending: 'pending',
    Failed: 'failed',
    Partial: 'partial'
} as const;

export type RefundInformationRefundStatusEnum = typeof RefundInformationRefundStatusEnum[keyof typeof RefundInformationRefundStatusEnum];

/**
 * 
 * @export
 * @interface RefundReportRequest
 */
export interface RefundReportRequest {
    /**
     * Array of store IDs to filter by (optional - omit to include all stores). Maximum 50 stores per request. 
     * @type {Array<string>}
     * @memberof RefundReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant/store owner ID to filter by (optional - omit to include all merchants). Admin users can access refunds for any merchant. 
     * @type {string}
     * @memberof RefundReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types (optional - omit to include all types)
     * @type {Array<string>}
     * @memberof RefundReportRequest
     */
    'storeType'?: Array<RefundReportRequestStoreTypeEnum>;
    /**
     * Filter by refund processing status (optional - omit to include all statuses). - initiated: Refund process has been started but not yet completed - completed: Refund has been successfully processed - failed: Refund processing failed 
     * @type {Array<string>}
     * @memberof RefundReportRequest
     */
    'refundStatus'?: Array<RefundReportRequestRefundStatusEnum>;
    /**
     * Filter by refund method (optional - omit to include all methods). - wallet: Refund issued to customer\'s wallet - online: Refund issued via online payment gateway - manual: Manual refund processing 
     * @type {Array<string>}
     * @memberof RefundReportRequest
     */
    'refundMethod'?: Array<RefundReportRequestRefundMethodEnum>;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to REFUND DATE (when refund was processed), not order creation date. - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof RefundReportRequest
     */
    'dateRange': RefundReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof RefundReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof RefundReportRequest
     */
    'dateTo'?: string;
}

export const RefundReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type RefundReportRequestStoreTypeEnum = typeof RefundReportRequestStoreTypeEnum[keyof typeof RefundReportRequestStoreTypeEnum];
export const RefundReportRequestRefundStatusEnum = {
    Initiated: 'initiated',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type RefundReportRequestRefundStatusEnum = typeof RefundReportRequestRefundStatusEnum[keyof typeof RefundReportRequestRefundStatusEnum];
export const RefundReportRequestRefundMethodEnum = {
    Wallet: 'wallet',
    Online: 'online',
    Manual: 'manual'
} as const;

export type RefundReportRequestRefundMethodEnum = typeof RefundReportRequestRefundMethodEnum[keyof typeof RefundReportRequestRefundMethodEnum];
export const RefundReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type RefundReportRequestDateRangeEnum = typeof RefundReportRequestDateRangeEnum[keyof typeof RefundReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface RejectedOrdersReportRequest
 */
export interface RejectedOrdersReportRequest {
    /**
     * Array of store IDs to filter by (optional - omit to include all stores). Maximum 50 stores per request. Note: Merchant users are auto-scoped to their own stores regardless of this parameter. 
     * @type {Array<string>}
     * @memberof RejectedOrdersReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant ID to filter by (optional - omit to include all merchants). Merchants can only access their own stores. Admin users can filter by any merchant. 
     * @type {string}
     * @memberof RejectedOrdersReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types (optional - omit to include all types)
     * @type {Array<string>}
     * @memberof RejectedOrdersReportRequest
     */
    'storeType'?: Array<RejectedOrdersReportRequestStoreTypeEnum>;
    /**
     * Array of delivery partner IDs to filter by (optional - omit to include all delivery partners). Maximum 50 delivery partners per request.  **Admin Only**: This filter is only available to admin users. For merchant users, this parameter is ignored as merchants cannot access delivery partner rejection data. 
     * @type {Array<string>}
     * @memberof RejectedOrdersReportRequest
     */
    'deliveryPartnerIds'?: Array<string>;
    /**
     * Specifies which type of rejection report to generate (optional). - merchant_rejected: Generate report for merchant/store rejections only - driver_rejected: Generate report for delivery partner rejections only  If omitted, defaults to merchant_rejected for merchant users, and includes both types for admin users.  **Admin Only**: Admin users can choose either type. Merchant users can only access merchant_rejected data. 
     * @type {string}
     * @memberof RejectedOrdersReportRequest
     */
    'rejectedBy'?: RejectedOrdersReportRequestRejectedByEnum;
    /**
     * Predefined date range periods or \'custom\' for custom date range. Applies to REJECTION TIME (when order/items were rejected), not order creation date. - today: From midnight today to now - thisWeek: From start of current week (Sunday) to now - thisMonth: From start of current month to now - last30Days: Last 30 days from now - thisYear: From January 1st of current year to now - custom: Use dateFrom and dateTo parameters 
     * @type {string}
     * @memberof RejectedOrdersReportRequest
     */
    'dateRange': RejectedOrdersReportRequestDateRangeEnum;
    /**
     * Start date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-01-01T00:00:00.000Z 
     * @type {string}
     * @memberof RejectedOrdersReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date for report (ISO 8601 format, UTC). Required if dateRange is \'custom\', ignored otherwise. Example: 2024-12-31T23:59:59.999Z 
     * @type {string}
     * @memberof RejectedOrdersReportRequest
     */
    'dateTo'?: string;
}

export const RejectedOrdersReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type RejectedOrdersReportRequestStoreTypeEnum = typeof RejectedOrdersReportRequestStoreTypeEnum[keyof typeof RejectedOrdersReportRequestStoreTypeEnum];
export const RejectedOrdersReportRequestRejectedByEnum = {
    MerchantRejected: 'merchant_rejected',
    DriverRejected: 'driver_rejected'
} as const;

export type RejectedOrdersReportRequestRejectedByEnum = typeof RejectedOrdersReportRequestRejectedByEnum[keyof typeof RejectedOrdersReportRequestRejectedByEnum];
export const RejectedOrdersReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type RejectedOrdersReportRequestDateRangeEnum = typeof RejectedOrdersReportRequestDateRangeEnum[keyof typeof RejectedOrdersReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface RemoveCouponRequest
 */
export interface RemoveCouponRequest {
    /**
     * The ID of the user removing the coupon
     * @type {string}
     * @memberof RemoveCouponRequest
     */
    'userId': string;
    /**
     * The ID of the store where the coupon is being removed
     * @type {string}
     * @memberof RemoveCouponRequest
     */
    'storeId': string;
    /**
     * The action to remove the coupon
     * @type {string}
     * @memberof RemoveCouponRequest
     */
    'action': RemoveCouponRequestActionEnum;
}

export const RemoveCouponRequestActionEnum = {
    Remove: 'remove'
} as const;

export type RemoveCouponRequestActionEnum = typeof RemoveCouponRequestActionEnum[keyof typeof RemoveCouponRequestActionEnum];

/**
 * Permission settings for reports
 * @export
 * @interface ReportsPermission
 */
export interface ReportsPermission {
    /**
     * Can view reports
     * @type {boolean}
     * @memberof ReportsPermission
     */
    'view'?: boolean;
    /**
     * Can export reports
     * @type {boolean}
     * @memberof ReportsPermission
     */
    'export'?: boolean;
}
/**
 * 
 * @export
 * @interface ResendOtpRequestSchema
 */
export interface ResendOtpRequestSchema {
    /**
     * User\'s mobile number
     * @type {number}
     * @memberof ResendOtpRequestSchema
     */
    'mobileNumber': number;
}
/**
 * 
 * @export
 * @interface ResetByEmail
 */
export interface ResetByEmail {
    /**
     * 
     * @type {string}
     * @memberof ResetByEmail
     */
    'channel': ResetByEmailChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof ResetByEmail
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ResetByEmail
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ResetByEmail
     */
    'platformType': ResetByEmailPlatformTypeEnum;
}

export const ResetByEmailChannelEnum = {
    Email: 'email'
} as const;

export type ResetByEmailChannelEnum = typeof ResetByEmailChannelEnum[keyof typeof ResetByEmailChannelEnum];
export const ResetByEmailPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ResetByEmailPlatformTypeEnum = typeof ResetByEmailPlatformTypeEnum[keyof typeof ResetByEmailPlatformTypeEnum];

/**
 * 
 * @export
 * @interface ResetByPhone
 */
export interface ResetByPhone {
    /**
     * 
     * @type {string}
     * @memberof ResetByPhone
     */
    'channel': ResetByPhoneChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof ResetByPhone
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ResetByPhone
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ResetByPhone
     */
    'platformType': ResetByPhonePlatformTypeEnum;
}

export const ResetByPhoneChannelEnum = {
    Phone: 'phone'
} as const;

export type ResetByPhoneChannelEnum = typeof ResetByPhoneChannelEnum[keyof typeof ResetByPhoneChannelEnum];
export const ResetByPhonePlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ResetByPhonePlatformTypeEnum = typeof ResetByPhonePlatformTypeEnum[keyof typeof ResetByPhonePlatformTypeEnum];

/**
 * 
 * @export
 * @interface ResetPasswordRequestSchema
 */
export interface ResetPasswordRequestSchema {
    /**
     * Contact method type
     * @type {string}
     * @memberof ResetPasswordRequestSchema
     */
    'channel': ResetPasswordRequestSchemaChannelEnum;
    /**
     * User\'s email address (required when channel is email)
     * @type {string}
     * @memberof ResetPasswordRequestSchema
     */
    'email'?: string;
    /**
     * User\'s phone number (required when channel is phone)
     * @type {string}
     * @memberof ResetPasswordRequestSchema
     */
    'phoneNumber'?: string;
    /**
     * New password for the user
     * @type {string}
     * @memberof ResetPasswordRequestSchema
     */
    'newPassword': string;
    /**
     * The platform type
     * @type {string}
     * @memberof ResetPasswordRequestSchema
     */
    'platformType': ResetPasswordRequestSchemaPlatformTypeEnum;
}

export const ResetPasswordRequestSchemaChannelEnum = {
    Email: 'email',
    Phone: 'phone'
} as const;

export type ResetPasswordRequestSchemaChannelEnum = typeof ResetPasswordRequestSchemaChannelEnum[keyof typeof ResetPasswordRequestSchemaChannelEnum];
export const ResetPasswordRequestSchemaPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type ResetPasswordRequestSchemaPlatformTypeEnum = typeof ResetPasswordRequestSchemaPlatformTypeEnum[keyof typeof ResetPasswordRequestSchemaPlatformTypeEnum];

/**
 * 
 * @export
 * @interface ResponseMessage
 */
export interface ResponseMessage {
    /**
     * Message Description
     * @type {string}
     * @memberof ResponseMessage
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface Restaurant
 */
export interface Restaurant {
    /**
     * The ID of the store
     * @type {string}
     * @memberof Restaurant
     */
    'id'?: string;
    /**
     * The merchant ID (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'merchantId': string;
    /**
     * The category IDs of the store
     * @type {Array<string>}
     * @memberof Restaurant
     */
    'categoryId'?: Array<string>;
    /**
     * The name of the store (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'storeName': string;
    /**
     * The Arabic name of the store
     * @type {string}
     * @memberof Restaurant
     */
    'storeNameArabic'?: string;
    /**
     * 
     * @type {MinOrderAmountSchema}
     * @memberof Restaurant
     */
    'minOrderAmount': MinOrderAmountSchema;
    /**
     * Whether the store allows pre-ordering (mandatory)
     * @type {boolean}
     * @memberof Restaurant
     */
    'canPreOrder': boolean;
    /**
     * Whether the store offers self-pickup (optional, default is false)
     * @type {boolean}
     * @memberof Restaurant
     */
    'hasSelfPickup': boolean;
    /**
     * Whether delivery is available (optional, default is true)
     * @type {boolean}
     * @memberof Restaurant
     */
    'deliveryAvailable': boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaDeliveryFee}
     * @memberof Restaurant
     */
    'deliveryFee': WritableRestaurantDataSchemaDeliveryFee;
    /**
     * 
     * @type {TimeDataSchema}
     * @memberof Restaurant
     */
    'deliveryTime': TimeDataSchema;
    /**
     * Description of the store in English (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'aboutStore': string;
    /**
     * Description of the store in Arabic (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'aboutStoreArabic'?: string;
    /**
     * Delivery radius in kilometers (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'deliveryRadiusKM': string;
    /**
     * Store phone number (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'storePhoneNumber': string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof Restaurant
     */
    'storeAddress': RestaurantAddressSchema;
    /**
     * URL of the store logo (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'storeLogo': string;
    /**
     * URLs of the store banners (mandatory)
     * @type {Array<string>}
     * @memberof Restaurant
     */
    'storeBanner': Array<string>;
    /**
     * 
     * @type {WorkingHoursSchema}
     * @memberof Restaurant
     */
    'workingHours': WorkingHoursSchema;
    /**
     * Whether cancellation is allowed (optional, default is true)
     * @type {boolean}
     * @memberof Restaurant
     */
    'isCancellationAllowed'?: boolean;
    /**
     * Cancellation policy of the store (optional, default is \"No cancellation\")
     * @type {string}
     * @memberof Restaurant
     */
    'cancellationPolicy'?: string;
    /**
     * Cancellation fee (optional, default is \"0\")
     * @type {string}
     * @memberof Restaurant
     */
    'cancellationFee'?: string;
    /**
     * Whether the store is wishlisted (optional, default is false)
     * @type {boolean}
     * @memberof Restaurant
     */
    'isWishListed'?: boolean;
    /**
     * Rating of the store (optional, default is 0)
     * @type {number}
     * @memberof Restaurant
     */
    'rating'?: number;
    /**
     * Type of store (mandatory)
     * @type {string}
     * @memberof Restaurant
     */
    'storeType': RestaurantStoreTypeEnum;
    /**
     * Whether the restaurant offers halal food (mandatory)
     * @type {boolean}
     * @memberof Restaurant
     */
    'isHalal': boolean;
    /**
     * Type of restaurant (mandatory)
     * @type {Array<string>}
     * @memberof Restaurant
     */
    'restaurantType': Array<RestaurantRestaurantTypeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Restaurant
     */
    'preferableTime'?: Array<RestaurantPreferableTimeEnum>;
    /**
     * Whether the restaurant accepts additional culinary requests (mandatory)
     * @type {boolean}
     * @memberof Restaurant
     */
    'additionalCulinaryRequest': boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaItemAvailableTime}
     * @memberof Restaurant
     */
    'itemAvailableTime': WritableRestaurantDataSchemaItemAvailableTime;
}

export const RestaurantStoreTypeEnum = {
    Restaurant: 'Restaurant'
} as const;

export type RestaurantStoreTypeEnum = typeof RestaurantStoreTypeEnum[keyof typeof RestaurantStoreTypeEnum];
export const RestaurantRestaurantTypeEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type RestaurantRestaurantTypeEnum = typeof RestaurantRestaurantTypeEnum[keyof typeof RestaurantRestaurantTypeEnum];
export const RestaurantPreferableTimeEnum = {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner'
} as const;

export type RestaurantPreferableTimeEnum = typeof RestaurantPreferableTimeEnum[keyof typeof RestaurantPreferableTimeEnum];

/**
 * 
 * @export
 * @interface RestaurantAddressSchema
 */
export interface RestaurantAddressSchema {
    /**
     * Full restaurant address
     * @type {string}
     * @memberof RestaurantAddressSchema
     */
    'address'?: string;
    /**
     * Latitude of the restaurant location
     * @type {string}
     * @memberof RestaurantAddressSchema
     */
    'latitude'?: string;
    /**
     * Longitude of the restaurant location
     * @type {string}
     * @memberof RestaurantAddressSchema
     */
    'longitude'?: string;
}
/**
 * 
 * @export
 * @interface RestaurantCategory
 */
export interface RestaurantCategory {
    /**
     * The unique identifier for the restaurant category.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'id': string;
    /**
     * The type of business for the category.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'storeType': RestaurantCategoryStoreTypeEnum;
    /**
     * The category name in English.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'nameEnglish': string;
    /**
     * The category name in Arabic.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'nameArabic': string;
    /**
     * The URL of the category image.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'categoryImage': string;
    /**
     * The URL of the category icon.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'categoryIcon': string;
    /**
     * Indicates if the category is active or not.
     * @type {boolean}
     * @memberof RestaurantCategory
     */
    'isActive': boolean;
    /**
     * The type of the user who created the category.
     * @type {string}
     * @memberof RestaurantCategory
     */
    'createdUserType': string;
}

export const RestaurantCategoryStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type RestaurantCategoryStoreTypeEnum = typeof RestaurantCategoryStoreTypeEnum[keyof typeof RestaurantCategoryStoreTypeEnum];

/**
 * 
 * @export
 * @interface RestaurantCategoryList
 */
export interface RestaurantCategoryList {
    /**
     * 
     * @type {Array<RestaurantCategory>}
     * @memberof RestaurantCategoryList
     */
    'data': Array<RestaurantCategory>;
    /**
     * 
     * @type {Pagination}
     * @memberof RestaurantCategoryList
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface RestaurantCategoryNames
 */
export interface RestaurantCategoryNames {
    /**
     * The unique identifier of the restaurant category.
     * @type {string}
     * @memberof RestaurantCategoryNames
     */
    'id': string;
    /**
     * The name of the restaurant category.
     * @type {string}
     * @memberof RestaurantCategoryNames
     */
    'nameEnglish': string;
    /**
     * The Arabic name of the restaurant category.
     * @type {string}
     * @memberof RestaurantCategoryNames
     */
    'nameArabic': string;
}
/**
 * 
 * @export
 * @interface RestaurantDetailSchema
 */
export interface RestaurantDetailSchema {
    /**
     * The unique identifier of the restaurant.
     * @type {string}
     * @memberof RestaurantDetailSchema
     */
    'id'?: string;
    /**
     * The name of the restaurant.
     * @type {string}
     * @memberof RestaurantDetailSchema
     */
    'name'?: string;
    /**
     * The name of the restaurant in Arabic.
     * @type {string}
     * @memberof RestaurantDetailSchema
     */
    'nameArabic'?: string;
    /**
     * The address of the restaurant.
     * @type {string}
     * @memberof RestaurantDetailSchema
     */
    'address'?: string;
    /**
     * Estimated delivery time for the restaurant.
     * @type {string}
     * @memberof RestaurantDetailSchema
     */
    'deliveryTime'?: string;
    /**
     * Availability status of the restaurant.
     * @type {boolean}
     * @memberof RestaurantDetailSchema
     */
    'isAvailable'?: boolean;
    /**
     * Minimum order amount required for delivery.
     * @type {number}
     * @memberof RestaurantDetailSchema
     */
    'minOrderAmount'?: number;
    /**
     * 
     * @type {Array<RestaurantDetailSchemaItemCategoriesInner>}
     * @memberof RestaurantDetailSchema
     */
    'itemCategories'?: Array<RestaurantDetailSchemaItemCategoriesInner>;
    /**
     * 
     * @type {Array<RestaurantDetailSchemaFoodItemsInner>}
     * @memberof RestaurantDetailSchema
     */
    'foodItems'?: Array<RestaurantDetailSchemaFoodItemsInner>;
}
/**
 * 
 * @export
 * @interface RestaurantDetailSchemaFoodItemsInner
 */
export interface RestaurantDetailSchemaFoodItemsInner {
    /**
     * The unique identifier of the food item.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'id'?: string;
    /**
     * The name of the food item.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'name'?: string;
    /**
     * The name of the food item in Arabic.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'nameArabic'?: string;
    /**
     * Indicates whether the food item is vegetarian or non-vegetarian.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'vegOrNonVeg'?: RestaurantDetailSchemaFoodItemsInnerVegOrNonVegEnum;
    /**
     * Indicates whether the food item is halal.
     * @type {boolean}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'isHalal'?: boolean;
    /**
     * Indicates whether the food item is marked as a favorite by the user.
     * @type {boolean}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'isFavorite'?: boolean;
    /**
     * The maximum retail price of the food item.
     * @type {number}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'mrp'?: number;
    /**
     * The final price of the food item after discounts.
     * @type {number}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'finalPrice'?: number;
    /**
     * A brief description of the food item.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'itemDescription'?: string;
    /**
     * A brief description of the food item in Arabic.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'itemDescriptionArabic'?: string;
    /**
     * The ID of the category the food item belongs to.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'categoryId'?: string;
    /**
     * The ID of the sub-category the food item belongs to.
     * @type {string}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'subCategoryId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RestaurantDetailSchemaFoodItemsInner
     */
    'imageUrl'?: Array<string>;
}

export const RestaurantDetailSchemaFoodItemsInnerVegOrNonVegEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type RestaurantDetailSchemaFoodItemsInnerVegOrNonVegEnum = typeof RestaurantDetailSchemaFoodItemsInnerVegOrNonVegEnum[keyof typeof RestaurantDetailSchemaFoodItemsInnerVegOrNonVegEnum];

/**
 * 
 * @export
 * @interface RestaurantDetailSchemaItemCategoriesInner
 */
export interface RestaurantDetailSchemaItemCategoriesInner {
    /**
     * The unique identifier of the category.
     * @type {string}
     * @memberof RestaurantDetailSchemaItemCategoriesInner
     */
    'id'?: string;
    /**
     * The name of the category.
     * @type {string}
     * @memberof RestaurantDetailSchemaItemCategoriesInner
     */
    'name'?: string;
    /**
     * The name of the category in Arabic.
     * @type {string}
     * @memberof RestaurantDetailSchemaItemCategoriesInner
     */
    'nameArabic'?: string;
    /**
     * 
     * @type {GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory}
     * @memberof RestaurantDetailSchemaItemCategoriesInner
     */
    'subCategory'?: GetRestaurantDetailsSchemaItemCategoriesInnerSubCategory;
}
/**
 * 
 * @export
 * @interface RestaurantImageSchema
 */
export interface RestaurantImageSchema {
    /**
     * The URL of the restaurant\'s image.
     * @type {string}
     * @memberof RestaurantImageSchema
     */
    'restaurantImage'?: string;
}
/**
 * 
 * @export
 * @interface RestaurantMerchantSchema
 */
export interface RestaurantMerchantSchema {
    /**
     * The unique identifier of the restaurant merchant.
     * @type {string}
     * @memberof RestaurantMerchantSchema
     */
    'id': string;
    /**
     * The name of the restaurant merchant.
     * @type {string}
     * @memberof RestaurantMerchantSchema
     */
    'name': string;
    /**
     * email of the merchant
     * @type {string}
     * @memberof RestaurantMerchantSchema
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RestaurantNameSchema
 */
export interface RestaurantNameSchema {
    /**
     * The language of the restaurant name.
     * @type {string}
     * @memberof RestaurantNameSchema
     */
    'language'?: RestaurantNameSchemaLanguageEnum;
    /**
     * The value of the restaurant name in the specified language.
     * @type {string}
     * @memberof RestaurantNameSchema
     */
    'value'?: string;
}

export const RestaurantNameSchemaLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;

export type RestaurantNameSchemaLanguageEnum = typeof RestaurantNameSchemaLanguageEnum[keyof typeof RestaurantNameSchemaLanguageEnum];

/**
 * 
 * @export
 * @interface RestaurantReviewSchema
 */
export interface RestaurantReviewSchema {
    /**
     * Name of the customer who gave the review
     * @type {string}
     * @memberof RestaurantReviewSchema
     */
    'review_customer_name'?: string;
    /**
     * URL or reference to the customer’s profile image
     * @type {string}
     * @memberof RestaurantReviewSchema
     */
    'review_customer_profile'?: string;
    /**
     * Comments from the customer
     * @type {string}
     * @memberof RestaurantReviewSchema
     */
    'review_comments'?: string;
    /**
     * Date of the review
     * @type {string}
     * @memberof RestaurantReviewSchema
     */
    'review_date'?: string;
    /**
     * Time of the review
     * @type {string}
     * @memberof RestaurantReviewSchema
     */
    'review_time'?: string;
    /**
     * Rating given by the customer as a string from 1 to 5
     * @type {string}
     * @memberof RestaurantReviewSchema
     */
    'review_rating'?: RestaurantReviewSchemaReviewRatingEnum;
}

export const RestaurantReviewSchemaReviewRatingEnum = {
    _1: '1',
    _2: '2',
    _3: '3',
    _4: '4',
    _5: '5'
} as const;

export type RestaurantReviewSchemaReviewRatingEnum = typeof RestaurantReviewSchemaReviewRatingEnum[keyof typeof RestaurantReviewSchemaReviewRatingEnum];

/**
 * 
 * @export
 * @interface RestaurantSchema
 */
export interface RestaurantSchema {
    /**
     * The unique identifier of the restaurant.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'restaurantId'?: string;
    /**
     * The ID of the restaurant category.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'restaurantCategoryId'?: string;
    /**
     * The name of the merchant who created the restaurant.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'createdByMerchantName'?: string;
    /**
     * The category of the restaurant.
     * @type {Array<RestaurantNameSchema>}
     * @memberof RestaurantSchema
     */
    'restaurantCategory'?: Array<RestaurantNameSchema>;
    /**
     * The name of the restaurant in different languages.
     * @type {Array<RestaurantNameSchema>}
     * @memberof RestaurantSchema
     */
    'restaurantName'?: Array<RestaurantNameSchema>;
    /**
     * 
     * @type {RestaurantSchemaMinOrderAmount}
     * @memberof RestaurantSchema
     */
    'minOrderAmount'?: RestaurantSchemaMinOrderAmount;
    /**
     * Indicates if pre-ordering is available.
     * @type {boolean}
     * @memberof RestaurantSchema
     */
    'preOrderOption'?: boolean;
    /**
     * Indicates if the restaurant offers halal food.
     * @type {boolean}
     * @memberof RestaurantSchema
     */
    'halal'?: boolean;
    /**
     * Type of restaurant.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'restaurantType'?: RestaurantSchemaRestaurantTypeEnum;
    /**
     * Preferred time for dining.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'preferrableTime'?: RestaurantSchemaPreferrableTimeEnum;
    /**
     * Indicates if self-pickup is available.
     * @type {boolean}
     * @memberof RestaurantSchema
     */
    'selfPickUpAvailable'?: boolean;
    /**
     * Indicates if delivery is available.
     * @type {boolean}
     * @memberof RestaurantSchema
     */
    'deliveryAvailable'?: boolean;
    /**
     * 
     * @type {DeliveryFeeSchema}
     * @memberof RestaurantSchema
     */
    'deliveryChargeSettings'?: DeliveryFeeSchema;
    /**
     * Distance to the restaurant in kilometers.
     * @type {number}
     * @memberof RestaurantSchema
     */
    'distance'?: number;
    /**
     * 
     * @type {RestaurantSchemaDeliveryTime}
     * @memberof RestaurantSchema
     */
    'deliveryTime'?: RestaurantSchemaDeliveryTime;
    /**
     * Whether additional cutlery is requested.
     * @type {boolean}
     * @memberof RestaurantSchema
     */
    'hasAdditionalCutleryRequest'?: boolean;
    /**
     * Description of the restaurant.
     * @type {Array<RestaurantNameSchema>}
     * @memberof RestaurantSchema
     */
    'aboutRestaurant'?: Array<RestaurantNameSchema>;
    /**
     * Delivery radius in kilometers.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'deliveryRadiusInKm'?: string;
    /**
     * Restaurant phone number.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof RestaurantSchema
     */
    'restaurantAddress'?: RestaurantAddressSchema;
    /**
     * Restaurant logo URL.
     * @type {string}
     * @memberof RestaurantSchema
     */
    'restaurantLogo'?: string;
    /**
     * URLs for restaurant banners.
     * @type {Array<string>}
     * @memberof RestaurantSchema
     */
    'restaurantBanner'?: Array<string>;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTime}
     * @memberof RestaurantSchema
     */
    'itemAvailableTime'?: RestaurantSchemaItemAvailableTime;
    /**
     * 
     * @type {RestaurantSchemaWorkingHours}
     * @memberof RestaurantSchema
     */
    'workingHours'?: RestaurantSchemaWorkingHours;
}

export const RestaurantSchemaRestaurantTypeEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type RestaurantSchemaRestaurantTypeEnum = typeof RestaurantSchemaRestaurantTypeEnum[keyof typeof RestaurantSchemaRestaurantTypeEnum];
export const RestaurantSchemaPreferrableTimeEnum = {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner'
} as const;

export type RestaurantSchemaPreferrableTimeEnum = typeof RestaurantSchemaPreferrableTimeEnum[keyof typeof RestaurantSchemaPreferrableTimeEnum];

/**
 * Delivery time.
 * @export
 * @interface RestaurantSchemaDeliveryTime
 */
export interface RestaurantSchemaDeliveryTime {
    /**
     * 
     * @type {number}
     * @memberof RestaurantSchemaDeliveryTime
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof RestaurantSchemaDeliveryTime
     */
    'format'?: RestaurantSchemaDeliveryTimeFormatEnum;
}

export const RestaurantSchemaDeliveryTimeFormatEnum = {
    Hours: 'hours',
    Minutes: 'minutes'
} as const;

export type RestaurantSchemaDeliveryTimeFormatEnum = typeof RestaurantSchemaDeliveryTimeFormatEnum[keyof typeof RestaurantSchemaDeliveryTimeFormatEnum];

/**
 * Item availability times.
 * @export
 * @interface RestaurantSchemaItemAvailableTime
 */
export interface RestaurantSchemaItemAvailableTime {
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaItemAvailableTime
     */
    'lunch'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaItemAvailableTime
     */
    'dinner'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaItemAvailableTime
     */
    'breakfast'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaItemAvailableTime
     */
    'brunch'?: RestaurantSchemaItemAvailableTimeLunch;
}
/**
 * 
 * @export
 * @interface RestaurantSchemaItemAvailableTimeLunch
 */
export interface RestaurantSchemaItemAvailableTimeLunch {
    /**
     * 
     * @type {string}
     * @memberof RestaurantSchemaItemAvailableTimeLunch
     */
    'startTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof RestaurantSchemaItemAvailableTimeLunch
     */
    'endTime'?: string;
}
/**
 * Minimum order amount.
 * @export
 * @interface RestaurantSchemaMinOrderAmount
 */
export interface RestaurantSchemaMinOrderAmount {
    /**
     * 
     * @type {CurrencyCode}
     * @memberof RestaurantSchemaMinOrderAmount
     */
    'currency'?: CurrencyCode;
    /**
     * 
     * @type {number}
     * @memberof RestaurantSchemaMinOrderAmount
     */
    'value'?: number;
}


/**
 * Working hours for the restaurant.
 * @export
 * @interface RestaurantSchemaWorkingHours
 */
export interface RestaurantSchemaWorkingHours {
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'sunday'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'monday'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'tuesday'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'wednesday'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'thursday'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'friday'?: RestaurantSchemaItemAvailableTimeLunch;
    /**
     * 
     * @type {RestaurantSchemaItemAvailableTimeLunch}
     * @memberof RestaurantSchemaWorkingHours
     */
    'saturday'?: RestaurantSchemaItemAvailableTimeLunch;
}
/**
 * 
 * @export
 * @interface RestaurantSettings
 */
export interface RestaurantSettings {
    /**
     * 
     * @type {FeaturedRestaurant}
     * @memberof RestaurantSettings
     */
    'featuredRestaurant'?: FeaturedRestaurant;
    /**
     * Common commission percentage
     * @type {number}
     * @memberof RestaurantSettings
     */
    'commonCommissionPercentage'?: number;
    /**
     * 
     * @type {CommonDeliveryRadius}
     * @memberof RestaurantSettings
     */
    'commonDeliveryRadius'?: CommonDeliveryRadius;
}
/**
 * 
 * @export
 * @interface RevenueByStoreTypePieChartItem
 */
export interface RevenueByStoreTypePieChartItem {
    /**
     * Store type classification (Restaurant, Pharmacy, Grocery).
     * @type {string}
     * @memberof RevenueByStoreTypePieChartItem
     */
    'storeType': string;
    /**
     * Total revenue attributed to each store type.
     * @type {number}
     * @memberof RevenueByStoreTypePieChartItem
     */
    'revenue': number;
}
/**
 * @type Review
 * @export
 */
export type Review = { type: 'DeliveryPerson' } & DeliveryBoyReview | { type: 'Item' } & ItemReview | { type: 'Store' } & StoreReview;

/**
 * Permission settings for review management
 * @export
 * @interface ReviewPermission
 */
export interface ReviewPermission {
    /**
     * Can view reviews
     * @type {boolean}
     * @memberof ReviewPermission
     */
    'view'?: boolean;
    /**
     * Can approve/reject reviews
     * @type {boolean}
     * @memberof ReviewPermission
     */
    'approve'?: boolean;
    /**
     * Can delete reviews
     * @type {boolean}
     * @memberof ReviewPermission
     */
    'delete'?: boolean;
}
/**
 * 
 * @export
 * @interface ReviewSuggestions
 */
export interface ReviewSuggestions {
    /**
     * Suggestions for the review, such as \"Great service\", \"Delicious food\", etc.
     * @type {Array<string>}
     * @memberof ReviewSuggestions
     */
    'suggestions': Array<string>;
}
/**
 * Summary of review statistics
 * @export
 * @interface ReviewSummarySchema
 */
export interface ReviewSummarySchema {
    /**
     * Average rating (0-5)
     * @type {number}
     * @memberof ReviewSummarySchema
     */
    'averageRating'?: number;
    /**
     * Total number of approved reviews
     * @type {number}
     * @memberof ReviewSummarySchema
     */
    'totalReviews'?: number;
    /**
     * 
     * @type {RatingBreakdownSchema}
     * @memberof ReviewSummarySchema
     */
    'ratingBreakdown'?: RatingBreakdownSchema;
}
/**
 * 
 * @export
 * @interface SalesReportRequest
 */
export interface SalesReportRequest {
    /**
     * Array of store IDs (optional - omit to include all stores)
     * @type {Array<string>}
     * @memberof SalesReportRequest
     */
    'storeIds'?: Array<string>;
    /**
     * Single merchant ID (optional - omit to include all merchants)
     * @type {string}
     * @memberof SalesReportRequest
     */
    'merchantId'?: string;
    /**
     * Filter by store types
     * @type {Array<string>}
     * @memberof SalesReportRequest
     */
    'storeType'?: Array<SalesReportRequestStoreTypeEnum>;
    /**
     * Order statuses to include (defaults to ORDER_DELIVERED only)
     * @type {Array<string>}
     * @memberof SalesReportRequest
     */
    'orderStatuses'?: Array<SalesReportRequestOrderStatusesEnum>;
    /**
     * Filter by payment methods
     * @type {Array<string>}
     * @memberof SalesReportRequest
     */
    'paymentMethods'?: Array<SalesReportRequestPaymentMethodsEnum>;
    /**
     * Array of driver IDs
     * @type {Array<string>}
     * @memberof SalesReportRequest
     */
    'driverIds'?: Array<string>;
    /**
     * Array of customer IDs
     * @type {Array<string>}
     * @memberof SalesReportRequest
     */
    'customerIds'?: Array<string>;
    /**
     * Predefined date range periods or custom
     * @type {string}
     * @memberof SalesReportRequest
     */
    'dateRange': SalesReportRequestDateRangeEnum;
    /**
     * Start date (required if dateRange is \'custom\')
     * @type {string}
     * @memberof SalesReportRequest
     */
    'dateFrom'?: string;
    /**
     * End date (required if dateRange is \'custom\')
     * @type {string}
     * @memberof SalesReportRequest
     */
    'dateTo'?: string;
}

export const SalesReportRequestStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type SalesReportRequestStoreTypeEnum = typeof SalesReportRequestStoreTypeEnum[keyof typeof SalesReportRequestStoreTypeEnum];
export const SalesReportRequestOrderStatusesEnum = {
    OrderDelivered: 'ORDER_DELIVERED',
    OrderCancelled: 'ORDER_CANCELLED',
    MerchantCancelled: 'MERCHANT_CANCELLED',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type SalesReportRequestOrderStatusesEnum = typeof SalesReportRequestOrderStatusesEnum[keyof typeof SalesReportRequestOrderStatusesEnum];
export const SalesReportRequestPaymentMethodsEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment',
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type SalesReportRequestPaymentMethodsEnum = typeof SalesReportRequestPaymentMethodsEnum[keyof typeof SalesReportRequestPaymentMethodsEnum];
export const SalesReportRequestDateRangeEnum = {
    Today: 'today',
    ThisWeek: 'thisWeek',
    ThisMonth: 'thisMonth',
    Last30Days: 'last30Days',
    ThisYear: 'thisYear',
    Custom: 'custom'
} as const;

export type SalesReportRequestDateRangeEnum = typeof SalesReportRequestDateRangeEnum[keyof typeof SalesReportRequestDateRangeEnum];

/**
 * 
 * @export
 * @interface SelfPickupCheckout
 */
export interface SelfPickupCheckout {
    /**
     * 
     * @type {string}
     * @memberof SelfPickupCheckout
     */
    'deliveryType': SelfPickupCheckoutDeliveryTypeEnum;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof SelfPickupCheckout
     */
    'shippingAddress': ShippingAddress;
    /**
     * Method of payment for the order
     * @type {string}
     * @memberof SelfPickupCheckout
     */
    'paymentMethod': SelfPickupCheckoutPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof SelfPickupCheckout
     */
    'couponCode'?: string;
    /**
     * Type of cart items
     * @type {string}
     * @memberof SelfPickupCheckout
     */
    'cartItemsType': SelfPickupCheckoutCartItemsTypeEnum;
}

export const SelfPickupCheckoutDeliveryTypeEnum = {
    SelfPickup: 'selfPickup'
} as const;

export type SelfPickupCheckoutDeliveryTypeEnum = typeof SelfPickupCheckoutDeliveryTypeEnum[keyof typeof SelfPickupCheckoutDeliveryTypeEnum];
export const SelfPickupCheckoutPaymentMethodEnum = {
    CashOnDelivery: 'cashOnDelivery',
    OnlinePayment: 'onlinePayment'
} as const;

export type SelfPickupCheckoutPaymentMethodEnum = typeof SelfPickupCheckoutPaymentMethodEnum[keyof typeof SelfPickupCheckoutPaymentMethodEnum];
export const SelfPickupCheckoutCartItemsTypeEnum = {
    All: 'All',
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type SelfPickupCheckoutCartItemsTypeEnum = typeof SelfPickupCheckoutCartItemsTypeEnum[keyof typeof SelfPickupCheckoutCartItemsTypeEnum];

/**
 * 
 * @export
 * @interface SendNewsletterAllSubscribers
 */
export interface SendNewsletterAllSubscribers {
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterAllSubscribers
     */
    'emailTo': SendNewsletterAllSubscribersEmailToEnum;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterAllSubscribers
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterAllSubscribers
     */
    'message': string;
}

export const SendNewsletterAllSubscribersEmailToEnum = {
    AllSubscribers: 'allSubscribers'
} as const;

export type SendNewsletterAllSubscribersEmailToEnum = typeof SendNewsletterAllSubscribersEmailToEnum[keyof typeof SendNewsletterAllSubscribersEmailToEnum];

/**
 * 
 * @export
 * @interface SendNewsletterAllUsers
 */
export interface SendNewsletterAllUsers {
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterAllUsers
     */
    'emailTo': SendNewsletterAllUsersEmailToEnum;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterAllUsers
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterAllUsers
     */
    'message': string;
}

export const SendNewsletterAllUsersEmailToEnum = {
    AllUsers: 'allUsers'
} as const;

export type SendNewsletterAllUsersEmailToEnum = typeof SendNewsletterAllUsersEmailToEnum[keyof typeof SendNewsletterAllUsersEmailToEnum];

/**
 * 
 * @export
 * @interface SendNewsletterParticularSubscribers
 */
export interface SendNewsletterParticularSubscribers {
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterParticularSubscribers
     */
    'emailTo': SendNewsletterParticularSubscribersEmailToEnum;
    /**
     * List of specific subscriber IDs to send the email to
     * @type {Array<string>}
     * @memberof SendNewsletterParticularSubscribers
     */
    'subscriberIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterParticularSubscribers
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterParticularSubscribers
     */
    'message': string;
}

export const SendNewsletterParticularSubscribersEmailToEnum = {
    ParticularSubscriber: 'particularSubscriber'
} as const;

export type SendNewsletterParticularSubscribersEmailToEnum = typeof SendNewsletterParticularSubscribersEmailToEnum[keyof typeof SendNewsletterParticularSubscribersEmailToEnum];

/**
 * 
 * @export
 * @interface SendNewsletterParticularUsers
 */
export interface SendNewsletterParticularUsers {
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterParticularUsers
     */
    'emailTo': SendNewsletterParticularUsersEmailToEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendNewsletterParticularUsers
     */
    'customerIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterParticularUsers
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof SendNewsletterParticularUsers
     */
    'message': string;
}

export const SendNewsletterParticularUsersEmailToEnum = {
    ParticularUsers: 'particularUsers'
} as const;

export type SendNewsletterParticularUsersEmailToEnum = typeof SendNewsletterParticularUsersEmailToEnum[keyof typeof SendNewsletterParticularUsersEmailToEnum];

/**
 * @type SendNewsletterRequest
 * @export
 */
export type SendNewsletterRequest = { emailTo: 'allSubscribers' } & SendNewsletterAllSubscribers | { emailTo: 'allUsers' } & SendNewsletterAllUsers | { emailTo: 'particularSubscriber' } & SendNewsletterParticularSubscribers | { emailTo: 'particularUsers' } & SendNewsletterParticularUsers;

/**
 * 
 * @export
 * @interface SendOtpByEmail
 */
export interface SendOtpByEmail {
    /**
     * Medium to resend OTP
     * @type {string}
     * @memberof SendOtpByEmail
     */
    'channel': SendOtpByEmailChannelEnum;
    /**
     * User\'s email address
     * @type {string}
     * @memberof SendOtpByEmail
     */
    'email': string;
}

export const SendOtpByEmailChannelEnum = {
    Email: 'email'
} as const;

export type SendOtpByEmailChannelEnum = typeof SendOtpByEmailChannelEnum[keyof typeof SendOtpByEmailChannelEnum];

/**
 * 
 * @export
 * @interface SendOtpByPhone
 */
export interface SendOtpByPhone {
    /**
     * Medium to resend OTP
     * @type {string}
     * @memberof SendOtpByPhone
     */
    'channel': SendOtpByPhoneChannelEnum;
    /**
     * Valid phone number
     * @type {string}
     * @memberof SendOtpByPhone
     */
    'phoneNumber': string;
}

export const SendOtpByPhoneChannelEnum = {
    Phone: 'phone'
} as const;

export type SendOtpByPhoneChannelEnum = typeof SendOtpByPhoneChannelEnum[keyof typeof SendOtpByPhoneChannelEnum];

/**
 * 
 * @export
 * @interface SendPushNotificationRequest
 */
export interface SendPushNotificationRequest {
    /**
     * Target audience for the push notification
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'sendTo': SendPushNotificationRequestSendToEnum;
    /**
     * Required if sendTo is PARTICULAR_CUSTOMER
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'customerId'?: string;
    /**
     * Required if sendTo is PARTICULAR_DELIVERY_BOY
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'deliveryBoyId'?: string;
    /**
     * Required if sendTo is PARTICULAR_MERCHANT
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'merchantId'?: string;
    /**
     * Optional; associate the notification with a specific store
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'storeId'?: string;
    /**
     * Title of the notification
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'title': string;
    /**
     * Text content of the notification
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'message': string;
    /**
     * Optional image URL for the notification
     * @type {string}
     * @memberof SendPushNotificationRequest
     */
    'imageUrl'?: string;
}

export const SendPushNotificationRequestSendToEnum = {
    AllCustomers: 'ALL_CUSTOMERS',
    ParticularCustomer: 'PARTICULAR_CUSTOMER',
    AllDeliveryBoys: 'ALL_DELIVERY_BOYS',
    ParticularDeliveryBoy: 'PARTICULAR_DELIVERY_BOY',
    AllMerchants: 'ALL_MERCHANTS',
    ParticularMerchant: 'PARTICULAR_MERCHANT'
} as const;

export type SendPushNotificationRequestSendToEnum = typeof SendPushNotificationRequestSendToEnum[keyof typeof SendPushNotificationRequestSendToEnum];

/**
 * 
 * @export
 * @interface SendReferralEmailRequest
 */
export interface SendReferralEmailRequest {
    /**
     * The ID of the user to send the referral email to
     * @type {string}
     * @memberof SendReferralEmailRequest
     */
    'userId': string;
    /**
     * The referral code to include in the email
     * @type {string}
     * @memberof SendReferralEmailRequest
     */
    'referralCode': string;
    /**
     * The name of the recipient who will receive the referral email
     * @type {string}
     * @memberof SendReferralEmailRequest
     */
    'recipientName': string;
    /**
     * The email address of the recipient who will receive the referral email
     * @type {string}
     * @memberof SendReferralEmailRequest
     */
    'recipientsEmail': string;
}
/**
 * 
 * @export
 * @interface SendReferralEmailResponse
 */
export interface SendReferralEmailResponse {
    /**
     * Indicates if the referral email was sent successfully
     * @type {boolean}
     * @memberof SendReferralEmailResponse
     */
    'success': boolean;
    /**
     * Success message
     * @type {string}
     * @memberof SendReferralEmailResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface SeoSettings
 */
export interface SeoSettings {
    /**
     * Meta title for SEO
     * @type {string}
     * @memberof SeoSettings
     */
    'metaTitle'?: string;
    /**
     * Meta title in Arabic
     * @type {string}
     * @memberof SeoSettings
     */
    'metaTitleArabic'?: string;
    /**
     * Meta keywords for SEO
     * @type {string}
     * @memberof SeoSettings
     */
    'metaKeywords'?: string;
    /**
     * Meta keywords in Arabic
     * @type {string}
     * @memberof SeoSettings
     */
    'metaKeywordsArabic'?: string;
    /**
     * Meta description for SEO
     * @type {string}
     * @memberof SeoSettings
     */
    'metaDescription'?: string;
    /**
     * Meta description in Arabic
     * @type {string}
     * @memberof SeoSettings
     */
    'metaDescriptionArabic'?: string;
}
/**
 * Permission settings for settings management
 * @export
 * @interface SettingsPermission
 */
export interface SettingsPermission {
    /**
     * Can view settings
     * @type {boolean}
     * @memberof SettingsPermission
     */
    'view'?: boolean;
    /**
     * Can edit settings
     * @type {boolean}
     * @memberof SettingsPermission
     */
    'edit'?: boolean;
}
/**
 * Permission settings for settlement module
 * @export
 * @interface SettlementPermission
 */
export interface SettlementPermission {
    /**
     * Can view settlements list and details
     * @type {boolean}
     * @memberof SettlementPermission
     */
    'view'?: boolean;
    /**
     * Can initiate settlement payments
     * @type {boolean}
     * @memberof SettlementPermission
     */
    'settle'?: boolean;
    /**
     * Can export settlements to Excel/PDF
     * @type {boolean}
     * @memberof SettlementPermission
     */
    'export'?: boolean;
}
/**
 * 
 * @export
 * @interface SettlementsResponse
 */
export interface SettlementsResponse {
    /**
     * 
     * @type {Array<TransactionResponse>}
     * @memberof SettlementsResponse
     */
    'transactions': Array<TransactionResponse>;
    /**
     * 
     * @type {TransactionSummary}
     * @memberof SettlementsResponse
     */
    'summary': TransactionSummary;
    /**
     * 
     * @type {Pagination}
     * @memberof SettlementsResponse
     */
    'pagination': Pagination;
}
/**
 * 
 * @export
 * @interface ShippingAddress
 */
export interface ShippingAddress {
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'addressType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'addressLine'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'latitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'longitude'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'alternatePhone'?: string | null;
}
/**
 * 
 * @export
 * @interface ShippingAddressNew
 */
export interface ShippingAddressNew {
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'alternativePhoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'addressLine'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'latitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddressNew
     */
    'longitude'?: string;
}
/**
 * 
 * @export
 * @interface SignupSuccessResponse
 */
export interface SignupSuccessResponse {
    /**
     * Message Description
     * @type {string}
     * @memberof SignupSuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SignupSuccessResponse
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupSuccessResponse
     */
    'userType'?: string;
}
/**
 * @type SignupUserRequest
 * @export
 */
export type SignupUserRequest = ManualSignUpRequestSchema | SocialSignUpRequestSchema;

/**
 * 
 * @export
 * @interface SocialLoginOptions
 */
export interface SocialLoginOptions {
    /**
     * 
     * @type {SocialLoginSettings}
     * @memberof SocialLoginOptions
     */
    'google': SocialLoginSettings;
    /**
     * 
     * @type {SocialLoginSettings}
     * @memberof SocialLoginOptions
     */
    'facebook': SocialLoginSettings;
    /**
     * 
     * @type {SocialLoginSettings}
     * @memberof SocialLoginOptions
     */
    'apple': SocialLoginSettings;
}
/**
 * 
 * @export
 * @interface SocialLoginRequestSchema
 */
export interface SocialLoginRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'loginType': SocialLoginRequestSchemaLoginTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'provider': SocialLoginRequestSchemaProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'profileImage'?: string;
    /**
     * The platform type for which the social login is requested
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'platformType': SocialLoginRequestSchemaPlatformTypeEnum;
    /**
     * Optional referral code for signup
     * @type {string}
     * @memberof SocialLoginRequestSchema
     */
    'referralCode'?: string;
}

export const SocialLoginRequestSchemaLoginTypeEnum = {
    Social: 'social'
} as const;

export type SocialLoginRequestSchemaLoginTypeEnum = typeof SocialLoginRequestSchemaLoginTypeEnum[keyof typeof SocialLoginRequestSchemaLoginTypeEnum];
export const SocialLoginRequestSchemaProviderEnum = {
    Google: 'google',
    Facebook: 'facebook',
    Apple: 'apple'
} as const;

export type SocialLoginRequestSchemaProviderEnum = typeof SocialLoginRequestSchemaProviderEnum[keyof typeof SocialLoginRequestSchemaProviderEnum];
export const SocialLoginRequestSchemaPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type SocialLoginRequestSchemaPlatformTypeEnum = typeof SocialLoginRequestSchemaPlatformTypeEnum[keyof typeof SocialLoginRequestSchemaPlatformTypeEnum];

/**
 * 
 * @export
 * @interface SocialLoginSettings
 */
export interface SocialLoginSettings {
    /**
     * Whether social login is enabled
     * @type {boolean}
     * @memberof SocialLoginSettings
     */
    'isEnabled': boolean;
    /**
     * Facebook App ID
     * @type {string}
     * @memberof SocialLoginSettings
     */
    'appId'?: string;
    /**
     * Text for the Facebook login button
     * @type {string}
     * @memberof SocialLoginSettings
     */
    'buttonText'?: string;
    /**
     * Text for the Facebook login button in Arabic
     * @type {string}
     * @memberof SocialLoginSettings
     */
    'buttonTextArabic'?: string;
}
/**
 * 
 * @export
 * @interface SocialSignUpRequestSchema
 */
export interface SocialSignUpRequestSchema {
    /**
     * 
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'signupType': SocialSignUpRequestSchemaSignupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'provider': SocialSignUpRequestSchemaProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'providerId': string;
    /**
     * 
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'profileImage'?: string;
    /**
     * The platform type for which the social signup is requested
     * @type {string}
     * @memberof SocialSignUpRequestSchema
     */
    'platformType': SocialSignUpRequestSchemaPlatformTypeEnum;
}

export const SocialSignUpRequestSchemaSignupTypeEnum = {
    Social: 'social'
} as const;

export type SocialSignUpRequestSchemaSignupTypeEnum = typeof SocialSignUpRequestSchemaSignupTypeEnum[keyof typeof SocialSignUpRequestSchemaSignupTypeEnum];
export const SocialSignUpRequestSchemaProviderEnum = {
    Google: 'google',
    Facebook: 'facebook',
    Apple: 'apple'
} as const;

export type SocialSignUpRequestSchemaProviderEnum = typeof SocialSignUpRequestSchemaProviderEnum[keyof typeof SocialSignUpRequestSchemaProviderEnum];
export const SocialSignUpRequestSchemaPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type SocialSignUpRequestSchemaPlatformTypeEnum = typeof SocialSignUpRequestSchemaPlatformTypeEnum[keyof typeof SocialSignUpRequestSchemaPlatformTypeEnum];

/**
 * Login using email or phone for SuperAdmin, SubAdmin, or Merchant
 * @export
 * @interface SpecialUserLoginRequestSchema
 */
export interface SpecialUserLoginRequestSchema {
    /**
     * Contact method type for login
     * @type {string}
     * @memberof SpecialUserLoginRequestSchema
     */
    'channel': SpecialUserLoginRequestSchemaChannelEnum;
    /**
     * User\'s email address (required when channel is email)
     * @type {string}
     * @memberof SpecialUserLoginRequestSchema
     */
    'email'?: string;
    /**
     * User\'s phone number (required when channel is phone)
     * @type {string}
     * @memberof SpecialUserLoginRequestSchema
     */
    'phoneNumber'?: string;
    /**
     * User\'s password
     * @type {string}
     * @memberof SpecialUserLoginRequestSchema
     */
    'password': string;
    /**
     * The platform type for login
     * @type {string}
     * @memberof SpecialUserLoginRequestSchema
     */
    'platformType': SpecialUserLoginRequestSchemaPlatformTypeEnum;
}

export const SpecialUserLoginRequestSchemaChannelEnum = {
    Email: 'email',
    Phone: 'phone'
} as const;

export type SpecialUserLoginRequestSchemaChannelEnum = typeof SpecialUserLoginRequestSchemaChannelEnum[keyof typeof SpecialUserLoginRequestSchemaChannelEnum];
export const SpecialUserLoginRequestSchemaPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant'
} as const;

export type SpecialUserLoginRequestSchemaPlatformTypeEnum = typeof SpecialUserLoginRequestSchemaPlatformTypeEnum[keyof typeof SpecialUserLoginRequestSchemaPlatformTypeEnum];

/**
 * Login using email for SuperAdmin, SubAdmin, or Merchant
 * @export
 * @interface SpecialUserLoginWithEmail
 */
export interface SpecialUserLoginWithEmail {
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithEmail
     */
    'channel': SpecialUserLoginWithEmailChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithEmail
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithEmail
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithEmail
     */
    'platformType': SpecialUserLoginWithEmailPlatformTypeEnum;
}

export const SpecialUserLoginWithEmailChannelEnum = {
    Email: 'email'
} as const;

export type SpecialUserLoginWithEmailChannelEnum = typeof SpecialUserLoginWithEmailChannelEnum[keyof typeof SpecialUserLoginWithEmailChannelEnum];
export const SpecialUserLoginWithEmailPlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type SpecialUserLoginWithEmailPlatformTypeEnum = typeof SpecialUserLoginWithEmailPlatformTypeEnum[keyof typeof SpecialUserLoginWithEmailPlatformTypeEnum];

/**
 * Login using phone number for SuperAdmin, SubAdmin, or Merchant
 * @export
 * @interface SpecialUserLoginWithPhone
 */
export interface SpecialUserLoginWithPhone {
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithPhone
     */
    'channel': SpecialUserLoginWithPhoneChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithPhone
     */
    'phoneNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithPhone
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SpecialUserLoginWithPhone
     */
    'platformType': SpecialUserLoginWithPhonePlatformTypeEnum;
}

export const SpecialUserLoginWithPhoneChannelEnum = {
    Phone: 'phone'
} as const;

export type SpecialUserLoginWithPhoneChannelEnum = typeof SpecialUserLoginWithPhoneChannelEnum[keyof typeof SpecialUserLoginWithPhoneChannelEnum];
export const SpecialUserLoginWithPhonePlatformTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant',
    Customer: 'customer',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type SpecialUserLoginWithPhonePlatformTypeEnum = typeof SpecialUserLoginWithPhonePlatformTypeEnum[keyof typeof SpecialUserLoginWithPhonePlatformTypeEnum];

/**
 * 
 * @export
 * @interface StatusSettings
 */
export interface StatusSettings {
    /**
     * Enable/disable coupon functionality
     * @type {boolean}
     * @memberof StatusSettings
     */
    'couponStatus'?: boolean;
    /**
     * 
     * @type {OtpVerificationStatus}
     * @memberof StatusSettings
     */
    'otpVerificationStatus'?: OtpVerificationStatus;
    /**
     * Enable/disable email verification
     * @type {boolean}
     * @memberof StatusSettings
     */
    'mailVerificationStatus'?: boolean;
    /**
     * Enable/disable no-contact delivery
     * @type {boolean}
     * @memberof StatusSettings
     */
    'noContactDeliveryStatus'?: boolean;
    /**
     * Enable/disable self pickup option
     * @type {boolean}
     * @memberof StatusSettings
     */
    'selfPickupStatus'?: boolean;
    /**
     * Show or hide out of stock products
     * @type {boolean}
     * @memberof StatusSettings
     */
    'showOutOfStockProducts'?: boolean;
    /**
     * Show or hide stock information
     * @type {boolean}
     * @memberof StatusSettings
     */
    'showStock'?: boolean;
}
/**
 * 
 * @export
 * @interface StoreBillBreakdown
 */
export interface StoreBillBreakdown {
    /**
     * Store identifier
     * @type {string}
     * @memberof StoreBillBreakdown
     */
    'storeId': string;
    /**
     * Store name
     * @type {string}
     * @memberof StoreBillBreakdown
     */
    'storeName': string;
    /**
     * Original amount from store
     * @type {number}
     * @memberof StoreBillBreakdown
     */
    'originalAmount': number;
    /**
     * Amount for confirmed items
     * @type {number}
     * @memberof StoreBillBreakdown
     */
    'confirmedAmount': number;
    /**
     * Refund amount from store
     * @type {number}
     * @memberof StoreBillBreakdown
     */
    'refundAmount': number;
    /**
     * 
     * @type {StoreBillBreakdownItemsBreakdown}
     * @memberof StoreBillBreakdown
     */
    'itemsBreakdown'?: StoreBillBreakdownItemsBreakdown;
}
/**
 * 
 * @export
 * @interface StoreBillBreakdownItemsBreakdown
 */
export interface StoreBillBreakdownItemsBreakdown {
    /**
     * 
     * @type {number}
     * @memberof StoreBillBreakdownItemsBreakdown
     */
    'confirmedItems'?: number;
    /**
     * 
     * @type {number}
     * @memberof StoreBillBreakdownItemsBreakdown
     */
    'refundedItems'?: number;
}
/**
 * 
 * @export
 * @interface StoreGroup
 */
export interface StoreGroup {
    /**
     * Store identifier
     * @type {string}
     * @memberof StoreGroup
     */
    'storeId': string;
    /**
     * Store name
     * @type {string}
     * @memberof StoreGroup
     */
    'storeName': string;
    /**
     * Store type
     * @type {string}
     * @memberof StoreGroup
     */
    'storeType': StoreGroupStoreTypeEnum;
    /**
     * 
     * @type {StoreStatus}
     * @memberof StoreGroup
     */
    'storeStatus': StoreStatus;
    /**
     * All items in this store with their acceptance status
     * @type {Array<StoreOrderItem>}
     * @memberof StoreGroup
     */
    'storeItems': Array<StoreOrderItem>;
    /**
     * 
     * @type {StoreTotals}
     * @memberof StoreGroup
     */
    'totals': StoreTotals;
    /**
     * 
     * @type {PickupStatus}
     * @memberof StoreGroup
     */
    'pickupStatus'?: PickupStatus;
}

export const StoreGroupStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type StoreGroupStoreTypeEnum = typeof StoreGroupStoreTypeEnum[keyof typeof StoreGroupStoreTypeEnum];

/**
 * 
 * @export
 * @interface StoreInfo
 */
export interface StoreInfo {
    /**
     * Unique identifier of the store
     * @type {string}
     * @memberof StoreInfo
     */
    'storeId': string;
    /**
     * Name of the store
     * @type {string}
     * @memberof StoreInfo
     */
    'storeName': string;
    /**
     * Full address of the store
     * @type {string}
     * @memberof StoreInfo
     */
    'address': string;
    /**
     * Latitude coordinate for pickup location
     * @type {string}
     * @memberof StoreInfo
     */
    'latitude': string;
    /**
     * Longitude coordinate for pickup location
     * @type {string}
     * @memberof StoreInfo
     */
    'longitude': string;
    /**
     * Contact number of the store
     * @type {string}
     * @memberof StoreInfo
     */
    'phoneNumber'?: string;
    /**
     * Type of the store (used for display or filtering)
     * @type {string}
     * @memberof StoreInfo
     */
    'storeType'?: StoreInfoStoreTypeEnum;
}

export const StoreInfoStoreTypeEnum = {
    Restaurant: 'Restaurant',
    Grocery: 'Grocery',
    Pharmacy: 'Pharmacy'
} as const;

export type StoreInfoStoreTypeEnum = typeof StoreInfoStoreTypeEnum[keyof typeof StoreInfoStoreTypeEnum];

/**
 * 
 * @export
 * @interface StoreItem
 */
export interface StoreItem {
    /**
     * Unique identifier of the item
     * @type {string}
     * @memberof StoreItem
     */
    'id': string;
    /**
     * Type of store the item belongs to
     * @type {string}
     * @memberof StoreItem
     */
    'storeType'?: StoreItemStoreTypeEnum;
    /**
     * Item name
     * @type {string}
     * @memberof StoreItem
     */
    'name': string;
    /**
     * Item description
     * @type {string}
     * @memberof StoreItem
     */
    'description'?: string;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof StoreItem
     */
    'currencyCode'?: CurrencyCode;
    /**
     * Original price
     * @type {number}
     * @memberof StoreItem
     */
    'price': number;
    /**
     * Discounted price, if applicable
     * @type {number}
     * @memberof StoreItem
     */
    'discountedPrice'?: number;
    /**
     * URL of the item image
     * @type {string}
     * @memberof StoreItem
     */
    'imageUrl': string;
    /**
     * Average rating of the item
     * @type {number}
     * @memberof StoreItem
     */
    'rating'?: number;
    /**
     * 
     * @type {ItemReviewDataSchema}
     * @memberof StoreItem
     */
    'reviewData'?: ItemReviewDataSchema;
    /**
     * Category of the item (e.g., Popular, Paratha)
     * @type {string}
     * @memberof StoreItem
     */
    'category'?: string;
    /**
     * Discount percentage
     * @type {number}
     * @memberof StoreItem
     */
    'discountPercentage'?: number;
    /**
     * Whether the item is vegetarian (green dot) or non-vegetarian (red dot)
     * @type {boolean}
     * @memberof StoreItem
     */
    'isVeg'?: boolean;
    /**
     * Whether the item has a combo offer available
     * @type {boolean}
     * @memberof StoreItem
     */
    'hasComboOffer'?: boolean;
    /**
     * Whether the item is added to wishlist (heart icon state)
     * @type {boolean}
     * @memberof StoreItem
     */
    'isWishlisted'?: boolean;
    /**
     * Special badges or tags (e.g., \"Bestseller\", \"Chef\'s Special\")
     * @type {Array<string>}
     * @memberof StoreItem
     */
    'badges'?: Array<string>;
    /**
     * Whether the item has choices (e.g., size, flavor)
     * @type {boolean}
     * @memberof StoreItem
     */
    'hasChoiceGroups'?: boolean;
    /**
     * Choice groups associated with the item
     * @type {Array<StoreItemChoiceGroup>}
     * @memberof StoreItem
     */
    'choiceGroups'?: Array<StoreItemChoiceGroup>;
    /**
     * 
     * @type {StoreItemAvailableTime}
     * @memberof StoreItem
     */
    'availableTime'?: StoreItemAvailableTime;
    /**
     * Whether the item is out of stock (itemQuantity <= 0)
     * @type {boolean}
     * @memberof StoreItem
     */
    'isOutOfStock'?: boolean;
    /**
     * Indicates if this item requires a prescription (for pharmacy items)
     * @type {boolean}
     * @memberof StoreItem
     */
    'requiresPrescription'?: boolean;
    /**
     * Type of prescription required
     * @type {string}
     * @memberof StoreItem
     */
    'prescriptionType'?: StoreItemPrescriptionTypeEnum;
    /**
     * Additional notes about prescription requirements
     * @type {string}
     * @memberof StoreItem
     */
    'prescriptionNotes'?: string;
}

export const StoreItemStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type StoreItemStoreTypeEnum = typeof StoreItemStoreTypeEnum[keyof typeof StoreItemStoreTypeEnum];
export const StoreItemPrescriptionTypeEnum = {
    Standard: 'standard',
    Controlled: 'controlled',
    Otc: 'otc'
} as const;

export type StoreItemPrescriptionTypeEnum = typeof StoreItemPrescriptionTypeEnum[keyof typeof StoreItemPrescriptionTypeEnum];

/**
 * Indicates when the item is available (only for Restaurant store type)
 * @export
 * @interface StoreItemAvailableTime
 */
export interface StoreItemAvailableTime {
    /**
     * Whether the item is available during breakfast
     * @type {boolean}
     * @memberof StoreItemAvailableTime
     */
    'isBreakfast'?: boolean;
    /**
     * Whether the item is available during lunch
     * @type {boolean}
     * @memberof StoreItemAvailableTime
     */
    'isLunch'?: boolean;
    /**
     * Whether the item is available during dinner
     * @type {boolean}
     * @memberof StoreItemAvailableTime
     */
    'isDinner'?: boolean;
}
/**
 * 
 * @export
 * @interface StoreItemChoice
 */
export interface StoreItemChoice {
    /**
     * Unique identifier of the choice
     * @type {string}
     * @memberof StoreItemChoice
     */
    'choiceId': string;
    /**
     * Name of the choice
     * @type {string}
     * @memberof StoreItemChoice
     */
    'choiceName': string;
    /**
     * Arabic name of the choice
     * @type {string}
     * @memberof StoreItemChoice
     */
    'choiceNameArabic'?: string;
    /**
     * Price of the choice
     * @type {number}
     * @memberof StoreItemChoice
     */
    'choicePrice': number;
}
/**
 * 
 * @export
 * @interface StoreItemChoiceGroup
 */
export interface StoreItemChoiceGroup {
    /**
     * Unique identifier of the choice group
     * @type {string}
     * @memberof StoreItemChoiceGroup
     */
    'choiceGroupId': string;
    /**
     * English name of the choice group
     * @type {string}
     * @memberof StoreItemChoiceGroup
     */
    'choiceGroupName': string;
    /**
     * Minimum number of choices required
     * @type {number}
     * @memberof StoreItemChoiceGroup
     */
    'minChoiceRequired': number;
    /**
     * Maximum number of choices allowed
     * @type {number}
     * @memberof StoreItemChoiceGroup
     */
    'maxChoiceAllowed': number;
    /**
     * Whether this choice group is required or optional
     * @type {boolean}
     * @memberof StoreItemChoiceGroup
     */
    'isChoiceRequired': boolean;
    /**
     * List of choices available under this group
     * @type {Array<StoreItemChoice>}
     * @memberof StoreItemChoiceGroup
     */
    'choiceDetails': Array<StoreItemChoice>;
}
/**
 * 
 * @export
 * @interface StoreLocationPoint
 */
export interface StoreLocationPoint {
    /**
     * Latitude in decimal degrees
     * @type {number}
     * @memberof StoreLocationPoint
     */
    'lat': number;
    /**
     * Longitude in decimal degrees
     * @type {number}
     * @memberof StoreLocationPoint
     */
    'lng': number;
    /**
     * Human-readable address
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'address'?: string;
    /**
     * When this location was last updated
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'lastUpdated'?: string;
    /**
     * Unique store identifier
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'storeId': string;
    /**
     * Store name
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'storeName': string;
    /**
     * Type of store
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'storeType': StoreLocationPointStoreTypeEnum;
    /**
     * Store-level status
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'status': StoreLocationPointStatusEnum;
    /**
     * Merchant identifier
     * @type {string}
     * @memberof StoreLocationPoint
     */
    'merchantId'?: string;
}

export const StoreLocationPointStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type StoreLocationPointStoreTypeEnum = typeof StoreLocationPointStoreTypeEnum[keyof typeof StoreLocationPointStoreTypeEnum];
export const StoreLocationPointStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Preparing: 'preparing',
    Ready: 'ready',
    PickedUp: 'picked_up'
} as const;

export type StoreLocationPointStatusEnum = typeof StoreLocationPointStatusEnum[keyof typeof StoreLocationPointStatusEnum];

/**
 * 
 * @export
 * @interface StoreOrderItem
 */
export interface StoreOrderItem {
    /**
     * Item identifier
     * @type {string}
     * @memberof StoreOrderItem
     */
    'id': string;
    /**
     * Item name
     * @type {string}
     * @memberof StoreOrderItem
     */
    'name': string;
    /**
     * Item quantity
     * @type {number}
     * @memberof StoreOrderItem
     */
    'quantity': number;
    /**
     * Item price
     * @type {number}
     * @memberof StoreOrderItem
     */
    'price': number;
    /**
     * Item status
     * @type {string}
     * @memberof StoreOrderItem
     */
    'status': StoreOrderItemStatusEnum;
    /**
     * Whether the item is accepted by the merchant
     * @type {boolean}
     * @memberof StoreOrderItem
     */
    'isAccepted': boolean;
    /**
     * Whether the item is rejected by the merchant
     * @type {boolean}
     * @memberof StoreOrderItem
     */
    'isRejected': boolean;
    /**
     * Item image URL
     * @type {string}
     * @memberof StoreOrderItem
     */
    'image'?: string;
    /**
     * Item customizations
     * @type {Array<string>}
     * @memberof StoreOrderItem
     */
    'customizations'?: Array<string>;
    /**
     * Special instructions for item
     * @type {string}
     * @memberof StoreOrderItem
     */
    'specialInstructions'?: string;
    /**
     * Reason for rejection (only present when isRejected is true)
     * @type {string}
     * @memberof StoreOrderItem
     */
    'rejectionReason'?: string;
    /**
     * Refund amount for rejected items
     * @type {number}
     * @memberof StoreOrderItem
     */
    'refundAmount'?: number;
    /**
     * Refund status for rejected items
     * @type {string}
     * @memberof StoreOrderItem
     */
    'refundStatus'?: StoreOrderItemRefundStatusEnum;
}

export const StoreOrderItemStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Preparing: 'preparing',
    Ready: 'ready',
    PickedUp: 'picked_up'
} as const;

export type StoreOrderItemStatusEnum = typeof StoreOrderItemStatusEnum[keyof typeof StoreOrderItemStatusEnum];
export const StoreOrderItemRefundStatusEnum = {
    Pending: 'pending',
    Processed: 'processed'
} as const;

export type StoreOrderItemRefundStatusEnum = typeof StoreOrderItemRefundStatusEnum[keyof typeof StoreOrderItemRefundStatusEnum];

/**
 * 
 * @export
 * @interface StoreOrderSummarySchema
 */
export interface StoreOrderSummarySchema {
    /**
     * Unique identifier for the store
     * @type {string}
     * @memberof StoreOrderSummarySchema
     */
    'storeId': string;
    /**
     * Name of the store
     * @type {string}
     * @memberof StoreOrderSummarySchema
     */
    'storeName': string;
    /**
     * 
     * @type {StorePricingSchema}
     * @memberof StoreOrderSummarySchema
     */
    'pricing': StorePricingSchema;
}
/**
 * 
 * @export
 * @interface StorePickupStatus
 */
export interface StorePickupStatus {
    /**
     * Store identifier
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storeId': string;
    /**
     * Store name in multiple languages
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storeName': string;
    /**
     * Type of store
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storeType': StorePickupStatusStoreTypeEnum;
    /**
     * Merchant identifier
     * @type {string}
     * @memberof StorePickupStatus
     */
    'merchantId'?: string;
    /**
     * Whether pickup from this store is completed
     * @type {boolean}
     * @memberof StorePickupStatus
     */
    'isPickedUp': boolean;
    /**
     * Store physical address
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storeAddress'?: string;
    /**
     * Store location latitude
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storeLatitude'?: string;
    /**
     * Store location longitude
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storeLongitude'?: string;
    /**
     * Store contact phone number
     * @type {string}
     * @memberof StorePickupStatus
     */
    'storePhoneNumber'?: string;
}

export const StorePickupStatusStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type StorePickupStatusStoreTypeEnum = typeof StorePickupStatusStoreTypeEnum[keyof typeof StorePickupStatusStoreTypeEnum];

/**
 * 
 * @export
 * @interface StorePickupStatusNew
 */
export interface StorePickupStatusNew {
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storeId': string;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storeName': string;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storeType': StorePickupStatusNewStoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'merchantId': string;
    /**
     * 
     * @type {boolean}
     * @memberof StorePickupStatusNew
     */
    'isPickedUp': boolean;
    /**
     * Whether all accepted items from this store are ready for pickup
     * @type {boolean}
     * @memberof StorePickupStatusNew
     */
    'isReadyForPickup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storeAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storeLatitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storeLongitude'?: string;
    /**
     * 
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'storePhoneNumber'?: string;
    /**
     * Whether merchant has accepted all items for this store
     * @type {boolean}
     * @memberof StorePickupStatusNew
     */
    'merchantAccepted'?: boolean;
    /**
     * Whether merchant has denied all items for this store
     * @type {boolean}
     * @memberof StorePickupStatusNew
     */
    'merchantDenied'?: boolean;
    /**
     * Whether merchant response is pending for this store
     * @type {boolean}
     * @memberof StorePickupStatusNew
     */
    'merchantPending'?: boolean;
    /**
     * Formatted date-time when merchant accepted (dd/MM/yyyy HH:mm)
     * @type {string}
     * @memberof StorePickupStatusNew
     */
    'merchantAcceptedTime'?: string;
    /**
     * Delivery fee for this store
     * @type {number}
     * @memberof StorePickupStatusNew
     */
    'deliveryFee'?: number;
    /**
     * Total number of items from this store
     * @type {number}
     * @memberof StorePickupStatusNew
     */
    'itemsCount'?: number;
    /**
     * Number of accepted items from this store
     * @type {number}
     * @memberof StorePickupStatusNew
     */
    'acceptedItemsCount'?: number;
    /**
     * Number of denied items from this store
     * @type {number}
     * @memberof StorePickupStatusNew
     */
    'deniedItemsCount'?: number;
}

export const StorePickupStatusNewStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type StorePickupStatusNewStoreTypeEnum = typeof StorePickupStatusNewStoreTypeEnum[keyof typeof StorePickupStatusNewStoreTypeEnum];

/**
 * 
 * @export
 * @interface StorePricingSchema
 */
export interface StorePricingSchema {
    /**
     * Store-level subtotal of all items
     * @type {number}
     * @memberof StorePricingSchema
     */
    'subtotal': number;
    /**
     * Total tax for all items in this store
     * @type {number}
     * @memberof StorePricingSchema
     */
    'tax': number;
    /**
     * Delivery fee (0 for self-pickup)
     * @type {number}
     * @memberof StorePricingSchema
     */
    'deliveryFee': number;
    /**
     * Total amount for this store
     * @type {number}
     * @memberof StorePricingSchema
     */
    'total': number;
    /**
     * Total coupon discount applied to store
     * @type {number}
     * @memberof StorePricingSchema
     */
    'couponDiscount'?: number;
}
/**
 * 
 * @export
 * @interface StoreRating
 */
export interface StoreRating {
    /**
     * Unique identifier for the store
     * @type {string}
     * @memberof StoreRating
     */
    'storeId': string;
    /**
     * Textual review for the store (service, packaging, overall experience)
     * @type {string}
     * @memberof StoreRating
     */
    'review': string;
}
/**
 * 
 * @export
 * @interface StoreRefund
 */
export interface StoreRefund {
    /**
     * Store identifier
     * @type {string}
     * @memberof StoreRefund
     */
    'storeId': string;
    /**
     * Store name
     * @type {string}
     * @memberof StoreRefund
     */
    'storeName': string;
    /**
     * Refund amount from this store
     * @type {number}
     * @memberof StoreRefund
     */
    'refundAmount': number;
    /**
     * Number of refunded items
     * @type {number}
     * @memberof StoreRefund
     */
    'refundedItemsCount': number;
    /**
     * Names of refunded items
     * @type {Array<string>}
     * @memberof StoreRefund
     */
    'refundedItems': Array<string>;
    /**
     * Store-specific refund reason
     * @type {string}
     * @memberof StoreRefund
     */
    'refundReason'?: string;
}
/**
 * 
 * @export
 * @interface StoreReview
 */
export interface StoreReview {
    /**
     * Type of review, must be \'Store\'
     * @type {string}
     * @memberof StoreReview
     */
    'type'?: StoreReviewTypeEnum;
    /**
     * Unique identifier for the store review
     * @type {string}
     * @memberof StoreReview
     */
    'reviewId'?: string;
    /**
     * Unique identifier for the store being reviewed
     * @type {string}
     * @memberof StoreReview
     */
    'storeId'?: string;
    /**
     * Name of the store being reviewed
     * @type {string}
     * @memberof StoreReview
     */
    'storeName'?: string;
    /**
     * Unique identifier for the merchant of the store
     * @type {string}
     * @memberof StoreReview
     */
    'merchantId'?: string;
    /**
     * Name of the merchant of the store
     * @type {string}
     * @memberof StoreReview
     */
    'merchantName'?: string;
    /**
     * Name of the customer providing the review
     * @type {string}
     * @memberof StoreReview
     */
    'customerName'?: string;
    /**
     * Unique identifier for the customer providing the review
     * @type {string}
     * @memberof StoreReview
     */
    'customerId'?: string;
    /**
     * Email address of the customer providing the review
     * @type {string}
     * @memberof StoreReview
     */
    'customerEmail'?: string;
    /**
     * Indicates whether the review is approved or not
     * @type {boolean}
     * @memberof StoreReview
     */
    'reviewApprovalStatus'?: boolean;
    /**
     * Review text for the store
     * @type {string}
     * @memberof StoreReview
     */
    'comment'?: string;
}

export const StoreReviewTypeEnum = {
    Store: 'Store'
} as const;

export type StoreReviewTypeEnum = typeof StoreReviewTypeEnum[keyof typeof StoreReviewTypeEnum];

/**
 * Complete review data for a store
 * @export
 * @interface StoreReviewDataSchema
 */
export interface StoreReviewDataSchema {
    /**
     * 
     * @type {ReviewSummarySchema}
     * @memberof StoreReviewDataSchema
     */
    'reviewSummary'?: ReviewSummarySchema;
    /**
     * List of recent approved reviews (max 10)
     * @type {Array<UserReviewSchema>}
     * @memberof StoreReviewDataSchema
     */
    'recentReviews'?: Array<UserReviewSchema>;
}
/**
 * 
 * @export
 * @interface StoreStatus
 */
export interface StoreStatus {
    /**
     * Store status
     * @type {string}
     * @memberof StoreStatus
     */
    'status': StoreStatusStatusEnum;
    /**
     * Status message
     * @type {string}
     * @memberof StoreStatus
     */
    'message': string;
    /**
     * Status update time
     * @type {string}
     * @memberof StoreStatus
     */
    'timestamp'?: string;
    /**
     * Estimated ready time
     * @type {string}
     * @memberof StoreStatus
     */
    'estimatedReadyTime'?: string;
}

export const StoreStatusStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Preparing: 'preparing',
    Ready: 'ready',
    PickedUp: 'picked_up'
} as const;

export type StoreStatusStatusEnum = typeof StoreStatusStatusEnum[keyof typeof StoreStatusStatusEnum];

/**
 * 
 * @export
 * @interface StoreStatusPieChartItem
 */
export interface StoreStatusPieChartItem {
    /**
     * Store operating status value (Open, Closed).
     * @type {string}
     * @memberof StoreStatusPieChartItem
     */
    'status': string;
    /**
     * Number of stores for each status.
     * @type {number}
     * @memberof StoreStatusPieChartItem
     */
    'count': number;
    /**
     * Percentage of stores for each status.
     * @type {number}
     * @memberof StoreStatusPieChartItem
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface StoreTotals
 */
export interface StoreTotals {
    /**
     * Number of confirmed items
     * @type {number}
     * @memberof StoreTotals
     */
    'confirmedItemsCount': number;
    /**
     * Number of unavailable items
     * @type {number}
     * @memberof StoreTotals
     */
    'unavailableItemsCount': number;
    /**
     * Total amount for confirmed items
     * @type {number}
     * @memberof StoreTotals
     */
    'confirmedAmount': number;
    /**
     * Total refund amount from store
     * @type {number}
     * @memberof StoreTotals
     */
    'refundAmount': number;
    /**
     * Original total amount from store
     * @type {number}
     * @memberof StoreTotals
     */
    'originalAmount'?: number;
}
/**
 * 
 * @export
 * @interface SubAdmin
 */
export interface SubAdmin {
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'lastLoginDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'lastLogoutDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'lastLoginIp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdmin
     */
    'status'?: SubAdminStatusEnum;
}

export const SubAdminStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type SubAdminStatusEnum = typeof SubAdminStatusEnum[keyof typeof SubAdminStatusEnum];

/**
 * 
 * @export
 * @interface SubAdminDetailsSchema
 */
export interface SubAdminDetailsSchema {
    /**
     * Unique identifier for the sub-admin
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'id': string;
    /**
     * Full name of the sub-admin
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'name': string;
    /**
     * Email address of the sub-admin
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'email': string;
    /**
     * Phone number of the sub-admin (Must be a valid international number)
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'mobileNumber': string;
    /**
     * Role of the user, specifically for sub-admins
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'role': SubAdminDetailsSchemaRoleEnum;
    /**
     * Current status of the sub-admin account
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'status': SubAdminDetailsSchemaStatusEnum;
    /**
     * Last login date and time of the sub-admin
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'lastLoginDate'?: string | null;
    /**
     * Last logout date and time of the sub-admin
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'lastLogoutDate'?: string | null;
    /**
     * Last login IP address of the sub-admin
     * @type {string}
     * @memberof SubAdminDetailsSchema
     */
    'lastLoginIp'?: string | null;
    /**
     * If true, the sub-admin has full system access
     * @type {boolean}
     * @memberof SubAdminDetailsSchema
     */
    'privilege'?: boolean;
    /**
     * 
     * @type {Permissions}
     * @memberof SubAdminDetailsSchema
     */
    'permissions': Permissions;
    /**
     * Number of unread notifications for the sub-admin
     * @type {number}
     * @memberof SubAdminDetailsSchema
     */
    'notificationsCount': number;
}

export const SubAdminDetailsSchemaRoleEnum = {
    SubAdmin: 'subAdmin'
} as const;

export type SubAdminDetailsSchemaRoleEnum = typeof SubAdminDetailsSchemaRoleEnum[keyof typeof SubAdminDetailsSchemaRoleEnum];
export const SubAdminDetailsSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type SubAdminDetailsSchemaStatusEnum = typeof SubAdminDetailsSchemaStatusEnum[keyof typeof SubAdminDetailsSchemaStatusEnum];

/**
 * Permission settings for different modules
 * @export
 * @interface SubAdminModulePermissions
 */
export interface SubAdminModulePermissions {
    /**
     * If true, the sub-admin has full system access
     * @type {boolean}
     * @memberof SubAdminModulePermissions
     */
    'privilege'?: boolean;
    /**
     * 
     * @type {Permissions}
     * @memberof SubAdminModulePermissions
     */
    'permissions'?: Permissions;
}
/**
 * 
 * @export
 * @interface SubAdminPermissions
 */
export interface SubAdminPermissions {
    /**
     * 
     * @type {boolean}
     * @memberof SubAdminPermissions
     */
    'view'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubAdminPermissions
     */
    'add'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubAdminPermissions
     */
    'edit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubAdminPermissions
     */
    'delete'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubAdminPermissions
     */
    'block'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubAdminPermissions
     */
    'unBlock'?: boolean;
}
/**
 * 
 * @export
 * @interface SubAdminWithPermissions
 */
export interface SubAdminWithPermissions {
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'lastLoginDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'lastLogoutDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'lastLoginIp'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubAdminWithPermissions
     */
    'status'?: SubAdminWithPermissionsStatusEnum;
    /**
     * If true, the sub-admin has full system access
     * @type {boolean}
     * @memberof SubAdminWithPermissions
     */
    'privilege'?: boolean;
    /**
     * 
     * @type {Permissions}
     * @memberof SubAdminWithPermissions
     */
    'permissions'?: Permissions;
}

export const SubAdminWithPermissionsStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type SubAdminWithPermissionsStatusEnum = typeof SubAdminWithPermissionsStatusEnum[keyof typeof SubAdminWithPermissionsStatusEnum];

/**
 * 
 * @export
 * @interface SubscribeToNewsletterRequest
 */
export interface SubscribeToNewsletterRequest {
    /**
     * Email address to subscribe to newsletter
     * @type {string}
     * @memberof SubscribeToNewsletterRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SubscriptionPlan
 */
export interface SubscriptionPlan {
    /**
     * ID of the subscription plan
     * @type {string}
     * @memberof SubscriptionPlan
     */
    'id'?: string;
    /**
     * Name of the subscription plan
     * @type {string}
     * @memberof SubscriptionPlan
     */
    'name': string;
    /**
     * Unit of plan duration
     * @type {string}
     * @memberof SubscriptionPlan
     */
    'durationIn': SubscriptionPlanDurationInEnum;
    /**
     * Number of duration units
     * @type {number}
     * @memberof SubscriptionPlan
     */
    'duration': number;
    /**
     * Maximum number of orders allowed in the plan
     * @type {number}
     * @memberof SubscriptionPlan
     */
    'numberOfOrders': number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof SubscriptionPlan
     */
    'currencyCode'?: CurrencyCode;
    /**
     * Price of the subscription plan
     * @type {number}
     * @memberof SubscriptionPlan
     */
    'price': number;
    /**
     * Whether all deliveries are free under this plan
     * @type {boolean}
     * @memberof SubscriptionPlan
     */
    'freeDeliveryFee': boolean;
    /**
     * Additional details about the plan
     * @type {string}
     * @memberof SubscriptionPlan
     */
    'description'?: string;
}

export const SubscriptionPlanDurationInEnum = {
    Day: 'day',
    Month: 'month',
    Year: 'year'
} as const;

export type SubscriptionPlanDurationInEnum = typeof SubscriptionPlanDurationInEnum[keyof typeof SubscriptionPlanDurationInEnum];

/**
 * 
 * @export
 * @interface SuccessResponseSchema
 */
export interface SuccessResponseSchema {
    /**
     * 
     * @type {boolean}
     * @memberof SuccessResponseSchema
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponseSchema
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface SuggestedPaymentOption
 */
export interface SuggestedPaymentOption {
    /**
     * Suggested payment method
     * @type {string}
     * @memberof SuggestedPaymentOption
     */
    'paymentMethod'?: SuggestedPaymentOptionPaymentMethodEnum;
    /**
     * Amount to be paid from wallet
     * @type {number}
     * @memberof SuggestedPaymentOption
     */
    'walletAmount'?: number;
    /**
     * Remaining amount for other payment method
     * @type {number}
     * @memberof SuggestedPaymentOption
     */
    'remainingAmount'?: number;
}

export const SuggestedPaymentOptionPaymentMethodEnum = {
    Wallet: 'wallet',
    WalletAndCashOnDelivery: 'walletAndCashOnDelivery',
    WalletAndOnlinePayment: 'walletAndOnlinePayment'
} as const;

export type SuggestedPaymentOptionPaymentMethodEnum = typeof SuggestedPaymentOptionPaymentMethodEnum[keyof typeof SuggestedPaymentOptionPaymentMethodEnum];

/**
 * 
 * @export
 * @interface SuperAdminDetailsSchema
 */
export interface SuperAdminDetailsSchema {
    /**
     * Unique identifier for the super admin
     * @type {string}
     * @memberof SuperAdminDetailsSchema
     */
    'id': string;
    /**
     * Full name of the super admin
     * @type {string}
     * @memberof SuperAdminDetailsSchema
     */
    'name': string;
    /**
     * Email address of the super admin
     * @type {string}
     * @memberof SuperAdminDetailsSchema
     */
    'email': string;
    /**
     * Phone number of the super admin (Must be a valid international number)
     * @type {string}
     * @memberof SuperAdminDetailsSchema
     */
    'mobileNumber': string;
    /**
     * Role of the user, specifically for super admins
     * @type {string}
     * @memberof SuperAdminDetailsSchema
     */
    'role': SuperAdminDetailsSchemaRoleEnum;
    /**
     * Number of unread notifications for the super admin
     * @type {number}
     * @memberof SuperAdminDetailsSchema
     */
    'notificationsCount': number;
}

export const SuperAdminDetailsSchemaRoleEnum = {
    SuperAdmin: 'superAdmin'
} as const;

export type SuperAdminDetailsSchemaRoleEnum = typeof SuperAdminDetailsSchemaRoleEnum[keyof typeof SuperAdminDetailsSchemaRoleEnum];

/**
 * 
 * @export
 * @interface TimeDataSchema
 */
export interface TimeDataSchema {
    /**
     * Time value for delivery time or working hours
     * @type {number}
     * @memberof TimeDataSchema
     */
    'value'?: number;
    /**
     * 
     * @type {string}
     * @memberof TimeDataSchema
     */
    'format'?: TimeDataSchemaFormatEnum;
}

export const TimeDataSchemaFormatEnum = {
    Hours: 'hours',
    Minutes: 'minutes',
    Seconds: 'seconds',
    HoursAr: 'ساعات',
    MinutesAr: 'دقائق',
    SecondsAr: 'ثواني'
} as const;

export type TimeDataSchemaFormatEnum = typeof TimeDataSchemaFormatEnum[keyof typeof TimeDataSchemaFormatEnum];

/**
 * 
 * @export
 * @interface TimePeriodSchema
 */
export interface TimePeriodSchema {
    /**
     * Start time for the meal period
     * @type {string}
     * @memberof TimePeriodSchema
     */
    'startTime'?: string;
    /**
     * End time for the meal period
     * @type {string}
     * @memberof TimePeriodSchema
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface TimeRange
 */
export interface TimeRange {
    /**
     * Start time in HH:MM format
     * @type {string}
     * @memberof TimeRange
     */
    'startTime': string;
    /**
     * End time in HH:MM format
     * @type {string}
     * @memberof TimeRange
     */
    'endTime': string;
    /**
     * Additional fee for this time range
     * @type {number}
     * @memberof TimeRange
     */
    'additionalFee'?: number;
}
/**
 * 
 * @export
 * @interface TimelineStep
 */
export interface TimelineStep {
    /**
     * Step identifier
     * @type {string}
     * @memberof TimelineStep
     */
    'id': string;
    /**
     * Step title
     * @type {string}
     * @memberof TimelineStep
     */
    'title': string;
    /**
     * Step description
     * @type {string}
     * @memberof TimelineStep
     */
    'description': string;
    /**
     * Step status
     * @type {string}
     * @memberof TimelineStep
     */
    'status': TimelineStepStatusEnum;
    /**
     * When step was completed
     * @type {string}
     * @memberof TimelineStep
     */
    'timestamp'?: string;
    /**
     * Additional step details
     * @type {Array<string>}
     * @memberof TimelineStep
     */
    'details'?: Array<string>;
}

export const TimelineStepStatusEnum = {
    Completed: 'completed',
    Current: 'current',
    Pending: 'pending'
} as const;

export type TimelineStepStatusEnum = typeof TimelineStepStatusEnum[keyof typeof TimelineStepStatusEnum];

/**
 * 
 * @export
 * @interface TipInitiateRequestSchema
 */
export interface TipInitiateRequestSchema {
    /**
     * Order ID for which to add tip
     * @type {string}
     * @memberof TipInitiateRequestSchema
     */
    'orderId': string;
    /**
     * ID of the user adding the tip
     * @type {string}
     * @memberof TipInitiateRequestSchema
     */
    'userId': string;
    /**
     * Currency code for the tip amount (e.g., JOD, SAR)
     * @type {string}
     * @memberof TipInitiateRequestSchema
     */
    'currencyCode': string;
    /**
     * Tip amount to be paid
     * @type {number}
     * @memberof TipInitiateRequestSchema
     */
    'tipAmount': number;
    /**
     * Platform type - determines payment response format (web: checkoutUrl, mobile: clientSecret for SDK)
     * @type {string}
     * @memberof TipInitiateRequestSchema
     */
    'platform': TipInitiateRequestSchemaPlatformEnum;
    /**
     * Payment gateway to use for tip payment
     * @type {string}
     * @memberof TipInitiateRequestSchema
     */
    'gatewayType': TipInitiateRequestSchemaGatewayTypeEnum;
}

export const TipInitiateRequestSchemaPlatformEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;

export type TipInitiateRequestSchemaPlatformEnum = typeof TipInitiateRequestSchemaPlatformEnum[keyof typeof TipInitiateRequestSchemaPlatformEnum];
export const TipInitiateRequestSchemaGatewayTypeEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type TipInitiateRequestSchemaGatewayTypeEnum = typeof TipInitiateRequestSchemaGatewayTypeEnum[keyof typeof TipInitiateRequestSchemaGatewayTypeEnum];

/**
 * 
 * @export
 * @interface TipInitiateResponseSchema
 */
export interface TipInitiateResponseSchema {
    /**
     * 
     * @type {boolean}
     * @memberof TipInitiateResponseSchema
     */
    'success': boolean;
    /**
     * Gateway checkout session ID
     * @type {string}
     * @memberof TipInitiateResponseSchema
     */
    'checkoutId': string;
    /**
     * URL to redirect user for payment (web platform only)
     * @type {string}
     * @memberof TipInitiateResponseSchema
     */
    'checkoutUrl'?: string;
    /**
     * Client secret for mobile SDK payment (mobile platform only, Stripe only)
     * @type {string}
     * @memberof TipInitiateResponseSchema
     */
    'clientSecret'?: string;
    /**
     * Payment session expiry time
     * @type {string}
     * @memberof TipInitiateResponseSchema
     */
    'expiresAt'?: string;
    /**
     * Payment record ID
     * @type {string}
     * @memberof TipInitiateResponseSchema
     */
    'paymentId': string;
    /**
     * 
     * @type {string}
     * @memberof TipInitiateResponseSchema
     */
    'tipStatus': TipInitiateResponseSchemaTipStatusEnum;
}

export const TipInitiateResponseSchemaTipStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Settled: 'settled'
} as const;

export type TipInitiateResponseSchemaTipStatusEnum = typeof TipInitiateResponseSchemaTipStatusEnum[keyof typeof TipInitiateResponseSchemaTipStatusEnum];

/**
 * 
 * @export
 * @interface TipStatusResponseSchema
 */
export interface TipStatusResponseSchema {
    /**
     * 
     * @type {boolean}
     * @memberof TipStatusResponseSchema
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TipStatusResponseSchema
     */
    'orderId': string;
    /**
     * Whether the user can add a tip for this order
     * @type {boolean}
     * @memberof TipStatusResponseSchema
     */
    'canTip': boolean;
    /**
     * 
     * @type {number}
     * @memberof TipStatusResponseSchema
     */
    'tipAmount': number;
    /**
     * 
     * @type {string}
     * @memberof TipStatusResponseSchema
     */
    'tipStatus': TipStatusResponseSchemaTipStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TipStatusResponseSchema
     */
    'tipPaidAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TipStatusResponseSchema
     */
    'deliveredBy'?: string | null;
}

export const TipStatusResponseSchemaTipStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Settled: 'settled'
} as const;

export type TipStatusResponseSchemaTipStatusEnum = typeof TipStatusResponseSchemaTipStatusEnum[keyof typeof TipStatusResponseSchemaTipStatusEnum];

/**
 * 
 * @export
 * @interface TipVerifyRequestSchema
 */
export interface TipVerifyRequestSchema {
    /**
     * Order ID for tip verification
     * @type {string}
     * @memberof TipVerifyRequestSchema
     */
    'orderId': string;
    /**
     * ID of the user verifying the tip
     * @type {string}
     * @memberof TipVerifyRequestSchema
     */
    'userId': string;
    /**
     * Gateway checkout session ID returned from tip initiate
     * @type {string}
     * @memberof TipVerifyRequestSchema
     */
    'checkoutId': string;
}
/**
 * 
 * @export
 * @interface TipVerifyResponseSchema
 */
export interface TipVerifyResponseSchema {
    /**
     * 
     * @type {boolean}
     * @memberof TipVerifyResponseSchema
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof TipVerifyResponseSchema
     */
    'tipAmount': number;
    /**
     * 
     * @type {string}
     * @memberof TipVerifyResponseSchema
     */
    'tipStatus': TipVerifyResponseSchemaTipStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TipVerifyResponseSchema
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof TipVerifyResponseSchema
     */
    'driverName'?: string;
}

export const TipVerifyResponseSchemaTipStatusEnum = {
    Pending: 'pending',
    Paid: 'paid',
    Failed: 'failed',
    Settled: 'settled'
} as const;

export type TipVerifyResponseSchemaTipStatusEnum = typeof TipVerifyResponseSchemaTipStatusEnum[keyof typeof TipVerifyResponseSchemaTipStatusEnum];

/**
 * 
 * @export
 * @interface ToggleChoiceStatusRequest
 */
export interface ToggleChoiceStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleChoiceStatusRequest
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ToggleChoiceStatusRequest
     */
    'status': ToggleChoiceStatusRequestStatusEnum;
}

export const ToggleChoiceStatusRequestStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type ToggleChoiceStatusRequestStatusEnum = typeof ToggleChoiceStatusRequestStatusEnum[keyof typeof ToggleChoiceStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface ToggleItemStatusRequest
 */
export interface ToggleItemStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleItemStatusRequest
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ToggleItemStatusRequest
     */
    'status': ToggleItemStatusRequestStatusEnum;
}

export const ToggleItemStatusRequestStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type ToggleItemStatusRequestStatusEnum = typeof ToggleItemStatusRequestStatusEnum[keyof typeof ToggleItemStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface ToggleMerchantActiveStatusRequest
 */
export interface ToggleMerchantActiveStatusRequest {
    /**
     * Indicates whether the merchant is active or blocked
     * @type {boolean}
     * @memberof ToggleMerchantActiveStatusRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface ToggleNewletterSubscriberStatusRequest
 */
export interface ToggleNewletterSubscriberStatusRequest {
    /**
     * List of subscriber IDs to update
     * @type {Array<string>}
     * @memberof ToggleNewletterSubscriberStatusRequest
     */
    'ids': Array<string>;
    /**
     * true = active, false = unsubscribed
     * @type {boolean}
     * @memberof ToggleNewletterSubscriberStatusRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface ToggleOfferStatusRequestSchema
 */
export interface ToggleOfferStatusRequestSchema {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleOfferStatusRequestSchema
     */
    'offerIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ToggleOfferStatusRequestSchema
     */
    'status': ToggleOfferStatusRequestSchemaStatusEnum;
}

export const ToggleOfferStatusRequestSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type ToggleOfferStatusRequestSchemaStatusEnum = typeof ToggleOfferStatusRequestSchemaStatusEnum[keyof typeof ToggleOfferStatusRequestSchemaStatusEnum];

/**
 * 
 * @export
 * @interface ToggleReviewApprovalStatusRequest
 */
export interface ToggleReviewApprovalStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleReviewApprovalStatusRequest
     */
    'reviewIds': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ToggleReviewApprovalStatusRequest
     */
    'status': boolean;
}
/**
 * 
 * @export
 * @interface ToggleSubAdminStatusRequest
 */
export interface ToggleSubAdminStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleSubAdminStatusRequest
     */
    'ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ToggleSubAdminStatusRequest
     */
    'status': ToggleSubAdminStatusRequestStatusEnum;
}

export const ToggleSubAdminStatusRequestStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type ToggleSubAdminStatusRequestStatusEnum = typeof ToggleSubAdminStatusRequestStatusEnum[keyof typeof ToggleSubAdminStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface ToggleSubCategoryStatusRequest
 */
export interface ToggleSubCategoryStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleSubCategoryStatusRequest
     */
    'ids': Array<string>;
    /**
     * The new status to be applied to the sub-item categories.
     * @type {string}
     * @memberof ToggleSubCategoryStatusRequest
     */
    'status': ToggleSubCategoryStatusRequestStatusEnum;
}

export const ToggleSubCategoryStatusRequestStatusEnum = {
    Published: 'Published',
    Unpublished: 'Unpublished'
} as const;

export type ToggleSubCategoryStatusRequestStatusEnum = typeof ToggleSubCategoryStatusRequestStatusEnum[keyof typeof ToggleSubCategoryStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface ToggleSubscriptionPlanStatusRequest
 */
export interface ToggleSubscriptionPlanStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleSubscriptionPlanStatusRequest
     */
    'ids': Array<string>;
    /**
     * Set to true to activate, false to deactivate
     * @type {boolean}
     * @memberof ToggleSubscriptionPlanStatusRequest
     */
    'isActive': boolean;
}
/**
 * 
 * @export
 * @interface ToggleUserStatusRequest
 */
export interface ToggleUserStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ToggleUserStatusRequest
     */
    'userIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ToggleUserStatusRequest
     */
    'status': ToggleUserStatusRequestStatusEnum;
}

export const ToggleUserStatusRequestStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type ToggleUserStatusRequestStatusEnum = typeof ToggleUserStatusRequestStatusEnum[keyof typeof ToggleUserStatusRequestStatusEnum];

/**
 * 
 * @export
 * @interface TotalPricingSchema
 */
export interface TotalPricingSchema {
    /**
     * Total subtotal across all stores
     * @type {number}
     * @memberof TotalPricingSchema
     */
    'subtotal': number;
    /**
     * Total tax across all stores
     * @type {number}
     * @memberof TotalPricingSchema
     */
    'tax': number;
    /**
     * Total delivery fees across all stores
     * @type {number}
     * @memberof TotalPricingSchema
     */
    'totalDeliveryFee': number;
    /**
     * Grand total for entire order
     * @type {number}
     * @memberof TotalPricingSchema
     */
    'grandTotal': number;
    /**
     * Total coupon discounts applied
     * @type {number}
     * @memberof TotalPricingSchema
     */
    'totalCouponDiscount'?: number;
}
/**
 * 
 * @export
 * @interface TrackingDetails
 */
export interface TrackingDetails {
    /**
     * 
     * @type {string}
     * @memberof TrackingDetails
     */
    'currentStatus': string;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof TrackingDetails
     */
    'history': Array<TrackingEvent>;
}
/**
 * 
 * @export
 * @interface TrackingEvent
 */
export interface TrackingEvent {
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof TrackingEvent
     */
    'orderId'?: string;
    /**
     * Unique identifier for the item being tracked
     * @type {string}
     * @memberof TrackingEvent
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    'status': string;
    /**
     * Timestamp of the tracking event
     * @type {string}
     * @memberof TrackingEvent
     */
    'timestamp': string;
    /**
     * Identifier of the user or system that updated the tracking event
     * @type {string}
     * @memberof TrackingEvent
     */
    'updateBy'?: string;
    /**
     * Type of user who updated the tracking event (e.g., customer, delivery person, admin)
     * @type {string}
     * @memberof TrackingEvent
     */
    'userType'?: string;
    /**
     * Reason for the tracking event
     * @type {string}
     * @memberof TrackingEvent
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface TrackingHistoryItem
 */
export interface TrackingHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'updatedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'userType'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingHistoryItem
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface TrackingMapData
 */
export interface TrackingMapData {
    /**
     * 
     * @type {LocationPoint}
     * @memberof TrackingMapData
     */
    'customerLocation'?: LocationPoint;
    /**
     * All store locations in the order
     * @type {Array<StoreLocationPoint>}
     * @memberof TrackingMapData
     */
    'storeLocations': Array<StoreLocationPoint>;
    /**
     * 
     * @type {DeliveryPartnerLocation}
     * @memberof TrackingMapData
     */
    'deliveryPartner'?: DeliveryPartnerLocation;
    /**
     * 
     * @type {LocationPoint}
     * @memberof TrackingMapData
     */
    'mapCenter'?: LocationPoint;
    /**
     * Suggested map zoom level
     * @type {number}
     * @memberof TrackingMapData
     */
    'zoomLevel'?: number;
}
/**
 * 
 * @export
 * @interface TransactionResponse
 */
export interface TransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'transactionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'fromUserId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'toUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'fromUserType'?: TransactionResponseFromUserTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'toUserType'?: TransactionResponseToUserTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    'amount'?: number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof TransactionResponse
     */
    'currency'?: CurrencyCode;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'transactionCategory'?: TransactionResponseTransactionCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'transactionType'?: TransactionResponseTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'status'?: TransactionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {UserInfo}
     * @memberof TransactionResponse
     */
    'fromUser'?: UserInfo;
    /**
     * 
     * @type {UserInfo}
     * @memberof TransactionResponse
     */
    'toUser'?: UserInfo;
    /**
     * 
     * @type {OrderInfo}
     * @memberof TransactionResponse
     */
    'orderInfo'?: OrderInfo;
}

export const TransactionResponseFromUserTypeEnum = {
    Admin: 'ADMIN',
    Subadmin: 'SUBADMIN',
    Merchant: 'MERCHANT',
    Customer: 'CUSTOMER',
    DeliveryPartner: 'DELIVERY_PARTNER'
} as const;

export type TransactionResponseFromUserTypeEnum = typeof TransactionResponseFromUserTypeEnum[keyof typeof TransactionResponseFromUserTypeEnum];
export const TransactionResponseToUserTypeEnum = {
    Admin: 'ADMIN',
    Subadmin: 'SUBADMIN',
    Merchant: 'MERCHANT',
    Customer: 'CUSTOMER',
    DeliveryPartner: 'DELIVERY_PARTNER'
} as const;

export type TransactionResponseToUserTypeEnum = typeof TransactionResponseToUserTypeEnum[keyof typeof TransactionResponseToUserTypeEnum];
export const TransactionResponseTransactionCategoryEnum = {
    OrderPayment: 'ORDER_PAYMENT',
    MerchantPayment: 'MERCHANT_PAYMENT',
    DeliveryFee: 'DELIVERY_FEE',
    DriverBonus: 'DRIVER_BONUS',
    Refund: 'REFUND',
    CodCollection: 'COD_COLLECTION',
    CodPayment: 'COD_PAYMENT',
    Tip: 'TIP'
} as const;

export type TransactionResponseTransactionCategoryEnum = typeof TransactionResponseTransactionCategoryEnum[keyof typeof TransactionResponseTransactionCategoryEnum];
export const TransactionResponseTransactionTypeEnum = {
    ToPay: 'toPay',
    ToReceive: 'toReceive',
    Completed: 'completed'
} as const;

export type TransactionResponseTransactionTypeEnum = typeof TransactionResponseTransactionTypeEnum[keyof typeof TransactionResponseTransactionTypeEnum];
export const TransactionResponseStatusEnum = {
    Pending: 'PENDING',
    Inprogress: 'INPROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    Cancelled: 'CANCELLED'
} as const;

export type TransactionResponseStatusEnum = typeof TransactionResponseStatusEnum[keyof typeof TransactionResponseStatusEnum];

/**
 * 
 * @export
 * @interface TransactionSummary
 */
export interface TransactionSummary {
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'totalAmountToPay'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'totalAmountToReceive'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'totalAmountCompleted'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'countToPay'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'countToReceive'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'countCompleted'?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionSummary
     */
    'pendingCount'?: number;
}
/**
 * 
 * @export
 * @interface UnavailableOrderItem
 */
export interface UnavailableOrderItem {
    /**
     * Item identifier
     * @type {string}
     * @memberof UnavailableOrderItem
     */
    'id': string;
    /**
     * Item name
     * @type {string}
     * @memberof UnavailableOrderItem
     */
    'name': string;
    /**
     * Item quantity
     * @type {number}
     * @memberof UnavailableOrderItem
     */
    'quantity': number;
    /**
     * Original item price
     * @type {number}
     * @memberof UnavailableOrderItem
     */
    'price': number;
    /**
     * Unavailability reason
     * @type {string}
     * @memberof UnavailableOrderItem
     */
    'reason': string;
    /**
     * Refund amount for item
     * @type {number}
     * @memberof UnavailableOrderItem
     */
    'refundAmount': number;
    /**
     * Refund processing status
     * @type {string}
     * @memberof UnavailableOrderItem
     */
    'refundStatus'?: UnavailableOrderItemRefundStatusEnum;
    /**
     * Item image URL
     * @type {string}
     * @memberof UnavailableOrderItem
     */
    'image'?: string;
}

export const UnavailableOrderItemRefundStatusEnum = {
    Processed: 'processed',
    Pending: 'pending',
    Failed: 'failed'
} as const;

export type UnavailableOrderItemRefundStatusEnum = typeof UnavailableOrderItemRefundStatusEnum[keyof typeof UnavailableOrderItemRefundStatusEnum];

/**
 * 
 * @export
 * @interface UpdateItemStockRequestSchema
 */
export interface UpdateItemStockRequestSchema {
    /**
     * The quantity of the item in stock
     * @type {number}
     * @memberof UpdateItemStockRequestSchema
     */
    'quantity': number;
    /**
     * The operation to perform on the current quantity
     * @type {string}
     * @memberof UpdateItemStockRequestSchema
     */
    'operation': UpdateItemStockRequestSchemaOperationEnum;
}

export const UpdateItemStockRequestSchemaOperationEnum = {
    Add: 'add',
    Subtract: 'subtract',
    Replace: 'replace'
} as const;

export type UpdateItemStockRequestSchemaOperationEnum = typeof UpdateItemStockRequestSchemaOperationEnum[keyof typeof UpdateItemStockRequestSchemaOperationEnum];

/**
 * 
 * @export
 * @interface UpdateOrderStatusRequest
 */
export interface UpdateOrderStatusRequest {
    /**
     * Unique identifier for the order (MongoDB ObjectId)
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'orderId': string;
    /**
     * Unique identifier for the order
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'orderNumber': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrderStatusRequest
     */
    'itemIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrderStatusRequest
     */
    'acceptedItemIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateOrderStatusRequest
     */
    'deniedItemIds'?: Array<string>;
    /**
     * Current status in the tracking flow
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'status': UpdateOrderStatusRequestStatusEnum;
    /**
     * Unique identifier for the user (MongoDB ObjectId)
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'userType': UpdateOrderStatusRequestUserTypeEnum;
    /**
     * Reason for the status change, if applicable (e.g., cancellation reason)
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'reason'?: string;
    /**
     * Unique identifier for the store (MongoDB ObjectId)
     * @type {string}
     * @memberof UpdateOrderStatusRequest
     */
    'storeId'?: string;
}

export const UpdateOrderStatusRequestStatusEnum = {
    MerchantAccepted: 'MERCHANT_ACCEPTED',
    MerchantDenied: 'MERCHANT_DENIED',
    MerchantCancelled: 'MERCHANT_CANCELLED',
    MerchantDelivered: 'MERCHANT_DELIVERED',
    DeliveryPartnerAccepted: 'DELIVERY_PARTNER_ACCEPTED',
    DeliveryPartnerDenied: 'DELIVERY_PARTNER_DENIED',
    OrderPreparing: 'ORDER_PREPARING',
    ReadyForPickup: 'READY_FOR_PICKUP',
    OrderPickedUp: 'ORDER_PICKED_UP',
    OrderArrivingNearby: 'ORDER_ARRIVING_NEARBY',
    OrderDelivered: 'ORDER_DELIVERED',
    OrderUnableToDeliver: 'ORDER_UNABLE_TO_DELIVER',
    OrderCancelled: 'ORDER_CANCELLED',
    MerchantStatus: 'MERCHANT_STATUS',
    DeliveryFailed: 'DELIVERY_FAILED'
} as const;

export type UpdateOrderStatusRequestStatusEnum = typeof UpdateOrderStatusRequestStatusEnum[keyof typeof UpdateOrderStatusRequestStatusEnum];
export const UpdateOrderStatusRequestUserTypeEnum = {
    Customer: 'customer',
    Admin: 'admin',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner'
} as const;

export type UpdateOrderStatusRequestUserTypeEnum = typeof UpdateOrderStatusRequestUserTypeEnum[keyof typeof UpdateOrderStatusRequestUserTypeEnum];

/**
 * 
 * @export
 * @interface UpdateRestaurantCategoryRequest
 */
export interface UpdateRestaurantCategoryRequest {
    /**
     * The category name in English.
     * @type {string}
     * @memberof UpdateRestaurantCategoryRequest
     */
    'nameEnglish'?: string;
    /**
     * The category name in Arabic.
     * @type {string}
     * @memberof UpdateRestaurantCategoryRequest
     */
    'nameArabic'?: string;
    /**
     * The URL of the category image.
     * @type {string}
     * @memberof UpdateRestaurantCategoryRequest
     */
    'categoryImage'?: string;
    /**
     * The URL of the category icon.
     * @type {string}
     * @memberof UpdateRestaurantCategoryRequest
     */
    'categoryIcon'?: string;
}
/**
 * Request body for updating the user\'s wallet
 * @export
 * @interface UpdateWalletRequest
 */
export interface UpdateWalletRequest {
    /**
     * ID of the wallet being updated
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'walletId'?: string;
    /**
     * ID of the user whose wallet is being updated
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'userId': string;
    /**
     * Amount to be credited or deducted
     * @type {number}
     * @memberof UpdateWalletRequest
     */
    'amount': number;
    /**
     * Type of transaction, credit or debit
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'type': UpdateWalletRequestTypeEnum;
    /**
     * Reason for the transaction (e.g., referral reward, order payment)
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'description'?: string;
    /**
     * Currency code for the transaction (e.g., JOD, SAR). If not provided, defaults to environment currency or JOD
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'currencyCode'?: string;
    /**
     * Payment method for wallet load (direct for admin/system initiated, stripe/hyperpay for user-initiated gateway payments)
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'paymentMethod'?: UpdateWalletRequestPaymentMethodEnum;
    /**
     * Platform type for gateway payments (determines response format)
     * @type {string}
     * @memberof UpdateWalletRequest
     */
    'platform'?: UpdateWalletRequestPlatformEnum;
}

export const UpdateWalletRequestTypeEnum = {
    Credit: 'credit',
    Debit: 'debit'
} as const;

export type UpdateWalletRequestTypeEnum = typeof UpdateWalletRequestTypeEnum[keyof typeof UpdateWalletRequestTypeEnum];
export const UpdateWalletRequestPaymentMethodEnum = {
    Direct: 'direct',
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type UpdateWalletRequestPaymentMethodEnum = typeof UpdateWalletRequestPaymentMethodEnum[keyof typeof UpdateWalletRequestPaymentMethodEnum];
export const UpdateWalletRequestPlatformEnum = {
    Web: 'web',
    Mobile: 'mobile'
} as const;

export type UpdateWalletRequestPlatformEnum = typeof UpdateWalletRequestPlatformEnum[keyof typeof UpdateWalletRequestPlatformEnum];

/**
 * Response for wallet update (supports both direct updates and payment gateway flows)
 * @export
 * @interface UpdateWalletResponse
 */
export interface UpdateWalletResponse {
    /**
     * Indicates whether payment gateway is required (false for direct updates, true for gateway payments)
     * @type {boolean}
     * @memberof UpdateWalletResponse
     */
    'requiresPayment': boolean;
    /**
     * User-friendly message about the wallet operation
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'message': string;
    /**
     * Wallet transaction ID for tracking (present for gateway payments)
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'transactionId'?: string;
    /**
     * Payment gateway checkout/session ID (present for gateway payments)
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'checkoutId'?: string;
    /**
     * Payment gateway checkout URL (for web platform)
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'checkoutUrl'?: string;
    /**
     * Payment intent client secret (for mobile Stripe)
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'clientSecret'?: string;
    /**
     * Ephemeral key for Stripe mobile SDK
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'ephemeralKey'?: string;
    /**
     * Stripe customer ID (for mobile)
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'customerId'?: string;
    /**
     * Stripe publishable key (for mobile)
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'publishableKey'?: string;
    /**
     * Payment gateway type being used
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'gatewayType'?: UpdateWalletResponseGatewayTypeEnum;
    /**
     * Checkout session expiry time
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'expiresAt'?: string;
    /**
     * Shopper result URL for HyperPay
     * @type {string}
     * @memberof UpdateWalletResponse
     */
    'shopperResultUrl'?: string;
}

export const UpdateWalletResponseGatewayTypeEnum = {
    Stripe: 'stripe',
    Hyperpay: 'hyperpay'
} as const;

export type UpdateWalletResponseGatewayTypeEnum = typeof UpdateWalletResponseGatewayTypeEnum[keyof typeof UpdateWalletResponseGatewayTypeEnum];

/**
 * 
 * @export
 * @interface UserAddressSchema
 */
export interface UserAddressSchema {
    /**
     * Unique identifier for the address
     * @type {string}
     * @memberof UserAddressSchema
     */
    'addressId'?: string;
    /**
     * Unique identifier for the user
     * @type {string}
     * @memberof UserAddressSchema
     */
    'userId'?: string;
    /**
     * Label for the address (e.g., Home, Work)
     * @type {string}
     * @memberof UserAddressSchema
     */
    'label'?: string;
    /**
     * Type of address (e.g., Residential, Commercial)
     * @type {string}
     * @memberof UserAddressSchema
     */
    'addressType'?: string;
    /**
     * Nearby landmark for easier identification
     * @type {string}
     * @memberof UserAddressSchema
     */
    'landmark'?: string;
    /**
     * Door or flat number of the address
     * @type {string}
     * @memberof UserAddressSchema
     */
    'doorOrFlatNumber'?: string;
    /**
     * Full restaurant address
     * @type {string}
     * @memberof UserAddressSchema
     */
    'address'?: string;
    /**
     * City of the restaurant location
     * @type {string}
     * @memberof UserAddressSchema
     */
    'city'?: string;
    /**
     * State of the restaurant location
     * @type {string}
     * @memberof UserAddressSchema
     */
    'state'?: string;
    /**
     * Country of the restaurant location
     * @type {string}
     * @memberof UserAddressSchema
     */
    'country'?: string;
    /**
     * Postal code of the restaurant location
     * @type {string}
     * @memberof UserAddressSchema
     */
    'postalCode'?: string;
    /**
     * Latitude of the restaurant location
     * @type {string}
     * @memberof UserAddressSchema
     */
    'latitude'?: string;
    /**
     * Longitude of the restaurant location
     * @type {string}
     * @memberof UserAddressSchema
     */
    'longitude'?: string;
    /**
     * Indicates if this is the default address
     * @type {boolean}
     * @memberof UserAddressSchema
     */
    'isDefault'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const UserDeviceTypeEnum = {
    Android: 'android',
    Ios: 'ios',
    Web: 'web'
} as const;

export type UserDeviceTypeEnum = typeof UserDeviceTypeEnum[keyof typeof UserDeviceTypeEnum];


/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    'userType'?: UserInfoUserTypeEnum;
}

export const UserInfoUserTypeEnum = {
    Admin: 'ADMIN',
    Subadmin: 'SUBADMIN',
    Merchant: 'MERCHANT',
    Customer: 'CUSTOMER',
    DeliveryPartner: 'DELIVERY_PARTNER'
} as const;

export type UserInfoUserTypeEnum = typeof UserInfoUserTypeEnum[keyof typeof UserInfoUserTypeEnum];

/**
 * Individual user review details
 * @export
 * @interface UserReviewSchema
 */
export interface UserReviewSchema {
    /**
     * Unique review identifier
     * @type {string}
     * @memberof UserReviewSchema
     */
    'reviewId'?: string;
    /**
     * User ID who wrote the review
     * @type {string}
     * @memberof UserReviewSchema
     */
    'userId'?: string;
    /**
     * Name of the user who wrote the review
     * @type {string}
     * @memberof UserReviewSchema
     */
    'userName'?: string;
    /**
     * Rating given (0-5)
     * @type {number}
     * @memberof UserReviewSchema
     */
    'rating'?: number;
    /**
     * Text content of the review
     * @type {string}
     * @memberof UserReviewSchema
     */
    'reviewText'?: string;
    /**
     * When the review was created
     * @type {string}
     * @memberof UserReviewSchema
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface UserSchema
 */
export interface UserSchema {
    /**
     * Unique identifier for the user
     * @type {string}
     * @memberof UserSchema
     */
    'userId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSchema
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSchema
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSchema
     */
    'mobileNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSchema
     */
    'alternativeMobileNumber'?: string;
    /**
     * 
     * @type {Array<UserAddressSchema>}
     * @memberof UserSchema
     */
    'userAddresses'?: Array<UserAddressSchema>;
    /**
     * URL of the restaurant logo (mandatory)
     * @type {string}
     * @memberof UserSchema
     */
    'profileImage'?: string;
    /**
     * Unique identifier for the user who added this user
     * @type {string}
     * @memberof UserSchema
     */
    'addedBy'?: string;
    /**
     * Status of the user account
     * @type {string}
     * @memberof UserSchema
     */
    'status'?: UserSchemaStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSchema
     */
    'userPreferredThemeColor'?: string;
}

export const UserSchemaStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;

export type UserSchemaStatusEnum = typeof UserSchemaStatusEnum[keyof typeof UserSchemaStatusEnum];

/**
 * 
 * @export
 * @interface UserShort
 */
export interface UserShort {
    /**
     * 
     * @type {string}
     * @memberof UserShort
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof UserShort
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserShort
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserShort
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface ValidationErrorDetailsSchema
 */
export interface ValidationErrorDetailsSchema {
    /**
     * Quantity requested by user
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'requestedQuantity'?: number;
    /**
     * Quantity available in stock
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'availableQuantity'?: number;
    /**
     * Required store capability that\'s missing
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'requiredCapability'?: string;
    /**
     * Distance from user to store (km)
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'distance'?: number;
    /**
     * Store\'s delivery radius (km)
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'deliveryRadius'?: number;
    /**
     * Requested order time
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'requestedTime'?: string;
    /**
     * Store opening time on requested date
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'storeOpenTime'?: string;
    /**
     * Store closing time on requested date
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'storeCloseTime'?: string;
    /**
     * Current order total for the store
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'currentOrderAmount'?: number;
    /**
     * Minimum order amount required by the store
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'minimumOrderAmount'?: number;
    /**
     * Current server time (for pre-order validation)
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'currentTime'?: string;
    /**
     * Minimum advance notice required for pre-orders (in minutes)
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'minimumAdvanceMinutes'?: number;
    /**
     * Current minutes in advance for the requested pre-order time
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'currentMinutesInAdvance'?: number;
    /**
     * Maximum advance time allowed for pre-orders (in days)
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'maximumAdvanceDays'?: number;
    /**
     * Current days in advance for the requested pre-order time
     * @type {number}
     * @memberof ValidationErrorDetailsSchema
     */
    'currentDaysInAdvance'?: number;
    /**
     * Delivery mode requested by user for pre-order
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'requestedDeliveryMode'?: string;
    /**
     * Required delivery mode for pre-orders
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'requiredDeliveryMode'?: string;
    /**
     * Pre-order time that was set in the cart
     * @type {string}
     * @memberof ValidationErrorDetailsSchema
     */
    'cartTime'?: string;
}
/**
 * 
 * @export
 * @interface ValidationErrorSchema
 */
export interface ValidationErrorSchema {
    /**
     * Category of validation error
     * @type {string}
     * @memberof ValidationErrorSchema
     */
    'type': ValidationErrorSchemaTypeEnum;
    /**
     * ID of the store related to this error
     * @type {string}
     * @memberof ValidationErrorSchema
     */
    'storeId'?: string;
    /**
     * Name of the store related to this error
     * @type {string}
     * @memberof ValidationErrorSchema
     */
    'storeName'?: string;
    /**
     * ID of the item related to this error
     * @type {string}
     * @memberof ValidationErrorSchema
     */
    'itemId'?: string;
    /**
     * Name of the item related to this error
     * @type {string}
     * @memberof ValidationErrorSchema
     */
    'itemName'?: string;
    /**
     * Human-readable error message
     * @type {string}
     * @memberof ValidationErrorSchema
     */
    'message': string;
    /**
     * 
     * @type {ValidationErrorDetailsSchema}
     * @memberof ValidationErrorSchema
     */
    'details'?: ValidationErrorDetailsSchema;
}

export const ValidationErrorSchemaTypeEnum = {
    StockUnavailable: 'STOCK_UNAVAILABLE',
    StoreCapability: 'STORE_CAPABILITY',
    WorkingHours: 'WORKING_HOURS',
    DeliveryRadius: 'DELIVERY_RADIUS',
    InvalidPreorderTime: 'INVALID_PREORDER_TIME',
    MinOrderAmount: 'MIN_ORDER_AMOUNT',
    PrescriptionRequired: 'PRESCRIPTION_REQUIRED',
    PreOrderDatetimeRequired: 'PRE_ORDER_DATETIME_REQUIRED',
    PreOrderDatetimeInvalid: 'PRE_ORDER_DATETIME_INVALID',
    PreOrderMinimumAdvance: 'PRE_ORDER_MINIMUM_ADVANCE',
    PreOrderMaximumAdvance: 'PRE_ORDER_MAXIMUM_ADVANCE',
    PreOrderDeliveryMode: 'PRE_ORDER_DELIVERY_MODE'
} as const;

export type ValidationErrorSchemaTypeEnum = typeof ValidationErrorSchemaTypeEnum[keyof typeof ValidationErrorSchemaTypeEnum];

/**
 * 
 * @export
 * @interface ValidationResultsSchema
 */
export interface ValidationResultsSchema {
    /**
     * Whether all stores meet delivery mode requirements
     * @type {boolean}
     * @memberof ValidationResultsSchema
     */
    'allStoresValid': boolean;
    /**
     * Whether all items are available in requested quantities
     * @type {boolean}
     * @memberof ValidationResultsSchema
     */
    'allItemsInStock': boolean;
    /**
     * Whether order can proceed to checkout
     * @type {boolean}
     * @memberof ValidationResultsSchema
     */
    'canProceedToCheckout'?: boolean;
    /**
     * List of validation errors (empty if all valid)
     * @type {Array<ValidationErrorSchema>}
     * @memberof ValidationResultsSchema
     */
    'validationErrors': Array<ValidationErrorSchema>;
}
/**
 * 
 * @export
 * @interface VefiryOtpResponse
 */
export interface VefiryOtpResponse {
    /**
     * Indicates if the OTP verification was successful
     * @type {boolean}
     * @memberof VefiryOtpResponse
     */
    'isVerified': boolean;
}
/**
 * Request to verify featured store payment
 * @export
 * @interface VerifyFeaturedPaymentRequest
 */
export interface VerifyFeaturedPaymentRequest {
    /**
     * Payment gateway checkout ID
     * @type {string}
     * @memberof VerifyFeaturedPaymentRequest
     */
    'checkoutId': string;
    /**
     * Merchant ID for verification
     * @type {string}
     * @memberof VerifyFeaturedPaymentRequest
     */
    'merchantId': string;
}
/**
 * Response after verifying featured store payment
 * @export
 * @interface VerifyFeaturedPaymentResponse
 */
export interface VerifyFeaturedPaymentResponse {
    /**
     * Whether payment was successful
     * @type {boolean}
     * @memberof VerifyFeaturedPaymentResponse
     */
    'success': boolean;
    /**
     * User-friendly message
     * @type {string}
     * @memberof VerifyFeaturedPaymentResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface VerifyOtpByEmail
 */
export interface VerifyOtpByEmail {
    /**
     * 
     * @type {string}
     * @memberof VerifyOtpByEmail
     */
    'channel': VerifyOtpByEmailChannelEnum;
    /**
     * Email address of the user
     * @type {string}
     * @memberof VerifyOtpByEmail
     */
    'email': string;
    /**
     * The OTP entered by the user (Must be exactly 6 numeric digits)
     * @type {string}
     * @memberof VerifyOtpByEmail
     */
    'otp': string;
}

export const VerifyOtpByEmailChannelEnum = {
    Email: 'email'
} as const;

export type VerifyOtpByEmailChannelEnum = typeof VerifyOtpByEmailChannelEnum[keyof typeof VerifyOtpByEmailChannelEnum];

/**
 * 
 * @export
 * @interface VerifyOtpByPhone
 */
export interface VerifyOtpByPhone {
    /**
     * 
     * @type {string}
     * @memberof VerifyOtpByPhone
     */
    'channel': VerifyOtpByPhoneChannelEnum;
    /**
     * Phone number of the user (Must be a valid international number)
     * @type {string}
     * @memberof VerifyOtpByPhone
     */
    'phoneNumber': string;
    /**
     * The OTP entered by the user (Must be exactly 6 numeric digits)
     * @type {string}
     * @memberof VerifyOtpByPhone
     */
    'otp': string;
}

export const VerifyOtpByPhoneChannelEnum = {
    Phone: 'phone'
} as const;

export type VerifyOtpByPhoneChannelEnum = typeof VerifyOtpByPhoneChannelEnum[keyof typeof VerifyOtpByPhoneChannelEnum];

/**
 * Verify OTP using email or phone
 * @export
 * @interface VerifyOtpRequest
 */
export interface VerifyOtpRequest {
    /**
     * Contact method type for OTP verification
     * @type {string}
     * @memberof VerifyOtpRequest
     */
    'channel': VerifyOtpRequestChannelEnum;
    /**
     * Email address of the user (required when channel is email)
     * @type {string}
     * @memberof VerifyOtpRequest
     */
    'email'?: string;
    /**
     * Phone number of the user (required when channel is phone, must be a valid international number)
     * @type {string}
     * @memberof VerifyOtpRequest
     */
    'phoneNumber'?: string;
    /**
     * The OTP entered by the user (must be exactly 6 numeric digits)
     * @type {string}
     * @memberof VerifyOtpRequest
     */
    'otp': string;
}

export const VerifyOtpRequestChannelEnum = {
    Email: 'email',
    Phone: 'phone'
} as const;

export type VerifyOtpRequestChannelEnum = typeof VerifyOtpRequestChannelEnum[keyof typeof VerifyOtpRequestChannelEnum];

/**
 * 
 * @export
 * @interface VerifyPaymentRequest
 */
export interface VerifyPaymentRequest {
    /**
     * Gateway checkout session ID returned from checkout
     * @type {string}
     * @memberof VerifyPaymentRequest
     */
    'checkoutId': string;
}
/**
 * 
 * @export
 * @interface VerifyPaymentResponse
 */
export interface VerifyPaymentResponse {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyPaymentResponse
     */
    'success': boolean;
    /**
     * Created order ID (only if payment successful)
     * @type {string}
     * @memberof VerifyPaymentResponse
     */
    'orderId'?: string;
    /**
     * Human-readable order number (only if payment successful)
     * @type {string}
     * @memberof VerifyPaymentResponse
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPaymentResponse
     */
    'message': string;
    /**
     * 
     * @type {VerifyPaymentResponsePaymentDetails}
     * @memberof VerifyPaymentResponse
     */
    'paymentDetails'?: VerifyPaymentResponsePaymentDetails;
}
/**
 * 
 * @export
 * @interface VerifyPaymentResponsePaymentDetails
 */
export interface VerifyPaymentResponsePaymentDetails {
    /**
     * 
     * @type {number}
     * @memberof VerifyPaymentResponsePaymentDetails
     */
    'totalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof VerifyPaymentResponsePaymentDetails
     */
    'walletAmountUsed'?: number;
    /**
     * 
     * @type {number}
     * @memberof VerifyPaymentResponsePaymentDetails
     */
    'gatewayAmountPaid'?: number;
    /**
     * 
     * @type {string}
     * @memberof VerifyPaymentResponsePaymentDetails
     */
    'paymentMethod'?: string;
}
/**
 * 
 * @export
 * @interface VerifyReferralCodeRequest
 */
export interface VerifyReferralCodeRequest {
    /**
     * The referral code to verify
     * @type {string}
     * @memberof VerifyReferralCodeRequest
     */
    'referralCode': string;
}
/**
 * 
 * @export
 * @interface VerifyReferralCodeResponse
 */
export interface VerifyReferralCodeResponse {
    /**
     * Indicates if the referral code is valid and available for use
     * @type {boolean}
     * @memberof VerifyReferralCodeResponse
     */
    'isValid': boolean;
    /**
     * Description of the verification result
     * @type {string}
     * @memberof VerifyReferralCodeResponse
     */
    'message': string;
    /**
     * 
     * @type {VerifyReferralCodeResponseReferrerDetails}
     * @memberof VerifyReferralCodeResponse
     */
    'referrerDetails'?: VerifyReferralCodeResponseReferrerDetails;
}
/**
 * Details about the user who generated the referral code (only included if code is valid)
 * @export
 * @interface VerifyReferralCodeResponseReferrerDetails
 */
export interface VerifyReferralCodeResponseReferrerDetails {
    /**
     * ID of the user who generated this referral code
     * @type {string}
     * @memberof VerifyReferralCodeResponseReferrerDetails
     */
    'referrerUserId'?: string;
    /**
     * Name of the user who generated this referral code
     * @type {string}
     * @memberof VerifyReferralCodeResponseReferrerDetails
     */
    'referrerName'?: string;
}
/**
 * 
 * @export
 * @interface VerifySettlementPaymentRequest
 */
export interface VerifySettlementPaymentRequest {
    /**
     * ID of the user who made the payment
     * @type {string}
     * @memberof VerifySettlementPaymentRequest
     */
    'userId': string;
    /**
     * Gateway checkout session ID
     * @type {string}
     * @memberof VerifySettlementPaymentRequest
     */
    'checkoutId': string;
}
/**
 * 
 * @export
 * @interface VerifySettlementPaymentResponse
 */
export interface VerifySettlementPaymentResponse {
    /**
     * Whether payment was successful
     * @type {boolean}
     * @memberof VerifySettlementPaymentResponse
     */
    'success'?: boolean;
    /**
     * Array of settlement IDs in this payment
     * @type {Array<string>}
     * @memberof VerifySettlementPaymentResponse
     */
    'settlementIds'?: Array<string>;
    /**
     * Total amount paid/attempted
     * @type {number}
     * @memberof VerifySettlementPaymentResponse
     */
    'totalAmount'?: number;
    /**
     * Human-readable result message
     * @type {string}
     * @memberof VerifySettlementPaymentResponse
     */
    'message'?: string;
    /**
     * Gateway transaction ID (if successful)
     * @type {string}
     * @memberof VerifySettlementPaymentResponse
     */
    'transactionId'?: string;
}
/**
 * Request to verify wallet payment after gateway redirect
 * @export
 * @interface VerifyWalletPaymentRequest
 */
export interface VerifyWalletPaymentRequest {
    /**
     * ID of the user
     * @type {string}
     * @memberof VerifyWalletPaymentRequest
     */
    'userId': string;
    /**
     * Gateway checkout/session ID (primary reference)
     * @type {string}
     * @memberof VerifyWalletPaymentRequest
     */
    'checkoutId': string;
}
/**
 * Response after verifying wallet payment
 * @export
 * @interface VerifyWalletPaymentResponse
 */
export interface VerifyWalletPaymentResponse {
    /**
     * Whether payment was successful
     * @type {boolean}
     * @memberof VerifyWalletPaymentResponse
     */
    'success': boolean;
    /**
     * Status message
     * @type {string}
     * @memberof VerifyWalletPaymentResponse
     */
    'message': string;
    /**
     * Updated wallet balance after credit
     * @type {number}
     * @memberof VerifyWalletPaymentResponse
     */
    'newBalance'?: number;
    /**
     * Amount credited to wallet
     * @type {number}
     * @memberof VerifyWalletPaymentResponse
     */
    'amount'?: number;
    /**
     * Wallet transaction ID
     * @type {string}
     * @memberof VerifyWalletPaymentResponse
     */
    'transactionId'?: string;
}
/**
 * 
 * @export
 * @interface ViewAndEditOnlyPermission
 */
export interface ViewAndEditOnlyPermission {
    /**
     * 
     * @type {boolean}
     * @memberof ViewAndEditOnlyPermission
     */
    'view'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ViewAndEditOnlyPermission
     */
    'edit'?: boolean;
}
/**
 * 
 * @export
 * @interface ViewOnlyPermission
 */
export interface ViewOnlyPermission {
    /**
     * 
     * @type {boolean}
     * @memberof ViewOnlyPermission
     */
    'view': boolean;
}
/**
 * Response for wallet balance check before checkout
 * @export
 * @interface WalletCheckoutBalanceResponse
 */
export interface WalletCheckoutBalanceResponse {
    /**
     * Current wallet balance
     * @type {number}
     * @memberof WalletCheckoutBalanceResponse
     */
    'walletBalance': number;
    /**
     * Total checkout amount
     * @type {number}
     * @memberof WalletCheckoutBalanceResponse
     */
    'totalAmount': number;
    /**
     * Whether the wallet has sufficient balance for full payment
     * @type {boolean}
     * @memberof WalletCheckoutBalanceResponse
     */
    'canPayWithWallet': boolean;
    /**
     * Whether wallet can cover part of the payment
     * @type {boolean}
     * @memberof WalletCheckoutBalanceResponse
     */
    'canPayPartialWithWallet'?: boolean;
    /**
     * Remaining amount needed if wallet balance is insufficient
     * @type {number}
     * @memberof WalletCheckoutBalanceResponse
     */
    'remainingAmountNeeded'?: number;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof WalletCheckoutBalanceResponse
     */
    'currencyCode': CurrencyCode;
    /**
     * Suggested payment combinations
     * @type {Array<SuggestedPaymentOption>}
     * @memberof WalletCheckoutBalanceResponse
     */
    'suggestedPaymentOptions'?: Array<SuggestedPaymentOption>;
}


/**
 * Permission settings for customer wallet management module
 * @export
 * @interface WalletPermission
 */
export interface WalletPermission {
    /**
     * Can view customer wallet list and transaction history
     * @type {boolean}
     * @memberof WalletPermission
     */
    'view'?: boolean;
    /**
     * Can add money to customer wallet
     * @type {boolean}
     * @memberof WalletPermission
     */
    'credit'?: boolean;
    /**
     * Can deduct money from customer wallet
     * @type {boolean}
     * @memberof WalletPermission
     */
    'debit'?: boolean;
}
/**
 * 
 * @export
 * @interface WalletSettlementPaymentResponse
 */
export interface WalletSettlementPaymentResponse {
    /**
     * Payment mode discriminator
     * @type {string}
     * @memberof WalletSettlementPaymentResponse
     */
    'paymentMode': WalletSettlementPaymentResponsePaymentModeEnum;
    /**
     * Whether payment was successful
     * @type {boolean}
     * @memberof WalletSettlementPaymentResponse
     */
    'success'?: boolean;
    /**
     * Success message
     * @type {string}
     * @memberof WalletSettlementPaymentResponse
     */
    'message'?: string;
    /**
     * ID of the settlement payment record
     * @type {string}
     * @memberof WalletSettlementPaymentResponse
     */
    'settlementPaymentId'?: string;
    /**
     * Array of settlement IDs in this payment
     * @type {Array<string>}
     * @memberof WalletSettlementPaymentResponse
     */
    'settlementIds'?: Array<string>;
    /**
     * Total amount paid
     * @type {number}
     * @memberof WalletSettlementPaymentResponse
     */
    'totalAmount'?: number;
    /**
     * Remaining wallet balance after payment
     * @type {number}
     * @memberof WalletSettlementPaymentResponse
     */
    'walletBalance'?: number;
}

export const WalletSettlementPaymentResponsePaymentModeEnum = {
    Wallet: 'WALLET'
} as const;

export type WalletSettlementPaymentResponsePaymentModeEnum = typeof WalletSettlementPaymentResponsePaymentModeEnum[keyof typeof WalletSettlementPaymentResponsePaymentModeEnum];

/**
 * Represents a transaction in the user\'s wallet
 * @export
 * @interface WalletTransaction
 */
export interface WalletTransaction {
    /**
     * The unique identifier for the transaction
     * @type {string}
     * @memberof WalletTransaction
     */
    'transactionId': string;
    /**
     * A description of the transaction
     * @type {string}
     * @memberof WalletTransaction
     */
    'description': string;
    /**
     * The amount involved in the transaction
     * @type {number}
     * @memberof WalletTransaction
     */
    'amount': number;
    /**
     * The type of transaction (credit or debit)
     * @type {string}
     * @memberof WalletTransaction
     */
    'transactionType': WalletTransactionTransactionTypeEnum;
    /**
     * The date and time when the transaction occurred
     * @type {string}
     * @memberof WalletTransaction
     */
    'timestamp': string;
}

export const WalletTransactionTransactionTypeEnum = {
    Credit: 'credit',
    Debit: 'debit'
} as const;

export type WalletTransactionTransactionTypeEnum = typeof WalletTransactionTransactionTypeEnum[keyof typeof WalletTransactionTransactionTypeEnum];

/**
 * 
 * @export
 * @interface WorkingDaySchema
 */
export interface WorkingDaySchema {
    /**
     * Whether the restaurant is open on this day
     * @type {boolean}
     * @memberof WorkingDaySchema
     */
    'isOpen'?: boolean;
    /**
     * Start time for the working hours
     * @type {string}
     * @memberof WorkingDaySchema
     */
    'startTime'?: string;
    /**
     * End time for the working hours
     * @type {string}
     * @memberof WorkingDaySchema
     */
    'endTime'?: string;
}
/**
 * 
 * @export
 * @interface WorkingHourEntrySchema
 */
export interface WorkingHourEntrySchema {
    /**
     * Status of availability for the day
     * @type {string}
     * @memberof WorkingHourEntrySchema
     */
    'available_status'?: WorkingHourEntrySchemaAvailableStatusEnum;
    /**
     * Day of the week
     * @type {string}
     * @memberof WorkingHourEntrySchema
     */
    'working_date'?: WorkingHourEntrySchemaWorkingDateEnum;
    /**
     * Start time for working hours (12-hour format with am/pm)
     * @type {string}
     * @memberof WorkingHourEntrySchema
     */
    'working_from_time'?: string;
    /**
     * End time for working hours (12-hour format with am/pm)
     * @type {string}
     * @memberof WorkingHourEntrySchema
     */
    'working_end_time'?: string;
}

export const WorkingHourEntrySchemaAvailableStatusEnum = {
    Available: 'Available',
    Unavailable: 'Unavailable'
} as const;

export type WorkingHourEntrySchemaAvailableStatusEnum = typeof WorkingHourEntrySchemaAvailableStatusEnum[keyof typeof WorkingHourEntrySchemaAvailableStatusEnum];
export const WorkingHourEntrySchemaWorkingDateEnum = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;

export type WorkingHourEntrySchemaWorkingDateEnum = typeof WorkingHourEntrySchemaWorkingDateEnum[keyof typeof WorkingHourEntrySchemaWorkingDateEnum];

/**
 * 
 * @export
 * @interface WorkingHoursSchema
 */
export interface WorkingHoursSchema {
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'sunday'?: WorkingDaySchema;
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'monday'?: WorkingDaySchema;
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'tuesday'?: WorkingDaySchema;
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'wednesday'?: WorkingDaySchema;
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'thursday'?: WorkingDaySchema;
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'friday'?: WorkingDaySchema;
    /**
     * 
     * @type {WorkingDaySchema}
     * @memberof WorkingHoursSchema
     */
    'saturday'?: WorkingDaySchema;
}
/**
 * 
 * @export
 * @interface WritableDeliveryLocationSchema
 */
export interface WritableDeliveryLocationSchema {
    /**
     * A label for the delivery location.
     * @type {string}
     * @memberof WritableDeliveryLocationSchema
     */
    'label'?: string;
    /**
     * The delivery address.
     * @type {string}
     * @memberof WritableDeliveryLocationSchema
     */
    'address': string;
    /**
     * The latitude of the delivery location.
     * @type {string}
     * @memberof WritableDeliveryLocationSchema
     */
    'latitude': string;
    /**
     * The longitude of the delivery location.
     * @type {string}
     * @memberof WritableDeliveryLocationSchema
     */
    'longitude': string;
    /**
     * Whether this is the default delivery location.
     * @type {boolean}
     * @memberof WritableDeliveryLocationSchema
     */
    'isDefault'?: boolean;
}
/**
 * 
 * @export
 * @interface WritableRestaurantDataSchema
 */
export interface WritableRestaurantDataSchema {
    /**
     * The merchant ID (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'merchantId'?: string;
    /**
     * The category ID of the restaurant (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'categoryId'?: string;
    /**
     * The name of the restaurant (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantName'?: string;
    /**
     * The Arabic name of the restaurant (optional)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantNameArabic'?: string;
    /**
     * 
     * @type {MinOrderAmountSchema}
     * @memberof WritableRestaurantDataSchema
     */
    'minOrderAmount'?: MinOrderAmountSchema;
    /**
     * Whether the restaurant allows pre-ordering (mandatory)
     * @type {boolean}
     * @memberof WritableRestaurantDataSchema
     */
    'canPreOrder'?: boolean;
    /**
     * Whether the restaurant offers halal food (mandatory)
     * @type {boolean}
     * @memberof WritableRestaurantDataSchema
     */
    'isHalal'?: boolean;
    /**
     * Type of restaurant (mandatory)
     * @type {Array<string>}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantType'?: Array<WritableRestaurantDataSchemaRestaurantTypeEnum>;
    /**
     * Type of store (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'storeType'?: WritableRestaurantDataSchemaStoreTypeEnum;
    /**
     * Preferred time for meals (optional)
     * @type {Array<string>}
     * @memberof WritableRestaurantDataSchema
     */
    'preferableTime'?: Array<WritableRestaurantDataSchemaPreferableTimeEnum>;
    /**
     * Whether the restaurant offers self-pickup (optional, default is false)
     * @type {boolean}
     * @memberof WritableRestaurantDataSchema
     */
    'hasSelfPickup'?: boolean;
    /**
     * Whether delivery is available (optional, default is true)
     * @type {boolean}
     * @memberof WritableRestaurantDataSchema
     */
    'deliveryAvailable'?: boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaDeliveryFee}
     * @memberof WritableRestaurantDataSchema
     */
    'deliveryFee'?: WritableRestaurantDataSchemaDeliveryFee;
    /**
     * 
     * @type {TimeDataSchema}
     * @memberof WritableRestaurantDataSchema
     */
    'deliveryTime'?: TimeDataSchema;
    /**
     * Whether the restaurant accepts additional culinary requests (mandatory)
     * @type {boolean}
     * @memberof WritableRestaurantDataSchema
     */
    'additionalCulinaryRequest'?: boolean;
    /**
     * Description of the restaurant in English (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'aboutRestaurant'?: string;
    /**
     * Description of the restaurant in Arabic (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'aboutRestaurantArabic'?: string;
    /**
     * Delivery radius in kilometers (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'deliveryRadiusKM'?: string;
    /**
     * Restaurant phone number (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantPhoneNumber'?: string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantAddress'?: RestaurantAddressSchema;
    /**
     * URL of the restaurant logo (mandatory)
     * @type {string}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantLogo'?: string;
    /**
     * URLs of the restaurant banners (mandatory)
     * @type {Array<string>}
     * @memberof WritableRestaurantDataSchema
     */
    'restaurantBanner'?: Array<string>;
    /**
     * 
     * @type {WritableRestaurantDataSchemaItemAvailableTime}
     * @memberof WritableRestaurantDataSchema
     */
    'itemAvailableTime'?: WritableRestaurantDataSchemaItemAvailableTime;
    /**
     * 
     * @type {WorkingHoursSchema}
     * @memberof WritableRestaurantDataSchema
     */
    'workingHours'?: WorkingHoursSchema;
}

export const WritableRestaurantDataSchemaRestaurantTypeEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type WritableRestaurantDataSchemaRestaurantTypeEnum = typeof WritableRestaurantDataSchemaRestaurantTypeEnum[keyof typeof WritableRestaurantDataSchemaRestaurantTypeEnum];
export const WritableRestaurantDataSchemaStoreTypeEnum = {
    Restaurant: 'restaurant',
    Grocery: 'grocery'
} as const;

export type WritableRestaurantDataSchemaStoreTypeEnum = typeof WritableRestaurantDataSchemaStoreTypeEnum[keyof typeof WritableRestaurantDataSchemaStoreTypeEnum];
export const WritableRestaurantDataSchemaPreferableTimeEnum = {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner'
} as const;

export type WritableRestaurantDataSchemaPreferableTimeEnum = typeof WritableRestaurantDataSchemaPreferableTimeEnum[keyof typeof WritableRestaurantDataSchemaPreferableTimeEnum];

/**
 * 
 * @export
 * @interface WritableRestaurantDataSchemaDeliveryFee
 */
export interface WritableRestaurantDataSchemaDeliveryFee {
    /**
     * 
     * @type {DeliveryChargeSettingSchema}
     * @memberof WritableRestaurantDataSchemaDeliveryFee
     */
    'deliveryChargeSetting'?: DeliveryChargeSettingSchema;
}
/**
 * 
 * @export
 * @interface WritableRestaurantDataSchemaItemAvailableTime
 */
export interface WritableRestaurantDataSchemaItemAvailableTime {
    /**
     * 
     * @type {TimePeriodSchema}
     * @memberof WritableRestaurantDataSchemaItemAvailableTime
     */
    'breakfast'?: TimePeriodSchema;
    /**
     * 
     * @type {TimePeriodSchema}
     * @memberof WritableRestaurantDataSchemaItemAvailableTime
     */
    'lunch'?: TimePeriodSchema;
    /**
     * 
     * @type {TimePeriodSchema}
     * @memberof WritableRestaurantDataSchemaItemAvailableTime
     */
    'dinner'?: TimePeriodSchema;
    /**
     * 
     * @type {TimePeriodSchema}
     * @memberof WritableRestaurantDataSchemaItemAvailableTime
     */
    'brunch'?: TimePeriodSchema;
}
/**
 * 
 * @export
 * @interface WritableStoreDataSchema
 */
export interface WritableStoreDataSchema {
    /**
     * The ID of the store
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'id'?: string;
    /**
     * The merchant ID (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'merchantId': string;
    /**
     * Type of store (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'storeType': WritableStoreDataSchemaStoreTypeEnum;
    /**
     * The category IDs of the store
     * @type {Array<string>}
     * @memberof WritableStoreDataSchema
     */
    'categoryId'?: Array<string>;
    /**
     * The name of the store (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'storeName': string;
    /**
     * The Arabic name of the store
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'storeNameArabic'?: string;
    /**
     * 
     * @type {MinOrderAmountSchema}
     * @memberof WritableStoreDataSchema
     */
    'minOrderAmount': MinOrderAmountSchema;
    /**
     * Whether the store allows pre-ordering (mandatory)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'canPreOrder': boolean;
    /**
     * Whether the store offers self-pickup (optional, default is false)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'hasSelfPickup': boolean;
    /**
     * Whether delivery is available (optional, default is true)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'deliveryAvailable': boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaDeliveryFee}
     * @memberof WritableStoreDataSchema
     */
    'deliveryFee'?: WritableRestaurantDataSchemaDeliveryFee;
    /**
     * 
     * @type {TimeDataSchema}
     * @memberof WritableStoreDataSchema
     */
    'deliveryTime'?: TimeDataSchema;
    /**
     * Description of the store in English (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'aboutStore': string;
    /**
     * Description of the store in Arabic (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'aboutStoreArabic'?: string;
    /**
     * Delivery radius in kilometers (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'deliveryRadiusKM': string;
    /**
     * Store phone number (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'storePhoneNumber': string;
    /**
     * 
     * @type {RestaurantAddressSchema}
     * @memberof WritableStoreDataSchema
     */
    'storeAddress': RestaurantAddressSchema;
    /**
     * URL of the store logo (mandatory)
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'storeLogo': string;
    /**
     * URLs of the store banners (mandatory)
     * @type {Array<string>}
     * @memberof WritableStoreDataSchema
     */
    'storeBanner': Array<string>;
    /**
     * 
     * @type {WorkingHoursSchema}
     * @memberof WritableStoreDataSchema
     */
    'workingHours': WorkingHoursSchema;
    /**
     * Whether cancellation is allowed (optional, default is true)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'isCancellationAllowed'?: boolean;
    /**
     * Cancellation policy of the store (optional, default is \"No cancellation\")
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'cancellationPolicy'?: string;
    /**
     * Cancellation fee (optional, default is \"0\")
     * @type {string}
     * @memberof WritableStoreDataSchema
     */
    'cancellationFee'?: string;
    /**
     * Whether the restaurant offers halal food (mandatory)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'isHalal'?: boolean;
    /**
     * Type of restaurant (mandatory)
     * @type {Array<string>}
     * @memberof WritableStoreDataSchema
     */
    'restaurantType'?: Array<WritableStoreDataSchemaRestaurantTypeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WritableStoreDataSchema
     */
    'preferableTime'?: Array<WritableStoreDataSchemaPreferableTimeEnum>;
    /**
     * Whether the restaurant accepts additional culinary requests (mandatory)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'additionalCulinaryRequest'?: boolean;
    /**
     * 
     * @type {WritableRestaurantDataSchemaItemAvailableTime}
     * @memberof WritableStoreDataSchema
     */
    'itemAvailableTime'?: WritableRestaurantDataSchemaItemAvailableTime;
    /**
     * Whether the pharmacy accepts additional packaging requests (mandatory)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'additionalPackagingRequest'?: boolean;
    /**
     * Whether a prescription is needed for the pharmacy (mandatory)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'prescriptionNeeded'?: boolean;
    /**
     * Whether the store is wishlisted (optional, default is false)
     * @type {boolean}
     * @memberof WritableStoreDataSchema
     */
    'isWishListed'?: boolean;
    /**
     * Rating of the store (optional, default is 0)
     * @type {number}
     * @memberof WritableStoreDataSchema
     */
    'rating'?: number;
    /**
     * 
     * @type {StoreReviewDataSchema}
     * @memberof WritableStoreDataSchema
     */
    'reviewData'?: StoreReviewDataSchema;
}

export const WritableStoreDataSchemaStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;

export type WritableStoreDataSchemaStoreTypeEnum = typeof WritableStoreDataSchemaStoreTypeEnum[keyof typeof WritableStoreDataSchemaStoreTypeEnum];
export const WritableStoreDataSchemaRestaurantTypeEnum = {
    Veg: 'veg',
    NonVeg: 'non-veg'
} as const;

export type WritableStoreDataSchemaRestaurantTypeEnum = typeof WritableStoreDataSchemaRestaurantTypeEnum[keyof typeof WritableStoreDataSchemaRestaurantTypeEnum];
export const WritableStoreDataSchemaPreferableTimeEnum = {
    Breakfast: 'breakfast',
    Lunch: 'lunch',
    Dinner: 'dinner'
} as const;

export type WritableStoreDataSchemaPreferableTimeEnum = typeof WritableStoreDataSchemaPreferableTimeEnum[keyof typeof WritableStoreDataSchemaPreferableTimeEnum];


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Set banner image for the end user
         * @summary Set banner image for the end user
         * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBannerImageSettings: async (dynamicHomePageContentSettings: DynamicHomePageContentSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dynamicHomePageContentSettings' is not null or undefined
            assertParamExists('addBannerImageSettings', 'dynamicHomePageContentSettings', dynamicHomePageContentSettings)
            const localVarPath = `/core/settings/configuration/addBanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicHomePageContentSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new choice to the system
         * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChoice: async (addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditChoiceRequestSchema' is not null or undefined
            assertParamExists('addChoice', 'addOrEditChoiceRequestSchema', addOrEditChoiceRequestSchema)
            const localVarPath = `/core/choice/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditChoiceRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new choice to the system
         * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChoiceGroup: async (addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrUpdateChoiceGroupRequestSchema' is not null or undefined
            assertParamExists('addChoiceGroup', 'addOrUpdateChoiceGroupRequestSchema', addOrUpdateChoiceGroupRequestSchema)
            const localVarPath = `/core/choicegroup/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdateChoiceGroupRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new CMS page to the system
         * @summary Add a new CMS page
         * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCmsPage: async (addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditCmsPageRequestSchema' is not null or undefined
            assertParamExists('addCmsPage', 'addOrEditCmsPageRequestSchema', addOrEditCmsPageRequestSchema)
            const localVarPath = `/core/cms/addCmsPage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditCmsPageRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set configuration settings for the end user
         * @summary Set configuration settings for the end user
         * @param {ConfigurationSettings} configurationSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfigurationSettings: async (configurationSettings: ConfigurationSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configurationSettings' is not null or undefined
            assertParamExists('addConfigurationSettings', 'configurationSettings', configurationSettings)
            const localVarPath = `/core/settings/configuration/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configurationSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new coupon to the system
         * @summary Add a new coupon
         * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoupon: async (addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditCouponRequestSchema' is not null or undefined
            assertParamExists('addCoupon', 'addOrEditCouponRequestSchema', addOrEditCouponRequestSchema)
            const localVarPath = `/core/coupon/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditCouponRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new delivery boy
         * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryBoy: async (addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditDeliveryBoyRequestSchema' is not null or undefined
            assertParamExists('addDeliveryBoy', 'addOrEditDeliveryBoyRequestSchema', addOrEditDeliveryBoyRequestSchema)
            const localVarPath = `/core/deliveryBoy/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditDeliveryBoyRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new delivery manager to the system
         * @summary Add a new delivery manager
         * @param {AddDeliveryManagerRequestSchema} addDeliveryManagerRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryManager: async (addDeliveryManagerRequestSchema: AddDeliveryManagerRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addDeliveryManagerRequestSchema' is not null or undefined
            assertParamExists('addDeliveryManager', 'addDeliveryManagerRequestSchema', addDeliveryManagerRequestSchema)
            const localVarPath = `/core/deliveryManager/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addDeliveryManagerRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new faq to the system
         * @summary Add a new Faq
         * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFaq: async (addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditFaqRequestSchema' is not null or undefined
            assertParamExists('addFaq', 'addOrEditFaqRequestSchema', addOrEditFaqRequestSchema)
            const localVarPath = `/core/faq/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditFaqRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new item
         * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItem: async (addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditItemRequestSchema' is not null or undefined
            assertParamExists('addItem', 'addOrEditItemRequestSchema', addOrEditItemRequestSchema)
            const localVarPath = `/core/item/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditItemRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new item category
         * @param {CreateItemCategoryRequest} createItemCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemCategory: async (createItemCategoryRequest: CreateItemCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createItemCategoryRequest' is not null or undefined
            assertParamExists('addItemCategory', 'createItemCategoryRequest', createItemCategoryRequest)
            const localVarPath = `/core/itemCategory/addItemCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createItemCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new item subcategory
         * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemSubCategory: async (createItemSubCategoryRequest: CreateItemSubCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createItemSubCategoryRequest' is not null or undefined
            assertParamExists('addItemSubCategory', 'createItemSubCategoryRequest', createItemSubCategoryRequest)
            const localVarPath = `/core/itemSubCategory/addItemSubCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createItemSubCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new meal for a store with items and choice groups
         * @summary Add a new meal
         * @param {AddMealRequest} addMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMeal: async (addMealRequest: AddMealRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addMealRequest' is not null or undefined
            assertParamExists('addMeal', 'addMealRequest', addMealRequest)
            const localVarPath = `/core/meal/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMealRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin creates a new offer coupon
         * @summary Create a new offer
         * @param {AddOfferRequestSchema} addOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOffer: async (addOfferRequestSchema: AddOfferRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOfferRequestSchema' is not null or undefined
            assertParamExists('addOffer', 'addOfferRequestSchema', addOfferRequestSchema)
            const localVarPath = `/core/admin/offers/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOfferRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new subscription plan if `id` is not provided. If `id` is present, updates the existing subscription plan.
         * @summary Add or edit a subscription plan
         * @param {SubscriptionPlan} subscriptionPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrEditSubscriptionPlan: async (subscriptionPlan: SubscriptionPlan, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionPlan' is not null or undefined
            assertParamExists('addOrEditSubscriptionPlan', 'subscriptionPlan', subscriptionPlan)
            const localVarPath = `/core/subscriptionPlan/addOrEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPlan, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a specified item to the user\'s cart
         * @summary Add an item to the Cart
         * @param {string} userId User identifier
         * @param {AddOrUpdateCartRequestSchema} addOrUpdateCartRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateCart: async (userId: string, addOrUpdateCartRequestSchema: AddOrUpdateCartRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addOrUpdateCart', 'userId', userId)
            // verify required parameter 'addOrUpdateCartRequestSchema' is not null or undefined
            assertParamExists('addOrUpdateCart', 'addOrUpdateCartRequestSchema', addOrUpdateCartRequestSchema)
            const localVarPath = `/core/user-app/cart/addOrUpdateCart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdateCartRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers or updates the FCM token for a user, allowing them to receive push notifications.
         * @summary Add or update device ID for push notifications
         * @param {AddOrUpdateDeviceIdRequest} addOrUpdateDeviceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateDeviceId: async (addOrUpdateDeviceIdRequest: AddOrUpdateDeviceIdRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrUpdateDeviceIdRequest' is not null or undefined
            assertParamExists('addOrUpdateDeviceId', 'addOrUpdateDeviceIdRequest', addOrUpdateDeviceIdRequest)
            const localVarPath = `/notifications/addOrUpdateDeviceId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdateDeviceIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a specified item to the user\'s wishList
         * @summary Add or update an item to the wishList
         * @param {AddOrUpdateWishListRequestSchema} addOrUpdateWishListRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateUserWishList: async (addOrUpdateWishListRequestSchema: AddOrUpdateWishListRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrUpdateWishListRequestSchema' is not null or undefined
            assertParamExists('addOrUpdateUserWishList', 'addOrUpdateWishListRequestSchema', addOrUpdateWishListRequestSchema)
            const localVarPath = `/core/user-app/wishlist/addOrUpdateUserWishList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdateWishListRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows a customer to submit a detailed review for a completed order, including: - App experience - Store rating - Delivery partner rating - Individual item ratings - Issues faced - Optional comments 
         * @summary Submit a review for an order
         * @param {AddReviewRequest} addReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderReview: async (addReviewRequest: AddReviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addReviewRequest' is not null or undefined
            assertParamExists('addOrderReview', 'addReviewRequest', addReviewRequest)
            const localVarPath = `/core/user-app/reviews/addOrderReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addReviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a new store to the system
         * @param {WritableStoreDataSchema} writableStoreDataSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStore: async (writableStoreDataSchema: WritableStoreDataSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'writableStoreDataSchema' is not null or undefined
            assertParamExists('addStore', 'writableStoreDataSchema', writableStoreDataSchema)
            const localVarPath = `/core/store/addStore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writableStoreDataSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint adds a new address for a user.
         * @summary Add a new user address
         * @param {UserAddressSchema} userAddressSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserAddress: async (userAddressSchema: UserAddressSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAddressSchema' is not null or undefined
            assertParamExists('addUserAddress', 'userAddressSchema', userAddressSchema)
            const localVarPath = `/core/addUserAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAddressSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds a new notification for a user and updates the notification count.
         * @summary Add a user notification and update count
         * @param {AddUserNotificationRequest} addUserNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserNotificationAndUpdateCount: async (addUserNotificationRequest: AddUserNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addUserNotificationRequest' is not null or undefined
            assertParamExists('addUserNotificationAndUpdateCount', 'addUserNotificationRequest', addUserNotificationRequest)
            const localVarPath = `/notifications/addUserNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUserNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows admin to assign a driver to an order either manually (by specifying driver ID) or automatically (system finds nearest available driver). The API updates order audits, notifies the driver, and optionally notifies the customer if driver is changed. 
         * @summary Admin assign driver to order manually or automatically
         * @param {AdminAssignDriverRequestSchema} adminAssignDriverRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssignDriver: async (adminAssignDriverRequestSchema: AdminAssignDriverRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminAssignDriverRequestSchema' is not null or undefined
            assertParamExists('adminAssignDriver', 'adminAssignDriverRequestSchema', adminAssignDriverRequestSchema)
            const localVarPath = `/core/order/admin/assign-driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAssignDriverRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin assigns specific offers to a user
         * @summary Assign offers to customer
         * @param {AssignOfferRequestSchema} assignOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignOffer: async (assignOfferRequestSchema: AssignOfferRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignOfferRequestSchema' is not null or undefined
            assertParamExists('assignOffer', 'assignOfferRequestSchema', assignOfferRequestSchema)
            const localVarPath = `/core/admin/offers/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignOfferRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Block or Unblock a restaurant category
         * @summary Block or Unblock restaurant category
         * @param {string} categoryId Category ID
         * @param {BlockOrUnblockRestaurantCategoryRequest} blockOrUnblockRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockOrUnblockRestaurantCategory: async (categoryId: string, blockOrUnblockRestaurantCategoryRequest: BlockOrUnblockRestaurantCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('blockOrUnblockRestaurantCategory', 'categoryId', categoryId)
            // verify required parameter 'blockOrUnblockRestaurantCategoryRequest' is not null or undefined
            assertParamExists('blockOrUnblockRestaurantCategory', 'blockOrUnblockRestaurantCategoryRequest', blockOrUnblockRestaurantCategoryRequest)
            const localVarPath = `/core/stores/categories/blockUnblock/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockOrUnblockRestaurantCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload multiple items at once using Excel (.xlsx) or CSV (.csv) file. Files with 50 or fewer rows are processed synchronously, while larger files are processed in the background.
         * @summary Bulk upload items from Excel or CSV file
         * @param {string} storeId The ID of the store for which items are being uploaded
         * @param {BulkUploadItemAddedByEnum} addedBy Who is adding the items (Admin or Merchant)
         * @param {File} file Excel (.xlsx) or CSV (.csv) file containing items to upload
         * @param {string} [merchantId] The ID of the merchant (required for merchant users, optional for admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadItem: async (storeId: string, addedBy: BulkUploadItemAddedByEnum, file: File, merchantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('bulkUploadItem', 'storeId', storeId)
            // verify required parameter 'addedBy' is not null or undefined
            assertParamExists('bulkUploadItem', 'addedBy', addedBy)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('bulkUploadItem', 'file', file)
            const localVarPath = `/core/item/bulkUpload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (addedBy !== undefined) {
                localVarQueryParameter['addedBy'] = addedBy;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculate the total price for featuring a store based on date range and configured pricing
         * @summary Calculate featured store pricing
         * @param {CalculateFeaturedPriceRequest} calculateFeaturedPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFeaturedPrice: async (calculateFeaturedPriceRequest: CalculateFeaturedPriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateFeaturedPriceRequest' is not null or undefined
            assertParamExists('calculateFeaturedPrice', 'calculateFeaturedPriceRequest', calculateFeaturedPriceRequest)
            const localVarPath = `/core/merchant/featured-store/calculate-price`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculateFeaturedPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint allows a user to change their password.
         * @summary Change user password
         * @param {string} userId The ID of the user whose password is being changed
         * @param {ChangeUserPasswordUserTypeEnum} userType The type of user (e.g., customer, admin, subAdmin, merchant, deliveryPartner)
         * @param {ChangePasswordRequestSchema} changePasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserPassword: async (userId: string, userType: ChangeUserPasswordUserTypeEnum, changePasswordRequestSchema: ChangePasswordRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('changeUserPassword', 'userId', userId)
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('changeUserPassword', 'userType', userType)
            // verify required parameter 'changePasswordRequestSchema' is not null or undefined
            assertParamExists('changeUserPassword', 'changePasswordRequestSchema', changePasswordRequestSchema)
            const localVarPath = `/core/profile/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a user exists based on userName, email, or phone
         * @param {CheckUserExistsRequest} checkUserExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserExists: async (checkUserExistsRequest: CheckUserExistsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkUserExistsRequest' is not null or undefined
            assertParamExists('checkUserExists', 'checkUserExistsRequest', checkUserExistsRequest)
            const localVarPath = `/auth/verifyUserExists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkUserExistsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checkout order
         * @param {string} userId The ID of the user
         * @param {CheckoutRequestSchema} checkoutRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutOrder: async (userId: string, checkoutRequestSchema: CheckoutRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkoutOrder', 'userId', userId)
            // verify required parameter 'checkoutRequestSchema' is not null or undefined
            assertParamExists('checkoutOrder', 'checkoutRequestSchema', checkoutRequestSchema)
            const localVarPath = `/core/user-app/cart/checkout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkoutRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new merchant to the platform
         * @summary Create a new merchant
         * @param {MerchantSchema} merchantSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchant: async (merchantSchema: MerchantSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantSchema' is not null or undefined
            assertParamExists('createMerchant', 'merchantSchema', merchantSchema)
            const localVarPath = `/core/merchant/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new restaurant category
         * @summary Create new category
         * @param {CreateRestaurantCategoryRequest} createRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRestaurantCategory: async (createRestaurantCategoryRequest: CreateRestaurantCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createRestaurantCategoryRequest' is not null or undefined
            assertParamExists('createRestaurantCategory', 'createRestaurantCategoryRequest', createRestaurantCategoryRequest)
            const localVarPath = `/core/stores/categories/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRestaurantCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint creates a new user with the provided details.
         * @summary Create a new admin user
         * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAdminUser: async (addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addOrEditSubAdminRequest' is not null or undefined
            assertParamExists('createSubAdminUser', 'addOrEditSubAdminRequest', addOrEditSubAdminRequest)
            const localVarPath = `/core/subAdmin/addSubAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditSubAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint creates a new user with the provided details.
         * @summary Create a new user
         * @param {AddUserSchema} addUserSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (addUserSchema: AddUserSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addUserSchema' is not null or undefined
            assertParamExists('createUser', 'addUserSchema', addUserSchema)
            const localVarPath = `/core/user/addUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addUserSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple categories by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategories: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteCategories', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/itemCategory/deleteItemCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple choice groups by IDs
         * @param {DeleteChoicesRequest} deleteChoicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChoiceGroups: async (deleteChoicesRequest: DeleteChoicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteChoicesRequest' is not null or undefined
            assertParamExists('deleteChoiceGroups', 'deleteChoicesRequest', deleteChoicesRequest)
            const localVarPath = `/core/choicegroup/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteChoicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple choices by IDs
         * @param {DeleteChoicesRequest} deleteChoicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChoices: async (deleteChoicesRequest: DeleteChoicesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteChoicesRequest' is not null or undefined
            assertParamExists('deleteChoices', 'deleteChoicesRequest', deleteChoicesRequest)
            const localVarPath = `/core/choice/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteChoicesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple cms pages by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCmsPages: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteCmsPages', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/cms/deleteCmsPage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple coupons by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupons: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteCoupons', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/coupon/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple delivery boys by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryBoys: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteDeliveryBoys', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/deliveryBoy/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple delivery managers by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryManagers: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteDeliveryManagers', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/deliveryManager/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple faqs by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaqs: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteFaqs', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/faq/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete banner images
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHomePageBanner: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteHomePageBanner', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/settings/configuration/deleteBanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple items by IDs
         * @param {DeleteItemsRequest} deleteItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItems: async (deleteItemsRequest: DeleteItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteItemsRequest' is not null or undefined
            assertParamExists('deleteItems', 'deleteItemsRequest', deleteItemsRequest)
            const localVarPath = `/core/item/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete one or more meals by IDs
         * @summary Delete meals
         * @param {DeleteMealsRequest} deleteMealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeals: async (deleteMealsRequest: DeleteMealsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteMealsRequest' is not null or undefined
            assertParamExists('deleteMeals', 'deleteMealsRequest', deleteMealsRequest)
            const localVarPath = `/core/meal/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteMealsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete merchant by ID
         * @param {string} merchantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchant: async (merchantId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('deleteMerchant', 'merchantId', merchantId)
            const localVarPath = `/core/merchant/delete/{merchantId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete subscribers by IDs
         * @param {DeleteNewsletterSubscribersRequest} deleteNewsletterSubscribersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNewsletterSubscribers: async (deleteNewsletterSubscribersRequest: DeleteNewsletterSubscribersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteNewsletterSubscribersRequest' is not null or undefined
            assertParamExists('deleteNewsletterSubscribers', 'deleteNewsletterSubscribersRequest', deleteNewsletterSubscribersRequest)
            const localVarPath = `/core/newsletter/subscribers/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteNewsletterSubscribersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin deletes one or more offers
         * @summary Delete offers
         * @param {DeleteOffersRequestSchema} deleteOffersRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffers: async (deleteOffersRequestSchema: DeleteOffersRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteOffersRequestSchema' is not null or undefined
            assertParamExists('deleteOffers', 'deleteOffersRequestSchema', deleteOffersRequestSchema)
            const localVarPath = `/core/admin/offers/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOffersRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a restaurant category
         * @summary Delete restaurant category
         * @param {string} categoryId Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRestaurantCategory: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('deleteRestaurantCategory', 'categoryId', categoryId)
            const localVarPath = `/core/stores/categories/delete/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint deletes multiple reviews based on the provided IDs.
         * @summary Delete multiple reviews by IDs
         * @param {DeleteReviewsRequest} deleteReviewsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReviews: async (deleteReviewsRequest: DeleteReviewsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteReviewsRequest' is not null or undefined
            assertParamExists('deleteReviews', 'deleteReviewsRequest', deleteReviewsRequest)
            const localVarPath = `/core/reviews/deleteReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteReviewsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple stores by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStores: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteStores', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/store/deleteStores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple sub-admins by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAdmins: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteSubAdmins', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/subAdmin/deleteSubAdmin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete multiple sub-item categories by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubItemCategory: async (deleteSubAdminsRequest: DeleteSubAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubAdminsRequest' is not null or undefined
            assertParamExists('deleteSubItemCategory', 'deleteSubAdminsRequest', deleteSubAdminsRequest)
            const localVarPath = `/core/itemSubCategory/deleteItemSubCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete subscription plans by IDs
         * @param {DeleteSubscriptionPlansRequest} deleteSubscriptionPlansRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionPlans: async (deleteSubscriptionPlansRequest: DeleteSubscriptionPlansRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteSubscriptionPlansRequest' is not null or undefined
            assertParamExists('deleteSubscriptionPlans', 'deleteSubscriptionPlansRequest', deleteSubscriptionPlansRequest)
            const localVarPath = `/core/subscriptionPlan/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteSubscriptionPlansRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a specific address for the user.
         * @summary Delete a user address
         * @param {string} addressId The unique identifier of the address to delete.
         * @param {string} userId The ID of the user to whom the address belongs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAddress: async (addressId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('deleteUserAddress', 'addressId', addressId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserAddress', 'userId', userId)
            const localVarPath = `/core/deleteUserAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (addressId !== undefined) {
                localVarQueryParameter['addressId'] = addressId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint deletes multiple users based on the provided IDs.
         * @summary Delete multiple users by IDs
         * @param {DeleteUsersRequest} deleteUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers: async (deleteUsersRequest: DeleteUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteUsersRequest' is not null or undefined
            assertParamExists('deleteUsers', 'deleteUsersRequest', deleteUsersRequest)
            const localVarPath = `/core/user/deleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed admin commission report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all stores and commission data across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total commission collected, total sales, average rate) 2. **Details Section**: Line-by-line listing of orders with commission breakdown  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Commission Type (common or custom) - Commission Percentage (rate applied, e.g., \"15%\") - Total Orders (count of orders in period) - Total Sales (total order amount / gross sales) - Commission Amount (commission collected from this store) - Average Commission per Order - Order Details (order ID, date, amount, commission calculated)  **Summary Fields (Overall):** - Total Commission Collected (sum across all stores) - Total Sales (All Stores) - Average Commission Rate (weighted average) - Store Count  **Commission Calculation:** Commission data is sourced from Commission Tracking records (recordType: admin_merchant): - Total Sales = totalOrderAmount - Commission Amount = totalAdminCommissionAmount - Commission Percentage:   * If merchant.commissionType === \"custom\" → merchant.commissionPercentage   * If merchant.commissionType === \"common\" → Platform default commission rate - Total Commission Collected = SUM(totalAdminCommissionAmount) across all filtered records  **Data Aggregation:** 1. Filter CommissionRecords by date range, store IDs, merchant ID, store type 2. Join with Merchant schema to get commission type and percentage 3. Join with Store schema to get store type 4. Group by store and calculate totals 5. Generate summary with platform-wide totals  **Date Filtering:** The dateRange parameter filters by order completion date (when commission was earned), not by commission payment or settlement date. 
         * @summary Download admin commission report
         * @param {AdminCommissionReportRequest} adminCommissionReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAdminCommissionReport: async (adminCommissionReportRequest: AdminCommissionReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCommissionReportRequest' is not null or undefined
            assertParamExists('downloadAdminCommissionReport', 'adminCommissionReportRequest', adminCommissionReportRequest)
            const localVarPath = `/core/reports/admin-commission/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCommissionReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a customized Excel template with store-specific categories, subcategories, and dropdown validations for bulk uploading items. Only XLSX format is supported.
         * @summary Download store-specific Excel template with customized dropdowns
         * @param {string} storeId Store ID for generating customized template with store-specific categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkUploadTemplate: async (storeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('downloadBulkUploadTemplate', 'storeId', storeId)
            const localVarPath = `/core/item/bulkUploadTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed cancelled orders report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all cancelled orders across all stores - Merchants: Can only access cancelled orders from their own stores  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall 2. **Details Section**: Line-by-line listing of cancelled orders  **Cancellation States Included (Default):** - ORDER_CANCELLED: Customer or system cancelled after order placed - MERCHANT_CANCELLED: Merchant cancelled the order - DELIVERY_FAILED: Delivery attempt failed, order marked cancelled  **Refund Calculation:** Refund amounts include Settlement records with status COMPLETED or PENDING/INPROGRESS where transactionType = \'REFUND\' and isRefund = true.  **Date Filtering:** The dateRange parameter filters by CANCEL DATE (when order was cancelled), not by order creation date. 
         * @summary Download cancelled orders report
         * @param {CancelledOrdersReportRequest} cancelledOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCancelledOrdersReport: async (cancelledOrdersReportRequest: CancelledOrdersReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancelledOrdersReportRequest' is not null or undefined
            assertParamExists('downloadCancelledOrdersReport', 'cancelledOrdersReportRequest', cancelledOrdersReportRequest)
            const localVarPath = `/core/reports/cancelled-orders/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelledOrdersReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed delivery performance report in Excel format with driver performance metrics.  **Access Control:** - Admins only: Can access delivery performance data for all drivers across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate performance metrics (total deliveries, avg time, on-time %, earnings) 2. **Details Section**: Line-by-line listing of deliveries with timestamps and performance indicators  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Orders Delivered (count of successfully delivered orders) - Average Delivery Time (from driver acceptance to delivery completion, in minutes) - Distance Covered (total kilometers traveled, calculated from GPS coordinates) - On-time Delivery Percentage (calculated by backend based on delivery time thresholds) - Delayed Deliveries Count (orders exceeding expected delivery time) - Cancelled Orders Count (ORDER_CANCELLED + DELIVERY_FAILED statuses) - Total Earnings (sum of delivery fees + driver bonuses for delivered orders) - Order Details (order ID, acceptance time, delivery time, duration, status)  **Performance Metrics Calculation:** - **Average Delivery Time**: Calculated as (deliveredTime - driverAcceptedTime) averaged across all delivered orders.   Time is measured in minutes from when the driver accepted the order to when delivery was completed.  - **Distance Covered**: Calculated from GPS coordinate tracking via DeliveryPartnerLocation records.   Backend uses haversine distance formula to calculate distance between consecutive location points   and sums the total distance traveled. Result is reported in kilometers with 2 decimal places.   **Note**: Distance is a calculated metric as no direct distance field exists in schemas.  - **On-time Delivery %**: Backend determines \"on-time\" threshold (typically 30-45 minutes based on   business rules) and calculates percentage of orders delivered within threshold.   Formula: (orders delivered within threshold / total delivered orders) × 100   **Note**: The on-time threshold logic is implemented in backend and may vary by region or store type.  - **Delayed Deliveries**: Count of orders where (deliveredTime - driverAcceptedTime) exceeds   the on-time threshold. These are orders that took longer than expected to complete.  - **Cancelled Orders**: Includes ORDER_CANCELLED (customer/merchant initiated cancellations) and   DELIVERY_FAILED (delivery attempts that could not be completed) statuses.  - **Total Earnings**: Sum of (deliveryFee + driverBonus) from EarningsBreakdown for ORDER_DELIVERED   orders only. Cancelled or failed orders do not contribute to earnings calculation.  **Multi-Store Order Handling:** Orders with multiple pickup locations (totalStoresCount > 1) are tracked with individual store pickup timestamps. Delivery time is measured from driver acceptance to final delivery completion, accounting for the complexity of multi-store pickups.  **Date Filtering:** The dateRange parameter filters by DELIVERY COMPLETION DATE (deliveredTime timestamp). This ensures performance metrics reflect when deliveries were actually completed, not when orders were placed or accepted by the driver.  **Order Status Filtering:** By default, includes ORDER_DELIVERED, ORDER_CANCELLED, and DELIVERY_FAILED statuses to provide comprehensive performance view. Successful deliveries contribute to positive metrics, while cancelled/failed orders are tracked separately for complete performance assessment. 
         * @summary Download delivery performance report
         * @param {DeliveryPerformanceReportRequest} deliveryPerformanceReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDeliveryPerformanceReport: async (deliveryPerformanceReportRequest: DeliveryPerformanceReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryPerformanceReportRequest' is not null or undefined
            assertParamExists('downloadDeliveryPerformanceReport', 'deliveryPerformanceReportRequest', deliveryPerformanceReportRequest)
            const localVarPath = `/core/reports/delivery-performance/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryPerformanceReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed driver payout report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all driver payouts across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total deliveries, total earnings, settlement breakdown) 2. **Details Section**: Line-by-line listing of deliveries with all specified fields  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Deliveries (count of orders delivered) - Total Earnings (sum of delivery fees + bonuses) - Delivery Fee Total - Driver Bonus Total - COD Collected (cash collected from customers) - Settlement Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Pending Amount (earnings not yet paid) - Paid Amount (earnings already settled) - Order Details (order ID, date, store name, customer name, amount)  **Earnings Calculation:** Total Earnings = Sum of (Delivery Fee + Driver Bonus) for all completed deliveries. - Delivery Fee: Base fee for delivery service - Driver Bonus: Emergency/urgent delivery bonuses - Earnings are calculated from orders with status ORDER_DELIVERED (default)  **Settlement Tracking:** Settlement records with transactionCategory = DELIVERY_FEE or DRIVER_BONUS and toUserType = DELIVERY_PARTNER are used to track payout status.  **Date Filtering:** The dateRange parameter filters by ORDER DELIVERY DATE (when order was delivered/completed), not by settlement/payout date. This shows earnings generated in the period, regardless of when they were paid out. 
         * @summary Download driver payout report
         * @param {DriverPayoutReportRequest} driverPayoutReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDriverPayoutReport: async (driverPayoutReportRequest: DriverPayoutReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverPayoutReportRequest' is not null or undefined
            assertParamExists('downloadDriverPayoutReport', 'driverPayoutReportRequest', driverPayoutReportRequest)
            const localVarPath = `/core/reports/driver-payouts/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driverPayoutReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed merchant payout report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all merchants and stores across the platform - Merchants: Can only access their own stores (403 Forbidden if accessing others)  **Report Structure:** Multi-merchant reports generate separate worksheets per merchant/store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total orders, gross sales, discounts, commission, net payout) 2. **Details Section**: Line-by-line listing of orders and settlements with all specified fields  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Total Orders (count of orders in period) - Gross Sales (total order amount before deductions) - Discounts (wallet/coupon/offer deductions) - Admin Commission (platform commission amount) - Item Rejections (merchant rejected item amounts) - Customer Cancellations (customer cancelled item amounts) - Net Payout (amount payable to merchant) - Payout Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Payout Date (when payment was made) - Payment Reference No (transaction ID from payment system) - Payment Method (how merchant was paid) - Balance Due (outstanding amount not yet paid) - Order Details (order ID, date, customer, amount, status)  **Financial Calculations:** Financial data is sourced from Commission Tracking records: - Gross Sales = totalOrderAmount - Discounts = totalWalletCouponOfferAmount - Admin Commission = totalAdminCommissionAmount - Item Rejections = totalMerchantRejectedItemAmount - Customer Cancellations = totalUserCancelledItemAmount - Net Payout = Gross Sales - Admin Commission - Discounts - Rejections - Cancellations - Balance Due = balanceAmountToPay (positive = owe merchant, negative = merchant owes platform)  **Settlement Tracking:** Settlement records with toUserType = MERCHANT and transactionCategory = MERCHANT_PAYMENT are used to track payout status and payment references.  **Date Filtering:** The dateRange parameter determines the date range: - today: Today\'s settlements (midnight to now, UTC) - thisWeek: This week\'s settlements (Monday to now, UTC) - thisMonth: This month\'s settlements (1st to now, UTC) - last30Days: Last 30 days of settlements - thisYear: This year\'s settlements (Jan 1 to now, UTC) - custom: Use dateFrom and dateTo parameters (ISO 8601 UTC format)  Applies to order delivery dates (when sales occurred), not settlement payment dates. 
         * @summary Download merchant payout report
         * @param {MerchantPayoutReportRequest} merchantPayoutReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMerchantPayoutReport: async (merchantPayoutReportRequest: MerchantPayoutReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantPayoutReportRequest' is not null or undefined
            assertParamExists('downloadMerchantPayoutReport', 'merchantPayoutReportRequest', merchantPayoutReportRequest)
            const localVarPath = `/core/reports/merchant-payouts/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantPayoutReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download order summary report with advanced filtering options in Excel format.  **Access Control:** - Admins: Can access orders from any store - Merchants: Can only access orders from their own stores  **Report Fields:** - Order ID: Unique order identifier - Store Name: Name of the store where order was placed - Store Type: Restaurant, GroceryStore, or PharmacyStore - Customer Name: Name of the customer who placed the order - Driver Name: Name of assigned delivery partner (or \"Not Assigned\" if no driver) - Order Date: Timestamp when order was placed - Order Status: Current order status (ORDER_DELIVERED, ORDER_CANCELLED, etc.) - Payment Method: How customer paid for the order - Order Total: Total order amount including all charges - Tax: Tax amount charged on the order - Delivery Fee: Delivery charge for the order - Net Amount: Confirmed amount after order processing (excludes cancelled/unavailable items)  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by delivery date or completion date.  **Net Amount vs Order Total:** - Order Total: Initial order amount at checkout (includes all items) - Net Amount: Final confirmed amount after processing (excludes cancelled/unavailable items) 
         * @summary Download order summary report
         * @param {OrderSummaryReportRequest} orderSummaryReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderSummaryReport: async (orderSummaryReportRequest: OrderSummaryReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderSummaryReportRequest' is not null or undefined
            assertParamExists('downloadOrderSummaryReport', 'orderSummaryReportRequest', orderSummaryReportRequest)
            const localVarPath = `/core/reports/order-summary/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderSummaryReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed pending orders report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all pending orders across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total pending orders, orders by status, total order value, etc.) 2. **Details Section**: Line-by-line listing of pending orders with all specified fields  **Report Fields:** - Order ID - Store Name - Customer Name - Driver Assigned (name or \"Not Assigned\" if no driver) - Order Placed At (timestamp when order was created) - Order Total (total order amount) - Payment Method (Cash, Card, Wallet, Online, etc.) - Current Status (ORDER_PLACED, ORDER_ACCEPTED, etc.)  **What are \"Pending Orders\"?** Pending orders are orders that are currently in progress and have not been completed or cancelled. These include orders with statuses: ORDER_PLACED, ORDER_ACCEPTED, ORDER_READY_FOR_PICKUP, DRIVER_ACCEPTED, DRIVER_ARRIVED, DRIVER_PICKED_UP, DRIVER_ON_THE_WAY.  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by order completion or delivery date. This helps identify orders that were placed within a specific time range and are still pending.  **Use Cases:** - Monitor orders currently being processed - Identify stuck or delayed orders - Track order fulfillment pipeline - Analyze order processing efficiency - Manage driver assignments for pending deliveries 
         * @summary Download pending orders report
         * @param {PendingOrdersReportRequest} pendingOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPendingOrdersReport: async (pendingOrdersReportRequest: PendingOrdersReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pendingOrdersReportRequest' is not null or undefined
            assertParamExists('downloadPendingOrdersReport', 'pendingOrdersReportRequest', pendingOrdersReportRequest)
            const localVarPath = `/core/reports/pending-orders/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pendingOrdersReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed refund report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all refunds across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total refunds, total amount, count by method, etc.) 2. **Details Section**: Line-by-line listing of refunds with all specified fields  **Report Fields:** - Order ID - Customer Name - Store Name - Refund Amount - Refund Reason - Refund Method (Wallet, Online, Manual) - Refund Date - Approved By (Admin name and email)  **Date Filtering:** The dateRange parameter filters by REFUND DATE (when refund was processed), not by order creation date. 
         * @summary Download refund report
         * @param {RefundReportRequest} refundReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRefundReport: async (refundReportRequest: RefundReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refundReportRequest' is not null or undefined
            assertParamExists('downloadRefundReport', 'refundReportRequest', refundReportRequest)
            const localVarPath = `/core/reports/refunds/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a detailed rejected orders report in Excel format with advanced filtering.  **Access Control:** - **Admins**: Can access all rejected orders across all stores, including both merchant and driver rejections - **Merchants**: Can only access rejected orders from their own stores, and ONLY merchant rejections (no delivery partner information)  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall    - Total rejected orders    - Count by rejection type (merchant vs driver - admin only)    - Count by store type    - Most common rejection reasons 2. **Details Section**: Line-by-line listing of rejected orders  **Report Fields:** - **Order ID**: Unique identifier for the order - **Store Name**: Name of the store/restaurant - **Customer Name**: Name of the customer who placed the order - **Rejected By**: Who rejected the order   - For merchants: Always shows \"Store\" (only merchant rejections visible)   - For admins: Shows \"Store\" or \"Driver\" based on rejection type - **Delivery Partner Name** (Admin only, driver rejections): Name of the delivery partner who rejected   - Only shown for driver rejections when user is admin   - Not visible to merchant users - **Reject Reason**: Reason provided for rejection - **Order Time**: Timestamp when order was placed - **Rejected Time**: Timestamp when order/items were rejected  **What are \"Rejected Orders\"?**  Rejected orders include:  1. **Merchant Rejections** (Visible to both merchants and admins):    - Orders with status MERCHANT_DENIED (merchant rejected before acceptance)    - Orders with items marked as isRejected=true (partial or full item rejection)    - Tracked via rejectionReason field in StoreOrderItem schema  2. **Driver Rejections** (Visible to admins only):    - Orders where delivery driver denied/rejected the assignment    - Tracked via deniedAt, denialType, and denialReason in DeliveryInfo schema    - Includes both manual driver rejections and auto-rejections (timeout)  **Role-Based Data Access:**  - **Merchants**: Will NEVER see driver rejection data, even if they set rejectedBy=driver_rejected or include deliveryPartnerIds.   The backend automatically scopes merchant requests to only merchant rejections from their own stores.   The \"Delivery Partner Name\" field will not appear in merchant reports.  - **Admins**: Can set rejectedBy to either:   - merchant_rejected: Generate merchant rejection report only   - driver_rejected: Generate delivery partner rejection report only   - Omit the parameter: Include both merchant and driver rejections in the report    Can use deliveryPartnerIds to filter by specific delivery partners (only applicable when rejectedBy=driver_rejected).   The \"Delivery Partner Name\" field appears for driver rejections.  **Date Filtering:**  The dateRange parameter filters by REJECTION TIME: - For merchant rejections: When order was denied or items were marked rejected - For driver rejections: The deniedAt timestamp (admin only)  This differs from order creation date and helps identify when rejections occurred.  **Use Cases:** - Analyze rejection patterns and trends - Identify stores with high rejection rates - Track common rejection reasons for operational improvements - Monitor driver rejection patterns (admin only) - Filter by specific delivery partners to analyze their rejection behavior (admin only) - Understand customer impact from rejected orders 
         * @summary Download rejected orders report
         * @param {RejectedOrdersReportRequest} rejectedOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRejectedOrdersReport: async (rejectedOrdersReportRequest: RejectedOrdersReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rejectedOrdersReportRequest' is not null or undefined
            assertParamExists('downloadRejectedOrdersReport', 'rejectedOrdersReportRequest', rejectedOrdersReportRequest)
            const localVarPath = `/core/reports/rejected-orders/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectedOrdersReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download sales report with advanced filtering options in Excel format. - Admins: Can access any store - Merchants: Can filter by their own stores 
         * @summary Download sales report
         * @param {SalesReportRequest} salesReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSalesReport: async (salesReportRequest: SalesReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesReportRequest' is not null or undefined
            assertParamExists('downloadSalesReport', 'salesReportRequest', salesReportRequest)
            const localVarPath = `/core/reports/sales/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing admin
         * @param {string} userId The ID of the admin to be updated
         * @param {EditAdminRequest} editAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin: async (userId: string, editAdminRequest: EditAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('editAdmin', 'userId', userId)
            // verify required parameter 'editAdminRequest' is not null or undefined
            assertParamExists('editAdmin', 'editAdminRequest', editAdminRequest)
            const localVarPath = `/core/editAdmin/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing choice in the system
         * @param {string} choiceId The ID of the delivery manager to be updated
         * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editChoice: async (choiceId: string, addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'choiceId' is not null or undefined
            assertParamExists('editChoice', 'choiceId', choiceId)
            // verify required parameter 'addOrEditChoiceRequestSchema' is not null or undefined
            assertParamExists('editChoice', 'addOrEditChoiceRequestSchema', addOrEditChoiceRequestSchema)
            const localVarPath = `/core/choice/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (choiceId !== undefined) {
                localVarQueryParameter['choiceId'] = choiceId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditChoiceRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing choice group in the system
         * @param {string} choiceGroupId The ID of the delivery manager to be updated
         * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editChoiceGroup: async (choiceGroupId: string, addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'choiceGroupId' is not null or undefined
            assertParamExists('editChoiceGroup', 'choiceGroupId', choiceGroupId)
            // verify required parameter 'addOrUpdateChoiceGroupRequestSchema' is not null or undefined
            assertParamExists('editChoiceGroup', 'addOrUpdateChoiceGroupRequestSchema', addOrUpdateChoiceGroupRequestSchema)
            const localVarPath = `/core/choicegroup/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (choiceGroupId !== undefined) {
                localVarQueryParameter['choiceGroupId'] = choiceGroupId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrUpdateChoiceGroupRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing CMS page in the system
         * @summary Edit an existing CMS page
         * @param {string} pageId The ID of the CMS page to be updated
         * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCmsPage: async (pageId: string, addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageId' is not null or undefined
            assertParamExists('editCmsPage', 'pageId', pageId)
            // verify required parameter 'addOrEditCmsPageRequestSchema' is not null or undefined
            assertParamExists('editCmsPage', 'addOrEditCmsPageRequestSchema', addOrEditCmsPageRequestSchema)
            const localVarPath = `/core/cms/editCmsPage/{pageId}`
                .replace(`{${"pageId"}}`, encodeURIComponent(String(pageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditCmsPageRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing coupon in the system
         * @summary Edit an existing coupon
         * @param {string} couponId The ID of the coupon to be updated
         * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCoupon: async (couponId: string, addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'couponId' is not null or undefined
            assertParamExists('editCoupon', 'couponId', couponId)
            // verify required parameter 'addOrEditCouponRequestSchema' is not null or undefined
            assertParamExists('editCoupon', 'addOrEditCouponRequestSchema', addOrEditCouponRequestSchema)
            const localVarPath = `/core/coupon/edit/{couponId}`
                .replace(`{${"couponId"}}`, encodeURIComponent(String(couponId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditCouponRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing delivery manager to the system
         * @summary Edit an existing delivery manager
         * @param {string} deliveryManagerId The ID of the delivery manager to be updated
         * @param {EditDeliveryManagerRequestSchema} editDeliveryManagerRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeliveryManager: async (deliveryManagerId: string, editDeliveryManagerRequestSchema: EditDeliveryManagerRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryManagerId' is not null or undefined
            assertParamExists('editDeliveryManager', 'deliveryManagerId', deliveryManagerId)
            // verify required parameter 'editDeliveryManagerRequestSchema' is not null or undefined
            assertParamExists('editDeliveryManager', 'editDeliveryManagerRequestSchema', editDeliveryManagerRequestSchema)
            const localVarPath = `/core/deliveryManager/edit/{deliveryManagerId}`
                .replace(`{${"deliveryManagerId"}}`, encodeURIComponent(String(deliveryManagerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editDeliveryManagerRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing faq in the system
         * @summary Edit an existing Faq
         * @param {string} faqId The ID of the faq to be updated
         * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFaq: async (faqId: string, addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'faqId' is not null or undefined
            assertParamExists('editFaq', 'faqId', faqId)
            // verify required parameter 'addOrEditFaqRequestSchema' is not null or undefined
            assertParamExists('editFaq', 'addOrEditFaqRequestSchema', addOrEditFaqRequestSchema)
            const localVarPath = `/core/faq/edit/{faqId}`
                .replace(`{${"faqId"}}`, encodeURIComponent(String(faqId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditFaqRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing home page banner in the system
         * @summary Edit an existing Home Page Banner
         * @param {string} bannerId The ID of the banner to be updated
         * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editHomePageBanner: async (bannerId: string, dynamicHomePageContentSettings: DynamicHomePageContentSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerId' is not null or undefined
            assertParamExists('editHomePageBanner', 'bannerId', bannerId)
            // verify required parameter 'dynamicHomePageContentSettings' is not null or undefined
            assertParamExists('editHomePageBanner', 'dynamicHomePageContentSettings', dynamicHomePageContentSettings)
            const localVarPath = `/core/settings/configuration/editBanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bannerId !== undefined) {
                localVarQueryParameter['bannerId'] = bannerId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dynamicHomePageContentSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} categoryId The ID of the item category to be updated
         * @param {CreateItemCategoryRequest} createItemCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editItemCategory: async (categoryId: string, createItemCategoryRequest: CreateItemCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('editItemCategory', 'categoryId', categoryId)
            // verify required parameter 'createItemCategoryRequest' is not null or undefined
            assertParamExists('editItemCategory', 'createItemCategoryRequest', createItemCategoryRequest)
            const localVarPath = `/core/itemCategory/editItemCategory/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createItemCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a meal with new details, items, and choice groups
         * @summary Edit an existing meal
         * @param {string} mealId The ID of the meal to be updated
         * @param {EditMealRequest} editMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMeal: async (mealId: string, editMealRequest: EditMealRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mealId' is not null or undefined
            assertParamExists('editMeal', 'mealId', mealId)
            // verify required parameter 'editMealRequest' is not null or undefined
            assertParamExists('editMeal', 'editMealRequest', editMealRequest)
            const localVarPath = `/core/meal/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (mealId !== undefined) {
                localVarQueryParameter['mealId'] = mealId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editMealRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin updates an existing offer
         * @summary Edit an offer
         * @param {string} offerId 
         * @param {EditOfferRequestSchema} editOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOffer: async (offerId: string, editOfferRequestSchema: EditOfferRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('editOffer', 'offerId', offerId)
            // verify required parameter 'editOfferRequestSchema' is not null or undefined
            assertParamExists('editOffer', 'editOfferRequestSchema', editOfferRequestSchema)
            const localVarPath = `/core/admin/offers/{offerId}`
                .replace(`{${"offerId"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editOfferRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} storeId The ID of the store to be updated
         * @param {WritableStoreDataSchema} writableStoreDataSchema 
         * @param {string} [merchantId] The ID of the merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStore: async (storeId: string, writableStoreDataSchema: WritableStoreDataSchema, merchantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('editStore', 'storeId', storeId)
            // verify required parameter 'writableStoreDataSchema' is not null or undefined
            assertParamExists('editStore', 'writableStoreDataSchema', writableStoreDataSchema)
            const localVarPath = `/core/store/editStore/{storeId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writableStoreDataSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} storeId The ID of the restaurant to be updated
         * @param {WritableRestaurantDataSchema} writableRestaurantDataSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStoreForAdmin: async (storeId: string, writableRestaurantDataSchema: WritableRestaurantDataSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('editStoreForAdmin', 'storeId', storeId)
            // verify required parameter 'writableRestaurantDataSchema' is not null or undefined
            assertParamExists('editStoreForAdmin', 'writableRestaurantDataSchema', writableRestaurantDataSchema)
            const localVarPath = `/core/store/updateStore/{storeId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(writableRestaurantDataSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing sub-admin
         * @param {string} id The ID of the sub-admin to be updated
         * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSubAdmin: async (id: string, addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editSubAdmin', 'id', id)
            // verify required parameter 'addOrEditSubAdminRequest' is not null or undefined
            assertParamExists('editSubAdmin', 'addOrEditSubAdminRequest', addOrEditSubAdminRequest)
            const localVarPath = `/core/subAdmin/editSubAdmin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditSubAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit an existing sub-item category
         * @param {string} subCategoryId The ID of the sub-item category to be updated
         * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSubItemCategory: async (subCategoryId: string, createItemSubCategoryRequest: CreateItemSubCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subCategoryId' is not null or undefined
            assertParamExists('editSubItemCategory', 'subCategoryId', subCategoryId)
            // verify required parameter 'createItemSubCategoryRequest' is not null or undefined
            assertParamExists('editSubItemCategory', 'createItemSubCategoryRequest', createItemSubCategoryRequest)
            const localVarPath = `/core/itemSubCategory/editItemSubCategory/{subCategoryId}`
                .replace(`{${"subCategoryId"}}`, encodeURIComponent(String(subCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createItemSubCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint edits an existing address for a user.
         * @summary Edit an existing user address
         * @param {UserAddressSchema} userAddressSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserAddress: async (userAddressSchema: UserAddressSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAddressSchema' is not null or undefined
            assertParamExists('editUserAddress', 'userAddressSchema', userAddressSchema)
            const localVarPath = `/core/editUserAddress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userAddressSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint updates the details of an existing user.
         * @summary Edit an existing user
         * @param {string} userId The ID of the user to be updated
         * @param {EditUserRequestSchema} editUserRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserById: async (userId: string, editUserRequestSchema: EditUserRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('editUserById', 'userId', userId)
            // verify required parameter 'editUserRequestSchema' is not null or undefined
            assertParamExists('editUserById', 'editUserRequestSchema', editUserRequestSchema)
            const localVarPath = `/core/user/editUser/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editUserRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates password reset by sending a link (email) or code (SMS) to the user
         * @summary Send reset password link or code to user
         * @param {ForgotPasswordRequestSchema} forgotPasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPasswordRequestSchema: ForgotPasswordRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forgotPasswordRequestSchema' is not null or undefined
            assertParamExists('forgotPassword', 'forgotPasswordRequestSchema', forgotPasswordRequestSchema)
            const localVarPath = `/auth/forgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a unique coupon code for the specified coupon.
         * @summary Generate a unique coupon code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCouponCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/coupon/generateCouponCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates OTP for email or phone number
         * @param {OtpRequest} otpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOtp: async (otpRequest: OtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otpRequest' is not null or undefined
            assertParamExists('generateOtp', 'otpRequest', otpRequest)
            const localVarPath = `/auth/generateOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a presigned URL for uploading, downloading, or deleting a file from AWS S3.
         * @summary Generate a presigned URL for AWS S3 operations
         * @param {GeneratePresignedUrlRequest} generatePresignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePresignedUrl: async (generatePresignedUrlRequest: GeneratePresignedUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generatePresignedUrlRequest' is not null or undefined
            assertParamExists('generatePresignedUrl', 'generatePresignedUrlRequest', generatePresignedUrlRequest)
            const localVarPath = `/core/aws/get-presigned-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generatePresignedUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint generates a unique referral code for the specified user. Each user can generate their own referral code to share with others.
         * @summary Generate a referral code for a specific user
         * @param {string} userId The ID of the user to generate a referral code for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReferralCode: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('generateReferralCode', 'userId', userId)
            const localVarPath = `/core/user/referral/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all banner images
         * @summary Get a list of all banner images
         * @param {number} page Page number (starting from 1)
         * @param {GetAllBannerImagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllBannerImagesSortByEnum} sortBy Field to sort by image text
         * @param {GetAllBannerImagesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by image text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBannerImages: async (page: number, limit: GetAllBannerImagesLimitEnum, sortBy: GetAllBannerImagesSortByEnum, sortOrder: GetAllBannerImagesSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllBannerImages', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllBannerImages', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllBannerImages', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllBannerImages', 'sortOrder', sortOrder)
            const localVarPath = `/core/settings/configuration/getAllBanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all choice groups with optional search and sorting parameters.
         * @summary Get a list of all choice groups
         * @param {number} page Page number (starting from 1)
         * @param {GetAllChoiceGroupsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllChoiceGroupsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllChoiceGroupsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] Filter choice groups by specific store ID
         * @param {GetAllChoiceGroupsStoreTypeEnum} [storeType] Filter choice groups by store type
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChoiceGroups: async (page: number, limit: GetAllChoiceGroupsLimitEnum, sortBy: GetAllChoiceGroupsSortByEnum, sortOrder: GetAllChoiceGroupsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoiceGroupsStoreTypeEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllChoiceGroups', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllChoiceGroups', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllChoiceGroups', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllChoiceGroups', 'sortOrder', sortOrder)
            const localVarPath = `/core/choicegroup/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all choices with optional search and sorting parameters.
         * @summary Get a list of all choices
         * @param {number} page Page number (starting from 1)
         * @param {GetAllChoicesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllChoicesSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllChoicesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the merchant to which the choices belong
         * @param {string} [storeId] Filter choices by specific store ID
         * @param {GetAllChoicesStoreTypeEnum} [storeType] Filter choices by store type
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChoices: async (page: number, limit: GetAllChoicesLimitEnum, sortBy: GetAllChoicesSortByEnum, sortOrder: GetAllChoicesSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoicesStoreTypeEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllChoices', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllChoices', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllChoices', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllChoices', 'sortOrder', sortOrder)
            const localVarPath = `/core/choice/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
         * @summary Get a list of all cms pages
         * @param {number} page Page number (starting from 1)
         * @param {GetAllCmsPagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllCmsPagesSortByEnum} sortBy Field to sort by (title, createdAt, status)
         * @param {GetAllCmsPagesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by page title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCmsPages: async (page: number, limit: GetAllCmsPagesLimitEnum, sortBy: GetAllCmsPagesSortByEnum, sortOrder: GetAllCmsPagesSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllCmsPages', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllCmsPages', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllCmsPages', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllCmsPages', 'sortOrder', sortOrder)
            const localVarPath = `/core/cms/getAllCmsPages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all types of commission tracking data (merchant, admin merchant, delivery partner) with optional transaction details in a single API call
         * @summary Get unified commission tracking data and transactions
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {GetAllCommissionTrackingRecordTypeEnum} recordType Filter by user type (merchant, admin merchant, delivery partner)
         * @param {GetAllCommissionTrackingSortByEnum} [sortBy] Field to sort by
         * @param {GetAllCommissionTrackingSortOrderEnum} [sortOrder] Sort order (ascending or descending)
         * @param {string} [search] Full-text search on merchant name, restaurant name, email, delivery partner details, transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCommissionTracking: async (page: number, limit: number, recordType: GetAllCommissionTrackingRecordTypeEnum, sortBy?: GetAllCommissionTrackingSortByEnum, sortOrder?: GetAllCommissionTrackingSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllCommissionTracking', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllCommissionTracking', 'limit', limit)
            // verify required parameter 'recordType' is not null or undefined
            assertParamExists('getAllCommissionTracking', 'recordType', recordType)
            const localVarPath = `/core/commissionTracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (recordType !== undefined) {
                localVarQueryParameter['recordType'] = recordType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all coupons with optional search and sorting parameters.
         * @summary Get a list of all coupons
         * @param {number} page Page number (starting from 1)
         * @param {GetAllCouponsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllCouponsSortByEnum} sortBy Field to sort by (coupon name, code, type, validity, start date, status, coupons left)
         * @param {GetAllCouponsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by coupon name, coupon code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCoupons: async (page: number, limit: GetAllCouponsLimitEnum, sortBy: GetAllCouponsSortByEnum, sortOrder: GetAllCouponsSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllCoupons', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllCoupons', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllCoupons', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllCoupons', 'sortOrder', sortOrder)
            const localVarPath = `/core/coupon/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all delivery boys with optional search and sorting parameters.
         * @summary Get a list of all delivery boys
         * @param {number} page Page number (starting from 1)
         * @param {GetAllDeliveryBoysLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllDeliveryBoysSortByEnum} sortBy Field to sort by (name, email, mobile number)
         * @param {GetAllDeliveryBoysSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by delivery boy name, delivery boy email, or delivery boy mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeliveryBoys: async (page: number, limit: GetAllDeliveryBoysLimitEnum, sortBy: GetAllDeliveryBoysSortByEnum, sortOrder: GetAllDeliveryBoysSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllDeliveryBoys', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllDeliveryBoys', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllDeliveryBoys', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllDeliveryBoys', 'sortOrder', sortOrder)
            const localVarPath = `/core/deliveryBoy/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all delivery managers with optional search and sorting parameters.
         * @summary Get a list of all delivery managers
         * @param {number} page Page number (starting from 1)
         * @param {GetAllDeliveryManagersLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllDeliveryManagersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllDeliveryManagersSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeliveryManagers: async (page: number, limit: GetAllDeliveryManagersLimitEnum, sortBy: GetAllDeliveryManagersSortByEnum, sortOrder: GetAllDeliveryManagersSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllDeliveryManagers', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllDeliveryManagers', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllDeliveryManagers', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllDeliveryManagers', 'sortOrder', sortOrder)
            const localVarPath = `/core/deliveryManager/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
         * @summary Get a list of all cms pages
         * @param {number} page Page number (starting from 1)
         * @param {GetAllFaqsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllFaqsSortByEnum} sortBy Field to sort by question, createdAt, or status
         * @param {GetAllFaqsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by page title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFaqs: async (page: number, limit: GetAllFaqsLimitEnum, sortBy: GetAllFaqsSortByEnum, sortOrder: GetAllFaqsSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllFaqs', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllFaqs', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllFaqs', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllFaqs', 'sortOrder', sortOrder)
            const localVarPath = `/core/faq/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all items with optional search and sorting parameters.
         * @summary Get a list of all items with stocks
         * @param {number} page Page number (starting from 1)
         * @param {GetAllItemStocksLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllItemStocksSortByEnum} sortBy Field to sort by product code, item name, restaurant name, merchant name, creaeted at
         * @param {GetAllItemStocksSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the merchant to filter items by
         * @param {string} [search] Search by product code, item name, restaurant name, merchant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemStocks: async (page: number, limit: GetAllItemStocksLimitEnum, sortBy: GetAllItemStocksSortByEnum, sortOrder: GetAllItemStocksSortOrderEnum, merchantId?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllItemStocks', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllItemStocks', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllItemStocks', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllItemStocks', 'sortOrder', sortOrder)
            const localVarPath = `/core/stockManagement/getAllItemStocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all items with optional search and sorting parameters.
         * @summary Get a list of all items
         * @param {number} page Page number (starting from 1)
         * @param {GetAllItemsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllItemsSortByEnum} sortBy Field to sort by (name, itemCode, lastLoginDate, lastLogoutDate)
         * @param {GetAllItemsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] Filter items by specific store ID
         * @param {GetAllItemsStoreTypeEnum} [storeType] Filter items by store type
         * @param {string} [search] Search by name, item code, or restaurant name
         * @param {GetAllItemsStockAvailabilityEnum} [stockAvailability] Filter by status
         * @param {GetAllItemsAddedByEnum} [addedBy] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItems: async (page: number, limit: GetAllItemsLimitEnum, sortBy: GetAllItemsSortByEnum, sortOrder: GetAllItemsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllItemsStoreTypeEnum, search?: string, stockAvailability?: GetAllItemsStockAvailabilityEnum, addedBy?: GetAllItemsAddedByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllItems', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllItems', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllItems', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllItems', 'sortOrder', sortOrder)
            const localVarPath = `/core/item/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (stockAvailability !== undefined) {
                localVarQueryParameter['stockAvailability'] = stockAvailability;
            }

            if (addedBy !== undefined) {
                localVarQueryParameter['addedBy'] = addedBy;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of meals with filtering and sorting options
         * @summary Get all meals
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of meals per page
         * @param {string} [search] Search term for meal name
         * @param {string} [sortBy] Field to sort by
         * @param {GetAllMealsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [storeId] Filter by store ID
         * @param {GetAllMealsStoreTypeEnum} [storeType] Filter by store type
         * @param {GetAllMealsStatusEnum} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMeals: async (page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetAllMealsSortOrderEnum, storeId?: string, storeType?: GetAllMealsStoreTypeEnum, status?: GetAllMealsStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/meal/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all notifications
         * @param {string} userId ID of the user to fetch notifications for.
         * @param {GetAllNotificationsUserTypeEnum} userType 
         * @param {number} page 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications: async (userId: string, userType: GetAllNotificationsUserTypeEnum, page: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAllNotifications', 'userId', userId)
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('getAllNotifications', 'userType', userType)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllNotifications', 'page', page)
            const localVarPath = `/notifications/getAllNotifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin retrieves all offer coupons with pagination and filtering
         * @summary Get all offers
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetAllOffersSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOffers: async (page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetAllOffersSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllOffers', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllOffers', 'limit', limit)
            const localVarPath = `/core/admin/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a comprehensive list of orders with role-based filtering and data access. Response structure varies based on userType using discriminator pattern. 
         * @summary Get unified order details for all user types
         * @param {GetAllOrdersUserTypeEnum} userType Type of user making the request
         * @param {string} [userId] Unique identifier of the user making the request
         * @param {GetAllOrdersLangEnum} [lang] Language code for localized content
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {string} [orderId] Filter by specific order ID (for individual order lookup)
         * @param {string} [storeId] Filter by specific store ID
         * @param {GetAllOrdersStatusEnum} [status] Filter by order status
         * @param {string} [fromDate] Filter orders from this date (YYYY-MM-DD)
         * @param {string} [toDate] Filter orders until this date (YYYY-MM-DD)
         * @param {GetAllOrdersSortByEnum} [sortBy] Field to sort by
         * @param {GetAllOrdersSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Full-text search on customer name, store name, item name, order ID
         * @param {GetAllOrdersOrderModeEnum} [orderMode] Filter by order mode (normal or pre-order)
         * @param {boolean} [requiresManualAssignment] Filter orders that require manual driver assignment (urgent orders, no drivers available)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders: async (userType: GetAllOrdersUserTypeEnum, userId?: string, lang?: GetAllOrdersLangEnum, page?: number, limit?: number, orderId?: string, storeId?: string, status?: GetAllOrdersStatusEnum, fromDate?: string, toDate?: string, sortBy?: GetAllOrdersSortByEnum, sortOrder?: GetAllOrdersSortOrderEnum, search?: string, orderMode?: GetAllOrdersOrderModeEnum, requiresManualAssignment?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('getAllOrders', 'userType', userType)
            const localVarPath = `/core/order/getAllOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderMode !== undefined) {
                localVarQueryParameter['orderMode'] = orderMode;
            }

            if (requiresManualAssignment !== undefined) {
                localVarQueryParameter['requiresManualAssignment'] = requiresManualAssignment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of restaurant categories with their details.
         * @summary Get a list of restaurant categories
         * @param {GetAllRestaurantCategoriesStoreTypeEnum} storeType The type of store to which the restaurant belongs (Grocery or Restaurant)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRestaurantCategories: async (storeType: GetAllRestaurantCategoriesStoreTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeType' is not null or undefined
            assertParamExists('getAllRestaurantCategories', 'storeType', storeType)
            const localVarPath = `/core/store/categories/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all restaurant merchants.
         * @summary Get all restaurant merchants
         * @param {GetAllRestaurantMerchantsStoreTypeEnum} [storeType] Optional filter by store type. If not provided, returns all merchants regardless of store type.
         * @param {string} [search] Search by merchant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRestaurantMerchants: async (storeType?: GetAllRestaurantMerchantsStoreTypeEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/merchants/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of reviews
         * @summary Get all reviews
         * @param {GetAllReviewsTypeEnum} type type of reviews to fetch
         * @param {string} page Page number for pagination
         * @param {GetAllReviewsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {string} [storeId] The ID of the merchant
         * @param {string} [merchantId] The ID of the merchant
         * @param {string} [search] Search term to filter categories
         * @param {GetAllReviewsStatusEnum} [status] Filter by status
         * @param {GetAllReviewsSortByEnum} [sortBy] Field to sort by
         * @param {GetAllReviewsSortDirectionEnum} [sortDirection] Direction of sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReviews: async (type: GetAllReviewsTypeEnum, page: string, limit: GetAllReviewsLimitEnum, storeId?: string, merchantId?: string, search?: string, status?: GetAllReviewsStatusEnum, sortBy?: GetAllReviewsSortByEnum, sortDirection?: GetAllReviewsSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getAllReviews', 'type', type)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllReviews', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllReviews', 'limit', limit)
            const localVarPath = `/core/reviews/getAllReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve transactions based on user type with filtering and pagination. Transactions are categorized as: - **toPay**: Amount user needs to pay - **toReceive**: Amount user will receive - **completed**: Completed transactions 
         * @summary Get All Settlements
         * @param {GetAllSettlementsUserTypeEnum} userType Type of user requesting transactions
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {string} [userId] ID of the user. Required for MERCHANT, CUSTOMER, and DELIVERY_PARTNER. Optional for ADMIN (auto-loaded if not provided).
         * @param {GetAllSettlementsTransactionTypeEnum} [transactionType] Filter by transaction category
         * @param {string} [fromDate] Start date for filtering (ISO 8601 format)
         * @param {string} [toDate] End date for filtering (ISO 8601 format)
         * @param {GetAllSettlementsSortByEnum} [sortBy] Sort field
         * @param {GetAllSettlementsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search in description or reference number
         * @param {GetAllSettlementsSettlementUserTypeEnum} [settlementUserType] Filter settlements by user type (MERCHANT, CUSTOMER, or DELIVERY_PARTNER). Use with settlementUserId to filter by specific user.
         * @param {string} [settlementUserId] Filter settlements by specific user ID. Use with settlementUserType to filter by merchantId, customerId, or deliveryPartnerId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSettlements: async (userType: GetAllSettlementsUserTypeEnum, page: number, limit: number, userId?: string, transactionType?: GetAllSettlementsTransactionTypeEnum, fromDate?: string, toDate?: string, sortBy?: GetAllSettlementsSortByEnum, sortOrder?: GetAllSettlementsSortOrderEnum, search?: string, settlementUserType?: GetAllSettlementsSettlementUserTypeEnum, settlementUserId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('getAllSettlements', 'userType', userType)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllSettlements', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllSettlements', 'limit', limit)
            const localVarPath = `/core/settlement/getAllSettlements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString() :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString() :
                    toDate;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (settlementUserType !== undefined) {
                localVarQueryParameter['settlementUserType'] = settlementUserType;
            }

            if (settlementUserId !== undefined) {
                localVarQueryParameter['settlementUserId'] = settlementUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all restaurants with detailed information
         * @param {number} page Page number (starting from 1)
         * @param {GetAllStoresForAdminLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllStoresForAdminSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllStoresForAdminSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetAllStoresForAdminStatusFilterEnum} statusFilter Filter by category status
         * @param {GetAllStoresForAdminAddedByFilterEnum} addedByFilter Filter by who added the restaurant
         * @param {string} [merchantId] 
         * @param {GetAllStoresForAdminStoreTypeEnum} [storeType] Filter stores by type
         * @param {string} [search] Search by restaurant name, merchant name, category, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStoresForAdmin: async (page: number, limit: GetAllStoresForAdminLimitEnum, sortBy: GetAllStoresForAdminSortByEnum, sortOrder: GetAllStoresForAdminSortOrderEnum, statusFilter: GetAllStoresForAdminStatusFilterEnum, addedByFilter: GetAllStoresForAdminAddedByFilterEnum, merchantId?: string, storeType?: GetAllStoresForAdminStoreTypeEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllStoresForAdmin', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllStoresForAdmin', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllStoresForAdmin', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllStoresForAdmin', 'sortOrder', sortOrder)
            // verify required parameter 'statusFilter' is not null or undefined
            assertParamExists('getAllStoresForAdmin', 'statusFilter', statusFilter)
            // verify required parameter 'addedByFilter' is not null or undefined
            assertParamExists('getAllStoresForAdmin', 'addedByFilter', addedByFilter)
            const localVarPath = `/core/store/getAllStores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }

            if (addedByFilter !== undefined) {
                localVarQueryParameter['addedByFilter'] = addedByFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all sub-admins
         * @param {number} page Page number (starting from 1)
         * @param {GetAllSubAdminsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllSubAdminsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllSubAdminsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubAdmins: async (page: number, limit: GetAllSubAdminsLimitEnum, sortBy: GetAllSubAdminsSortByEnum, sortOrder: GetAllSubAdminsSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllSubAdmins', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllSubAdmins', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllSubAdmins', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllSubAdmins', 'sortOrder', sortOrder)
            const localVarPath = `/core/subAdmin/getAllSubAdmins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all subscription plans with optional search, filtering, and sorting.
         * @summary Get a list of all subscription plans
         * @param {number} page Page number (starting from 1)
         * @param {GetAllSubscriptionPlansLimitEnum} limit Number of records per page
         * @param {string} [search] Search by plan name
         * @param {GetAllSubscriptionPlansPlanDurationInEnum} [planDurationIn] Filter by duration unit
         * @param {GetAllSubscriptionPlansStatusEnum} [status] Filter by active status
         * @param {GetAllSubscriptionPlansSortByEnum} [sortBy] Field to sort by
         * @param {GetAllSubscriptionPlansSortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionPlans: async (page: number, limit: GetAllSubscriptionPlansLimitEnum, search?: string, planDurationIn?: GetAllSubscriptionPlansPlanDurationInEnum, status?: GetAllSubscriptionPlansStatusEnum, sortBy?: GetAllSubscriptionPlansSortByEnum, sortOrder?: GetAllSubscriptionPlansSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllSubscriptionPlans', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllSubscriptionPlans', 'limit', limit)
            const localVarPath = `/core/subscriptionPlans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (planDurationIn !== undefined) {
                localVarQueryParameter['planDurationIn'] = planDurationIn;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all users with optional search and sorting parameters.
         * @summary Get a list of all users
         * @param {number} page Page number (starting from 1)
         * @param {GetAllUsersLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllUsersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllUsersSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by user name, email, or mobile number
         * @param {GetAllUsersStatusEnum} [status] Filter by status
         * @param {GetAllUsersAddedByEnum} [addedBy] Filter by Added By
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (page: number, limit: GetAllUsersLimitEnum, sortBy: GetAllUsersSortByEnum, sortOrder: GetAllUsersSortOrderEnum, search?: string, status?: GetAllUsersStatusEnum, addedBy?: GetAllUsersAddedByEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAllUsers', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAllUsers', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAllUsers', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAllUsers', 'sortOrder', sortOrder)
            const localVarPath = `/core/user/getAllUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (addedBy !== undefined) {
                localVarQueryParameter['addedBy'] = addedBy;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns available coupons for given stores
         * @param {GetAvailableCouponsRequest} getAvailableCouponsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCoupons: async (getAvailableCouponsRequest: GetAvailableCouponsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAvailableCouponsRequest' is not null or undefined
            assertParamExists('getAvailableCoupons', 'getAvailableCouponsRequest', getAvailableCouponsRequest)
            const localVarPath = `/core/coupon/getAvailableCoupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAvailableCouponsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin retrieves all active offers that can be assigned to users
         * @summary Get available offers for assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableOffersForAssignment: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/admin/offers/available-for-assignment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check the status and progress of a background bulk upload job
         * @summary Get status of a bulk upload job
         * @param {string} jobId The unique identifier of the bulk upload job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkUploadStatus: async (jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getBulkUploadStatus', 'jobId', jobId)
            const localVarPath = `/core/item/bulkUpload/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all available choice groups based on the selected store type.
         * @summary Get all choice groups
         * @param {string} storeId The ID of the store to which the choice groups belong
         * @param {string} [search] Search by choice group name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChoiceGroups: async (storeId: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getChoiceGroups', 'storeId', storeId)
            const localVarPath = `/core/choiceGroup/getChoiceGroups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of all available choices based on the selected store.
         * @summary Get all choices
         * @param {string} storeId The ID of the store to which the choices belong
         * @param {string} [search] Search by choice name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChoicesList: async (storeId: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getChoicesList', 'storeId', storeId)
            const localVarPath = `/core/choices/getChoicesList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all active CMS pages for customer footer links with language support
         * @summary Get CMS pages for customer display
         * @param {GetCmsPagesForCustomerLangEnum} lang Language code (en, ar)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsPagesForCustomer: async (lang: GetCmsPagesForCustomerLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getCmsPagesForCustomer', 'lang', lang)
            const localVarPath = `/core/cms/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the configuration settings for the end user.
         * @summary Get Configuration Settings
         * @param {GetConfigurationSettingsLanguageEnum} [language] Language filter for the configuration settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationSettings: async (language?: GetConfigurationSettingsLanguageEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/settings/configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Customer User Details (Mobile)
         * @param {string} userId The ID of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCustomerDetails', 'userId', userId)
            const localVarPath = `/core/getUserDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin retrieves detailed loyalty points history for a specific customer
         * @summary Get customer loyalty history
         * @param {string} userId 
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoyaltyHistory: async (userId: string, page: number, limit: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCustomerLoyaltyHistory', 'userId', userId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCustomerLoyaltyHistory', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomerLoyaltyHistory', 'limit', limit)
            const localVarPath = `/core/admin/offers/customers/loyalty-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin retrieves customer list with orders, wallet, loyalty, and offers data
         * @summary Get customers with full details
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetCustomersDetailsForOffersSortOrderEnum} [sortOrder] 
         * @param {GetCustomersDetailsForOffersStatusEnum} [status] 
         * @param {GetCustomersDetailsForOffersCustomerTypeEnum} [customerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersDetailsForOffers: async (page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetCustomersDetailsForOffersSortOrderEnum, status?: GetCustomersDetailsForOffersStatusEnum, customerType?: GetCustomersDetailsForOffersCustomerTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCustomersDetailsForOffers', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomersDetailsForOffers', 'limit', limit)
            const localVarPath = `/core/admin/offers/customer-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (customerType !== undefined) {
                localVarQueryParameter['customerType'] = customerType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of all customers with their wallet information including balance, transaction history, and management actions.
         * @summary Get all customers with wallet details for admin panel
         * @param {number} page Page number (starting from 1)
         * @param {GetCustomersWithWalletDetailsLimitEnum} limit Number of records per page
         * @param {string} [search] Search by customer name, email, or phone number
         * @param {GetCustomersWithWalletDetailsSortByEnum} [sortBy] Field to sort by
         * @param {GetCustomersWithWalletDetailsSortOrderEnum} [sortOrder] Sort order
         * @param {GetCustomersWithWalletDetailsCustomerStatusEnum} [customerStatus] Filter by customer status
         * @param {GetCustomersWithWalletDetailsTransactionTypeEnum} [transactionType] Filter by recent transaction type
         * @param {string} [dateFrom] Filter transactions from this date (YYYY-MM-DD)
         * @param {string} [dateTo] Filter transactions to this date (YYYY-MM-DD)
         * @param {number} [transactionLimit] Number of recent transactions to return per customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersWithWalletDetails: async (page: number, limit: GetCustomersWithWalletDetailsLimitEnum, search?: string, sortBy?: GetCustomersWithWalletDetailsSortByEnum, sortOrder?: GetCustomersWithWalletDetailsSortOrderEnum, customerStatus?: GetCustomersWithWalletDetailsCustomerStatusEnum, transactionType?: GetCustomersWithWalletDetailsTransactionTypeEnum, dateFrom?: string, dateTo?: string, transactionLimit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCustomersWithWalletDetails', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getCustomersWithWalletDetails', 'limit', limit)
            const localVarPath = `/core/wallet/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (customerStatus !== undefined) {
                localVarQueryParameter['customerStatus'] = customerStatus;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (transactionLimit !== undefined) {
                localVarQueryParameter['transactionLimit'] = transactionLimit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns consolidated dashboard data with metrics, charts, and recent entries.
         * @param {GetDashboardMetricsDashboardTypeEnum} dashboardType Type of dashboard to retrieve (admin or merchant).
         * @param {string} fromDate Start date for dashboard data (inclusive, format YYYY-MM-DD).
         * @param {string} toDate End date for dashboard data (inclusive, format YYYY-MM-DD).
         * @param {string} [merchantId] Merchant ID for merchant-specific dashboards (required if dashboardType is merchant).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardMetrics: async (dashboardType: GetDashboardMetricsDashboardTypeEnum, fromDate: string, toDate: string, merchantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardType' is not null or undefined
            assertParamExists('getDashboardMetrics', 'dashboardType', dashboardType)
            // verify required parameter 'fromDate' is not null or undefined
            assertParamExists('getDashboardMetrics', 'fromDate', fromDate)
            // verify required parameter 'toDate' is not null or undefined
            assertParamExists('getDashboardMetrics', 'toDate', toDate)
            const localVarPath = `/core/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dashboardType !== undefined) {
                localVarQueryParameter['dashboardType'] = dashboardType;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any instanceof Date) ?
                    (fromDate as any).toISOString().substring(0,10) :
                    fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any instanceof Date) ?
                    (toDate as any).toISOString().substring(0,10) :
                    toDate;
            }

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all active FAQs for customer landing page with language support
         * @summary Get FAQs for customer display
         * @param {GetFaqsForCustomerLangEnum} lang Language code (en, ar)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaqsForCustomer: async (lang: GetFaqsForCustomerLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getFaqsForCustomer', 'lang', lang)
            const localVarPath = `/core/faq/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all featured store subscriptions for a merchant with optional filters
         * @summary Get featured store subscriptions
         * @param {string} merchantId Merchant ID to filter subscriptions
         * @param {string} [storeId] Optional store ID to filter subscriptions for a specific store
         * @param {GetFeaturedStoreSubscriptionsStatusEnum} [status] Optional status filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedStoreSubscriptions: async (merchantId: string, storeId?: string, status?: GetFeaturedStoreSubscriptionsStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getFeaturedStoreSubscriptions', 'merchantId', merchantId)
            const localVarPath = `/core/merchant/featured-store/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns banners, filters, dynamic categories, and nearby/explore stores based on user location and store type.
         * @summary Get Home Page Data
         * @param {string} userId 
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {GetHomePageDataForUserAppStoreTypeEnum} [storeType] 
         * @param {string} [search] 
         * @param {GetHomePageDataForUserAppSortByEnum} [sortBy] 
         * @param {GetHomePageDataForUserAppOffersEnum} [offers] 
         * @param {string} [cuisines] Filter stores by cuisine types. This is a dynamic filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomePageDataForUserApp: async (userId: string, latitude: number, longitude: number, storeType?: GetHomePageDataForUserAppStoreTypeEnum, search?: string, sortBy?: GetHomePageDataForUserAppSortByEnum, offers?: GetHomePageDataForUserAppOffersEnum, cuisines?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getHomePageDataForUserApp', 'userId', userId)
            // verify required parameter 'latitude' is not null or undefined
            assertParamExists('getHomePageDataForUserApp', 'latitude', latitude)
            // verify required parameter 'longitude' is not null or undefined
            assertParamExists('getHomePageDataForUserApp', 'longitude', longitude)
            const localVarPath = `/core/userApp/getHomePageData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (offers !== undefined) {
                localVarQueryParameter['offers'] = offers;
            }

            if (cuisines !== undefined) {
                localVarQueryParameter['cuisines'] = cuisines;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all item categories
         * @param {number} page Page number (starting from 1)
         * @param {GetItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
         * @param {GetItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetItemCategoriesStatusFilterEnum} statusFilter Filter by category status
         * @param {GetItemCategoriesAddedByFilterEnum} addedByFilter Filter by category status
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] The ID of the store to which the item category belongs
         * @param {GetItemCategoriesStoreTypeEnum} [storeType] Filter item categories by store type
         * @param {string} [search] Search by category name (English or Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemCategories: async (page: number, limit: GetItemCategoriesLimitEnum, sortBy: GetItemCategoriesSortByEnum, sortOrder: GetItemCategoriesSortOrderEnum, statusFilter: GetItemCategoriesStatusFilterEnum, addedByFilter: GetItemCategoriesAddedByFilterEnum, merchantId?: string, storeId?: string, storeType?: GetItemCategoriesStoreTypeEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getItemCategories', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getItemCategories', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getItemCategories', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getItemCategories', 'sortOrder', sortOrder)
            // verify required parameter 'statusFilter' is not null or undefined
            assertParamExists('getItemCategories', 'statusFilter', statusFilter)
            // verify required parameter 'addedByFilter' is not null or undefined
            assertParamExists('getItemCategories', 'addedByFilter', addedByFilter)
            const localVarPath = `/core/itemCategory/getItemCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }

            if (addedByFilter !== undefined) {
                localVarQueryParameter['addedByFilter'] = addedByFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve user\'s loyalty points balance, earned history, redeemed history, and potential wallet credit
         * @summary Get user loyalty points and history
         * @param {string} userId The ID of the user
         * @param {GetLoyaltyPointsLangEnum} lang Language code for transaction descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPoints: async (userId: string, lang: GetLoyaltyPointsLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getLoyaltyPoints', 'userId', userId)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getLoyaltyPoints', 'lang', lang)
            const localVarPath = `/core/user-app/loyalty/getPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of merchants
         * @param {number} page 
         * @param {number} limit 
         * @param {GetMerchantsStoreTypeEnum} [storeType] Filter merchants by business type
         * @param {string} [search] 
         * @param {GetMerchantsSortByEnum} [sortBy] 
         * @param {GetMerchantsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchants: async (page: number, limit: number, storeType?: GetMerchantsStoreTypeEnum, search?: string, sortBy?: GetMerchantsSortByEnum, sortOrder?: GetMerchantsSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getMerchants', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getMerchants', 'limit', limit)
            const localVarPath = `/core/merchant/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of subscribers with optional search and sorting.
         * @summary Get list of subscribers
         * @param {number} page Page number (starts from 1)
         * @param {GetNewsletterSubscribersLimitEnum} limit Number of records per page
         * @param {string} [search] Search by email
         * @param {GetNewsletterSubscribersStatusEnum} [status] 
         * @param {GetNewsletterSubscribersSortByEnum} [sortBy] Field to sort by
         * @param {GetNewsletterSubscribersSortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletterSubscribers: async (page: number, limit: GetNewsletterSubscribersLimitEnum, search?: string, status?: GetNewsletterSubscribersStatusEnum, sortBy?: GetNewsletterSubscribersSortByEnum, sortOrder?: GetNewsletterSubscribersSortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getNewsletterSubscribers', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getNewsletterSubscribers', 'limit', limit)
            const localVarPath = `/core/newsletter/subscribers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves complete real-time tracking information for multi-store orders including store-level status, delivery partner info, timeline, items, refunds, and billing details
         * @summary Get comprehensive order tracking details
         * @param {string} orderId Unique identifier for the order (ObjectId or Order Number format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTracking: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderTracking', 'orderId', orderId)
            const localVarPath = `/tracking/orderTracking/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns list of active payment gateways with supported currencies
         * @summary Get available payment gateways
         * @param {string} [currency] Optional currency code to filter gateways by support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentGateways: async (currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/payment/gateways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns only public-facing settings without credentials or sensitive data
         * @summary Get public settings for mobile/web clients
         * @param {GetPublicSettingsLangEnum} [lang] Language code for multilingual content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicSettings: async (lang?: GetPublicSettingsLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/settings/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve paginated referral report with search, sort, and filter capabilities for admin panel
         * @summary Get referral report for admin panel
         * @param {number} page Page number for pagination (default 1)
         * @param {number} limit Number of items per page (default 10, max 100)
         * @param {string} [search] Search term to filter by referrer name, referral code, or used user name
         * @param {GetReferralReportSortByEnum} [sortBy] Field to sort by
         * @param {GetReferralReportSortOrderEnum} [sortOrder] Sort order
         * @param {GetReferralReportStatusEnum} [status] Filter by referral status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralReport: async (page: number, limit: number, search?: string, sortBy?: GetReferralReportSortByEnum, sortOrder?: GetReferralReportSortOrderEnum, status?: GetReferralReportStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getReferralReport', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getReferralReport', 'limit', limit)
            const localVarPath = `/core/referral/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of restaurant categories
         * @summary Get all restaurant categories
         * @param {string} page Page number for pagination
         * @param {string} limit Number of items per page
         * @param {GetRestaurantCategoriesStoreTypeEnum} [storeType] Filter store categories by type
         * @param {string} [search] Search term to filter categories
         * @param {GetRestaurantCategoriesStatusEnum} [status] Filter by status
         * @param {GetRestaurantCategoriesSortByEnum} [sortBy] Field to sort by
         * @param {GetRestaurantCategoriesSortDirectionEnum} [sortDirection] Direction of sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestaurantCategories: async (page: string, limit: string, storeType?: GetRestaurantCategoriesStoreTypeEnum, search?: string, status?: GetRestaurantCategoriesStatusEnum, sortBy?: GetRestaurantCategoriesSortByEnum, sortDirection?: GetRestaurantCategoriesSortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getRestaurantCategories', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getRestaurantCategories', 'limit', limit)
            const localVarPath = `/core/getStoreCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of review suggestion strings that can be shown in the UI.
         * @summary Get all review suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewSuggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/user-app/reviews/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Web User Details (Admin & Merchant)
         * @param {string} userId The ID of the user making the request.
         * @param {GetSpecialUserDetailsUserTypeEnum} userType The platform type of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialUserDetails: async (userId: string, userType: GetSpecialUserDetailsUserTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getSpecialUserDetails', 'userId', userId)
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('getSpecialUserDetails', 'userType', userType)
            const localVarPath = `/core/getSpecialUserDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches detailed information about a store by its ID, including type-specific fields for display on mobile screens.
         * @summary Retrieve Store Details
         * @param {string} storeId The unique identifier of the store
         * @param {string} userId The unique identifier of the user (optional, for personalized data)
         * @param {GetStoreDetailsLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreDetails: async (storeId: string, userId: string, lang: GetStoreDetailsLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getStoreDetails', 'storeId', storeId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getStoreDetails', 'userId', userId)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getStoreDetails', 'lang', lang)
            const localVarPath = `/core/user-app/store/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches items available in the store (e.g., food for Restaurant, products for Grocery/Pharmacy) with optional filtering.
         * @summary Retrieve Store Items
         * @param {string} storeId The unique identifier of the store
         * @param {GetStoreMenuLanguageEnum} language 
         * @param {string} userId The unique identifier of the user (optional, for personalized data)
         * @param {string} [category] Filter items by category (e.g., Popular, Paratha)
         * @param {string} [search] Search term to filter items by name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreMenu: async (storeId: string, language: GetStoreMenuLanguageEnum, userId: string, category?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getStoreMenu', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getStoreMenu', 'language', language)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getStoreMenu', 'userId', userId)
            const localVarPath = `/core/user-app/store/menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of stores. If merchantId is provided, returns stores for that specific merchant. If not provided, returns all stores.
         * @summary Get stores list
         * @param {string} [merchantId] Optional filter by merchant ID. If not provided, returns all stores.
         * @param {string} [search] Search by store name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresListByMerchant: async (merchantId?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/stores/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all sub-item categories
         * @param {string} parentCategoryId ID of the parent category to filter subcategories
         * @param {number} page Page number (starting from 1)
         * @param {GetSubItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetSubItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
         * @param {GetSubItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetSubItemCategoriesStatusFilterEnum} statusFilter Filter by subcategory status
         * @param {GetSubItemCategoriesAddedByFilterEnum} addedByFilter Filter by who added the subcategory
         * @param {string} [search] Search by subcategory name (English or Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubItemCategories: async (parentCategoryId: string, page: number, limit: GetSubItemCategoriesLimitEnum, sortBy: GetSubItemCategoriesSortByEnum, sortOrder: GetSubItemCategoriesSortOrderEnum, statusFilter: GetSubItemCategoriesStatusFilterEnum, addedByFilter: GetSubItemCategoriesAddedByFilterEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentCategoryId' is not null or undefined
            assertParamExists('getSubItemCategories', 'parentCategoryId', parentCategoryId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getSubItemCategories', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getSubItemCategories', 'limit', limit)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getSubItemCategories', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getSubItemCategories', 'sortOrder', sortOrder)
            // verify required parameter 'statusFilter' is not null or undefined
            assertParamExists('getSubItemCategories', 'statusFilter', statusFilter)
            // verify required parameter 'addedByFilter' is not null or undefined
            assertParamExists('getSubItemCategories', 'addedByFilter', addedByFilter)
            const localVarPath = `/core/itemSubCategory/getItemSubCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (parentCategoryId !== undefined) {
                localVarQueryParameter['parentCategoryId'] = parentCategoryId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }

            if (addedByFilter !== undefined) {
                localVarQueryParameter['addedByFilter'] = addedByFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve tip status and details for a specific order
         * @summary Get tip status for an order
         * @param {string} userId The ID of the user
         * @param {string} orderId The order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipStatus: async (userId: string, orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTipStatus', 'userId', userId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getTipStatus', 'orderId', orderId)
            const localVarPath = `/core/tip/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the complete cart with all items grouped by store
         * @summary Get user\'s complete cart
         * @param {string} userId User identifier
         * @param {GetUserCartStoreTypeEnum} storeType Store type to filter items by store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCart: async (userId: string, storeType: GetUserCartStoreTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCart', 'userId', userId)
            // verify required parameter 'storeType' is not null or undefined
            assertParamExists('getUserCart', 'storeType', storeType)
            const localVarPath = `/core/user-app/cart/getUserCart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves user details necessary for the checkout process, including delivery address and contact information.
         * @summary Get user details required for checkout
         * @param {string} userId User ID to retrieve details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCheckoutDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserCheckoutDetails', 'userId', userId)
            const localVarPath = `/core/userDetails/getUserCheckoutDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all reviews submitted by the authenticated user with filtering, sorting, and pagination options.
         * @summary Get user\'s review history
         * @param {string} userId User ID to fetch reviews for
         * @param {number} [page] Page number for pagination
         * @param {GetUserReviewsLimitEnum} [limit] Number of reviews per page
         * @param {GetUserReviewsTypeEnum} [type] Filter reviews by type (All returns all review types)
         * @param {string} [startDate] Filter reviews created on or after this date
         * @param {string} [endDate] Filter reviews created on or before this date
         * @param {GetUserReviewsRatingEnum} [rating] Filter reviews by specific rating
         * @param {GetUserReviewsSortByEnum} [sortBy] Field to sort by
         * @param {GetUserReviewsSortDirectionEnum} [sortDirection] Sort direction
         * @param {GetUserReviewsLangEnum} [lang] Language code for multilingual fields (itemName, storeName)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReviews: async (userId: string, page?: number, limit?: GetUserReviewsLimitEnum, type?: GetUserReviewsTypeEnum, startDate?: string, endDate?: string, rating?: GetUserReviewsRatingEnum, sortBy?: GetUserReviewsSortByEnum, sortDirection?: GetUserReviewsSortDirectionEnum, lang?: GetUserReviewsLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserReviews', 'userId', userId)
            const localVarPath = `/core/user-app/reviews/my-reviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }

            if (rating !== undefined) {
                localVarQueryParameter['rating'] = rating;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the complete wishList with all items grouped by store
         * @summary Get user\'s complete wishList
         * @param {string} userId User identifier
         * @param {GetUserWishListStoreTypeEnum} storeType Store type to filter items by store.
         * @param {GetUserWishListLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserWishList: async (userId: string, storeType: GetUserWishListStoreTypeEnum, lang: GetUserWishListLangEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserWishList', 'userId', userId)
            // verify required parameter 'storeType' is not null or undefined
            assertParamExists('getUserWishList', 'storeType', storeType)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('getUserWishList', 'lang', lang)
            const localVarPath = `/core/user-app/wishlist/getUserWishList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (storeType !== undefined) {
                localVarQueryParameter['storeType'] = storeType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get wallet balance for checkout
         * @param {string} userId The ID of the user
         * @param {number} totalAmount Total checkout amount to compare with wallet balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletCheckoutBalance: async (userId: string, totalAmount: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWalletCheckoutBalance', 'userId', userId)
            // verify required parameter 'totalAmount' is not null or undefined
            assertParamExists('getWalletCheckoutBalance', 'totalAmount', totalAmount)
            const localVarPath = `/core/user-app/wallet/checkoutBalance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (totalAmount !== undefined) {
                localVarQueryParameter['totalAmount'] = totalAmount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the current wallet balance for the user
         * @param {string} userId The ID of the user whose wallet details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getWalletDetails', 'userId', userId)
            const localVarPath = `/core/wallet/getWalletDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receives payment events from Hyperpay
         * @summary Hyperpay webhook endpoint
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hyperpayWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('hyperpayWebhook', 'body', body)
            const localVarPath = `/core/payment/webhook/hyperpay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate payment for one or more pending settlements using a payment gateway. User can select multiple settlements and pay them all at once in a single transaction. 
         * @summary Initiate bulk settlement payment
         * @param {InitiateSettlementPaymentRequest} initiateSettlementPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSettlementPayment: async (initiateSettlementPaymentRequest: InitiateSettlementPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'initiateSettlementPaymentRequest' is not null or undefined
            assertParamExists('initiateSettlementPayment', 'initiateSettlementPaymentRequest', initiateSettlementPaymentRequest)
            const localVarPath = `/core/settlement/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initiateSettlementPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate a tip payment for a delivered order through payment gateway
         * @summary Initiate tip payment
         * @param {TipInitiateRequestSchema} tipInitiateRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTipPayment: async (tipInitiateRequestSchema: TipInitiateRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tipInitiateRequestSchema' is not null or undefined
            assertParamExists('initiateTipPayment', 'tipInitiateRequestSchema', tipInitiateRequestSchema)
            const localVarPath = `/core/tip/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tipInitiateRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of customers that can be selected for sending newsletters.
         * @summary List all customers
         * @param {string} [search] Search by customer name, phone or email
         * @param {ListCustomersUserTypeEnum} [userType] Filter by user type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers: async (search?: string, userType?: ListCustomersUserTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/customers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (userType !== undefined) {
                localVarQueryParameter['userType'] = userType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Log in a user (traditional or social)
         * @param {LoginUserRequest} [loginUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser: async (loginUserRequest?: LoginUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply or remove a coupon during checkout
         * @param {ManageCouponRequest} manageCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageCoupon: async (manageCouponRequest: ManageCouponRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'manageCouponRequest' is not null or undefined
            assertParamExists('manageCoupon', 'manageCouponRequest', manageCouponRequest)
            const localVarPath = `/core/coupon/manageCoupon`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(manageCouponRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks a specific notification as read for the authenticated user.
         * @summary Mark a notification as read
         * @param {MarkNotificationAsReadRequest} markNotificationAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead: async (markNotificationAsReadRequest: MarkNotificationAsReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markNotificationAsReadRequest' is not null or undefined
            assertParamExists('markNotificationAsRead', 'markNotificationAsReadRequest', markNotificationAsReadRequest)
            const localVarPath = `/notifications/markread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationAsReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates cart items, store capabilities, working hours, and calculates accurate order summary based on delivery mode (selfPickup/delivery) and order mode (normal/preOrder). This API sits between cart and checkout to provide comprehensive validations. 
         * @summary Prepare order with delivery mode and order type validations
         * @param {string} userId The ID of the user
         * @param {PrepareOrderLangEnum} lang Language preference for localized data (English or Arabic)
         * @param {PrepareOrderRequestSchema} prepareOrderRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareOrder: async (userId: string, lang: PrepareOrderLangEnum, prepareOrderRequestSchema: PrepareOrderRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('prepareOrder', 'userId', userId)
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('prepareOrder', 'lang', lang)
            // verify required parameter 'prepareOrderRequestSchema' is not null or undefined
            assertParamExists('prepareOrder', 'prepareOrderRequestSchema', prepareOrderRequestSchema)
            const localVarPath = `/core/order/prepare`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(prepareOrderRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiate payment to feature a store for a specific period
         * @summary Purchase featured store subscription
         * @param {PurchaseFeaturedStoreRequest} purchaseFeaturedStoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseFeaturedStore: async (purchaseFeaturedStoreRequest: PurchaseFeaturedStoreRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'purchaseFeaturedStoreRequest' is not null or undefined
            assertParamExists('purchaseFeaturedStore', 'purchaseFeaturedStoreRequest', purchaseFeaturedStoreRequest)
            const localVarPath = `/core/merchant/featured-store/purchase`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(purchaseFeaturedStoreRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Convert available loyalty points to wallet credit based on configured redemption rate
         * @summary Redeem loyalty points to wallet credit
         * @param {RedeemPointsRequest} redeemPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemPoints: async (redeemPointsRequest: RedeemPointsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemPointsRequest' is not null or undefined
            assertParamExists('redeemPoints', 'redeemPointsRequest', redeemPointsRequest)
            const localVarPath = `/core/user-app/loyalty/redeemPoints`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemPointsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a new access token using a refresh token
         * @summary Refresh access token
         * @param {RefreshTokenRequestSchema} refreshTokenRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (refreshTokenRequestSchema: RefreshTokenRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshTokenRequestSchema' is not null or undefined
            assertParamExists('refreshToken', 'refreshTokenRequestSchema', refreshTokenRequestSchema)
            const localVarPath = `/auth/refreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resend the OTP to the user\'s email or phone number
         * @summary Resend OTP
         * @param {OtpRequest} otpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOtp: async (otpRequest: OtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'otpRequest' is not null or undefined
            assertParamExists('resendOtp', 'otpRequest', otpRequest)
            const localVarPath = `/auth/resendOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset a user\'s password using a token
         * @summary Reset password
         * @param {ResetPasswordRequestSchema} resetPasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequestSchema: ResetPasswordRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequestSchema' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequestSchema', resetPasswordRequestSchema)
            const localVarPath = `/auth/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search Delivery Boys by filter
         * @param {string} [name] Partial or full name of the delivery boy
         * @param {number} [latitude] Latitude coordinate
         * @param {number} [longitude] Longitude coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeliveryBoys: async (name?: string, latitude?: number, longitude?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/core/deliveryBoy/searchDeliveryBoys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a newsletter email to all users, particular users, all subscribers, or particular subscribers.
         * @summary Send newsletter to selected audience
         * @param {SendNewsletterRequest} sendNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewsletter: async (sendNewsletterRequest: SendNewsletterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendNewsletterRequest' is not null or undefined
            assertParamExists('sendNewsletter', 'sendNewsletterRequest', sendNewsletterRequest)
            const localVarPath = `/core/newsletter/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a push notification to users or delivery personnel based on the selected type and recipient.
         * @summary Send push notification
         * @param {SendPushNotificationRequest} sendPushNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPushNotification: async (sendPushNotificationRequest: SendPushNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendPushNotificationRequest' is not null or undefined
            assertParamExists('sendPushNotification', 'sendPushNotificationRequest', sendPushNotificationRequest)
            const localVarPath = `/notifications/sendPushNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPushNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint sends a referral email to the specified user with the provided referral code.
         * @summary Send referral email to a user
         * @param {SendReferralEmailRequest} sendReferralEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReferralEmail: async (sendReferralEmailRequest: SendReferralEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendReferralEmailRequest' is not null or undefined
            assertParamExists('sendReferralEmail', 'sendReferralEmailRequest', sendReferralEmailRequest)
            const localVarPath = `/core/user/referral/sendEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendReferralEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register a new user (traditional or social)
         * @param {SignupUserRequest} signupUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupUser: async (signupUserRequest: SignupUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupUserRequest' is not null or undefined
            assertParamExists('signupUser', 'signupUserRequest', signupUserRequest)
            const localVarPath = `/auth/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticates special users using either email or mobile number and returns role-specific user details
         * @summary Login for Special Users (SuperAdmin, SubAdmin, Merchant)
         * @param {SpecialUserLoginRequestSchema} specialUserLoginRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialUserLogin: async (specialUserLoginRequestSchema: SpecialUserLoginRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'specialUserLoginRequestSchema' is not null or undefined
            assertParamExists('specialUserLogin', 'specialUserLoginRequestSchema', specialUserLoginRequestSchema)
            const localVarPath = `/auth/login/specialUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(specialUserLoginRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Receives payment events from Stripe
         * @summary Stripe webhook endpoint
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhook: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('stripeWebhook', 'body', body)
            const localVarPath = `/core/payment/webhook/stripe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows website visitors to subscribe to the newsletter. Public endpoint without authentication.
         * @summary Subscribe to newsletter from customer website
         * @param {SubscribeToNewsletterRequest} subscribeToNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToNewsletter: async (subscribeToNewsletterRequest: SubscribeToNewsletterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeToNewsletterRequest' is not null or undefined
            assertParamExists('subscribeToNewsletter', 'subscribeToNewsletterRequest', subscribeToNewsletterRequest)
            const localVarPath = `/core/newsletter/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeToNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle the status of multiple banner images by their IDs.
         * @summary Toggle status (blocked/unblocked) for multiple banner images
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBannerImageStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleBannerImageStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/settings/configuration/toggleBanner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple choice groups
         * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChoiceGroupStatus: async (toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleChoiceStatusRequest' is not null or undefined
            assertParamExists('toggleChoiceGroupStatus', 'toggleChoiceStatusRequest', toggleChoiceStatusRequest)
            const localVarPath = `/core/choicegroup/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleChoiceStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple choices
         * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChoiceStatus: async (toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleChoiceStatusRequest' is not null or undefined
            assertParamExists('toggleChoiceStatus', 'toggleChoiceStatusRequest', toggleChoiceStatusRequest)
            const localVarPath = `/core/choice/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleChoiceStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle the status of multiple cms pages by their IDs. This operation allows you to block or unblock multiple cms pages at once.
         * @summary Toggle status (blocked/unblocked) for multiple cms pages
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleCmsPagesStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleCmsPagesStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/cms/toggleCmsPageStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple coupons
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleCouponStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleCouponStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/coupon/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple delivery boys
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDeliveryBoyStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleDeliveryBoyStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/deliveryBoy/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple delivery managers
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDeliveryManagerStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleDeliveryManagerStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/deliveryManager/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle the status of multiple faqs by their IDs. This operation allows you to block or unblock multiple faqs at once.
         * @summary Toggle status (blocked/unblocked) for multiple faqs
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFaqsStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleFaqsStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/faq/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple categories
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleItemCategoriesStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleItemCategoriesStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/itemCategory/toggleItemCategoryStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Toggle the status of multiple items by their IDs. This operation allows you to block or unblock multiple items at once.
         * @summary Toggle status (blocked/unblocked) for multiple items
         * @param {ToggleItemStatusRequest} toggleItemStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleItemStatus: async (toggleItemStatusRequest: ToggleItemStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleItemStatusRequest' is not null or undefined
            assertParamExists('toggleItemStatus', 'toggleItemStatusRequest', toggleItemStatusRequest)
            const localVarPath = `/core/item/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleItemStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Block or unblock a merchant
         * @param {string} merchantId 
         * @param {ToggleMerchantActiveStatusRequest} toggleMerchantActiveStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleMerchantActiveStatus: async (merchantId: string, toggleMerchantActiveStatusRequest: ToggleMerchantActiveStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('toggleMerchantActiveStatus', 'merchantId', merchantId)
            // verify required parameter 'toggleMerchantActiveStatusRequest' is not null or undefined
            assertParamExists('toggleMerchantActiveStatus', 'toggleMerchantActiveStatusRequest', toggleMerchantActiveStatusRequest)
            const localVarPath = `/core/merchant/blockUnblock/{merchantId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleMerchantActiveStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle subscription status (subscribe/unsubscribe) of subscribers
         * @param {ToggleNewletterSubscriberStatusRequest} toggleNewletterSubscriberStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleNewletterSubscriberStatus: async (toggleNewletterSubscriberStatusRequest: ToggleNewletterSubscriberStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleNewletterSubscriberStatusRequest' is not null or undefined
            assertParamExists('toggleNewletterSubscriberStatus', 'toggleNewletterSubscriberStatusRequest', toggleNewletterSubscriberStatusRequest)
            const localVarPath = `/core/newsletter/subscribers/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleNewletterSubscriberStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin blocks or unblocks offers
         * @summary Toggle offer status
         * @param {ToggleOfferStatusRequestSchema} toggleOfferStatusRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleOfferStatus: async (toggleOfferStatusRequestSchema: ToggleOfferStatusRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleOfferStatusRequestSchema' is not null or undefined
            assertParamExists('toggleOfferStatus', 'toggleOfferStatusRequestSchema', toggleOfferStatusRequestSchema)
            const localVarPath = `/core/admin/offers/toggle-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleOfferStatusRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint toggles the approval status of multiple reviews based on the provided IDs and status.
         * @summary Toggle status for multiple reviews
         * @param {ToggleReviewApprovalStatusRequest} toggleReviewApprovalStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleReviewApprovalStatus: async (toggleReviewApprovalStatusRequest: ToggleReviewApprovalStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleReviewApprovalStatusRequest' is not null or undefined
            assertParamExists('toggleReviewApprovalStatus', 'toggleReviewApprovalStatusRequest', toggleReviewApprovalStatusRequest)
            const localVarPath = `/core/reviews/toggleReivewStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleReviewApprovalStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple stores
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleStoreStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleStoreStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/store/toggleStoreStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple sub-admins
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleSubAdminStatus: async (toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubAdminStatusRequest' is not null or undefined
            assertParamExists('toggleSubAdminStatus', 'toggleSubAdminStatusRequest', toggleSubAdminStatusRequest)
            const localVarPath = `/core/subAdmin/toggleSubAdminStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubAdminStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle the status of multiple sub-item categories
         * @param {ToggleSubCategoryStatusRequest} toggleSubCategoryStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleSubCategoryStatus: async (toggleSubCategoryStatusRequest: ToggleSubCategoryStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubCategoryStatusRequest' is not null or undefined
            assertParamExists('toggleSubCategoryStatus', 'toggleSubCategoryStatusRequest', toggleSubCategoryStatusRequest)
            const localVarPath = `/core/itemSubCategory/toggleItemSubCategoryStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubCategoryStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle status (active/inactive) for multiple subscription plans
         * @param {ToggleSubscriptionPlanStatusRequest} toggleSubscriptionPlanStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleSubscriptionPlanStatus: async (toggleSubscriptionPlanStatusRequest: ToggleSubscriptionPlanStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleSubscriptionPlanStatusRequest' is not null or undefined
            assertParamExists('toggleSubscriptionPlanStatus', 'toggleSubscriptionPlanStatusRequest', toggleSubscriptionPlanStatusRequest)
            const localVarPath = `/core/subscriptionPlan/toggleStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleSubscriptionPlanStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint toggles the status of multiple users based on the provided IDs and status.
         * @summary Toggle status (blocked/unblocked) for multiple users
         * @param {ToggleUserStatusRequest} toggleUserStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleUserStatus: async (toggleUserStatusRequest: ToggleUserStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleUserStatusRequest' is not null or undefined
            assertParamExists('toggleUserStatus', 'toggleUserStatusRequest', toggleUserStatusRequest)
            const localVarPath = `/core/user/toggleUserStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleUserStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a new delivery boy
         * @param {string} deliveryBoyId The ID of the delivery boy to be updated
         * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryBoy: async (deliveryBoyId: string, addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryBoyId' is not null or undefined
            assertParamExists('updateDeliveryBoy', 'deliveryBoyId', deliveryBoyId)
            // verify required parameter 'addOrEditDeliveryBoyRequestSchema' is not null or undefined
            assertParamExists('updateDeliveryBoy', 'addOrEditDeliveryBoyRequestSchema', addOrEditDeliveryBoyRequestSchema)
            const localVarPath = `/core/deliveryBoy/edit/{deliveryBoyId}`
                .replace(`{${"deliveryBoyId"}}`, encodeURIComponent(String(deliveryBoyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditDeliveryBoyRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit an existing item in the system
         * @summary Edit an existing item
         * @param {string} itemId The ID of the item to be updated
         * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItem: async (itemId: string, addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('updateItem', 'itemId', itemId)
            // verify required parameter 'addOrEditItemRequestSchema' is not null or undefined
            assertParamExists('updateItem', 'addOrEditItemRequestSchema', addOrEditItemRequestSchema)
            const localVarPath = `/core/item/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOrEditItemRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update stock of an item
         * @param {string} itemId The ID of the item to be updated
         * @param {UpdateItemStockRequestSchema} updateItemStockRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemStock: async (itemId: string, updateItemStockRequestSchema: UpdateItemStockRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('updateItemStock', 'itemId', itemId)
            // verify required parameter 'updateItemStockRequestSchema' is not null or undefined
            assertParamExists('updateItemStock', 'updateItemStockRequestSchema', updateItemStockRequestSchema)
            const localVarPath = `/core/stockManagement/updateItemStock/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateItemStockRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update merchant by ID
         * @param {string} merchantId 
         * @param {MerchantSchema} merchantSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchant: async (merchantId: string, merchantSchema: MerchantSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('updateMerchant', 'merchantId', merchantId)
            // verify required parameter 'merchantSchema' is not null or undefined
            assertParamExists('updateMerchant', 'merchantSchema', merchantSchema)
            const localVarPath = `/core/merchant/update/{merchantId}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows updating the status of an order (e.g., cancel, accept, dispatch, deliver, etc.)
         * @summary Update order status
         * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderStatus: async (updateOrderStatusRequest: UpdateOrderStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOrderStatusRequest' is not null or undefined
            assertParamExists('updateOrderStatus', 'updateOrderStatusRequest', updateOrderStatusRequest)
            const localVarPath = `/core/user-app/orders/updateStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing restaurant category
         * @summary Update category
         * @param {string} categoryId Category ID
         * @param {UpdateRestaurantCategoryRequest} updateRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRestaurantCategory: async (categoryId: string, updateRestaurantCategoryRequest: UpdateRestaurantCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('updateRestaurantCategory', 'categoryId', categoryId)
            // verify required parameter 'updateRestaurantCategoryRequest' is not null or undefined
            assertParamExists('updateRestaurantCategory', 'updateRestaurantCategoryRequest', updateRestaurantCategoryRequest)
            const localVarPath = `/core/stores/categories/update/{categoryId}`
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRestaurantCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user\'s wallet by crediting or deducting an amount
         * @param {UpdateWalletRequest} updateWalletRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWallet: async (updateWalletRequest: UpdateWalletRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateWalletRequest' is not null or undefined
            assertParamExists('updateWallet', 'updateWalletRequest', updateWalletRequest)
            const localVarPath = `/core/wallet/updateWallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateWalletRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify payment status and activate featured store subscription
         * @summary Verify featured store payment
         * @param {VerifyFeaturedPaymentRequest} verifyFeaturedPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyFeaturedPayment: async (verifyFeaturedPaymentRequest: VerifyFeaturedPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyFeaturedPaymentRequest' is not null or undefined
            assertParamExists('verifyFeaturedPayment', 'verifyFeaturedPaymentRequest', verifyFeaturedPaymentRequest)
            const localVarPath = `/core/merchant/featured-store/verify-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyFeaturedPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifies OTP for user (email or phone)
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOtp: async (verifyOtpRequest: VerifyOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyOtpRequest' is not null or undefined
            assertParamExists('verifyOtp', 'verifyOtpRequest', verifyOtpRequest)
            const localVarPath = `/auth/verifyOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify payment status after user returns from payment gateway and create order if successful
         * @summary Verify payment and create order
         * @param {string} userId The ID of the user
         * @param {VerifyPaymentRequest} verifyPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPayment: async (userId: string, verifyPaymentRequest: VerifyPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('verifyPayment', 'userId', userId)
            // verify required parameter 'verifyPaymentRequest' is not null or undefined
            assertParamExists('verifyPayment', 'verifyPaymentRequest', verifyPaymentRequest)
            const localVarPath = `/core/payment/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint verifies if a referral code is valid and available for use. It only checks validation without consuming the code.
         * @summary Verify a referral code
         * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyReferralCode: async (verifyReferralCodeRequest: VerifyReferralCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyReferralCodeRequest' is not null or undefined
            assertParamExists('verifyReferralCode', 'verifyReferralCodeRequest', verifyReferralCodeRequest)
            const localVarPath = `/core/user/referral/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyReferralCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify the status of a settlement payment after user completes payment via gateway. Updates all settlements in the payment based on gateway response. 
         * @summary Verify settlement payment status
         * @param {VerifySettlementPaymentRequest} verifySettlementPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySettlementPayment: async (verifySettlementPaymentRequest: VerifySettlementPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifySettlementPaymentRequest' is not null or undefined
            assertParamExists('verifySettlementPayment', 'verifySettlementPaymentRequest', verifySettlementPaymentRequest)
            const localVarPath = `/core/settlement/verify-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifySettlementPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify tip payment status after user completes payment
         * @summary Verify tip payment
         * @param {TipVerifyRequestSchema} tipVerifyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTipPayment: async (tipVerifyRequestSchema: TipVerifyRequestSchema, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tipVerifyRequestSchema' is not null or undefined
            assertParamExists('verifyTipPayment', 'tipVerifyRequestSchema', tipVerifyRequestSchema)
            const localVarPath = `/core/tip/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tipVerifyRequestSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify wallet payment after gateway redirect
         * @param {VerifyWalletPaymentRequest} verifyWalletPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWalletPayment: async (verifyWalletPaymentRequest: VerifyWalletPaymentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyWalletPaymentRequest' is not null or undefined
            assertParamExists('verifyWalletPayment', 'verifyWalletPaymentRequest', verifyWalletPaymentRequest)
            const localVarPath = `/core/wallet/verify-payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyWalletPaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Set banner image for the end user
         * @summary Set banner image for the end user
         * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBannerImageSettings(dynamicHomePageContentSettings: DynamicHomePageContentSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBannerImageSettings(dynamicHomePageContentSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addBannerImageSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new choice to the system
         * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addChoice(addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addChoice(addOrEditChoiceRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addChoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new choice to the system
         * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addChoiceGroup(addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addChoiceGroup(addOrUpdateChoiceGroupRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addChoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new CMS page to the system
         * @summary Add a new CMS page
         * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCmsPage(addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCmsPage(addOrEditCmsPageRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addCmsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set configuration settings for the end user
         * @summary Set configuration settings for the end user
         * @param {ConfigurationSettings} configurationSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addConfigurationSettings(configurationSettings: ConfigurationSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addConfigurationSettings(configurationSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addConfigurationSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new coupon to the system
         * @summary Add a new coupon
         * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCoupon(addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCoupon(addOrEditCouponRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new delivery boy
         * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDeliveryBoy(addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDeliveryBoy(addOrEditDeliveryBoyRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addDeliveryBoy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new delivery manager to the system
         * @summary Add a new delivery manager
         * @param {AddDeliveryManagerRequestSchema} addDeliveryManagerRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDeliveryManager(addDeliveryManagerRequestSchema: AddDeliveryManagerRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDeliveryManager(addDeliveryManagerRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addDeliveryManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new faq to the system
         * @summary Add a new Faq
         * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFaq(addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFaq(addOrEditFaqRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new item
         * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addItem(addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addItem(addOrEditItemRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new item category
         * @param {CreateItemCategoryRequest} createItemCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addItemCategory(createItemCategoryRequest: CreateItemCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addItemCategory(createItemCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addItemCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new item subcategory
         * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addItemSubCategory(createItemSubCategoryRequest: CreateItemSubCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addItemSubCategory(createItemSubCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addItemSubCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new meal for a store with items and choice groups
         * @summary Add a new meal
         * @param {AddMealRequest} addMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMeal(addMealRequest: AddMealRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMeal(addMealRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addMeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin creates a new offer coupon
         * @summary Create a new offer
         * @param {AddOfferRequestSchema} addOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOffer(addOfferRequestSchema: AddOfferRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOffer(addOfferRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a new subscription plan if `id` is not provided. If `id` is present, updates the existing subscription plan.
         * @summary Add or edit a subscription plan
         * @param {SubscriptionPlan} subscriptionPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrEditSubscriptionPlan(subscriptionPlan: SubscriptionPlan, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrEditSubscriptionPlan(subscriptionPlan, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addOrEditSubscriptionPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a specified item to the user\'s cart
         * @summary Add an item to the Cart
         * @param {string} userId User identifier
         * @param {AddOrUpdateCartRequestSchema} addOrUpdateCartRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdateCart(userId: string, addOrUpdateCartRequestSchema: AddOrUpdateCartRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddOrUpdateCartResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdateCart(userId, addOrUpdateCartRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addOrUpdateCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registers or updates the FCM token for a user, allowing them to receive push notifications.
         * @summary Add or update device ID for push notifications
         * @param {AddOrUpdateDeviceIdRequest} addOrUpdateDeviceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdateDeviceId(addOrUpdateDeviceIdRequest: AddOrUpdateDeviceIdRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdateDeviceId(addOrUpdateDeviceIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addOrUpdateDeviceId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a specified item to the user\'s wishList
         * @summary Add or update an item to the wishList
         * @param {AddOrUpdateWishListRequestSchema} addOrUpdateWishListRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrUpdateUserWishList(addOrUpdateWishListRequestSchema: AddOrUpdateWishListRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrUpdateUserWishList(addOrUpdateWishListRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addOrUpdateUserWishList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows a customer to submit a detailed review for a completed order, including: - App experience - Store rating - Delivery partner rating - Individual item ratings - Issues faced - Optional comments 
         * @summary Submit a review for an order
         * @param {AddReviewRequest} addReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addOrderReview(addReviewRequest: AddReviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addOrderReview(addReviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addOrderReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a new store to the system
         * @param {WritableStoreDataSchema} writableStoreDataSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStore(writableStoreDataSchema: WritableStoreDataSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddStore201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStore(writableStoreDataSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addStore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint adds a new address for a user.
         * @summary Add a new user address
         * @param {UserAddressSchema} userAddressSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserAddress(userAddressSchema: UserAddressSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserAddress(userAddressSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addUserAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds a new notification for a user and updates the notification count.
         * @summary Add a user notification and update count
         * @param {AddUserNotificationRequest} addUserNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserNotificationAndUpdateCount(addUserNotificationRequest: AddUserNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserNotificationAndUpdateCount(addUserNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.addUserNotificationAndUpdateCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows admin to assign a driver to an order either manually (by specifying driver ID) or automatically (system finds nearest available driver). The API updates order audits, notifies the driver, and optionally notifies the customer if driver is changed. 
         * @summary Admin assign driver to order manually or automatically
         * @param {AdminAssignDriverRequestSchema} adminAssignDriverRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAssignDriver(adminAssignDriverRequestSchema: AdminAssignDriverRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAssignDriverResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAssignDriver(adminAssignDriverRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.adminAssignDriver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin assigns specific offers to a user
         * @summary Assign offers to customer
         * @param {AssignOfferRequestSchema} assignOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignOffer(assignOfferRequestSchema: AssignOfferRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignOffer(assignOfferRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.assignOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Block or Unblock a restaurant category
         * @summary Block or Unblock restaurant category
         * @param {string} categoryId Category ID
         * @param {BlockOrUnblockRestaurantCategoryRequest} blockOrUnblockRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockOrUnblockRestaurantCategory(categoryId: string, blockOrUnblockRestaurantCategoryRequest: BlockOrUnblockRestaurantCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockOrUnblockRestaurantCategory(categoryId, blockOrUnblockRestaurantCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.blockOrUnblockRestaurantCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload multiple items at once using Excel (.xlsx) or CSV (.csv) file. Files with 50 or fewer rows are processed synchronously, while larger files are processed in the background.
         * @summary Bulk upload items from Excel or CSV file
         * @param {string} storeId The ID of the store for which items are being uploaded
         * @param {BulkUploadItemAddedByEnum} addedBy Who is adding the items (Admin or Merchant)
         * @param {File} file Excel (.xlsx) or CSV (.csv) file containing items to upload
         * @param {string} [merchantId] The ID of the merchant (required for merchant users, optional for admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUploadItem(storeId: string, addedBy: BulkUploadItemAddedByEnum, file: File, merchantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUploadResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUploadItem(storeId, addedBy, file, merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.bulkUploadItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calculate the total price for featuring a store based on date range and configured pricing
         * @summary Calculate featured store pricing
         * @param {CalculateFeaturedPriceRequest} calculateFeaturedPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateFeaturedPrice(calculateFeaturedPriceRequest: CalculateFeaturedPriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalculateFeaturedPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateFeaturedPrice(calculateFeaturedPriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.calculateFeaturedPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint allows a user to change their password.
         * @summary Change user password
         * @param {string} userId The ID of the user whose password is being changed
         * @param {ChangeUserPasswordUserTypeEnum} userType The type of user (e.g., customer, admin, subAdmin, merchant, deliveryPartner)
         * @param {ChangePasswordRequestSchema} changePasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUserPassword(userId: string, userType: ChangeUserPasswordUserTypeEnum, changePasswordRequestSchema: ChangePasswordRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUserPassword(userId, userType, changePasswordRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.changeUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if a user exists based on userName, email, or phone
         * @param {CheckUserExistsRequest} checkUserExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkUserExists(checkUserExistsRequest: CheckUserExistsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckUserExistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkUserExists(checkUserExistsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkUserExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Checkout order
         * @param {string} userId The ID of the user
         * @param {CheckoutRequestSchema} checkoutRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkoutOrder(userId: string, checkoutRequestSchema: CheckoutRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkoutOrder(userId, checkoutRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkoutOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new merchant to the platform
         * @summary Create a new merchant
         * @param {MerchantSchema} merchantSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMerchant(merchantSchema: MerchantSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMerchant(merchantSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a new restaurant category
         * @summary Create new category
         * @param {CreateRestaurantCategoryRequest} createRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRestaurantCategory(createRestaurantCategoryRequest: CreateRestaurantCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRestaurantCategory(createRestaurantCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createRestaurantCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint creates a new user with the provided details.
         * @summary Create a new admin user
         * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSubAdminUser(addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSubAdminUser(addOrEditSubAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createSubAdminUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint creates a new user with the provided details.
         * @summary Create a new user
         * @param {AddUserSchema} addUserSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(addUserSchema: AddUserSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(addUserSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple categories by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategories(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategories(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple choice groups by IDs
         * @param {DeleteChoicesRequest} deleteChoicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChoiceGroups(deleteChoicesRequest: DeleteChoicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChoiceGroups(deleteChoicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteChoiceGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple choices by IDs
         * @param {DeleteChoicesRequest} deleteChoicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChoices(deleteChoicesRequest: DeleteChoicesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChoices(deleteChoicesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteChoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple cms pages by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCmsPages(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCmsPages(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteCmsPages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple coupons by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCoupons(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCoupons(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteCoupons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple delivery boys by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeliveryBoys(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeliveryBoys(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteDeliveryBoys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple delivery managers by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDeliveryManagers(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDeliveryManagers(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteDeliveryManagers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple faqs by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFaqs(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFaqs(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteFaqs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete banner images
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHomePageBanner(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHomePageBanner(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteHomePageBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple items by IDs
         * @param {DeleteItemsRequest} deleteItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItems(deleteItemsRequest: DeleteItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItems(deleteItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete one or more meals by IDs
         * @summary Delete meals
         * @param {DeleteMealsRequest} deleteMealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMeals(deleteMealsRequest: DeleteMealsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMeals(deleteMealsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteMeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete merchant by ID
         * @param {string} merchantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMerchant(merchantId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMerchant(merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete subscribers by IDs
         * @param {DeleteNewsletterSubscribersRequest} deleteNewsletterSubscribersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNewsletterSubscribers(deleteNewsletterSubscribersRequest: DeleteNewsletterSubscribersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNewsletterSubscribers(deleteNewsletterSubscribersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteNewsletterSubscribers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin deletes one or more offers
         * @summary Delete offers
         * @param {DeleteOffersRequestSchema} deleteOffersRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOffers(deleteOffersRequestSchema: DeleteOffersRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOffers(deleteOffersRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a restaurant category
         * @summary Delete restaurant category
         * @param {string} categoryId Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRestaurantCategory(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRestaurantCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteRestaurantCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint deletes multiple reviews based on the provided IDs.
         * @summary Delete multiple reviews by IDs
         * @param {DeleteReviewsRequest} deleteReviewsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReviews(deleteReviewsRequest: DeleteReviewsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReviews(deleteReviewsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple stores by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStores(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStores(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteStores']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple sub-admins by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubAdmins(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubAdmins(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteSubAdmins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete multiple sub-item categories by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubItemCategory(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubItemCategory(deleteSubAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteSubItemCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete subscription plans by IDs
         * @param {DeleteSubscriptionPlansRequest} deleteSubscriptionPlansRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscriptionPlans(deleteSubscriptionPlansRequest: DeleteSubscriptionPlansRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscriptionPlans(deleteSubscriptionPlansRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteSubscriptionPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a specific address for the user.
         * @summary Delete a user address
         * @param {string} addressId The unique identifier of the address to delete.
         * @param {string} userId The ID of the user to whom the address belongs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserAddress(addressId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserAddress(addressId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteUserAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint deletes multiple users based on the provided IDs.
         * @summary Delete multiple users by IDs
         * @param {DeleteUsersRequest} deleteUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUsers(deleteUsersRequest: DeleteUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUsers(deleteUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.deleteUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed admin commission report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all stores and commission data across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total commission collected, total sales, average rate) 2. **Details Section**: Line-by-line listing of orders with commission breakdown  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Commission Type (common or custom) - Commission Percentage (rate applied, e.g., \"15%\") - Total Orders (count of orders in period) - Total Sales (total order amount / gross sales) - Commission Amount (commission collected from this store) - Average Commission per Order - Order Details (order ID, date, amount, commission calculated)  **Summary Fields (Overall):** - Total Commission Collected (sum across all stores) - Total Sales (All Stores) - Average Commission Rate (weighted average) - Store Count  **Commission Calculation:** Commission data is sourced from Commission Tracking records (recordType: admin_merchant): - Total Sales = totalOrderAmount - Commission Amount = totalAdminCommissionAmount - Commission Percentage:   * If merchant.commissionType === \"custom\" → merchant.commissionPercentage   * If merchant.commissionType === \"common\" → Platform default commission rate - Total Commission Collected = SUM(totalAdminCommissionAmount) across all filtered records  **Data Aggregation:** 1. Filter CommissionRecords by date range, store IDs, merchant ID, store type 2. Join with Merchant schema to get commission type and percentage 3. Join with Store schema to get store type 4. Group by store and calculate totals 5. Generate summary with platform-wide totals  **Date Filtering:** The dateRange parameter filters by order completion date (when commission was earned), not by commission payment or settlement date. 
         * @summary Download admin commission report
         * @param {AdminCommissionReportRequest} adminCommissionReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadAdminCommissionReport(adminCommissionReportRequest: AdminCommissionReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadAdminCommissionReport(adminCommissionReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadAdminCommissionReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a customized Excel template with store-specific categories, subcategories, and dropdown validations for bulk uploading items. Only XLSX format is supported.
         * @summary Download store-specific Excel template with customized dropdowns
         * @param {string} storeId Store ID for generating customized template with store-specific categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBulkUploadTemplate(storeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBulkUploadTemplate(storeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadBulkUploadTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed cancelled orders report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all cancelled orders across all stores - Merchants: Can only access cancelled orders from their own stores  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall 2. **Details Section**: Line-by-line listing of cancelled orders  **Cancellation States Included (Default):** - ORDER_CANCELLED: Customer or system cancelled after order placed - MERCHANT_CANCELLED: Merchant cancelled the order - DELIVERY_FAILED: Delivery attempt failed, order marked cancelled  **Refund Calculation:** Refund amounts include Settlement records with status COMPLETED or PENDING/INPROGRESS where transactionType = \'REFUND\' and isRefund = true.  **Date Filtering:** The dateRange parameter filters by CANCEL DATE (when order was cancelled), not by order creation date. 
         * @summary Download cancelled orders report
         * @param {CancelledOrdersReportRequest} cancelledOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCancelledOrdersReport(cancelledOrdersReportRequest: CancelledOrdersReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCancelledOrdersReport(cancelledOrdersReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadCancelledOrdersReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed delivery performance report in Excel format with driver performance metrics.  **Access Control:** - Admins only: Can access delivery performance data for all drivers across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate performance metrics (total deliveries, avg time, on-time %, earnings) 2. **Details Section**: Line-by-line listing of deliveries with timestamps and performance indicators  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Orders Delivered (count of successfully delivered orders) - Average Delivery Time (from driver acceptance to delivery completion, in minutes) - Distance Covered (total kilometers traveled, calculated from GPS coordinates) - On-time Delivery Percentage (calculated by backend based on delivery time thresholds) - Delayed Deliveries Count (orders exceeding expected delivery time) - Cancelled Orders Count (ORDER_CANCELLED + DELIVERY_FAILED statuses) - Total Earnings (sum of delivery fees + driver bonuses for delivered orders) - Order Details (order ID, acceptance time, delivery time, duration, status)  **Performance Metrics Calculation:** - **Average Delivery Time**: Calculated as (deliveredTime - driverAcceptedTime) averaged across all delivered orders.   Time is measured in minutes from when the driver accepted the order to when delivery was completed.  - **Distance Covered**: Calculated from GPS coordinate tracking via DeliveryPartnerLocation records.   Backend uses haversine distance formula to calculate distance between consecutive location points   and sums the total distance traveled. Result is reported in kilometers with 2 decimal places.   **Note**: Distance is a calculated metric as no direct distance field exists in schemas.  - **On-time Delivery %**: Backend determines \"on-time\" threshold (typically 30-45 minutes based on   business rules) and calculates percentage of orders delivered within threshold.   Formula: (orders delivered within threshold / total delivered orders) × 100   **Note**: The on-time threshold logic is implemented in backend and may vary by region or store type.  - **Delayed Deliveries**: Count of orders where (deliveredTime - driverAcceptedTime) exceeds   the on-time threshold. These are orders that took longer than expected to complete.  - **Cancelled Orders**: Includes ORDER_CANCELLED (customer/merchant initiated cancellations) and   DELIVERY_FAILED (delivery attempts that could not be completed) statuses.  - **Total Earnings**: Sum of (deliveryFee + driverBonus) from EarningsBreakdown for ORDER_DELIVERED   orders only. Cancelled or failed orders do not contribute to earnings calculation.  **Multi-Store Order Handling:** Orders with multiple pickup locations (totalStoresCount > 1) are tracked with individual store pickup timestamps. Delivery time is measured from driver acceptance to final delivery completion, accounting for the complexity of multi-store pickups.  **Date Filtering:** The dateRange parameter filters by DELIVERY COMPLETION DATE (deliveredTime timestamp). This ensures performance metrics reflect when deliveries were actually completed, not when orders were placed or accepted by the driver.  **Order Status Filtering:** By default, includes ORDER_DELIVERED, ORDER_CANCELLED, and DELIVERY_FAILED statuses to provide comprehensive performance view. Successful deliveries contribute to positive metrics, while cancelled/failed orders are tracked separately for complete performance assessment. 
         * @summary Download delivery performance report
         * @param {DeliveryPerformanceReportRequest} deliveryPerformanceReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDeliveryPerformanceReport(deliveryPerformanceReportRequest: DeliveryPerformanceReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDeliveryPerformanceReport(deliveryPerformanceReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadDeliveryPerformanceReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed driver payout report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all driver payouts across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total deliveries, total earnings, settlement breakdown) 2. **Details Section**: Line-by-line listing of deliveries with all specified fields  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Deliveries (count of orders delivered) - Total Earnings (sum of delivery fees + bonuses) - Delivery Fee Total - Driver Bonus Total - COD Collected (cash collected from customers) - Settlement Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Pending Amount (earnings not yet paid) - Paid Amount (earnings already settled) - Order Details (order ID, date, store name, customer name, amount)  **Earnings Calculation:** Total Earnings = Sum of (Delivery Fee + Driver Bonus) for all completed deliveries. - Delivery Fee: Base fee for delivery service - Driver Bonus: Emergency/urgent delivery bonuses - Earnings are calculated from orders with status ORDER_DELIVERED (default)  **Settlement Tracking:** Settlement records with transactionCategory = DELIVERY_FEE or DRIVER_BONUS and toUserType = DELIVERY_PARTNER are used to track payout status.  **Date Filtering:** The dateRange parameter filters by ORDER DELIVERY DATE (when order was delivered/completed), not by settlement/payout date. This shows earnings generated in the period, regardless of when they were paid out. 
         * @summary Download driver payout report
         * @param {DriverPayoutReportRequest} driverPayoutReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDriverPayoutReport(driverPayoutReportRequest: DriverPayoutReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDriverPayoutReport(driverPayoutReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadDriverPayoutReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed merchant payout report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all merchants and stores across the platform - Merchants: Can only access their own stores (403 Forbidden if accessing others)  **Report Structure:** Multi-merchant reports generate separate worksheets per merchant/store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total orders, gross sales, discounts, commission, net payout) 2. **Details Section**: Line-by-line listing of orders and settlements with all specified fields  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Total Orders (count of orders in period) - Gross Sales (total order amount before deductions) - Discounts (wallet/coupon/offer deductions) - Admin Commission (platform commission amount) - Item Rejections (merchant rejected item amounts) - Customer Cancellations (customer cancelled item amounts) - Net Payout (amount payable to merchant) - Payout Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Payout Date (when payment was made) - Payment Reference No (transaction ID from payment system) - Payment Method (how merchant was paid) - Balance Due (outstanding amount not yet paid) - Order Details (order ID, date, customer, amount, status)  **Financial Calculations:** Financial data is sourced from Commission Tracking records: - Gross Sales = totalOrderAmount - Discounts = totalWalletCouponOfferAmount - Admin Commission = totalAdminCommissionAmount - Item Rejections = totalMerchantRejectedItemAmount - Customer Cancellations = totalUserCancelledItemAmount - Net Payout = Gross Sales - Admin Commission - Discounts - Rejections - Cancellations - Balance Due = balanceAmountToPay (positive = owe merchant, negative = merchant owes platform)  **Settlement Tracking:** Settlement records with toUserType = MERCHANT and transactionCategory = MERCHANT_PAYMENT are used to track payout status and payment references.  **Date Filtering:** The dateRange parameter determines the date range: - today: Today\'s settlements (midnight to now, UTC) - thisWeek: This week\'s settlements (Monday to now, UTC) - thisMonth: This month\'s settlements (1st to now, UTC) - last30Days: Last 30 days of settlements - thisYear: This year\'s settlements (Jan 1 to now, UTC) - custom: Use dateFrom and dateTo parameters (ISO 8601 UTC format)  Applies to order delivery dates (when sales occurred), not settlement payment dates. 
         * @summary Download merchant payout report
         * @param {MerchantPayoutReportRequest} merchantPayoutReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMerchantPayoutReport(merchantPayoutReportRequest: MerchantPayoutReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMerchantPayoutReport(merchantPayoutReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadMerchantPayoutReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download order summary report with advanced filtering options in Excel format.  **Access Control:** - Admins: Can access orders from any store - Merchants: Can only access orders from their own stores  **Report Fields:** - Order ID: Unique order identifier - Store Name: Name of the store where order was placed - Store Type: Restaurant, GroceryStore, or PharmacyStore - Customer Name: Name of the customer who placed the order - Driver Name: Name of assigned delivery partner (or \"Not Assigned\" if no driver) - Order Date: Timestamp when order was placed - Order Status: Current order status (ORDER_DELIVERED, ORDER_CANCELLED, etc.) - Payment Method: How customer paid for the order - Order Total: Total order amount including all charges - Tax: Tax amount charged on the order - Delivery Fee: Delivery charge for the order - Net Amount: Confirmed amount after order processing (excludes cancelled/unavailable items)  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by delivery date or completion date.  **Net Amount vs Order Total:** - Order Total: Initial order amount at checkout (includes all items) - Net Amount: Final confirmed amount after processing (excludes cancelled/unavailable items) 
         * @summary Download order summary report
         * @param {OrderSummaryReportRequest} orderSummaryReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrderSummaryReport(orderSummaryReportRequest: OrderSummaryReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrderSummaryReport(orderSummaryReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadOrderSummaryReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed pending orders report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all pending orders across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total pending orders, orders by status, total order value, etc.) 2. **Details Section**: Line-by-line listing of pending orders with all specified fields  **Report Fields:** - Order ID - Store Name - Customer Name - Driver Assigned (name or \"Not Assigned\" if no driver) - Order Placed At (timestamp when order was created) - Order Total (total order amount) - Payment Method (Cash, Card, Wallet, Online, etc.) - Current Status (ORDER_PLACED, ORDER_ACCEPTED, etc.)  **What are \"Pending Orders\"?** Pending orders are orders that are currently in progress and have not been completed or cancelled. These include orders with statuses: ORDER_PLACED, ORDER_ACCEPTED, ORDER_READY_FOR_PICKUP, DRIVER_ACCEPTED, DRIVER_ARRIVED, DRIVER_PICKED_UP, DRIVER_ON_THE_WAY.  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by order completion or delivery date. This helps identify orders that were placed within a specific time range and are still pending.  **Use Cases:** - Monitor orders currently being processed - Identify stuck or delayed orders - Track order fulfillment pipeline - Analyze order processing efficiency - Manage driver assignments for pending deliveries 
         * @summary Download pending orders report
         * @param {PendingOrdersReportRequest} pendingOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPendingOrdersReport(pendingOrdersReportRequest: PendingOrdersReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPendingOrdersReport(pendingOrdersReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadPendingOrdersReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed refund report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all refunds across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total refunds, total amount, count by method, etc.) 2. **Details Section**: Line-by-line listing of refunds with all specified fields  **Report Fields:** - Order ID - Customer Name - Store Name - Refund Amount - Refund Reason - Refund Method (Wallet, Online, Manual) - Refund Date - Approved By (Admin name and email)  **Date Filtering:** The dateRange parameter filters by REFUND DATE (when refund was processed), not by order creation date. 
         * @summary Download refund report
         * @param {RefundReportRequest} refundReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRefundReport(refundReportRequest: RefundReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRefundReport(refundReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadRefundReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a detailed rejected orders report in Excel format with advanced filtering.  **Access Control:** - **Admins**: Can access all rejected orders across all stores, including both merchant and driver rejections - **Merchants**: Can only access rejected orders from their own stores, and ONLY merchant rejections (no delivery partner information)  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall    - Total rejected orders    - Count by rejection type (merchant vs driver - admin only)    - Count by store type    - Most common rejection reasons 2. **Details Section**: Line-by-line listing of rejected orders  **Report Fields:** - **Order ID**: Unique identifier for the order - **Store Name**: Name of the store/restaurant - **Customer Name**: Name of the customer who placed the order - **Rejected By**: Who rejected the order   - For merchants: Always shows \"Store\" (only merchant rejections visible)   - For admins: Shows \"Store\" or \"Driver\" based on rejection type - **Delivery Partner Name** (Admin only, driver rejections): Name of the delivery partner who rejected   - Only shown for driver rejections when user is admin   - Not visible to merchant users - **Reject Reason**: Reason provided for rejection - **Order Time**: Timestamp when order was placed - **Rejected Time**: Timestamp when order/items were rejected  **What are \"Rejected Orders\"?**  Rejected orders include:  1. **Merchant Rejections** (Visible to both merchants and admins):    - Orders with status MERCHANT_DENIED (merchant rejected before acceptance)    - Orders with items marked as isRejected=true (partial or full item rejection)    - Tracked via rejectionReason field in StoreOrderItem schema  2. **Driver Rejections** (Visible to admins only):    - Orders where delivery driver denied/rejected the assignment    - Tracked via deniedAt, denialType, and denialReason in DeliveryInfo schema    - Includes both manual driver rejections and auto-rejections (timeout)  **Role-Based Data Access:**  - **Merchants**: Will NEVER see driver rejection data, even if they set rejectedBy=driver_rejected or include deliveryPartnerIds.   The backend automatically scopes merchant requests to only merchant rejections from their own stores.   The \"Delivery Partner Name\" field will not appear in merchant reports.  - **Admins**: Can set rejectedBy to either:   - merchant_rejected: Generate merchant rejection report only   - driver_rejected: Generate delivery partner rejection report only   - Omit the parameter: Include both merchant and driver rejections in the report    Can use deliveryPartnerIds to filter by specific delivery partners (only applicable when rejectedBy=driver_rejected).   The \"Delivery Partner Name\" field appears for driver rejections.  **Date Filtering:**  The dateRange parameter filters by REJECTION TIME: - For merchant rejections: When order was denied or items were marked rejected - For driver rejections: The deniedAt timestamp (admin only)  This differs from order creation date and helps identify when rejections occurred.  **Use Cases:** - Analyze rejection patterns and trends - Identify stores with high rejection rates - Track common rejection reasons for operational improvements - Monitor driver rejection patterns (admin only) - Filter by specific delivery partners to analyze their rejection behavior (admin only) - Understand customer impact from rejected orders 
         * @summary Download rejected orders report
         * @param {RejectedOrdersReportRequest} rejectedOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRejectedOrdersReport(rejectedOrdersReportRequest: RejectedOrdersReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRejectedOrdersReport(rejectedOrdersReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadRejectedOrdersReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download sales report with advanced filtering options in Excel format. - Admins: Can access any store - Merchants: Can filter by their own stores 
         * @summary Download sales report
         * @param {SalesReportRequest} salesReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadSalesReport(salesReportRequest: SalesReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadSalesReport(salesReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.downloadSalesReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing admin
         * @param {string} userId The ID of the admin to be updated
         * @param {EditAdminRequest} editAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editAdmin(userId: string, editAdminRequest: EditAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editAdmin(userId, editAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing choice in the system
         * @param {string} choiceId The ID of the delivery manager to be updated
         * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editChoice(choiceId: string, addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editChoice(choiceId, addOrEditChoiceRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editChoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing choice group in the system
         * @param {string} choiceGroupId The ID of the delivery manager to be updated
         * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editChoiceGroup(choiceGroupId: string, addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editChoiceGroup(choiceGroupId, addOrUpdateChoiceGroupRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editChoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing CMS page in the system
         * @summary Edit an existing CMS page
         * @param {string} pageId The ID of the CMS page to be updated
         * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCmsPage(pageId: string, addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCmsPage(pageId, addOrEditCmsPageRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editCmsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing coupon in the system
         * @summary Edit an existing coupon
         * @param {string} couponId The ID of the coupon to be updated
         * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editCoupon(couponId: string, addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editCoupon(couponId, addOrEditCouponRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing delivery manager to the system
         * @summary Edit an existing delivery manager
         * @param {string} deliveryManagerId The ID of the delivery manager to be updated
         * @param {EditDeliveryManagerRequestSchema} editDeliveryManagerRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDeliveryManager(deliveryManagerId: string, editDeliveryManagerRequestSchema: EditDeliveryManagerRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDeliveryManager(deliveryManagerId, editDeliveryManagerRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editDeliveryManager']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing faq in the system
         * @summary Edit an existing Faq
         * @param {string} faqId The ID of the faq to be updated
         * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editFaq(faqId: string, addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editFaq(faqId, addOrEditFaqRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editFaq']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing home page banner in the system
         * @summary Edit an existing Home Page Banner
         * @param {string} bannerId The ID of the banner to be updated
         * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editHomePageBanner(bannerId: string, dynamicHomePageContentSettings: DynamicHomePageContentSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editHomePageBanner(bannerId, dynamicHomePageContentSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editHomePageBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} categoryId The ID of the item category to be updated
         * @param {CreateItemCategoryRequest} createItemCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editItemCategory(categoryId: string, createItemCategoryRequest: CreateItemCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editItemCategory(categoryId, createItemCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editItemCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a meal with new details, items, and choice groups
         * @summary Edit an existing meal
         * @param {string} mealId The ID of the meal to be updated
         * @param {EditMealRequest} editMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editMeal(mealId: string, editMealRequest: EditMealRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editMeal(mealId, editMealRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editMeal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin updates an existing offer
         * @summary Edit an offer
         * @param {string} offerId 
         * @param {EditOfferRequestSchema} editOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editOffer(offerId: string, editOfferRequestSchema: EditOfferRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editOffer(offerId, editOfferRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} storeId The ID of the store to be updated
         * @param {WritableStoreDataSchema} writableStoreDataSchema 
         * @param {string} [merchantId] The ID of the merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editStore(storeId: string, writableStoreDataSchema: WritableStoreDataSchema, merchantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editStore(storeId, writableStoreDataSchema, merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editStore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} storeId The ID of the restaurant to be updated
         * @param {WritableRestaurantDataSchema} writableRestaurantDataSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editStoreForAdmin(storeId: string, writableRestaurantDataSchema: WritableRestaurantDataSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editStoreForAdmin(storeId, writableRestaurantDataSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editStoreForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing sub-admin
         * @param {string} id The ID of the sub-admin to be updated
         * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSubAdmin(id: string, addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSubAdmin(id, addOrEditSubAdminRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editSubAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Edit an existing sub-item category
         * @param {string} subCategoryId The ID of the sub-item category to be updated
         * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editSubItemCategory(subCategoryId: string, createItemSubCategoryRequest: CreateItemSubCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editSubItemCategory(subCategoryId, createItemSubCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editSubItemCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint edits an existing address for a user.
         * @summary Edit an existing user address
         * @param {UserAddressSchema} userAddressSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUserAddress(userAddressSchema: UserAddressSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUserAddress(userAddressSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editUserAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint updates the details of an existing user.
         * @summary Edit an existing user
         * @param {string} userId The ID of the user to be updated
         * @param {EditUserRequestSchema} editUserRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editUserById(userId: string, editUserRequestSchema: EditUserRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editUserById(userId, editUserRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.editUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates password reset by sending a link (email) or code (SMS) to the user
         * @summary Send reset password link or code to user
         * @param {ForgotPasswordRequestSchema} forgotPasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPasswordRequestSchema: ForgotPasswordRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(forgotPasswordRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a unique coupon code for the specified coupon.
         * @summary Generate a unique coupon code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateCouponCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateCouponCodeResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateCouponCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateCouponCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generates OTP for email or phone number
         * @param {OtpRequest} otpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateOtp(otpRequest: OtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateOtp(otpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a presigned URL for uploading, downloading, or deleting a file from AWS S3.
         * @summary Generate a presigned URL for AWS S3 operations
         * @param {GeneratePresignedUrlRequest} generatePresignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generatePresignedUrl(generatePresignedUrlRequest: GeneratePresignedUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AwsPresignedURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generatePresignedUrl(generatePresignedUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generatePresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint generates a unique referral code for the specified user. Each user can generate their own referral code to share with others.
         * @summary Generate a referral code for a specific user
         * @param {string} userId The ID of the user to generate a referral code for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateReferralCode(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateReferralCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateReferralCode(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.generateReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all banner images
         * @summary Get a list of all banner images
         * @param {number} page Page number (starting from 1)
         * @param {GetAllBannerImagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllBannerImagesSortByEnum} sortBy Field to sort by image text
         * @param {GetAllBannerImagesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by image text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBannerImages(page: number, limit: GetAllBannerImagesLimitEnum, sortBy: GetAllBannerImagesSortByEnum, sortOrder: GetAllBannerImagesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllBannerImagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBannerImages(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllBannerImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all choice groups with optional search and sorting parameters.
         * @summary Get a list of all choice groups
         * @param {number} page Page number (starting from 1)
         * @param {GetAllChoiceGroupsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllChoiceGroupsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllChoiceGroupsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] Filter choice groups by specific store ID
         * @param {GetAllChoiceGroupsStoreTypeEnum} [storeType] Filter choice groups by store type
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChoiceGroups(page: number, limit: GetAllChoiceGroupsLimitEnum, sortBy: GetAllChoiceGroupsSortByEnum, sortOrder: GetAllChoiceGroupsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoiceGroupsStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllChoiceGroupResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChoiceGroups(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllChoiceGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all choices with optional search and sorting parameters.
         * @summary Get a list of all choices
         * @param {number} page Page number (starting from 1)
         * @param {GetAllChoicesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllChoicesSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllChoicesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the merchant to which the choices belong
         * @param {string} [storeId] Filter choices by specific store ID
         * @param {GetAllChoicesStoreTypeEnum} [storeType] Filter choices by store type
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChoices(page: number, limit: GetAllChoicesLimitEnum, sortBy: GetAllChoicesSortByEnum, sortOrder: GetAllChoicesSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoicesStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllChoicesResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChoices(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllChoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
         * @summary Get a list of all cms pages
         * @param {number} page Page number (starting from 1)
         * @param {GetAllCmsPagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllCmsPagesSortByEnum} sortBy Field to sort by (title, createdAt, status)
         * @param {GetAllCmsPagesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by page title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCmsPages(page: number, limit: GetAllCmsPagesLimitEnum, sortBy: GetAllCmsPagesSortByEnum, sortOrder: GetAllCmsPagesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCmsPagesResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCmsPages(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllCmsPages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all types of commission tracking data (merchant, admin merchant, delivery partner) with optional transaction details in a single API call
         * @summary Get unified commission tracking data and transactions
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {GetAllCommissionTrackingRecordTypeEnum} recordType Filter by user type (merchant, admin merchant, delivery partner)
         * @param {GetAllCommissionTrackingSortByEnum} [sortBy] Field to sort by
         * @param {GetAllCommissionTrackingSortOrderEnum} [sortOrder] Sort order (ascending or descending)
         * @param {string} [search] Full-text search on merchant name, restaurant name, email, delivery partner details, transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCommissionTracking(page: number, limit: number, recordType: GetAllCommissionTrackingRecordTypeEnum, sortBy?: GetAllCommissionTrackingSortByEnum, sortOrder?: GetAllCommissionTrackingSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCommissionTracking(page, limit, recordType, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllCommissionTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all coupons with optional search and sorting parameters.
         * @summary Get a list of all coupons
         * @param {number} page Page number (starting from 1)
         * @param {GetAllCouponsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllCouponsSortByEnum} sortBy Field to sort by (coupon name, code, type, validity, start date, status, coupons left)
         * @param {GetAllCouponsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by coupon name, coupon code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCoupons(page: number, limit: GetAllCouponsLimitEnum, sortBy: GetAllCouponsSortByEnum, sortOrder: GetAllCouponsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllCouponsResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCoupons(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllCoupons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all delivery boys with optional search and sorting parameters.
         * @summary Get a list of all delivery boys
         * @param {number} page Page number (starting from 1)
         * @param {GetAllDeliveryBoysLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllDeliveryBoysSortByEnum} sortBy Field to sort by (name, email, mobile number)
         * @param {GetAllDeliveryBoysSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by delivery boy name, delivery boy email, or delivery boy mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDeliveryBoys(page: number, limit: GetAllDeliveryBoysLimitEnum, sortBy: GetAllDeliveryBoysSortByEnum, sortOrder: GetAllDeliveryBoysSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllDeliveryBoysResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDeliveryBoys(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllDeliveryBoys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all delivery managers with optional search and sorting parameters.
         * @summary Get a list of all delivery managers
         * @param {number} page Page number (starting from 1)
         * @param {GetAllDeliveryManagersLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllDeliveryManagersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllDeliveryManagersSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDeliveryManagers(page: number, limit: GetAllDeliveryManagersLimitEnum, sortBy: GetAllDeliveryManagersSortByEnum, sortOrder: GetAllDeliveryManagersSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllDeliveryManagersResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDeliveryManagers(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllDeliveryManagers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
         * @summary Get a list of all cms pages
         * @param {number} page Page number (starting from 1)
         * @param {GetAllFaqsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllFaqsSortByEnum} sortBy Field to sort by question, createdAt, or status
         * @param {GetAllFaqsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by page title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllFaqs(page: number, limit: GetAllFaqsLimitEnum, sortBy: GetAllFaqsSortByEnum, sortOrder: GetAllFaqsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllFaqsResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllFaqs(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllFaqs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all items with optional search and sorting parameters.
         * @summary Get a list of all items with stocks
         * @param {number} page Page number (starting from 1)
         * @param {GetAllItemStocksLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllItemStocksSortByEnum} sortBy Field to sort by product code, item name, restaurant name, merchant name, creaeted at
         * @param {GetAllItemStocksSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the merchant to filter items by
         * @param {string} [search] Search by product code, item name, restaurant name, merchant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllItemStocks(page: number, limit: GetAllItemStocksLimitEnum, sortBy: GetAllItemStocksSortByEnum, sortOrder: GetAllItemStocksSortOrderEnum, merchantId?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllItemsInStockResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllItemStocks(page, limit, sortBy, sortOrder, merchantId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllItemStocks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all items with optional search and sorting parameters.
         * @summary Get a list of all items
         * @param {number} page Page number (starting from 1)
         * @param {GetAllItemsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllItemsSortByEnum} sortBy Field to sort by (name, itemCode, lastLoginDate, lastLogoutDate)
         * @param {GetAllItemsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] Filter items by specific store ID
         * @param {GetAllItemsStoreTypeEnum} [storeType] Filter items by store type
         * @param {string} [search] Search by name, item code, or restaurant name
         * @param {GetAllItemsStockAvailabilityEnum} [stockAvailability] Filter by status
         * @param {GetAllItemsAddedByEnum} [addedBy] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllItems(page: number, limit: GetAllItemsLimitEnum, sortBy: GetAllItemsSortByEnum, sortOrder: GetAllItemsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllItemsStoreTypeEnum, search?: string, stockAvailability?: GetAllItemsStockAvailabilityEnum, addedBy?: GetAllItemsAddedByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllItemsResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllItems(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, stockAvailability, addedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of meals with filtering and sorting options
         * @summary Get all meals
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of meals per page
         * @param {string} [search] Search term for meal name
         * @param {string} [sortBy] Field to sort by
         * @param {GetAllMealsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [storeId] Filter by store ID
         * @param {GetAllMealsStoreTypeEnum} [storeType] Filter by store type
         * @param {GetAllMealsStatusEnum} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMeals(page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetAllMealsSortOrderEnum, storeId?: string, storeType?: GetAllMealsStoreTypeEnum, status?: GetAllMealsStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllMeals200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMeals(page, limit, search, sortBy, sortOrder, storeId, storeType, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllMeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all notifications
         * @param {string} userId ID of the user to fetch notifications for.
         * @param {GetAllNotificationsUserTypeEnum} userType 
         * @param {number} page 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllNotifications(userId: string, userType: GetAllNotificationsUserTypeEnum, page: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllNotifications(userId, userType, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin retrieves all offer coupons with pagination and filtering
         * @summary Get all offers
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetAllOffersSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOffers(page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetAllOffersSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllOffersResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOffers(page, limit, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a comprehensive list of orders with role-based filtering and data access. Response structure varies based on userType using discriminator pattern. 
         * @summary Get unified order details for all user types
         * @param {GetAllOrdersUserTypeEnum} userType Type of user making the request
         * @param {string} [userId] Unique identifier of the user making the request
         * @param {GetAllOrdersLangEnum} [lang] Language code for localized content
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {string} [orderId] Filter by specific order ID (for individual order lookup)
         * @param {string} [storeId] Filter by specific store ID
         * @param {GetAllOrdersStatusEnum} [status] Filter by order status
         * @param {string} [fromDate] Filter orders from this date (YYYY-MM-DD)
         * @param {string} [toDate] Filter orders until this date (YYYY-MM-DD)
         * @param {GetAllOrdersSortByEnum} [sortBy] Field to sort by
         * @param {GetAllOrdersSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Full-text search on customer name, store name, item name, order ID
         * @param {GetAllOrdersOrderModeEnum} [orderMode] Filter by order mode (normal or pre-order)
         * @param {boolean} [requiresManualAssignment] Filter orders that require manual driver assignment (urgent orders, no drivers available)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrders(userType: GetAllOrdersUserTypeEnum, userId?: string, lang?: GetAllOrdersLangEnum, page?: number, limit?: number, orderId?: string, storeId?: string, status?: GetAllOrdersStatusEnum, fromDate?: string, toDate?: string, sortBy?: GetAllOrdersSortByEnum, sortOrder?: GetAllOrdersSortOrderEnum, search?: string, orderMode?: GetAllOrdersOrderModeEnum, requiresManualAssignment?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrders(userType, userId, lang, page, limit, orderId, storeId, status, fromDate, toDate, sortBy, sortOrder, search, orderMode, requiresManualAssignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of restaurant categories with their details.
         * @summary Get a list of restaurant categories
         * @param {GetAllRestaurantCategoriesStoreTypeEnum} storeType The type of store to which the restaurant belongs (Grocery or Restaurant)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRestaurantCategories(storeType: GetAllRestaurantCategoriesStoreTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RestaurantCategoryNames>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRestaurantCategories(storeType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllRestaurantCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all restaurant merchants.
         * @summary Get all restaurant merchants
         * @param {GetAllRestaurantMerchantsStoreTypeEnum} [storeType] Optional filter by store type. If not provided, returns all merchants regardless of store type.
         * @param {string} [search] Search by merchant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllRestaurantMerchants(storeType?: GetAllRestaurantMerchantsStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RestaurantMerchantSchema>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllRestaurantMerchants(storeType, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllRestaurantMerchants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of reviews
         * @summary Get all reviews
         * @param {GetAllReviewsTypeEnum} type type of reviews to fetch
         * @param {string} page Page number for pagination
         * @param {GetAllReviewsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {string} [storeId] The ID of the merchant
         * @param {string} [merchantId] The ID of the merchant
         * @param {string} [search] Search term to filter categories
         * @param {GetAllReviewsStatusEnum} [status] Filter by status
         * @param {GetAllReviewsSortByEnum} [sortBy] Field to sort by
         * @param {GetAllReviewsSortDirectionEnum} [sortDirection] Direction of sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllReviews(type: GetAllReviewsTypeEnum, page: string, limit: GetAllReviewsLimitEnum, storeId?: string, merchantId?: string, search?: string, status?: GetAllReviewsStatusEnum, sortBy?: GetAllReviewsSortByEnum, sortDirection?: GetAllReviewsSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllReviewsResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllReviews(type, page, limit, storeId, merchantId, search, status, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve transactions based on user type with filtering and pagination. Transactions are categorized as: - **toPay**: Amount user needs to pay - **toReceive**: Amount user will receive - **completed**: Completed transactions 
         * @summary Get All Settlements
         * @param {GetAllSettlementsUserTypeEnum} userType Type of user requesting transactions
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {string} [userId] ID of the user. Required for MERCHANT, CUSTOMER, and DELIVERY_PARTNER. Optional for ADMIN (auto-loaded if not provided).
         * @param {GetAllSettlementsTransactionTypeEnum} [transactionType] Filter by transaction category
         * @param {string} [fromDate] Start date for filtering (ISO 8601 format)
         * @param {string} [toDate] End date for filtering (ISO 8601 format)
         * @param {GetAllSettlementsSortByEnum} [sortBy] Sort field
         * @param {GetAllSettlementsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search in description or reference number
         * @param {GetAllSettlementsSettlementUserTypeEnum} [settlementUserType] Filter settlements by user type (MERCHANT, CUSTOMER, or DELIVERY_PARTNER). Use with settlementUserId to filter by specific user.
         * @param {string} [settlementUserId] Filter settlements by specific user ID. Use with settlementUserType to filter by merchantId, customerId, or deliveryPartnerId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSettlements(userType: GetAllSettlementsUserTypeEnum, page: number, limit: number, userId?: string, transactionType?: GetAllSettlementsTransactionTypeEnum, fromDate?: string, toDate?: string, sortBy?: GetAllSettlementsSortByEnum, sortOrder?: GetAllSettlementsSortOrderEnum, search?: string, settlementUserType?: GetAllSettlementsSettlementUserTypeEnum, settlementUserId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettlementsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSettlements(userType, page, limit, userId, transactionType, fromDate, toDate, sortBy, sortOrder, search, settlementUserType, settlementUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllSettlements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of all restaurants with detailed information
         * @param {number} page Page number (starting from 1)
         * @param {GetAllStoresForAdminLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllStoresForAdminSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllStoresForAdminSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetAllStoresForAdminStatusFilterEnum} statusFilter Filter by category status
         * @param {GetAllStoresForAdminAddedByFilterEnum} addedByFilter Filter by who added the restaurant
         * @param {string} [merchantId] 
         * @param {GetAllStoresForAdminStoreTypeEnum} [storeType] Filter stores by type
         * @param {string} [search] Search by restaurant name, merchant name, category, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStoresForAdmin(page: number, limit: GetAllStoresForAdminLimitEnum, sortBy: GetAllStoresForAdminSortByEnum, sortOrder: GetAllStoresForAdminSortOrderEnum, statusFilter: GetAllStoresForAdminStatusFilterEnum, addedByFilter: GetAllStoresForAdminAddedByFilterEnum, merchantId?: string, storeType?: GetAllStoresForAdminStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStoreListResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStoresForAdmin(page, limit, sortBy, sortOrder, statusFilter, addedByFilter, merchantId, storeType, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllStoresForAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of all sub-admins
         * @param {number} page Page number (starting from 1)
         * @param {GetAllSubAdminsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllSubAdminsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllSubAdminsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSubAdmins(page: number, limit: GetAllSubAdminsLimitEnum, sortBy: GetAllSubAdminsSortByEnum, sortOrder: GetAllSubAdminsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllSubAdminsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSubAdmins(page, limit, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllSubAdmins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all subscription plans with optional search, filtering, and sorting.
         * @summary Get a list of all subscription plans
         * @param {number} page Page number (starting from 1)
         * @param {GetAllSubscriptionPlansLimitEnum} limit Number of records per page
         * @param {string} [search] Search by plan name
         * @param {GetAllSubscriptionPlansPlanDurationInEnum} [planDurationIn] Filter by duration unit
         * @param {GetAllSubscriptionPlansStatusEnum} [status] Filter by active status
         * @param {GetAllSubscriptionPlansSortByEnum} [sortBy] Field to sort by
         * @param {GetAllSubscriptionPlansSortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllSubscriptionPlans(page: number, limit: GetAllSubscriptionPlansLimitEnum, search?: string, planDurationIn?: GetAllSubscriptionPlansPlanDurationInEnum, status?: GetAllSubscriptionPlansStatusEnum, sortBy?: GetAllSubscriptionPlansSortByEnum, sortOrder?: GetAllSubscriptionPlansSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllSubscriptionPlans(page, limit, search, planDurationIn, status, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllSubscriptionPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all users with optional search and sorting parameters.
         * @summary Get a list of all users
         * @param {number} page Page number (starting from 1)
         * @param {GetAllUsersLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllUsersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllUsersSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by user name, email, or mobile number
         * @param {GetAllUsersStatusEnum} [status] Filter by status
         * @param {GetAllUsersAddedByEnum} [addedBy] Filter by Added By
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(page: number, limit: GetAllUsersLimitEnum, sortBy: GetAllUsersSortByEnum, sortOrder: GetAllUsersSortOrderEnum, search?: string, status?: GetAllUsersStatusEnum, addedBy?: GetAllUsersAddedByEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllUsersResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(page, limit, sortBy, sortOrder, search, status, addedBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns available coupons for given stores
         * @param {GetAvailableCouponsRequest} getAvailableCouponsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableCoupons(getAvailableCouponsRequest: GetAvailableCouponsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableCouponsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableCoupons(getAvailableCouponsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAvailableCoupons']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin retrieves all active offers that can be assigned to users
         * @summary Get available offers for assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableOffersForAssignment(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAvailableOffersForAssignment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableOffersForAssignment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getAvailableOffersForAssignment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check the status and progress of a background bulk upload job
         * @summary Get status of a bulk upload job
         * @param {string} jobId The unique identifier of the bulk upload job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBulkUploadStatus(jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUploadStatusResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBulkUploadStatus(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getBulkUploadStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all available choice groups based on the selected store type.
         * @summary Get all choice groups
         * @param {string} storeId The ID of the store to which the choice groups belong
         * @param {string} [search] Search by choice group name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChoiceGroups(storeId: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChoiceGroupList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChoiceGroups(storeId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getChoiceGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of all available choices based on the selected store.
         * @summary Get all choices
         * @param {string} storeId The ID of the store to which the choices belong
         * @param {string} [search] Search by choice name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChoicesList(storeId: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChoiceList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChoicesList(storeId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getChoicesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all active CMS pages for customer footer links with language support
         * @summary Get CMS pages for customer display
         * @param {GetCmsPagesForCustomerLangEnum} lang Language code (en, ar)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCmsPagesForCustomer(lang: GetCmsPagesForCustomerLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCmsPagesResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCmsPagesForCustomer(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCmsPagesForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the configuration settings for the end user.
         * @summary Get Configuration Settings
         * @param {GetConfigurationSettingsLanguageEnum} [language] Language filter for the configuration settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurationSettings(language?: GetConfigurationSettingsLanguageEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConfigurationSettings>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurationSettings(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getConfigurationSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Customer User Details (Mobile)
         * @param {string} userId The ID of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerDetailsSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin retrieves detailed loyalty points history for a specific customer
         * @summary Get customer loyalty history
         * @param {string} userId 
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerLoyaltyHistory(userId: string, page: number, limit: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomerLoyaltyHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerLoyaltyHistory(userId, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomerLoyaltyHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin retrieves customer list with orders, wallet, loyalty, and offers data
         * @summary Get customers with full details
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetCustomersDetailsForOffersSortOrderEnum} [sortOrder] 
         * @param {GetCustomersDetailsForOffersStatusEnum} [status] 
         * @param {GetCustomersDetailsForOffersCustomerTypeEnum} [customerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersDetailsForOffers(page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetCustomersDetailsForOffersSortOrderEnum, status?: GetCustomersDetailsForOffersStatusEnum, customerType?: GetCustomersDetailsForOffersCustomerTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCustomersDetailsForOffers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersDetailsForOffers(page, limit, search, sortBy, sortOrder, status, customerType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomersDetailsForOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of all customers with their wallet information including balance, transaction history, and management actions.
         * @summary Get all customers with wallet details for admin panel
         * @param {number} page Page number (starting from 1)
         * @param {GetCustomersWithWalletDetailsLimitEnum} limit Number of records per page
         * @param {string} [search] Search by customer name, email, or phone number
         * @param {GetCustomersWithWalletDetailsSortByEnum} [sortBy] Field to sort by
         * @param {GetCustomersWithWalletDetailsSortOrderEnum} [sortOrder] Sort order
         * @param {GetCustomersWithWalletDetailsCustomerStatusEnum} [customerStatus] Filter by customer status
         * @param {GetCustomersWithWalletDetailsTransactionTypeEnum} [transactionType] Filter by recent transaction type
         * @param {string} [dateFrom] Filter transactions from this date (YYYY-MM-DD)
         * @param {string} [dateTo] Filter transactions to this date (YYYY-MM-DD)
         * @param {number} [transactionLimit] Number of recent transactions to return per customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomersWithWalletDetails(page: number, limit: GetCustomersWithWalletDetailsLimitEnum, search?: string, sortBy?: GetCustomersWithWalletDetailsSortByEnum, sortOrder?: GetCustomersWithWalletDetailsSortOrderEnum, customerStatus?: GetCustomersWithWalletDetailsCustomerStatusEnum, transactionType?: GetCustomersWithWalletDetailsTransactionTypeEnum, dateFrom?: string, dateTo?: string, transactionLimit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerWalletListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomersWithWalletDetails(page, limit, search, sortBy, sortOrder, customerStatus, transactionType, dateFrom, dateTo, transactionLimit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getCustomersWithWalletDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns consolidated dashboard data with metrics, charts, and recent entries.
         * @param {GetDashboardMetricsDashboardTypeEnum} dashboardType Type of dashboard to retrieve (admin or merchant).
         * @param {string} fromDate Start date for dashboard data (inclusive, format YYYY-MM-DD).
         * @param {string} toDate End date for dashboard data (inclusive, format YYYY-MM-DD).
         * @param {string} [merchantId] Merchant ID for merchant-specific dashboards (required if dashboardType is merchant).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardMetrics(dashboardType: GetDashboardMetricsDashboardTypeEnum, fromDate: string, toDate: string, merchantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardMetrics(dashboardType, fromDate, toDate, merchantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getDashboardMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all active FAQs for customer landing page with language support
         * @summary Get FAQs for customer display
         * @param {GetFaqsForCustomerLangEnum} lang Language code (en, ar)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFaqsForCustomer(lang: GetFaqsForCustomerLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerFaqsResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFaqsForCustomer(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFaqsForCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all featured store subscriptions for a merchant with optional filters
         * @summary Get featured store subscriptions
         * @param {string} merchantId Merchant ID to filter subscriptions
         * @param {string} [storeId] Optional store ID to filter subscriptions for a specific store
         * @param {GetFeaturedStoreSubscriptionsStatusEnum} [status] Optional status filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeaturedStoreSubscriptions(merchantId: string, storeId?: string, status?: GetFeaturedStoreSubscriptionsStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFeaturedStoreSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeaturedStoreSubscriptions(merchantId, storeId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getFeaturedStoreSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns banners, filters, dynamic categories, and nearby/explore stores based on user location and store type.
         * @summary Get Home Page Data
         * @param {string} userId 
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {GetHomePageDataForUserAppStoreTypeEnum} [storeType] 
         * @param {string} [search] 
         * @param {GetHomePageDataForUserAppSortByEnum} [sortBy] 
         * @param {GetHomePageDataForUserAppOffersEnum} [offers] 
         * @param {string} [cuisines] Filter stores by cuisine types. This is a dynamic filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHomePageDataForUserApp(userId: string, latitude: number, longitude: number, storeType?: GetHomePageDataForUserAppStoreTypeEnum, search?: string, sortBy?: GetHomePageDataForUserAppSortByEnum, offers?: GetHomePageDataForUserAppOffersEnum, cuisines?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomePageResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHomePageDataForUserApp(userId, latitude, longitude, storeType, search, sortBy, offers, cuisines, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getHomePageDataForUserApp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all item categories
         * @param {number} page Page number (starting from 1)
         * @param {GetItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
         * @param {GetItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetItemCategoriesStatusFilterEnum} statusFilter Filter by category status
         * @param {GetItemCategoriesAddedByFilterEnum} addedByFilter Filter by category status
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] The ID of the store to which the item category belongs
         * @param {GetItemCategoriesStoreTypeEnum} [storeType] Filter item categories by store type
         * @param {string} [search] Search by category name (English or Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemCategories(page: number, limit: GetItemCategoriesLimitEnum, sortBy: GetItemCategoriesSortByEnum, sortOrder: GetItemCategoriesSortOrderEnum, statusFilter: GetItemCategoriesStatusFilterEnum, addedByFilter: GetItemCategoriesAddedByFilterEnum, merchantId?: string, storeId?: string, storeType?: GetItemCategoriesStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetItemCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemCategories(page, limit, sortBy, sortOrder, statusFilter, addedByFilter, merchantId, storeId, storeType, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getItemCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve user\'s loyalty points balance, earned history, redeemed history, and potential wallet credit
         * @summary Get user loyalty points and history
         * @param {string} userId The ID of the user
         * @param {GetLoyaltyPointsLangEnum} lang Language code for transaction descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoyaltyPoints(userId: string, lang: GetLoyaltyPointsLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLoyaltyPointsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoyaltyPoints(userId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getLoyaltyPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get list of merchants
         * @param {number} page 
         * @param {number} limit 
         * @param {GetMerchantsStoreTypeEnum} [storeType] Filter merchants by business type
         * @param {string} [search] 
         * @param {GetMerchantsSortByEnum} [sortBy] 
         * @param {GetMerchantsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchants(page: number, limit: number, storeType?: GetMerchantsStoreTypeEnum, search?: string, sortBy?: GetMerchantsSortByEnum, sortOrder?: GetMerchantsSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantListSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchants(page, limit, storeType, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getMerchants']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of subscribers with optional search and sorting.
         * @summary Get list of subscribers
         * @param {number} page Page number (starts from 1)
         * @param {GetNewsletterSubscribersLimitEnum} limit Number of records per page
         * @param {string} [search] Search by email
         * @param {GetNewsletterSubscribersStatusEnum} [status] 
         * @param {GetNewsletterSubscribersSortByEnum} [sortBy] Field to sort by
         * @param {GetNewsletterSubscribersSortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsletterSubscribers(page: number, limit: GetNewsletterSubscribersLimitEnum, search?: string, status?: GetNewsletterSubscribersStatusEnum, sortBy?: GetNewsletterSubscribersSortByEnum, sortOrder?: GetNewsletterSubscribersSortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAllNewsletterSubscribersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsletterSubscribers(page, limit, search, status, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getNewsletterSubscribers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves complete real-time tracking information for multi-store orders including store-level status, delivery partner info, timeline, items, refunds, and billing details
         * @summary Get comprehensive order tracking details
         * @param {string} orderId Unique identifier for the order (ObjectId or Order Number format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderTracking(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderTrackingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderTracking(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getOrderTracking']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns list of active payment gateways with supported currencies
         * @summary Get available payment gateways
         * @param {string} [currency] Optional currency code to filter gateways by support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPaymentGateways(currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentGatewaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPaymentGateways(currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPaymentGateways']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns only public-facing settings without credentials or sensitive data
         * @summary Get public settings for mobile/web clients
         * @param {GetPublicSettingsLangEnum} [lang] Language code for multilingual content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicSettings(lang?: GetPublicSettingsLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicSettings(lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getPublicSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve paginated referral report with search, sort, and filter capabilities for admin panel
         * @summary Get referral report for admin panel
         * @param {number} page Page number for pagination (default 1)
         * @param {number} limit Number of items per page (default 10, max 100)
         * @param {string} [search] Search term to filter by referrer name, referral code, or used user name
         * @param {GetReferralReportSortByEnum} [sortBy] Field to sort by
         * @param {GetReferralReportSortOrderEnum} [sortOrder] Sort order
         * @param {GetReferralReportStatusEnum} [status] Filter by referral status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralReport(page: number, limit: number, search?: string, sortBy?: GetReferralReportSortByEnum, sortOrder?: GetReferralReportSortOrderEnum, status?: GetReferralReportStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralReport(page, limit, search, sortBy, sortOrder, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getReferralReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of restaurant categories
         * @summary Get all restaurant categories
         * @param {string} page Page number for pagination
         * @param {string} limit Number of items per page
         * @param {GetRestaurantCategoriesStoreTypeEnum} [storeType] Filter store categories by type
         * @param {string} [search] Search term to filter categories
         * @param {GetRestaurantCategoriesStatusEnum} [status] Filter by status
         * @param {GetRestaurantCategoriesSortByEnum} [sortBy] Field to sort by
         * @param {GetRestaurantCategoriesSortDirectionEnum} [sortDirection] Direction of sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRestaurantCategories(page: string, limit: string, storeType?: GetRestaurantCategoriesStoreTypeEnum, search?: string, status?: GetRestaurantCategoriesStatusEnum, sortBy?: GetRestaurantCategoriesSortByEnum, sortDirection?: GetRestaurantCategoriesSortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestaurantCategoryList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRestaurantCategories(page, limit, storeType, search, status, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getRestaurantCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of review suggestion strings that can be shown in the UI.
         * @summary Get all review suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewSuggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReviewSuggestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewSuggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getReviewSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Web User Details (Admin & Merchant)
         * @param {string} userId The ID of the user making the request.
         * @param {GetSpecialUserDetailsUserTypeEnum} userType The platform type of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpecialUserDetails(userId: string, userType: GetSpecialUserDetailsUserTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpecialUserDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpecialUserDetails(userId, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSpecialUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches detailed information about a store by its ID, including type-specific fields for display on mobile screens.
         * @summary Retrieve Store Details
         * @param {string} storeId The unique identifier of the store
         * @param {string} userId The unique identifier of the user (optional, for personalized data)
         * @param {GetStoreDetailsLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoreDetails(storeId: string, userId: string, lang: GetStoreDetailsLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WritableStoreDataSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreDetails(storeId, userId, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStoreDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches items available in the store (e.g., food for Restaurant, products for Grocery/Pharmacy) with optional filtering.
         * @summary Retrieve Store Items
         * @param {string} storeId The unique identifier of the store
         * @param {GetStoreMenuLanguageEnum} language 
         * @param {string} userId The unique identifier of the user (optional, for personalized data)
         * @param {string} [category] Filter items by category (e.g., Popular, Paratha)
         * @param {string} [search] Search term to filter items by name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoreMenu(storeId: string, language: GetStoreMenuLanguageEnum, userId: string, category?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<StoreItem>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreMenu(storeId, language, userId, category, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStoreMenu']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of stores. If merchantId is provided, returns stores for that specific merchant. If not provided, returns all stores.
         * @summary Get stores list
         * @param {string} [merchantId] Optional filter by merchant ID. If not provided, returns all stores.
         * @param {string} [search] Search by store name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoresListByMerchant(merchantId?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MerchantStore>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoresListByMerchant(merchantId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getStoresListByMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all sub-item categories
         * @param {string} parentCategoryId ID of the parent category to filter subcategories
         * @param {number} page Page number (starting from 1)
         * @param {GetSubItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetSubItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
         * @param {GetSubItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetSubItemCategoriesStatusFilterEnum} statusFilter Filter by subcategory status
         * @param {GetSubItemCategoriesAddedByFilterEnum} addedByFilter Filter by who added the subcategory
         * @param {string} [search] Search by subcategory name (English or Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubItemCategories(parentCategoryId: string, page: number, limit: GetSubItemCategoriesLimitEnum, sortBy: GetSubItemCategoriesSortByEnum, sortOrder: GetSubItemCategoriesSortOrderEnum, statusFilter: GetSubItemCategoriesStatusFilterEnum, addedByFilter: GetSubItemCategoriesAddedByFilterEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSubItemCategories200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubItemCategories(parentCategoryId, page, limit, sortBy, sortOrder, statusFilter, addedByFilter, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getSubItemCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve tip status and details for a specific order
         * @summary Get tip status for an order
         * @param {string} userId The ID of the user
         * @param {string} orderId The order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTipStatus(userId: string, orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TipStatusResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTipStatus(userId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getTipStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the complete cart with all items grouped by store
         * @summary Get user\'s complete cart
         * @param {string} userId User identifier
         * @param {GetUserCartStoreTypeEnum} storeType Store type to filter items by store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCart(userId: string, storeType: GetUserCartStoreTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserCart200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCart(userId, storeType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserCart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves user details necessary for the checkout process, including delivery address and contact information.
         * @summary Get user details required for checkout
         * @param {string} userId User ID to retrieve details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserCheckoutDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerCheckoutDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserCheckoutDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserCheckoutDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all reviews submitted by the authenticated user with filtering, sorting, and pagination options.
         * @summary Get user\'s review history
         * @param {string} userId User ID to fetch reviews for
         * @param {number} [page] Page number for pagination
         * @param {GetUserReviewsLimitEnum} [limit] Number of reviews per page
         * @param {GetUserReviewsTypeEnum} [type] Filter reviews by type (All returns all review types)
         * @param {string} [startDate] Filter reviews created on or after this date
         * @param {string} [endDate] Filter reviews created on or before this date
         * @param {GetUserReviewsRatingEnum} [rating] Filter reviews by specific rating
         * @param {GetUserReviewsSortByEnum} [sortBy] Field to sort by
         * @param {GetUserReviewsSortDirectionEnum} [sortDirection] Sort direction
         * @param {GetUserReviewsLangEnum} [lang] Language code for multilingual fields (itemName, storeName)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserReviews(userId: string, page?: number, limit?: GetUserReviewsLimitEnum, type?: GetUserReviewsTypeEnum, startDate?: string, endDate?: string, rating?: GetUserReviewsRatingEnum, sortBy?: GetUserReviewsSortByEnum, sortDirection?: GetUserReviewsSortDirectionEnum, lang?: GetUserReviewsLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyReviewsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserReviews(userId, page, limit, type, startDate, endDate, rating, sortBy, sortDirection, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the complete wishList with all items grouped by store
         * @summary Get user\'s complete wishList
         * @param {string} userId User identifier
         * @param {GetUserWishListStoreTypeEnum} storeType Store type to filter items by store.
         * @param {GetUserWishListLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserWishList(userId: string, storeType: GetUserWishListStoreTypeEnum, lang: GetUserWishListLangEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserWishListResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserWishList(userId, storeType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getUserWishList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get wallet balance for checkout
         * @param {string} userId The ID of the user
         * @param {number} totalAmount Total checkout amount to compare with wallet balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWalletCheckoutBalance(userId: string, totalAmount: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WalletCheckoutBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletCheckoutBalance(userId, totalAmount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getWalletCheckoutBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the current wallet balance for the user
         * @param {string} userId The ID of the user whose wallet details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWalletDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWalletDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.getWalletDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receives payment events from Hyperpay
         * @summary Hyperpay webhook endpoint
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hyperpayWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hyperpayWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.hyperpayWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate payment for one or more pending settlements using a payment gateway. User can select multiple settlements and pay them all at once in a single transaction. 
         * @summary Initiate bulk settlement payment
         * @param {InitiateSettlementPaymentRequest} initiateSettlementPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateSettlementPayment(initiateSettlementPaymentRequest: InitiateSettlementPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InitiateSettlementPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateSettlementPayment(initiateSettlementPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.initiateSettlementPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate a tip payment for a delivered order through payment gateway
         * @summary Initiate tip payment
         * @param {TipInitiateRequestSchema} tipInitiateRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateTipPayment(tipInitiateRequestSchema: TipInitiateRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TipInitiateResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateTipPayment(tipInitiateRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.initiateTipPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of customers that can be selected for sending newsletters.
         * @summary List all customers
         * @param {string} [search] Search by customer name, phone or email
         * @param {ListCustomersUserTypeEnum} [userType] Filter by user type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCustomers(search?: string, userType?: ListCustomersUserTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCustomers(search, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.listCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Log in a user (traditional or social)
         * @param {LoginUserRequest} [loginUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginUser(loginUserRequest?: LoginUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginUser(loginUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.loginUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Apply or remove a coupon during checkout
         * @param {ManageCouponRequest} manageCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageCoupon(manageCouponRequest: ManageCouponRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManageCouponResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageCoupon(manageCouponRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.manageCoupon']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks a specific notification as read for the authenticated user.
         * @summary Mark a notification as read
         * @param {MarkNotificationAsReadRequest} markNotificationAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsRead(markNotificationAsReadRequest: MarkNotificationAsReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsRead(markNotificationAsReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.markNotificationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates cart items, store capabilities, working hours, and calculates accurate order summary based on delivery mode (selfPickup/delivery) and order mode (normal/preOrder). This API sits between cart and checkout to provide comprehensive validations. 
         * @summary Prepare order with delivery mode and order type validations
         * @param {string} userId The ID of the user
         * @param {PrepareOrderLangEnum} lang Language preference for localized data (English or Arabic)
         * @param {PrepareOrderRequestSchema} prepareOrderRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async prepareOrder(userId: string, lang: PrepareOrderLangEnum, prepareOrderRequestSchema: PrepareOrderRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareOrderResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.prepareOrder(userId, lang, prepareOrderRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.prepareOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiate payment to feature a store for a specific period
         * @summary Purchase featured store subscription
         * @param {PurchaseFeaturedStoreRequest} purchaseFeaturedStoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purchaseFeaturedStore(purchaseFeaturedStoreRequest: PurchaseFeaturedStoreRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseFeaturedStoreResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purchaseFeaturedStore(purchaseFeaturedStoreRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.purchaseFeaturedStore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Convert available loyalty points to wallet credit based on configured redemption rate
         * @summary Redeem loyalty points to wallet credit
         * @param {RedeemPointsRequest} redeemPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeemPoints(redeemPointsRequest: RedeemPointsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeemPointsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeemPoints(redeemPointsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.redeemPoints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a new access token using a refresh token
         * @summary Refresh access token
         * @param {RefreshTokenRequestSchema} refreshTokenRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(refreshTokenRequestSchema: RefreshTokenRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resend the OTP to the user\'s email or phone number
         * @summary Resend OTP
         * @param {OtpRequest} otpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendOtp(otpRequest: OtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendOtp(otpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.resendOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset a user\'s password using a token
         * @summary Reset password
         * @param {ResetPasswordRequestSchema} resetPasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequestSchema: ResetPasswordRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search Delivery Boys by filter
         * @param {string} [name] Partial or full name of the delivery boy
         * @param {number} [latitude] Latitude coordinate
         * @param {number} [longitude] Longitude coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDeliveryBoys(name?: string, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeliveryBoyWithLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDeliveryBoys(name, latitude, longitude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.searchDeliveryBoys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a newsletter email to all users, particular users, all subscribers, or particular subscribers.
         * @summary Send newsletter to selected audience
         * @param {SendNewsletterRequest} sendNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNewsletter(sendNewsletterRequest: SendNewsletterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNewsletter(sendNewsletterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a push notification to users or delivery personnel based on the selected type and recipient.
         * @summary Send push notification
         * @param {SendPushNotificationRequest} sendPushNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPushNotification(sendPushNotificationRequest: SendPushNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPushNotification(sendPushNotificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendPushNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint sends a referral email to the specified user with the provided referral code.
         * @summary Send referral email to a user
         * @param {SendReferralEmailRequest} sendReferralEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendReferralEmail(sendReferralEmailRequest: SendReferralEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendReferralEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendReferralEmail(sendReferralEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.sendReferralEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register a new user (traditional or social)
         * @param {SignupUserRequest} signupUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signupUser(signupUserRequest: SignupUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignupSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signupUser(signupUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.signupUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authenticates special users using either email or mobile number and returns role-specific user details
         * @summary Login for Special Users (SuperAdmin, SubAdmin, Merchant)
         * @param {SpecialUserLoginRequestSchema} specialUserLoginRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialUserLogin(specialUserLoginRequestSchema: SpecialUserLoginRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialUserLogin(specialUserLoginRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.specialUserLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Receives payment events from Stripe
         * @summary Stripe webhook endpoint
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeWebhook(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeWebhook(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.stripeWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows website visitors to subscribe to the newsletter. Public endpoint without authentication.
         * @summary Subscribe to newsletter from customer website
         * @param {SubscribeToNewsletterRequest} subscribeToNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeToNewsletter(subscribeToNewsletterRequest: SubscribeToNewsletterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeToNewsletter(subscribeToNewsletterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.subscribeToNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle the status of multiple banner images by their IDs.
         * @summary Toggle status (blocked/unblocked) for multiple banner images
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleBannerImageStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleBannerImageStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleBannerImageStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple choice groups
         * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleChoiceGroupStatus(toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleChoiceGroupStatus(toggleChoiceStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleChoiceGroupStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple choices
         * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleChoiceStatus(toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleChoiceStatus(toggleChoiceStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleChoiceStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle the status of multiple cms pages by their IDs. This operation allows you to block or unblock multiple cms pages at once.
         * @summary Toggle status (blocked/unblocked) for multiple cms pages
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleCmsPagesStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleCmsPagesStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleCmsPagesStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple coupons
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleCouponStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleCouponStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleCouponStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple delivery boys
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleDeliveryBoyStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleDeliveryBoyStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleDeliveryBoyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple delivery managers
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleDeliveryManagerStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleDeliveryManagerStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleDeliveryManagerStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle the status of multiple faqs by their IDs. This operation allows you to block or unblock multiple faqs at once.
         * @summary Toggle status (blocked/unblocked) for multiple faqs
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleFaqsStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleFaqsStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleFaqsStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple categories
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleItemCategoriesStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleItemCategoriesStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleItemCategoriesStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Toggle the status of multiple items by their IDs. This operation allows you to block or unblock multiple items at once.
         * @summary Toggle status (blocked/unblocked) for multiple items
         * @param {ToggleItemStatusRequest} toggleItemStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleItemStatus(toggleItemStatusRequest: ToggleItemStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleItemStatus(toggleItemStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleItemStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Block or unblock a merchant
         * @param {string} merchantId 
         * @param {ToggleMerchantActiveStatusRequest} toggleMerchantActiveStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleMerchantActiveStatus(merchantId: string, toggleMerchantActiveStatusRequest: ToggleMerchantActiveStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleMerchantActiveStatus(merchantId, toggleMerchantActiveStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleMerchantActiveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle subscription status (subscribe/unsubscribe) of subscribers
         * @param {ToggleNewletterSubscriberStatusRequest} toggleNewletterSubscriberStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleNewletterSubscriberStatus(toggleNewletterSubscriberStatusRequest: ToggleNewletterSubscriberStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleNewletterSubscriberStatus(toggleNewletterSubscriberStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleNewletterSubscriberStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin blocks or unblocks offers
         * @summary Toggle offer status
         * @param {ToggleOfferStatusRequestSchema} toggleOfferStatusRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleOfferStatus(toggleOfferStatusRequestSchema: ToggleOfferStatusRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleOfferStatus(toggleOfferStatusRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleOfferStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint toggles the approval status of multiple reviews based on the provided IDs and status.
         * @summary Toggle status for multiple reviews
         * @param {ToggleReviewApprovalStatusRequest} toggleReviewApprovalStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleReviewApprovalStatus(toggleReviewApprovalStatusRequest: ToggleReviewApprovalStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleReviewApprovalStatus(toggleReviewApprovalStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleReviewApprovalStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple stores
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleStoreStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleStoreStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleStoreStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple sub-admins
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleSubAdminStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleSubAdminStatus(toggleSubAdminStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleSubAdminStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle the status of multiple sub-item categories
         * @param {ToggleSubCategoryStatusRequest} toggleSubCategoryStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleSubCategoryStatus(toggleSubCategoryStatusRequest: ToggleSubCategoryStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleSubCategoryStatus(toggleSubCategoryStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleSubCategoryStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Toggle status (active/inactive) for multiple subscription plans
         * @param {ToggleSubscriptionPlanStatusRequest} toggleSubscriptionPlanStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleSubscriptionPlanStatus(toggleSubscriptionPlanStatusRequest: ToggleSubscriptionPlanStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleSubscriptionPlanStatus(toggleSubscriptionPlanStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleSubscriptionPlanStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint toggles the status of multiple users based on the provided IDs and status.
         * @summary Toggle status (blocked/unblocked) for multiple users
         * @param {ToggleUserStatusRequest} toggleUserStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleUserStatus(toggleUserStatusRequest: ToggleUserStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleUserStatus(toggleUserStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.toggleUserStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a new delivery boy
         * @param {string} deliveryBoyId The ID of the delivery boy to be updated
         * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeliveryBoy(deliveryBoyId: string, addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeliveryBoy(deliveryBoyId, addOrEditDeliveryBoyRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateDeliveryBoy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit an existing item in the system
         * @summary Edit an existing item
         * @param {string} itemId The ID of the item to be updated
         * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItem(itemId: string, addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateItem(itemId, addOrEditItemRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update stock of an item
         * @param {string} itemId The ID of the item to be updated
         * @param {UpdateItemStockRequestSchema} updateItemStockRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateItemStock(itemId: string, updateItemStockRequestSchema: UpdateItemStockRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateItemStock(itemId, updateItemStockRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateItemStock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update merchant by ID
         * @param {string} merchantId 
         * @param {MerchantSchema} merchantSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchant(merchantId: string, merchantSchema: MerchantSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchant(merchantId, merchantSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateMerchant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Allows updating the status of an order (e.g., cancel, accept, dispatch, deliver, etc.)
         * @summary Update order status
         * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderStatus(updateOrderStatusRequest: UpdateOrderStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderStatus(updateOrderStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateOrderStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing restaurant category
         * @summary Update category
         * @param {string} categoryId Category ID
         * @param {UpdateRestaurantCategoryRequest} updateRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRestaurantCategory(categoryId: string, updateRestaurantCategoryRequest: UpdateRestaurantCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRestaurantCategory(categoryId, updateRestaurantCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateRestaurantCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user\'s wallet by crediting or deducting an amount
         * @param {UpdateWalletRequest} updateWalletRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWallet(updateWalletRequest: UpdateWalletRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateWalletResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWallet(updateWalletRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.updateWallet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify payment status and activate featured store subscription
         * @summary Verify featured store payment
         * @param {VerifyFeaturedPaymentRequest} verifyFeaturedPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyFeaturedPayment(verifyFeaturedPaymentRequest: VerifyFeaturedPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyFeaturedPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyFeaturedPayment(verifyFeaturedPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyFeaturedPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verifies OTP for user (email or phone)
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyOtp(verifyOtpRequest: VerifyOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VefiryOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp(verifyOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify payment status after user returns from payment gateway and create order if successful
         * @summary Verify payment and create order
         * @param {string} userId The ID of the user
         * @param {VerifyPaymentRequest} verifyPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyPayment(userId: string, verifyPaymentRequest: VerifyPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPayment(userId, verifyPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint verifies if a referral code is valid and available for use. It only checks validation without consuming the code.
         * @summary Verify a referral code
         * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyReferralCode(verifyReferralCodeRequest: VerifyReferralCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyReferralCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyReferralCode(verifyReferralCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyReferralCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify the status of a settlement payment after user completes payment via gateway. Updates all settlements in the payment based on gateway response. 
         * @summary Verify settlement payment status
         * @param {VerifySettlementPaymentRequest} verifySettlementPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifySettlementPayment(verifySettlementPaymentRequest: VerifySettlementPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifySettlementPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifySettlementPayment(verifySettlementPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifySettlementPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify tip payment status after user completes payment
         * @summary Verify tip payment
         * @param {TipVerifyRequestSchema} tipVerifyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTipPayment(tipVerifyRequestSchema: TipVerifyRequestSchema, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TipVerifyResponseSchema>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTipPayment(tipVerifyRequestSchema, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyTipPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify wallet payment after gateway redirect
         * @param {VerifyWalletPaymentRequest} verifyWalletPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyWalletPayment(verifyWalletPaymentRequest: VerifyWalletPaymentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyWalletPaymentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyWalletPayment(verifyWalletPaymentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.verifyWalletPayment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Set banner image for the end user
         * @summary Set banner image for the end user
         * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBannerImageSettings(dynamicHomePageContentSettings: DynamicHomePageContentSettings, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addBannerImageSettings(dynamicHomePageContentSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new choice to the system
         * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChoice(addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addChoice(addOrEditChoiceRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new choice to the system
         * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addChoiceGroup(addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addChoiceGroup(addOrUpdateChoiceGroupRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new CMS page to the system
         * @summary Add a new CMS page
         * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCmsPage(addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addCmsPage(addOrEditCmsPageRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Set configuration settings for the end user
         * @summary Set configuration settings for the end user
         * @param {ConfigurationSettings} configurationSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addConfigurationSettings(configurationSettings: ConfigurationSettings, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addConfigurationSettings(configurationSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new coupon to the system
         * @summary Add a new coupon
         * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCoupon(addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addCoupon(addOrEditCouponRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new delivery boy
         * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryBoy(addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addDeliveryBoy(addOrEditDeliveryBoyRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new delivery manager to the system
         * @summary Add a new delivery manager
         * @param {AddDeliveryManagerRequestSchema} addDeliveryManagerRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDeliveryManager(addDeliveryManagerRequestSchema: AddDeliveryManagerRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addDeliveryManager(addDeliveryManagerRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new faq to the system
         * @summary Add a new Faq
         * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFaq(addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addFaq(addOrEditFaqRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new item
         * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItem(addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addItem(addOrEditItemRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new item category
         * @param {CreateItemCategoryRequest} createItemCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemCategory(createItemCategoryRequest: CreateItemCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addItemCategory(createItemCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new item subcategory
         * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemSubCategory(createItemSubCategoryRequest: CreateItemSubCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addItemSubCategory(createItemSubCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new meal for a store with items and choice groups
         * @summary Add a new meal
         * @param {AddMealRequest} addMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMeal(addMealRequest: AddMealRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseSchema> {
            return localVarFp.addMeal(addMealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin creates a new offer coupon
         * @summary Create a new offer
         * @param {AddOfferRequestSchema} addOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOffer(addOfferRequestSchema: AddOfferRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addOffer(addOfferRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a new subscription plan if `id` is not provided. If `id` is present, updates the existing subscription plan.
         * @summary Add or edit a subscription plan
         * @param {SubscriptionPlan} subscriptionPlan 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrEditSubscriptionPlan(subscriptionPlan: SubscriptionPlan, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addOrEditSubscriptionPlan(subscriptionPlan, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a specified item to the user\'s cart
         * @summary Add an item to the Cart
         * @param {string} userId User identifier
         * @param {AddOrUpdateCartRequestSchema} addOrUpdateCartRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateCart(userId: string, addOrUpdateCartRequestSchema: AddOrUpdateCartRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<AddOrUpdateCartResponseSchema> {
            return localVarFp.addOrUpdateCart(userId, addOrUpdateCartRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers or updates the FCM token for a user, allowing them to receive push notifications.
         * @summary Add or update device ID for push notifications
         * @param {AddOrUpdateDeviceIdRequest} addOrUpdateDeviceIdRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateDeviceId(addOrUpdateDeviceIdRequest: AddOrUpdateDeviceIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addOrUpdateDeviceId(addOrUpdateDeviceIdRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a specified item to the user\'s wishList
         * @summary Add or update an item to the wishList
         * @param {AddOrUpdateWishListRequestSchema} addOrUpdateWishListRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrUpdateUserWishList(addOrUpdateWishListRequestSchema: AddOrUpdateWishListRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addOrUpdateUserWishList(addOrUpdateWishListRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows a customer to submit a detailed review for a completed order, including: - App experience - Store rating - Delivery partner rating - Individual item ratings - Issues faced - Optional comments 
         * @summary Submit a review for an order
         * @param {AddReviewRequest} addReviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderReview(addReviewRequest: AddReviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addOrderReview(addReviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a new store to the system
         * @param {WritableStoreDataSchema} writableStoreDataSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStore(writableStoreDataSchema: WritableStoreDataSchema, options?: RawAxiosRequestConfig): AxiosPromise<AddStore201Response> {
            return localVarFp.addStore(writableStoreDataSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint adds a new address for a user.
         * @summary Add a new user address
         * @param {UserAddressSchema} userAddressSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserAddress(userAddressSchema: UserAddressSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addUserAddress(userAddressSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds a new notification for a user and updates the notification count.
         * @summary Add a user notification and update count
         * @param {AddUserNotificationRequest} addUserNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserNotificationAndUpdateCount(addUserNotificationRequest: AddUserNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.addUserNotificationAndUpdateCount(addUserNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows admin to assign a driver to an order either manually (by specifying driver ID) or automatically (system finds nearest available driver). The API updates order audits, notifies the driver, and optionally notifies the customer if driver is changed. 
         * @summary Admin assign driver to order manually or automatically
         * @param {AdminAssignDriverRequestSchema} adminAssignDriverRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAssignDriver(adminAssignDriverRequestSchema: AdminAssignDriverRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<AdminAssignDriverResponseSchema> {
            return localVarFp.adminAssignDriver(adminAssignDriverRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin assigns specific offers to a user
         * @summary Assign offers to customer
         * @param {AssignOfferRequestSchema} assignOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignOffer(assignOfferRequestSchema: AssignOfferRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.assignOffer(assignOfferRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Block or Unblock a restaurant category
         * @summary Block or Unblock restaurant category
         * @param {string} categoryId Category ID
         * @param {BlockOrUnblockRestaurantCategoryRequest} blockOrUnblockRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockOrUnblockRestaurantCategory(categoryId: string, blockOrUnblockRestaurantCategoryRequest: BlockOrUnblockRestaurantCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.blockOrUnblockRestaurantCategory(categoryId, blockOrUnblockRestaurantCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload multiple items at once using Excel (.xlsx) or CSV (.csv) file. Files with 50 or fewer rows are processed synchronously, while larger files are processed in the background.
         * @summary Bulk upload items from Excel or CSV file
         * @param {string} storeId The ID of the store for which items are being uploaded
         * @param {BulkUploadItemAddedByEnum} addedBy Who is adding the items (Admin or Merchant)
         * @param {File} file Excel (.xlsx) or CSV (.csv) file containing items to upload
         * @param {string} [merchantId] The ID of the merchant (required for merchant users, optional for admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadItem(storeId: string, addedBy: BulkUploadItemAddedByEnum, file: File, merchantId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkUploadResponseSchema> {
            return localVarFp.bulkUploadItem(storeId, addedBy, file, merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculate the total price for featuring a store based on date range and configured pricing
         * @summary Calculate featured store pricing
         * @param {CalculateFeaturedPriceRequest} calculateFeaturedPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateFeaturedPrice(calculateFeaturedPriceRequest: CalculateFeaturedPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CalculateFeaturedPriceResponse> {
            return localVarFp.calculateFeaturedPrice(calculateFeaturedPriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint allows a user to change their password.
         * @summary Change user password
         * @param {string} userId The ID of the user whose password is being changed
         * @param {ChangeUserPasswordUserTypeEnum} userType The type of user (e.g., customer, admin, subAdmin, merchant, deliveryPartner)
         * @param {ChangePasswordRequestSchema} changePasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserPassword(userId: string, userType: ChangeUserPasswordUserTypeEnum, changePasswordRequestSchema: ChangePasswordRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.changeUserPassword(userId, userType, changePasswordRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a user exists based on userName, email, or phone
         * @param {CheckUserExistsRequest} checkUserExistsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkUserExists(checkUserExistsRequest: CheckUserExistsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckUserExistsResponse> {
            return localVarFp.checkUserExists(checkUserExistsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checkout order
         * @param {string} userId The ID of the user
         * @param {CheckoutRequestSchema} checkoutRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkoutOrder(userId: string, checkoutRequestSchema: CheckoutRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutResponseSchema> {
            return localVarFp.checkoutOrder(userId, checkoutRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new merchant to the platform
         * @summary Create a new merchant
         * @param {MerchantSchema} merchantSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchant(merchantSchema: MerchantSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.createMerchant(merchantSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new restaurant category
         * @summary Create new category
         * @param {CreateRestaurantCategoryRequest} createRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRestaurantCategory(createRestaurantCategoryRequest: CreateRestaurantCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.createRestaurantCategory(createRestaurantCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint creates a new user with the provided details.
         * @summary Create a new admin user
         * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAdminUser(addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.createSubAdminUser(addOrEditSubAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint creates a new user with the provided details.
         * @summary Create a new user
         * @param {AddUserSchema} addUserSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(addUserSchema: AddUserSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.createUser(addUserSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple categories by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategories(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteCategories(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple choice groups by IDs
         * @param {DeleteChoicesRequest} deleteChoicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChoiceGroups(deleteChoicesRequest: DeleteChoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteChoiceGroups(deleteChoicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple choices by IDs
         * @param {DeleteChoicesRequest} deleteChoicesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChoices(deleteChoicesRequest: DeleteChoicesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteChoices(deleteChoicesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple cms pages by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCmsPages(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteCmsPages(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple coupons by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupons(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteCoupons(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple delivery boys by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryBoys(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteDeliveryBoys(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple delivery managers by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeliveryManagers(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteDeliveryManagers(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple faqs by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaqs(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteFaqs(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete banner images
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHomePageBanner(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteHomePageBanner(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple items by IDs
         * @param {DeleteItemsRequest} deleteItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItems(deleteItemsRequest: DeleteItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteItems(deleteItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete one or more meals by IDs
         * @summary Delete meals
         * @param {DeleteMealsRequest} deleteMealsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMeals(deleteMealsRequest: DeleteMealsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseSchema> {
            return localVarFp.deleteMeals(deleteMealsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete merchant by ID
         * @param {string} merchantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMerchant(merchantId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteMerchant(merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete subscribers by IDs
         * @param {DeleteNewsletterSubscribersRequest} deleteNewsletterSubscribersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNewsletterSubscribers(deleteNewsletterSubscribersRequest: DeleteNewsletterSubscribersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteNewsletterSubscribers(deleteNewsletterSubscribersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin deletes one or more offers
         * @summary Delete offers
         * @param {DeleteOffersRequestSchema} deleteOffersRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOffers(deleteOffersRequestSchema: DeleteOffersRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteOffers(deleteOffersRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a restaurant category
         * @summary Delete restaurant category
         * @param {string} categoryId Category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRestaurantCategory(categoryId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteRestaurantCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint deletes multiple reviews based on the provided IDs.
         * @summary Delete multiple reviews by IDs
         * @param {DeleteReviewsRequest} deleteReviewsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReviews(deleteReviewsRequest: DeleteReviewsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteReviews(deleteReviewsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple stores by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStores(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteStores(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple sub-admins by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAdmins(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteSubAdmins(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete multiple sub-item categories by IDs
         * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubItemCategory(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteSubItemCategory(deleteSubAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete subscription plans by IDs
         * @param {DeleteSubscriptionPlansRequest} deleteSubscriptionPlansRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionPlans(deleteSubscriptionPlansRequest: DeleteSubscriptionPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteSubscriptionPlans(deleteSubscriptionPlansRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a specific address for the user.
         * @summary Delete a user address
         * @param {string} addressId The unique identifier of the address to delete.
         * @param {string} userId The ID of the user to whom the address belongs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserAddress(addressId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteUserAddress(addressId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint deletes multiple users based on the provided IDs.
         * @summary Delete multiple users by IDs
         * @param {DeleteUsersRequest} deleteUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers(deleteUsersRequest: DeleteUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.deleteUsers(deleteUsersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed admin commission report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all stores and commission data across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total commission collected, total sales, average rate) 2. **Details Section**: Line-by-line listing of orders with commission breakdown  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Commission Type (common or custom) - Commission Percentage (rate applied, e.g., \"15%\") - Total Orders (count of orders in period) - Total Sales (total order amount / gross sales) - Commission Amount (commission collected from this store) - Average Commission per Order - Order Details (order ID, date, amount, commission calculated)  **Summary Fields (Overall):** - Total Commission Collected (sum across all stores) - Total Sales (All Stores) - Average Commission Rate (weighted average) - Store Count  **Commission Calculation:** Commission data is sourced from Commission Tracking records (recordType: admin_merchant): - Total Sales = totalOrderAmount - Commission Amount = totalAdminCommissionAmount - Commission Percentage:   * If merchant.commissionType === \"custom\" → merchant.commissionPercentage   * If merchant.commissionType === \"common\" → Platform default commission rate - Total Commission Collected = SUM(totalAdminCommissionAmount) across all filtered records  **Data Aggregation:** 1. Filter CommissionRecords by date range, store IDs, merchant ID, store type 2. Join with Merchant schema to get commission type and percentage 3. Join with Store schema to get store type 4. Group by store and calculate totals 5. Generate summary with platform-wide totals  **Date Filtering:** The dateRange parameter filters by order completion date (when commission was earned), not by commission payment or settlement date. 
         * @summary Download admin commission report
         * @param {AdminCommissionReportRequest} adminCommissionReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadAdminCommissionReport(adminCommissionReportRequest: AdminCommissionReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadAdminCommissionReport(adminCommissionReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a customized Excel template with store-specific categories, subcategories, and dropdown validations for bulk uploading items. Only XLSX format is supported.
         * @summary Download store-specific Excel template with customized dropdowns
         * @param {string} storeId Store ID for generating customized template with store-specific categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBulkUploadTemplate(storeId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadBulkUploadTemplate(storeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed cancelled orders report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all cancelled orders across all stores - Merchants: Can only access cancelled orders from their own stores  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall 2. **Details Section**: Line-by-line listing of cancelled orders  **Cancellation States Included (Default):** - ORDER_CANCELLED: Customer or system cancelled after order placed - MERCHANT_CANCELLED: Merchant cancelled the order - DELIVERY_FAILED: Delivery attempt failed, order marked cancelled  **Refund Calculation:** Refund amounts include Settlement records with status COMPLETED or PENDING/INPROGRESS where transactionType = \'REFUND\' and isRefund = true.  **Date Filtering:** The dateRange parameter filters by CANCEL DATE (when order was cancelled), not by order creation date. 
         * @summary Download cancelled orders report
         * @param {CancelledOrdersReportRequest} cancelledOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCancelledOrdersReport(cancelledOrdersReportRequest: CancelledOrdersReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCancelledOrdersReport(cancelledOrdersReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed delivery performance report in Excel format with driver performance metrics.  **Access Control:** - Admins only: Can access delivery performance data for all drivers across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate performance metrics (total deliveries, avg time, on-time %, earnings) 2. **Details Section**: Line-by-line listing of deliveries with timestamps and performance indicators  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Orders Delivered (count of successfully delivered orders) - Average Delivery Time (from driver acceptance to delivery completion, in minutes) - Distance Covered (total kilometers traveled, calculated from GPS coordinates) - On-time Delivery Percentage (calculated by backend based on delivery time thresholds) - Delayed Deliveries Count (orders exceeding expected delivery time) - Cancelled Orders Count (ORDER_CANCELLED + DELIVERY_FAILED statuses) - Total Earnings (sum of delivery fees + driver bonuses for delivered orders) - Order Details (order ID, acceptance time, delivery time, duration, status)  **Performance Metrics Calculation:** - **Average Delivery Time**: Calculated as (deliveredTime - driverAcceptedTime) averaged across all delivered orders.   Time is measured in minutes from when the driver accepted the order to when delivery was completed.  - **Distance Covered**: Calculated from GPS coordinate tracking via DeliveryPartnerLocation records.   Backend uses haversine distance formula to calculate distance between consecutive location points   and sums the total distance traveled. Result is reported in kilometers with 2 decimal places.   **Note**: Distance is a calculated metric as no direct distance field exists in schemas.  - **On-time Delivery %**: Backend determines \"on-time\" threshold (typically 30-45 minutes based on   business rules) and calculates percentage of orders delivered within threshold.   Formula: (orders delivered within threshold / total delivered orders) × 100   **Note**: The on-time threshold logic is implemented in backend and may vary by region or store type.  - **Delayed Deliveries**: Count of orders where (deliveredTime - driverAcceptedTime) exceeds   the on-time threshold. These are orders that took longer than expected to complete.  - **Cancelled Orders**: Includes ORDER_CANCELLED (customer/merchant initiated cancellations) and   DELIVERY_FAILED (delivery attempts that could not be completed) statuses.  - **Total Earnings**: Sum of (deliveryFee + driverBonus) from EarningsBreakdown for ORDER_DELIVERED   orders only. Cancelled or failed orders do not contribute to earnings calculation.  **Multi-Store Order Handling:** Orders with multiple pickup locations (totalStoresCount > 1) are tracked with individual store pickup timestamps. Delivery time is measured from driver acceptance to final delivery completion, accounting for the complexity of multi-store pickups.  **Date Filtering:** The dateRange parameter filters by DELIVERY COMPLETION DATE (deliveredTime timestamp). This ensures performance metrics reflect when deliveries were actually completed, not when orders were placed or accepted by the driver.  **Order Status Filtering:** By default, includes ORDER_DELIVERED, ORDER_CANCELLED, and DELIVERY_FAILED statuses to provide comprehensive performance view. Successful deliveries contribute to positive metrics, while cancelled/failed orders are tracked separately for complete performance assessment. 
         * @summary Download delivery performance report
         * @param {DeliveryPerformanceReportRequest} deliveryPerformanceReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDeliveryPerformanceReport(deliveryPerformanceReportRequest: DeliveryPerformanceReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadDeliveryPerformanceReport(deliveryPerformanceReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed driver payout report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all driver payouts across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total deliveries, total earnings, settlement breakdown) 2. **Details Section**: Line-by-line listing of deliveries with all specified fields  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Deliveries (count of orders delivered) - Total Earnings (sum of delivery fees + bonuses) - Delivery Fee Total - Driver Bonus Total - COD Collected (cash collected from customers) - Settlement Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Pending Amount (earnings not yet paid) - Paid Amount (earnings already settled) - Order Details (order ID, date, store name, customer name, amount)  **Earnings Calculation:** Total Earnings = Sum of (Delivery Fee + Driver Bonus) for all completed deliveries. - Delivery Fee: Base fee for delivery service - Driver Bonus: Emergency/urgent delivery bonuses - Earnings are calculated from orders with status ORDER_DELIVERED (default)  **Settlement Tracking:** Settlement records with transactionCategory = DELIVERY_FEE or DRIVER_BONUS and toUserType = DELIVERY_PARTNER are used to track payout status.  **Date Filtering:** The dateRange parameter filters by ORDER DELIVERY DATE (when order was delivered/completed), not by settlement/payout date. This shows earnings generated in the period, regardless of when they were paid out. 
         * @summary Download driver payout report
         * @param {DriverPayoutReportRequest} driverPayoutReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDriverPayoutReport(driverPayoutReportRequest: DriverPayoutReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadDriverPayoutReport(driverPayoutReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed merchant payout report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all merchants and stores across the platform - Merchants: Can only access their own stores (403 Forbidden if accessing others)  **Report Structure:** Multi-merchant reports generate separate worksheets per merchant/store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total orders, gross sales, discounts, commission, net payout) 2. **Details Section**: Line-by-line listing of orders and settlements with all specified fields  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Total Orders (count of orders in period) - Gross Sales (total order amount before deductions) - Discounts (wallet/coupon/offer deductions) - Admin Commission (platform commission amount) - Item Rejections (merchant rejected item amounts) - Customer Cancellations (customer cancelled item amounts) - Net Payout (amount payable to merchant) - Payout Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Payout Date (when payment was made) - Payment Reference No (transaction ID from payment system) - Payment Method (how merchant was paid) - Balance Due (outstanding amount not yet paid) - Order Details (order ID, date, customer, amount, status)  **Financial Calculations:** Financial data is sourced from Commission Tracking records: - Gross Sales = totalOrderAmount - Discounts = totalWalletCouponOfferAmount - Admin Commission = totalAdminCommissionAmount - Item Rejections = totalMerchantRejectedItemAmount - Customer Cancellations = totalUserCancelledItemAmount - Net Payout = Gross Sales - Admin Commission - Discounts - Rejections - Cancellations - Balance Due = balanceAmountToPay (positive = owe merchant, negative = merchant owes platform)  **Settlement Tracking:** Settlement records with toUserType = MERCHANT and transactionCategory = MERCHANT_PAYMENT are used to track payout status and payment references.  **Date Filtering:** The dateRange parameter determines the date range: - today: Today\'s settlements (midnight to now, UTC) - thisWeek: This week\'s settlements (Monday to now, UTC) - thisMonth: This month\'s settlements (1st to now, UTC) - last30Days: Last 30 days of settlements - thisYear: This year\'s settlements (Jan 1 to now, UTC) - custom: Use dateFrom and dateTo parameters (ISO 8601 UTC format)  Applies to order delivery dates (when sales occurred), not settlement payment dates. 
         * @summary Download merchant payout report
         * @param {MerchantPayoutReportRequest} merchantPayoutReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMerchantPayoutReport(merchantPayoutReportRequest: MerchantPayoutReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadMerchantPayoutReport(merchantPayoutReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download order summary report with advanced filtering options in Excel format.  **Access Control:** - Admins: Can access orders from any store - Merchants: Can only access orders from their own stores  **Report Fields:** - Order ID: Unique order identifier - Store Name: Name of the store where order was placed - Store Type: Restaurant, GroceryStore, or PharmacyStore - Customer Name: Name of the customer who placed the order - Driver Name: Name of assigned delivery partner (or \"Not Assigned\" if no driver) - Order Date: Timestamp when order was placed - Order Status: Current order status (ORDER_DELIVERED, ORDER_CANCELLED, etc.) - Payment Method: How customer paid for the order - Order Total: Total order amount including all charges - Tax: Tax amount charged on the order - Delivery Fee: Delivery charge for the order - Net Amount: Confirmed amount after order processing (excludes cancelled/unavailable items)  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by delivery date or completion date.  **Net Amount vs Order Total:** - Order Total: Initial order amount at checkout (includes all items) - Net Amount: Final confirmed amount after processing (excludes cancelled/unavailable items) 
         * @summary Download order summary report
         * @param {OrderSummaryReportRequest} orderSummaryReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderSummaryReport(orderSummaryReportRequest: OrderSummaryReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadOrderSummaryReport(orderSummaryReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed pending orders report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all pending orders across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total pending orders, orders by status, total order value, etc.) 2. **Details Section**: Line-by-line listing of pending orders with all specified fields  **Report Fields:** - Order ID - Store Name - Customer Name - Driver Assigned (name or \"Not Assigned\" if no driver) - Order Placed At (timestamp when order was created) - Order Total (total order amount) - Payment Method (Cash, Card, Wallet, Online, etc.) - Current Status (ORDER_PLACED, ORDER_ACCEPTED, etc.)  **What are \"Pending Orders\"?** Pending orders are orders that are currently in progress and have not been completed or cancelled. These include orders with statuses: ORDER_PLACED, ORDER_ACCEPTED, ORDER_READY_FOR_PICKUP, DRIVER_ACCEPTED, DRIVER_ARRIVED, DRIVER_PICKED_UP, DRIVER_ON_THE_WAY.  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by order completion or delivery date. This helps identify orders that were placed within a specific time range and are still pending.  **Use Cases:** - Monitor orders currently being processed - Identify stuck or delayed orders - Track order fulfillment pipeline - Analyze order processing efficiency - Manage driver assignments for pending deliveries 
         * @summary Download pending orders report
         * @param {PendingOrdersReportRequest} pendingOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPendingOrdersReport(pendingOrdersReportRequest: PendingOrdersReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadPendingOrdersReport(pendingOrdersReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed refund report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all refunds across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total refunds, total amount, count by method, etc.) 2. **Details Section**: Line-by-line listing of refunds with all specified fields  **Report Fields:** - Order ID - Customer Name - Store Name - Refund Amount - Refund Reason - Refund Method (Wallet, Online, Manual) - Refund Date - Approved By (Admin name and email)  **Date Filtering:** The dateRange parameter filters by REFUND DATE (when refund was processed), not by order creation date. 
         * @summary Download refund report
         * @param {RefundReportRequest} refundReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRefundReport(refundReportRequest: RefundReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadRefundReport(refundReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a detailed rejected orders report in Excel format with advanced filtering.  **Access Control:** - **Admins**: Can access all rejected orders across all stores, including both merchant and driver rejections - **Merchants**: Can only access rejected orders from their own stores, and ONLY merchant rejections (no delivery partner information)  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall    - Total rejected orders    - Count by rejection type (merchant vs driver - admin only)    - Count by store type    - Most common rejection reasons 2. **Details Section**: Line-by-line listing of rejected orders  **Report Fields:** - **Order ID**: Unique identifier for the order - **Store Name**: Name of the store/restaurant - **Customer Name**: Name of the customer who placed the order - **Rejected By**: Who rejected the order   - For merchants: Always shows \"Store\" (only merchant rejections visible)   - For admins: Shows \"Store\" or \"Driver\" based on rejection type - **Delivery Partner Name** (Admin only, driver rejections): Name of the delivery partner who rejected   - Only shown for driver rejections when user is admin   - Not visible to merchant users - **Reject Reason**: Reason provided for rejection - **Order Time**: Timestamp when order was placed - **Rejected Time**: Timestamp when order/items were rejected  **What are \"Rejected Orders\"?**  Rejected orders include:  1. **Merchant Rejections** (Visible to both merchants and admins):    - Orders with status MERCHANT_DENIED (merchant rejected before acceptance)    - Orders with items marked as isRejected=true (partial or full item rejection)    - Tracked via rejectionReason field in StoreOrderItem schema  2. **Driver Rejections** (Visible to admins only):    - Orders where delivery driver denied/rejected the assignment    - Tracked via deniedAt, denialType, and denialReason in DeliveryInfo schema    - Includes both manual driver rejections and auto-rejections (timeout)  **Role-Based Data Access:**  - **Merchants**: Will NEVER see driver rejection data, even if they set rejectedBy=driver_rejected or include deliveryPartnerIds.   The backend automatically scopes merchant requests to only merchant rejections from their own stores.   The \"Delivery Partner Name\" field will not appear in merchant reports.  - **Admins**: Can set rejectedBy to either:   - merchant_rejected: Generate merchant rejection report only   - driver_rejected: Generate delivery partner rejection report only   - Omit the parameter: Include both merchant and driver rejections in the report    Can use deliveryPartnerIds to filter by specific delivery partners (only applicable when rejectedBy=driver_rejected).   The \"Delivery Partner Name\" field appears for driver rejections.  **Date Filtering:**  The dateRange parameter filters by REJECTION TIME: - For merchant rejections: When order was denied or items were marked rejected - For driver rejections: The deniedAt timestamp (admin only)  This differs from order creation date and helps identify when rejections occurred.  **Use Cases:** - Analyze rejection patterns and trends - Identify stores with high rejection rates - Track common rejection reasons for operational improvements - Monitor driver rejection patterns (admin only) - Filter by specific delivery partners to analyze their rejection behavior (admin only) - Understand customer impact from rejected orders 
         * @summary Download rejected orders report
         * @param {RejectedOrdersReportRequest} rejectedOrdersReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRejectedOrdersReport(rejectedOrdersReportRequest: RejectedOrdersReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadRejectedOrdersReport(rejectedOrdersReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Download sales report with advanced filtering options in Excel format. - Admins: Can access any store - Merchants: Can filter by their own stores 
         * @summary Download sales report
         * @param {SalesReportRequest} salesReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadSalesReport(salesReportRequest: SalesReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadSalesReport(salesReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing admin
         * @param {string} userId The ID of the admin to be updated
         * @param {EditAdminRequest} editAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editAdmin(userId: string, editAdminRequest: EditAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editAdmin(userId, editAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing choice in the system
         * @param {string} choiceId The ID of the delivery manager to be updated
         * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editChoice(choiceId: string, addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editChoice(choiceId, addOrEditChoiceRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing choice group in the system
         * @param {string} choiceGroupId The ID of the delivery manager to be updated
         * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editChoiceGroup(choiceGroupId: string, addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editChoiceGroup(choiceGroupId, addOrUpdateChoiceGroupRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing CMS page in the system
         * @summary Edit an existing CMS page
         * @param {string} pageId The ID of the CMS page to be updated
         * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCmsPage(pageId: string, addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editCmsPage(pageId, addOrEditCmsPageRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing coupon in the system
         * @summary Edit an existing coupon
         * @param {string} couponId The ID of the coupon to be updated
         * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editCoupon(couponId: string, addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editCoupon(couponId, addOrEditCouponRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing delivery manager to the system
         * @summary Edit an existing delivery manager
         * @param {string} deliveryManagerId The ID of the delivery manager to be updated
         * @param {EditDeliveryManagerRequestSchema} editDeliveryManagerRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDeliveryManager(deliveryManagerId: string, editDeliveryManagerRequestSchema: EditDeliveryManagerRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editDeliveryManager(deliveryManagerId, editDeliveryManagerRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing faq in the system
         * @summary Edit an existing Faq
         * @param {string} faqId The ID of the faq to be updated
         * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editFaq(faqId: string, addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editFaq(faqId, addOrEditFaqRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing home page banner in the system
         * @summary Edit an existing Home Page Banner
         * @param {string} bannerId The ID of the banner to be updated
         * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editHomePageBanner(bannerId: string, dynamicHomePageContentSettings: DynamicHomePageContentSettings, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editHomePageBanner(bannerId, dynamicHomePageContentSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} categoryId The ID of the item category to be updated
         * @param {CreateItemCategoryRequest} createItemCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editItemCategory(categoryId: string, createItemCategoryRequest: CreateItemCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editItemCategory(categoryId, createItemCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a meal with new details, items, and choice groups
         * @summary Edit an existing meal
         * @param {string} mealId The ID of the meal to be updated
         * @param {EditMealRequest} editMealRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMeal(mealId: string, editMealRequest: EditMealRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseSchema> {
            return localVarFp.editMeal(mealId, editMealRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin updates an existing offer
         * @summary Edit an offer
         * @param {string} offerId 
         * @param {EditOfferRequestSchema} editOfferRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editOffer(offerId: string, editOfferRequestSchema: EditOfferRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editOffer(offerId, editOfferRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} storeId The ID of the store to be updated
         * @param {WritableStoreDataSchema} writableStoreDataSchema 
         * @param {string} [merchantId] The ID of the merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStore(storeId: string, writableStoreDataSchema: WritableStoreDataSchema, merchantId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editStore(storeId, writableStoreDataSchema, merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing item category
         * @param {string} storeId The ID of the restaurant to be updated
         * @param {WritableRestaurantDataSchema} writableRestaurantDataSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editStoreForAdmin(storeId: string, writableRestaurantDataSchema: WritableRestaurantDataSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editStoreForAdmin(storeId, writableRestaurantDataSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing sub-admin
         * @param {string} id The ID of the sub-admin to be updated
         * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSubAdmin(id: string, addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editSubAdmin(id, addOrEditSubAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit an existing sub-item category
         * @param {string} subCategoryId The ID of the sub-item category to be updated
         * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editSubItemCategory(subCategoryId: string, createItemSubCategoryRequest: CreateItemSubCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editSubItemCategory(subCategoryId, createItemSubCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint edits an existing address for a user.
         * @summary Edit an existing user address
         * @param {UserAddressSchema} userAddressSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserAddress(userAddressSchema: UserAddressSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editUserAddress(userAddressSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint updates the details of an existing user.
         * @summary Edit an existing user
         * @param {string} userId The ID of the user to be updated
         * @param {EditUserRequestSchema} editUserRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editUserById(userId: string, editUserRequestSchema: EditUserRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.editUserById(userId, editUserRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates password reset by sending a link (email) or code (SMS) to the user
         * @summary Send reset password link or code to user
         * @param {ForgotPasswordRequestSchema} forgotPasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPasswordRequestSchema: ForgotPasswordRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.forgotPassword(forgotPasswordRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a unique coupon code for the specified coupon.
         * @summary Generate a unique coupon code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCouponCode(options?: RawAxiosRequestConfig): AxiosPromise<GenerateCouponCodeResponseSchema> {
            return localVarFp.generateCouponCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generates OTP for email or phone number
         * @param {OtpRequest} otpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateOtp(otpRequest: OtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.generateOtp(otpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a presigned URL for uploading, downloading, or deleting a file from AWS S3.
         * @summary Generate a presigned URL for AWS S3 operations
         * @param {GeneratePresignedUrlRequest} generatePresignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generatePresignedUrl(generatePresignedUrlRequest: GeneratePresignedUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<AwsPresignedURL> {
            return localVarFp.generatePresignedUrl(generatePresignedUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint generates a unique referral code for the specified user. Each user can generate their own referral code to share with others.
         * @summary Generate a referral code for a specific user
         * @param {string} userId The ID of the user to generate a referral code for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReferralCode(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GenerateReferralCodeResponse> {
            return localVarFp.generateReferralCode(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all banner images
         * @summary Get a list of all banner images
         * @param {number} page Page number (starting from 1)
         * @param {GetAllBannerImagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllBannerImagesSortByEnum} sortBy Field to sort by image text
         * @param {GetAllBannerImagesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by image text
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBannerImages(page: number, limit: GetAllBannerImagesLimitEnum, sortBy: GetAllBannerImagesSortByEnum, sortOrder: GetAllBannerImagesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllBannerImagesResponse> {
            return localVarFp.getAllBannerImages(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all choice groups with optional search and sorting parameters.
         * @summary Get a list of all choice groups
         * @param {number} page Page number (starting from 1)
         * @param {GetAllChoiceGroupsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllChoiceGroupsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllChoiceGroupsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] Filter choice groups by specific store ID
         * @param {GetAllChoiceGroupsStoreTypeEnum} [storeType] Filter choice groups by store type
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChoiceGroups(page: number, limit: GetAllChoiceGroupsLimitEnum, sortBy: GetAllChoiceGroupsSortByEnum, sortOrder: GetAllChoiceGroupsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoiceGroupsStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllChoiceGroupResponseSchema> {
            return localVarFp.getAllChoiceGroups(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all choices with optional search and sorting parameters.
         * @summary Get a list of all choices
         * @param {number} page Page number (starting from 1)
         * @param {GetAllChoicesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllChoicesSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllChoicesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the merchant to which the choices belong
         * @param {string} [storeId] Filter choices by specific store ID
         * @param {GetAllChoicesStoreTypeEnum} [storeType] Filter choices by store type
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChoices(page: number, limit: GetAllChoicesLimitEnum, sortBy: GetAllChoicesSortByEnum, sortOrder: GetAllChoicesSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoicesStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllChoicesResponseSchema> {
            return localVarFp.getAllChoices(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
         * @summary Get a list of all cms pages
         * @param {number} page Page number (starting from 1)
         * @param {GetAllCmsPagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllCmsPagesSortByEnum} sortBy Field to sort by (title, createdAt, status)
         * @param {GetAllCmsPagesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by page title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCmsPages(page: number, limit: GetAllCmsPagesLimitEnum, sortBy: GetAllCmsPagesSortByEnum, sortOrder: GetAllCmsPagesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCmsPagesResponseSchema> {
            return localVarFp.getAllCmsPages(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all types of commission tracking data (merchant, admin merchant, delivery partner) with optional transaction details in a single API call
         * @summary Get unified commission tracking data and transactions
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {GetAllCommissionTrackingRecordTypeEnum} recordType Filter by user type (merchant, admin merchant, delivery partner)
         * @param {GetAllCommissionTrackingSortByEnum} [sortBy] Field to sort by
         * @param {GetAllCommissionTrackingSortOrderEnum} [sortOrder] Sort order (ascending or descending)
         * @param {string} [search] Full-text search on merchant name, restaurant name, email, delivery partner details, transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCommissionTracking(page: number, limit: number, recordType: GetAllCommissionTrackingRecordTypeEnum, sortBy?: GetAllCommissionTrackingSortByEnum, sortOrder?: GetAllCommissionTrackingSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<CommissionTrackingResponse> {
            return localVarFp.getAllCommissionTracking(page, limit, recordType, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all coupons with optional search and sorting parameters.
         * @summary Get a list of all coupons
         * @param {number} page Page number (starting from 1)
         * @param {GetAllCouponsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllCouponsSortByEnum} sortBy Field to sort by (coupon name, code, type, validity, start date, status, coupons left)
         * @param {GetAllCouponsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by coupon name, coupon code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCoupons(page: number, limit: GetAllCouponsLimitEnum, sortBy: GetAllCouponsSortByEnum, sortOrder: GetAllCouponsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllCouponsResponseSchema> {
            return localVarFp.getAllCoupons(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all delivery boys with optional search and sorting parameters.
         * @summary Get a list of all delivery boys
         * @param {number} page Page number (starting from 1)
         * @param {GetAllDeliveryBoysLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllDeliveryBoysSortByEnum} sortBy Field to sort by (name, email, mobile number)
         * @param {GetAllDeliveryBoysSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by delivery boy name, delivery boy email, or delivery boy mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeliveryBoys(page: number, limit: GetAllDeliveryBoysLimitEnum, sortBy: GetAllDeliveryBoysSortByEnum, sortOrder: GetAllDeliveryBoysSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllDeliveryBoysResponseSchema> {
            return localVarFp.getAllDeliveryBoys(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all delivery managers with optional search and sorting parameters.
         * @summary Get a list of all delivery managers
         * @param {number} page Page number (starting from 1)
         * @param {GetAllDeliveryManagersLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllDeliveryManagersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllDeliveryManagersSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDeliveryManagers(page: number, limit: GetAllDeliveryManagersLimitEnum, sortBy: GetAllDeliveryManagersSortByEnum, sortOrder: GetAllDeliveryManagersSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllDeliveryManagersResponseSchema> {
            return localVarFp.getAllDeliveryManagers(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
         * @summary Get a list of all cms pages
         * @param {number} page Page number (starting from 1)
         * @param {GetAllFaqsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllFaqsSortByEnum} sortBy Field to sort by question, createdAt, or status
         * @param {GetAllFaqsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by page title
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFaqs(page: number, limit: GetAllFaqsLimitEnum, sortBy: GetAllFaqsSortByEnum, sortOrder: GetAllFaqsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllFaqsResponseSchema> {
            return localVarFp.getAllFaqs(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all items with optional search and sorting parameters.
         * @summary Get a list of all items with stocks
         * @param {number} page Page number (starting from 1)
         * @param {GetAllItemStocksLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllItemStocksSortByEnum} sortBy Field to sort by product code, item name, restaurant name, merchant name, creaeted at
         * @param {GetAllItemStocksSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the merchant to filter items by
         * @param {string} [search] Search by product code, item name, restaurant name, merchant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItemStocks(page: number, limit: GetAllItemStocksLimitEnum, sortBy: GetAllItemStocksSortByEnum, sortOrder: GetAllItemStocksSortOrderEnum, merchantId?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllItemsInStockResponseSchema> {
            return localVarFp.getAllItemStocks(page, limit, sortBy, sortOrder, merchantId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all items with optional search and sorting parameters.
         * @summary Get a list of all items
         * @param {number} page Page number (starting from 1)
         * @param {GetAllItemsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllItemsSortByEnum} sortBy Field to sort by (name, itemCode, lastLoginDate, lastLogoutDate)
         * @param {GetAllItemsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] Filter items by specific store ID
         * @param {GetAllItemsStoreTypeEnum} [storeType] Filter items by store type
         * @param {string} [search] Search by name, item code, or restaurant name
         * @param {GetAllItemsStockAvailabilityEnum} [stockAvailability] Filter by status
         * @param {GetAllItemsAddedByEnum} [addedBy] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllItems(page: number, limit: GetAllItemsLimitEnum, sortBy: GetAllItemsSortByEnum, sortOrder: GetAllItemsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllItemsStoreTypeEnum, search?: string, stockAvailability?: GetAllItemsStockAvailabilityEnum, addedBy?: GetAllItemsAddedByEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAllItemsResponseSchema> {
            return localVarFp.getAllItems(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, stockAvailability, addedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of meals with filtering and sorting options
         * @summary Get all meals
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of meals per page
         * @param {string} [search] Search term for meal name
         * @param {string} [sortBy] Field to sort by
         * @param {GetAllMealsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [storeId] Filter by store ID
         * @param {GetAllMealsStoreTypeEnum} [storeType] Filter by store type
         * @param {GetAllMealsStatusEnum} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMeals(page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetAllMealsSortOrderEnum, storeId?: string, storeType?: GetAllMealsStoreTypeEnum, status?: GetAllMealsStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAllMeals200Response> {
            return localVarFp.getAllMeals(page, limit, search, sortBy, sortOrder, storeId, storeType, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all notifications
         * @param {string} userId ID of the user to fetch notifications for.
         * @param {GetAllNotificationsUserTypeEnum} userType 
         * @param {number} page 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllNotifications(userId: string, userType: GetAllNotificationsUserTypeEnum, page: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetAllNotificationsResponse> {
            return localVarFp.getAllNotifications(userId, userType, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin retrieves all offer coupons with pagination and filtering
         * @summary Get all offers
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetAllOffersSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOffers(page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetAllOffersSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAllOffersResponseSchema> {
            return localVarFp.getAllOffers(page, limit, search, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a comprehensive list of orders with role-based filtering and data access. Response structure varies based on userType using discriminator pattern. 
         * @summary Get unified order details for all user types
         * @param {GetAllOrdersUserTypeEnum} userType Type of user making the request
         * @param {string} [userId] Unique identifier of the user making the request
         * @param {GetAllOrdersLangEnum} [lang] Language code for localized content
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {string} [orderId] Filter by specific order ID (for individual order lookup)
         * @param {string} [storeId] Filter by specific store ID
         * @param {GetAllOrdersStatusEnum} [status] Filter by order status
         * @param {string} [fromDate] Filter orders from this date (YYYY-MM-DD)
         * @param {string} [toDate] Filter orders until this date (YYYY-MM-DD)
         * @param {GetAllOrdersSortByEnum} [sortBy] Field to sort by
         * @param {GetAllOrdersSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Full-text search on customer name, store name, item name, order ID
         * @param {GetAllOrdersOrderModeEnum} [orderMode] Filter by order mode (normal or pre-order)
         * @param {boolean} [requiresManualAssignment] Filter orders that require manual driver assignment (urgent orders, no drivers available)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrders(userType: GetAllOrdersUserTypeEnum, userId?: string, lang?: GetAllOrdersLangEnum, page?: number, limit?: number, orderId?: string, storeId?: string, status?: GetAllOrdersStatusEnum, fromDate?: string, toDate?: string, sortBy?: GetAllOrdersSortByEnum, sortOrder?: GetAllOrdersSortOrderEnum, search?: string, orderMode?: GetAllOrdersOrderModeEnum, requiresManualAssignment?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<OrderResponse> {
            return localVarFp.getAllOrders(userType, userId, lang, page, limit, orderId, storeId, status, fromDate, toDate, sortBy, sortOrder, search, orderMode, requiresManualAssignment, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of restaurant categories with their details.
         * @summary Get a list of restaurant categories
         * @param {GetAllRestaurantCategoriesStoreTypeEnum} storeType The type of store to which the restaurant belongs (Grocery or Restaurant)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRestaurantCategories(storeType: GetAllRestaurantCategoriesStoreTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<RestaurantCategoryNames>> {
            return localVarFp.getAllRestaurantCategories(storeType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all restaurant merchants.
         * @summary Get all restaurant merchants
         * @param {GetAllRestaurantMerchantsStoreTypeEnum} [storeType] Optional filter by store type. If not provided, returns all merchants regardless of store type.
         * @param {string} [search] Search by merchant name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRestaurantMerchants(storeType?: GetAllRestaurantMerchantsStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RestaurantMerchantSchema>> {
            return localVarFp.getAllRestaurantMerchants(storeType, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of reviews
         * @summary Get all reviews
         * @param {GetAllReviewsTypeEnum} type type of reviews to fetch
         * @param {string} page Page number for pagination
         * @param {GetAllReviewsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {string} [storeId] The ID of the merchant
         * @param {string} [merchantId] The ID of the merchant
         * @param {string} [search] Search term to filter categories
         * @param {GetAllReviewsStatusEnum} [status] Filter by status
         * @param {GetAllReviewsSortByEnum} [sortBy] Field to sort by
         * @param {GetAllReviewsSortDirectionEnum} [sortDirection] Direction of sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllReviews(type: GetAllReviewsTypeEnum, page: string, limit: GetAllReviewsLimitEnum, storeId?: string, merchantId?: string, search?: string, status?: GetAllReviewsStatusEnum, sortBy?: GetAllReviewsSortByEnum, sortDirection?: GetAllReviewsSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAllReviewsResponseSchema> {
            return localVarFp.getAllReviews(type, page, limit, storeId, merchantId, search, status, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve transactions based on user type with filtering and pagination. Transactions are categorized as: - **toPay**: Amount user needs to pay - **toReceive**: Amount user will receive - **completed**: Completed transactions 
         * @summary Get All Settlements
         * @param {GetAllSettlementsUserTypeEnum} userType Type of user requesting transactions
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {string} [userId] ID of the user. Required for MERCHANT, CUSTOMER, and DELIVERY_PARTNER. Optional for ADMIN (auto-loaded if not provided).
         * @param {GetAllSettlementsTransactionTypeEnum} [transactionType] Filter by transaction category
         * @param {string} [fromDate] Start date for filtering (ISO 8601 format)
         * @param {string} [toDate] End date for filtering (ISO 8601 format)
         * @param {GetAllSettlementsSortByEnum} [sortBy] Sort field
         * @param {GetAllSettlementsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search in description or reference number
         * @param {GetAllSettlementsSettlementUserTypeEnum} [settlementUserType] Filter settlements by user type (MERCHANT, CUSTOMER, or DELIVERY_PARTNER). Use with settlementUserId to filter by specific user.
         * @param {string} [settlementUserId] Filter settlements by specific user ID. Use with settlementUserType to filter by merchantId, customerId, or deliveryPartnerId.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSettlements(userType: GetAllSettlementsUserTypeEnum, page: number, limit: number, userId?: string, transactionType?: GetAllSettlementsTransactionTypeEnum, fromDate?: string, toDate?: string, sortBy?: GetAllSettlementsSortByEnum, sortOrder?: GetAllSettlementsSortOrderEnum, search?: string, settlementUserType?: GetAllSettlementsSettlementUserTypeEnum, settlementUserId?: string, options?: RawAxiosRequestConfig): AxiosPromise<SettlementsResponse> {
            return localVarFp.getAllSettlements(userType, page, limit, userId, transactionType, fromDate, toDate, sortBy, sortOrder, search, settlementUserType, settlementUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all restaurants with detailed information
         * @param {number} page Page number (starting from 1)
         * @param {GetAllStoresForAdminLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllStoresForAdminSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllStoresForAdminSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetAllStoresForAdminStatusFilterEnum} statusFilter Filter by category status
         * @param {GetAllStoresForAdminAddedByFilterEnum} addedByFilter Filter by who added the restaurant
         * @param {string} [merchantId] 
         * @param {GetAllStoresForAdminStoreTypeEnum} [storeType] Filter stores by type
         * @param {string} [search] Search by restaurant name, merchant name, category, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStoresForAdmin(page: number, limit: GetAllStoresForAdminLimitEnum, sortBy: GetAllStoresForAdminSortByEnum, sortOrder: GetAllStoresForAdminSortOrderEnum, statusFilter: GetAllStoresForAdminStatusFilterEnum, addedByFilter: GetAllStoresForAdminAddedByFilterEnum, merchantId?: string, storeType?: GetAllStoresForAdminStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetStoreListResponseSchema> {
            return localVarFp.getAllStoresForAdmin(page, limit, sortBy, sortOrder, statusFilter, addedByFilter, merchantId, storeType, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all sub-admins
         * @param {number} page Page number (starting from 1)
         * @param {GetAllSubAdminsLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllSubAdminsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllSubAdminsSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by name, email, or mobile number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubAdmins(page: number, limit: GetAllSubAdminsLimitEnum, sortBy: GetAllSubAdminsSortByEnum, sortOrder: GetAllSubAdminsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetAllSubAdminsResponse> {
            return localVarFp.getAllSubAdmins(page, limit, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all subscription plans with optional search, filtering, and sorting.
         * @summary Get a list of all subscription plans
         * @param {number} page Page number (starting from 1)
         * @param {GetAllSubscriptionPlansLimitEnum} limit Number of records per page
         * @param {string} [search] Search by plan name
         * @param {GetAllSubscriptionPlansPlanDurationInEnum} [planDurationIn] Filter by duration unit
         * @param {GetAllSubscriptionPlansStatusEnum} [status] Filter by active status
         * @param {GetAllSubscriptionPlansSortByEnum} [sortBy] Field to sort by
         * @param {GetAllSubscriptionPlansSortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllSubscriptionPlans(page: number, limit: GetAllSubscriptionPlansLimitEnum, search?: string, planDurationIn?: GetAllSubscriptionPlansPlanDurationInEnum, status?: GetAllSubscriptionPlansStatusEnum, sortBy?: GetAllSubscriptionPlansSortByEnum, sortOrder?: GetAllSubscriptionPlansSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPlan> {
            return localVarFp.getAllSubscriptionPlans(page, limit, search, planDurationIn, status, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all users with optional search and sorting parameters.
         * @summary Get a list of all users
         * @param {number} page Page number (starting from 1)
         * @param {GetAllUsersLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetAllUsersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
         * @param {GetAllUsersSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {string} [search] Search by user name, email, or mobile number
         * @param {GetAllUsersStatusEnum} [status] Filter by status
         * @param {GetAllUsersAddedByEnum} [addedBy] Filter by Added By
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(page: number, limit: GetAllUsersLimitEnum, sortBy: GetAllUsersSortByEnum, sortOrder: GetAllUsersSortOrderEnum, search?: string, status?: GetAllUsersStatusEnum, addedBy?: GetAllUsersAddedByEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAllUsersResponseSchema> {
            return localVarFp.getAllUsers(page, limit, sortBy, sortOrder, search, status, addedBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns available coupons for given stores
         * @param {GetAvailableCouponsRequest} getAvailableCouponsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCoupons(getAvailableCouponsRequest: GetAvailableCouponsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAvailableCouponsResponse> {
            return localVarFp.getAvailableCoupons(getAvailableCouponsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin retrieves all active offers that can be assigned to users
         * @summary Get available offers for assignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableOffersForAssignment(options?: RawAxiosRequestConfig): AxiosPromise<GetAvailableOffersForAssignment> {
            return localVarFp.getAvailableOffersForAssignment(options).then((request) => request(axios, basePath));
        },
        /**
         * Check the status and progress of a background bulk upload job
         * @summary Get status of a bulk upload job
         * @param {string} jobId The unique identifier of the bulk upload job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBulkUploadStatus(jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkUploadStatusResponseSchema> {
            return localVarFp.getBulkUploadStatus(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all available choice groups based on the selected store type.
         * @summary Get all choice groups
         * @param {string} storeId The ID of the store to which the choice groups belong
         * @param {string} [search] Search by choice group name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChoiceGroups(storeId: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChoiceGroupList>> {
            return localVarFp.getChoiceGroups(storeId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of all available choices based on the selected store.
         * @summary Get all choices
         * @param {string} storeId The ID of the store to which the choices belong
         * @param {string} [search] Search by choice name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChoicesList(storeId: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChoiceList>> {
            return localVarFp.getChoicesList(storeId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all active CMS pages for customer footer links with language support
         * @summary Get CMS pages for customer display
         * @param {GetCmsPagesForCustomerLangEnum} lang Language code (en, ar)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCmsPagesForCustomer(lang: GetCmsPagesForCustomerLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCmsPagesResponseSchema> {
            return localVarFp.getCmsPagesForCustomer(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the configuration settings for the end user.
         * @summary Get Configuration Settings
         * @param {GetConfigurationSettingsLanguageEnum} [language] Language filter for the configuration settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationSettings(language?: GetConfigurationSettingsLanguageEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<ConfigurationSettings>> {
            return localVarFp.getConfigurationSettings(language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Customer User Details (Mobile)
         * @param {string} userId The ID of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomerDetailsSchema> {
            return localVarFp.getCustomerDetails(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin retrieves detailed loyalty points history for a specific customer
         * @summary Get customer loyalty history
         * @param {string} userId 
         * @param {number} page Page number for pagination
         * @param {number} limit Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerLoyaltyHistory(userId: string, page: number, limit: number, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomerLoyaltyHistory> {
            return localVarFp.getCustomerLoyaltyHistory(userId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin retrieves customer list with orders, wallet, loyalty, and offers data
         * @summary Get customers with full details
         * @param {number} page 
         * @param {number} limit 
         * @param {string} [search] 
         * @param {string} [sortBy] 
         * @param {GetCustomersDetailsForOffersSortOrderEnum} [sortOrder] 
         * @param {GetCustomersDetailsForOffersStatusEnum} [status] 
         * @param {GetCustomersDetailsForOffersCustomerTypeEnum} [customerType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersDetailsForOffers(page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetCustomersDetailsForOffersSortOrderEnum, status?: GetCustomersDetailsForOffersStatusEnum, customerType?: GetCustomersDetailsForOffersCustomerTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetCustomersDetailsForOffers> {
            return localVarFp.getCustomersDetailsForOffers(page, limit, search, sortBy, sortOrder, status, customerType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of all customers with their wallet information including balance, transaction history, and management actions.
         * @summary Get all customers with wallet details for admin panel
         * @param {number} page Page number (starting from 1)
         * @param {GetCustomersWithWalletDetailsLimitEnum} limit Number of records per page
         * @param {string} [search] Search by customer name, email, or phone number
         * @param {GetCustomersWithWalletDetailsSortByEnum} [sortBy] Field to sort by
         * @param {GetCustomersWithWalletDetailsSortOrderEnum} [sortOrder] Sort order
         * @param {GetCustomersWithWalletDetailsCustomerStatusEnum} [customerStatus] Filter by customer status
         * @param {GetCustomersWithWalletDetailsTransactionTypeEnum} [transactionType] Filter by recent transaction type
         * @param {string} [dateFrom] Filter transactions from this date (YYYY-MM-DD)
         * @param {string} [dateTo] Filter transactions to this date (YYYY-MM-DD)
         * @param {number} [transactionLimit] Number of recent transactions to return per customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersWithWalletDetails(page: number, limit: GetCustomersWithWalletDetailsLimitEnum, search?: string, sortBy?: GetCustomersWithWalletDetailsSortByEnum, sortOrder?: GetCustomersWithWalletDetailsSortOrderEnum, customerStatus?: GetCustomersWithWalletDetailsCustomerStatusEnum, transactionType?: GetCustomersWithWalletDetailsTransactionTypeEnum, dateFrom?: string, dateTo?: string, transactionLimit?: number, options?: RawAxiosRequestConfig): AxiosPromise<CustomerWalletListResponse> {
            return localVarFp.getCustomersWithWalletDetails(page, limit, search, sortBy, sortOrder, customerStatus, transactionType, dateFrom, dateTo, transactionLimit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns consolidated dashboard data with metrics, charts, and recent entries.
         * @param {GetDashboardMetricsDashboardTypeEnum} dashboardType Type of dashboard to retrieve (admin or merchant).
         * @param {string} fromDate Start date for dashboard data (inclusive, format YYYY-MM-DD).
         * @param {string} toDate End date for dashboard data (inclusive, format YYYY-MM-DD).
         * @param {string} [merchantId] Merchant ID for merchant-specific dashboards (required if dashboardType is merchant).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardMetrics(dashboardType: GetDashboardMetricsDashboardTypeEnum, fromDate: string, toDate: string, merchantId?: string, options?: RawAxiosRequestConfig): AxiosPromise<DashboardResponse> {
            return localVarFp.getDashboardMetrics(dashboardType, fromDate, toDate, merchantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all active FAQs for customer landing page with language support
         * @summary Get FAQs for customer display
         * @param {GetFaqsForCustomerLangEnum} lang Language code (en, ar)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaqsForCustomer(lang: GetFaqsForCustomerLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<CustomerFaqsResponseSchema> {
            return localVarFp.getFaqsForCustomer(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all featured store subscriptions for a merchant with optional filters
         * @summary Get featured store subscriptions
         * @param {string} merchantId Merchant ID to filter subscriptions
         * @param {string} [storeId] Optional store ID to filter subscriptions for a specific store
         * @param {GetFeaturedStoreSubscriptionsStatusEnum} [status] Optional status filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeaturedStoreSubscriptions(merchantId: string, storeId?: string, status?: GetFeaturedStoreSubscriptionsStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetFeaturedStoreSubscriptionsResponse> {
            return localVarFp.getFeaturedStoreSubscriptions(merchantId, storeId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns banners, filters, dynamic categories, and nearby/explore stores based on user location and store type.
         * @summary Get Home Page Data
         * @param {string} userId 
         * @param {number} latitude 
         * @param {number} longitude 
         * @param {GetHomePageDataForUserAppStoreTypeEnum} [storeType] 
         * @param {string} [search] 
         * @param {GetHomePageDataForUserAppSortByEnum} [sortBy] 
         * @param {GetHomePageDataForUserAppOffersEnum} [offers] 
         * @param {string} [cuisines] Filter stores by cuisine types. This is a dynamic filter.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomePageDataForUserApp(userId: string, latitude: number, longitude: number, storeType?: GetHomePageDataForUserAppStoreTypeEnum, search?: string, sortBy?: GetHomePageDataForUserAppSortByEnum, offers?: GetHomePageDataForUserAppOffersEnum, cuisines?: string, options?: RawAxiosRequestConfig): AxiosPromise<HomePageResponseSchema> {
            return localVarFp.getHomePageDataForUserApp(userId, latitude, longitude, storeType, search, sortBy, offers, cuisines, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all item categories
         * @param {number} page Page number (starting from 1)
         * @param {GetItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
         * @param {GetItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetItemCategoriesStatusFilterEnum} statusFilter Filter by category status
         * @param {GetItemCategoriesAddedByFilterEnum} addedByFilter Filter by category status
         * @param {string} [merchantId] The ID of the store to which the item category belongs
         * @param {string} [storeId] The ID of the store to which the item category belongs
         * @param {GetItemCategoriesStoreTypeEnum} [storeType] Filter item categories by store type
         * @param {string} [search] Search by category name (English or Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemCategories(page: number, limit: GetItemCategoriesLimitEnum, sortBy: GetItemCategoriesSortByEnum, sortOrder: GetItemCategoriesSortOrderEnum, statusFilter: GetItemCategoriesStatusFilterEnum, addedByFilter: GetItemCategoriesAddedByFilterEnum, merchantId?: string, storeId?: string, storeType?: GetItemCategoriesStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetItemCategories200Response> {
            return localVarFp.getItemCategories(page, limit, sortBy, sortOrder, statusFilter, addedByFilter, merchantId, storeId, storeType, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve user\'s loyalty points balance, earned history, redeemed history, and potential wallet credit
         * @summary Get user loyalty points and history
         * @param {string} userId The ID of the user
         * @param {GetLoyaltyPointsLangEnum} lang Language code for transaction descriptions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoyaltyPoints(userId: string, lang: GetLoyaltyPointsLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetLoyaltyPointsResponse> {
            return localVarFp.getLoyaltyPoints(userId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of merchants
         * @param {number} page 
         * @param {number} limit 
         * @param {GetMerchantsStoreTypeEnum} [storeType] Filter merchants by business type
         * @param {string} [search] 
         * @param {GetMerchantsSortByEnum} [sortBy] 
         * @param {GetMerchantsSortOrderEnum} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchants(page: number, limit: number, storeType?: GetMerchantsStoreTypeEnum, search?: string, sortBy?: GetMerchantsSortByEnum, sortOrder?: GetMerchantsSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<MerchantListSchema> {
            return localVarFp.getMerchants(page, limit, storeType, search, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of subscribers with optional search and sorting.
         * @summary Get list of subscribers
         * @param {number} page Page number (starts from 1)
         * @param {GetNewsletterSubscribersLimitEnum} limit Number of records per page
         * @param {string} [search] Search by email
         * @param {GetNewsletterSubscribersStatusEnum} [status] 
         * @param {GetNewsletterSubscribersSortByEnum} [sortBy] Field to sort by
         * @param {GetNewsletterSubscribersSortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletterSubscribers(page: number, limit: GetNewsletterSubscribersLimitEnum, search?: string, status?: GetNewsletterSubscribersStatusEnum, sortBy?: GetNewsletterSubscribersSortByEnum, sortOrder?: GetNewsletterSubscribersSortOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetAllNewsletterSubscribersResponse> {
            return localVarFp.getNewsletterSubscribers(page, limit, search, status, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves complete real-time tracking information for multi-store orders including store-level status, delivery partner info, timeline, items, refunds, and billing details
         * @summary Get comprehensive order tracking details
         * @param {string} orderId Unique identifier for the order (ObjectId or Order Number format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTracking(orderId: string, options?: RawAxiosRequestConfig): AxiosPromise<OrderTrackingResponse> {
            return localVarFp.getOrderTracking(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns list of active payment gateways with supported currencies
         * @summary Get available payment gateways
         * @param {string} [currency] Optional currency code to filter gateways by support
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentGateways(currency?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaymentGatewaysResponse> {
            return localVarFp.getPaymentGateways(currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns only public-facing settings without credentials or sensitive data
         * @summary Get public settings for mobile/web clients
         * @param {GetPublicSettingsLangEnum} [lang] Language code for multilingual content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicSettings(lang?: GetPublicSettingsLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<PublicSettingsResponse> {
            return localVarFp.getPublicSettings(lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve paginated referral report with search, sort, and filter capabilities for admin panel
         * @summary Get referral report for admin panel
         * @param {number} page Page number for pagination (default 1)
         * @param {number} limit Number of items per page (default 10, max 100)
         * @param {string} [search] Search term to filter by referrer name, referral code, or used user name
         * @param {GetReferralReportSortByEnum} [sortBy] Field to sort by
         * @param {GetReferralReportSortOrderEnum} [sortOrder] Sort order
         * @param {GetReferralReportStatusEnum} [status] Filter by referral status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralReport(page: number, limit: number, search?: string, sortBy?: GetReferralReportSortByEnum, sortOrder?: GetReferralReportSortOrderEnum, status?: GetReferralReportStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<ReferralReportResponse> {
            return localVarFp.getReferralReport(page, limit, search, sortBy, sortOrder, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of restaurant categories
         * @summary Get all restaurant categories
         * @param {string} page Page number for pagination
         * @param {string} limit Number of items per page
         * @param {GetRestaurantCategoriesStoreTypeEnum} [storeType] Filter store categories by type
         * @param {string} [search] Search term to filter categories
         * @param {GetRestaurantCategoriesStatusEnum} [status] Filter by status
         * @param {GetRestaurantCategoriesSortByEnum} [sortBy] Field to sort by
         * @param {GetRestaurantCategoriesSortDirectionEnum} [sortDirection] Direction of sorting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRestaurantCategories(page: string, limit: string, storeType?: GetRestaurantCategoriesStoreTypeEnum, search?: string, status?: GetRestaurantCategoriesStatusEnum, sortBy?: GetRestaurantCategoriesSortByEnum, sortDirection?: GetRestaurantCategoriesSortDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<RestaurantCategoryList> {
            return localVarFp.getRestaurantCategories(page, limit, storeType, search, status, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of review suggestion strings that can be shown in the UI.
         * @summary Get all review suggestions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewSuggestions(options?: RawAxiosRequestConfig): AxiosPromise<ReviewSuggestions> {
            return localVarFp.getReviewSuggestions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Web User Details (Admin & Merchant)
         * @param {string} userId The ID of the user making the request.
         * @param {GetSpecialUserDetailsUserTypeEnum} userType The platform type of the user making the request.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialUserDetails(userId: string, userType: GetSpecialUserDetailsUserTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetSpecialUserDetails200Response> {
            return localVarFp.getSpecialUserDetails(userId, userType, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches detailed information about a store by its ID, including type-specific fields for display on mobile screens.
         * @summary Retrieve Store Details
         * @param {string} storeId The unique identifier of the store
         * @param {string} userId The unique identifier of the user (optional, for personalized data)
         * @param {GetStoreDetailsLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreDetails(storeId: string, userId: string, lang: GetStoreDetailsLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<WritableStoreDataSchema> {
            return localVarFp.getStoreDetails(storeId, userId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches items available in the store (e.g., food for Restaurant, products for Grocery/Pharmacy) with optional filtering.
         * @summary Retrieve Store Items
         * @param {string} storeId The unique identifier of the store
         * @param {GetStoreMenuLanguageEnum} language 
         * @param {string} userId The unique identifier of the user (optional, for personalized data)
         * @param {string} [category] Filter items by category (e.g., Popular, Paratha)
         * @param {string} [search] Search term to filter items by name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreMenu(storeId: string, language: GetStoreMenuLanguageEnum, userId: string, category?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<StoreItem>; }> {
            return localVarFp.getStoreMenu(storeId, language, userId, category, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of stores. If merchantId is provided, returns stores for that specific merchant. If not provided, returns all stores.
         * @summary Get stores list
         * @param {string} [merchantId] Optional filter by merchant ID. If not provided, returns all stores.
         * @param {string} [search] Search by store name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoresListByMerchant(merchantId?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MerchantStore>> {
            return localVarFp.getStoresListByMerchant(merchantId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all sub-item categories
         * @param {string} parentCategoryId ID of the parent category to filter subcategories
         * @param {number} page Page number (starting from 1)
         * @param {GetSubItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
         * @param {GetSubItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
         * @param {GetSubItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
         * @param {GetSubItemCategoriesStatusFilterEnum} statusFilter Filter by subcategory status
         * @param {GetSubItemCategoriesAddedByFilterEnum} addedByFilter Filter by who added the subcategory
         * @param {string} [search] Search by subcategory name (English or Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubItemCategories(parentCategoryId: string, page: number, limit: GetSubItemCategoriesLimitEnum, sortBy: GetSubItemCategoriesSortByEnum, sortOrder: GetSubItemCategoriesSortOrderEnum, statusFilter: GetSubItemCategoriesStatusFilterEnum, addedByFilter: GetSubItemCategoriesAddedByFilterEnum, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<GetSubItemCategories200Response> {
            return localVarFp.getSubItemCategories(parentCategoryId, page, limit, sortBy, sortOrder, statusFilter, addedByFilter, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve tip status and details for a specific order
         * @summary Get tip status for an order
         * @param {string} userId The ID of the user
         * @param {string} orderId The order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTipStatus(userId: string, orderId: string, options?: RawAxiosRequestConfig): AxiosPromise<TipStatusResponseSchema> {
            return localVarFp.getTipStatus(userId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the complete cart with all items grouped by store
         * @summary Get user\'s complete cart
         * @param {string} userId User identifier
         * @param {GetUserCartStoreTypeEnum} storeType Store type to filter items by store.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCart(userId: string, storeType: GetUserCartStoreTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetUserCart200Response> {
            return localVarFp.getUserCart(userId, storeType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves user details necessary for the checkout process, including delivery address and contact information.
         * @summary Get user details required for checkout
         * @param {string} userId User ID to retrieve details for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCheckoutDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomerCheckoutDetails> {
            return localVarFp.getUserCheckoutDetails(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all reviews submitted by the authenticated user with filtering, sorting, and pagination options.
         * @summary Get user\'s review history
         * @param {string} userId User ID to fetch reviews for
         * @param {number} [page] Page number for pagination
         * @param {GetUserReviewsLimitEnum} [limit] Number of reviews per page
         * @param {GetUserReviewsTypeEnum} [type] Filter reviews by type (All returns all review types)
         * @param {string} [startDate] Filter reviews created on or after this date
         * @param {string} [endDate] Filter reviews created on or before this date
         * @param {GetUserReviewsRatingEnum} [rating] Filter reviews by specific rating
         * @param {GetUserReviewsSortByEnum} [sortBy] Field to sort by
         * @param {GetUserReviewsSortDirectionEnum} [sortDirection] Sort direction
         * @param {GetUserReviewsLangEnum} [lang] Language code for multilingual fields (itemName, storeName)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserReviews(userId: string, page?: number, limit?: GetUserReviewsLimitEnum, type?: GetUserReviewsTypeEnum, startDate?: string, endDate?: string, rating?: GetUserReviewsRatingEnum, sortBy?: GetUserReviewsSortByEnum, sortDirection?: GetUserReviewsSortDirectionEnum, lang?: GetUserReviewsLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<MyReviewsResponse> {
            return localVarFp.getUserReviews(userId, page, limit, type, startDate, endDate, rating, sortBy, sortDirection, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the complete wishList with all items grouped by store
         * @summary Get user\'s complete wishList
         * @param {string} userId User identifier
         * @param {GetUserWishListStoreTypeEnum} storeType Store type to filter items by store.
         * @param {GetUserWishListLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserWishList(userId: string, storeType: GetUserWishListStoreTypeEnum, lang: GetUserWishListLangEnum, options?: RawAxiosRequestConfig): AxiosPromise<GetUserWishListResponseSchema> {
            return localVarFp.getUserWishList(userId, storeType, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get wallet balance for checkout
         * @param {string} userId The ID of the user
         * @param {number} totalAmount Total checkout amount to compare with wallet balance
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletCheckoutBalance(userId: string, totalAmount: number, options?: RawAxiosRequestConfig): AxiosPromise<WalletCheckoutBalanceResponse> {
            return localVarFp.getWalletCheckoutBalance(userId, totalAmount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the current wallet balance for the user
         * @param {string} userId The ID of the user whose wallet details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetWalletDetailsResponse> {
            return localVarFp.getWalletDetails(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives payment events from Hyperpay
         * @summary Hyperpay webhook endpoint
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hyperpayWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.hyperpayWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate payment for one or more pending settlements using a payment gateway. User can select multiple settlements and pay them all at once in a single transaction. 
         * @summary Initiate bulk settlement payment
         * @param {InitiateSettlementPaymentRequest} initiateSettlementPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSettlementPayment(initiateSettlementPaymentRequest: InitiateSettlementPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<InitiateSettlementPaymentResponse> {
            return localVarFp.initiateSettlementPayment(initiateSettlementPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate a tip payment for a delivered order through payment gateway
         * @summary Initiate tip payment
         * @param {TipInitiateRequestSchema} tipInitiateRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTipPayment(tipInitiateRequestSchema: TipInitiateRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<TipInitiateResponseSchema> {
            return localVarFp.initiateTipPayment(tipInitiateRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of customers that can be selected for sending newsletters.
         * @summary List all customers
         * @param {string} [search] Search by customer name, phone or email
         * @param {ListCustomersUserTypeEnum} [userType] Filter by user type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCustomers(search?: string, userType?: ListCustomersUserTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomerListItem>> {
            return localVarFp.listCustomers(search, userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Log in a user (traditional or social)
         * @param {LoginUserRequest} [loginUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUser(loginUserRequest?: LoginUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.loginUser(loginUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply or remove a coupon during checkout
         * @param {ManageCouponRequest} manageCouponRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageCoupon(manageCouponRequest: ManageCouponRequest, options?: RawAxiosRequestConfig): AxiosPromise<ManageCouponResponse> {
            return localVarFp.manageCoupon(manageCouponRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks a specific notification as read for the authenticated user.
         * @summary Mark a notification as read
         * @param {MarkNotificationAsReadRequest} markNotificationAsReadRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead(markNotificationAsReadRequest: MarkNotificationAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.markNotificationAsRead(markNotificationAsReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates cart items, store capabilities, working hours, and calculates accurate order summary based on delivery mode (selfPickup/delivery) and order mode (normal/preOrder). This API sits between cart and checkout to provide comprehensive validations. 
         * @summary Prepare order with delivery mode and order type validations
         * @param {string} userId The ID of the user
         * @param {PrepareOrderLangEnum} lang Language preference for localized data (English or Arabic)
         * @param {PrepareOrderRequestSchema} prepareOrderRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        prepareOrder(userId: string, lang: PrepareOrderLangEnum, prepareOrderRequestSchema: PrepareOrderRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<PrepareOrderResponseSchema> {
            return localVarFp.prepareOrder(userId, lang, prepareOrderRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiate payment to feature a store for a specific period
         * @summary Purchase featured store subscription
         * @param {PurchaseFeaturedStoreRequest} purchaseFeaturedStoreRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseFeaturedStore(purchaseFeaturedStoreRequest: PurchaseFeaturedStoreRequest, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseFeaturedStoreResponse> {
            return localVarFp.purchaseFeaturedStore(purchaseFeaturedStoreRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Convert available loyalty points to wallet credit based on configured redemption rate
         * @summary Redeem loyalty points to wallet credit
         * @param {RedeemPointsRequest} redeemPointsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemPoints(redeemPointsRequest: RedeemPointsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RedeemPointsResponse> {
            return localVarFp.redeemPoints(redeemPointsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a new access token using a refresh token
         * @summary Refresh access token
         * @param {RefreshTokenRequestSchema} refreshTokenRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(refreshTokenRequestSchema: RefreshTokenRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.refreshToken(refreshTokenRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Resend the OTP to the user\'s email or phone number
         * @summary Resend OTP
         * @param {OtpRequest} otpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOtp(otpRequest: OtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.resendOtp(otpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset a user\'s password using a token
         * @summary Reset password
         * @param {ResetPasswordRequestSchema} resetPasswordRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequestSchema: ResetPasswordRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.resetPassword(resetPasswordRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search Delivery Boys by filter
         * @param {string} [name] Partial or full name of the delivery boy
         * @param {number} [latitude] Latitude coordinate
         * @param {number} [longitude] Longitude coordinate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDeliveryBoys(name?: string, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DeliveryBoyWithLocation>> {
            return localVarFp.searchDeliveryBoys(name, latitude, longitude, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a newsletter email to all users, particular users, all subscribers, or particular subscribers.
         * @summary Send newsletter to selected audience
         * @param {SendNewsletterRequest} sendNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNewsletter(sendNewsletterRequest: SendNewsletterRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.sendNewsletter(sendNewsletterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a push notification to users or delivery personnel based on the selected type and recipient.
         * @summary Send push notification
         * @param {SendPushNotificationRequest} sendPushNotificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPushNotification(sendPushNotificationRequest: SendPushNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.sendPushNotification(sendPushNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint sends a referral email to the specified user with the provided referral code.
         * @summary Send referral email to a user
         * @param {SendReferralEmailRequest} sendReferralEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReferralEmail(sendReferralEmailRequest: SendReferralEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendReferralEmailResponse> {
            return localVarFp.sendReferralEmail(sendReferralEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register a new user (traditional or social)
         * @param {SignupUserRequest} signupUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupUser(signupUserRequest: SignupUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<SignupSuccessResponse> {
            return localVarFp.signupUser(signupUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticates special users using either email or mobile number and returns role-specific user details
         * @summary Login for Special Users (SuperAdmin, SubAdmin, Merchant)
         * @param {SpecialUserLoginRequestSchema} specialUserLoginRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialUserLogin(specialUserLoginRequestSchema: SpecialUserLoginRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<LoginResponse> {
            return localVarFp.specialUserLogin(specialUserLoginRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Receives payment events from Stripe
         * @summary Stripe webhook endpoint
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhook(body: object, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.stripeWebhook(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows website visitors to subscribe to the newsletter. Public endpoint without authentication.
         * @summary Subscribe to newsletter from customer website
         * @param {SubscribeToNewsletterRequest} subscribeToNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeToNewsletter(subscribeToNewsletterRequest: SubscribeToNewsletterRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseSchema> {
            return localVarFp.subscribeToNewsletter(subscribeToNewsletterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle the status of multiple banner images by their IDs.
         * @summary Toggle status (blocked/unblocked) for multiple banner images
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleBannerImageStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleBannerImageStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple choice groups
         * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChoiceGroupStatus(toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleChoiceGroupStatus(toggleChoiceStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple choices
         * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleChoiceStatus(toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleChoiceStatus(toggleChoiceStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle the status of multiple cms pages by their IDs. This operation allows you to block or unblock multiple cms pages at once.
         * @summary Toggle status (blocked/unblocked) for multiple cms pages
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleCmsPagesStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleCmsPagesStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple coupons
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleCouponStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleCouponStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple delivery boys
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDeliveryBoyStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleDeliveryBoyStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple delivery managers
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleDeliveryManagerStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleDeliveryManagerStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle the status of multiple faqs by their IDs. This operation allows you to block or unblock multiple faqs at once.
         * @summary Toggle status (blocked/unblocked) for multiple faqs
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleFaqsStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleFaqsStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple categories
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleItemCategoriesStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleItemCategoriesStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Toggle the status of multiple items by their IDs. This operation allows you to block or unblock multiple items at once.
         * @summary Toggle status (blocked/unblocked) for multiple items
         * @param {ToggleItemStatusRequest} toggleItemStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleItemStatus(toggleItemStatusRequest: ToggleItemStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleItemStatus(toggleItemStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Block or unblock a merchant
         * @param {string} merchantId 
         * @param {ToggleMerchantActiveStatusRequest} toggleMerchantActiveStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleMerchantActiveStatus(merchantId: string, toggleMerchantActiveStatusRequest: ToggleMerchantActiveStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleMerchantActiveStatus(merchantId, toggleMerchantActiveStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle subscription status (subscribe/unsubscribe) of subscribers
         * @param {ToggleNewletterSubscriberStatusRequest} toggleNewletterSubscriberStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleNewletterSubscriberStatus(toggleNewletterSubscriberStatusRequest: ToggleNewletterSubscriberStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleNewletterSubscriberStatus(toggleNewletterSubscriberStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Admin blocks or unblocks offers
         * @summary Toggle offer status
         * @param {ToggleOfferStatusRequestSchema} toggleOfferStatusRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleOfferStatus(toggleOfferStatusRequestSchema: ToggleOfferStatusRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleOfferStatus(toggleOfferStatusRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint toggles the approval status of multiple reviews based on the provided IDs and status.
         * @summary Toggle status for multiple reviews
         * @param {ToggleReviewApprovalStatusRequest} toggleReviewApprovalStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleReviewApprovalStatus(toggleReviewApprovalStatusRequest: ToggleReviewApprovalStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleReviewApprovalStatus(toggleReviewApprovalStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple stores
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleStoreStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleStoreStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (blocked/unblocked) for multiple sub-admins
         * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleSubAdminStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleSubAdminStatus(toggleSubAdminStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle the status of multiple sub-item categories
         * @param {ToggleSubCategoryStatusRequest} toggleSubCategoryStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleSubCategoryStatus(toggleSubCategoryStatusRequest: ToggleSubCategoryStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleSubCategoryStatus(toggleSubCategoryStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle status (active/inactive) for multiple subscription plans
         * @param {ToggleSubscriptionPlanStatusRequest} toggleSubscriptionPlanStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleSubscriptionPlanStatus(toggleSubscriptionPlanStatusRequest: ToggleSubscriptionPlanStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleSubscriptionPlanStatus(toggleSubscriptionPlanStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint toggles the status of multiple users based on the provided IDs and status.
         * @summary Toggle status (blocked/unblocked) for multiple users
         * @param {ToggleUserStatusRequest} toggleUserStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleUserStatus(toggleUserStatusRequest: ToggleUserStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.toggleUserStatus(toggleUserStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a new delivery boy
         * @param {string} deliveryBoyId The ID of the delivery boy to be updated
         * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryBoy(deliveryBoyId: string, addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.updateDeliveryBoy(deliveryBoyId, addOrEditDeliveryBoyRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit an existing item in the system
         * @summary Edit an existing item
         * @param {string} itemId The ID of the item to be updated
         * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItem(itemId: string, addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.updateItem(itemId, addOrEditItemRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update stock of an item
         * @param {string} itemId The ID of the item to be updated
         * @param {UpdateItemStockRequestSchema} updateItemStockRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemStock(itemId: string, updateItemStockRequestSchema: UpdateItemStockRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.updateItemStock(itemId, updateItemStockRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update merchant by ID
         * @param {string} merchantId 
         * @param {MerchantSchema} merchantSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchant(merchantId: string, merchantSchema: MerchantSchema, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.updateMerchant(merchantId, merchantSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows updating the status of an order (e.g., cancel, accept, dispatch, deliver, etc.)
         * @summary Update order status
         * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderStatus(updateOrderStatusRequest: UpdateOrderStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.updateOrderStatus(updateOrderStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing restaurant category
         * @summary Update category
         * @param {string} categoryId Category ID
         * @param {UpdateRestaurantCategoryRequest} updateRestaurantCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRestaurantCategory(categoryId: string, updateRestaurantCategoryRequest: UpdateRestaurantCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMessage> {
            return localVarFp.updateRestaurantCategory(categoryId, updateRestaurantCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user\'s wallet by crediting or deducting an amount
         * @param {UpdateWalletRequest} updateWalletRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWallet(updateWalletRequest: UpdateWalletRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateWalletResponse> {
            return localVarFp.updateWallet(updateWalletRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify payment status and activate featured store subscription
         * @summary Verify featured store payment
         * @param {VerifyFeaturedPaymentRequest} verifyFeaturedPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyFeaturedPayment(verifyFeaturedPaymentRequest: VerifyFeaturedPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyFeaturedPaymentResponse> {
            return localVarFp.verifyFeaturedPayment(verifyFeaturedPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifies OTP for user (email or phone)
         * @param {VerifyOtpRequest} verifyOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyOtp(verifyOtpRequest: VerifyOtpRequest, options?: RawAxiosRequestConfig): AxiosPromise<VefiryOtpResponse> {
            return localVarFp.verifyOtp(verifyOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify payment status after user returns from payment gateway and create order if successful
         * @summary Verify payment and create order
         * @param {string} userId The ID of the user
         * @param {VerifyPaymentRequest} verifyPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPayment(userId: string, verifyPaymentRequest: VerifyPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyPaymentResponse> {
            return localVarFp.verifyPayment(userId, verifyPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint verifies if a referral code is valid and available for use. It only checks validation without consuming the code.
         * @summary Verify a referral code
         * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyReferralCode(verifyReferralCodeRequest: VerifyReferralCodeRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyReferralCodeResponse> {
            return localVarFp.verifyReferralCode(verifyReferralCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify the status of a settlement payment after user completes payment via gateway. Updates all settlements in the payment based on gateway response. 
         * @summary Verify settlement payment status
         * @param {VerifySettlementPaymentRequest} verifySettlementPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySettlementPayment(verifySettlementPaymentRequest: VerifySettlementPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifySettlementPaymentResponse> {
            return localVarFp.verifySettlementPayment(verifySettlementPaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify tip payment status after user completes payment
         * @summary Verify tip payment
         * @param {TipVerifyRequestSchema} tipVerifyRequestSchema 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTipPayment(tipVerifyRequestSchema: TipVerifyRequestSchema, options?: RawAxiosRequestConfig): AxiosPromise<TipVerifyResponseSchema> {
            return localVarFp.verifyTipPayment(tipVerifyRequestSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify wallet payment after gateway redirect
         * @param {VerifyWalletPaymentRequest} verifyWalletPaymentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyWalletPayment(verifyWalletPaymentRequest: VerifyWalletPaymentRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyWalletPaymentResponse> {
            return localVarFp.verifyWalletPayment(verifyWalletPaymentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Set banner image for the end user
     * @summary Set banner image for the end user
     * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addBannerImageSettings(dynamicHomePageContentSettings: DynamicHomePageContentSettings, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addBannerImageSettings(dynamicHomePageContentSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new choice to the system
     * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addChoice(addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addChoice(addOrEditChoiceRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new choice to the system
     * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addChoiceGroup(addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addChoiceGroup(addOrUpdateChoiceGroupRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new CMS page to the system
     * @summary Add a new CMS page
     * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addCmsPage(addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addCmsPage(addOrEditCmsPageRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set configuration settings for the end user
     * @summary Set configuration settings for the end user
     * @param {ConfigurationSettings} configurationSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addConfigurationSettings(configurationSettings: ConfigurationSettings, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addConfigurationSettings(configurationSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new coupon to the system
     * @summary Add a new coupon
     * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addCoupon(addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addCoupon(addOrEditCouponRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new delivery boy
     * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addDeliveryBoy(addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addDeliveryBoy(addOrEditDeliveryBoyRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new delivery manager to the system
     * @summary Add a new delivery manager
     * @param {AddDeliveryManagerRequestSchema} addDeliveryManagerRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addDeliveryManager(addDeliveryManagerRequestSchema: AddDeliveryManagerRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addDeliveryManager(addDeliveryManagerRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new faq to the system
     * @summary Add a new Faq
     * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addFaq(addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addFaq(addOrEditFaqRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new item
     * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addItem(addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addItem(addOrEditItemRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new item category
     * @param {CreateItemCategoryRequest} createItemCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addItemCategory(createItemCategoryRequest: CreateItemCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addItemCategory(createItemCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new item subcategory
     * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addItemSubCategory(createItemSubCategoryRequest: CreateItemSubCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addItemSubCategory(createItemSubCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new meal for a store with items and choice groups
     * @summary Add a new meal
     * @param {AddMealRequest} addMealRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addMeal(addMealRequest: AddMealRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addMeal(addMealRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin creates a new offer coupon
     * @summary Create a new offer
     * @param {AddOfferRequestSchema} addOfferRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOffer(addOfferRequestSchema: AddOfferRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOffer(addOfferRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a new subscription plan if `id` is not provided. If `id` is present, updates the existing subscription plan.
     * @summary Add or edit a subscription plan
     * @param {SubscriptionPlan} subscriptionPlan 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrEditSubscriptionPlan(subscriptionPlan: SubscriptionPlan, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrEditSubscriptionPlan(subscriptionPlan, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a specified item to the user\'s cart
     * @summary Add an item to the Cart
     * @param {string} userId User identifier
     * @param {AddOrUpdateCartRequestSchema} addOrUpdateCartRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrUpdateCart(userId: string, addOrUpdateCartRequestSchema: AddOrUpdateCartRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrUpdateCart(userId, addOrUpdateCartRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers or updates the FCM token for a user, allowing them to receive push notifications.
     * @summary Add or update device ID for push notifications
     * @param {AddOrUpdateDeviceIdRequest} addOrUpdateDeviceIdRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrUpdateDeviceId(addOrUpdateDeviceIdRequest: AddOrUpdateDeviceIdRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrUpdateDeviceId(addOrUpdateDeviceIdRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a specified item to the user\'s wishList
     * @summary Add or update an item to the wishList
     * @param {AddOrUpdateWishListRequestSchema} addOrUpdateWishListRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrUpdateUserWishList(addOrUpdateWishListRequestSchema: AddOrUpdateWishListRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrUpdateUserWishList(addOrUpdateWishListRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows a customer to submit a detailed review for a completed order, including: - App experience - Store rating - Delivery partner rating - Individual item ratings - Issues faced - Optional comments 
     * @summary Submit a review for an order
     * @param {AddReviewRequest} addReviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addOrderReview(addReviewRequest: AddReviewRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addOrderReview(addReviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a new store to the system
     * @param {WritableStoreDataSchema} writableStoreDataSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addStore(writableStoreDataSchema: WritableStoreDataSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addStore(writableStoreDataSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint adds a new address for a user.
     * @summary Add a new user address
     * @param {UserAddressSchema} userAddressSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addUserAddress(userAddressSchema: UserAddressSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addUserAddress(userAddressSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds a new notification for a user and updates the notification count.
     * @summary Add a user notification and update count
     * @param {AddUserNotificationRequest} addUserNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public addUserNotificationAndUpdateCount(addUserNotificationRequest: AddUserNotificationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).addUserNotificationAndUpdateCount(addUserNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows admin to assign a driver to an order either manually (by specifying driver ID) or automatically (system finds nearest available driver). The API updates order audits, notifies the driver, and optionally notifies the customer if driver is changed. 
     * @summary Admin assign driver to order manually or automatically
     * @param {AdminAssignDriverRequestSchema} adminAssignDriverRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public adminAssignDriver(adminAssignDriverRequestSchema: AdminAssignDriverRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).adminAssignDriver(adminAssignDriverRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin assigns specific offers to a user
     * @summary Assign offers to customer
     * @param {AssignOfferRequestSchema} assignOfferRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public assignOffer(assignOfferRequestSchema: AssignOfferRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).assignOffer(assignOfferRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Block or Unblock a restaurant category
     * @summary Block or Unblock restaurant category
     * @param {string} categoryId Category ID
     * @param {BlockOrUnblockRestaurantCategoryRequest} blockOrUnblockRestaurantCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public blockOrUnblockRestaurantCategory(categoryId: string, blockOrUnblockRestaurantCategoryRequest: BlockOrUnblockRestaurantCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).blockOrUnblockRestaurantCategory(categoryId, blockOrUnblockRestaurantCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload multiple items at once using Excel (.xlsx) or CSV (.csv) file. Files with 50 or fewer rows are processed synchronously, while larger files are processed in the background.
     * @summary Bulk upload items from Excel or CSV file
     * @param {string} storeId The ID of the store for which items are being uploaded
     * @param {BulkUploadItemAddedByEnum} addedBy Who is adding the items (Admin or Merchant)
     * @param {File} file Excel (.xlsx) or CSV (.csv) file containing items to upload
     * @param {string} [merchantId] The ID of the merchant (required for merchant users, optional for admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public bulkUploadItem(storeId: string, addedBy: BulkUploadItemAddedByEnum, file: File, merchantId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).bulkUploadItem(storeId, addedBy, file, merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calculate the total price for featuring a store based on date range and configured pricing
     * @summary Calculate featured store pricing
     * @param {CalculateFeaturedPriceRequest} calculateFeaturedPriceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public calculateFeaturedPrice(calculateFeaturedPriceRequest: CalculateFeaturedPriceRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).calculateFeaturedPrice(calculateFeaturedPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint allows a user to change their password.
     * @summary Change user password
     * @param {string} userId The ID of the user whose password is being changed
     * @param {ChangeUserPasswordUserTypeEnum} userType The type of user (e.g., customer, admin, subAdmin, merchant, deliveryPartner)
     * @param {ChangePasswordRequestSchema} changePasswordRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public changeUserPassword(userId: string, userType: ChangeUserPasswordUserTypeEnum, changePasswordRequestSchema: ChangePasswordRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).changeUserPassword(userId, userType, changePasswordRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a user exists based on userName, email, or phone
     * @param {CheckUserExistsRequest} checkUserExistsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkUserExists(checkUserExistsRequest: CheckUserExistsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkUserExists(checkUserExistsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checkout order
     * @param {string} userId The ID of the user
     * @param {CheckoutRequestSchema} checkoutRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkoutOrder(userId: string, checkoutRequestSchema: CheckoutRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkoutOrder(userId, checkoutRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new merchant to the platform
     * @summary Create a new merchant
     * @param {MerchantSchema} merchantSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createMerchant(merchantSchema: MerchantSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createMerchant(merchantSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new restaurant category
     * @summary Create new category
     * @param {CreateRestaurantCategoryRequest} createRestaurantCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createRestaurantCategory(createRestaurantCategoryRequest: CreateRestaurantCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createRestaurantCategory(createRestaurantCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint creates a new user with the provided details.
     * @summary Create a new admin user
     * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createSubAdminUser(addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createSubAdminUser(addOrEditSubAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint creates a new user with the provided details.
     * @summary Create a new user
     * @param {AddUserSchema} addUserSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public createUser(addUserSchema: AddUserSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).createUser(addUserSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple categories by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCategories(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCategories(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple choice groups by IDs
     * @param {DeleteChoicesRequest} deleteChoicesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteChoiceGroups(deleteChoicesRequest: DeleteChoicesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteChoiceGroups(deleteChoicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple choices by IDs
     * @param {DeleteChoicesRequest} deleteChoicesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteChoices(deleteChoicesRequest: DeleteChoicesRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteChoices(deleteChoicesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple cms pages by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCmsPages(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCmsPages(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple coupons by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteCoupons(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteCoupons(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple delivery boys by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteDeliveryBoys(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDeliveryBoys(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple delivery managers by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteDeliveryManagers(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteDeliveryManagers(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple faqs by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteFaqs(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteFaqs(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete banner images
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteHomePageBanner(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteHomePageBanner(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple items by IDs
     * @param {DeleteItemsRequest} deleteItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteItems(deleteItemsRequest: DeleteItemsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteItems(deleteItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete one or more meals by IDs
     * @summary Delete meals
     * @param {DeleteMealsRequest} deleteMealsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMeals(deleteMealsRequest: DeleteMealsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMeals(deleteMealsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete merchant by ID
     * @param {string} merchantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteMerchant(merchantId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteMerchant(merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete subscribers by IDs
     * @param {DeleteNewsletterSubscribersRequest} deleteNewsletterSubscribersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteNewsletterSubscribers(deleteNewsletterSubscribersRequest: DeleteNewsletterSubscribersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteNewsletterSubscribers(deleteNewsletterSubscribersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin deletes one or more offers
     * @summary Delete offers
     * @param {DeleteOffersRequestSchema} deleteOffersRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteOffers(deleteOffersRequestSchema: DeleteOffersRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteOffers(deleteOffersRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a restaurant category
     * @summary Delete restaurant category
     * @param {string} categoryId Category ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteRestaurantCategory(categoryId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteRestaurantCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint deletes multiple reviews based on the provided IDs.
     * @summary Delete multiple reviews by IDs
     * @param {DeleteReviewsRequest} deleteReviewsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteReviews(deleteReviewsRequest: DeleteReviewsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteReviews(deleteReviewsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple stores by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteStores(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteStores(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple sub-admins by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSubAdmins(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSubAdmins(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete multiple sub-item categories by IDs
     * @param {DeleteSubAdminsRequest} deleteSubAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSubItemCategory(deleteSubAdminsRequest: DeleteSubAdminsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSubItemCategory(deleteSubAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete subscription plans by IDs
     * @param {DeleteSubscriptionPlansRequest} deleteSubscriptionPlansRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteSubscriptionPlans(deleteSubscriptionPlansRequest: DeleteSubscriptionPlansRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteSubscriptionPlans(deleteSubscriptionPlansRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a specific address for the user.
     * @summary Delete a user address
     * @param {string} addressId The unique identifier of the address to delete.
     * @param {string} userId The ID of the user to whom the address belongs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteUserAddress(addressId: string, userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteUserAddress(addressId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint deletes multiple users based on the provided IDs.
     * @summary Delete multiple users by IDs
     * @param {DeleteUsersRequest} deleteUsersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public deleteUsers(deleteUsersRequest: DeleteUsersRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).deleteUsers(deleteUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed admin commission report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all stores and commission data across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total commission collected, total sales, average rate) 2. **Details Section**: Line-by-line listing of orders with commission breakdown  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Commission Type (common or custom) - Commission Percentage (rate applied, e.g., \"15%\") - Total Orders (count of orders in period) - Total Sales (total order amount / gross sales) - Commission Amount (commission collected from this store) - Average Commission per Order - Order Details (order ID, date, amount, commission calculated)  **Summary Fields (Overall):** - Total Commission Collected (sum across all stores) - Total Sales (All Stores) - Average Commission Rate (weighted average) - Store Count  **Commission Calculation:** Commission data is sourced from Commission Tracking records (recordType: admin_merchant): - Total Sales = totalOrderAmount - Commission Amount = totalAdminCommissionAmount - Commission Percentage:   * If merchant.commissionType === \"custom\" → merchant.commissionPercentage   * If merchant.commissionType === \"common\" → Platform default commission rate - Total Commission Collected = SUM(totalAdminCommissionAmount) across all filtered records  **Data Aggregation:** 1. Filter CommissionRecords by date range, store IDs, merchant ID, store type 2. Join with Merchant schema to get commission type and percentage 3. Join with Store schema to get store type 4. Group by store and calculate totals 5. Generate summary with platform-wide totals  **Date Filtering:** The dateRange parameter filters by order completion date (when commission was earned), not by commission payment or settlement date. 
     * @summary Download admin commission report
     * @param {AdminCommissionReportRequest} adminCommissionReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadAdminCommissionReport(adminCommissionReportRequest: AdminCommissionReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadAdminCommissionReport(adminCommissionReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a customized Excel template with store-specific categories, subcategories, and dropdown validations for bulk uploading items. Only XLSX format is supported.
     * @summary Download store-specific Excel template with customized dropdowns
     * @param {string} storeId Store ID for generating customized template with store-specific categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadBulkUploadTemplate(storeId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadBulkUploadTemplate(storeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed cancelled orders report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all cancelled orders across all stores - Merchants: Can only access cancelled orders from their own stores  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall 2. **Details Section**: Line-by-line listing of cancelled orders  **Cancellation States Included (Default):** - ORDER_CANCELLED: Customer or system cancelled after order placed - MERCHANT_CANCELLED: Merchant cancelled the order - DELIVERY_FAILED: Delivery attempt failed, order marked cancelled  **Refund Calculation:** Refund amounts include Settlement records with status COMPLETED or PENDING/INPROGRESS where transactionType = \'REFUND\' and isRefund = true.  **Date Filtering:** The dateRange parameter filters by CANCEL DATE (when order was cancelled), not by order creation date. 
     * @summary Download cancelled orders report
     * @param {CancelledOrdersReportRequest} cancelledOrdersReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadCancelledOrdersReport(cancelledOrdersReportRequest: CancelledOrdersReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadCancelledOrdersReport(cancelledOrdersReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed delivery performance report in Excel format with driver performance metrics.  **Access Control:** - Admins only: Can access delivery performance data for all drivers across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate performance metrics (total deliveries, avg time, on-time %, earnings) 2. **Details Section**: Line-by-line listing of deliveries with timestamps and performance indicators  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Orders Delivered (count of successfully delivered orders) - Average Delivery Time (from driver acceptance to delivery completion, in minutes) - Distance Covered (total kilometers traveled, calculated from GPS coordinates) - On-time Delivery Percentage (calculated by backend based on delivery time thresholds) - Delayed Deliveries Count (orders exceeding expected delivery time) - Cancelled Orders Count (ORDER_CANCELLED + DELIVERY_FAILED statuses) - Total Earnings (sum of delivery fees + driver bonuses for delivered orders) - Order Details (order ID, acceptance time, delivery time, duration, status)  **Performance Metrics Calculation:** - **Average Delivery Time**: Calculated as (deliveredTime - driverAcceptedTime) averaged across all delivered orders.   Time is measured in minutes from when the driver accepted the order to when delivery was completed.  - **Distance Covered**: Calculated from GPS coordinate tracking via DeliveryPartnerLocation records.   Backend uses haversine distance formula to calculate distance between consecutive location points   and sums the total distance traveled. Result is reported in kilometers with 2 decimal places.   **Note**: Distance is a calculated metric as no direct distance field exists in schemas.  - **On-time Delivery %**: Backend determines \"on-time\" threshold (typically 30-45 minutes based on   business rules) and calculates percentage of orders delivered within threshold.   Formula: (orders delivered within threshold / total delivered orders) × 100   **Note**: The on-time threshold logic is implemented in backend and may vary by region or store type.  - **Delayed Deliveries**: Count of orders where (deliveredTime - driverAcceptedTime) exceeds   the on-time threshold. These are orders that took longer than expected to complete.  - **Cancelled Orders**: Includes ORDER_CANCELLED (customer/merchant initiated cancellations) and   DELIVERY_FAILED (delivery attempts that could not be completed) statuses.  - **Total Earnings**: Sum of (deliveryFee + driverBonus) from EarningsBreakdown for ORDER_DELIVERED   orders only. Cancelled or failed orders do not contribute to earnings calculation.  **Multi-Store Order Handling:** Orders with multiple pickup locations (totalStoresCount > 1) are tracked with individual store pickup timestamps. Delivery time is measured from driver acceptance to final delivery completion, accounting for the complexity of multi-store pickups.  **Date Filtering:** The dateRange parameter filters by DELIVERY COMPLETION DATE (deliveredTime timestamp). This ensures performance metrics reflect when deliveries were actually completed, not when orders were placed or accepted by the driver.  **Order Status Filtering:** By default, includes ORDER_DELIVERED, ORDER_CANCELLED, and DELIVERY_FAILED statuses to provide comprehensive performance view. Successful deliveries contribute to positive metrics, while cancelled/failed orders are tracked separately for complete performance assessment. 
     * @summary Download delivery performance report
     * @param {DeliveryPerformanceReportRequest} deliveryPerformanceReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadDeliveryPerformanceReport(deliveryPerformanceReportRequest: DeliveryPerformanceReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadDeliveryPerformanceReport(deliveryPerformanceReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed driver payout report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all driver payouts across the platform - This endpoint is restricted to admin users only  **Report Structure:** Multi-driver reports generate separate worksheets per driver plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total deliveries, total earnings, settlement breakdown) 2. **Details Section**: Line-by-line listing of deliveries with all specified fields  **Report Fields:** - Driver ID - Driver Name (First Name + Last Name) - Driver Phone - Driver Email - Driver Status (blocked/unblocked) - Total Deliveries (count of orders delivered) - Total Earnings (sum of delivery fees + bonuses) - Delivery Fee Total - Driver Bonus Total - COD Collected (cash collected from customers) - Settlement Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Pending Amount (earnings not yet paid) - Paid Amount (earnings already settled) - Order Details (order ID, date, store name, customer name, amount)  **Earnings Calculation:** Total Earnings = Sum of (Delivery Fee + Driver Bonus) for all completed deliveries. - Delivery Fee: Base fee for delivery service - Driver Bonus: Emergency/urgent delivery bonuses - Earnings are calculated from orders with status ORDER_DELIVERED (default)  **Settlement Tracking:** Settlement records with transactionCategory = DELIVERY_FEE or DRIVER_BONUS and toUserType = DELIVERY_PARTNER are used to track payout status.  **Date Filtering:** The dateRange parameter filters by ORDER DELIVERY DATE (when order was delivered/completed), not by settlement/payout date. This shows earnings generated in the period, regardless of when they were paid out. 
     * @summary Download driver payout report
     * @param {DriverPayoutReportRequest} driverPayoutReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadDriverPayoutReport(driverPayoutReportRequest: DriverPayoutReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadDriverPayoutReport(driverPayoutReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed merchant payout report in Excel format with advanced filtering.  **Access Control:** - Admins: Can access all merchants and stores across the platform - Merchants: Can only access their own stores (403 Forbidden if accessing others)  **Report Structure:** Multi-merchant reports generate separate worksheets per merchant/store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total orders, gross sales, discounts, commission, net payout) 2. **Details Section**: Line-by-line listing of orders and settlements with all specified fields  **Report Fields:** - Store ID - Store Name - Store Type (Restaurant, GroceryStore, PharmacyStore) - Merchant Name - Merchant Email - Total Orders (count of orders in period) - Gross Sales (total order amount before deductions) - Discounts (wallet/coupon/offer deductions) - Admin Commission (platform commission amount) - Item Rejections (merchant rejected item amounts) - Customer Cancellations (customer cancelled item amounts) - Net Payout (amount payable to merchant) - Payout Status (PENDING, INPROGRESS, COMPLETED, FAILED, CANCELLED) - Payout Date (when payment was made) - Payment Reference No (transaction ID from payment system) - Payment Method (how merchant was paid) - Balance Due (outstanding amount not yet paid) - Order Details (order ID, date, customer, amount, status)  **Financial Calculations:** Financial data is sourced from Commission Tracking records: - Gross Sales = totalOrderAmount - Discounts = totalWalletCouponOfferAmount - Admin Commission = totalAdminCommissionAmount - Item Rejections = totalMerchantRejectedItemAmount - Customer Cancellations = totalUserCancelledItemAmount - Net Payout = Gross Sales - Admin Commission - Discounts - Rejections - Cancellations - Balance Due = balanceAmountToPay (positive = owe merchant, negative = merchant owes platform)  **Settlement Tracking:** Settlement records with toUserType = MERCHANT and transactionCategory = MERCHANT_PAYMENT are used to track payout status and payment references.  **Date Filtering:** The dateRange parameter determines the date range: - today: Today\'s settlements (midnight to now, UTC) - thisWeek: This week\'s settlements (Monday to now, UTC) - thisMonth: This month\'s settlements (1st to now, UTC) - last30Days: Last 30 days of settlements - thisYear: This year\'s settlements (Jan 1 to now, UTC) - custom: Use dateFrom and dateTo parameters (ISO 8601 UTC format)  Applies to order delivery dates (when sales occurred), not settlement payment dates. 
     * @summary Download merchant payout report
     * @param {MerchantPayoutReportRequest} merchantPayoutReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadMerchantPayoutReport(merchantPayoutReportRequest: MerchantPayoutReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadMerchantPayoutReport(merchantPayoutReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download order summary report with advanced filtering options in Excel format.  **Access Control:** - Admins: Can access orders from any store - Merchants: Can only access orders from their own stores  **Report Fields:** - Order ID: Unique order identifier - Store Name: Name of the store where order was placed - Store Type: Restaurant, GroceryStore, or PharmacyStore - Customer Name: Name of the customer who placed the order - Driver Name: Name of assigned delivery partner (or \"Not Assigned\" if no driver) - Order Date: Timestamp when order was placed - Order Status: Current order status (ORDER_DELIVERED, ORDER_CANCELLED, etc.) - Payment Method: How customer paid for the order - Order Total: Total order amount including all charges - Tax: Tax amount charged on the order - Delivery Fee: Delivery charge for the order - Net Amount: Confirmed amount after order processing (excludes cancelled/unavailable items)  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by delivery date or completion date.  **Net Amount vs Order Total:** - Order Total: Initial order amount at checkout (includes all items) - Net Amount: Final confirmed amount after processing (excludes cancelled/unavailable items) 
     * @summary Download order summary report
     * @param {OrderSummaryReportRequest} orderSummaryReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadOrderSummaryReport(orderSummaryReportRequest: OrderSummaryReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadOrderSummaryReport(orderSummaryReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed pending orders report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all pending orders across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total pending orders, orders by status, total order value, etc.) 2. **Details Section**: Line-by-line listing of pending orders with all specified fields  **Report Fields:** - Order ID - Store Name - Customer Name - Driver Assigned (name or \"Not Assigned\" if no driver) - Order Placed At (timestamp when order was created) - Order Total (total order amount) - Payment Method (Cash, Card, Wallet, Online, etc.) - Current Status (ORDER_PLACED, ORDER_ACCEPTED, etc.)  **What are \"Pending Orders\"?** Pending orders are orders that are currently in progress and have not been completed or cancelled. These include orders with statuses: ORDER_PLACED, ORDER_ACCEPTED, ORDER_READY_FOR_PICKUP, DRIVER_ACCEPTED, DRIVER_ARRIVED, DRIVER_PICKED_UP, DRIVER_ON_THE_WAY.  **Date Filtering:** The dateRange parameter filters by ORDER PLACED DATE (when order was created), not by order completion or delivery date. This helps identify orders that were placed within a specific time range and are still pending.  **Use Cases:** - Monitor orders currently being processed - Identify stuck or delayed orders - Track order fulfillment pipeline - Analyze order processing efficiency - Manage driver assignments for pending deliveries 
     * @summary Download pending orders report
     * @param {PendingOrdersReportRequest} pendingOrdersReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadPendingOrdersReport(pendingOrdersReportRequest: PendingOrdersReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadPendingOrdersReport(pendingOrdersReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed refund report in Excel format with advanced filtering.  **Access Control:** - Admins only: Can access all refunds across all stores - This endpoint is restricted to admin users only  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics (total refunds, total amount, count by method, etc.) 2. **Details Section**: Line-by-line listing of refunds with all specified fields  **Report Fields:** - Order ID - Customer Name - Store Name - Refund Amount - Refund Reason - Refund Method (Wallet, Online, Manual) - Refund Date - Approved By (Admin name and email)  **Date Filtering:** The dateRange parameter filters by REFUND DATE (when refund was processed), not by order creation date. 
     * @summary Download refund report
     * @param {RefundReportRequest} refundReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadRefundReport(refundReportRequest: RefundReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadRefundReport(refundReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a detailed rejected orders report in Excel format with advanced filtering.  **Access Control:** - **Admins**: Can access all rejected orders across all stores, including both merchant and driver rejections - **Merchants**: Can only access rejected orders from their own stores, and ONLY merchant rejections (no delivery partner information)  **Report Structure:** Multi-store reports generate separate worksheets per store plus an overview sheet. Each worksheet contains: 1. **Summary Section**: Aggregate metrics for that store/overall    - Total rejected orders    - Count by rejection type (merchant vs driver - admin only)    - Count by store type    - Most common rejection reasons 2. **Details Section**: Line-by-line listing of rejected orders  **Report Fields:** - **Order ID**: Unique identifier for the order - **Store Name**: Name of the store/restaurant - **Customer Name**: Name of the customer who placed the order - **Rejected By**: Who rejected the order   - For merchants: Always shows \"Store\" (only merchant rejections visible)   - For admins: Shows \"Store\" or \"Driver\" based on rejection type - **Delivery Partner Name** (Admin only, driver rejections): Name of the delivery partner who rejected   - Only shown for driver rejections when user is admin   - Not visible to merchant users - **Reject Reason**: Reason provided for rejection - **Order Time**: Timestamp when order was placed - **Rejected Time**: Timestamp when order/items were rejected  **What are \"Rejected Orders\"?**  Rejected orders include:  1. **Merchant Rejections** (Visible to both merchants and admins):    - Orders with status MERCHANT_DENIED (merchant rejected before acceptance)    - Orders with items marked as isRejected=true (partial or full item rejection)    - Tracked via rejectionReason field in StoreOrderItem schema  2. **Driver Rejections** (Visible to admins only):    - Orders where delivery driver denied/rejected the assignment    - Tracked via deniedAt, denialType, and denialReason in DeliveryInfo schema    - Includes both manual driver rejections and auto-rejections (timeout)  **Role-Based Data Access:**  - **Merchants**: Will NEVER see driver rejection data, even if they set rejectedBy=driver_rejected or include deliveryPartnerIds.   The backend automatically scopes merchant requests to only merchant rejections from their own stores.   The \"Delivery Partner Name\" field will not appear in merchant reports.  - **Admins**: Can set rejectedBy to either:   - merchant_rejected: Generate merchant rejection report only   - driver_rejected: Generate delivery partner rejection report only   - Omit the parameter: Include both merchant and driver rejections in the report    Can use deliveryPartnerIds to filter by specific delivery partners (only applicable when rejectedBy=driver_rejected).   The \"Delivery Partner Name\" field appears for driver rejections.  **Date Filtering:**  The dateRange parameter filters by REJECTION TIME: - For merchant rejections: When order was denied or items were marked rejected - For driver rejections: The deniedAt timestamp (admin only)  This differs from order creation date and helps identify when rejections occurred.  **Use Cases:** - Analyze rejection patterns and trends - Identify stores with high rejection rates - Track common rejection reasons for operational improvements - Monitor driver rejection patterns (admin only) - Filter by specific delivery partners to analyze their rejection behavior (admin only) - Understand customer impact from rejected orders 
     * @summary Download rejected orders report
     * @param {RejectedOrdersReportRequest} rejectedOrdersReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadRejectedOrdersReport(rejectedOrdersReportRequest: RejectedOrdersReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadRejectedOrdersReport(rejectedOrdersReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download sales report with advanced filtering options in Excel format. - Admins: Can access any store - Merchants: Can filter by their own stores 
     * @summary Download sales report
     * @param {SalesReportRequest} salesReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public downloadSalesReport(salesReportRequest: SalesReportRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).downloadSalesReport(salesReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing admin
     * @param {string} userId The ID of the admin to be updated
     * @param {EditAdminRequest} editAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editAdmin(userId: string, editAdminRequest: EditAdminRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editAdmin(userId, editAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing choice in the system
     * @param {string} choiceId The ID of the delivery manager to be updated
     * @param {AddOrEditChoiceRequestSchema} addOrEditChoiceRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editChoice(choiceId: string, addOrEditChoiceRequestSchema: AddOrEditChoiceRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editChoice(choiceId, addOrEditChoiceRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing choice group in the system
     * @param {string} choiceGroupId The ID of the delivery manager to be updated
     * @param {AddOrUpdateChoiceGroupRequestSchema} addOrUpdateChoiceGroupRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editChoiceGroup(choiceGroupId: string, addOrUpdateChoiceGroupRequestSchema: AddOrUpdateChoiceGroupRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editChoiceGroup(choiceGroupId, addOrUpdateChoiceGroupRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing CMS page in the system
     * @summary Edit an existing CMS page
     * @param {string} pageId The ID of the CMS page to be updated
     * @param {AddOrEditCmsPageRequestSchema} addOrEditCmsPageRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editCmsPage(pageId: string, addOrEditCmsPageRequestSchema: AddOrEditCmsPageRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editCmsPage(pageId, addOrEditCmsPageRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing coupon in the system
     * @summary Edit an existing coupon
     * @param {string} couponId The ID of the coupon to be updated
     * @param {AddOrEditCouponRequestSchema} addOrEditCouponRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editCoupon(couponId: string, addOrEditCouponRequestSchema: AddOrEditCouponRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editCoupon(couponId, addOrEditCouponRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing delivery manager to the system
     * @summary Edit an existing delivery manager
     * @param {string} deliveryManagerId The ID of the delivery manager to be updated
     * @param {EditDeliveryManagerRequestSchema} editDeliveryManagerRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editDeliveryManager(deliveryManagerId: string, editDeliveryManagerRequestSchema: EditDeliveryManagerRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editDeliveryManager(deliveryManagerId, editDeliveryManagerRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing faq in the system
     * @summary Edit an existing Faq
     * @param {string} faqId The ID of the faq to be updated
     * @param {AddOrEditFaqRequestSchema} addOrEditFaqRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editFaq(faqId: string, addOrEditFaqRequestSchema: AddOrEditFaqRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editFaq(faqId, addOrEditFaqRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing home page banner in the system
     * @summary Edit an existing Home Page Banner
     * @param {string} bannerId The ID of the banner to be updated
     * @param {DynamicHomePageContentSettings} dynamicHomePageContentSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editHomePageBanner(bannerId: string, dynamicHomePageContentSettings: DynamicHomePageContentSettings, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editHomePageBanner(bannerId, dynamicHomePageContentSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing item category
     * @param {string} categoryId The ID of the item category to be updated
     * @param {CreateItemCategoryRequest} createItemCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editItemCategory(categoryId: string, createItemCategoryRequest: CreateItemCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editItemCategory(categoryId, createItemCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a meal with new details, items, and choice groups
     * @summary Edit an existing meal
     * @param {string} mealId The ID of the meal to be updated
     * @param {EditMealRequest} editMealRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editMeal(mealId: string, editMealRequest: EditMealRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editMeal(mealId, editMealRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin updates an existing offer
     * @summary Edit an offer
     * @param {string} offerId 
     * @param {EditOfferRequestSchema} editOfferRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editOffer(offerId: string, editOfferRequestSchema: EditOfferRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editOffer(offerId, editOfferRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing item category
     * @param {string} storeId The ID of the store to be updated
     * @param {WritableStoreDataSchema} writableStoreDataSchema 
     * @param {string} [merchantId] The ID of the merchant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editStore(storeId: string, writableStoreDataSchema: WritableStoreDataSchema, merchantId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editStore(storeId, writableStoreDataSchema, merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing item category
     * @param {string} storeId The ID of the restaurant to be updated
     * @param {WritableRestaurantDataSchema} writableRestaurantDataSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editStoreForAdmin(storeId: string, writableRestaurantDataSchema: WritableRestaurantDataSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editStoreForAdmin(storeId, writableRestaurantDataSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing sub-admin
     * @param {string} id The ID of the sub-admin to be updated
     * @param {AddOrEditSubAdminRequest} addOrEditSubAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editSubAdmin(id: string, addOrEditSubAdminRequest: AddOrEditSubAdminRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editSubAdmin(id, addOrEditSubAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit an existing sub-item category
     * @param {string} subCategoryId The ID of the sub-item category to be updated
     * @param {CreateItemSubCategoryRequest} createItemSubCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editSubItemCategory(subCategoryId: string, createItemSubCategoryRequest: CreateItemSubCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editSubItemCategory(subCategoryId, createItemSubCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint edits an existing address for a user.
     * @summary Edit an existing user address
     * @param {UserAddressSchema} userAddressSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editUserAddress(userAddressSchema: UserAddressSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editUserAddress(userAddressSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint updates the details of an existing user.
     * @summary Edit an existing user
     * @param {string} userId The ID of the user to be updated
     * @param {EditUserRequestSchema} editUserRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public editUserById(userId: string, editUserRequestSchema: EditUserRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).editUserById(userId, editUserRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates password reset by sending a link (email) or code (SMS) to the user
     * @summary Send reset password link or code to user
     * @param {ForgotPasswordRequestSchema} forgotPasswordRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public forgotPassword(forgotPasswordRequestSchema: ForgotPasswordRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).forgotPassword(forgotPasswordRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a unique coupon code for the specified coupon.
     * @summary Generate a unique coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateCouponCode(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateCouponCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generates OTP for email or phone number
     * @param {OtpRequest} otpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateOtp(otpRequest: OtpRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateOtp(otpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a presigned URL for uploading, downloading, or deleting a file from AWS S3.
     * @summary Generate a presigned URL for AWS S3 operations
     * @param {GeneratePresignedUrlRequest} generatePresignedUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generatePresignedUrl(generatePresignedUrlRequest: GeneratePresignedUrlRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generatePresignedUrl(generatePresignedUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint generates a unique referral code for the specified user. Each user can generate their own referral code to share with others.
     * @summary Generate a referral code for a specific user
     * @param {string} userId The ID of the user to generate a referral code for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public generateReferralCode(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).generateReferralCode(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all banner images
     * @summary Get a list of all banner images
     * @param {number} page Page number (starting from 1)
     * @param {GetAllBannerImagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllBannerImagesSortByEnum} sortBy Field to sort by image text
     * @param {GetAllBannerImagesSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by image text
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllBannerImages(page: number, limit: GetAllBannerImagesLimitEnum, sortBy: GetAllBannerImagesSortByEnum, sortOrder: GetAllBannerImagesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllBannerImages(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all choice groups with optional search and sorting parameters.
     * @summary Get a list of all choice groups
     * @param {number} page Page number (starting from 1)
     * @param {GetAllChoiceGroupsLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllChoiceGroupsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
     * @param {GetAllChoiceGroupsSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [merchantId] The ID of the store to which the item category belongs
     * @param {string} [storeId] Filter choice groups by specific store ID
     * @param {GetAllChoiceGroupsStoreTypeEnum} [storeType] Filter choice groups by store type
     * @param {string} [search] Search by name, email, or mobile number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllChoiceGroups(page: number, limit: GetAllChoiceGroupsLimitEnum, sortBy: GetAllChoiceGroupsSortByEnum, sortOrder: GetAllChoiceGroupsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoiceGroupsStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllChoiceGroups(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all choices with optional search and sorting parameters.
     * @summary Get a list of all choices
     * @param {number} page Page number (starting from 1)
     * @param {GetAllChoicesLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllChoicesSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
     * @param {GetAllChoicesSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [merchantId] The ID of the merchant to which the choices belong
     * @param {string} [storeId] Filter choices by specific store ID
     * @param {GetAllChoicesStoreTypeEnum} [storeType] Filter choices by store type
     * @param {string} [search] Search by name, email, or mobile number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllChoices(page: number, limit: GetAllChoicesLimitEnum, sortBy: GetAllChoicesSortByEnum, sortOrder: GetAllChoicesSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllChoicesStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllChoices(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
     * @summary Get a list of all cms pages
     * @param {number} page Page number (starting from 1)
     * @param {GetAllCmsPagesLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllCmsPagesSortByEnum} sortBy Field to sort by (title, createdAt, status)
     * @param {GetAllCmsPagesSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by page title
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllCmsPages(page: number, limit: GetAllCmsPagesLimitEnum, sortBy: GetAllCmsPagesSortByEnum, sortOrder: GetAllCmsPagesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllCmsPages(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all types of commission tracking data (merchant, admin merchant, delivery partner) with optional transaction details in a single API call
     * @summary Get unified commission tracking data and transactions
     * @param {number} page Page number for pagination
     * @param {number} limit Number of items per page
     * @param {GetAllCommissionTrackingRecordTypeEnum} recordType Filter by user type (merchant, admin merchant, delivery partner)
     * @param {GetAllCommissionTrackingSortByEnum} [sortBy] Field to sort by
     * @param {GetAllCommissionTrackingSortOrderEnum} [sortOrder] Sort order (ascending or descending)
     * @param {string} [search] Full-text search on merchant name, restaurant name, email, delivery partner details, transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllCommissionTracking(page: number, limit: number, recordType: GetAllCommissionTrackingRecordTypeEnum, sortBy?: GetAllCommissionTrackingSortByEnum, sortOrder?: GetAllCommissionTrackingSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllCommissionTracking(page, limit, recordType, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all coupons with optional search and sorting parameters.
     * @summary Get a list of all coupons
     * @param {number} page Page number (starting from 1)
     * @param {GetAllCouponsLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllCouponsSortByEnum} sortBy Field to sort by (coupon name, code, type, validity, start date, status, coupons left)
     * @param {GetAllCouponsSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by coupon name, coupon code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllCoupons(page: number, limit: GetAllCouponsLimitEnum, sortBy: GetAllCouponsSortByEnum, sortOrder: GetAllCouponsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllCoupons(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all delivery boys with optional search and sorting parameters.
     * @summary Get a list of all delivery boys
     * @param {number} page Page number (starting from 1)
     * @param {GetAllDeliveryBoysLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllDeliveryBoysSortByEnum} sortBy Field to sort by (name, email, mobile number)
     * @param {GetAllDeliveryBoysSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by delivery boy name, delivery boy email, or delivery boy mobile number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllDeliveryBoys(page: number, limit: GetAllDeliveryBoysLimitEnum, sortBy: GetAllDeliveryBoysSortByEnum, sortOrder: GetAllDeliveryBoysSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllDeliveryBoys(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all delivery managers with optional search and sorting parameters.
     * @summary Get a list of all delivery managers
     * @param {number} page Page number (starting from 1)
     * @param {GetAllDeliveryManagersLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllDeliveryManagersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
     * @param {GetAllDeliveryManagersSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by name, email, or mobile number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllDeliveryManagers(page: number, limit: GetAllDeliveryManagersLimitEnum, sortBy: GetAllDeliveryManagersSortByEnum, sortOrder: GetAllDeliveryManagersSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllDeliveryManagers(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all cms pages with optional search and sorting parameters.
     * @summary Get a list of all cms pages
     * @param {number} page Page number (starting from 1)
     * @param {GetAllFaqsLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllFaqsSortByEnum} sortBy Field to sort by question, createdAt, or status
     * @param {GetAllFaqsSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by page title
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllFaqs(page: number, limit: GetAllFaqsLimitEnum, sortBy: GetAllFaqsSortByEnum, sortOrder: GetAllFaqsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllFaqs(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all items with optional search and sorting parameters.
     * @summary Get a list of all items with stocks
     * @param {number} page Page number (starting from 1)
     * @param {GetAllItemStocksLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllItemStocksSortByEnum} sortBy Field to sort by product code, item name, restaurant name, merchant name, creaeted at
     * @param {GetAllItemStocksSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [merchantId] The ID of the merchant to filter items by
     * @param {string} [search] Search by product code, item name, restaurant name, merchant name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllItemStocks(page: number, limit: GetAllItemStocksLimitEnum, sortBy: GetAllItemStocksSortByEnum, sortOrder: GetAllItemStocksSortOrderEnum, merchantId?: string, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllItemStocks(page, limit, sortBy, sortOrder, merchantId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all items with optional search and sorting parameters.
     * @summary Get a list of all items
     * @param {number} page Page number (starting from 1)
     * @param {GetAllItemsLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllItemsSortByEnum} sortBy Field to sort by (name, itemCode, lastLoginDate, lastLogoutDate)
     * @param {GetAllItemsSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [merchantId] The ID of the store to which the item category belongs
     * @param {string} [storeId] Filter items by specific store ID
     * @param {GetAllItemsStoreTypeEnum} [storeType] Filter items by store type
     * @param {string} [search] Search by name, item code, or restaurant name
     * @param {GetAllItemsStockAvailabilityEnum} [stockAvailability] Filter by status
     * @param {GetAllItemsAddedByEnum} [addedBy] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllItems(page: number, limit: GetAllItemsLimitEnum, sortBy: GetAllItemsSortByEnum, sortOrder: GetAllItemsSortOrderEnum, merchantId?: string, storeId?: string, storeType?: GetAllItemsStoreTypeEnum, search?: string, stockAvailability?: GetAllItemsStockAvailabilityEnum, addedBy?: GetAllItemsAddedByEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllItems(page, limit, sortBy, sortOrder, merchantId, storeId, storeType, search, stockAvailability, addedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of meals with filtering and sorting options
     * @summary Get all meals
     * @param {number} [page] Page number for pagination
     * @param {number} [limit] Number of meals per page
     * @param {string} [search] Search term for meal name
     * @param {string} [sortBy] Field to sort by
     * @param {GetAllMealsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [storeId] Filter by store ID
     * @param {GetAllMealsStoreTypeEnum} [storeType] Filter by store type
     * @param {GetAllMealsStatusEnum} [status] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllMeals(page?: number, limit?: number, search?: string, sortBy?: string, sortOrder?: GetAllMealsSortOrderEnum, storeId?: string, storeType?: GetAllMealsStoreTypeEnum, status?: GetAllMealsStatusEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllMeals(page, limit, search, sortBy, sortOrder, storeId, storeType, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all notifications
     * @param {string} userId ID of the user to fetch notifications for.
     * @param {GetAllNotificationsUserTypeEnum} userType 
     * @param {number} page 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllNotifications(userId: string, userType: GetAllNotificationsUserTypeEnum, page: number, limit?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllNotifications(userId, userType, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin retrieves all offer coupons with pagination and filtering
     * @summary Get all offers
     * @param {number} page 
     * @param {number} limit 
     * @param {string} [search] 
     * @param {string} [sortBy] 
     * @param {GetAllOffersSortOrderEnum} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllOffers(page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetAllOffersSortOrderEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllOffers(page, limit, search, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a comprehensive list of orders with role-based filtering and data access. Response structure varies based on userType using discriminator pattern. 
     * @summary Get unified order details for all user types
     * @param {GetAllOrdersUserTypeEnum} userType Type of user making the request
     * @param {string} [userId] Unique identifier of the user making the request
     * @param {GetAllOrdersLangEnum} [lang] Language code for localized content
     * @param {number} [page] Page number for pagination
     * @param {number} [limit] Number of items per page
     * @param {string} [orderId] Filter by specific order ID (for individual order lookup)
     * @param {string} [storeId] Filter by specific store ID
     * @param {GetAllOrdersStatusEnum} [status] Filter by order status
     * @param {string} [fromDate] Filter orders from this date (YYYY-MM-DD)
     * @param {string} [toDate] Filter orders until this date (YYYY-MM-DD)
     * @param {GetAllOrdersSortByEnum} [sortBy] Field to sort by
     * @param {GetAllOrdersSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Full-text search on customer name, store name, item name, order ID
     * @param {GetAllOrdersOrderModeEnum} [orderMode] Filter by order mode (normal or pre-order)
     * @param {boolean} [requiresManualAssignment] Filter orders that require manual driver assignment (urgent orders, no drivers available)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllOrders(userType: GetAllOrdersUserTypeEnum, userId?: string, lang?: GetAllOrdersLangEnum, page?: number, limit?: number, orderId?: string, storeId?: string, status?: GetAllOrdersStatusEnum, fromDate?: string, toDate?: string, sortBy?: GetAllOrdersSortByEnum, sortOrder?: GetAllOrdersSortOrderEnum, search?: string, orderMode?: GetAllOrdersOrderModeEnum, requiresManualAssignment?: boolean, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllOrders(userType, userId, lang, page, limit, orderId, storeId, status, fromDate, toDate, sortBy, sortOrder, search, orderMode, requiresManualAssignment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of restaurant categories with their details.
     * @summary Get a list of restaurant categories
     * @param {GetAllRestaurantCategoriesStoreTypeEnum} storeType The type of store to which the restaurant belongs (Grocery or Restaurant)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllRestaurantCategories(storeType: GetAllRestaurantCategoriesStoreTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllRestaurantCategories(storeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all restaurant merchants.
     * @summary Get all restaurant merchants
     * @param {GetAllRestaurantMerchantsStoreTypeEnum} [storeType] Optional filter by store type. If not provided, returns all merchants regardless of store type.
     * @param {string} [search] Search by merchant name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllRestaurantMerchants(storeType?: GetAllRestaurantMerchantsStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllRestaurantMerchants(storeType, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of reviews
     * @summary Get all reviews
     * @param {GetAllReviewsTypeEnum} type type of reviews to fetch
     * @param {string} page Page number for pagination
     * @param {GetAllReviewsLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {string} [storeId] The ID of the merchant
     * @param {string} [merchantId] The ID of the merchant
     * @param {string} [search] Search term to filter categories
     * @param {GetAllReviewsStatusEnum} [status] Filter by status
     * @param {GetAllReviewsSortByEnum} [sortBy] Field to sort by
     * @param {GetAllReviewsSortDirectionEnum} [sortDirection] Direction of sorting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllReviews(type: GetAllReviewsTypeEnum, page: string, limit: GetAllReviewsLimitEnum, storeId?: string, merchantId?: string, search?: string, status?: GetAllReviewsStatusEnum, sortBy?: GetAllReviewsSortByEnum, sortDirection?: GetAllReviewsSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllReviews(type, page, limit, storeId, merchantId, search, status, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve transactions based on user type with filtering and pagination. Transactions are categorized as: - **toPay**: Amount user needs to pay - **toReceive**: Amount user will receive - **completed**: Completed transactions 
     * @summary Get All Settlements
     * @param {GetAllSettlementsUserTypeEnum} userType Type of user requesting transactions
     * @param {number} page Page number for pagination
     * @param {number} limit Number of items per page
     * @param {string} [userId] ID of the user. Required for MERCHANT, CUSTOMER, and DELIVERY_PARTNER. Optional for ADMIN (auto-loaded if not provided).
     * @param {GetAllSettlementsTransactionTypeEnum} [transactionType] Filter by transaction category
     * @param {string} [fromDate] Start date for filtering (ISO 8601 format)
     * @param {string} [toDate] End date for filtering (ISO 8601 format)
     * @param {GetAllSettlementsSortByEnum} [sortBy] Sort field
     * @param {GetAllSettlementsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search in description or reference number
     * @param {GetAllSettlementsSettlementUserTypeEnum} [settlementUserType] Filter settlements by user type (MERCHANT, CUSTOMER, or DELIVERY_PARTNER). Use with settlementUserId to filter by specific user.
     * @param {string} [settlementUserId] Filter settlements by specific user ID. Use with settlementUserType to filter by merchantId, customerId, or deliveryPartnerId.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllSettlements(userType: GetAllSettlementsUserTypeEnum, page: number, limit: number, userId?: string, transactionType?: GetAllSettlementsTransactionTypeEnum, fromDate?: string, toDate?: string, sortBy?: GetAllSettlementsSortByEnum, sortOrder?: GetAllSettlementsSortOrderEnum, search?: string, settlementUserType?: GetAllSettlementsSettlementUserTypeEnum, settlementUserId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllSettlements(userType, page, limit, userId, transactionType, fromDate, toDate, sortBy, sortOrder, search, settlementUserType, settlementUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all restaurants with detailed information
     * @param {number} page Page number (starting from 1)
     * @param {GetAllStoresForAdminLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllStoresForAdminSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
     * @param {GetAllStoresForAdminSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {GetAllStoresForAdminStatusFilterEnum} statusFilter Filter by category status
     * @param {GetAllStoresForAdminAddedByFilterEnum} addedByFilter Filter by who added the restaurant
     * @param {string} [merchantId] 
     * @param {GetAllStoresForAdminStoreTypeEnum} [storeType] Filter stores by type
     * @param {string} [search] Search by restaurant name, merchant name, category, email, or mobile number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllStoresForAdmin(page: number, limit: GetAllStoresForAdminLimitEnum, sortBy: GetAllStoresForAdminSortByEnum, sortOrder: GetAllStoresForAdminSortOrderEnum, statusFilter: GetAllStoresForAdminStatusFilterEnum, addedByFilter: GetAllStoresForAdminAddedByFilterEnum, merchantId?: string, storeType?: GetAllStoresForAdminStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllStoresForAdmin(page, limit, sortBy, sortOrder, statusFilter, addedByFilter, merchantId, storeType, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all sub-admins
     * @param {number} page Page number (starting from 1)
     * @param {GetAllSubAdminsLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllSubAdminsSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
     * @param {GetAllSubAdminsSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by name, email, or mobile number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllSubAdmins(page: number, limit: GetAllSubAdminsLimitEnum, sortBy: GetAllSubAdminsSortByEnum, sortOrder: GetAllSubAdminsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllSubAdmins(page, limit, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all subscription plans with optional search, filtering, and sorting.
     * @summary Get a list of all subscription plans
     * @param {number} page Page number (starting from 1)
     * @param {GetAllSubscriptionPlansLimitEnum} limit Number of records per page
     * @param {string} [search] Search by plan name
     * @param {GetAllSubscriptionPlansPlanDurationInEnum} [planDurationIn] Filter by duration unit
     * @param {GetAllSubscriptionPlansStatusEnum} [status] Filter by active status
     * @param {GetAllSubscriptionPlansSortByEnum} [sortBy] Field to sort by
     * @param {GetAllSubscriptionPlansSortOrderEnum} [sortOrder] Sort order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllSubscriptionPlans(page: number, limit: GetAllSubscriptionPlansLimitEnum, search?: string, planDurationIn?: GetAllSubscriptionPlansPlanDurationInEnum, status?: GetAllSubscriptionPlansStatusEnum, sortBy?: GetAllSubscriptionPlansSortByEnum, sortOrder?: GetAllSubscriptionPlansSortOrderEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllSubscriptionPlans(page, limit, search, planDurationIn, status, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all users with optional search and sorting parameters.
     * @summary Get a list of all users
     * @param {number} page Page number (starting from 1)
     * @param {GetAllUsersLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetAllUsersSortByEnum} sortBy Field to sort by (name, email, mobileNumber, lastLoginDate, lastLogoutDate)
     * @param {GetAllUsersSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {string} [search] Search by user name, email, or mobile number
     * @param {GetAllUsersStatusEnum} [status] Filter by status
     * @param {GetAllUsersAddedByEnum} [addedBy] Filter by Added By
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAllUsers(page: number, limit: GetAllUsersLimitEnum, sortBy: GetAllUsersSortByEnum, sortOrder: GetAllUsersSortOrderEnum, search?: string, status?: GetAllUsersStatusEnum, addedBy?: GetAllUsersAddedByEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAllUsers(page, limit, sortBy, sortOrder, search, status, addedBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns available coupons for given stores
     * @param {GetAvailableCouponsRequest} getAvailableCouponsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableCoupons(getAvailableCouponsRequest: GetAvailableCouponsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableCoupons(getAvailableCouponsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin retrieves all active offers that can be assigned to users
     * @summary Get available offers for assignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getAvailableOffersForAssignment(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getAvailableOffersForAssignment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check the status and progress of a background bulk upload job
     * @summary Get status of a bulk upload job
     * @param {string} jobId The unique identifier of the bulk upload job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getBulkUploadStatus(jobId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getBulkUploadStatus(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all available choice groups based on the selected store type.
     * @summary Get all choice groups
     * @param {string} storeId The ID of the store to which the choice groups belong
     * @param {string} [search] Search by choice group name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getChoiceGroups(storeId: string, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getChoiceGroups(storeId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of all available choices based on the selected store.
     * @summary Get all choices
     * @param {string} storeId The ID of the store to which the choices belong
     * @param {string} [search] Search by choice name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getChoicesList(storeId: string, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getChoicesList(storeId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all active CMS pages for customer footer links with language support
     * @summary Get CMS pages for customer display
     * @param {GetCmsPagesForCustomerLangEnum} lang Language code (en, ar)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCmsPagesForCustomer(lang: GetCmsPagesForCustomerLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCmsPagesForCustomer(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the configuration settings for the end user.
     * @summary Get Configuration Settings
     * @param {GetConfigurationSettingsLanguageEnum} [language] Language filter for the configuration settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getConfigurationSettings(language?: GetConfigurationSettingsLanguageEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getConfigurationSettings(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Customer User Details (Mobile)
     * @param {string} userId The ID of the user making the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCustomerDetails(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomerDetails(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin retrieves detailed loyalty points history for a specific customer
     * @summary Get customer loyalty history
     * @param {string} userId 
     * @param {number} page Page number for pagination
     * @param {number} limit Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCustomerLoyaltyHistory(userId: string, page: number, limit: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomerLoyaltyHistory(userId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin retrieves customer list with orders, wallet, loyalty, and offers data
     * @summary Get customers with full details
     * @param {number} page 
     * @param {number} limit 
     * @param {string} [search] 
     * @param {string} [sortBy] 
     * @param {GetCustomersDetailsForOffersSortOrderEnum} [sortOrder] 
     * @param {GetCustomersDetailsForOffersStatusEnum} [status] 
     * @param {GetCustomersDetailsForOffersCustomerTypeEnum} [customerType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCustomersDetailsForOffers(page: number, limit: number, search?: string, sortBy?: string, sortOrder?: GetCustomersDetailsForOffersSortOrderEnum, status?: GetCustomersDetailsForOffersStatusEnum, customerType?: GetCustomersDetailsForOffersCustomerTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomersDetailsForOffers(page, limit, search, sortBy, sortOrder, status, customerType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of all customers with their wallet information including balance, transaction history, and management actions.
     * @summary Get all customers with wallet details for admin panel
     * @param {number} page Page number (starting from 1)
     * @param {GetCustomersWithWalletDetailsLimitEnum} limit Number of records per page
     * @param {string} [search] Search by customer name, email, or phone number
     * @param {GetCustomersWithWalletDetailsSortByEnum} [sortBy] Field to sort by
     * @param {GetCustomersWithWalletDetailsSortOrderEnum} [sortOrder] Sort order
     * @param {GetCustomersWithWalletDetailsCustomerStatusEnum} [customerStatus] Filter by customer status
     * @param {GetCustomersWithWalletDetailsTransactionTypeEnum} [transactionType] Filter by recent transaction type
     * @param {string} [dateFrom] Filter transactions from this date (YYYY-MM-DD)
     * @param {string} [dateTo] Filter transactions to this date (YYYY-MM-DD)
     * @param {number} [transactionLimit] Number of recent transactions to return per customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getCustomersWithWalletDetails(page: number, limit: GetCustomersWithWalletDetailsLimitEnum, search?: string, sortBy?: GetCustomersWithWalletDetailsSortByEnum, sortOrder?: GetCustomersWithWalletDetailsSortOrderEnum, customerStatus?: GetCustomersWithWalletDetailsCustomerStatusEnum, transactionType?: GetCustomersWithWalletDetailsTransactionTypeEnum, dateFrom?: string, dateTo?: string, transactionLimit?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getCustomersWithWalletDetails(page, limit, search, sortBy, sortOrder, customerStatus, transactionType, dateFrom, dateTo, transactionLimit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns consolidated dashboard data with metrics, charts, and recent entries.
     * @param {GetDashboardMetricsDashboardTypeEnum} dashboardType Type of dashboard to retrieve (admin or merchant).
     * @param {string} fromDate Start date for dashboard data (inclusive, format YYYY-MM-DD).
     * @param {string} toDate End date for dashboard data (inclusive, format YYYY-MM-DD).
     * @param {string} [merchantId] Merchant ID for merchant-specific dashboards (required if dashboardType is merchant).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getDashboardMetrics(dashboardType: GetDashboardMetricsDashboardTypeEnum, fromDate: string, toDate: string, merchantId?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getDashboardMetrics(dashboardType, fromDate, toDate, merchantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all active FAQs for customer landing page with language support
     * @summary Get FAQs for customer display
     * @param {GetFaqsForCustomerLangEnum} lang Language code (en, ar)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFaqsForCustomer(lang: GetFaqsForCustomerLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFaqsForCustomer(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all featured store subscriptions for a merchant with optional filters
     * @summary Get featured store subscriptions
     * @param {string} merchantId Merchant ID to filter subscriptions
     * @param {string} [storeId] Optional store ID to filter subscriptions for a specific store
     * @param {GetFeaturedStoreSubscriptionsStatusEnum} [status] Optional status filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getFeaturedStoreSubscriptions(merchantId: string, storeId?: string, status?: GetFeaturedStoreSubscriptionsStatusEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getFeaturedStoreSubscriptions(merchantId, storeId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns banners, filters, dynamic categories, and nearby/explore stores based on user location and store type.
     * @summary Get Home Page Data
     * @param {string} userId 
     * @param {number} latitude 
     * @param {number} longitude 
     * @param {GetHomePageDataForUserAppStoreTypeEnum} [storeType] 
     * @param {string} [search] 
     * @param {GetHomePageDataForUserAppSortByEnum} [sortBy] 
     * @param {GetHomePageDataForUserAppOffersEnum} [offers] 
     * @param {string} [cuisines] Filter stores by cuisine types. This is a dynamic filter.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getHomePageDataForUserApp(userId: string, latitude: number, longitude: number, storeType?: GetHomePageDataForUserAppStoreTypeEnum, search?: string, sortBy?: GetHomePageDataForUserAppSortByEnum, offers?: GetHomePageDataForUserAppOffersEnum, cuisines?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getHomePageDataForUserApp(userId, latitude, longitude, storeType, search, sortBy, offers, cuisines, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all item categories
     * @param {number} page Page number (starting from 1)
     * @param {GetItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
     * @param {GetItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {GetItemCategoriesStatusFilterEnum} statusFilter Filter by category status
     * @param {GetItemCategoriesAddedByFilterEnum} addedByFilter Filter by category status
     * @param {string} [merchantId] The ID of the store to which the item category belongs
     * @param {string} [storeId] The ID of the store to which the item category belongs
     * @param {GetItemCategoriesStoreTypeEnum} [storeType] Filter item categories by store type
     * @param {string} [search] Search by category name (English or Arabic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getItemCategories(page: number, limit: GetItemCategoriesLimitEnum, sortBy: GetItemCategoriesSortByEnum, sortOrder: GetItemCategoriesSortOrderEnum, statusFilter: GetItemCategoriesStatusFilterEnum, addedByFilter: GetItemCategoriesAddedByFilterEnum, merchantId?: string, storeId?: string, storeType?: GetItemCategoriesStoreTypeEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getItemCategories(page, limit, sortBy, sortOrder, statusFilter, addedByFilter, merchantId, storeId, storeType, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve user\'s loyalty points balance, earned history, redeemed history, and potential wallet credit
     * @summary Get user loyalty points and history
     * @param {string} userId The ID of the user
     * @param {GetLoyaltyPointsLangEnum} lang Language code for transaction descriptions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getLoyaltyPoints(userId: string, lang: GetLoyaltyPointsLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getLoyaltyPoints(userId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of merchants
     * @param {number} page 
     * @param {number} limit 
     * @param {GetMerchantsStoreTypeEnum} [storeType] Filter merchants by business type
     * @param {string} [search] 
     * @param {GetMerchantsSortByEnum} [sortBy] 
     * @param {GetMerchantsSortOrderEnum} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getMerchants(page: number, limit: number, storeType?: GetMerchantsStoreTypeEnum, search?: string, sortBy?: GetMerchantsSortByEnum, sortOrder?: GetMerchantsSortOrderEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getMerchants(page, limit, storeType, search, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of subscribers with optional search and sorting.
     * @summary Get list of subscribers
     * @param {number} page Page number (starts from 1)
     * @param {GetNewsletterSubscribersLimitEnum} limit Number of records per page
     * @param {string} [search] Search by email
     * @param {GetNewsletterSubscribersStatusEnum} [status] 
     * @param {GetNewsletterSubscribersSortByEnum} [sortBy] Field to sort by
     * @param {GetNewsletterSubscribersSortOrderEnum} [sortOrder] Sort order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getNewsletterSubscribers(page: number, limit: GetNewsletterSubscribersLimitEnum, search?: string, status?: GetNewsletterSubscribersStatusEnum, sortBy?: GetNewsletterSubscribersSortByEnum, sortOrder?: GetNewsletterSubscribersSortOrderEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getNewsletterSubscribers(page, limit, search, status, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves complete real-time tracking information for multi-store orders including store-level status, delivery partner info, timeline, items, refunds, and billing details
     * @summary Get comprehensive order tracking details
     * @param {string} orderId Unique identifier for the order (ObjectId or Order Number format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getOrderTracking(orderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getOrderTracking(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns list of active payment gateways with supported currencies
     * @summary Get available payment gateways
     * @param {string} [currency] Optional currency code to filter gateways by support
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPaymentGateways(currency?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPaymentGateways(currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns only public-facing settings without credentials or sensitive data
     * @summary Get public settings for mobile/web clients
     * @param {GetPublicSettingsLangEnum} [lang] Language code for multilingual content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getPublicSettings(lang?: GetPublicSettingsLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getPublicSettings(lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve paginated referral report with search, sort, and filter capabilities for admin panel
     * @summary Get referral report for admin panel
     * @param {number} page Page number for pagination (default 1)
     * @param {number} limit Number of items per page (default 10, max 100)
     * @param {string} [search] Search term to filter by referrer name, referral code, or used user name
     * @param {GetReferralReportSortByEnum} [sortBy] Field to sort by
     * @param {GetReferralReportSortOrderEnum} [sortOrder] Sort order
     * @param {GetReferralReportStatusEnum} [status] Filter by referral status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getReferralReport(page: number, limit: number, search?: string, sortBy?: GetReferralReportSortByEnum, sortOrder?: GetReferralReportSortOrderEnum, status?: GetReferralReportStatusEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getReferralReport(page, limit, search, sortBy, sortOrder, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of restaurant categories
     * @summary Get all restaurant categories
     * @param {string} page Page number for pagination
     * @param {string} limit Number of items per page
     * @param {GetRestaurantCategoriesStoreTypeEnum} [storeType] Filter store categories by type
     * @param {string} [search] Search term to filter categories
     * @param {GetRestaurantCategoriesStatusEnum} [status] Filter by status
     * @param {GetRestaurantCategoriesSortByEnum} [sortBy] Field to sort by
     * @param {GetRestaurantCategoriesSortDirectionEnum} [sortDirection] Direction of sorting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getRestaurantCategories(page: string, limit: string, storeType?: GetRestaurantCategoriesStoreTypeEnum, search?: string, status?: GetRestaurantCategoriesStatusEnum, sortBy?: GetRestaurantCategoriesSortByEnum, sortDirection?: GetRestaurantCategoriesSortDirectionEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getRestaurantCategories(page, limit, storeType, search, status, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of review suggestion strings that can be shown in the UI.
     * @summary Get all review suggestions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getReviewSuggestions(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getReviewSuggestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Web User Details (Admin & Merchant)
     * @param {string} userId The ID of the user making the request.
     * @param {GetSpecialUserDetailsUserTypeEnum} userType The platform type of the user making the request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSpecialUserDetails(userId: string, userType: GetSpecialUserDetailsUserTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSpecialUserDetails(userId, userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches detailed information about a store by its ID, including type-specific fields for display on mobile screens.
     * @summary Retrieve Store Details
     * @param {string} storeId The unique identifier of the store
     * @param {string} userId The unique identifier of the user (optional, for personalized data)
     * @param {GetStoreDetailsLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStoreDetails(storeId: string, userId: string, lang: GetStoreDetailsLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStoreDetails(storeId, userId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches items available in the store (e.g., food for Restaurant, products for Grocery/Pharmacy) with optional filtering.
     * @summary Retrieve Store Items
     * @param {string} storeId The unique identifier of the store
     * @param {GetStoreMenuLanguageEnum} language 
     * @param {string} userId The unique identifier of the user (optional, for personalized data)
     * @param {string} [category] Filter items by category (e.g., Popular, Paratha)
     * @param {string} [search] Search term to filter items by name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStoreMenu(storeId: string, language: GetStoreMenuLanguageEnum, userId: string, category?: string, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStoreMenu(storeId, language, userId, category, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of stores. If merchantId is provided, returns stores for that specific merchant. If not provided, returns all stores.
     * @summary Get stores list
     * @param {string} [merchantId] Optional filter by merchant ID. If not provided, returns all stores.
     * @param {string} [search] Search by store name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getStoresListByMerchant(merchantId?: string, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getStoresListByMerchant(merchantId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all sub-item categories
     * @param {string} parentCategoryId ID of the parent category to filter subcategories
     * @param {number} page Page number (starting from 1)
     * @param {GetSubItemCategoriesLimitEnum} limit Number of records per page (10, 25, 50, 100)
     * @param {GetSubItemCategoriesSortByEnum} sortBy Field to sort by (nameEnglish, nameArabic, createdAt, addedBy)
     * @param {GetSubItemCategoriesSortOrderEnum} sortOrder Sort order (asc or desc)
     * @param {GetSubItemCategoriesStatusFilterEnum} statusFilter Filter by subcategory status
     * @param {GetSubItemCategoriesAddedByFilterEnum} addedByFilter Filter by who added the subcategory
     * @param {string} [search] Search by subcategory name (English or Arabic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getSubItemCategories(parentCategoryId: string, page: number, limit: GetSubItemCategoriesLimitEnum, sortBy: GetSubItemCategoriesSortByEnum, sortOrder: GetSubItemCategoriesSortOrderEnum, statusFilter: GetSubItemCategoriesStatusFilterEnum, addedByFilter: GetSubItemCategoriesAddedByFilterEnum, search?: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getSubItemCategories(parentCategoryId, page, limit, sortBy, sortOrder, statusFilter, addedByFilter, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve tip status and details for a specific order
     * @summary Get tip status for an order
     * @param {string} userId The ID of the user
     * @param {string} orderId The order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getTipStatus(userId: string, orderId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getTipStatus(userId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the complete cart with all items grouped by store
     * @summary Get user\'s complete cart
     * @param {string} userId User identifier
     * @param {GetUserCartStoreTypeEnum} storeType Store type to filter items by store.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCart(userId: string, storeType: GetUserCartStoreTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCart(userId, storeType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves user details necessary for the checkout process, including delivery address and contact information.
     * @summary Get user details required for checkout
     * @param {string} userId User ID to retrieve details for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserCheckoutDetails(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserCheckoutDetails(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all reviews submitted by the authenticated user with filtering, sorting, and pagination options.
     * @summary Get user\'s review history
     * @param {string} userId User ID to fetch reviews for
     * @param {number} [page] Page number for pagination
     * @param {GetUserReviewsLimitEnum} [limit] Number of reviews per page
     * @param {GetUserReviewsTypeEnum} [type] Filter reviews by type (All returns all review types)
     * @param {string} [startDate] Filter reviews created on or after this date
     * @param {string} [endDate] Filter reviews created on or before this date
     * @param {GetUserReviewsRatingEnum} [rating] Filter reviews by specific rating
     * @param {GetUserReviewsSortByEnum} [sortBy] Field to sort by
     * @param {GetUserReviewsSortDirectionEnum} [sortDirection] Sort direction
     * @param {GetUserReviewsLangEnum} [lang] Language code for multilingual fields (itemName, storeName)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserReviews(userId: string, page?: number, limit?: GetUserReviewsLimitEnum, type?: GetUserReviewsTypeEnum, startDate?: string, endDate?: string, rating?: GetUserReviewsRatingEnum, sortBy?: GetUserReviewsSortByEnum, sortDirection?: GetUserReviewsSortDirectionEnum, lang?: GetUserReviewsLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserReviews(userId, page, limit, type, startDate, endDate, rating, sortBy, sortDirection, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the complete wishList with all items grouped by store
     * @summary Get user\'s complete wishList
     * @param {string} userId User identifier
     * @param {GetUserWishListStoreTypeEnum} storeType Store type to filter items by store.
     * @param {GetUserWishListLangEnum} lang Language for multilingual fields (en for English, ar for Arabic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getUserWishList(userId: string, storeType: GetUserWishListStoreTypeEnum, lang: GetUserWishListLangEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getUserWishList(userId, storeType, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get wallet balance for checkout
     * @param {string} userId The ID of the user
     * @param {number} totalAmount Total checkout amount to compare with wallet balance
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getWalletCheckoutBalance(userId: string, totalAmount: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getWalletCheckoutBalance(userId, totalAmount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the current wallet balance for the user
     * @param {string} userId The ID of the user whose wallet details are to be fetched
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public getWalletDetails(userId: string, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).getWalletDetails(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receives payment events from Hyperpay
     * @summary Hyperpay webhook endpoint
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public hyperpayWebhook(body: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).hyperpayWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate payment for one or more pending settlements using a payment gateway. User can select multiple settlements and pay them all at once in a single transaction. 
     * @summary Initiate bulk settlement payment
     * @param {InitiateSettlementPaymentRequest} initiateSettlementPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public initiateSettlementPayment(initiateSettlementPaymentRequest: InitiateSettlementPaymentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).initiateSettlementPayment(initiateSettlementPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate a tip payment for a delivered order through payment gateway
     * @summary Initiate tip payment
     * @param {TipInitiateRequestSchema} tipInitiateRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public initiateTipPayment(tipInitiateRequestSchema: TipInitiateRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).initiateTipPayment(tipInitiateRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of customers that can be selected for sending newsletters.
     * @summary List all customers
     * @param {string} [search] Search by customer name, phone or email
     * @param {ListCustomersUserTypeEnum} [userType] Filter by user type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public listCustomers(search?: string, userType?: ListCustomersUserTypeEnum, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).listCustomers(search, userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Log in a user (traditional or social)
     * @param {LoginUserRequest} [loginUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public loginUser(loginUserRequest?: LoginUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).loginUser(loginUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply or remove a coupon during checkout
     * @param {ManageCouponRequest} manageCouponRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public manageCoupon(manageCouponRequest: ManageCouponRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).manageCoupon(manageCouponRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks a specific notification as read for the authenticated user.
     * @summary Mark a notification as read
     * @param {MarkNotificationAsReadRequest} markNotificationAsReadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public markNotificationAsRead(markNotificationAsReadRequest: MarkNotificationAsReadRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).markNotificationAsRead(markNotificationAsReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates cart items, store capabilities, working hours, and calculates accurate order summary based on delivery mode (selfPickup/delivery) and order mode (normal/preOrder). This API sits between cart and checkout to provide comprehensive validations. 
     * @summary Prepare order with delivery mode and order type validations
     * @param {string} userId The ID of the user
     * @param {PrepareOrderLangEnum} lang Language preference for localized data (English or Arabic)
     * @param {PrepareOrderRequestSchema} prepareOrderRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public prepareOrder(userId: string, lang: PrepareOrderLangEnum, prepareOrderRequestSchema: PrepareOrderRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).prepareOrder(userId, lang, prepareOrderRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiate payment to feature a store for a specific period
     * @summary Purchase featured store subscription
     * @param {PurchaseFeaturedStoreRequest} purchaseFeaturedStoreRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public purchaseFeaturedStore(purchaseFeaturedStoreRequest: PurchaseFeaturedStoreRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).purchaseFeaturedStore(purchaseFeaturedStoreRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Convert available loyalty points to wallet credit based on configured redemption rate
     * @summary Redeem loyalty points to wallet credit
     * @param {RedeemPointsRequest} redeemPointsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public redeemPoints(redeemPointsRequest: RedeemPointsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).redeemPoints(redeemPointsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a new access token using a refresh token
     * @summary Refresh access token
     * @param {RefreshTokenRequestSchema} refreshTokenRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public refreshToken(refreshTokenRequestSchema: RefreshTokenRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).refreshToken(refreshTokenRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resend the OTP to the user\'s email or phone number
     * @summary Resend OTP
     * @param {OtpRequest} otpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resendOtp(otpRequest: OtpRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resendOtp(otpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset a user\'s password using a token
     * @summary Reset password
     * @param {ResetPasswordRequestSchema} resetPasswordRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public resetPassword(resetPasswordRequestSchema: ResetPasswordRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).resetPassword(resetPasswordRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search Delivery Boys by filter
     * @param {string} [name] Partial or full name of the delivery boy
     * @param {number} [latitude] Latitude coordinate
     * @param {number} [longitude] Longitude coordinate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public searchDeliveryBoys(name?: string, latitude?: number, longitude?: number, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).searchDeliveryBoys(name, latitude, longitude, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a newsletter email to all users, particular users, all subscribers, or particular subscribers.
     * @summary Send newsletter to selected audience
     * @param {SendNewsletterRequest} sendNewsletterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendNewsletter(sendNewsletterRequest: SendNewsletterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendNewsletter(sendNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a push notification to users or delivery personnel based on the selected type and recipient.
     * @summary Send push notification
     * @param {SendPushNotificationRequest} sendPushNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendPushNotification(sendPushNotificationRequest: SendPushNotificationRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendPushNotification(sendPushNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint sends a referral email to the specified user with the provided referral code.
     * @summary Send referral email to a user
     * @param {SendReferralEmailRequest} sendReferralEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public sendReferralEmail(sendReferralEmailRequest: SendReferralEmailRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).sendReferralEmail(sendReferralEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register a new user (traditional or social)
     * @param {SignupUserRequest} signupUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public signupUser(signupUserRequest: SignupUserRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).signupUser(signupUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticates special users using either email or mobile number and returns role-specific user details
     * @summary Login for Special Users (SuperAdmin, SubAdmin, Merchant)
     * @param {SpecialUserLoginRequestSchema} specialUserLoginRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public specialUserLogin(specialUserLoginRequestSchema: SpecialUserLoginRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).specialUserLogin(specialUserLoginRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Receives payment events from Stripe
     * @summary Stripe webhook endpoint
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public stripeWebhook(body: object, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).stripeWebhook(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows website visitors to subscribe to the newsletter. Public endpoint without authentication.
     * @summary Subscribe to newsletter from customer website
     * @param {SubscribeToNewsletterRequest} subscribeToNewsletterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public subscribeToNewsletter(subscribeToNewsletterRequest: SubscribeToNewsletterRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).subscribeToNewsletter(subscribeToNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle the status of multiple banner images by their IDs.
     * @summary Toggle status (blocked/unblocked) for multiple banner images
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleBannerImageStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleBannerImageStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple choice groups
     * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleChoiceGroupStatus(toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleChoiceGroupStatus(toggleChoiceStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple choices
     * @param {ToggleChoiceStatusRequest} toggleChoiceStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleChoiceStatus(toggleChoiceStatusRequest: ToggleChoiceStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleChoiceStatus(toggleChoiceStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle the status of multiple cms pages by their IDs. This operation allows you to block or unblock multiple cms pages at once.
     * @summary Toggle status (blocked/unblocked) for multiple cms pages
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleCmsPagesStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleCmsPagesStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple coupons
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleCouponStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleCouponStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple delivery boys
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleDeliveryBoyStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleDeliveryBoyStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple delivery managers
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleDeliveryManagerStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleDeliveryManagerStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle the status of multiple faqs by their IDs. This operation allows you to block or unblock multiple faqs at once.
     * @summary Toggle status (blocked/unblocked) for multiple faqs
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleFaqsStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleFaqsStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple categories
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleItemCategoriesStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleItemCategoriesStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Toggle the status of multiple items by their IDs. This operation allows you to block or unblock multiple items at once.
     * @summary Toggle status (blocked/unblocked) for multiple items
     * @param {ToggleItemStatusRequest} toggleItemStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleItemStatus(toggleItemStatusRequest: ToggleItemStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleItemStatus(toggleItemStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Block or unblock a merchant
     * @param {string} merchantId 
     * @param {ToggleMerchantActiveStatusRequest} toggleMerchantActiveStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleMerchantActiveStatus(merchantId: string, toggleMerchantActiveStatusRequest: ToggleMerchantActiveStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleMerchantActiveStatus(merchantId, toggleMerchantActiveStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle subscription status (subscribe/unsubscribe) of subscribers
     * @param {ToggleNewletterSubscriberStatusRequest} toggleNewletterSubscriberStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleNewletterSubscriberStatus(toggleNewletterSubscriberStatusRequest: ToggleNewletterSubscriberStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleNewletterSubscriberStatus(toggleNewletterSubscriberStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin blocks or unblocks offers
     * @summary Toggle offer status
     * @param {ToggleOfferStatusRequestSchema} toggleOfferStatusRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleOfferStatus(toggleOfferStatusRequestSchema: ToggleOfferStatusRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleOfferStatus(toggleOfferStatusRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint toggles the approval status of multiple reviews based on the provided IDs and status.
     * @summary Toggle status for multiple reviews
     * @param {ToggleReviewApprovalStatusRequest} toggleReviewApprovalStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleReviewApprovalStatus(toggleReviewApprovalStatusRequest: ToggleReviewApprovalStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleReviewApprovalStatus(toggleReviewApprovalStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple stores
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleStoreStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleStoreStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (blocked/unblocked) for multiple sub-admins
     * @param {ToggleSubAdminStatusRequest} toggleSubAdminStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleSubAdminStatus(toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleSubAdminStatus(toggleSubAdminStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle the status of multiple sub-item categories
     * @param {ToggleSubCategoryStatusRequest} toggleSubCategoryStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleSubCategoryStatus(toggleSubCategoryStatusRequest: ToggleSubCategoryStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleSubCategoryStatus(toggleSubCategoryStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle status (active/inactive) for multiple subscription plans
     * @param {ToggleSubscriptionPlanStatusRequest} toggleSubscriptionPlanStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleSubscriptionPlanStatus(toggleSubscriptionPlanStatusRequest: ToggleSubscriptionPlanStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleSubscriptionPlanStatus(toggleSubscriptionPlanStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint toggles the status of multiple users based on the provided IDs and status.
     * @summary Toggle status (blocked/unblocked) for multiple users
     * @param {ToggleUserStatusRequest} toggleUserStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public toggleUserStatus(toggleUserStatusRequest: ToggleUserStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).toggleUserStatus(toggleUserStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a new delivery boy
     * @param {string} deliveryBoyId The ID of the delivery boy to be updated
     * @param {AddOrEditDeliveryBoyRequestSchema} addOrEditDeliveryBoyRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateDeliveryBoy(deliveryBoyId: string, addOrEditDeliveryBoyRequestSchema: AddOrEditDeliveryBoyRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateDeliveryBoy(deliveryBoyId, addOrEditDeliveryBoyRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit an existing item in the system
     * @summary Edit an existing item
     * @param {string} itemId The ID of the item to be updated
     * @param {AddOrEditItemRequestSchema} addOrEditItemRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateItem(itemId: string, addOrEditItemRequestSchema: AddOrEditItemRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateItem(itemId, addOrEditItemRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update stock of an item
     * @param {string} itemId The ID of the item to be updated
     * @param {UpdateItemStockRequestSchema} updateItemStockRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateItemStock(itemId: string, updateItemStockRequestSchema: UpdateItemStockRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateItemStock(itemId, updateItemStockRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update merchant by ID
     * @param {string} merchantId 
     * @param {MerchantSchema} merchantSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateMerchant(merchantId: string, merchantSchema: MerchantSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateMerchant(merchantId, merchantSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows updating the status of an order (e.g., cancel, accept, dispatch, deliver, etc.)
     * @summary Update order status
     * @param {UpdateOrderStatusRequest} updateOrderStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateOrderStatus(updateOrderStatusRequest: UpdateOrderStatusRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateOrderStatus(updateOrderStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing restaurant category
     * @summary Update category
     * @param {string} categoryId Category ID
     * @param {UpdateRestaurantCategoryRequest} updateRestaurantCategoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateRestaurantCategory(categoryId: string, updateRestaurantCategoryRequest: UpdateRestaurantCategoryRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateRestaurantCategory(categoryId, updateRestaurantCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user\'s wallet by crediting or deducting an amount
     * @param {UpdateWalletRequest} updateWalletRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public updateWallet(updateWalletRequest: UpdateWalletRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).updateWallet(updateWalletRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify payment status and activate featured store subscription
     * @summary Verify featured store payment
     * @param {VerifyFeaturedPaymentRequest} verifyFeaturedPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyFeaturedPayment(verifyFeaturedPaymentRequest: VerifyFeaturedPaymentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyFeaturedPayment(verifyFeaturedPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifies OTP for user (email or phone)
     * @param {VerifyOtpRequest} verifyOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyOtp(verifyOtpRequest: VerifyOtpRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyOtp(verifyOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify payment status after user returns from payment gateway and create order if successful
     * @summary Verify payment and create order
     * @param {string} userId The ID of the user
     * @param {VerifyPaymentRequest} verifyPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyPayment(userId: string, verifyPaymentRequest: VerifyPaymentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyPayment(userId, verifyPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint verifies if a referral code is valid and available for use. It only checks validation without consuming the code.
     * @summary Verify a referral code
     * @param {VerifyReferralCodeRequest} verifyReferralCodeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyReferralCode(verifyReferralCodeRequest: VerifyReferralCodeRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyReferralCode(verifyReferralCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify the status of a settlement payment after user completes payment via gateway. Updates all settlements in the payment based on gateway response. 
     * @summary Verify settlement payment status
     * @param {VerifySettlementPaymentRequest} verifySettlementPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifySettlementPayment(verifySettlementPaymentRequest: VerifySettlementPaymentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifySettlementPayment(verifySettlementPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify tip payment status after user completes payment
     * @summary Verify tip payment
     * @param {TipVerifyRequestSchema} tipVerifyRequestSchema 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyTipPayment(tipVerifyRequestSchema: TipVerifyRequestSchema, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyTipPayment(tipVerifyRequestSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify wallet payment after gateway redirect
     * @param {VerifyWalletPaymentRequest} verifyWalletPaymentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public verifyWalletPayment(verifyWalletPaymentRequest: VerifyWalletPaymentRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).verifyWalletPayment(verifyWalletPaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const BulkUploadItemAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;
export type BulkUploadItemAddedByEnum = typeof BulkUploadItemAddedByEnum[keyof typeof BulkUploadItemAddedByEnum];
/**
 * @export
 */
export const ChangeUserPasswordUserTypeEnum = {
    Customer: 'customer',
    Admin: 'admin',
    SubAdmin: 'subAdmin',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner'
} as const;
export type ChangeUserPasswordUserTypeEnum = typeof ChangeUserPasswordUserTypeEnum[keyof typeof ChangeUserPasswordUserTypeEnum];
/**
 * @export
 */
export const GetAllBannerImagesLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllBannerImagesLimitEnum = typeof GetAllBannerImagesLimitEnum[keyof typeof GetAllBannerImagesLimitEnum];
/**
 * @export
 */
export const GetAllBannerImagesSortByEnum = {
    ImageTextEnglish: 'imageTextEnglish',
    CreatedAt: 'createdAt'
} as const;
export type GetAllBannerImagesSortByEnum = typeof GetAllBannerImagesSortByEnum[keyof typeof GetAllBannerImagesSortByEnum];
/**
 * @export
 */
export const GetAllBannerImagesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllBannerImagesSortOrderEnum = typeof GetAllBannerImagesSortOrderEnum[keyof typeof GetAllBannerImagesSortOrderEnum];
/**
 * @export
 */
export const GetAllChoiceGroupsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllChoiceGroupsLimitEnum = typeof GetAllChoiceGroupsLimitEnum[keyof typeof GetAllChoiceGroupsLimitEnum];
/**
 * @export
 */
export const GetAllChoiceGroupsSortByEnum = {
    MerchantName: 'merchantName',
    Choice: 'choice',
    Choices: 'choices',
    CreatedAt: 'createdAt',
    MinimumLimit: 'minimumLimit',
    MaximumLimit: 'maximumLimit'
} as const;
export type GetAllChoiceGroupsSortByEnum = typeof GetAllChoiceGroupsSortByEnum[keyof typeof GetAllChoiceGroupsSortByEnum];
/**
 * @export
 */
export const GetAllChoiceGroupsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllChoiceGroupsSortOrderEnum = typeof GetAllChoiceGroupsSortOrderEnum[keyof typeof GetAllChoiceGroupsSortOrderEnum];
/**
 * @export
 */
export const GetAllChoiceGroupsStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetAllChoiceGroupsStoreTypeEnum = typeof GetAllChoiceGroupsStoreTypeEnum[keyof typeof GetAllChoiceGroupsStoreTypeEnum];
/**
 * @export
 */
export const GetAllChoicesLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllChoicesLimitEnum = typeof GetAllChoicesLimitEnum[keyof typeof GetAllChoicesLimitEnum];
/**
 * @export
 */
export const GetAllChoicesSortByEnum = {
    MerchantName: 'merchantName',
    Email: 'email',
    ChoiceName: 'choiceName',
    CreatedAt: 'createdAt'
} as const;
export type GetAllChoicesSortByEnum = typeof GetAllChoicesSortByEnum[keyof typeof GetAllChoicesSortByEnum];
/**
 * @export
 */
export const GetAllChoicesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllChoicesSortOrderEnum = typeof GetAllChoicesSortOrderEnum[keyof typeof GetAllChoicesSortOrderEnum];
/**
 * @export
 */
export const GetAllChoicesStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetAllChoicesStoreTypeEnum = typeof GetAllChoicesStoreTypeEnum[keyof typeof GetAllChoicesStoreTypeEnum];
/**
 * @export
 */
export const GetAllCmsPagesLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllCmsPagesLimitEnum = typeof GetAllCmsPagesLimitEnum[keyof typeof GetAllCmsPagesLimitEnum];
/**
 * @export
 */
export const GetAllCmsPagesSortByEnum = {
    Title: 'title',
    CreatedAt: 'createdAt',
    Status: 'status'
} as const;
export type GetAllCmsPagesSortByEnum = typeof GetAllCmsPagesSortByEnum[keyof typeof GetAllCmsPagesSortByEnum];
/**
 * @export
 */
export const GetAllCmsPagesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllCmsPagesSortOrderEnum = typeof GetAllCmsPagesSortOrderEnum[keyof typeof GetAllCmsPagesSortOrderEnum];
/**
 * @export
 */
export const GetAllCommissionTrackingRecordTypeEnum = {
    Merchant: 'merchant',
    AdminMerchant: 'adminMerchant',
    DeliveryPartner: 'deliveryPartner'
} as const;
export type GetAllCommissionTrackingRecordTypeEnum = typeof GetAllCommissionTrackingRecordTypeEnum[keyof typeof GetAllCommissionTrackingRecordTypeEnum];
/**
 * @export
 */
export const GetAllCommissionTrackingSortByEnum = {
    RestaurantName: 'restaurantName',
    MerchantName: 'merchantName',
    DeliveryPartnerName: 'deliveryPartnerName',
    TotalOrderAmount: 'totalOrderAmount',
    TotalCommissionAmount: 'totalCommissionAmount',
    BalanceAmount: 'balanceAmount',
    ReceivedAmount: 'receivedAmount',
    PaidAmount: 'paidAmount',
    TotalOrders: 'totalOrders',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt'
} as const;
export type GetAllCommissionTrackingSortByEnum = typeof GetAllCommissionTrackingSortByEnum[keyof typeof GetAllCommissionTrackingSortByEnum];
/**
 * @export
 */
export const GetAllCommissionTrackingSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllCommissionTrackingSortOrderEnum = typeof GetAllCommissionTrackingSortOrderEnum[keyof typeof GetAllCommissionTrackingSortOrderEnum];
/**
 * @export
 */
export const GetAllCouponsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllCouponsLimitEnum = typeof GetAllCouponsLimitEnum[keyof typeof GetAllCouponsLimitEnum];
/**
 * @export
 */
export const GetAllCouponsSortByEnum = {
    Name: 'name',
    Code: 'code',
    Type: 'type',
    Validity: 'validity',
    CreatedAt: 'createdAt',
    StartDate: 'startDate',
    Status: 'status',
    CouponsLeft: 'couponsLeft'
} as const;
export type GetAllCouponsSortByEnum = typeof GetAllCouponsSortByEnum[keyof typeof GetAllCouponsSortByEnum];
/**
 * @export
 */
export const GetAllCouponsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllCouponsSortOrderEnum = typeof GetAllCouponsSortOrderEnum[keyof typeof GetAllCouponsSortOrderEnum];
/**
 * @export
 */
export const GetAllDeliveryBoysLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllDeliveryBoysLimitEnum = typeof GetAllDeliveryBoysLimitEnum[keyof typeof GetAllDeliveryBoysLimitEnum];
/**
 * @export
 */
export const GetAllDeliveryBoysSortByEnum = {
    DeliveryBoyName: 'deliveryBoyName',
    DeliveryBoyEmail: 'deliveryBoyEmail',
    DeliveryBoyMobile: 'deliveryBoyMobile',
    CreatedAt: 'createdAt'
} as const;
export type GetAllDeliveryBoysSortByEnum = typeof GetAllDeliveryBoysSortByEnum[keyof typeof GetAllDeliveryBoysSortByEnum];
/**
 * @export
 */
export const GetAllDeliveryBoysSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllDeliveryBoysSortOrderEnum = typeof GetAllDeliveryBoysSortOrderEnum[keyof typeof GetAllDeliveryBoysSortOrderEnum];
/**
 * @export
 */
export const GetAllDeliveryManagersLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllDeliveryManagersLimitEnum = typeof GetAllDeliveryManagersLimitEnum[keyof typeof GetAllDeliveryManagersLimitEnum];
/**
 * @export
 */
export const GetAllDeliveryManagersSortByEnum = {
    Name: 'name',
    Email: 'email',
    MobileNumber: 'mobileNumber',
    CreatedAt: 'createdAt'
} as const;
export type GetAllDeliveryManagersSortByEnum = typeof GetAllDeliveryManagersSortByEnum[keyof typeof GetAllDeliveryManagersSortByEnum];
/**
 * @export
 */
export const GetAllDeliveryManagersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllDeliveryManagersSortOrderEnum = typeof GetAllDeliveryManagersSortOrderEnum[keyof typeof GetAllDeliveryManagersSortOrderEnum];
/**
 * @export
 */
export const GetAllFaqsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllFaqsLimitEnum = typeof GetAllFaqsLimitEnum[keyof typeof GetAllFaqsLimitEnum];
/**
 * @export
 */
export const GetAllFaqsSortByEnum = {
    Question: 'question',
    CreatedAt: 'createdAt',
    Status: 'status'
} as const;
export type GetAllFaqsSortByEnum = typeof GetAllFaqsSortByEnum[keyof typeof GetAllFaqsSortByEnum];
/**
 * @export
 */
export const GetAllFaqsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllFaqsSortOrderEnum = typeof GetAllFaqsSortOrderEnum[keyof typeof GetAllFaqsSortOrderEnum];
/**
 * @export
 */
export const GetAllItemStocksLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllItemStocksLimitEnum = typeof GetAllItemStocksLimitEnum[keyof typeof GetAllItemStocksLimitEnum];
/**
 * @export
 */
export const GetAllItemStocksSortByEnum = {
    ProductCode: 'productCode',
    ItemName: 'itemName',
    RestaurantName: 'restaurantName',
    MerchantName: 'merchantName',
    CreatedAt: 'createdAt'
} as const;
export type GetAllItemStocksSortByEnum = typeof GetAllItemStocksSortByEnum[keyof typeof GetAllItemStocksSortByEnum];
/**
 * @export
 */
export const GetAllItemStocksSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllItemStocksSortOrderEnum = typeof GetAllItemStocksSortOrderEnum[keyof typeof GetAllItemStocksSortOrderEnum];
/**
 * @export
 */
export const GetAllItemsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllItemsLimitEnum = typeof GetAllItemsLimitEnum[keyof typeof GetAllItemsLimitEnum];
/**
 * @export
 */
export const GetAllItemsSortByEnum = {
    ItemName: 'itemName',
    ItemCode: 'itemCode',
    RestaurantName: 'restaurantName',
    OriginalPrice: 'originalPrice',
    DiscountedPrice: 'discountedPrice',
    StockAvailability: 'stockAvailability',
    CreatedAt: 'createdAt',
    AddedBy: 'addedBy'
} as const;
export type GetAllItemsSortByEnum = typeof GetAllItemsSortByEnum[keyof typeof GetAllItemsSortByEnum];
/**
 * @export
 */
export const GetAllItemsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllItemsSortOrderEnum = typeof GetAllItemsSortOrderEnum[keyof typeof GetAllItemsSortOrderEnum];
/**
 * @export
 */
export const GetAllItemsStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetAllItemsStoreTypeEnum = typeof GetAllItemsStoreTypeEnum[keyof typeof GetAllItemsStoreTypeEnum];
/**
 * @export
 */
export const GetAllItemsStockAvailabilityEnum = {
    Available: 'Available',
    Sold: 'Sold',
    All: 'All'
} as const;
export type GetAllItemsStockAvailabilityEnum = typeof GetAllItemsStockAvailabilityEnum[keyof typeof GetAllItemsStockAvailabilityEnum];
/**
 * @export
 */
export const GetAllItemsAddedByEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant'
} as const;
export type GetAllItemsAddedByEnum = typeof GetAllItemsAddedByEnum[keyof typeof GetAllItemsAddedByEnum];
/**
 * @export
 */
export const GetAllMealsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllMealsSortOrderEnum = typeof GetAllMealsSortOrderEnum[keyof typeof GetAllMealsSortOrderEnum];
/**
 * @export
 */
export const GetAllMealsStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetAllMealsStoreTypeEnum = typeof GetAllMealsStoreTypeEnum[keyof typeof GetAllMealsStoreTypeEnum];
/**
 * @export
 */
export const GetAllMealsStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;
export type GetAllMealsStatusEnum = typeof GetAllMealsStatusEnum[keyof typeof GetAllMealsStatusEnum];
/**
 * @export
 */
export const GetAllNotificationsUserTypeEnum = {
    Customer: 'customer',
    Admin: 'admin',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner'
} as const;
export type GetAllNotificationsUserTypeEnum = typeof GetAllNotificationsUserTypeEnum[keyof typeof GetAllNotificationsUserTypeEnum];
/**
 * @export
 */
export const GetAllOffersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllOffersSortOrderEnum = typeof GetAllOffersSortOrderEnum[keyof typeof GetAllOffersSortOrderEnum];
/**
 * @export
 */
export const GetAllOrdersUserTypeEnum = {
    Admin: 'Admin',
    Merchant: 'Merchant',
    Customer: 'Customer',
    DeliveryPartner: 'DeliveryPartner'
} as const;
export type GetAllOrdersUserTypeEnum = typeof GetAllOrdersUserTypeEnum[keyof typeof GetAllOrdersUserTypeEnum];
/**
 * @export
 */
export const GetAllOrdersLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetAllOrdersLangEnum = typeof GetAllOrdersLangEnum[keyof typeof GetAllOrdersLangEnum];
/**
 * @export
 */
export const GetAllOrdersStatusEnum = {
    OrderPlaced: 'orderPlaced',
    DeliveryPartnerAssigned: 'deliveryPartnerAssigned',
    DeliveryPartnerAccepted: 'deliveryPartnerAccepted',
    MerchantAccepted: 'merchantAccepted',
    MerchantRejected: 'merchantRejected',
    OrderPreparing: 'orderPreparing',
    OrderDispatched: 'orderDispatched',
    OrderArrived: 'orderArrived',
    OrderDelivered: 'orderDelivered',
    OrderCancelled: 'orderCancelled'
} as const;
export type GetAllOrdersStatusEnum = typeof GetAllOrdersStatusEnum[keyof typeof GetAllOrdersStatusEnum];
/**
 * @export
 */
export const GetAllOrdersSortByEnum = {
    OrderDate: 'orderDate',
    TotalAmount: 'totalAmount',
    UpdatedAt: 'updatedAt',
    CustomerName: 'customerName',
    Status: 'status'
} as const;
export type GetAllOrdersSortByEnum = typeof GetAllOrdersSortByEnum[keyof typeof GetAllOrdersSortByEnum];
/**
 * @export
 */
export const GetAllOrdersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllOrdersSortOrderEnum = typeof GetAllOrdersSortOrderEnum[keyof typeof GetAllOrdersSortOrderEnum];
/**
 * @export
 */
export const GetAllOrdersOrderModeEnum = {
    Normal: 'normal',
    PreOrder: 'preOrder'
} as const;
export type GetAllOrdersOrderModeEnum = typeof GetAllOrdersOrderModeEnum[keyof typeof GetAllOrdersOrderModeEnum];
/**
 * @export
 */
export const GetAllRestaurantCategoriesStoreTypeEnum = {
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore',
    Restaurant: 'Restaurant'
} as const;
export type GetAllRestaurantCategoriesStoreTypeEnum = typeof GetAllRestaurantCategoriesStoreTypeEnum[keyof typeof GetAllRestaurantCategoriesStoreTypeEnum];
/**
 * @export
 */
export const GetAllRestaurantMerchantsStoreTypeEnum = {
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore',
    Restaurant: 'Restaurant'
} as const;
export type GetAllRestaurantMerchantsStoreTypeEnum = typeof GetAllRestaurantMerchantsStoreTypeEnum[keyof typeof GetAllRestaurantMerchantsStoreTypeEnum];
/**
 * @export
 */
export const GetAllReviewsTypeEnum = {
    Item: 'Item',
    Store: 'Store',
    DeliveryPerson: 'DeliveryPerson'
} as const;
export type GetAllReviewsTypeEnum = typeof GetAllReviewsTypeEnum[keyof typeof GetAllReviewsTypeEnum];
/**
 * @export
 */
export const GetAllReviewsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllReviewsLimitEnum = typeof GetAllReviewsLimitEnum[keyof typeof GetAllReviewsLimitEnum];
/**
 * @export
 */
export const GetAllReviewsStatusEnum = {
    Approved: 'approved',
    Disapproved: 'disapproved'
} as const;
export type GetAllReviewsStatusEnum = typeof GetAllReviewsStatusEnum[keyof typeof GetAllReviewsStatusEnum];
/**
 * @export
 */
export const GetAllReviewsSortByEnum = {
    Name: 'name',
    Status: 'status'
} as const;
export type GetAllReviewsSortByEnum = typeof GetAllReviewsSortByEnum[keyof typeof GetAllReviewsSortByEnum];
/**
 * @export
 */
export const GetAllReviewsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllReviewsSortDirectionEnum = typeof GetAllReviewsSortDirectionEnum[keyof typeof GetAllReviewsSortDirectionEnum];
/**
 * @export
 */
export const GetAllSettlementsUserTypeEnum = {
    Admin: 'ADMIN',
    Merchant: 'MERCHANT',
    Customer: 'CUSTOMER',
    DeliveryPartner: 'DELIVERY_PARTNER'
} as const;
export type GetAllSettlementsUserTypeEnum = typeof GetAllSettlementsUserTypeEnum[keyof typeof GetAllSettlementsUserTypeEnum];
/**
 * @export
 */
export const GetAllSettlementsTransactionTypeEnum = {
    ToPay: 'toPay',
    ToReceive: 'toReceive',
    Completed: 'completed',
    All: 'all'
} as const;
export type GetAllSettlementsTransactionTypeEnum = typeof GetAllSettlementsTransactionTypeEnum[keyof typeof GetAllSettlementsTransactionTypeEnum];
/**
 * @export
 */
export const GetAllSettlementsSortByEnum = {
    CreatedAt: 'createdAt',
    Amount: 'amount',
    DueDate: 'dueDate'
} as const;
export type GetAllSettlementsSortByEnum = typeof GetAllSettlementsSortByEnum[keyof typeof GetAllSettlementsSortByEnum];
/**
 * @export
 */
export const GetAllSettlementsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllSettlementsSortOrderEnum = typeof GetAllSettlementsSortOrderEnum[keyof typeof GetAllSettlementsSortOrderEnum];
/**
 * @export
 */
export const GetAllSettlementsSettlementUserTypeEnum = {
    Merchant: 'MERCHANT',
    Customer: 'CUSTOMER',
    DeliveryPartner: 'DELIVERY_PARTNER'
} as const;
export type GetAllSettlementsSettlementUserTypeEnum = typeof GetAllSettlementsSettlementUserTypeEnum[keyof typeof GetAllSettlementsSettlementUserTypeEnum];
/**
 * @export
 */
export const GetAllStoresForAdminLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllStoresForAdminLimitEnum = typeof GetAllStoresForAdminLimitEnum[keyof typeof GetAllStoresForAdminLimitEnum];
/**
 * @export
 */
export const GetAllStoresForAdminSortByEnum = {
    RestaurantName: 'restaurantName',
    Merchant: 'merchant',
    Category: 'category',
    AddedBy: 'addedBy',
    Status: 'status',
    CreatedAt: 'createdAt'
} as const;
export type GetAllStoresForAdminSortByEnum = typeof GetAllStoresForAdminSortByEnum[keyof typeof GetAllStoresForAdminSortByEnum];
/**
 * @export
 */
export const GetAllStoresForAdminSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllStoresForAdminSortOrderEnum = typeof GetAllStoresForAdminSortOrderEnum[keyof typeof GetAllStoresForAdminSortOrderEnum];
/**
 * @export
 */
export const GetAllStoresForAdminStatusFilterEnum = {
    Published: 'Published',
    Unpublished: 'Unpublished',
    All: 'All'
} as const;
export type GetAllStoresForAdminStatusFilterEnum = typeof GetAllStoresForAdminStatusFilterEnum[keyof typeof GetAllStoresForAdminStatusFilterEnum];
/**
 * @export
 */
export const GetAllStoresForAdminAddedByFilterEnum = {
    Merchant: 'Merchant',
    Admin: 'Admin',
    All: 'All'
} as const;
export type GetAllStoresForAdminAddedByFilterEnum = typeof GetAllStoresForAdminAddedByFilterEnum[keyof typeof GetAllStoresForAdminAddedByFilterEnum];
/**
 * @export
 */
export const GetAllStoresForAdminStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetAllStoresForAdminStoreTypeEnum = typeof GetAllStoresForAdminStoreTypeEnum[keyof typeof GetAllStoresForAdminStoreTypeEnum];
/**
 * @export
 */
export const GetAllSubAdminsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllSubAdminsLimitEnum = typeof GetAllSubAdminsLimitEnum[keyof typeof GetAllSubAdminsLimitEnum];
/**
 * @export
 */
export const GetAllSubAdminsSortByEnum = {
    Name: 'name',
    Email: 'email',
    MobileNumber: 'mobileNumber',
    LastLoginDate: 'lastLoginDate',
    LastLogoutDate: 'lastLogoutDate'
} as const;
export type GetAllSubAdminsSortByEnum = typeof GetAllSubAdminsSortByEnum[keyof typeof GetAllSubAdminsSortByEnum];
/**
 * @export
 */
export const GetAllSubAdminsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllSubAdminsSortOrderEnum = typeof GetAllSubAdminsSortOrderEnum[keyof typeof GetAllSubAdminsSortOrderEnum];
/**
 * @export
 */
export const GetAllSubscriptionPlansLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllSubscriptionPlansLimitEnum = typeof GetAllSubscriptionPlansLimitEnum[keyof typeof GetAllSubscriptionPlansLimitEnum];
/**
 * @export
 */
export const GetAllSubscriptionPlansPlanDurationInEnum = {
    Day: 'day',
    Month: 'month',
    Year: 'year'
} as const;
export type GetAllSubscriptionPlansPlanDurationInEnum = typeof GetAllSubscriptionPlansPlanDurationInEnum[keyof typeof GetAllSubscriptionPlansPlanDurationInEnum];
/**
 * @export
 */
export const GetAllSubscriptionPlansStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;
export type GetAllSubscriptionPlansStatusEnum = typeof GetAllSubscriptionPlansStatusEnum[keyof typeof GetAllSubscriptionPlansStatusEnum];
/**
 * @export
 */
export const GetAllSubscriptionPlansSortByEnum = {
    Name: 'name',
    PlanDuration: 'planDuration',
    Price: 'price',
    NumberOfOrders: 'numberOfOrders'
} as const;
export type GetAllSubscriptionPlansSortByEnum = typeof GetAllSubscriptionPlansSortByEnum[keyof typeof GetAllSubscriptionPlansSortByEnum];
/**
 * @export
 */
export const GetAllSubscriptionPlansSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllSubscriptionPlansSortOrderEnum = typeof GetAllSubscriptionPlansSortOrderEnum[keyof typeof GetAllSubscriptionPlansSortOrderEnum];
/**
 * @export
 */
export const GetAllUsersLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetAllUsersLimitEnum = typeof GetAllUsersLimitEnum[keyof typeof GetAllUsersLimitEnum];
/**
 * @export
 */
export const GetAllUsersSortByEnum = {
    Name: 'name',
    Email: 'email',
    MobileNumber: 'mobileNumber',
    AddedBy: 'addedBy',
    Status: 'status',
    LastAdded: 'lastAdded'
} as const;
export type GetAllUsersSortByEnum = typeof GetAllUsersSortByEnum[keyof typeof GetAllUsersSortByEnum];
/**
 * @export
 */
export const GetAllUsersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllUsersSortOrderEnum = typeof GetAllUsersSortOrderEnum[keyof typeof GetAllUsersSortOrderEnum];
/**
 * @export
 */
export const GetAllUsersStatusEnum = {
    Published: 'Published',
    Unpublished: 'Unpublished'
} as const;
export type GetAllUsersStatusEnum = typeof GetAllUsersStatusEnum[keyof typeof GetAllUsersStatusEnum];
/**
 * @export
 */
export const GetAllUsersAddedByEnum = {
    Admin: 'Admin',
    Normal: 'Normal',
    Google: 'Google',
    Facebook: 'Facebook'
} as const;
export type GetAllUsersAddedByEnum = typeof GetAllUsersAddedByEnum[keyof typeof GetAllUsersAddedByEnum];
/**
 * @export
 */
export const GetCmsPagesForCustomerLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetCmsPagesForCustomerLangEnum = typeof GetCmsPagesForCustomerLangEnum[keyof typeof GetCmsPagesForCustomerLangEnum];
/**
 * @export
 */
export const GetConfigurationSettingsLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetConfigurationSettingsLanguageEnum = typeof GetConfigurationSettingsLanguageEnum[keyof typeof GetConfigurationSettingsLanguageEnum];
/**
 * @export
 */
export const GetCustomersDetailsForOffersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCustomersDetailsForOffersSortOrderEnum = typeof GetCustomersDetailsForOffersSortOrderEnum[keyof typeof GetCustomersDetailsForOffersSortOrderEnum];
/**
 * @export
 */
export const GetCustomersDetailsForOffersStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;
export type GetCustomersDetailsForOffersStatusEnum = typeof GetCustomersDetailsForOffersStatusEnum[keyof typeof GetCustomersDetailsForOffersStatusEnum];
/**
 * @export
 */
export const GetCustomersDetailsForOffersCustomerTypeEnum = {
    MostOrderPlaced: 'MostOrderPlaced',
    RecentlyAdded: 'RecentlyAdded',
    OfferAssigned: 'OfferAssigned',
    OfferNotAssigned: 'OfferNotAssigned'
} as const;
export type GetCustomersDetailsForOffersCustomerTypeEnum = typeof GetCustomersDetailsForOffersCustomerTypeEnum[keyof typeof GetCustomersDetailsForOffersCustomerTypeEnum];
/**
 * @export
 */
export const GetCustomersWithWalletDetailsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetCustomersWithWalletDetailsLimitEnum = typeof GetCustomersWithWalletDetailsLimitEnum[keyof typeof GetCustomersWithWalletDetailsLimitEnum];
/**
 * @export
 */
export const GetCustomersWithWalletDetailsSortByEnum = {
    CustomerName: 'customerName',
    CustomerEmail: 'customerEmail',
    AvailableWalletBalance: 'availableWalletBalance',
    LastTransactionDate: 'lastTransactionDate',
    TotalTransactions: 'totalTransactions',
    CustomerStatus: 'customerStatus'
} as const;
export type GetCustomersWithWalletDetailsSortByEnum = typeof GetCustomersWithWalletDetailsSortByEnum[keyof typeof GetCustomersWithWalletDetailsSortByEnum];
/**
 * @export
 */
export const GetCustomersWithWalletDetailsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCustomersWithWalletDetailsSortOrderEnum = typeof GetCustomersWithWalletDetailsSortOrderEnum[keyof typeof GetCustomersWithWalletDetailsSortOrderEnum];
/**
 * @export
 */
export const GetCustomersWithWalletDetailsCustomerStatusEnum = {
    Blocked: 'blocked',
    Unblocked: 'unblocked'
} as const;
export type GetCustomersWithWalletDetailsCustomerStatusEnum = typeof GetCustomersWithWalletDetailsCustomerStatusEnum[keyof typeof GetCustomersWithWalletDetailsCustomerStatusEnum];
/**
 * @export
 */
export const GetCustomersWithWalletDetailsTransactionTypeEnum = {
    Credit: 'credit',
    Debit: 'debit'
} as const;
export type GetCustomersWithWalletDetailsTransactionTypeEnum = typeof GetCustomersWithWalletDetailsTransactionTypeEnum[keyof typeof GetCustomersWithWalletDetailsTransactionTypeEnum];
/**
 * @export
 */
export const GetDashboardMetricsDashboardTypeEnum = {
    Admin: 'admin',
    Merchant: 'merchant'
} as const;
export type GetDashboardMetricsDashboardTypeEnum = typeof GetDashboardMetricsDashboardTypeEnum[keyof typeof GetDashboardMetricsDashboardTypeEnum];
/**
 * @export
 */
export const GetFaqsForCustomerLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetFaqsForCustomerLangEnum = typeof GetFaqsForCustomerLangEnum[keyof typeof GetFaqsForCustomerLangEnum];
/**
 * @export
 */
export const GetFeaturedStoreSubscriptionsStatusEnum = {
    Active: 'active',
    Expired: 'expired',
    Pending: 'pending',
    Failed: 'failed'
} as const;
export type GetFeaturedStoreSubscriptionsStatusEnum = typeof GetFeaturedStoreSubscriptionsStatusEnum[keyof typeof GetFeaturedStoreSubscriptionsStatusEnum];
/**
 * @export
 */
export const GetHomePageDataForUserAppStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetHomePageDataForUserAppStoreTypeEnum = typeof GetHomePageDataForUserAppStoreTypeEnum[keyof typeof GetHomePageDataForUserAppStoreTypeEnum];
/**
 * @export
 */
export const GetHomePageDataForUserAppSortByEnum = {
    FastDelivery: 'FastDelivery',
    Distance: 'Distance',
    RatingHighToLow: 'RatingHighToLow'
} as const;
export type GetHomePageDataForUserAppSortByEnum = typeof GetHomePageDataForUserAppSortByEnum[keyof typeof GetHomePageDataForUserAppSortByEnum];
/**
 * @export
 */
export const GetHomePageDataForUserAppOffersEnum = {
    FreeDelivery: 'FreeDelivery',
    Deal: 'Deal',
    Vouchers: 'Vouchers'
} as const;
export type GetHomePageDataForUserAppOffersEnum = typeof GetHomePageDataForUserAppOffersEnum[keyof typeof GetHomePageDataForUserAppOffersEnum];
/**
 * @export
 */
export const GetItemCategoriesLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetItemCategoriesLimitEnum = typeof GetItemCategoriesLimitEnum[keyof typeof GetItemCategoriesLimitEnum];
/**
 * @export
 */
export const GetItemCategoriesSortByEnum = {
    NameEnglish: 'nameEnglish',
    NameArabic: 'nameArabic',
    CreatedAt: 'createdAt',
    AddedBy: 'addedBy'
} as const;
export type GetItemCategoriesSortByEnum = typeof GetItemCategoriesSortByEnum[keyof typeof GetItemCategoriesSortByEnum];
/**
 * @export
 */
export const GetItemCategoriesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetItemCategoriesSortOrderEnum = typeof GetItemCategoriesSortOrderEnum[keyof typeof GetItemCategoriesSortOrderEnum];
/**
 * @export
 */
export const GetItemCategoriesStatusFilterEnum = {
    Published: 'Published',
    Unpublished: 'Unpublished',
    All: 'All'
} as const;
export type GetItemCategoriesStatusFilterEnum = typeof GetItemCategoriesStatusFilterEnum[keyof typeof GetItemCategoriesStatusFilterEnum];
/**
 * @export
 */
export const GetItemCategoriesAddedByFilterEnum = {
    Merchant: 'Merchant',
    Admin: 'Admin',
    All: 'All'
} as const;
export type GetItemCategoriesAddedByFilterEnum = typeof GetItemCategoriesAddedByFilterEnum[keyof typeof GetItemCategoriesAddedByFilterEnum];
/**
 * @export
 */
export const GetItemCategoriesStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetItemCategoriesStoreTypeEnum = typeof GetItemCategoriesStoreTypeEnum[keyof typeof GetItemCategoriesStoreTypeEnum];
/**
 * @export
 */
export const GetLoyaltyPointsLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetLoyaltyPointsLangEnum = typeof GetLoyaltyPointsLangEnum[keyof typeof GetLoyaltyPointsLangEnum];
/**
 * @export
 */
export const GetMerchantsStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetMerchantsStoreTypeEnum = typeof GetMerchantsStoreTypeEnum[keyof typeof GetMerchantsStoreTypeEnum];
/**
 * @export
 */
export const GetMerchantsSortByEnum = {
    Name: 'name',
    Email: 'email',
    MobileNumber: 'mobileNumber',
    Status: 'status',
    AddedBy: 'addedBy'
} as const;
export type GetMerchantsSortByEnum = typeof GetMerchantsSortByEnum[keyof typeof GetMerchantsSortByEnum];
/**
 * @export
 */
export const GetMerchantsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetMerchantsSortOrderEnum = typeof GetMerchantsSortOrderEnum[keyof typeof GetMerchantsSortOrderEnum];
/**
 * @export
 */
export const GetNewsletterSubscribersLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetNewsletterSubscribersLimitEnum = typeof GetNewsletterSubscribersLimitEnum[keyof typeof GetNewsletterSubscribersLimitEnum];
/**
 * @export
 */
export const GetNewsletterSubscribersStatusEnum = {
    Active: 'active',
    Inactive: 'inactive'
} as const;
export type GetNewsletterSubscribersStatusEnum = typeof GetNewsletterSubscribersStatusEnum[keyof typeof GetNewsletterSubscribersStatusEnum];
/**
 * @export
 */
export const GetNewsletterSubscribersSortByEnum = {
    Email: 'email'
} as const;
export type GetNewsletterSubscribersSortByEnum = typeof GetNewsletterSubscribersSortByEnum[keyof typeof GetNewsletterSubscribersSortByEnum];
/**
 * @export
 */
export const GetNewsletterSubscribersSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetNewsletterSubscribersSortOrderEnum = typeof GetNewsletterSubscribersSortOrderEnum[keyof typeof GetNewsletterSubscribersSortOrderEnum];
/**
 * @export
 */
export const GetPublicSettingsLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetPublicSettingsLangEnum = typeof GetPublicSettingsLangEnum[keyof typeof GetPublicSettingsLangEnum];
/**
 * @export
 */
export const GetReferralReportSortByEnum = {
    ReferrerUserName: 'referrerUserName',
    ReferralCode: 'referralCode',
    UsedUserName: 'usedUserName',
    OfferPercentage: 'offerPercentage',
    WalletAmount: 'walletAmount',
    Status: 'status',
    CreatedAt: 'createdAt',
    UsedAt: 'usedAt'
} as const;
export type GetReferralReportSortByEnum = typeof GetReferralReportSortByEnum[keyof typeof GetReferralReportSortByEnum];
/**
 * @export
 */
export const GetReferralReportSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetReferralReportSortOrderEnum = typeof GetReferralReportSortOrderEnum[keyof typeof GetReferralReportSortOrderEnum];
/**
 * @export
 */
export const GetReferralReportStatusEnum = {
    Initiated: 'Initiated',
    SignedUp: 'SignedUp',
    WalletPaid: 'WalletPaid'
} as const;
export type GetReferralReportStatusEnum = typeof GetReferralReportStatusEnum[keyof typeof GetReferralReportStatusEnum];
/**
 * @export
 */
export const GetRestaurantCategoriesStoreTypeEnum = {
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetRestaurantCategoriesStoreTypeEnum = typeof GetRestaurantCategoriesStoreTypeEnum[keyof typeof GetRestaurantCategoriesStoreTypeEnum];
/**
 * @export
 */
export const GetRestaurantCategoriesStatusEnum = {
    Active: 'active',
    Blocked: 'blocked'
} as const;
export type GetRestaurantCategoriesStatusEnum = typeof GetRestaurantCategoriesStatusEnum[keyof typeof GetRestaurantCategoriesStatusEnum];
/**
 * @export
 */
export const GetRestaurantCategoriesSortByEnum = {
    Name: 'name',
    Status: 'status',
    AddedBy: 'addedBy'
} as const;
export type GetRestaurantCategoriesSortByEnum = typeof GetRestaurantCategoriesSortByEnum[keyof typeof GetRestaurantCategoriesSortByEnum];
/**
 * @export
 */
export const GetRestaurantCategoriesSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetRestaurantCategoriesSortDirectionEnum = typeof GetRestaurantCategoriesSortDirectionEnum[keyof typeof GetRestaurantCategoriesSortDirectionEnum];
/**
 * @export
 */
export const GetSpecialUserDetailsUserTypeEnum = {
    SuperAdmin: 'superAdmin',
    SubAdmin: 'subAdmin',
    Merchant: 'merchant',
    DeliveryPartner: 'deliveryPartner'
} as const;
export type GetSpecialUserDetailsUserTypeEnum = typeof GetSpecialUserDetailsUserTypeEnum[keyof typeof GetSpecialUserDetailsUserTypeEnum];
/**
 * @export
 */
export const GetStoreDetailsLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetStoreDetailsLangEnum = typeof GetStoreDetailsLangEnum[keyof typeof GetStoreDetailsLangEnum];
/**
 * @export
 */
export const GetStoreMenuLanguageEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetStoreMenuLanguageEnum = typeof GetStoreMenuLanguageEnum[keyof typeof GetStoreMenuLanguageEnum];
/**
 * @export
 */
export const GetSubItemCategoriesLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetSubItemCategoriesLimitEnum = typeof GetSubItemCategoriesLimitEnum[keyof typeof GetSubItemCategoriesLimitEnum];
/**
 * @export
 */
export const GetSubItemCategoriesSortByEnum = {
    NameEnglish: 'nameEnglish',
    NameArabic: 'nameArabic',
    CreatedAt: 'createdAt',
    AddedBy: 'addedBy'
} as const;
export type GetSubItemCategoriesSortByEnum = typeof GetSubItemCategoriesSortByEnum[keyof typeof GetSubItemCategoriesSortByEnum];
/**
 * @export
 */
export const GetSubItemCategoriesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetSubItemCategoriesSortOrderEnum = typeof GetSubItemCategoriesSortOrderEnum[keyof typeof GetSubItemCategoriesSortOrderEnum];
/**
 * @export
 */
export const GetSubItemCategoriesStatusFilterEnum = {
    Published: 'Published',
    Unpublished: 'Unpublished',
    All: 'All'
} as const;
export type GetSubItemCategoriesStatusFilterEnum = typeof GetSubItemCategoriesStatusFilterEnum[keyof typeof GetSubItemCategoriesStatusFilterEnum];
/**
 * @export
 */
export const GetSubItemCategoriesAddedByFilterEnum = {
    Merchant: 'Merchant',
    Admin: 'Admin',
    All: 'All'
} as const;
export type GetSubItemCategoriesAddedByFilterEnum = typeof GetSubItemCategoriesAddedByFilterEnum[keyof typeof GetSubItemCategoriesAddedByFilterEnum];
/**
 * @export
 */
export const GetUserCartStoreTypeEnum = {
    All: 'All',
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetUserCartStoreTypeEnum = typeof GetUserCartStoreTypeEnum[keyof typeof GetUserCartStoreTypeEnum];
/**
 * @export
 */
export const GetUserReviewsLimitEnum = {
    NUMBER_10: 10,
    NUMBER_25: 25,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetUserReviewsLimitEnum = typeof GetUserReviewsLimitEnum[keyof typeof GetUserReviewsLimitEnum];
/**
 * @export
 */
export const GetUserReviewsTypeEnum = {
    All: 'All',
    Item: 'Item',
    Store: 'Store',
    DeliveryPerson: 'DeliveryPerson'
} as const;
export type GetUserReviewsTypeEnum = typeof GetUserReviewsTypeEnum[keyof typeof GetUserReviewsTypeEnum];
/**
 * @export
 */
export const GetUserReviewsRatingEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5
} as const;
export type GetUserReviewsRatingEnum = typeof GetUserReviewsRatingEnum[keyof typeof GetUserReviewsRatingEnum];
/**
 * @export
 */
export const GetUserReviewsSortByEnum = {
    CreatedAt: 'createdAt',
    Rating: 'rating'
} as const;
export type GetUserReviewsSortByEnum = typeof GetUserReviewsSortByEnum[keyof typeof GetUserReviewsSortByEnum];
/**
 * @export
 */
export const GetUserReviewsSortDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetUserReviewsSortDirectionEnum = typeof GetUserReviewsSortDirectionEnum[keyof typeof GetUserReviewsSortDirectionEnum];
/**
 * @export
 */
export const GetUserReviewsLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetUserReviewsLangEnum = typeof GetUserReviewsLangEnum[keyof typeof GetUserReviewsLangEnum];
/**
 * @export
 */
export const GetUserWishListStoreTypeEnum = {
    All: 'All',
    Restaurant: 'Restaurant',
    GroceryStore: 'GroceryStore',
    PharmacyStore: 'PharmacyStore'
} as const;
export type GetUserWishListStoreTypeEnum = typeof GetUserWishListStoreTypeEnum[keyof typeof GetUserWishListStoreTypeEnum];
/**
 * @export
 */
export const GetUserWishListLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type GetUserWishListLangEnum = typeof GetUserWishListLangEnum[keyof typeof GetUserWishListLangEnum];
/**
 * @export
 */
export const ListCustomersUserTypeEnum = {
    NormalCustomer: 'normalCustomer',
    NewsLetterSubscriber: 'newsLetterSubscriber'
} as const;
export type ListCustomersUserTypeEnum = typeof ListCustomersUserTypeEnum[keyof typeof ListCustomersUserTypeEnum];
/**
 * @export
 */
export const PrepareOrderLangEnum = {
    En: 'en',
    Ar: 'ar'
} as const;
export type PrepareOrderLangEnum = typeof PrepareOrderLangEnum[keyof typeof PrepareOrderLangEnum];


